/* configurator-aframe-lib.js -- A-FRAME on the house line (aframe-v19)

   The A-frame rebuilt from nothing on the shared core (configurator-ui.js),
   the shared page (configurator-house.liquid) and the shared assets -- the
   third product founded that way after the T house. The old A-frame lib of
   the same name is retired by this file; nothing is taken from it.

   What an A-frame is here (Marek, Sep 2026):
     a rectangle, never anything else; its two long sides ARE the roof, from
     a low plinth to the ridge, 50 to 70 degrees, 60 by default; the two short
     sides are timber-framed gables. A carpenter's roof: rafters, a ridge
     beam, floor joists that are the collar ties. The upper floors are not
     chosen -- they come out of the plan and the pitch: a floor exists
     wherever a 900 mm bed fits, up to three storeys. The plan steps by 50 mm
     (2 in imperial) and the dimension always shows a round number. The roof
     insulation is above the rafters by default (rafters seen from inside)
     with a switch to between them, in STRUCTURE. The footing follows the
     size: a one-storey cabin may stand on screws or precast piers; once a
     second floor comes out, strips with a slab are the only footing.

   Product metafield: custom.configurator_type = aframe
   Needs core-v474 or newer (base on the product's rect, reinforcement; point footings with the floor frame, stairs billed as kits; own pitch range, own plan step).
*/
(function (global) {
  'use strict';

  var VERSION = 'aframe-v178';
  var _rafMembers = [];

  function build(__CORE) {
    var API = __CORE.API, STATE = __CORE.STATE, ICO = __CORE.ICO, BOOTDATA = __CORE.BOOTDATA,
        LIMITS = __CORE.LIMITS, _UI = __CORE._UI,
        _log = __CORE._log, _t = __CORE._t, _rows = __CORE._rows,
        _bill = __CORE._bill, _asmMark = __CORE._asmMark,
        fmtLen = __CORE.fmtLen, poly = __CORE.poly, polyArea = __CORE.polyArea,
        wallTop = __CORE.wallTop, wallThickness = __CORE.wallThickness,
        segments = __CORE.segments, roofPlanes = __CORE.roofPlanes,
        __PROD = __CORE.__PROD;

    /* The A's roof is frame + skin, not the shared roof layer. Its pitch
       also sets storey count and all the interior clearances. Keep these
       dependencies in one frame during the gesture; bill once on release. */
    __PROD._dragLayers = function (kind, setKey) {
      if (setKey !== 'roof') return null;
      if (kind === 'the pitch slider') {
        return API.layers().filter(function (l) { return l.id !== 'aframe-overhead' && l.id !== 'aframe-coating'; })
          .map(function (l) { return l.id.replace(/^aframe-/, ''); });
      }
      if (kind === 'the roofover grip') return ['base', 'gables', 'facade', 'frame', 'skin', 'lps', 'drip', 'wingbase', 'wing'];
      return null;
    };

    /* A BOX OF THIS PRODUCT'S OWN (from thouse-v23). The one the core hands over
       takes a MATERIAL as its third argument, no turn, and cuts at grade; this
       file was calling it with a width where the material goes, so every wall,
       plate, purlin, post and tie came out as a mesh with no material lying at
       the wrong height -- which is why nothing but the roof could be seen
       (Marek: nevidim nic jineho nez strechu). */
    function _box(T, g, w, h, d, x, y, z, ry, col, op) {
      var m = new T.Mesh(new T.BoxGeometry(w, h, d),
        new T.MeshStandardMaterial({ color: col, roughness: 0.9, metalness: 0, transparent: (op != null && op < 1), opacity: (op == null ? 1 : op) }));
      m.position.set(x, y, z);
      if (ry) m.rotation.y = ry;
      g.add(m);
      return m;
    }

    __CORE.PRODUCT = 'aframe';
    __CORE.LOG_TAG = 'aframe';
    __CORE.FOCUS = 'qty audit trim bom';

    /* THE ASSEMBLY WALK'S ORDER (aframe-v137, as the ADU sets it): the layers
       in build order, the items inside a layer, and across the layers the
       order the A goes up on site -- the base, the sill plates and the rafter
       pairs with the ridge, the floors tying them, the gables' frames, the
       roof closed (deck, underlay, roof windows, battens, edges, covering,
       ridge), the gables' sheathing, units and glass, the facade, the wing,
       the porch and the balcony, the lightning protection, then the inside:
       the wool, the barrier, the battens, the boards, the floors' finishes,
       the partitions, the skirting, the stairs and the drip strip last.
       A step is named by its catalogue code in the page's language; the key
       is the fallback and the id the lists below go by. */
    __CORE.ASM_ORDER = ['aframe-overhead', 'aframe-base', 'aframe-wingbase', 'aframe-frame', 'aframe-gables', 'aframe-skin', 'aframe-facade', 'aframe-wing',
                        'aframe-lps', 'aframe-elec', 'aframe-elec-up', 'aframe-elec-up2', 'aframe-heat', 'aframe-water', 'aframe-waste', 'aframe-lining', 'aframe-floors', 'aframe-partitions', 'aframe-wet', 'aframe-fitout', 'aframe-stairs', 'aframe-drip'];
    __CORE.ASM_STEP_ORDER = {
      'aframe-base': ['grd_concrete', 'grd_gravel', 'layer_insulation', 'base_screws', 'base_pads', 'base_piers', 'layer_floor_joists', 'layer_rodent_mesh',
                      'layer_breather_membrane', 'layer_floor_wool', 'layer_vapour_barrier', 'layer_floor_subfloor', 'layer_render', 'slab_joints', 'entrance_steps'],
      'aframe-frame': ['sill_seal', 'sill_plate', 'anchor_bolts', 'roof_framing', 'ridge_beam', 'ridge_plates', 'hurricane_ties', 'layer_floor_joists',
                       'layer_floor_subfloor', 'roof_framing_lookouts', 'roof_windows', 'soffit', 'grd_concrete', 'base_screws', 'base_pads',
                       'terrace_supports', 'porch_plate', 'porch_braces', 'porch_ties', 'terrace_frame', 'decking'],
      'aframe-gables': ['sill_seal', 'sill_plate', 'wall_frame', 'curtain_wall', 'layer_osb', 'layer_breather_membrane', 'windows_doors', 'glazing',
                        'glazing_cap', 'balcony_frame', 'base_screws', 'balcony_posts', 'decking', 'balcony_rail'],
      'aframe-skin': ['roof_lining', 'roof_sheathing', 'roof_insulation', 'roof_underlay', 'roof_counter_battens', 'roof_battens', 'roof_edges',
                      'roof_verge_board', 'roof_covering', 'roof_ridge', 'roof_flashing'],
      'aframe-facade': ['layer_eps', 'layer_vented_battens', 'layer_rodent_mesh', 'sauna_ui_cladding', 'windows_doors'],
      'aframe-wing': ['sill_plate', 'wall_frame', 'roof_framing', 'roof_firring', 'dormer_frame', 'roof_sheathing', 'roof_membrane', 'roof_edges', 'gutters', 'layer_osb', 'layer_breather_membrane', 'windows_doors',
                      'layer_vented_battens', 'layer_rodent_mesh', 'sauna_ui_cladding', 'deck_geotextile', 'deck_sleepers', 'decking', 'balcony_rail', 'dormer_wool',
                      'layer_studs_wool', 'layer_ceiling_insulation', 'layer_vapour_barrier', 'layer_service_battens', 'layer_ceiling_battens', 'layer_plasterboard', 'layer_ceiling_board', 'casing'],
      'aframe-lining': [{ id: 'eave_baffle', dir: 'in' }, { id: 'layer_rafter_wool', dir: 'in' }, { id: 'layer_studs_wool', dir: 'side' },
                        { id: 'layer_vapour_barrier', dir: 'in' }, { id: 'layer_service_battens', dir: 'in' }, { id: 'layer_plasterboard', dir: 'in' },
                        { id: 'casing', dir: 'side' }],
      'aframe-floors': ['layer_floor_wool', 'layer_ceiling_battens', 'layer_ceiling_board', 'edge_strip', 'layer_levelling', 'layer_floor_underlay',
                        'layer_floor_finish', 'layer_floor_skirting'],
      'aframe-partitions': ['partition_frame', 'layer_plasterboard', 'partition_wool', 'interior_doors', 'casing', 'closet_shelf'],
      'aframe-wet': ['layer_waterproofing', 'layer_floor_finish', 'wall_tile', 'door_transition']
    };
    __CORE.ASM_GLOBAL_ORDER = ['aframe-overhead|*', 'aframe-water|water_under_slab', 'aframe-waste|waste_under_slab', 'aframe-base|*', 'aframe-wingbase|*',
      'aframe-frame|sill_seal', 'aframe-frame|sill_plate', 'aframe-frame|anchor_bolts', 'aframe-frame|roof_framing', 'aframe-frame|ridge_beam',
      'aframe-frame|ridge_plates', 'aframe-frame|hurricane_ties', 'aframe-frame|layer_floor_joists', 'aframe-frame|layer_floor_subfloor',
      'aframe-frame|roof_framing_lookouts',
      'aframe-gables|sill_seal', 'aframe-gables|sill_plate', 'aframe-gables|wall_frame', 'aframe-gables|curtain_wall',
      'aframe-wing|sill_plate', 'aframe-wing|wall_frame', 'aframe-wing|roof_framing', 'aframe-wing|dormer_frame',
      'aframe-skin|roof_lining', 'aframe-skin|roof_sheathing', 'aframe-skin|roof_insulation', 'aframe-skin|roof_underlay', 'aframe-frame|roof_windows',
      'aframe-skin|roof_flashing', 'aframe-skin|roof_counter_battens', 'aframe-skin|roof_battens', 'aframe-skin|roof_edges', 'aframe-skin|roof_verge_board', 'aframe-skin|roof_covering',
      'aframe-skin|roof_ridge', 'aframe-skin|*',
      'aframe-gables|layer_osb', 'aframe-gables|layer_breather_membrane', 'aframe-gables|windows_doors', 'aframe-gables|glazing', 'aframe-gables|glazing_cap',
      'aframe-facade|layer_eps', 'aframe-facade|layer_vented_battens', 'aframe-facade|layer_rodent_mesh', 'aframe-facade|sauna_ui_cladding', 'aframe-facade|windows_doors', 'aframe-frame|soffit',
      'aframe-wing|*', 'aframe-gables|*', 'aframe-frame|*', 'aframe-lps|*',
      'aframe-lining|eave_baffle', 'aframe-lining|layer_rafter_wool', 'aframe-lining|layer_studs_wool', 'aframe-lining|layer_vapour_barrier',
      'aframe-lining|layer_service_battens', 'aframe-floors|layer_floor_wool', 'aframe-floors|layer_ceiling_battens',
      /* the cables in the service cavity before the boards close it (the ADU puts its electrics before the wall's inside layers) */
      'aframe-elec|*', 'aframe-elec-up|*', 'aframe-elec-up2|*', 'aframe-heat|*', 'aframe-water|*', 'aframe-waste|*',
      'aframe-lining|layer_plasterboard', 'aframe-floors|layer_ceiling_board', 'aframe-lining|*',
      /* the floor's finishes before the partitions, the skirting after them (the ADU, adu-v1400) */
      'aframe-floors|edge_strip', 'aframe-floors|layer_levelling', 'aframe-floors|layer_floor_underlay', 'aframe-floors|layer_floor_finish',
      'aframe-partitions|*', 'aframe-wet|*', 'aframe-floors|*', 'aframe-fitout|*', 'aframe-stairs|*', 'aframe-drip|*'];
    __CORE.ASM_LABELS = { 'aframe-base': ['base', 'BASE'], 'aframe-wingbase': ['base', 'BASE'], 'aframe-frame': ['structure_v2', 'Timber frame'],
                          'aframe-gables': ['walls', 'Walls'], 'aframe-skin': ['roof', 'Roof'], 'aframe-facade': ['walls', 'Walls'], 'aframe-wing': ['walls', 'Walls'],
                          'aframe-lining': ['walls', 'Walls'], 'aframe-floors': ['floor_label', 'Floor'], 'aframe-partitions': ['partitions', 'PARTITIONS'],
                          'aframe-lps': ['lps_label', 'Lightning protection'], 'aframe-drip': ['base', 'BASE'], 'aframe-fitout': ['container_int_fitout', 'FITOUT'],
                          'aframe-elec': ['viz_elec', 'Electrics'], 'aframe-elec-up': ['viz_elec', 'Electrics'], 'aframe-elec-up2': ['viz_elec', 'Electrics'],
                          'aframe-heat': ['mep_heating', 'Heating'], 'aframe-water': ['mep_water', 'Water supply'],
                          'aframe-waste': ['mep_drain', 'Drainage'], 'aframe-wet': ['grp_wet', 'Wet rooms'], 'aframe-airseal': ['walls', 'Walls'] };

    /* -------------------------------------------------------------------------
       THE BUILDING, AS IT STARTS. A 6 x 9 m cabin, the ridge along the length.
       The plinth is what the core calls the wall top: the ground floor deck
       (STACK.slab) plus a token clear height plus the plate zone, 0.50 m, and
       the roof planes leave from there -- there are no side walls.
       ------------------------------------------------------------------------- */
    LIMITS.minW = 3.6; LIMITS.maxW = 9.0; LIMITS.minL = 3.6; LIMITS.maxL = 15.0;
    STATE.footprint.w = 6.00;
    STATE.footprint.l = 9.00;
    STATE.wing = { on: false };
    STATE.storeys = 1;
    STATE.clearH = [0.01];
    STATE.roof.type = 'gable';
    STATE.roof.parapet = false;
    STATE.roof.axis = 'l';
    if (!(STATE.roof.pitch >= 50 && STATE.roof.pitch <= 70)) STATE.roof.pitch = 60;
    STATE.roof.eave = 0;
    /* the line's own default reach is 600 all round; an A-frame's tails are
       200 and its rakes 400, unless the project has set its own */
    (function () {
      var o = STATE.roof.over, lineDefault = !o || (Math.abs(o.x0 - 0.6) < 1e-6 && Math.abs(o.x1 - 0.6) < 1e-6 && Math.abs(o.z0 - 0.6) < 1e-6 && Math.abs(o.z1 - 0.6) < 1e-6);
      if (lineDefault) STATE.roof.over = { x0: 0, x1: 0, z0: 0.40, z1: 0.40 };
    })();
    /* THE RAFTERS' FEET ARE ON THE DECK EDGE. The core lays a roof plane from
       the eave edge at the height it is told; for an A-frame that height is
       the deck, minus what the tail drops over the overhang at the pitch, so
       the plane passes the deck edge exactly at deck level and the tail runs
       on down outside. Set before every build (core-v335 beforeBuild). */
    /* THE DECK IS WHERE THE CONCRETE ACTUALLY IS (aframe-v10, Marek: porad
       jsou utopene v betonove desce). On strips the slab is drawn by the
       core, and its top is not always STACK.slab -- the plate and the
       rafters were set on 350 while the slab stood higher, so the feet were
       in the concrete. The slab reports its own top; that is the deck on
       strips, and if it differs from what this build assumed, the build is
       run once more with the right figure. */
    var _slabTopSeen = null, _slabRebuilt = false, _loadT0 = Date.now(), _loadN = 0, _loadTrace = [];
    try { _loadTrace.push('load     page ' + ((typeof location !== 'undefined' && /[?&]p=/.test(location.search)) ? 'opened with a project link (?p=): the project is fetched after the first build' : 'opened without ?p=')); } catch (eLt) {}
    /* THE GROUND FLOOR'S HEIGHT, FROM THE SAME ANSWER THE CORE USES (aframe-v94,
       Marek: pri nacitani probliknou battens pod krytinou, jen ve spodni
       polovine). The core has no STACK on the object it hands a product, so
       until the base had been built once this read the fallback 350: the
       first build set the plate, the rafters and the eave on 350, the core's
       slab came out on the project's 800, and the whole A was built again a
       moment later -- the first one, 450 too low with the covering on the
       core's planes over it, was the flash. The core sets its stack from
       __PROD._productSlab (floor slider, footing), so the lib asks the same
       function and both agree from the first build, on every footing. */
    function _deckY() {
      var v = null;
      try { v = __PROD._productSlab(STATE.foundation); } catch (eD) { v = null; }
      if (typeof v === 'number' && isFinite(v)) return v;
      if (STATE.foundation === 'strips' && typeof _slabTopSeen === 'number') return _slabTopSeen;
      return (__CORE.STACK && __CORE.STACK.slab) || 0.35;
    }
    /* THE RAFTERS STAND ON A PLATE (aframe-v8, S1, Marek: jak se spravne
       zakladaji krokve). A 60 x 160 plate laid flat along each long edge of
       the ground floor -- on a slab it is bolted down through a sill seal, on
       the timber floor it is screwed down into the rim -- and each rafter's
       foot is cut LEVEL and sits on it, held by a hurricane tie. The rafter's
       top face meets the plate's outer edge, so the level seat lies on the
       plate. At 60 degrees a birdsmouth would cut through the rafter, so
       there is none, and there are no tails: the eave overhang is held at
       nought, since a tail would run down into the slab edge. What stops the
       feet spreading is the floor they stand on. */
    var PLATE = { w: 0.160, h: 0.060, code: 'KVH60160' };
    /* THE PLATE IS AS WIDE AS THE SEAT (aframe-v11, Marek: polovina krokve
       lezi ve vzduchu -- sirsi profil). The level seat is the rafter's depth
       over the sine of the pitch: 261 at 50 degrees, 231 at 60, 208 at 70
       for a 200 rafter. The plate is the narrowest board of the catalogue
       laid flat that takes the whole seat -- 160, 200 or 240 -- and past 240
       two boards side by side. Recomputed on every build. */
    var BOARDS = [ { w: 0.160, code: 'KVH60160' }, { w: 0.200, code: 'KVH60200' }, { w: 0.240, code: 'KVH60240' } ];
    /* THE BASE IS UNDER EVERY RAFTER (aframe-v12, core-v474 rect, Marek:
       zalozeni pod celou strechou = kryta terasa). The rafters run past the
       gables by the rake; the base -- strips and slab, or the point footings
       with their floor -- covers the rectangle out to the end rafters' outer
       faces, and the plates run the same length, so no rafter's foot is in
       the air. When the roof is stretched, this rectangle grows with it. */
    var RAKE = 0.30;
    /* THE ROOF PULLED OUT OVER A GABLE (aframe-v59, Marek: presah strechy na
       stitech jako u jinych projektu -- kryta strecha, previs s venkovni
       terasou). The reach at each gable is the one dragged in Roof & Base
       (STATE.roof.over z0 / z1), never less than the 300 rake. Up to 600 it
       stays a rake on lookouts; past that it is a porch: the rafter pairs
       go on at 600 over it, the ridge beam and the plates with them, the
       plates there stand on posts on the footing the person chose (ground
       screws instead of the slab), and each porch pair is tied across at
       head height. The house's base stays under the house and its 300. */
    var PORCH_MIN = 0.60, PORCH_TIE = 2.40;
    function _rakeOf(e) {
      var o = STATE.roof && STATE.roof.over, v = o ? (e ? o.z1 : o.z0) : RAKE;
      return (typeof v === 'number' && v > RAKE) ? v : RAKE;
    }
    function _porch(e) { return _rakeOf(e) > PORCH_MIN + 1e-6; }
    /* ON A PORCH SIDE THE HOUSE'S BASE STOPS AT THE FACADE (aframe-v100,
       Marek: vyska terasy musi licovat u vsech zalozeni s podlahou domu nebo
       nize): the porch lies a step under the floor, so the house slab may not
       run on under it -- it ends at the gable's outer face, and the porch's
       own slab, lower, takes over from there */
    function _facT() { return SHEATH.t + FAC.memb + _ciT() + FAC.batt.d + FAC.clad.t; }
    function _baseRake(e) { return _porch(e) ? Math.max(0, _facT() - _rafSize().t / 2) : _rakeOf(e); }
    function _baseRect() {
      var B = _barRect(), t = _rafSize().t;
      return { x0: B.x0, x1: B.x1, z0: B.z0 - _baseRake(0) - t / 2, z1: B.z1 + _baseRake(1) + t / 2 };
    }
    /* THE STRIPS SIT INSIDE THE LINE (aframe-v13, Marek: vidis to
       zalozeni?). The core centres a strip on the line it is given and runs
       the slab 'out' past it; given the base line itself, the slab and the
       strips stood 200 outside the plates and left a ledge of concrete under
       the drip line, outside the rafter feet. Given a line 200 inside, with
       out 200, the strip's outer face, the slab's edge and the plate's outer
       edge are the same plane. */
    /* THE LAYERS UNDER THE SLAB READ AS WHAT THEY ARE (aframe-v18, Marek:
       pattern na makadam / kamenivo). Two canvas textures, made once: the
       gravel as the ADU draws it -- stones in three greys on a darker bed --
       and the EPS as white beads with faint joins. */
    var _texCache = {};
    function _layerTex(T, kind) {
      if (_texCache[kind]) return _texCache[kind];
      var tx = null;
      try {
        var n = 256, cv = global.document.createElement('canvas');
        cv.width = n; cv.height = n;
        var c = cv.getContext('2d'), k, seed = (kind === 'stone') ? 12345 : 777;
        var rnd = function () { seed = (seed * 1103515245 + 12345) & 0x7fffffff; return seed / 0x7fffffff; };
        if (kind === 'stone') {
          c.fillStyle = '#6F6A62'; c.fillRect(0, 0, n, n);
          var cols = ['#9C958A', '#8A8378', '#B0A99C', '#7D776E'];
          for (k = 0; k < 900; k++) {
            var rx = rnd() * n, ry = rnd() * n, rr = 3 + rnd() * 7;
            c.fillStyle = cols[k % cols.length];
            c.beginPath(); c.ellipse(rx, ry, rr, rr * (0.6 + rnd() * 0.5), rnd() * Math.PI, 0, Math.PI * 2); c.fill();
          }
        } else {
          c.fillStyle = '#F2F2EC'; c.fillRect(0, 0, n, n);
          for (k = 0; k < 1400; k++) {
            var bx = rnd() * n, by = rnd() * n, br = 2 + rnd() * 3;
            c.fillStyle = (k % 3) ? '#E4E4DC' : '#FAFAF6';
            c.beginPath(); c.arc(bx, by, br, 0, Math.PI * 2); c.fill();
          }
          c.strokeStyle = 'rgba(150,150,140,0.5)'; c.lineWidth = 2; c.strokeRect(1, 1, n - 2, n - 2);
        }
        tx = new T.CanvasTexture(cv);
        tx.wrapS = tx.wrapT = T.RepeatWrapping;
        tx.repeat.set(kind === 'stone' ? 6 : 4, kind === 'stone' ? 6 : 4);
      } catch (eT) { tx = null; }
      _texCache[kind] = tx;
      return tx;
    }
    /* OSB AS IT LOOKS (aframe-v40, Marek: osb texturou, naznacit spary podle
       metric / imperial): pale strands on the board's own tan, one sheet to a
       tile with its joint round the edge -- 1250 x 2500 metric, 4 x 8 ft
       imperial -- so the joints fall where the sheets meet; the long side
       across the joists */
    function _osbSheet() { return STATE.isMetric ? { w: 1.250, l: 2.500 } : { w: 1.2192, l: 2.4384 }; }
    function _osbTex(T) {
      var key = 'osb' + (STATE.isMetric ? 'm' : 'i');
      if (_texCache[key]) return _texCache[key];
      var tx = null;
      try {
        var cw = 256, ch = 256, cv = global.document.createElement('canvas');
        cv.width = cw; cv.height = ch;
        var c = cv.getContext('2d'), k, seed = 4242;
        var rnd = function () { seed = (seed * 1103515245 + 12345) & 0x7fffffff; return seed / 0x7fffffff; };
        c.fillStyle = '#D2B07A'; c.fillRect(0, 0, cw, ch);
        var cols = ['#C39F68', '#E0C38E', '#B8925C', '#D9BB84', '#A98553'];
        for (k = 0; k < 520; k++) {
          c.save(); c.translate(rnd() * cw, rnd() * ch); c.rotate(rnd() * Math.PI);
          c.fillStyle = cols[k % cols.length]; c.fillRect(-6 - rnd() * 6, -1.2, 12 + rnd() * 12, 2.4 + rnd() * 1.5);
          c.restore();
        }
        /* TWO ROWS OF SHEETS, THE SECOND SET HALF A SHEET ON (aframe-v43, Marek:
           cikcak, at kratke spary nenavazuji): the long edges run straight, the
           short ones jump by half a sheet from row to row */
        c.strokeStyle = 'rgba(90,70,40,0.85)'; c.lineWidth = 2;
        c.beginPath(); c.moveTo(1, 0); c.lineTo(1, ch); c.moveTo(cw / 2, 0); c.lineTo(cw / 2, ch);
        c.moveTo(0, 1); c.lineTo(cw / 2, 1); c.moveTo(cw / 2, ch / 2); c.lineTo(cw, ch / 2); c.stroke();
        tx = new T.CanvasTexture(cv);
        tx.wrapS = tx.wrapT = T.RepeatWrapping;
      } catch (eO) { tx = null; }
      _texCache[key] = tx;
      return tx;
    }
    /* a board of OSB: its top shows the sheets at their real size */
    function _osbBox(T, g, w, h, d, x, y, z) {
      var base = _osbTex(T), SH = _osbSheet(), mat;
      if (base) {
        var t2 = base.clone(); t2.needsUpdate = true; t2.wrapS = t2.wrapT = T.RepeatWrapping;
        t2.repeat.set(w / (2 * SH.w), d / SH.l);
        mat = new T.MeshStandardMaterial({ map: t2, roughness: 0.85 });
      } else mat = new T.MeshStandardMaterial({ color: 0xD2B07A, roughness: 0.85 });
      var m = new T.Mesh(new T.BoxGeometry(w, h, d), mat);
      m.position.set(x, y, z); g.add(m);
      return m;
    }
    function _stripRect() {
      var R = _baseRect(), q = 0.20;
      return { x0: R.x0 + q, x1: R.x1 - q, z0: R.z0 + q, z1: R.z1 - q };
    }
    function _plateFit() {
      var p = (STATE.roof.pitch || 60) * Math.PI / 180, seat = _rafSize().d / Math.sin(p), i;
      /* ON CONCRETE THE PLATE IS PRESSURE-TREATED (aframe-v15, F4): one row,
         KVP45290, 45 x 290 (a 2x12), laid flat; two side by side where the
         seat is longer than 290 */
      if (STATE.foundation === 'strips') {
        var nT = (0.290 >= seat - 0.001) ? 1 : 2;
        return { n: nT, bw: 0.290, code: 'KVP45290', w: nT * 0.290, seat: seat, h: 0.045, treated: true };
      }
      for (i = 0; i < BOARDS.length; i++) if (BOARDS[i].w >= seat - 0.001) return { n: 1, bw: BOARDS[i].w, code: BOARDS[i].code, w: BOARDS[i].w, seat: seat, h: PLATE.h };
      for (i = 0; i < BOARDS.length; i++) if (2 * BOARDS[i].w >= seat - 0.001) return { n: 2, bw: BOARDS[i].w, code: BOARDS[i].code, w: 2 * BOARDS[i].w, seat: seat, h: PLATE.h };
      return { n: 2, bw: 0.240, code: 'KVH60240', w: 0.480, seat: seat, h: PLATE.h };
    }
    /* THE ROOF PLANE PASSES THE PLATE'S OUTER EDGE AT THE PLATE'S TOP
       (aframe-v9). The core will not let an eave come nearer the wall than
       its 100 mm minimum plus the cladding, so its plane edge lies about 120
       outside the plate. v8 put the rafter's foot on that edge and the foot
       hung 120 past the plate (Marek: neni to tak jak to popisujes). The
       plane is now dropped so that it crosses the plate's outer edge exactly
       at the plate's top, and the rafter is cut there; how far the core's
       edge still runs past the foot is said in the log. */
    var _eaveOut = 0;
    /* A TAILS PRODUCT ON THE CORE'S TERMS (aframe-v62, Marek: presah az 5 m na
       kazdou stranu): the planes stay on the eave on the two long sides (the
       A's eave is at the ground, datum 0), and each gable end reaches out up
       to 5 m when its edge is dragged on Roof & Base */
    __PROD._roofTails = true;
    /* no wall height on the A (aframe-v66, Marek: wall height nedava smysl): the core leaves the slider out */
    __PROD._noWallHeight = true;
    /* the eaves come down to the ground (aframe-v68, Marek: kryta terasa jen smerem kde je stit): on Roof & Base the core's roof ghost drags the two gable ends only */
    __PROD._eaveFixed = true;
    /* THE FLOOR OVER THE GROUND ON ROOF & BASE (aframe-v71, Marek: deska je
       docela vysoko nad terenem, dat do roof and base posuvnik): the core's
       floor slider, the finished floor of the ground storey over grade. On
       strips it is a slab on the strips, 150 to 800, 300 unless moved (the
       line's 650 is a crawl space the A never has); on a point base the
       floor frame needs its joists and a hand of air under them, 350 at the
       least, 400 unless moved. The porch deck and the balcony follow it. */
    __PROD.FLOOR_LEVEL = { min: 0.15, max: 0.80, step: 0.05 };
    __PROD._productSlab = function (fnd) {
      var onS = (fnd === 'strips'), lo = onS ? 0.15 : 0.35, def = onS ? 0.30 : 0.40;
      var v = (typeof STATE.floorLevel === 'number' && isFinite(STATE.floorLevel)) ? STATE.floorLevel : def;
      return Math.max(lo, Math.min(0.80, v));
    };
    __PROD._eaveMin = 0;
    __PROD.beforeBuild = function () {
      /* NO PARAPET ON AN A (aframe-v69): the line's default is a parapet,
         which the house products clear when a roof tile is tapped; the A has
         no roof tile, so it stayed on and the core drew no roof ghost on Roof
         & Base (snapshot: handles active, rects none) */
      if (STATE.roof.parapet) { STATE.roof.parapet = false; _log('roof     parapet cleared -- an A-frame has none; the roof ghost on Roof & Base comes back'); }
      var o = STATE.roof.over || (STATE.roof.over = {});
      o.x0 = 0; o.x1 = 0;
      /* the gables' reach never under the 300 rake the fly rafters need */
      if (!(o.z0 >= RAKE)) o.z0 = RAKE; if (!(o.z1 >= RAKE)) o.z1 = RAKE;
      var seat = _deckY() + _plateFit().h, p = (STATE.roof.pitch || 60) * Math.PI / 180;
      STATE.roof.eaveY = seat;
      var out = 0;
      try {
        var PL = roofPlanes() || [], q, cx = STATE.origin.x;
        for (q = 0; q < PL.length; q++) {
          if (PL[q].kind !== 'slope' || !PL[q].eave) continue;
          out = Math.abs(PL[q].eave[0][0] - cx) - STATE.footprint.w / 2;
          break;
        }
      } catch (eP) { out = 0; }
      _eaveOut = Math.max(0, out);
      STATE.roof.eaveY = seat - _eaveOut * Math.tan(p);
      /* THE JOISTS ARE SIZED BY THE WIDEST FLOOR (aframe-v41, Marek: profily
         podle unosnosti): 60 x 200 while the widest upper floor spans up to
         4200 between the rafters, 60 x 240 over that (up to the 9 m house) */
      if (_opOn) { try { _sizeJoists(); } catch (eJ) {} }
      /* the insulation choice is kept with the project (aframe-v32) */
      try { var PI = STATE.product && STATE.product.aframeInsul; if (PI === 'above' || PI === 'between') INSUL = PI; } catch (eI) {}
      /* the gables' height for the core, and the old choices made into openings once (aframe-v24) */
      if (_opOn) { try { _opPrep(); } catch (eOp) { _opNote = 'ERROR preparing the openings: ' + ((eOp && eOp.message) || eOp); } }
      /* the partition between the house and each side wing (aframe-v109) */
      try { if (typeof WING !== 'undefined' && WING) _wingPartsSync(); } catch (eWp) { _wpNote = 'wingpart ERROR ' + ((eWp && eWp.message) || eWp); }
      try { if (typeof WING !== 'undefined' && WING && typeof WOPS !== 'undefined' && WOPS) _wingOpsSync(); } catch (eWo) { _wopNote = 'wingops  ERROR ' + ((eWo && eWo.message) || eWo); }
    };
    __PROD.beforeBuild();
    STATE.foundation = 'strips';

    var CLEAR = { ground: 2.50, upper: 2.20 };      /* clear heights (Marek) */
    var BED = { w: 0.90, at: 0.80 };                 /* a bed 900 wide, judged 800 above the floor */
    var FLOOR = { joist: { code: 'KVH60200', t: 0.060, d: 0.200, sp: 0.600 }, deck: { code: 'sheet.osb18', t: 0.018 } };
    var RAF = { small: { code: 'KVH60200', t: 0.060, d: 0.200 }, big: { code: 'KVH60240', t: 0.060, d: 0.240 }, sp: 0.600 };
    var RIDGE = { code: 'KVH10200', w: 0.100, h: 0.200 };
    /* 'above' | 'between' the rafters; between by default since aframe-v33
       (the build-up is reviewed layer by layer, and it is the usual DIY way) */
    var INSUL = 'between';
    var WOOD = 0xC9A87A, GABLE_COL = 0xD9CBB3;
    /* THE STAIRS (aframe-v4, A2; billed as kits in aframe-v5). A straight
       flight from each floor to the next, from the shared drawer; the opening
       is kept per upper floor and dragged on that floor's plan. The flight is
       one catalogue kit picked by the rise, the guard round the opening is
       billed by the metre -- both by the drawer. The kind -- ordinary or loft
       stair -- is switched on the Floorplan step and kept with the project;
       ordinary by default. */
    var STAIR = { w: 0.90, landing: 0.90, gable: 0.20 };
    function _stairKind() { var P = STATE.product || {}; return (P.aframeStair === 'loft') ? 'loft' : 'straight'; }
    /* WHAT IS HIDDEN WHILE A LAYER IS UNDER REVIEW. 'stairs': the gables and
       the roof skin are not built, so the flight can be seen from outside;
       'gables': the roof skin is not built, so the gable frames can be seen
       with the rafters over them; '' builds everything. */
    /* THE GABLE FRAME (aframe-v7, A4a), the ADU's stud wall members: 60 x 160
       studs every 600 from the ridge line out, a sole plate laid flat on the
       deck with the sill seal under it, and a raked top plate under the
       rafters on each side. The frame's outer face is the footprint line. */
    var GABLE = { t: 0.060, d: 0.160, sp: 0.600, code: 'KVH60160', seal: 'INS01003', sealT: 0.005 };
    /* THE GABLE OPENINGS (aframe-v20, K2). The A has no storey walls, so the
       core's windows and doors (which live on the wall segments of a storey)
       have nowhere to go; each gable carries its own choice instead: nothing,
       the entrance door, or the whole triangle glazed (K3). The door is the
       catalogue's exterior door, 900 x 2080, set in a rough opening 10 mm
       round it, fixed the way the core fixes every frame. */
    var DOOR = { code: 'ODE09001', w: 0.90, h: 2.08, gap: 0.010, frame: 0.068, col: 0x34373A, leaf: 0x4A4D50,
                 tape: 'OWP00002', foam: 'ODP00001', foamM: 30, anchor: 'OWP00003', anchorSp: 0.70, thresh: 'ODD00003' };
    /* THE GLAZED GABLE (aframe-v21, K3): the whole triangle under the raked
       plates, one made-to-measure fixed triple-glazed panel billed by the m2
       of glass. The panel comes with its own frame and glazing bead, so no
       bead, no mullion profile and no stud is billed inside it -- the lumber
       of that gable is only the sole and the two raked plates round it.
       FIXF0001 is priced by a RATE, not scraped. */
    var GLAZE = { code: 'FIXF0001', glass: 0x9FC3D6, frame: 0x34373A, mull: 0.050 };
    /* THE ROOF WINDOWS (aframe-v22, K4): in the two long sides of the A,
       the core's four roof-window sizes, 0 to 3 a side, on one storey, the
       sill 950 over that floor on the inside. The rough opening is the
       frame + 20 each way. At 600 centres no size fits between two
       rafters (540 clear), so every window is trimmed: a full-length trimmer
       rafter each side, doubled headers top and bottom between them, and
       the rafters in between cut and butted to the headers. */
    /* NO RAFTER IS CUT FOR A ROOF WINDOW (aframe-v25, Marek: nemeli bychom
       dat jen zdvojeny profil kolem okna, popripade omezit nabidku?). The
       window sits in one bay; the two rafters of that bay are set apart to
       its width plus 40 of fitting room, the bays either side get narrower
       by as much, and nothing else in the roof moves. The two rafters are
       doubled full length on the window's slope, and a single block closes
       the opening at its head and at its sill. A bay of 1140 is more than a
       60 x 200 rafter should take without a proper header, so the 1140 wide
       window is not offered on the A. */
    var ROOFWIN = { sizes: [{ code: 'OWR55118', w: 0.55, h: 1.18 }, { code: 'OWR78118', w: 0.78, h: 1.18 },
                            { code: 'OWR78140', w: 0.78, h: 1.40 }],
                    notOffered: ['OWR11118'], fit: 0.040, minBay: 0.20,
                    gap: 0.020, sill: 0.95, max: 3, col: 0x34373A, glass: 0x9FC3D6, frameH: 0.090 };
    /* THE GABLE SHEATHING (aframe-v23, A4b): 18 mm OSB on the outer face of
       each gable frame, the breathable membrane over it -- the ADU wall's own
       rows and rules (sheathing nails 22 a m2, membrane on a 1500 roll lapped
       100, the laps taped). The door's rough opening and the glazed triangle
       are cut out, so neither board nor membrane is billed where the door or
       the FIXF0001 panel stands. */
    var SHEATH = { code: 'sheet.osb18', t: 0.018, nail: 'FAS70000', nailPerM2: 22, col: 0xD8B97A,
                   memb: 'INS00002', tape: 'INS01005', roll: 1.50, lap: 0.10, membCol: 0xDCDFD8 };
    /* ITEMS THE CATALOGUE DOES NOT HAVE YET (aframe-v23, Marek: udrzuj seznam
       items ktere chybi, zatim je uctuj). Billed on a placeholder row named
       for what it is, so the quantity is in the bill; the row gets its real
       code when the catalogue thread makes it. */
    var MISSING = {
      /* aframe-v96: the catalogue made the second batch too (OWI00001,
         KVG60160, OWP00004, OWP00005, FAS65090, OWP00006, OWA55118,
         OWA78140) -- nothing is billed on a placeholder any more. The one
         fallback left is a flashing kit for a roof window size with no kit
         row (1140x1180, not offered on the A): it would be billed on
         TBD.roofWinFlash and say so in the roofwin line. */
      'TBD.recessCap':    'Metal cap over the rafters and the apron over the header in the sunk dormer of a side wing (m)',
      'TBD.edgeStrip':    'Perimeter edge (expansion) strip, foam about 8 x 50, round the floor under the self-levelling bed on the slab (m)',
      'TBD.rodentMesh':   'Galvanised welded rodent mesh (hardware cloth) about 6 mm, 0.6 mm wire, across the undersides of the floor joists on point footings (m2)',
      'TBD.woodOil':      'Interior wood oil, clear, water based, two coats, on the T&G and the rafters seen from the room with the insulation above the rafters (m2 of surface; the T house asked the same: INTERIOR WOOD OIL)',
      'TBD.staple':       'Hammer-tacker staple, galvanised, about 10 mm (3/8 in.) crown and leg, holding the vapour barrier and the breather membranes on the framing until the battens or boards go over them (pcs; 6 a m2)',
      'TBD.sw3way':       '3-way light switch (a pair switches one light from two places: the stair light at the foot and the head of every flight, IRC R303.7.1), white, for the US box (pcs; aframe-v165; the garage apartment asks the same, ga.sw3way)',
      'TBD.stairNose':    'Stair nose profile for the vinyl plank floor (overlap stair nosing about 50 x 13 with a lip down the edge, in the floor\'s colour), round the stair opening on the upper floor: the top step\'s nosing and the vinyl\'s edge cover (m; aframe-v164)'
    };
    /* THE CHEMISTRY OF THE JUNCTIONS (aframe-v153, plan J): every gypsum face
       primed before the core's paint (WIS00001: "two coats over a filled and
       primed surface"), the penetrating primer PEN00001 on the net board area
       +5%; the barrier and the breather membranes stapled to the framing,
       6 a m2, before the battens hold them; the barrier's foot where it meets
       the slab or the deck sealed with butyl tape INS01001 (the membrane tape
       INS01005 does not hold on concrete or OSB), the laps and the corners
       stay on INS01005 */
    var CHEM = { primer: 'PEN00001', primerW: 1.05, staple: 'TBD.staple', staplePerM2: 6, butyl: 'INS01001', butylW: 1.05 };
    function _chemNote(ctx, who, pr, st, bu) {
      var o = [];
      if (pr > 0) o.push('primer ' + CHEM.primer + ' ' + (pr * CHEM.primerW).toFixed(2) + ' m2 (' + pr.toFixed(2) + ' of board +5%)');
      if (st > 0) o.push(Math.ceil(st * CHEM.staplePerM2) + ' x ' + CHEM.staple + ' (' + st.toFixed(2) + ' m2 of barrier / membrane, 6 a m2)');
      if (bu > 0) o.push('butyl ' + CHEM.butyl + ' ' + (bu * CHEM.butylW).toFixed(2) + ' m (' + bu.toFixed(2) + ' of the barrier\'s foot on the floor +5%)');
      if (o.length) ctx.log('chem     ' + who + ' (aframe-v153): ' + o.join(', '));
    }
    function _chemBill(L, pr, st, bu) {
      if (pr > 0.01) API.billAdd(L, CHEM.primer, Math.round(pr * CHEM.primerW * 100) / 100);
      if (st > 0.01) API.billAdd(L, CHEM.staple, Math.ceil(st * CHEM.staplePerM2));
      if (bu > 0.01) API.billAdd(L, CHEM.butyl, Math.round(bu * CHEM.butylW * 100) / 100);
    }
    /* the flashing kit by the window's size: only 780x1180 has a row so far */
    /* the build-up over the rafters (aframe-v99) */
    var ABOVE = { pir: 'ROP12003', t: 0.160, layers: 2, screw: 'FAS80320' };   /* the fallback before the zones load; by the zone: _pirAbove (aframe-v158, TBD.pir80 retired) */
    /* THE SLOPES' HYBRID (aframe-v157, plan K step 2a, Marek: varianta A).
       Between the rafters the mineral wool fills the rafter full; on the deck
       foil faced PIR boards (ROP12002 / 12003 / 12001 = 50 / 80 / 100, one
       layer or two with the joints staggered, taped INS01005, IRC R806.5.2)
       as thick as the zone asks: at least the IRC R806.5 condensation share
       (R-5 in zones 2-3, 15 in 4, 20 in 5, 25 in 6, 35 in 7-8 -- zone 8's,
       the frost depth does not tell 7 from 8) and at least the 2021 IECC
       ceiling (R-49 / 60) less the wool's. Over the PIR the underlay and
       the counter battens, vented from the eaves (insect comb ROV00100) to
       the ridge, so the vent channel under the deck and its baffles are
       gone. The vapour barrier stays under the rafters (the air barrier the
       boxes are taped to, aframe-v155), none on the deck under the PIR. The
       counter battens held down through the PIR into the rafters by washer
       head screws 8 mm (FAS80200 / 80260 / 80320, the shortest that goes 70
       into the rafter through the batten 30, the PIR and the deck 18); the
       insulation above the rafters takes the same screw -- TBD.screw8x300
       retired */
    var HYB = { stock: [['ROP12002', 0.050], ['ROP12003', 0.080], ['ROP12001', 0.100]], cb: 0.030, deck: 0.018, embed: 0.070,
                screws: [['FAS80200', 0.200], ['FAS80260', 0.260], ['FAS80320', 0.320]] };
    var R806 = { '2': 5, '3': 5, '4': 15, '5': 20, '6': 25, '7-8': 35 };
    function _pirScrew(t) {
      var need = HYB.cb + t + HYB.deck + HYB.embed, i;
      for (i = 0; i < HYB.screws.length; i++) if (HYB.screws[i][1] >= need - 0.001) return HYB.screws[i][0];
      return HYB.screws[HYB.screws.length - 1][0];
    }
    var _pirMemo = { key: '', val: null };
    function _pirAbove() {
      if (!IECC_Z) return (INSUL === 'above') ? { mode: 'above', code: ABOVE.pir, t: ABOVE.t, layers: ABOVE.layers, screw: _pirScrew(ABOVE.t) } : null;
      if (INSUL === 'above') {
        /* ABOVE THE RAFTERS BY THE ZONE (aframe-v158, plan K step 2b): one
           continuous layer with nothing bridging it, so the IECC's U-factor
           alternative (2021 Table R402.1.2: ceiling U-0.026 in zones 2-3,
           0.024 from 4) is the measure: the assembly -- air films 0.61 each
           side, the T&G, the deck, the PIR -- against it. 2 x 80 ROP12003
           (U-0.0246) in zones 2-3, 2 x 100 ROP12001 (U-0.0200) from 4;
           TBD.pir80 retired. The prescriptive R-49 / 60 would take 240 /
           280 and a screw past the catalogue's 320 */
        var Za = _iecc(), keyA = 'above|' + (+STATE.climateZone || 0);
        if (_pirMemo.key === keyA) return _pirMemo.val;
        var cA = null, ia;
        for (ia = 0; ia < ABOVE_Z.length; ia++) { var tA = ABOVE_Z[ia][1] * ABOVE_Z[ia][2]; if (_aboveU(tA) <= Za.ceilU + 1e-5) { cA = ABOVE_Z[ia]; break; } }
        cA = cA || ABOVE_Z[ABOVE_Z.length - 1];
        var vA = { mode: 'above', code: cA[0], t: cA[1] * cA[2], layers: cA[2], screw: _pirScrew(cA[1] * cA[2]), r: _rOf(cA[1] * cA[2], R_IN.pir), u: _aboveU(cA[1] * cA[2]), uMax: Za.ceilU, cz: Za.cz };
        _pirMemo = { key: keyA, val: vA };
        return vA;
      }
      var R = _rafSize(), key = INSUL + '|' + (+STATE.climateZone || 0) + '|' + R.d;
      if (_pirMemo.key === key) return _pirMemo.val;
      var Z = _iecc(), W = woolUpTo(R.d), rW = _rOf(W.t, R_IN.wool), cond = R806[Z.cz] || 0, need = Math.max(cond, Z.ceil - rW), C = [], i, best = null;
      HYB.stock.forEach(function (s) { C.push({ code: s[0], t: s[1], layers: 1 }); C.push({ code: s[0], t: 2 * s[1], layers: 2 }); });
      C.sort(function (a, b) { return (a.t - b.t) || (a.layers - b.layers); });
      for (i = 0; i < C.length; i++) if (_rOf(C[i].t, R_IN.pir) >= need - 0.5) { best = C[i]; break; }
      best = best || C[C.length - 1];
      best.mode = 'hybrid'; best.screw = _pirScrew(best.t); best.wool = W; best.rW = rW; best.r = _rOf(best.t, R_IN.pir);
      best.need = need; best.cond = cond; best.cz = Z.cz; best.ceil = Z.ceil;
      _pirMemo = { key: key, val: best };
      return best;
    }
    var ABOVE_Z = [['ROP12003', 0.080, 2], ['ROP12001', 0.100, 2]];
    function _aboveU(t) { return 1 / (0.61 + FAC.clad.t / 0.0254 * 1.25 + 0.018 / 0.0254 * 1.25 + _rOf(t, R_IN.pir) + 0.61); }
    function _pirT() { var P = _pirAbove(); return P ? P.t : 0; }
    /* THE WALLS' CONTINUOUS LAYER (aframe-v158, plan K step 2b): the gables'
       R-25 cavity meets the 2021 IECC wood frame wall alone in zones 2 and 3
       (13 / 20); from zone 4 the table asks 20+5 (or 13+10, 0+15) -- a
       continuous board outside the sheathing. EPS 40 (INS00402, R-6.3) on
       the membrane, under the rainscreen battens: vapour-open enough to let
       the wall dry outward past the poly inside (a foil faced board would
       make a second barrier); laid in courses of 1200 x 600 boards, held by
       two plate anchors FAT00016 + FAS60080 a board until the battens go on,
       the battens screwed through it with FAS60160 instead of FAS60100, PU
       foam FCP00005 one per 10 m2 at the units and the edges. The facade,
       the soffit, the porch base and the walls' service runs sit 40 further
       out. The side wing's walls and the dormer follow in v159 */
    var CI = { code: 'INS00402', t: 0.040, board: 0.72, plate: 'FAT00016', screw: 'FAS60080', perBoard: 2, foam: 'FCP00005', foamPer: 10, battScrew: 'FAS60160', col: 0xE6E4DC };
    var _ciMemo = { key: '', val: 0 };
    function _ciT() {
      if (!IECC_Z) return 0;
      var key = String(+STATE.climateZone || 0);
      if (_ciMemo.key === key) return _ciMemo.val;
      var Z = _iecc(), cav = _rOf(woolFill(GABLE.d).t, R_IN.wool);
      var bare = Z.wall.some(function (w) { return cav >= w[0] - 0.5 && w[1] <= 0; });
      var v = bare ? 0 : CI.t;
      _ciMemo = { key: key, val: v };
      return v;
    }
    /* the verge board's planks by the height they close: 40 over the verge rafter + the deck + the PIR (aframe-v157) */
    function _vergeRows(P) { var h = 0.040 + 0.021 + P.t + 0.002; return (h <= 0.162) ? [['KVR16019', 0.160]] : (h <= 0.262) ? [['KVR16019', 0.160], ['KVR10019', 0.100]] : [['KVR16019', 0.160], ['KVR16019', 0.160]]; }
    function _pirTxt(P) { return P.layers + ' x ' + Math.round(P.t / P.layers * 1000) + ' = ' + Math.round(P.t * 1000) + ' ' + P.code; }
    var FLASH_KIT = { 'OWR55118': 'OWA55118', 'OWR78118': 'OWA78118', 'OWR78140': 'OWA78140' };
    /* the one-piece LVL rafter past the US stock length (aframe-v88) */
    var LVL = { code: 'KVI45240', over: 7.315 };
    var _flashKitLabel = 'OWA78118', _flashKitCode = '';
    /* THE OPENINGS ARE THE CORE'S (aframe-v24, P1, Marek: chci stejny
       zpusob vkladani a editace vsude na konfiguratorech, i kdyz ma sikmou
       stenu). The Doors & Windows step is the ADU's: a kind opens the
       catalogue, a tap on a wall places the unit, Edit drags it and the bin
       takes it away (core-v491). This file only answers the core's questions:
       which walls take a unit (the two gables; a roof window goes on the
       roof), how high a unit may reach under the rake, what a full or half
       wall unit is in a triangle, and where a roof window lands on a slope. */
    var AF_KINDS = ['window', 'door', 'french', 'roof'];
    var _opOn = false;          /* true once the whole file has been read */
    var _opNote = '';           /* what the last preparation did, for the snapshot */
    /* the gable's own geometry, in one place: the sole on the deck and the
       raked plates under the rafters, as heights over a point x across the A */
    function _gGeo() {
      var S = _sect(), B = _barRect(), cx = (B.x0 + B.x1) / 2, t = GABLE.t;
      var yUnder = function (x) { return S.top + (S.half - S.rafD / S.sin - Math.abs(x - cx)) * S.tan; };
      var yPlate = function (x) { return yUnder(x) - t / S.cos; };
      return { S: S, B: B, cx: cx, ySole: S.deck, yStud0: S.deck + t, yUnder: yUnder, yPlate: yPlate, xIn: S.widthAt(S.deck) / 2 };
    }
    /* a gable is a ground-storey segment running across the A (the ridge runs along z) */
    function _isGable(sg) {
      return !!sg && (sg.storey | 0) === 0 && Math.abs(sg.z1 - sg.z0) < 1e-4 && sg.len > 0.5;
    }
    function _gableSegs() {
      var out = [], L = [], i;
      try { L = segments() || []; } catch (eS) { L = []; }
      for (i = 0; i < L.length; i++) if (_isGable(L[i])) out.push(L[i]);
      return out;
    }
    function _segUx(sg) { return (sg.x1 - sg.x0) / sg.len; }
    /* THE FULL AND THE HALF UNIT OF A GABLE: the whole triangle between the
       sole and the raked plates (FIXF0001), or the band at its top, the upper
       half of its height (FIXH0001) */
    /* THE HALF UNIT STANDS UPRIGHT (aframe-v57, Marek: half wall window na
       vysku, ne na sirku): a band half the gable's width, centred, from the
       sole up to the raked plates -- a pentagon, its top the rake. The unit
       carries its outline (poly), its half-width at any height (wAt) and its
       perimeter, so every layer cuts round it the same way. */
    /* ONE GABLE GLAZING, NINE WAYS (aframe-v64, Marek: jen jedno full wall
       window s prepinacem i pro half, at se to zjednodussi; half na vysku --
       prosklene horizontalne 1 patro / 2 patra / 1 a 3 patro / leva pulka /
       prava pulka / stredem). The unit is the core's full wall window; its
       variant is kept on the record as afVar and stepped by the cycler icon:
         balcony, door, plain   the whole triangle (the three sets of v63)
         g1                     the ground floor, level under the floor 2 zone
         g12                    floors 1 and 2, level under the floor 3 zone
         g13                    floors 1 and 3, a solid wall across floor 2
         left, right            the half of the triangle each side of the ridge line
         center                 the upright band in the middle (the old half unit)
       Every glazed part is the triangle cut to a rectangle, so every layer
       cuts round it the same way: rects [x0, x1, y0, y1] and their polygons.
       A variant the floors do not allow (g1 on one floor, g12 and g13 on
       fewer than three) is skipped by the cycler and built as plain. */
    var GLZ_VARS = ['balcony', 'door', 'plain', 'g1', 'g12', 'g13', 'left', 'right', 'center'];
    var GLZ_FULL = { balcony: 1, door: 1, plain: 1 };
    function _glzOk(v) {
      var n = floors().length;
      if (v === 'g1') return n >= 2;
      if (v === 'g12' || v === 'g13') return n >= 3;
      if (v === 'balcony') return true;
      return GLZ_VARS.indexOf(v) >= 0;
    }
    function _glzVarOf(rec) {
      if (typeof rec === 'string') return (rec === 'half') ? 'center' : 'balcony';
      var v = rec && rec.afVar;
      if (GLZ_VARS.indexOf(v) < 0) v = (rec && (rec.rake === 'half' || rec.halfW)) ? 'center' : 'balcony';
      return _glzOk(v) ? v : 'plain';
    }
    function _glzLabel(v) {
      return ({ balcony: _t('glazing_set_balcony', 'Doors + balcony'), door: _t('glazing_set_door', 'HS door'), plain: _t('glazing_set_plain', 'Glass only'),
                g1: _t('glazing_set_g1', 'Floor 1'), g12: _t('glazing_set_g12', 'Floors 1-2'), g13: _t('glazing_set_g13', 'Floors 1 + 3'),
                left: _t('glazing_set_left', 'Left half'), right: _t('glazing_set_right', 'Right half'), center: _t('glazing_set_center', 'Centre band') })[v] || v;
    }
    /* a polygon cut to x0..x1 (both kept edges upright) */
    function _polyClipX(P, x0, x1) {
      var clip = function (poly, keep) {
        var out = [], i;
        for (i = 0; i < poly.length; i++) {
          var A = poly[i], B = poly[(i + 1) % poly.length], ia = keep(A), ib = keep(B);
          if (ia >= 0) out.push(A);
          if ((ia >= 0) !== (ib >= 0)) { var t = ia / (ia - ib); out.push([A[0] + t * (B[0] - A[0]), A[1] + t * (B[1] - A[1])]); }
        }
        return out;
      };
      var Q = clip(P, function (p) { return p[0] - x0; });
      if (Q.length >= 3) Q = clip(Q, function (p) { return x1 - p[0]; });
      return (Q.length >= 3) ? Q : [];
    }
    /* a polygon clipped to a convex one (both counter-clockwise or not, the
       clip polygon's winding is read) */
    function _clipConvex(P, C) {
      var ar = 0, i; for (i = 0; i < C.length; i++) { var a1 = C[i], a2 = C[(i + 1) % C.length]; ar += a1[0] * a2[1] - a2[0] * a1[1]; }
      var sg = ar >= 0 ? 1 : -1, out = P.slice();
      for (i = 0; i < C.length && out.length >= 3; i++) {
        var A = C[i], B = C[(i + 1) % C.length], inp = out, j;
        var side = function (p) { return sg * ((B[0] - A[0]) * (p[1] - A[1]) - (B[1] - A[1]) * (p[0] - A[0])); };
        out = [];
        for (j = 0; j < inp.length; j++) {
          var P1 = inp[j], P2 = inp[(j + 1) % inp.length], s1 = side(P1), s2 = side(P2);
          if (s1 >= 0) out.push(P1);
          if ((s1 >= 0) !== (s2 >= 0)) { var tq = s1 / (s1 - s2); out.push([P1[0] + tq * (P2[0] - P1[0]), P1[1] + tq * (P2[1] - P1[1])]); }
        }
      }
      return (out.length >= 3) ? out : [];
    }
    /* WHAT IS LEFT OF A CONVEX OUTLINE ROUND A SET OF RECTANGLES (aframe-v64):
       the grid of the rectangles' edges, the free cells of each column merged
       up the column and with the next column where the runs are the same,
       each piece clipped to the outline. A gable glazed across its whole
       width touches the outline on both sides, which a shape with a hole
       cannot take; these pieces can. */
    function _outlineMinus(C, RR) {
      var xs = [], ys = [], i, x0 = 1e9, x1 = -1e9, y0 = 1e9, y1 = -1e9;
      for (i = 0; i < C.length; i++) { x0 = Math.min(x0, C[i][0]); x1 = Math.max(x1, C[i][0]); y0 = Math.min(y0, C[i][1]); y1 = Math.max(y1, C[i][1]); }
      xs.push(x0, x1); ys.push(y0, y1);
      for (i = 0; i < RR.length; i++) { xs.push(RR[i][0], RR[i][1]); ys.push(RR[i][2], RR[i][3]); }
      var uniq = function (A, a, b) { A = A.filter(function (v) { return v >= a - 1e-6 && v <= b + 1e-6; }).sort(function (p, q) { return p - q; }); var o = [], k; for (k = 0; k < A.length; k++) if (!o.length || A[k] - o[o.length - 1] > 0.001) o.push(Math.max(a, Math.min(b, A[k]))); return o; };
      xs = uniq(xs, x0, x1); ys = uniq(ys, y0, y1);
      var solid = function (x, y) { for (var r = 0; r < RR.length; r++) if (x > RR[r][0] && x < RR[r][1] && y > RR[r][2] && y < RR[r][3]) return true; return false; };
      var cols = [], ix, iy, out = [];
      for (ix = 0; ix + 1 < xs.length; ix++) {
        var xm = (xs[ix] + xs[ix + 1]) / 2, lo = null, runs = [];
        for (iy = 0; iy + 1 <= ys.length; iy++) {
          var free = (iy + 1 < ys.length) && !solid(xm, (ys[iy] + ys[iy + 1]) / 2);
          if (free && lo == null) lo = ys[iy];
          if (!free && lo != null) { runs.push([lo, ys[iy]]); lo = null; }
        }
        var key = runs.map(function (r) { return r[0].toFixed(4) + ':' + r[1].toFixed(4); }).join('|');
        if (cols.length && cols[cols.length - 1].key === key && Math.abs(cols[cols.length - 1].x1 - xs[ix]) < 1e-6) cols[cols.length - 1].x1 = xs[ix + 1];
        else cols.push({ x0: xs[ix], x1: xs[ix + 1], key: key, runs: runs });
      }
      for (ix = 0; ix < cols.length; ix++) for (iy = 0; iy < cols[ix].runs.length; iy++) {
        var CL = cols[ix], R = CL.runs[iy], P = _clipConvex([[CL.x0, R[0]], [CL.x1, R[0]], [CL.x1, R[1]], [CL.x0, R[1]]], C);
        if (P.length >= 3 && _polyArea(P) > 0.0005) out.push(P);
      }
      return out;
    }
    /* the part of a convex polygon on the outer side of the line A -> B */
    function _halfOut(P, A, B, triSign) {
      var out = [], j, side = function (p) { return -triSign * ((B[0] - A[0]) * (p[1] - A[1]) - (B[1] - A[1]) * (p[0] - A[0])); };
      for (j = 0; j < P.length; j++) {
        var P1 = P[j], P2 = P[(j + 1) % P.length], s1 = side(P1), s2 = side(P2);
        if (s1 >= 0) out.push(P1);
        if ((s1 >= 0) !== (s2 >= 0)) { var tq = s1 / (s1 - s2); out.push([P1[0] + tq * (P2[0] - P1[0]), P1[1] + tq * (P2[1] - P1[1])]); }
      }
      return (out.length >= 3) ? out : [];
    }
    /* A LAYER OF THE GABLE ROUND A PARTLY GLAZED GABLE (aframe-v64): the
       outline less the units' rectangles and the glazing's rectangles, then
       inside each glazing rectangle what lies outside the glass triangle
       (the strip over the raked plates) given back */
    function _gableMinus(C, unitRR, RU) {
      var out = _outlineMinus(C, unitRR.concat(RU.rects)), i, TR = RU.tri;
      var ar = (TR[1][0] - TR[0][0]) * (TR[2][1] - TR[0][1]) - (TR[2][0] - TR[0][0]) * (TR[1][1] - TR[0][1]), sgn = ar >= 0 ? 1 : -1;
      for (i = 0; i < RU.rects.length; i++) {
        var R = RU.rects[i], base = _clipConvex([[R[0], R[2]], [R[1], R[2]], [R[1], R[3]], [R[0], R[3]]], C);
        if (base.length < 3) continue;
        var pA = _halfOut(base, TR[1], TR[2], sgn), pB = _halfOut(base, TR[2], TR[0], sgn);
        if (pB.length >= 3) { pB = _halfOut(pB, TR[2], TR[1], sgn); }            /* not the part pA has already */
        if (pA.length >= 3 && _polyArea(pA) > 0.0005) out.push(pA);
        if (pB.length >= 3 && _polyArea(pB) > 0.0005) out.push(pB);
      }
      return out;
    }
    function _polyArea(P) { var a = 0, i; for (i = 0; i < P.length; i++) { var p1 = P[i], p2 = P[(i + 1) % P.length]; a += p1[0] * p2[1] - p2[0] * p1[1]; } return Math.abs(a) / 2; }
    function _polyPerim(P) { var a = 0, i; for (i = 0; i < P.length; i++) { var p1 = P[i], p2 = P[(i + 1) % P.length]; a += Math.hypot(p2[0] - p1[0], p2[1] - p1[1]); } return a; }
    function _rakeUnit(sg, rec) {
      var G = _gGeo(), cx = G.cx, h0 = G.yPlate(cx) - G.yStud0, b0 = h0 / G.S.tan, v = _glzVarOf(rec), t = GABLE.t;
      var full = !!GLZ_FULL[v], yB = G.yStud0, apex = G.yPlate(cx);
      /* A FULLY GLAZED GABLE GOES UP UNDER THE GABLE RAFTER (aframe-v67,
         Marek: full wall window zapustene az pod zaklop strechy, zadne kousky
         kolem): no raked top plates there, the glazing's own head frame is
         screwed up into the gable rafter, so the glass reaches its underside */
      /* ...AND SO DOES EVERY PARTLY GLAZED ONE (aframe-v89, Marek: i half
         window ve stitu pri cyklovani zapustene az ke krokvim, zadne
         dorezavane obklady okolo): wherever the glass meets the rake it runs
         up to the rafter's underside; the raked plates stay only over the
         framed part of the gable, cut plumb at the glass */
      apex = G.yUnder(cx); b0 = (apex - yB) / G.S.tan;
      var TRI = [[cx - b0, yB], [cx + b0, yB], [cx, apex]];
      var fl = floors(), zb = function (i) { return fl[i].y - FLOOR.deck.t - FLOOR.joist.d; };
      var rects = [], heads = [], sills = [], jambs = [];
      if (full) rects.push([cx - b0, cx + b0, yB, apex]);
      else if (v === 'g1') { rects.push([cx - b0, cx + b0, yB, zb(1) - 2 * t]); heads.push(zb(1) - 2 * t); }
      else if (v === 'g12') { rects.push([cx - b0, cx + b0, yB, zb(2) - 2 * t]); heads.push(zb(2) - 2 * t); }
      else if (v === 'g13') {
        rects.push([cx - b0, cx + b0, yB, zb(1) - 2 * t]); heads.push(zb(1) - 2 * t);
        rects.push([cx - b0, cx + b0, fl[2].y + 2 * t, apex]); sills.push(fl[2].y);
      }
      else if (v === 'left') { rects.push([cx - b0, cx - t, yB, apex]); jambs.push({ x: cx - t, s: 1 }); }
      else if (v === 'right') { rects.push([cx + t, cx + b0, yB, apex]); jambs.push({ x: cx + t, s: -1 }); }
      else { rects.push([cx - b0 / 2, cx + b0 / 2, yB, apex]); jambs.push({ x: cx - b0 / 2, s: -1 }); jambs.push({ x: cx + b0 / 2, s: 1 }); }
      var polys = [], area = 0, per = 0, i, bx0 = 1e9, bx1 = -1e9, by0 = 1e9, by1 = -1e9;
      for (i = 0; i < rects.length; i++) {
        var R = rects[i], P = _polyBand(TRI, R[2], R[3]).poly;
        if (P.length >= 3) P = _polyClipX(P, R[0], R[1]);
        if (P.length < 3) continue;
        polys.push(P); area += _polyArea(P); per += _polyPerim(P);
        for (var k = 0; k < P.length; k++) { bx0 = Math.min(bx0, P[k][0]); bx1 = Math.max(bx1, P[k][0]); by0 = Math.min(by0, P[k][1]); by1 = Math.max(by1, P[k][1]); }
      }
      if (!polys.length) { polys.push(TRI); area = _polyArea(TRI); per = _polyPerim(TRI); bx0 = cx - b0; bx1 = cx + b0; by0 = yB; by1 = apex; }
      var wAt = function (y) { if (y < yB - 1e-9 || y > apex) return 0; return Math.min(b0, (apex - y) / G.S.tan); };
      /* the glazed x-runs over a height band, and the glazed y-runs over an upright strip */
      var xRuns = function (ya, yb2) { var o = [], q; for (q = 0; q < polys.length; q++) { var PB = _polyBand(polys[q], ya, yb2).poly; if (PB.length < 3) continue; var a = 1e9, b = -1e9, j; for (j = 0; j < PB.length; j++) { a = Math.min(a, PB[j][0]); b = Math.max(b, PB[j][0]); } o.push([a, b]); } return o; };
      var yRuns = function (xa, xb) { var o = [], q; for (q = 0; q < polys.length; q++) { var PX = _polyClipX(polys[q], xa, xb); if (PX.length < 3) continue; var a = 1e9, b = -1e9, j; for (j = 0; j < PX.length; j++) { a = Math.min(a, PX[j][1]); b = Math.max(b, PX[j][1]); } o.push([a, b]); } return o; };
      var topAt = function (x) { return apex - Math.abs(x - cx) * G.S.tan; };
      return { half: !full, full: full, v: v, topAt: topAt, at: (((bx0 + bx1) / 2) - sg.x0) / _segUx(sg), w: bx1 - bx0, h: by1 - by0, sill: by0 - sg.y0, yB: yB, b: full ? b0 : (bx1 - bx0) / 2, b0: b0, yK: yB,
               rects: rects, polys: polys, poly: polys[0], heads: heads, sills: sills, jambs: jambs, xRuns: xRuns, yRuns: yRuns, tri: TRI,
               area: area, perim: per, wAt: wAt, apex: apex, cx: full ? cx : (bx0 + bx1) / 2, cxG: cx, code: full ? 'FIXF0001' : 'FIXH0001' };
    }
    function _polyPath(T, P, asShape) {
      var o = asShape ? new T.Shape() : new T.Path(), i;
      o.moveTo(P[0][0], P[0][1]); for (i = 1; i < P.length; i++) o.lineTo(P[i][0], P[i][1]); o.lineTo(P[0][0], P[0][1]);
      return o;
    }
    /* a polygon cut to the band y0..y1 (both kept edges level) */
    function _polyBand(P, y0, y1) {
      var clip = function (poly, keep) {
        var out = [], i;
        for (i = 0; i < poly.length; i++) {
          var A = poly[i], B = poly[(i + 1) % poly.length], ia = keep(A), ib = keep(B);
          if (ia >= 0) out.push(A);
          if ((ia >= 0) !== (ib >= 0)) { var t = ia / (ia - ib); out.push([A[0] + t * (B[0] - A[0]), A[1] + t * (B[1] - A[1])]); }
        }
        return out;
      };
      var Q = clip(P, function (p) { return p[1] - y0; });
      if (Q.length >= 3) Q = clip(Q, function (p) { return y1 - p[1]; });
      if (Q.length < 3) return { poly: [], area: 0 };
      var a = 0, i; for (i = 0; i < Q.length; i++) { var p1 = Q[i], p2 = Q[(i + 1) % Q.length]; a += p1[0] * p2[1] - p2[0] * p1[1]; }
      return { poly: Q, area: Math.abs(a) / 2 };
    }
    /* FOR THE CORE'S EDIT OVERLAY AND ITS CYCLER ICON (aframe-v63, for the UI
       thread): the outline of a full or half glazing as the wall sees it --
       [[u along the wall, v up from the wall's foot], ...] -- so the ghost is
       the glass and not the box round it; and the unit's set, stepped on a tap
       of the icon at the gable's middle ({ label, next() }). A unit that is not
       a glazing answers null and the core keeps its rectangle and no icon. */
    __PROD._opOutline = function (sg, rec) {
      if (!_opOn || !rec || !(rec.rake || rec.fullW || rec.halfW) || !_isGable(sg)) return null;
      var RU = _rakeUnit(sg, rec), ux = _segUx(sg), out = [], i, q;
      for (q = 0; q < RU.polys.length; q++) {
        var P = [];
        for (i = 0; i < RU.polys[q].length; i++) P.push([(RU.polys[q][i][0] - sg.x0) / ux, RU.polys[q][i][1] - sg.y0]);
        out.push(P);
      }
      return (out.length === 1) ? out[0] : out;
    };
    /* the variants the floors allow, in the order Marek listed them */
    function _glzNext(rec) {
      var v = _glzVarOf(rec), i = GLZ_VARS.indexOf(v), k, nx = v;
      for (k = 1; k <= GLZ_VARS.length; k++) { var c = GLZ_VARS[(i + k) % GLZ_VARS.length]; if (_glzOk(c)) { nx = c; break; } }
      rec.afVar = nx;
      /* the record carries the glazed part's box, for the plan and the grab */
      try {
        var GS = _gableSegs(), sg = null, q;
        for (q = 0; q < GS.length; q++) if (GS[q].id === rec.seg) sg = GS[q];
        if (sg) { var RU = _rakeUnit(sg, rec); rec.at = RU.at; rec.w = RU.w; rec.h = RU.h; rec.sill = RU.sill; rec.code = RU.code; rec.fullW = true; rec.halfW = null; rec.rake = 'full'; }
      } catch (eR) {}
      return nx;
    }
    __PROD._opCycle = function (rec) {
      if (!_opOn || !rec || !(rec.rake || rec.fullW || rec.halfW)) return null;
      return { label: _glzLabel(_glzVarOf(rec)), next: function () { var nx = _glzNext(rec); _log('glass    gable glazing -> ' + nx + ' (' + _glzLabel(nx) + ', cycler)'); return nx; } };
    };
    __PROD._opHost = function (sg, kind) {
      if (kind === 'roof') return false;
      if (_isWingSeg(sg)) return kind !== 'garage';
      return _isGable(sg);
    };
    /* how high the member over a unit may sit: the header (two plies) under
       the raked plate, over the kings' outer faces, whichever end is lower */
    __PROD._opUnder = function (sg, rec) {
      /* in a wing's wall: under its doubled header under the plates (aframe-v113) */
      if (_opOn && rec && _isWingSeg(sg)) { var Hw = _wingH(sg.wing); return Hw.wallTop - 2 * GABLE.t - WOPS.hdr - Hw.yP; }
      if (!_opOn || !rec || !_isGable(sg)) return null;
      var G = _gGeo(), tt = GABLE.t, ux = _segUx(sg);
      var eL = (+rec.at || 0) - (+rec.w || 0) / 2 - 2 * tt, eR = (+rec.at || 0) + (+rec.w || 0) / 2 + 2 * tt;
      return Math.min(G.yPlate(sg.x0 + ux * eL), G.yPlate(sg.x0 + ux * eR)) - 2 * tt - sg.y0;
    };
    __PROD._opFull = function (sg, o) {
      if (!_opOn || !_isGable(sg)) return null;
      /* one unit for both tiles (aframe-v64): the half tile starts it as the centre band */
      var v0 = (o.full === 'half') ? 'center' : 'balcony', RU = _rakeUnit(sg, { afVar: v0 });
      return { seg: sg.id, at: RU.at, w: RU.w, h: RU.h, sill: RU.sill, kind: o.kind || 'window',
               code: RU.code, fullW: true, halfW: null, rake: 'full', afVar: v0, leaves: 1 };
    };
    /* THE ROOF WINDOWS ON THE SLOPES. A record { host: 'roof', plane:
       'left' | 'right', along: z of its centre, up: its centre's distance up
       the rafters' top face from the foot }. */
    /* THE RAFTER LINES, AS A CARPENTER SETS THEM OUT (aframe-v31, Marek:
       stity podle praxe). A gable rafter pair stands over each gable wall,
       flush with its outer face; the rake overhang is a fly (barge) rafter
       pair at the rake edge, held to the house by lookouts -- flat blocks
       that run from the fly rafter over the gable rafter, notched into it,
       to the first common rafter inside. The common rafters share the
       length between the two gable rafters evenly, 600 at the most. */
    function _rafGrid() {
      var B = _barRect(), tt = _rafSize().t, z0 = B.z0 - _rakeOf(0), z1 = B.z1 + _rakeOf(1);
      var g0 = B.z0 + tt / 2, g1 = B.z1 - tt / 2, m = Math.max(1, Math.ceil((g1 - g0) / RAF.sp - 1e-6)), lines = [z0], q, iG0, iG1;
      /* over a porch the pairs go on at 600 at the most between the gable rafter and the end one */
      if (_porch(0)) { var m0 = Math.max(1, Math.ceil((g0 - z0) / RAF.sp - 1e-6)); for (q = 1; q < m0; q++) lines.push(z0 + (g0 - z0) * q / m0); }
      iG0 = lines.length;
      var wSd = _wingSides();
      if (!wSd.length) { for (q = 0; q <= m; q++) lines.push(g0 + (g1 - g0) * q / m); }
      else {
        /* the wing's rafters are fixed (aframe-v106); the house's run evenly up to them from each gable, 600 at most */
        var WGr = _wingGrid(), F = WGr.lines, ma = Math.max(1, Math.ceil((F[0] - g0) / RAF.sp - 1e-6)), mb = Math.max(1, Math.ceil((g1 - F[F.length - 1]) / RAF.sp - 1e-6));
        for (q = 0; q < ma; q++) lines.push(g0 + (F[0] - g0) * q / ma);
        for (q = 0; q < F.length; q++) lines.push(F[q]);
        for (q = 1; q <= mb; q++) lines.push(F[F.length - 1] + (g1 - F[F.length - 1]) * q / mb);
      }
      iG1 = lines.length - 1;
      if (_porch(1)) { var m1 = Math.max(1, Math.ceil((z1 - g1) / RAF.sp - 1e-6)); for (q = 1; q < m1; q++) lines.push(g1 + (z1 - g1) * q / m1); }
      lines.push(z1);
      return { z0: z0, z1: z1, n: lines.length - 1, lines: lines, sp: (g1 - g0) / m, gable: [iG0, iG1], fly: [0, lines.length - 1], porch: [_porch(0), _porch(1)] };
    }
    /* the bay a point along the ridge falls in: lines[k] < z < lines[k + 1] */
    function _bayOf(RG, z) {
      var k;
      for (k = 0; k < RG.n; k++) if (z < RG.lines[k + 1]) return k;
      return RG.n - 1;
    }
    function _roofGeo() {
      var S = _sect(), B = _barRect(), R = _rafSize(), cx = (B.x0 + B.x1) / 2, xT = S.w / 2;
      return { S: S, B: B, R: R, cx: cx, yTop0: S.top + S.half * S.tan, xT: xT, Ltop: xT / S.cos };
    }
    function _rwSizeOf(rec) {
      var i;
      for (i = 0; i < ROOFWIN.sizes.length; i++) if (ROOFWIN.sizes[i].code === rec.code) return ROOFWIN.sizes[i];
      return { code: rec.code || null, w: +rec.w || 0.78, h: +rec.h || 1.18 };
    }
    function _rwOffered(code) { return ROOFWIN.notOffered.indexOf(code) < 0; }
    /* THE PICKER SHOWS ONLY WHAT THE A TAKES (aframe-v26): the core reads
       its roof group live from the kit's catalogue, so the units the A does
       not offer are taken out of that group on this page */
    var _rwTrimmed = '';
    function _rwTrimOffer() {
      try {
        var U = (typeof _UI === 'function') ? _UI() : _UI, C = U && U.OPENING_CATALOG, G = C && C.roof;
        if (!G || !G.items) return;
        var keep = [], gone = [], i;
        for (i = 0; i < G.items.length; i++) { if (_rwOffered(G.items[i].code)) keep.push(G.items[i]); else gone.push(G.items[i].code); }
        if (gone.length) { G.items = keep; _rwTrimmed = 'roof windows not offered on the A, taken out of the picker: ' + gone.join(', '); }
      } catch (eT) { _rwTrimmed = 'could not trim the roof window offer: ' + ((eT && eT.message) || eT); }
    }
    function _rafOver(RG, a0, a1, tt) {
      var q;
      for (q = 0; q <= RG.n; q++) { var zr = RG.lines[q]; if (zr + tt / 2 > a0 + 1e-6 && zr - tt / 2 < a1 - 1e-6) return true; }
      return false;
    }
    /* where a ray meets a slope's top face; 'only' keeps it on one slope */
    function _slopeHit(ray, only) {
      if (!ray || !ray.origin || !ray.direction) return null;
      var Q = _roofGeo(), S = Q.S, RG = _rafGrid(), best = null, sd;
      for (sd = -1; sd <= 1; sd += 2) {
        var nm = (sd < 0) ? 'left' : 'right';
        if (only && only !== nm) continue;
        var nx = sd * S.sin, ny = S.cos, dd = nx * Q.cx + ny * Q.yTop0;
        var den = nx * ray.direction.x + ny * ray.direction.y;
        if (Math.abs(den) < 1e-9) continue;
        var tq = (dd - nx * ray.origin.x - ny * ray.origin.y) / den;
        if (!(tq > 0)) continue;
        var px = ray.origin.x + ray.direction.x * tq, pz = ray.origin.z + ray.direction.z * tq, u = sd * (px - Q.cx);
        if (!only && (u < 0 || u > Q.xT || pz < RG.z0 || pz > RG.z1)) continue;
        if (!best || tq < best.t) best = { t: tq, plane: nm, along: pz, up: Q.Ltop - u / S.cos };
      }
      return best;
    }
    /* KEPT LEGAL: across the slope its centre goes to a rafter line or a bay
       middle where both trimmers clear every rafter that stays whole; down
       the slope its headers stay 300 off the ridge beam and off the rafter
       foot, and it stays inside one storey -- the sill 200 over that floor,
       the head under the joists of the floor above */
    function _roofFit(rec) {
      var Q = _roofGeo(), S = Q.S, R = Q.R, RG = _rafGrid(), sz = _rwSizeOf(rec), tt = R.t, fl = floors(), notes = [];
      var roH = sz.h + 2 * ROOFWIN.gap, k, best = null, clr = sz.w + ROOFWIN.fit;
      var zA = Q.B.z0 + GABLE.d + 0.05, zB = Q.B.z1 - GABLE.d - 0.05, want = +rec.along || 0;
      /* OVER A PORCH TOO (aframe-v62, Marek: stresni okno muze byt i nad terasou):
         the bays out to the porch's end rafter take a window; over a plain
         rake it is brought in over the house */
      if (RG.porch && RG.porch[0]) zA = RG.z0 + 0.10;
      if (RG.porch && RG.porch[1]) zB = RG.z1 - 0.10;
      if (want < zA || want > zB) notes.push('tapped at ' + Math.round(want * 1000) + ' along the ridge, over the rake -- brought in to the nearest bay');
      /* across the slope: the middle of a bay, whose two rafters -- set apart
         to the window and doubled on their outer faces -- stay inside the gables */
      /* and not next to a bay another roof window has, on either slope --
         the rafter between them cannot move both ways; in the SAME bay only
         the same window (aframe-v26, Marek: nad sebe jen stejna okna): the
         bay is set apart to one width, so a second window there, on either
         slope, is the same unit, and on the same slope it stands above or
         below the first with its own blocks */
      var busy = {}, stackS = {}, OPb = STATE.openings || [], qb;
      for (qb = 0; qb < OPb.length; qb++) {
        var ob = OPb[qb];
        if (!ob || ob === rec || ob.host !== 'roof') continue;
        var kbO = _bayOf(RG, +ob.along || 0);
        busy[kbO - 1] = true; busy[kbO + 1] = true;
        if (ob.code !== rec.code) busy[kbO] = true;
        else if (ob.plane === rec.plane) {
          var szO = _rwSizeOf(ob), hO = szO.h + 2 * ROOFWIN.gap;
          (stackS[kbO] = stackS[kbO] || []).push([Q.Ltop - (+ob.up || 0), hO]);
        }
      }
      for (k = 0; k < RG.n; k++) {
        var c = (RG.lines[k] + RG.lines[k + 1]) / 2, e0 = c - clr / 2 - 2 * tt, e1 = c + clr / 2 + 2 * tt;
        if (e0 < zA || e1 > zB || busy[k]) continue;
        if (best == null || Math.abs(c - want) < Math.abs(best - want)) best = c;
      }
      if (!_rwOffered(sz.code)) notes.push(sz.code + ' is not offered on the A (a bay that wide needs a header)');
      if (best == null) notes.push('no bay along the slope where it fits between the gables (a bay beside another window, or with a different one in it, is taken)');
      else rec.along = best;
      var kBest = (best == null) ? -1 : _bayOf(RG, best), STK = stackS[kBest] || [];
      var yIn = function (s) { return Q.yTop0 - s * S.sin - R.d / S.cos; };
      var sMin = 0.30 + 2 * tt + roH / 2;
      var sMax = (Q.xT - R.d / S.sin) / S.cos - 2 * tt - roH / 2;
      var sM = Math.max(sMin, Math.min(sMax, Q.Ltop - (+rec.up || 0)));
      /* inside one storey, for a centre s: the storey its centre falls in */
      var inStorey = function (s0) {
        var yC = yIn(s0), st = 0, q;
        for (q = 0; q < fl.length; q++) if (fl[q].y <= yC) st = q;
        var F = fl[st], yCeil = (st + 1 < fl.length) ? (fl[st + 1].y - FLOOR.joist.d - FLOOR.deck.t) : null;
        var sBmax = (Q.yTop0 - R.d / S.cos - (F.y + 0.20)) / S.sin;
        var sTmin = (yCeil != null) ? ((Q.yTop0 - R.d / S.cos - yCeil) / S.sin) : -1e9;
        var lo = Math.max(sMin, sTmin + roH / 2), hi = Math.min(sMax, sBmax - roH / 2);
        if (lo > hi + 1e-6) return { ok: false, st: st, s: s0, room: Math.max(0, hi - lo + roH) };
        return { ok: true, st: st, s: Math.min(hi, Math.max(lo, s0)) };
      };
      /* clear of a window stacked in the same bay: blocks do not share */
      var clash = function (s0) {
        for (var j = 0; j < STK.length; j++) if (Math.abs(s0 - STK[j][0]) < (STK[j][1] + roH) / 2 + 2 * tt - 1e-6) return true;
        return false;
      };
      var fit = inStorey(sM);
      /* ONE ROW A STOREY (aframe-v90, Marek: stresni okna by se mela vyskove
         zarovnavat vuci sobe, dat jim v podlazi optimalni vysku od podlahy).
         On the storey it is dragged to, a window snaps to that storey's row:
         the sill of its opening ROOFWIN.sill (950) over the floor -- the usual
         850..1100 for a roof window, which at this pitch puts a 1180 unit's
         head near 2 m, so one sees out sitting and standing. Where the row
         does not fit (a low storey under the ridge) it keeps the nearest
         height that does; a second window stacked in the same bay keeps its
         own height, since two cannot share a row there. */
      rec.rowSnap = false;
      if (fit.ok) {
        var Fr = fl[fit.st], sRow = (Q.yTop0 - R.d / S.cos - (Fr.y + ROOFWIN.sill)) / S.sin - roH / 2;
        var fRow = inStorey(Math.max(sMin, Math.min(sMax, sRow)));
        if (fRow.ok && fRow.st === fit.st && !clash(fRow.s)) { fit = fRow; rec.rowSnap = (Math.abs(fRow.s - sRow) < 0.002) ? 'row' : 'nearest'; }
        else rec.rowSnap = 'stacked';
      }
      if (fit.ok && clash(fit.s)) {
        var cands = [], j2, bestF = null;
        for (j2 = 0; j2 < STK.length; j2++) {
          var dS = (STK[j2][1] + roH) / 2 + 2 * tt + 0.001;
          cands.push(STK[j2][0] - dS); cands.push(STK[j2][0] + dS);
        }
        for (j2 = 0; j2 < cands.length; j2++) {
          var f2 = inStorey(Math.max(sMin, Math.min(sMax, cands[j2])));
          if (f2.ok && !clash(f2.s) && (!bestF || Math.abs(f2.s - sM) < Math.abs(bestF.s - sM))) bestF = f2;
        }
        if (bestF) fit = bestF;
        else notes.push('no room above or below the other window in bay ' + (kBest + 1));
      }
      if (!fit.ok) notes.push('it does not fit on storey ' + (fit.st + 1) + ' (' + Math.round(roH * 1000) + ' along the slope, room ' + Math.round(fit.room * 1000) + ')');
      else sM = fit.s;
      rec.up = Q.Ltop - sM; rec.storey = fit.st; rec.w = sz.w; rec.h = sz.h;
      rec.fitNote = notes.join('; ');
      return rec;
    }
    __PROD._roofHit = function (ray) {
      if (!_opOn) return null;
      var h = _slopeHit(ray);
      return h ? { plane: h.plane, along: h.along, up: h.up } : null;
    };
    __PROD._roofClamp = function (rec) { if (_opOn && rec) _roofFit(rec); };
    __PROD._roofMove = function (rec, ray, drag) {
      if (!_opOn || !rec) return;
      var h = _slopeHit(ray, rec.plane);
      if (!h) return;
      if (drag && !drag.rwOff) drag.rwOff = { a: (+rec.along || 0) - h.along, u: (+rec.up || 0) - h.up };
      var off = (drag && drag.rwOff) || { a: 0, u: 0 };
      rec.along = h.along + off.a; rec.up = h.up + off.u;
      _roofFit(rec);
    };
    /* EVERY BUILD: the gables stand as tall as their apex so the core lets a
       unit reach up the triangle, and ONCE per project the old choices
       (aframe-v20..v23: a door or glazing per gable, 0-3 roof windows a side)
       become ordinary openings; a new project starts with the same default --
       the entrance door in the front gable and one 780 x 1180 roof window a
       side on the upper floor */
    function _opPrep() {
      var P = STATE.product = STATE.product || {}, GS = _gableSegs(), i, G = _gGeo();
      STATE.segH = STATE.segH || {};
      for (i = 0; i < GS.length; i++) STATE.segH[GS[i].id] = Math.max(0.5, G.yUnder(G.cx) - GS[i].y0);
      if (P.aframeOpMig) return;
      var B = _barRect(), front = null, back = null;
      for (i = 0; i < GS.length; i++) {
        if (Math.abs(GS[i].z0 - B.z0) < 0.01) front = GS[i];
        else if (Math.abs(GS[i].z0 - B.z1) < 0.01) back = GS[i];
      }
      if (!front || !back) { _opNote = 'migration waits: ' + GS.length + ' gable segment(s) found'; return; }
      STATE.openings = STATE.openings || [];
      var gb = P.aframeGable || null, rw = P.aframeRoofWin || null, made = [];
      if (!STATE.openings.length) {
        var gOpt = function (side) { var v = gb && gb[side]; return (v === 'none' || v === 'door' || v === 'glass') ? v : (side === 'front' ? 'door' : 'none'); };
        var pairs = [['front', front], ['back', back]], pq;
        for (pq = 0; pq < 2; pq++) {
          var v = gOpt(pairs[pq][0]), sg = pairs[pq][1], RU = _rakeUnit(sg, 'full');
          if (v === 'door') {
            STATE.openings.push({ seg: sg.id, at: RU.at, w: DOOR.w, h: DOOR.h, sill: 0, kind: 'door', code: DOOR.code, hand: 'L', leaves: 1 });
            made.push(pairs[pq][0] + ' door ' + DOOR.code);
          } else if (v === 'glass') {
            STATE.openings.push({ seg: sg.id, at: RU.at, w: RU.w, h: RU.h, sill: RU.sill, kind: 'window', code: RU.code, fullW: true, rake: 'full', leaves: 1 });
            made.push(pairs[pq][0] + ' glazing ' + RU.code);
          }
        }
        var code = (rw && rw.code) || 'OWR78118', sz0 = _rwSizeOf({ code: code }), fl = floors();
        var stW = (rw && typeof rw.storey === 'number') ? rw.storey : (fl.length > 1 ? 1 : 0);
        if (stW >= fl.length) stW = fl.length - 1;
        var Q = _roofGeo(), roH0 = sz0.h + 2 * ROOFWIN.gap;
        var sB0 = (Q.yTop0 - (fl[stW].y + ROOFWIN.sill) - Q.R.d / Q.S.cos) / Q.S.sin, up0 = Q.Ltop - (sB0 - roH0 / 2);
        var zA = B.z0 + GABLE.d + 0.05, zB = B.z1 - GABLE.d - 0.05, nm, kk;
        var sides = ['left', 'right'];
        for (pq = 0; pq < 2; pq++) {
          nm = sides[pq];
          var cnt = (rw && typeof rw[nm] === 'number') ? Math.max(0, Math.min(3, rw[nm] | 0)) : 1;
          for (kk = 0; kk < cnt; kk++) {
            var rec = { host: 'roof', kind: 'roof', code: sz0.code, w: sz0.w, h: sz0.h, sill: 0, plane: nm,
                        along: zA + (kk + 0.5) * (zB - zA) / cnt, up: up0 };
            _roofFit(rec);
            STATE.openings.push(rec);
            made.push(nm + ' roof window ' + sz0.code);
          }
        }
      }
      P.aframeOpMig = 1;
      delete P.aframeGable; delete P.aframeRoofWin;
      _opNote = 'openings from the old choices / the default: ' + (made.length ? made.join(', ') : 'none (the project already had openings)');
      try { if (API.savePref) API.savePref(); } catch (eSv) {}
    }
    /* nothing under review by hiding (aframe-v47): the sheathing, the membrane and the roof skin are drawn again */
    var REVIEW = '';
    /* the roof skin under review (aframe-v48): 'edges' hides the covering and the ridge cap and draws the drip edge and verge magenta; '' draws it all */
    /* the edges accepted (aframe-v50, Marek: profily asi ok) */
    var SKIN_REVIEW = '';
    /* the roof window flashing under review (aframe-v54): magenta while true */
    var FLASH_REVIEW = false;
    /* a quarter-turn arrow for the Rotate tile, drawn like the kit's icons */
    var ICO_ROTATE = '<path d="M20 12a8 8 0 1 1-2.34-5.66"/><path d="M20 4v5h-5"/>';

    /* -------------------------------------------------------------------------
       WHAT THIS CABIN BILLS AGAINST -- rows the catalogue has today.
       ------------------------------------------------------------------------- */
    __CORE.CATALOG = {
      'grd.excavation':   { code: 'FEE00001', unit: 'm3',  label: 'Excavation' },
      'grd.gravel':       { code: 'FCO00001', unit: 'm3',  label: 'Gravel base 16-32' },
      'grd.gravelSlab':   { code: 'FFG00001', unit: 'm3',  label: 'Pea gravel (slab)' },
      'grd.geotextile':   { code: 'FEC00003', unit: 'm2',  label: 'Geotextile' },
      'grd.concrete':     { code: 'FCO00002', unit: 'm3',  label: 'Structural concrete C20/25 (footings)' },
      'grd.concreteSlab': { code: 'FFM00001', unit: 'm3',  label: 'Cast-in-place concrete C20/25 (slab)' },
      'FCO00003':         { code: 'FCO00003', unit: 'm',   label: 'Reinforcing steel bar 14' },
      'WWR00061':         { code: 'WWR00061', unit: 'pcs', label: 'Reinforcing stirrups 250x200' },
      /* the reinforcement of the strips and the slab (aframe-v12, core-v474) */
      'FFM00004':         { code: 'FFM00004', unit: 'pcs', label: 'Rebar spacer' },
      'FEC00026':         { code: 'FEC00026', unit: 'kg',  label: 'Tying wire' },
      'FFR30002':         { code: 'FFR30002', unit: 'pcs', label: 'Welded wire mesh (slab)' },
      /* under the slab (aframe-v14): the ADU's film and its tape */
      'ROV00001':         { code: 'ROV00001', unit: 'm2',  label: 'Vapour barrier foil' },
      'INS01502':         { code: 'INS01502', unit: 'm2',  label: 'EPS insulation board 150' },
      'INS01005':         { code: 'INS01005', unit: 'm',   label: 'Sealing tape for membranes' },
      'FCO00007':         { code: 'FCO00007', unit: 'ls',  label: 'Foundation formwork' },
      'KVH60200':         { code: 'KVH60200', unit: 'm',   label: 'Dimensional lumber 60x200' },
      'KVH60240':         { code: 'KVH60240', unit: 'm',   label: 'Dimensional lumber 60x240' },
      'KVH10200':         { code: 'KVH10200', unit: 'm',   label: 'Dimensional lumber 100x200' },
      /* the stairs, billed as kits (aframe-v5): one flight by its rise, the
         guard round the opening by the metre */
      'SIS22060':         { code: 'SIS22060', unit: 'pcs', label: 'Straight stairs (rise to 2200)' },
      'SIS24070':         { code: 'SIS24070', unit: 'pcs', label: 'Straight stairs (rise to 2400)' },
      'SIS30090':         { code: 'SIS30090', unit: 'pcs', label: 'Straight stairs (rise to 3000)' },
      'SIS32090':         { code: 'SIS32090', unit: 'pcs', label: 'Straight stairs (rise to 3200)' },
      'SIS28090':         { code: 'SIS28090', unit: 'pcs', label: 'Straight stairs (rise to 2800)' },
      'SIS28070':         { code: 'SIS28070', unit: 'pcs', label: 'Loft stairs (rise to 2800)' },
      'SIS00001':         { code: 'SIS00001', unit: 'm',   label: 'Straight railing' },
      'sheet.osb18':      { code: 'OSB25002', unit: 'm2',  label: 'OSB board 18 mm' },
      /* the gable frames (aframe-v7): the ADU's stud and its sill seal */
      'KVH60160':         { code: 'KVH60160', unit: 'm',   label: 'Dimensional lumber 60x160' },
      'INS01003':         { code: 'INS01003', unit: 'm',   label: 'Sill seal under bottom plate' },
      /* the point footings and the floor frame on them (aframe-v6), the rows
         the ADU bills them with */
      'steel.screwPile':  { code: 'FGR00004', unit: 'pcs', label: 'Ground screw 1500x102' },
      'steel.saddle':     { code: 'FGR00002', unit: 'pcs', label: 'U head post adapter' },
      'grd.padBlock':     { code: 'FCO00009', unit: 'pcs', label: 'Precast concrete footing 400x400' },
      'FCO00004':         { code: 'FCO00004', unit: 'pcs', label: 'Post base anchor U type' },
      'FAS55050':         { code: 'FAS55050', unit: 'pcs', label: 'Stainless steel screw (a2) 5.5x50' },
      'FAS50060':         { code: 'FAS50060', unit: 'pcs', label: 'Wood screw 5x60 (#10 2-1/2In.)' },
      'FAS45145':         { code: 'FAS45145', unit: 'pcs', label: 'Nails 145 (20d)' },
      /* the roof skin from the shared drawer (aframe-v3): deck, underlay,
         battens, edges, covering, ridge -- the rows the whole line bills */
      'OSB25002':         { code: 'OSB25002', unit: 'm2',  label: 'OSB board 18 mm' },
      'FAS70000':         { code: 'FAS70000', unit: 'pcs', label: 'Sheathing nail' },
      'ROR00008':         { code: 'ROR00008', unit: 'm2',  label: 'Roof underlay' },
      'FAS63000':         { code: 'FAS63000', unit: 'pcs', label: 'Staple' },
      'KVR50030':         { code: 'KVR50030', unit: 'm',   label: 'Counter batten 50x30' },
      /* the interior lining (aframe-v32), the ADU ceiling's rows */
      'WDD24001':         { code: 'WDD24001', unit: 'm2',  label: 'Gypsum board 12.5 mm' },
      'WDF00008':         { code: 'WDF00008', unit: 'm',   label: 'Drywall tape' },
      'WDF00009':         { code: 'WDF00009', unit: 'kg',  label: 'Drywall joint compound' },
      'WDS00001':         { code: 'WDS00001', unit: 'pcs', label: 'Drywall ceiling screws' },
      /* the floors (aframe-v37), the ADU's rows */
      'INS01201':         { code: 'INS01201', unit: 'm2',  label: 'Mineral wool 120' },
      /* the wool between the rafters and the gable studs (aframe-v43), the ADU's rows */
      'INS02001':         { code: 'INS02001', unit: 'm2',  label: 'Mineral wool 200' },
      'INS01601':         { code: 'INS01601', unit: 'm2',  label: 'Mineral wool 160' },
      'INS01151':         { code: 'INS01151', unit: 'm2',  label: 'Mineral wool 115' },
      'INS00601':         { code: 'INS00601', unit: 'm2',  label: 'Mineral wool 60' },
      'INS01004':         { code: 'INS01004', unit: 'm2',  label: 'Impact sound underlay' },
      'FFC00005':         { code: 'FFC00005', unit: 'm2',  label: 'Vinyl flooring (LVF)' },
      'FFW00002':         { code: 'FFW00002', unit: 'm',   label: 'Skirting boards' },
      'KVR50031':         { code: 'KVR50031', unit: 'm',   label: 'Roof batten 50x30' },
      'FAS60100':         { code: 'FAS60100', unit: 'pcs', label: 'Roofing screw' },
      /* the full glazing's doors (aframe-v63), the core catalogue's rows */
      'OWR20001':         { code: 'OWR20001', unit: 'pcs', label: 'HS sliding door 2000x2590' },
      'OWR15002':         { code: 'OWR15002', unit: 'pcs', label: 'HS sliding door 1500x2590' },
      'OWR10001':         { code: 'OWR10001', unit: 'pcs', label: 'French door 1000x2590' },
      'OWR12001':         { code: 'OWR12001', unit: 'pcs', label: 'Window 1200x1500 (the wing, aframe-v112)' },
      'TBD.recessCap':    { code: 'TBD.recessCap', unit: 'm', label: 'Metal cap on the rafters in the sunk dormer -- NO CODE YET' },
      /* the balcony (aframe-v58), the ADU terrace's rows */
      'TST00002':         { code: 'TST00002', unit: 'm2',  label: 'Decking boards' },
      'FAT00011':         { code: 'FAT00011', unit: 'pcs', label: 'Joist hanger' },
      'FAS80200':         { code: 'FAS80200', unit: 'pcs', label: 'Washer head screw 8x200' },
      /* the slopes' hybrid (aframe-v157): PIR on the deck, the counter battens' screws through it */
      'FAS80260':         { code: 'FAS80260', unit: 'pcs', label: 'Washer head screw 8x260' },
      /* the flight's railing and fixings (aframe-v163, the garage apartment's rows) */
      'SIS00002':         { code: 'SIS00002', unit: 'm',   label: 'Stair railing' },
      'FAT00005':         { code: 'FAT00005', unit: 'pcs', label: 'Reinforced angle bracket' },
      'FAS50040':         { code: 'FAS50040', unit: 'pcs', label: 'Structural connector screw' },
      'FAS10075':         { code: 'FAS10075', unit: 'pcs', label: 'Concrete screw anchor' },
      'FAS80100':         { code: 'FAS80100', unit: 'pcs', label: 'Wood screw 8x100' },
      /* the stairwell's edge (aframe-v164, the barndominium's row; the nose has none yet) */
      'WIW00001':         { code: 'WIW00001', unit: 'm',   label: 'Corner beads for walls' },
      'TBD.stairNose':    { code: 'TBD.stairNose', unit: 'm', label: 'Stair nose profile for the vinyl floor -- NO CODE YET' },
      /* the stair light (aframe-v165, the garage apartment's 9a): the 3-way pair has no row yet */
      'TBD.sw3way':       { code: 'TBD.sw3way', unit: 'pcs', label: '3-way light switch -- NO CODE YET' },
      /* the entrance steps (aframe-v170, the RANCH's row) */
      'SES28011':         { code: 'SES28011', unit: 'pcs', label: 'Exterior straight stairs' },
      /* the slab's joints (aframe-v171, the garage apartment's rows) */
      'FFM00008':         { code: 'FFM00008', unit: 'm',   label: 'Sawcut control joint' },
      'FFM00009':         { code: 'FFM00009', unit: 'm',   label: 'Isolation joint filler' },
      'KVR16019':         { code: 'KVR16019', unit: 'm',   label: 'Planed plank 160x19' },
      /* the walls' continuous layer (aframe-v158) */
      'INS00402':         { code: 'INS00402', unit: 'm2',  label: 'EPS insulation board 40' },
      'FAT00016':         { code: 'FAT00016', unit: 'pcs', label: 'Insulation plate anchor 60' },
      'FAS60160':         { code: 'FAS60160', unit: 'pcs', label: 'Wood screw 6x160' },
      'KVR10019':         { code: 'KVR10019', unit: 'm',   label: 'Planed plank 100x19' },
      'FAS80320':         { code: 'FAS80320', unit: 'pcs', label: 'Washer head screw 8x320' },
      'ROP12002':         { code: 'ROP12002', unit: 'm2',  label: 'PIR insulation board alu 50' },
      'ROP12003':         { code: 'ROP12003', unit: 'm2',  label: 'PIR insulation board alu 80' },
      'ROP12001':         { code: 'ROP12001', unit: 'm2',  label: 'PIR insulation board alu 100' },
      'KVH10100':         { code: 'KVH10100', unit: 'm',   label: 'Dimensional lumber 100x100' },
      'KVH10060':         { code: 'KVH10060', unit: 'm',   label: 'Dimensional lumber 60x100' },
      'ODI06001':         { code: 'ODI06001', unit: 'pcs', label: 'Interior door 600 LH' },
      'ODI06002':         { code: 'ODI06002', unit: 'pcs', label: 'Interior door 600 RH' },
      'ODI08001':         { code: 'ODI08001', unit: 'pcs', label: 'Interior door 800 LH' },
      'ODI08002':         { code: 'ODI08002', unit: 'pcs', label: 'Interior door 800 RH' },
      'ODI09001':         { code: 'ODI09001', unit: 'pcs', label: 'Interior door 900 LH' },
      'ODI09002':         { code: 'ODI09002', unit: 'pcs', label: 'Interior door 900 RH' },
      'ODI12001':         { code: 'ODI12001', unit: 'pcs', label: 'Double interior door 1220' },
      'ODI16001':         { code: 'ODI16001', unit: 'pcs', label: 'Double interior door 1520' },
      'ODD00001':         { code: 'ODD00001', unit: 'pcs', label: 'Interior door handle set' },
      'ODD00005':         { code: 'ODD00005', unit: 'pcs', label: 'Door hinge' },
      /* the gables' rainscreen (aframe-v47), the ADU's rows */
      'KVH40060':         { code: 'KVH40060', unit: 'm',   label: 'Timber batten 40x60' },
      'FVW01351':         { code: 'FVW01351', unit: 'm2',  label: 'Wood facade cladding 135x15' },
      'FEC00034':         { code: 'FEC00034', unit: 'm',   label: 'Rodent mesh (cavity foot)' },
      /* the vent channel over the wool in the rafter bays (aframe-v49), the ADU's rows */
      'ROV00100':         { code: 'ROV00100', unit: 'm',   label: 'Eaves ventilation strip 100' },
      'ROV00101':         { code: 'ROV00101', unit: 'm',   label: 'Vent baffle' },
      'ROM02401':         { code: 'ROM02401', unit: 'm',   label: 'Drip edge' },
      'ROR00006':         { code: 'ROR00006', unit: 'm',   label: 'Verge trim' },
      'FAS00318':         { code: 'FAS00318', unit: 'pcs', label: 'Roofing nail' },
      'ROR00001':         { code: 'ROR00001', unit: 'm2',  label: 'Asphalt shingle' },
      'ROR12004':         { code: 'ROR12004', unit: 'm2',  label: 'Trapezoidal sheet' },
      'ROR12003':         { code: 'ROR12003', unit: 'm2',  label: 'Standing seam sheet' },
      'ROR00009':         { code: 'ROR00009', unit: 'm',   label: 'Ridge cap 250' },
      /* the rafter feet on their plate (aframe-v8): the rows the ADU fixes
         its sill, its trusses and its frame joints with */
      'KVP45290':         { code: 'KVP45290', unit: 'm',   label: 'Pressure treated lumber 45x290' },
      'FAT16010':         { code: 'FAT16010', unit: 'pcs', label: 'Steel threaded rod M16 1 m' },
      'FAT16011':         { code: 'FAT16011', unit: 'pcs', label: 'Nut M16' },
      'FAT16001':         { code: 'FAT16001', unit: 'pcs', label: 'Steel washer M16' },
      'FAT16002':         { code: 'FAT16002', unit: 'pcs', label: 'Steel cap nut M16' },
      'ROT00007':         { code: 'ROT00007', unit: 'pcs', label: 'Hurricane tie 250x40x2' },
      'FAS38038':         { code: 'FAS38038', unit: 'pcs', label: 'Structural connector nail 3.8x38' },
      'FAS75132':         { code: 'FAS75132', unit: 'pcs', label: 'Full thread screw 7.5x132' },
      'ROT00006':         { code: 'ROT00006', unit: 'pcs', label: 'Truss connector plate 250x150x1.2' },
      'ROR00007':         { code: 'ROR00007', unit: 'm',   label: 'Ridge vent strip' },
      'FAS00225':         { code: 'FAS00225', unit: 'pcs', label: 'Sealing screw' },
      /* the entrance door in the gable (aframe-v20, K2), with the rows the
         core fixes every frame with (core-v383..385) */
      'ODE09001':         { code: 'ODE09001', unit: 'pcs', label: 'Exterior door 900x2080 L' },
      'OWP00002':         { code: 'OWP00002', unit: 'm',   label: 'Frame joint tape' },
      'ODP00001':         { code: 'ODP00001', unit: 'pcs', label: 'PU foam' },
      'OWP00003':         { code: 'OWP00003', unit: 'pcs', label: 'Frame anchor' },
      'ODD00003':         { code: 'ODD00003', unit: 'm',   label: 'Door transition strip' },
      /* the glazed gable (aframe-v21, K3): a finished panel, its frame included */
      'FIXF0001':         { code: 'FIXF0001', unit: 'm2',  label: 'Fixed full wall window' },
      'FIXH0001':         { code: 'FIXH0001', unit: 'm2',  label: 'Fixed half wall window' },
      /* the window sill boards, outer and inner, the core's frame rule (aframe-v24) */
      'OWW00002':         { code: 'OWW00002', unit: 'm',   label: 'Window sill outer' },
      'OWW00001':         { code: 'OWW00001', unit: 'm',   label: 'Window sill inner' },
      /* the gable sheathing's membrane (aframe-v23), the ADU wall's row */
      'INS00002':         { code: 'INS00002', unit: 'm2',  label: 'Breathable membrane' },
      /* placeholder rows for items the catalogue does not have yet (MISSING) */
      /* the wing's flat roof (aframe-v102): the ADU's flat roof and gutter rows */
      'ROT00004':         { code: 'ROT00004', unit: 'm',   label: 'Furring strip 30x100' },
      'ROR00002':         { code: 'ROR00002', unit: 'm2',  label: 'Roof hydrofoil' },
      'ROA00001':         { code: 'ROA00001', unit: 'm',   label: 'Aluminium termination bar 30x3' },
      'ROR00012':         { code: 'ROR00012', unit: 'm',   label: 'Self adhesive flashing tape' },
      'FAS45070':         { code: 'FAS45070', unit: 'pcs', label: 'Stainless steel screw (a2)' },
      'FEC00038':         { code: 'FEC00038', unit: 'pcs', label: 'Polyurethane construction sealant' },
      'FEC00003':         { code: 'FEC00003', unit: 'm2',  label: 'Geotextile' },
      'ROG01251':         { code: 'ROG01251', unit: 'm',   label: 'Rainwater gutter' },
      'ROA01251':         { code: 'ROA01251', unit: 'pcs', label: 'Gutter bracket' },
      'ROG00001':         { code: 'ROG00001', unit: 'pcs', label: 'Gutter end cap' },
      'ROG00005':         { code: 'ROG00005', unit: 'pcs', label: 'Gutter hopper' },
      'ROG01252':         { code: 'ROG01252', unit: 'm',   label: 'Rainwater downspout' },
      'ROG00006':         { code: 'ROG00006', unit: 'pcs', label: 'Downspout elbow' },
      'ROG00009':         { code: 'ROG00009', unit: 'pcs', label: 'Downspout outlet elbow' },
      'ROG00011':         { code: 'ROG00011', unit: 'pcs', label: 'Downspout bracket' },
      'TBD.roofWinFlash': { code: 'TBD.roofWinFlash', unit: 'pcs', label: 'Roof window flashing kit, other size -- NO CODE YET' },
      'TBD.pir80':        { code: 'TBD.pir80', unit: 'm2', label: 'PIR insulation board 80 -- NO CODE YET' },
      'TBD.screw8x300':   { code: 'TBD.screw8x300', unit: 'pcs', label: 'Counter-batten screw 8x300 through the insulation -- NO CODE YET' },
      'TBD.woodOil':      { code: 'TBD.woodOil', unit: 'm2', label: 'Interior wood oil, clear, two coats -- NO CODE YET' },
      /* the timber curtain wall of a glazed gable (aframe-v91), its rows (aframe-v96) */
      'OWI00001':         { code: 'OWI00001', unit: 'm2',  label: 'Insulated glass unit' },
      'KVG60160':         { code: 'KVG60160', unit: 'm',   label: 'Glued laminated timber 60x160' },
      'OWP00004':         { code: 'OWP00004', unit: 'm',   label: 'Curtain wall pressure plate' },
      'OWP00005':         { code: 'OWP00005', unit: 'm',   label: 'EPDM glazing gasket' },
      'FAS65090':         { code: 'FAS65090', unit: 'pcs', label: 'Stainless steel screw 6.5x90' },
      'OWP00006':         { code: 'OWP00006', unit: 'pcs', label: 'Glazing setting block' },
      'OWA55118':         { code: 'OWA55118', unit: 'pcs', label: 'Roof window flashing kit 550x1180' },
      'OWA78140':         { code: 'OWA78140', unit: 'pcs', label: 'Roof window flashing kit 780x1400' },
      /* the rows the catalogue made for the A-frame (aframe-v87) */
      'OWA78118':         { code: 'OWA78118', unit: 'pcs', label: 'Roof window flashing kit 780x1180' },
      'KVP60160':         { code: 'KVP60160', unit: 'm',   label: 'Pressure treated lumber 60x160' },
      'FFC00007':         { code: 'FFC00007', unit: 'kg',  label: 'Self-leveling underlayment' },
      'FEC00020':         { code: 'FEC00020', unit: 'm2',  label: 'Concrete primer' },
      'SFF00003':         { code: 'SFF00003', unit: 'm',   label: 'Landscape edging' },
      'FAS80060':         { code: 'FAS80060', unit: 'pcs', label: 'Screw anchor' },
      'INS00503':         { code: 'INS00503', unit: 'm2',  label: 'XPS insulation board' },
      /* the slab's perimeter and plinth (aframe-v131), the ADU's ETICS rows */
      'FCP00005':         { code: 'FCP00005', unit: 'pcs', label: 'Low expansion adhesive foam 750ml' },
      'FFR00051':         { code: 'FFR00051', unit: 'm2',  label: 'Reinforcing base coat 5' },
      'GTM00001':         { code: 'GTM00001', unit: 'm2',  label: 'Glass fiber textile mesh' },
      'PEN00001':         { code: 'PEN00001', unit: 'm2',  label: 'Penetrating primer' },
      'INS01001':         { code: 'INS01001', unit: 'm',   label: 'Butyl sealing tape' },
      'TBD.staple':       { code: 'TBD.staple', unit: 'pcs', label: 'Hammer-tacker staple for the barrier and the membranes -- NO CODE YET' },
      'FCP00002':         { code: 'FCP00002', unit: 'm2',  label: 'Plinth render 6' },
      'FCP00006':         { code: 'FCP00006', unit: 'm',   label: 'ETICS corner bead with mesh 100x150' },
      'TBD.edgeStrip':    { code: 'TBD.edgeStrip', unit: 'm', label: 'Perimeter edge strip under the levelling bed -- NO CODE YET' },
      'TBD.rodentMesh':   { code: 'TBD.rodentMesh', unit: 'm2', label: 'Galvanised rodent mesh (hardware cloth) under the floor joists -- NO CODE YET' },
      /* the overhead lump sums (aframe-v135), the ADU's nineteen rows word for word */
      'OVH01001': { code: 'OVH01001', unit: 'ls', label: 'Site survey and soil testing' },
      'OVH01002': { code: 'OVH01002', unit: 'ls', label: 'Project documentation and engineering' },
      'OVH02001': { code: 'OVH02001', unit: 'ls', label: 'Zoning and land use approval' },
      'OVH02002': { code: 'OVH02002', unit: 'ls', label: 'Building and trade permits' },
      'OVH02003': { code: 'OVH02003', unit: 'ls', label: 'Municipal and impact fees' },
      'OVH03001': { code: 'OVH03001', unit: 'ls', label: 'Utility connections and tap fees' },
      'OVH03003': { code: 'OVH03003', unit: 'ls', label: 'Service trenching and locates' },
      'OVH04001': { code: 'OVH04001', unit: 'ls', label: 'Temporary utilities' },
      'OVH04003': { code: 'OVH04003', unit: 'ls', label: 'Site protection and erosion control' },
      'OVH05001': { code: 'OVH05001', unit: 'ls', label: 'Equipment and lift rental' },
      'OVH05002': { code: 'OVH05002', unit: 'ls', label: 'Mobilization and delivery' },
      'OVH05003': { code: 'OVH05003', unit: 'ls', label: 'Fuel and consumables' },
      'OVH06001': { code: 'OVH06001', unit: 'ls', label: 'Construction insurance' },
      'OVH07001': { code: 'OVH07001', unit: 'ls', label: 'Code inspections' },
      'OVH07002': { code: 'OVH07002', unit: 'ls', label: 'Performance and compliance testing' },
      'OVH08004': { code: 'OVH08004', unit: 'ls', label: 'Sales tax on materials' },
      'OVH08005': { code: 'OVH08005', unit: 'ls', label: 'Contingency reserve' },
      'OVH10001': { code: 'OVH10001', unit: 'ls', label: 'Waste removal and disposal' },
      'OVH10002': { code: 'OVH10002', unit: 'ls', label: 'Final cleaning and handover' },
      /* the lightning protection (aframe-v136), the ADU's rows */
      'LPS00001': { code: 'LPS00001', unit: 'pcs', label: 'Lightning air terminal' },
      'LPS00002': { code: 'LPS00002', unit: 'm',   label: 'Lightning conductor cable' },
      'LPS00003': { code: 'LPS00003', unit: 'pcs', label: 'Conductor clip' },
      'LPS00004': { code: 'LPS00004', unit: 'pcs', label: 'Conductor connector' },
      'LPS00005': { code: 'LPS00005', unit: 'pcs', label: 'Ground rod' },
      'LPS00006': { code: 'LPS00006', unit: 'pcs', label: 'Ground rod clamp' },
      'LPS00007': { code: 'LPS00007', unit: 'pcs', label: 'Bonding clamp' },
      'LPS00008': { code: 'LPS00008', unit: 'pcs', label: 'Down conductor guard' },
      /* the subfloor glue (aframe-v134), the catalogue's 10 oz cartridge */
      'FEC00031':         { code: 'FEC00031', unit: 'pcs', label: 'Construction adhesive (subfloor, 10 oz cartridge)' },
      /* the fitout's fixings (aframe-v138, the ADU's rows): four screws for a piece on a wall, a tube of silicone for a wet one */
      'FAS60080':         { code: 'FAS60080', unit: 'pcs', label: 'Wood screw 6x80' },
      'FEC00040':         { code: 'FEC00040', unit: 'pcs', label: 'Sanitary silicone 310 ml' },
      'SMH00504':         { code: 'SMH00504', unit: 'pcs', label: 'Tub box 300x300' },
      /* the wet rooms (aframe-v143, the ADU's rows) */
      'FEC00025':         { code: 'FEC00025', unit: 'kg',  label: 'Waterproofing membrane 2K' },
      'FEC00018':         { code: 'FEC00018', unit: 'kg',  label: 'Flex tile adhesive' },
      'FFC00003':         { code: 'FFC00003', unit: 'm2',  label: 'Ceramic floor tiles' },
      'SBG00001':         { code: 'SBG00001', unit: 'kg',  label: 'Grout' },
      'SBC00001':         { code: 'SBC00001', unit: 'm2',  label: 'Ceramic wall tile' },
      /* the trim and the wet board (aframe-v144, the barndo's / the ADU's rows) */
      'WDD24002':         { code: 'WDD24002', unit: 'm2',  label: 'Moisture-resistant gypsum board' },
      'ODD00022':         { code: 'ODD00022', unit: 'm',   label: 'Interior casing 70x18' },
      'FAS18032':         { code: 'FAS18032', unit: 'pcs', label: 'Stainless finish nail 1.8x32' },
      'FMA00011':         { code: 'FMA00011', unit: 'm',   label: 'Closet shelf with hang rod 300' },
      'KVI45240':         { code: 'KVI45240', unit: 'm',   label: 'LVL beam 45x240' },
      /* the roof windows (aframe-v22, K4), the core's own sizes */
      'OWR55118':         { code: 'OWR55118', unit: 'pcs', label: 'Roof window 550x1180' },
      'OWR78118':         { code: 'OWR78118', unit: 'pcs', label: 'Roof window 780x1180' },
      'OWR78140':         { code: 'OWR78140', unit: 'pcs', label: 'Roof window 780x1400' },
      'OWR11118':         { code: 'OWR11118', unit: 'pcs', label: 'Roof window 1140x1180' }
    };

    /* -------------------------------------------------------------------------
       THE SECTION OF THE A. Everything on this product is read off it: the
       roof plane leaves the plinth at the eave edge and rises at the pitch;
       the inside width at any height is what is left between the rafters'
       undersides. One function, so the floors, the frame and the footing rule
       cannot disagree about the shape.
       ------------------------------------------------------------------------- */
    /* SAFE BEFORE RAF EXISTS (aframe-v17): beforeBuild runs once while the
       file is still being read, before RAF is assigned further down; v16
       asked RAF there through the plate and the whole lib threw (BUILD
       THREW ... reading 'small'). Until RAF is set, the same two sizes. */
    /* EVERY LAYER'S OPEN SHEETS ARE LEFT OUT OF THE SECTION'S FILL (aframe-v52,
       Marek: pri rezu X je videt seda plocha, ktera se natacela). The cut
       fills each body it slices by a stencil count of its faces; a sheet with
       no thickness -- a gypsum panel, a film, a folded flashing, a skin piece
       cut round a window -- never closes the count, so the fill spread over
       the cut plane wherever the eye looked through such a sheet, and moved
       with the eye. After each layer is built its meshes are checked: one
       whose every edge is shared by two faces is a body and is filled; any
       other is flagged isEdge, which the core's stencil skips. */
    var _openMemo = {};
    function _isOpenGeo(geo) {
      if (_openMemo[geo.uuid] != null) return _openMemo[geo.uuid];
      var pos = geo.attributes.position, idx = geo.index, n = idx ? idx.count : pos.count, E = {}, i, k;
      var key = function (j) { return Math.round(pos.getX(j) * 1e4) + ',' + Math.round(pos.getY(j) * 1e4) + ',' + Math.round(pos.getZ(j) * 1e4); };
      for (i = 0; i + 2 < n; i += 3) {
        var a = key(idx ? idx.getX(i) : i), b = key(idx ? idx.getX(i + 1) : i + 1), c = key(idx ? idx.getX(i + 2) : i + 2), es = [[a, b], [b, c], [c, a]];
        if (a === b || b === c || c === a) continue;          /* a sliver of no area closes nothing */
        for (k = 0; k < 3; k++) { var e = es[k][0] + '>' + es[k][1]; E[e] = (E[e] || 0) + 1; }
      }
      /* A BODY IS CLOSED AND WOUND ONE WAY ROUND (aframe-v53, Marek: ted to
         delaji battens na rezu). Every edge must be walked once each way by
         its two faces; a box whose faces are wound some inward, some outward
         closes the edge count but not the stencil's, and the fill spread
         again -- the drawer's battens are built so */
      var open = false, ek;
      for (ek in E) {
        if (!E.hasOwnProperty(ek)) continue;
        var pr = ek.split('>'), back = pr[1] + '>' + pr[0];
        if (E[ek] !== 1 || E[back] !== 1) { open = true; break; }
      }
      _openMemo[geo.uuid] = open;
      return open;
    }
    function _markOpen(ctx) {
      var nO = 0, nB = 0;
      ctx.group.traverse(function (o) {
        if (!o.isMesh || !o.geometry || !o.geometry.attributes || !o.geometry.attributes.position) return;
        var op = false; try { op = _isOpenGeo(o.geometry); } catch (eO) { op = true; }
        if (op) { o.userData.isEdge = true; nO++; } else nB++;
      });
      return { open: nO, body: nB };
    }
    /* THE PLAN IS THE ASSET'S DRAWING, NOTHING OF THE MODEL (aframe-v78,
       Marek: v pudorysu nema byt videt strecha ani okna vsech pater, cisty
       pudorys jako jinde). Copied from the ADU (adu-v... registerLayer wrap):
       while the floorplan is up every layer builds into a group that is never
       put on the stage -- the bill and the log are made exactly as in 3D, the
       geometry is not seen, and the plan shows only the floorplan asset's own
       drawing of the storey picked. */
    var _planSaid = '', _planAt = 0;
    function _inPlan() { try { return !!(__CORE._planWanted && __CORE._planWanted()); } catch (e) { return false; } }
    /* ---------------------------------------------------------------------
       THE PLAN OF EACH STOREY, FOR THE CORE (aframe-v80, Marek: pudorysy maji
       mit sirku skutecneho patra, ne zakladny; jen relevantni okna a dvere
       toho patra, i balkonove v full wall window). Two answers the core's
       plan host can ask (see navod-configurator-ui-pudorys-aframe.md):
         __PROD._planPoly(storey) -> the outline of that storey: the base
             outline narrowed about the ridge line to the floor's own width
             (where the rafters' undersides meet the floor), same corners, same
             order, so the walls keep their ids S0-W0..3
         __PROD._planOps(storey, wallId) -> the openings the plan draws on that
             wall on that storey, in the host's opsOn shape, measured along the
             storey's own (narrower) wall: the units whose sill stands on that
             storey, the gable glazing where it crosses the storey (fixed
             glazing), and the doors in it -- the HS door on the ground floor,
             the balcony door on floor 2
       --------------------------------------------------------------------- */
    function _planW(st) {
      var fl = floors(), F = fl[Math.max(0, Math.min(fl.length - 1, st | 0))];
      return Math.max(1.0, F.floorWidth || _barRect().x1 - _barRect().x0);
    }
    __PROD._planPoly = function (st) {
      if (!_opOn) return null;
      var P = null; try { P = poly(); } catch (e) { P = null; }
      if (!P || P.length < 3) return null;
      var B = _barRect(), cx = (B.x0 + B.x1) / 2, W = B.x1 - B.x0, f = _planW(st) / W, out = [], i;
      for (i = 0; i < P.length; i++) out.push([cx + (P[i][0] - cx) * f, P[i][1]]);
      return _planWithWings(st, out).P;
    };
    /* THE GROUND FLOOR'S PLAN TAKES IN THE SIDE WINGS (aframe-v111, Marek:
       obrys + kridlo). Under a wing the slope is open from the beam down, so
       the ground floor's outline steps out there to the wing's outer wall: the
       eave wall is broken for the wing's length and the ring goes round the
       wing (four corners put into the eave's edge). The partition under the
       beam then stands inside the outline and the wing is a room of its own.
       The ring keeps its first corners, so the gables stay S0-W0 and S0-W2 in
       the house's own numbering; the plan numbers its edges in order, so the
       tags say which house wall each plan edge is (null: a wing wall) and
       _planOps answers through them. */
    /* FLOOR 2'S PLAN TAKES THE SLOTS OUT (aframe-v115): each slot of the
       sunk dormer is a notch in the eave wall's line, in to its door wall;
       the notch's back edge carries the door (tag 'D<side>:<bay>') */
    function _planWithSlots(P, tags, sides) {
      var xs = P.map(function (p) { return p[0]; }), xMin = Math.min.apply(null, xs), xMax = Math.max.apply(null, xs), outP = [], outT = [], i;
      var B = _barRect(), cx = (B.x0 + B.x1) / 2;
      for (i = 0; i < P.length; i++) {
        var a = P[i], b = P[(i + 1) % P.length];
        outP.push(a); outT.push(tags[i]);
        if (Math.abs(a[0] - b[0]) > 1e-6) continue;
        var sd = (Math.abs(a[0] - xMin) < 1e-6) ? -1 : ((Math.abs(a[0] - xMax) < 1e-6) ? 1 : 0);
        if (!sd || sides.indexOf(sd) < 0) continue;
        var D = _dormer(sd); if (!D) continue;
        var xD = cx + sd * D.dD; if (Math.abs(xD - cx) >= Math.abs(a[0] - cx) - 0.05) continue;
        var up = b[1] > a[1], bays = [{ z0: D.bays[0][0], z1: D.bays[D.bays.length - 1][1], j: 0 }].filter(function (bb) { return bb.z0 > Math.min(a[1], b[1]) + 0.05 && bb.z1 < Math.max(a[1], b[1]) - 0.05; });
        bays.sort(function (p1, p2) { return up ? p1.z0 - p2.z0 : p2.z0 - p1.z0; });
        bays.forEach(function (bb) {
          var zs1 = up ? bb.z0 : bb.z1, zs2 = up ? bb.z1 : bb.z0, k = (sd < 0) ? 'L' : 'R';
          outP.push([a[0], zs1]); outT.push('S' + k + ':' + bb.j);
          outP.push([xD, zs1]);   outT.push('D' + k + ':' + bb.j);
          outP.push([xD, zs2]);   outT.push('S' + k + ':' + bb.j);
          outP.push([a[0], zs2]); outT.push(tags[i]);
        });
      }
      return { P: outP, tags: outT };
    }
    function _planWithWings(st, P) {
      var tags = [], i, sides = [];
      for (i = 0; i < P.length; i++) tags.push('S0-W' + i);
      try { if (_wingOk()) sides = _wingSides(); } catch (eW) { sides = []; }
      if (!sides.length || !P || P.length < 3) return { P: P, tags: tags };
      if ((st | 0) === 1) return _planWithSlots(P, tags, sides);
      if ((st | 0) !== 0) return { P: P, tags: tags };
      var xs = P.map(function (p) { return p[0]; }), xMin = Math.min.apply(null, xs), xMax = Math.max.apply(null, xs), outP = [], outT = [];
      for (i = 0; i < P.length; i++) {
        var a = P[i], b = P[(i + 1) % P.length];
        outP.push(a); outT.push(tags[i]);
        if (Math.abs(a[0] - b[0]) > 1e-6) continue;
        var sd = (Math.abs(a[0] - xMin) < 1e-6) ? -1 : ((Math.abs(a[0] - xMax) < 1e-6) ? 1 : 0);
        if (!sd || sides.indexOf(sd) < 0) continue;
        var WR = _wingRect(sd), xo = (sd < 0) ? WR.x0 : WR.x1, zA = Math.max(Math.min(a[1], b[1]) + 0.05, WR.z0), zB = Math.min(Math.max(a[1], b[1]) - 0.05, WR.z1);
        if (zB - zA < 0.5) continue;
        var up = b[1] > a[1], z1st = up ? zA : zB, z2nd = up ? zB : zA;
        var kW = (sd < 0) ? 'L' : 'R', e1 = (Math.abs(z1st - WR.z0) < Math.abs(z1st - WR.z1)) ? 'z0' : 'z1', e2 = (e1 === 'z0') ? 'z1' : 'z0';
        outP.push([a[0], z1st]); outT.push('W' + kW + ':' + e1);
        outP.push([xo, z1st]);   outT.push('W' + kW + ':outer');
        outP.push([xo, z2nd]);   outT.push('W' + kW + ':' + e2);
        outP.push([a[0], z2nd]); outT.push(tags[i]);
      }
      return { P: outP, tags: outT };
    }
    function _glzDoorsFor(RU, v, fl) {
      var out = [], q;
      if (!RU || RU.half || v === 'plain') return out;
      for (q = 0; q < GLZ_DOORS.ground.length; q++) { var C = _glzDoorFit(GLZ_DOORS.ground[q], RU.yB, 0); if (C && RU.wAt(RU.yB + C.h + GLAZE.mull) >= C.w / 2 + GLAZE.mull + 0.05) { out.push({ st: 0, d: C }); break; } }
      if (v === 'balcony' && fl.length > 1) { var U = _glzDoorFit(GLZ_DOORS.upper, fl[1].y, 1); if (U && RU.wAt(fl[1].y + U.h + GLAZE.mull) >= U.w / 2 + GLAZE.mull + 0.05) out.push({ st: 1, d: U }); }
      return out;
    }
    function _planOpsHouse(st, wallId) {
      if (!_opOn) return null;
      st = st | 0;
      var fl = floors(), F = fl[st]; if (!F) return [];
      /* the ground floor takes everything under floor 2 (aframe-v139): on point
         footings the floor is 100 over the gable's sole line, and a door with
         its sill on the sole fell out of the plan (and out of the electrics) */
      var yLo = (st === 0) ? -1e9 : F.y - 0.05, yHi = (st + 1 < fl.length) ? (fl[st + 1].y - FLOOR.deck.t - FLOOR.joist.d) : 1e9;
      var GS = _gableSegs(), B = _barRect(), cx = (B.x0 + B.x1) / 2, f = _planW(st) / (B.x1 - B.x0), out = [], q;
      for (q = 0; q < GS.length; q++) {
        var sg = GS[q];
        if (wallId != null && sg.id !== wallId) continue;
        var ux = _segUx(sg), x0p = cx + (sg.x0 - cx) * f;
        var uP = function (x) { return (x - x0p) * ux; };
        var ops = sg.openings || [], rk = null, k;
        for (k = 0; k < ops.length; k++) {
          var o = ops[k];
          if (o.rake || o.fullW || o.halfW) { rk = rk || o; continue; }
          var yb = sg.y0 + (o.sill || 0);
          if (yb < yLo || yb >= yHi) continue;
          var xc = sg.x0 + ux * o.at;
          out.push({ seg: sg.id, at: uP(xc), c: uP(xc), off: uP(xc), w: o.w, width: o.w, h: o.h, sill: o.sill, kind: o.kind, code: o.code, hand: o.hand, leaves: o.leaves, fullW: null, halfW: null, fix: false });
        }
        if (rk) {
          var RU = _rakeUnit(sg, rk), v = RU.v, doors = _glzDoorsFor(RU, v, fl).filter(function (D) { return D.st === st; });
          var yA = Math.max(F.y + 0.10, RU.yB + 0.05), yB2 = Math.min(F.y + 1.20, yHi - 0.05);
          var runs = (yB2 > yA) ? RU.xRuns(yA, yB2) : [], r;
          for (r = 0; r < runs.length; r++) {
            var a = Math.max(runs[r][0], cx - _planW(st) / 2 + 0.02), b = Math.min(runs[r][1], cx + _planW(st) / 2 - 0.02);
            var cuts = [[a, b]], dq;
            /* the glass left and right of a door in it, the door itself on its own */
            for (dq = 0; dq < doors.length; dq++) {
              var dA = cx - doors[dq].d.w / 2 - GLAZE.mull, dB = cx + doors[dq].d.w / 2 + GLAZE.mull, nx = [], cq;
              for (cq = 0; cq < cuts.length; cq++) { if (dB <= cuts[cq][0] || dA >= cuts[cq][1]) { nx.push(cuts[cq]); continue; } if (dA > cuts[cq][0]) nx.push([cuts[cq][0], dA]); if (dB < cuts[cq][1]) nx.push([dB, cuts[cq][1]]); }
              cuts = nx;
            }
            for (dq = 0; dq < cuts.length; dq++) {
              var wG = cuts[dq][1] - cuts[dq][0]; if (wG < 0.20) continue;
              var xg = (cuts[dq][0] + cuts[dq][1]) / 2;
              out.push({ seg: sg.id, at: uP(xg), c: uP(xg), off: uP(xg), w: wG, width: wG, h: 1.0, sill: F.y - sg.y0, kind: 'window', code: RU.code, leaves: 1, fullW: null, halfW: null, fix: true });
            }
          }
          for (var dd = 0; dd < doors.length; dd++) {
            var D = doors[dd].d, slide = (D.leaves > 1);
            out.push({ seg: sg.id, at: uP(cx), c: uP(cx), off: uP(cx), w: D.w, width: D.w, h: D.h, sill: F.y - sg.y0, kind: slide ? 'french' : 'door', code: D.code, hand: 'L', leaves: D.leaves, fullW: null, halfW: null, fix: false });
          }
        }
      }
      return out;
    }
    __PROD._planOps = function (st, wallId) {
      if (!_opOn) return null;
      var P0 = null; try { P0 = __PROD._planPoly(st); } catch (eP) { P0 = null; }
      var W = null; try { var B0 = poly(), B = _barRect(), cx = (B.x0 + B.x1) / 2, f = _planW(st) / (B.x1 - B.x0); W = _planWithWings(st, B0.map(function (p) { return [cx + (p[0] - cx) * f, p[1]]; })); } catch (eW) { W = null; }
      if (!W || W.tags.every(function (t, i) { return t === 'S0-W' + i; })) return _planOpsHouse(st, wallId);
      /* the wings' corners are in the ring: the plan's edge ids are mapped to the house's walls and back */
      var planOf = {}, i, out = [];
      for (i = 0; i < W.tags.length; i++) if (W.tags[i] && planOf[W.tags[i]] == null) planOf[W.tags[i]] = 'S0-W' + i;
      /* a wing wall's openings, measured along the plan's edge (aframe-v112) */
      var slotDoor = function (ix3) {
        var m3 = /^D([LR]):(\d)$/.exec(W.tags[ix3] || ''); if (!m3) return [];
        var D3 = _dormer(m3[1] === 'L' ? -1 : 1); if (!D3) return [];
        var a3 = W.P[ix3], c3 = W.P[(ix3 + 1) % W.P.length], len3 = Math.hypot(c3[0] - a3[0], c3[1] - a3[1]) || 1, uz3 = (c3[1] - a3[1]) / len3;
        return D3.bays.map(function (b3) {
          var bw3 = b3[1] - b3[0], w3 = Math.min(DORM.doorW, bw3 - 0.12), at3 = ((b3[0] + b3[1]) / 2 - a3[1]) * uz3;
          return { seg: 'S0-W' + ix3, at: at3, c: at3, off: at3, w: w3, width: w3, h: DORM.doorH, sill: 0, kind: 'door', code: GLZ_DOORS.upper.code, hand: 'L', leaves: 1, fullW: null, halfW: null, fix: false };
        });
      };
      var wingOps = function (ix2) {
        var tg = W.tags[ix2], m = /^W([LR]):(outer|z0|z1)$/.exec(tg || ''); if (!m) return [];
        var sd = (m[1] === 'L') ? -1 : 1, WR = _wingRect(sd), xo = (sd < 0) ? WR.x0 : WR.x1, a = W.P[ix2], b = W.P[(ix2 + 1) % W.P.length];
        var len = Math.hypot(b[0] - a[0], b[1] - a[1]) || 1, ux = (b[0] - a[0]) / len, uz = (b[1] - a[1]) / len;
        var SGp = _wingSegs(sd), gP = null, qP; for (qP = 0; qP < SGp.length; qP++) if (SGp[qP].wall === m[2]) gP = SGp[qP];
        if (!gP) return [];
        return (STATE.openings || []).filter(function (o) { return o && o.seg === gP.id; }).map(function (o) {
          var tP = (+o.at || 0) / gP.len, px = gP.x0 + (gP.x1 - gP.x0) * tP, pz = gP.z0 + (gP.z1 - gP.z0) * tP, at = (px - a[0]) * ux + (pz - a[1]) * uz;
          return { seg: 'S0-W' + ix2, at: at, c: at, off: at, w: o.w, width: o.w, h: o.h, sill: o.sill, kind: o.kind, code: o.code, hand: o.hand || 'L', leaves: o.leaves || 1, fullW: null, halfW: null, fix: false };
        });
      };
      if (wallId != null) {
        var ix = parseInt(String(wallId).replace('S0-W', ''), 10), hid = (ix >= 0 && ix < W.tags.length) ? W.tags[ix] : null;
        if (!hid) return [];
        if (hid.charAt(0) === 'W') return wingOps(ix);
        if (hid.charAt(0) === 'D') return slotDoor(ix);
        if (hid.charAt(0) === 'S' && hid.indexOf('S0-W') !== 0) return [];
        out = _planOpsHouse(st, hid) || [];
        out.forEach(function (o) { o.seg = wallId; });
        return out;
      }
      out = _planOpsHouse(st, null) || [];
      out.forEach(function (o) { if (planOf[o.seg]) o.seg = planOf[o.seg]; });
      for (i = 0; i < W.tags.length; i++) if (W.tags[i] && W.tags[i].charAt(0) === 'W') out = out.concat(wingOps(i));
      for (i = 0; i < W.tags.length; i++) if (W.tags[i] && W.tags[i].charAt(0) === 'D') out = out.concat(slotDoor(i));
      return out;
    };
    function _planDiag() {
      try {
        var st = STATE.planStorey | 0, P = __PROD._planPoly(st), O = __PROD._planOps(st) || [];
        return 'plan     storey ' + (st + 1) + ' outline ' + (P ? (Math.round((P[1][0] - P[0][0]) * 1000) + ' wide (the floor at ' + Math.round(floors()[st].y * 1000) + ')') : '-') + ', ' + O.length + ' opening(s) for it: ' + O.map(function (o) { return (o.code || o.kind) + (o.fix ? ' glazing' : '') + ' ' + Math.round(o.w * 1000) + ' on ' + o.seg; }).join(', ') + ' (the core plan hooks)' + ((P && P.length > 4) ? (' | wing outline: ' + P.length + ' corners, ' + P.map(function (q) { return Math.round(q[0] * 1000) + '/' + Math.round(q[1] * 1000); }).join(' ')) : '') + (_stairArrowNote ? (' | ' + _stairArrowNote) : '');
      } catch (e) { return 'plan     diag threw: ' + ((e && e.message) || e); }
    }
    /* THE LAYERS ARE CHECKED ONE BY ONE, FROM THE INSIDE OUT (aframe-v128, Marek:
       jednotlive vrstvy budeme vizualne kontrolovat, zacit od vnitrnich -- sdk,
       battens, izolace -- po odsouhlaseni se jde na dalsi). Every build-up has its
       own step, as WALL_STEP and ROOF_STEP in the ADU: its layers are numbered from
       the inside out, a layer past the step is not drawn (it is still billed), and
       the layer AT the step is the one under review. 99 = the build-up is done and
       drawn whole. The build-ups:
         gfloor    the ground floor (slab, or the timber floor on point footings)
         ufloor    the upper floors and the ceilings under them
         slope     the A's two roof slopes (between or above the rafters)
         gable     the two gables
         wingwall  the side wings' walls
         wingroof  the side wings' ceiling and walked roof
         part      the partitions
       AF_FOCUS names one build-up to look at alone: the others' layers are not
       drawn while it is set ('' = everything as usual). */
    /* LAYERS ABOVE HIDDEN, THE REST AS BUILT (aframe-v129, Marek: az budeme resit
       jednotlive vrstvy, musis vrstvy nad ni skryt, at jsou videt reference
       okolo). A build-up's layers are numbered in the order they are BUILT, from
       the bearing side to the face that is seen; the step shows layers 1..n of
       that build-up only, so the layer under review lies open on top and every
       other build-up stands whole round it. AF_FOCUS stays '' (off). */
    var AF_STEP = { gfloor: 99, ufloor: 99, slope: 99, gable: 99, wingwall: 99, wingroof: 99, dormer: 99, part: 99 };
    var AF_FOCUS = '';
    /* the ground floor's layers, bottom up, by footing */
    /* the slab's perimeter (aframe-v131): XPS 50 outside the slab edge and the stem, the plinth finish over it above grade */
    var PERIM = { t: 0.050, fin: 0.008, edge: { code: 'TBD.edgeStrip', t: 0.008, h: 0.050 } };
    /* the side wing's perimeter (aframe-v149): magenta for an admin until Marek has checked it */
    var WPERIM_REVIEW = true;
    function _gfLayers() {
      if (STATE.foundation === 'strips') return ['gravel bed 150 grd.gravelSlab', 'EPS 150 INS01502', 'vapour barrier ROV00001 + tape INS01005', 'concrete slab 150 with its mesh', 'perimeter XPS 50 INS00503 + foam FCP00005', 'plinth finish FFR00051 + GTM00001 + PEN00001 + FCP00002 + bead FCP00006', 'edge strip 8 TBD.edgeStrip', 'levelling bed 3 FFC00007 + primer FEC00020', 'impact underlay INS01004', 'vinyl plank FFC00005', 'skirting FFW00002 + FAS50060'];
      return ['footings and floor frame KVH60240', 'rodent mesh TBD.rodentMesh + furring KVR50030', 'breather membrane INS00002', 'wool between the joists', 'vapour barrier ROV00001 + tape INS01005', 'OSB 18 deck + glue FEC00031', 'impact underlay INS01004', 'vinyl plank FFC00005', 'skirting FFW00002 + FAS50060'];
    }
    function _gfIdx(name) {
      var L = _gfLayers(), i;
      for (i = 0; i < L.length; i++) if (L[i].indexOf(name) === 0) return i + 1;
      return 99;
    }
    function _gfOn(name) { return _stepOn('gfloor', _gfIdx(name)); }
    function _gfNote() {
      var L = _gfLayers(), n = AF_STEP.gfloor, o = [], i;
      if (n >= 99) return 'gfloor   ' + STATE.foundation + ': all ' + L.length + ' layers drawn (done)';
      if (!_isAdmin()) return 'gfloor   ' + STATE.foundation + ', step ' + n + ' of ' + L.length + ' set, but this visitor is not an admin: all ' + L.length + ' layers drawn';
      for (i = 0; i < L.length; i++) o.push((i + 1) + ' ' + L[i] + (i + 1 === n ? ' <- UNDER REVIEW' : (i + 1 > n ? ' (hidden, billed)' : '')));
      return 'gfloor   ' + STATE.foundation + ', review step ' + n + ' of ' + L.length + ', the layers above hidden, all else as built: ' + o.join(' | ');
    }
    /* THE UPPER FLOORS AND THE CEILINGS UNDER THEM, ONE BUILD-UP (aframe-v134,
       plan D). Numbered as they go up on site: the joists, the deck glued and
       screwed to them straight away (it is the platform the rest is built
       from), then from below the wool, the ceiling battens and the gypsum, and
       last on top the underlay, the vinyl and the skirting. The joists and the
       deck are drawn and billed by the frame layer, the rest by the floors
       layer, which now holds the ceilings too (they left the lining). The
       ground floor's underlay, vinyl and skirting stay in gfloor. */
    var UF = { joists: 1, osb: 2, wool: 3, batt: 4, board: 5, under: 6, vinyl: 7, skirt: 8 };
    /* subfloor glue, US practice (APA glued floor system): a 6 mm (1/4 in) bead
       on every joist, ledger and header the deck bears on, a second bead where
       two sheets meet; a 10 oz cartridge lays about 9 m of it */
    var SUBGLUE = { code: 'FEC00031', mPerTube: 9.0, edges: 1.10 };
    function _ufLayers() {
      return ['joists, ledgers, headers ' + FLOOR.joist.code, 'OSB 18 deck OSB25002, glued FEC00031 + screwed FAS50060', 'wool 120 between the joists INS01201',
              'ceiling battens KVR50030 + FAS60100', 'gypsum ceiling WDD24001 + screws, tape, filler', 'impact underlay INS01004', 'vinyl plank FFC00005', 'skirting FFW00002 + FAS50060'];
    }
    function _ufOn(n) { return _stepOn('ufloor', n); }
    function _ufRv(n) { return _isRv('ufloor', n); }
    function _ufNote() {
      var L = _ufLayers(), n = AF_STEP.ufloor, nF = floors().length, o = [], i;
      if (nF < 2) return 'ufloor   no upper floor at this size and pitch (' + nF + ' storey): nothing to build or review';
      if (n >= 99) return 'ufloor   ' + (nF - 1) + ' upper floor(s): all ' + L.length + ' layers drawn (done)';
      if (!_isAdmin()) return 'ufloor   step ' + n + ' of ' + L.length + ' set, but this visitor is not an admin: all ' + L.length + ' layers drawn';
      for (i = 0; i < L.length; i++) o.push((i + 1) + ' ' + L[i] + (i + 1 === n ? ' <- UNDER REVIEW' : (i + 1 > n ? ' (hidden, billed)' : '')));
      return 'ufloor   ' + (nF - 1) + ' upper floor(s), review step ' + n + ' of ' + L.length + ': ' + o.join(' | ');
    }
    /* THE REVIEW IS AN ADMIN'S VIEW (aframe-v130, Marek: pro usera s tagem admin
       skryj vsechno krome nosne konstrukce a relevantni vrstvy, kterou resime, v
       magenta; pro bezneho uzivatele nechat byt videt vsechno). A visitor who is
       not an admin gets every layer drawn whatever the steps say. */
    function _isAdmin() {
      try { var LP = global.LEVA_PRODUCT || {}; return LP.isAdmin === true || LP.isAdmin === 'true'; } catch (eA) { return false; }
    }
    /* the build-up under review: the first one not done, for an admin only */
    function _rvAsm() {
      if (!_isAdmin()) return '';
      for (var k in AF_STEP) if (AF_STEP.hasOwnProperty(k) && AF_STEP[k] < 99) return k;
      return '';
    }
    /* is layer n of this build-up the one under review (drawn magenta, kept on the stage) */
    function _isRv(asm, n) { return _isAdmin() && AF_STEP[asm] === n; }
    function _rvTag(m) { if (m && m.userData) m.userData.afReview = true; return m; }
    function _rvTag2(m, on) { return on ? _rvTag(m) : m; }
    /* what the review keeps of each lib layer besides the layer under review:
       'struct' the bearing members, told by their timber or concrete colour;
       'base' everything but the bodies tagged as a non-bearing layer (afNs);
       absent = nothing */
    var RV_KEEP = { 'aframe-base': 'base', 'aframe-wingbase': 'base', 'aframe-frame': 'struct', 'aframe-gables': 'struct', 'aframe-wing': 'struct', 'aframe-partitions': 'struct' };
    var RV_COLS = [0xC9A87A, 0xB08E5E, 0xA9A77A, 0x9A9A96, 0x9E9B93, 0xB9A88C];
    var _rvStat = { off: 0, kept: 0, rv: 0, lay: [] };
    function _rvStrip(ctx, id, before) {
      var T = ctx.THREE, mode = RV_KEEP[id] || '', cols = RV_COLS.map(function (h) { return new T.Color(h).getHex(); }), nOff = 0, nKeep = 0, nRv = 0;
      var keep = function (o) {
        if (o.userData && o.userData.afReview) { nRv++; return true; }
        if (!o.isMesh) return false;
        if (mode === 'base') return !(o.userData && o.userData.afNs);
        if (mode !== 'struct') return false;
        var mt = Array.isArray(o.material) ? o.material[0] : o.material, c = mt && mt.color;
        return !!(c && !mt.map && cols.indexOf(c.getHex()) >= 0);
      };
      /* WHAT IS TAKEN OFF IS HIDDEN, NOT THROWN AWAY (aframe-v134). The core's
         coating layer (core-v643) measures the wood to paint off the bodies in
         the model, so a body removed for the review took its paint off the bill
         (MFP00007 / 00001 / 00002 fell by a fifth). Every body taken off goes
         into one group per layer that is never drawn -- three.js skips a hidden
         group's children whatever their own flag says, the merge pass and the
         section skip it too -- and its layers are switched off so a tap cannot
         hit it. The bill reads the same in the review as outside it. */
      var hold = null;
      var put = function (o) {
        if (!hold) { hold = new T.Group(); hold.visible = false; hold.userData.afRvHold = true; T.Group.prototype.add.call(ctx.group, hold); }
        hold.add(o);
        o.traverse(function (m) { if (m.layers) m.layers.disableAll(); });
      };
      var walk = function (grp, top) {
        grp.children.slice().forEach(function (o) {
          if (top && before && before.indexOf(o) >= 0) return;   /* only what this layer added */
          if (o.userData && (o.userData.afPlanFrame || o.userData.afRvHold)) return;
          if (keep(o)) { nKeep++; return; }
          if (!o.isMesh && !o.isLine && !o.isLineSegments && !o.isPoints && o.children && o.children.length) { walk(o); if (!o.children.length) grp.remove(o); return; }
          put(o); nOff++;
        });
      };
      walk(ctx.group, true);
      _rvStat.off += nOff; _rvStat.kept += nKeep; _rvStat.rv += nRv;
      if (nRv) _rvStat.lay.push(id.replace('aframe-', '') + ' ' + nRv);
    }
    function _rvNote() {
      var a = _rvAsm();
      if (!a) return 'review   ' + (_isAdmin() ? 'admin, no build-up under review: everything drawn' : 'not an admin (LEVA_PRODUCT.isAdmin not set): everything drawn, the steps ignored');
      if (!_asmAvail(a)) return 'review   admin, ' + a + ' step ' + AF_STEP[a] + ' kept from before, but ' + (a === 'slope' ? 'the insulation is between the rafters (Structure)' : (a === 'wingwall' || a === 'wingroof' || a === 'dormer') ? 'this A has no side wing' : a === 'part' ? 'there is no partition (draw one on the Floorplan)' : 'this A has no upper floor') + ': nothing to review (tap the up-down button for the next build-up)';
      return 'review   admin, ' + a + ' step ' + AF_STEP[a] + ': only the bearing structure and the layer under review (magenta) drawn -- ' + _rvStat.kept + ' structural bod(ies) kept, ' + _rvStat.off + ' hidden (still in the model for the bill and the coating), the layer under review ' + _rvStat.rv + ' bod(ies) in ' + (_rvStat.lay.length ? _rvStat.lay.join(', ') : 'NO LAYER -- nothing tagged, report it');
    }
    /* THE REVIEW ARROWS IN THE CANVAS (aframe-v133, Marek: po vzoru barndominium
       nahore v canvas sipky, kde bych si proklikal jednotlive kroky / vrstvy). For
       an admin only, a bar at the top centre of the 3D view: the build-up button
       cycles off -> each build-up that has its layers numbered -> off; the arrows
       step its layers 1..N (layer n in magenta, 1..n-1 built under it, the rest
       hidden, only the bearing structure round it); the label names the layer.
       The choice is kept in this browser (localStorage af-review), not in the
       project. Debug text, English on purpose. */
    /* THE SLOPES WITH THE INSULATION ABOVE THE RAFTERS (aframe-v146, plan E):
       the skin's phases as the shared drawer lays them, inside out -- the T&G
       seen from the room, the deck, the vapour layer with the PIR and its
       screws, the underlay, the counter-battens and battens, the edges, the
       covering, the ridge. Offered on the arrows while the Structure switch
       says above; the layer under review magenta, those under it in their
       colours, those over it hidden (billed all the same) */
    /* aframe-v147 (plan F): with the insulation BETWEEN the rafters (the
       default) the slopes' own layers come first, as built from the rafters
       to the room -- the vent baffles, the wool, the barrier, the service
       battens, the gypsum (the lining layer) -- then the skin over the
       rafters (deck, underlay, battens -- none under shingles --, edges,
       covering, ridge); while an inner layer is under review the skin is
       hidden and the bays are seen from outside */
    function _slopeDefs() {
      var C = null; try { C = API.covDef(); } catch (eC) { C = null; }
      var shg = !!(C && C.key === 'shingle'), cov = 'covering ' + ((C && C.code) || '') + ' + roof window flashing', rdg = 'ridge ' + (shg ? 'ROR00007' : 'ROR00009'), L = [];
      var PA = _pirAbove();
      if (INSUL === 'above') {
        L.push(['lining', 'T&G ' + FAC.clad.code + ' between the rafters + oil TBD.woodOil'], ['deck', 'deck OSB25002 + FAS70000'],
               ['insul', 'vapour layer ROV00001, PIR ' + _pirTxt(PA) + ', screws ' + PA.screw + ', PU foam FCP00005'], ['underlay', 'underlay ROR00008'],
               ['battens', 'counter-battens KVR50030 + battens KVR50031 + FAS60100, insect comb ROV00100' + (shg ? ' (shingles: the nail base billed, not drawn)' : '')]);
      } else if (PA) {
        /* the hybrid (aframe-v157): the wool fills the rafters, no vent channel under the deck; the PIR on the deck */
        L.push(['wool', 'mineral wool between the rafters, full depth ' + _woolTxt(PA.wool)],
               ['vb', 'vapour barrier ROV00001 + tape INS01005'], ['sbatt', 'service battens KVR50030 + FAS60100'], ['board', 'gypsum WDD24001 + screws, tape, filler'],
               ['deck', 'deck OSB25002 + FAS70000'], ['insul', 'PIR on the deck ' + _pirTxt(PA) + ', joints taped INS01005, screws ' + PA.screw + ', PU foam FCP00005'],
               ['underlay', 'underlay ROR00008'],
               ['battens', 'counter-battens KVR50030 + battens KVR50031 + FAS60100, insect comb ROV00100' + (shg ? ' (shingles: the nail base billed, not drawn)' : '')]);
      } else {
        L.push(['baffle', 'vent baffles ' + VENT.baffle + ' + eave strip ' + VENT.strip], ['wool', 'mineral wool between the rafters'],
               ['vb', 'vapour barrier ROV00001 + tape INS01005'], ['sbatt', 'service battens KVR50030 + FAS60100'], ['board', 'gypsum WDD24001 + screws, tape, filler'],
               ['deck', 'deck OSB25002 + FAS70000'], ['underlay', 'underlay ROR00008']);
        if (!shg) L.push(['battens', 'counter-battens KVR50030 + battens KVR50031 + FAS60100']);
      }
      L.push(['edges', 'edges: drip ROM02401, verge ROR00006' + (PA ? (', verge board ' + _vergeRows(PA).map(function (r) { return r[0]; }).join(' + ') + ' + FAS60080') : '')], ['cover', cov], ['ridge', rdg]);
      return L;
    }
    function _slopeLayers() { return _slopeDefs().map(function (d) { return d[1]; }); }
    /* THE GABLES' BUILD-UP (aframe-v148, plan G), in the order of the A's
       assembly walk -- the shell closed from outside first, then lined from
       the room: the OSB on the studs, the membrane, the units and the
       glazing, the rainscreen battens with the rodent mesh at their foot, the
       cladding, the soffit under the rake overhang; then the wool between the
       studs, the vapour barrier, the service battens, the gypsum and the
       casings. The studs, plates, headers and blocking are the bearing frame,
       always drawn. Bodies of three lib layers take part (gables, facade,
       lining) and the frame's soffit; each tags its own by the walk item */
    function _gableDefs() {
      var WGd = woolFill(GABLE.d);
      return [['osb', 'OSB sheathing OSB25002 + ' + SHEATH.nail], ['memb', 'membrane ' + SHEATH.memb + ' + tape ' + SHEATH.tape],
              ['units', 'windows, doors, glazing (foam ' + DOOR.foam + ', tape ' + DOOR.tape + ', sills)']].concat(
              (_ciT() > 0) ? [['ci', 'EPS ' + Math.round(_ciT() * 1000) + ' ' + CI.code + ' on the membrane, plate anchors ' + CI.plate + ' + ' + CI.screw + ', foam ' + CI.foam]] : []).concat([
              ['batt', 'rainscreen battens ' + FAC.batt.code + ' + ' + ((_ciT() > 0) ? CI.battScrew : FAC.batt.screw) + ', rodent mesh ' + FAC.mesh], ['clad', 'cladding ' + FAC.clad.code + ' + ' + FAC.clad.nail],
              ['soffit', 'soffit under the rake overhang ' + FAC.clad.code], ['wool', 'wool between the studs ' + _woolTxt(WGd)],
              ['vb', 'vapour barrier ROV00001 + tape INS01005'], ['sbatt', 'service battens KVR50030 + FAS60100'],
              ['board', 'gypsum WDD24001 + screws, tape, filler'], ['case', 'casings ' + CASE.code + ' + ' + CASE.nail + ' round the units']]);
    }
    function _gableLayers() { return _gableDefs().map(function (d) { return d[1]; }); }
    /* THE SIDE WING'S WALLS (aframe-v149, plan H): the gables' build-up in the
       same order, less the soffit -- the walls carry the walked roof, no
       overhang. The membrane, the rainscreen battens with the mesh, the wool,
       the barrier and the service battens were billed and not drawn: drawn now */
    function _wingWallDefs() {
      var WGw = woolFill(GABLE.d);
      return [['osb', 'OSB sheathing OSB25002 + ' + SHEATH.nail], ['memb', 'membrane ' + SHEATH.memb + ' + tape ' + SHEATH.tape],
              ['units', 'windows, doors (foam ' + DOOR.foam + ', tape ' + DOOR.tape + ', sills)']].concat(
              (_ciT() > 0) ? [['ci', 'EPS ' + Math.round(_ciT() * 1000) + ' ' + CI.code + ' on the membrane, plate anchors ' + CI.plate + ' + ' + CI.screw + ', foam ' + CI.foam]] : []).concat([
              ['batt', 'rainscreen battens ' + FAC.batt.code + ' + ' + ((_ciT() > 0) ? CI.battScrew : FAC.batt.screw) + ', rodent mesh ' + FAC.mesh], ['clad', 'cladding ' + FAC.clad.code + ' + ' + FAC.clad.nail],
              ['wool', 'wool between the studs ' + _woolTxt(WGw)], ['vb', 'vapour barrier ROV00001 + tape INS01005'], ['sbatt', 'service battens KVR50030 + FAS60100'],
              ['board', 'gypsum WDD24001 + screws, tape, filler'], ['case', 'casings ' + CASE.code + ' + ' + CASE.nail + ' round the units']]);
    }
    function _wingWallLayers() { return _wingWallDefs().map(function (d) { return d[1]; }); }
    /* THE SIDE WING'S WALKED ROOF (aframe-v150, plan H part 2), as it goes
       up: on the joists and the beam (the structure, always drawn) the
       firring for the fall, the OSB, the membrane, the edges, the gutter,
       then the deck over the membrane (geotextile, sleepers, boards) and the
       railing; from below the ceiling: wool, barrier, battens, gypsum. The
       firring, the geotextile, the drip edges, the wool, the barrier and the
       battens were billed and not drawn: drawn now */
    function _wingRoofDefs() {
      var WFr = woolFill(0.20);
      return [['firr', 'firring ROT00004 (the 2 % fall), hangers ROT00007 + FAT00011 + FAS38038'], ['osb', 'OSB deck OSB25002 + FAS70000'],
              ['memb', 'membrane ROR00002 (up 300 at the A), termination bar ROA00001 + FAS45070, tape ROR00012, sealant FEC00038'],
              ['edge', 'drip edge ROM02401 + FAS00318 round the free edges'], ['gut', 'gutter ROG01251 + brackets ROA01251, downspout ROG01252'],
              ['geo', 'geotextile FEC00003'], ['sleep', 'sleepers KVP60160, loose'], ['deck', 'decking TST00002 + FAS55050'], ['rail', 'railing SIS00001'],
              ['wool', 'wool between the joists ' + _woolTxt(WFr) + ' (40 vented over it)'], ['vb', 'vapour barrier ROV00001 + tape INS01005'],
              ['batt', 'ceiling battens KVR50030 + FAS60100'], ['board', 'gypsum ceiling WDD24001 + screws, tape, filler']];
    }
    function _wingRoofLayers() { return _wingRoofDefs().map(function (d) { return d[1]; }); }
    /* THE SUNK DORMER (aframe-v151, plan H part 3): the door wall at the back
       of each slot and the triangles at the slots' sides (and the pier under
       the axis rafter between two slots), outside first as the gables, the
       metal of the cut, then from the room. The header and the frames are
       the structure. The door wall was one block in the boards' colour, the
       triangles had no membrane, battens or barrier: drawn now in layers */
    function _dormerDefs() {
      return [['osb', 'OSB OSB25002 + ' + SHEATH.nail + ' (door wall, side triangles)'], ['memb', 'membrane ' + SHEATH.memb + ' + tape ' + SHEATH.tape],
              ['door', 'glazed door ' + GLZ_DOORS.upper.code + ' + threshold ' + DOOR.thresh + ', foam, tape, anchors'],
              ['batt', 'rainscreen battens ' + FAC.batt.code + ' + ' + FAC.batt.screw + ((_dormCi() > 0) ? (', the door wall EPS ' + Math.round(_dormCi() * 1000) + ' ' + CI.code + ' under them, screws ' + ((_dormCi() > 0.045) ? 'FAS80200' : CI.battScrew)) : '')], ['clad', 'cladding ' + FAC.clad.code + ' + ' + FAC.clad.nail],
              ['metal', 'drip edge ROM02401, apron + caps ' + DORM.cap + ' + FAS00225, verge ROR00006, tape ROR00012'],
              ['wool', 'wool: the door wall\'s 100 frame ' + _woolTxt(woolFill(DORM.wallT)) + ', the triangles\' 160 frame ' + _woolTxt(woolFill(DORM.triT))], ['vb', 'vapour barrier ROV00001 + tape INS01005'],
              ['board', 'gypsum WDD24001 + screws, tape, filler'], ['case', 'casing ' + CASE.code + ' + ' + CASE.nail + ' round the doors']];
    }
    function _dormerLayers() { return _dormerDefs().map(function (d) { return d[1]; }); }
    /* THE PARTITIONS (aframe-v152, plan I), as a carpenter closes one: the
       frame (the structure, always drawn), the gypsum on one face, the wool
       in the bays from the open side, the gypsum on the other face with the
       joints taped and filled, the door units, the casings both faces, the
       closets' shelves and rods */
    function _partDefs() {
      return [['board1', 'gypsum, one face ' + LINE.board.code + ' + screws ' + LINE.board.screw], ['wool', 'acoustic wool ' + PWOOL.code + ' in the bays'],
              ['board2', 'gypsum, the other face + tape ' + LINE.board.tape + ', filler ' + LINE.board.filler],
              ['door', 'door units ODI... (lining, leaf) + handle set ODD00001 + hinges ODD00005'], ['case', 'casings ' + CASE.code + ' + ' + CASE.nail + ', both faces'],
              ['closet', 'closet shelf + rod ' + CLO.code + ' + ' + CLO.screw]];
    }
    function _partLayers() { return _partDefs().map(function (d) { return d[1]; }); }
    function _asmKey(o) { var it = o && o.userData && o.userData.asm; return it ? String((typeof it === 'object') ? (it.key || '') : it) : ''; }
    /* a build-up's bodies under review: the phase at the step MAGENTA, those under it kept in their colours, those over it left to the strip (hidden, billed) */
    function _rvTagList(T, kids, phOf, L, st) {
      var n = { rv: 0, un: 0, ab: 0 };
      kids.forEach(function (o) {
        if (!o || !o.userData || o.userData.afRvHold) return;
        var ph = phOf(o), ix = ph ? _slopeIdx(ph, L) : 0;
        if (!ix) return;
        if (ix > st) { n.ab++; return; }
        o.userData.afReview = true;
        if (ix === st) { n.rv++; o.traverse(function (m) { if (m.isMesh && m.material) { var mm = (Array.isArray(m.material) ? m.material[0] : m.material).clone(); mm.map = null; mm.color = new T.Color(MAGENTA); m.material = mm; } }); }
        else n.un++;
      });
      return n;
    }
    function _gableRvNote(who, n) { var L = _gableLayers(), st = AF_STEP.gable; return who + 'review gable step ' + st + ' of ' + L.length + ' (' + (L[st - 1] || '?') + '): ' + n.rv + ' bod(ies) MAGENTA, ' + n.un + ' under it in their colours, ' + n.ab + ' over it hidden (billed)'; }
    function _slopeIdx(ph, L) { L = L || _slopeDefs(); var i; for (i = 0; i < L.length; i++) if (L[i][0] === ph) return i + 1; return 0; }
    /* the skin's bodies by their walk item -> the step */
    function _slopeIdxOf(key, L) {
      key = String(key || '');
      var ph = /lining/.test(key) ? 'lining' : /sheathing|deck/.test(key) ? 'deck' : /insul|vapour|pir/.test(key) ? 'insul' : /underlay/.test(key) ? 'underlay' :
               /batten/.test(key) ? 'battens' : /edge|drip|verge/.test(key) ? 'edges' : /cover|flash/.test(key) ? 'cover' : /ridge/.test(key) ? 'ridge' : '';
      return ph ? _slopeIdx(ph, L) : 0;
    }
    var AF_LAYERS = { gfloor: function () { return _gfLayers(); }, ufloor: function () { return _ufLayers(); }, slope: function () { return _slopeLayers(); }, gable: function () { return _gableLayers(); }, wingwall: function () { return _wingWallLayers(); }, wingroof: function () { return _wingRoofLayers(); }, dormer: function () { return _dormerLayers(); }, part: function () { return _partLayers(); } };
    /* a build-up the arrows offer: the upper floors only while the A has one (aframe-v134); the slopes either way (aframe-v146 above, v147 between); the gables (aframe-v148); the wing's walls, roof and dormer while there is a wing (aframe-v149 - v151); the partitions while there are any (aframe-v152) */
    function _asmAvail(k) { if (k === 'wingwall' || k === 'wingroof') return _wingSides().length > 0; if (k === 'dormer') return _wingSides().some(function (sw) { return !!_dormer(sw); }); if (k === 'part') return (STATE.parts || []).length > 0; return k !== 'ufloor' || floors().length >= 2; }
    var AF_ASM_NAME = { gfloor: 'ground floor', ufloor: 'ceilings + floors', slope: 'roof slopes', gable: 'gables', wingwall: 'wing walls', wingroof: 'wing roof', dormer: 'dormer', part: 'partitions' };
    var _rvLoaded = false;
    function _rvLoad() {
      if (_rvLoaded) return; _rvLoaded = true;
      try {
        var raw = global.localStorage && global.localStorage.getItem('af-review'), o = raw ? JSON.parse(raw) : null;
        if (o && AF_LAYERS[o.asm] && o.n >= 1) { for (var k in AF_STEP) if (AF_STEP.hasOwnProperty(k)) AF_STEP[k] = 99; AF_STEP[o.asm] = o.n | 0; }
        else if (o && o.asm === '') { for (var k2 in AF_STEP) if (AF_STEP.hasOwnProperty(k2)) AF_STEP[k2] = 99; }
      } catch (eL) {}
    }
    function _rvSet(asm, n) {
      var k;
      for (k in AF_STEP) if (AF_STEP.hasOwnProperty(k)) AF_STEP[k] = 99;
      if (asm && AF_LAYERS[asm]) { var N = AF_LAYERS[asm]().length; AF_STEP[asm] = Math.max(1, Math.min(N, n | 0)); }
      try { if (global.localStorage) global.localStorage.setItem('af-review', JSON.stringify({ asm: asm || '', n: asm ? AF_STEP[asm] : 0 })); } catch (eS) {}
      _log('review   arrows: ' + (asm ? (asm + ' step ' + AF_STEP[asm]) : 'off, everything drawn'));
      try { API.rebuild(); } catch (eR) {}
    }
    function _rvBar() {
      var doc = global.document; if (!doc || !doc.createElement) return;
      var bar = doc.getElementById('af-review-bar');
      var show = _isAdmin() && !_inPlan();
      if (!show) { if (bar) bar.style.display = 'none'; return; }
      var st = null; try { st = (API._stage || __CORE._stage)(); } catch (eSt) { st = null; }
      var cv = st && st.renderer && st.renderer.domElement, host = cv && cv.parentElement;
      if (!host) return;
      if (!bar || bar.parentElement !== host) {
        if (bar && bar.parentElement) bar.parentElement.removeChild(bar);
        try { if (global.getComputedStyle && global.getComputedStyle(host).position === 'static') host.style.position = 'relative'; } catch (eP) {}
        bar = doc.createElement('div'); bar.id = 'af-review-bar';
        bar.setAttribute('style', 'position:absolute;top:8px;left:50%;transform:translateX(-50%);z-index:30;display:flex;align-items:center;gap:6px;padding:4px 6px;border-radius:20px;background:rgba(20,20,20,0.78);color:#fff;font:12px/1.2 sans-serif;user-select:none;max-width:94%;');
        var btn = function (txt, id) {
          var b = doc.createElement('button'); b.type = 'button'; b.id = id; b.textContent = txt;
          b.setAttribute('style', 'border:0;border-radius:14px;min-width:30px;height:28px;padding:0 8px;background:#fff;color:#111;font:600 13px sans-serif;cursor:pointer;');
          bar.appendChild(b); return b;
        };
        var bA = btn('\u21C5', 'af-rv-asm'), bP = btn('\u25C0', 'af-rv-prev');
        var lab = doc.createElement('span'); lab.id = 'af-rv-lab'; lab.setAttribute('style', 'padding:0 6px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:60vw;'); bar.appendChild(lab);
        var bN = btn('\u25B6', 'af-rv-next');
        var stop = function (e) { if (e) { e.stopPropagation(); if (e.preventDefault) e.preventDefault(); } };
        ['pointerdown', 'touchstart', 'mousedown'].forEach(function (ev) { bar.addEventListener(ev, function (e) { e.stopPropagation(); }, { passive: true }); });
        bA.addEventListener('click', function (e) {
          stop(e);
          var keys = Object.keys(AF_LAYERS).filter(_asmAvail), cur = _rvAsm(), i = keys.indexOf(cur);
          var nx = (i < 0) ? keys[0] : (i + 1 < keys.length ? keys[i + 1] : '');
          _rvSet(nx, 1);
        });
        bP.addEventListener('click', function (e) { stop(e); var a = _rvAsm(); if (a) _rvSet(a, AF_STEP[a] - 1); });
        bN.addEventListener('click', function (e) { stop(e); var a = _rvAsm(); if (a) _rvSet(a, AF_STEP[a] + 1); });
        host.appendChild(bar);
      }
      bar.style.display = 'flex';
      var a = _rvAsm(), labEl = doc.getElementById('af-rv-lab'), pv = doc.getElementById('af-rv-prev'), nxb = doc.getElementById('af-rv-next');
      if (!a) { labEl.textContent = 'layers: off (tap \u21C5)'; pv.disabled = nxb.disabled = true; pv.style.opacity = nxb.style.opacity = '0.35'; return; }
      var L = AF_LAYERS[a](), n = AF_STEP[a];
      labEl.textContent = (AF_ASM_NAME[a] || a) + ' ' + n + '/' + L.length + ' \u00B7 ' + (L[n - 1] || '?');
      pv.disabled = (n <= 1); nxb.disabled = (n >= L.length);
      pv.style.opacity = pv.disabled ? '0.35' : '1'; nxb.style.opacity = nxb.disabled ? '0.35' : '1';
    }
    function _stepOn(asm, n) {
      if (!_isAdmin()) return true;
      if (AF_FOCUS && AF_FOCUS !== asm) return false;
      return n <= (AF_STEP[asm] == null ? 99 : AF_STEP[asm]);
    }
    function _stepNote() {
      var k, o = [];
      for (k in AF_STEP) if (AF_STEP.hasOwnProperty(k)) o.push(k + ' ' + (AF_STEP[k] >= 99 ? 'done' : ('step ' + AF_STEP[k])));
      return 'asm      build-ups (inside out, a layer past its step not drawn, still billed): ' + o.join(', ') + (AF_FOCUS ? (' | FOCUS ' + AF_FOCUS + ' alone') : '');
    }
    /* THE BILL CHECKED AFTER EVERY LAYER (aframe-v128): how many rows each layer
       holds, and any row with no catalogue entry, a quantity that is not a
       number or not over nought -- the line is printed when it changes */
    var _bomSaid = '';
    function _bomNote(ctx) {
      var L = [], bad = [], nRow = 0, k, c;
      for (k in _bill) {
        if (!_bill.hasOwnProperty(k) || k.indexOf('aframe-') !== 0) continue;
        var B9 = _bill[k] || {}, n9 = 0;
        for (c in B9) {
          if (!B9.hasOwnProperty(c)) continue;
          n9++; nRow++;
          var q9 = B9[c];
          if (!(q9 > 0) || !isFinite(q9)) bad.push(k + ':' + c + '=' + q9);
          if (!(__CORE.CATALOG && __CORE.CATALOG[c])) bad.push(k + ':' + c + ' NO CATALOGUE ROW');
        }
        L.push(k.replace('aframe-', '') + ' ' + n9);
      }
      var miss = Object.keys(MISSING || {});
      var line = 'bom      ' + nRow + ' row(s) in ' + L.length + ' layer(s): ' + L.join(', ') + ' | placeholders still billed: ' + (miss.length ? miss.join(', ') : 'none') + ' | ' + (bad.length ? ('PROBLEMS ' + bad.join(', ')) : 'no row without a catalogue entry, none at nought');
      if (line !== _bomSaid) { _bomSaid = line; if (ctx && ctx.log) ctx.log(line); else _log(line); }
    }
    /* -------------------------------------------------------------------------
       THE ASSEMBLY MARKS AND THE PAINT (aframe-v137, Marek: dalsi krok -- the
       assembly walk as in the ADU). The core's walk makes one step of every
       item a layer marks (_asmMark: key, direction, name, code) -- the bodies a
       builder adds after a mark carry it. Until v136 the gables were one item,
       the facade, the skin, the lining and the floors none at all; now every
       material has its mark, named by its catalogue code.

       _am(ctx, key, name, code, dir) switches to an item, the same mark object
       again when the item comes back (studs between headers, battens between
       boards), so a layer does not pile up marks.
       _afHid(ctx) is the layer's hidden group: what a review step does not draw
       is built there, never seen, so the coating the core measures off the
       bodies reads the same in the review as outside it.
       _asmDeep(group) hands a group's mark down to its bodies (a review group,
       a layer of the point-footing floor): the core measures a body only by
       its own mark.

       THE PAINT INSIDE AND OUT. The core paints all wood with the impregnation
       and puts the sealer and the top coat on the wood of a layer that is not
       enclosed (its default: anything not named floor / stud-wall / partition /
       ceiling -- which was every layer of the A, so the rafters, the studs and
       the joists inside the envelope got three coats). The A says which is
       outside (__PROD._coatEnclosed): the facade layer alone; and what stands
       outdoors inside an enclosed layer (__PROD._coatOutside): the porch, the
       balcony, the wing's walked deck -- the bodies flagged afOut, measured by
       the core's own rule, a code the facade already has left out (the core
       counts that one outside whole).
       ------------------------------------------------------------------------- */
    function _am(ctx, key, name, code, dir) {
      if (!ctx || !ctx.marks) return;
      if (ctx._afAsmM !== ctx.marks) { ctx._afAsmM = ctx.marks; ctx._afAsm = {}; }
      var id = key + '|' + (code || '') + '|' + name, M = ctx._afAsm;
      if (!M[id]) { _asmMark(ctx, key, dir || 'top', name, code || ''); M[id] = ctx.item; }
      else ctx.item = M[id];
    }
    function _afHid(ctx) {
      var g = ctx.group, T = ctx.THREE, h = null, i;
      for (i = 0; i < g.children.length; i++) if (g.children[i].userData && g.children[i].userData.afHid) { h = g.children[i]; break; }
      if (!h) {
        h = new T.Group(); h.visible = false; h.userData.afRvHold = true; h.userData.afHid = true;
        h.add = function () {
          var q;
          for (q = 0; q < arguments.length; q++) {
            var o = arguments[q];
            if (o && o.traverse) o.traverse(function (m) { if (m.userData && !m.userData.asm && ctx.item) m.userData.asm = ctx.item; if (m.layers) m.layers.disableAll(); });
          }
          return T.Group.prototype.add.apply(this, arguments);
        };
        T.Group.prototype.add.call(g, h);
      }
      return h;
    }
    function _asmDeep(g) {
      var fill = function (o, tag) {
        var own = o.userData && o.userData.asm;
        if (!own && tag && o.userData) { o.userData.asm = tag; own = tag; }
        var i; for (i = 0; i < o.children.length; i++) fill(o.children[i], own || tag);
      };
      var i;
      for (i = 0; i < g.children.length; i++) { var c = g.children[i]; if (c.userData && c.userData.afRvHold) continue; fill(c, null); }
    }
    /* the outdoor bodies of a builder: every direct child from k0 on */
    function _outFlag(ctx, k0, why) {
      var ch = ctx.group.children, i;
      for (i = k0; i < ch.length; i++) if (ch[i].userData && !ch[i].userData.afRvHold) ch[i].userData.afOut = why;
    }
    /* re-mark what a core drawer added from k0 on, by the bodies' colour: [[hex, key, name, code], ...]; the rest takes dflt */
    function _asmByColour(ctx, k0, list, dflt) {
      var ch = ctx.group.children, i, q, keep = ctx.item, mk = [], mkD = null;
      for (q = 0; q < list.length; q++) { _am(ctx, list[q][1], list[q][2], list[q][3]); mk.push(ctx.item); }
      if (dflt) { _am(ctx, dflt[0], dflt[1], dflt[2]); mkD = ctx.item; }
      ctx.item = keep;
      for (i = k0; i < ch.length; i++) {
        var o = ch[i], mt = o.material && (Array.isArray(o.material) ? o.material[0] : o.material), hx = (mt && mt.color) ? mt.color.getHex() : -1, hit = null;
        for (q = 0; q < list.length; q++) if (hx === list[q][0]) { hit = mk[q]; break; }
        if (!hit) hit = mkD;
        if (hit && o.userData) o.userData.asm = hit;
      }
    }
    /* wood, as the core's coating decides it (core-v643 _woodHere) */
    function _coatWood(code) {
      var C = __CORE.CATALOG || {}, r = C[code], cd = (r && r.code) ? r.code : code, nm = String(((C[cd] || r || {}).label) || '').toUpperCase();
      if (/GYPSUM|OSB|CEMENT|MEMBRANE|FOIL|WOOL|INSULAT|TILE|GLASS|STEEL|METAL|SCREW|NAIL|FLASHING|GUTTER/.test(nm)) return '';
      if (/LUMBER|TIMBER|BATTEN|CLADDING|DECKING|TRIM|SHIPLAP|SIDING|PLYWOOD|WOOD/.test(nm)) return cd;
      var row = null, i;
      try { var pd = global.productData; if (pd && pd.length) for (i = 0; i < pd.length; i++) if (pd[i] && pd[i][0] === cd) { row = pd[i]; break; } } catch (eP) { row = null; }
      var n2 = String((row && row[3]) || '').toUpperCase();
      if (row && /FURNITURE|SANITARY|APPLIANCE|KITCHEN|LIGHTING|ELECTRIC/.test(String(row[1] || '').toUpperCase())) return '';
      if (!n2) return /^(KVH|KVR|KVL|TST)/.test(cd) ? cd : '';
      if (/LUMBER|BATTEN|FURRING|DECKING|TIMBER|STUD|RAFTER|JOIST|PLATE|BEAM|POST/.test(n2) && !/CONNECTOR|TIE|SCREW|NAIL|PLATE 1|PLATE 2/.test(n2)) return cd;
      return /WOOD (FACADE )?CLADDING|WOOD CORNER TRIM|DECKING|SHIPLAP|SIDING|WOOD PANEL/.test(n2) ? cd : '';
    }
    /* a body's painted surface, the core's rule */
    function _coatArea(o) {
      var g = o.geometry; if (!g) return 0;
      if (!g.boundingBox) g.computeBoundingBox();
      var bb = g.boundingBox, sc = o.scale || { x: 1, y: 1, z: 1 };
      var d = [Math.abs(bb.max.x - bb.min.x) * (sc.x || 1), Math.abs(bb.max.y - bb.min.y) * (sc.y || 1), Math.abs(bb.max.z - bb.min.z) * (sc.z || 1)];
      d.sort(function (a, b) { return b - a; });
      var len = d[0], wid = d[1], thk = d[2], u = o.userData;
      if (!(len > 0.001 && wid > 0.0001)) return 0;
      if (u && typeof u.coatA === 'number' && isFinite(u.coatA) && u.coatA >= 0) return u.coatA;
      if (thk < 0.0005) return len * wid;
      if (thk < wid / 6) return len * wid + 2 * (len + wid) * thk;
      return 2 * (wid + thk) * len + 2 * wid * thk;
    }
    /* A SLANTED MEMBER IS MEASURED BY ITS OWN SHAPE (aframe-v137). The core
       measures a body by the box round its geometry, and the A draws its
       rafters, raked studs and plates, the soffit and the gable boards as
       shapes extruded in place: the box round a rafter is the whole slope, so
       one 60 x 200 rafter counted some 15 m2 and the frame 700 m2 of paint
       where it has about 160. Each extruded wooden body hands the core its
       real surface (userData.coatA, the core's own way in, core-v611): a
       member all round (both faces and the edges), a board its face and its
       edges, the core's two cases. */
    function _coatFix(g, T) {
      var ring = function (pts) { var L = 0, i; for (i = 0; i < pts.length; i++) { var a = pts[i], b = pts[(i + 1) % pts.length]; L += Math.hypot(b.x - a.x, b.y - a.y); } return L; };
      g.traverse(function (o) {
        if (!o.isMesh || !o.geometry || !o.geometry.parameters) return;
        var Pr = o.geometry.parameters, sh = Pr.shapes, op = Pr.options;
        if (!sh || !op || !(op.depth > 0)) return;
        var m = o.userData && o.userData.asm, tag = m ? (typeof m === 'string' ? m : (m.code || m.key || '')) : '';
        if (!tag || !_coatWood(tag)) return;
        var list = Array.isArray(sh) ? sh : [sh], A = 0, Pm = 0, q;
        for (q = 0; q < list.length; q++) {
          var ex = list[q].extractPoints(12);
          A += Math.abs(T.ShapeUtils.area(ex.shape)); Pm += ring(ex.shape);
          ex.holes.forEach(function (h) { A -= Math.abs(T.ShapeUtils.area(h)); Pm += ring(h); });
        }
        if (!(A > 0 && Pm > 0)) return;
        var d = op.depth, ws = 2 * A / Pm;
        if (d < ws / 6) o.userData.coatA = A + Pm * d;                  /* a board lying in the shape: its face and edges */
        else if (ws < d / 6) o.userData.coatA = (Pm / 2) * d + 2 * A;   /* a board standing across it */
        else o.userData.coatA = 2 * A + Pm * d;                         /* a member: all round */
      });
    }
    var COAT_OUT_LAYERS = /^aframe-facade$/;
    /* ONLY THE WALL TILE COMES OFF THE PAINT (aframe-v153, plan J; the core's
       opt-in since core-v661, the RANCH's ranch-v59 pattern): the core took
       every m2 row with TILE in its label off the gypsum -- the geotextile of
       the drip strip and the wing's deck, the plinth's 'glass fiber textile
       mesh' -- and the 6x9 painted 48 of its 143 m2 of board. Now only the
       wet rooms' wall tile SBC00001 'Ceramic wall tile' lies on the board */
    __PROD._paintTileRe = /\bWALL TILE/;
    /* THE COATING BY WHERE THE WOOD IS (aframe-v154, plan J part 2; the core's
       opt-in __PROD._coatByLayer since core-v661, the RANCH's ranch-v59). The
       core sealed and top-coated a whole profile the moment one body of it
       stood in the facade layer: every batten KVH40060 (behind the boards on
       the gables, the wing and the dormer) and every board FVW01351 -- the
       T&G seen from the room under insulation above the rafters among them.
       Kept per layer now, and the layer hands the core (layer, code):
         aframe-facade  the boards outside, the battens behind them enclosed
         aframe-frame   its boards outside (the soffit, the porch's T&G), the
                        rest enclosed (the porch's members and rafters by the
                        product's outdoor area, _coatOutside)
         aframe-wing    its boards outside (the wing's and the dormer's
                        cladding), the rest enclosed (the wing's deck by
                        _coatOutside)
         everything else enclosed (the skin's T&G and battens among it).
       The impregnation MFP00007 stays on all of it. */
    function _coatEncl(id, code) {
      id = String(id || ''); code = String(code || '');
      if (id === 'aframe-facade') return code === FAC.batt.code;
      if (id === 'aframe-frame' || id === 'aframe-wing') return code !== FAC.clad.code && code !== TRIM.lin && code !== TRIM.cas;   /* the units' outside trim (aframe-v162) */
      if (id === 'aframe-skin' && (code === 'KVR16019' || code === 'KVR10019')) return false;   /* the verge boards (aframe-v157) */
      return !COAT_OUT_LAYERS.test(id);
    }
    __PROD._coatByLayer = true;
    __PROD._coatEnclosed = { test: function (id, code) { return _coatEncl(id, code); } };
    __PROD._coatOutside = function () {
      var st = null; try { st = (API._stage || __CORE._stage)(); } catch (eSt) { st = null; }
      if (!st || !st.group) return { area: 0, note: '' };
      var tagOf = function (o) { var m = o.userData && o.userData.asm; return m ? (typeof m === 'string' ? m : (m.code || m.key || '')) : ''; };
      var info = function (o) {
        var p = o, why = null;
        while (p) { if (!why && p.userData && p.userData.afOut) why = p.userData.afOut; if (p.userData && p.userData.layer) return { lay: p.userData.layer, why: why }; p = p.parent; }
        return { lay: '', why: why };
      };
      /* the outdoor bodies the core counts enclosed by their layer and code (aframe-v154: by the body, the core
         keeps each code per layer now -- a body whose layer and code are outside is the core's already) */
      var list = [];
      st.group.traverse(function (o) {
        if (!o.isMesh || !o.geometry) return;
        var tg = tagOf(o); if (!tg) return;
        var cd = _coatWood(tg); if (!cd) return;
        var I = info(o);
        if (I.why && _coatEncl(I.lay, cd)) list.push({ o: o, cd: cd, why: I.why });
      });
      var by = {}, a = 0, q;
      for (q = 0; q < list.length; q++) {
        var ar = _coatArea(list[q].o);
        by[list[q].why] = (by[list[q].why] || 0) + ar; a += ar;
      }
      var parts = Object.keys(by).map(function (k) { return k + ' ' + by[k].toFixed(1); });
      return { area: a, note: 'the A: ' + (parts.length ? parts.join(', ') : 'none') + '; by layer (aframe-v154): the boards of the facade, the frame and the wing outside, the battens behind them in' };
    };
    function _regLayer(def) {
      var b0 = def.build3d;
      var b = function (ctx) {
        if (!_inPlan()) return b0(ctx);
        var T = ctx && ctx.THREE;
        if (!T || !T.Group) return b0(ctx);
        var spare = new T.Group(), c2 = {}, k;
        for (k in ctx) { if (ctx.hasOwnProperty(k)) c2[k] = ctx[k]; }
        c2.group = spare;
        /* THE PLAN KEEPS ITS FRAME (aframe-v80, Marek: pri prechodu do
           vedlejsiho okna se pudorys extremne zoomne): with nothing on the
           stage its own resize measured an empty group and squeezed the plan's
           camera to nothing. One flat box the size of the base, never drawn
           (its material is off), stays on the stage so there is always a
           building to measure; it sits on the ground, so a tap still lands
           where it did */
        if (ctx.group && !ctx.group.children.some(function (c) { return c.userData && c.userData.afPlanFrame; })) {
          var BRf = _baseRect(), fm = new T.Mesh(new T.BoxGeometry(BRf.x1 - BRf.x0, 0.001, BRf.z1 - BRf.z0), new T.MeshBasicMaterial({ visible: false }));
          fm.position.set((BRf.x0 + BRf.x1) / 2, 0.0005, (BRf.z0 + BRf.z1) / 2);
          fm.userData.afPlanFrame = true; fm.userData.arSkip = true; fm.userData.isEdge = true;
          ctx.group.add(fm);
        }
        var r0 = b0(c2);
        var note = 'plan     storey ' + ((STATE.planStorey | 0) + 1) + ' on the plan: the model is built for the bill but not drawn -- the plan is the floorplan asset\'s drawing only | ' + _planDiag();
        var nowP = Date.now();
        if (note !== _planSaid || nowP - _planAt > 300) { _planSaid = note; ctx.log(note); }
        _planAt = nowP;
        return r0;
      };
      def.build3d = function (ctx) {
        if (def.id === _firstLayerId) { _rvLoad(); if (!_inPlan()) _rvStat = { off: 0, kept: 0, rv: 0, lay: [] }; }
        var kid0 = (ctx && ctx.group && ctx.group.children) ? ctx.group.children.slice() : [];
        var r = b(ctx), m = null;
        if (_inPlan()) { if (def.id === _lastLayerId) { try { _rvBar(); } catch (eBp) {} } return r; }
        /* every body carries its item, a group's bodies too (aframe-v137) -- before the review hides any */
        try { if (ctx && ctx.group) { _asmDeep(ctx.group); _coatFix(ctx.group, ctx.THREE); } } catch (eDp) { if (ctx.log) ctx.log('coating  ERROR the marks or the surfaces in ' + def.id + ': ' + ((eDp && eDp.message) || eDp)); }
        /* the admin's review: everything but the structure and the layer under review off the stage (aframe-v130) */
        if (_rvAsm() && ctx && ctx.group && ctx.THREE) { try { _rvStrip(ctx, def.id, kid0); } catch (eRv) { if (ctx.log) ctx.log('review   ERROR stripping ' + def.id + ': ' + ((eRv && eRv.message) || eRv)); } }
        /* after the last layer of the build: the build-ups' steps and the bill check, once */
        if (def.id === _lastLayerId) { if (ctx && ctx.log) { ctx.log(_rvNote()); ctx.log(_stepNote()); } try { _bomNote(ctx); } catch (eBm) {} try { _rvBar(); } catch (eBar) { if (ctx && ctx.log) ctx.log('review   ERROR the arrows bar: ' + ((eBar && eBar.message) || eBar)); } }
        /* from core-v504 the section's own stencil checks every mesh (moved there) */
        var cv = +String(__CORE.CORE_VERSION || '').replace(/[^0-9]/g, '');
        if (cv < 504) { try { m = _markOpen(ctx); } catch (eM) {} }
        if (m && ctx.log) ctx.log('section  ' + def.id + ': ' + m.body + ' bod(ies) filled when cut, ' + m.open + ' open sheet(s) left unfilled');
        return r;
      };
      _lastLayerId = def.id; if (!_firstLayerId) _firstLayerId = def.id;
      return API.registerLayer(def);
    }
    var _lastLayerId = '', _firstLayerId = '';
    function _rafSize() {
      var RF = (typeof RAF !== 'undefined' && RAF) ? RAF : { small: { code: 'KVH60200', t: 0.060, d: 0.200 }, big: { code: 'KVH60240', t: 0.060, d: 0.240 } };
      /* THE RAFTER BY THE STOREYS (aframe-v52, Marek: u malych pudorysu
         mensi krokve, do 2 pater mensi, 3 patra vetsi -- a DIY build, sized
         lean): 60 x 200 up to two floors, 60 x 240 with three. The floors are
         counted on the small rafter's section (the count asks the section,
         the section asks the rafter), so the question cannot loop */
      if (_rafBusy) return RF.small;
      var nF = 1;
      _rafBusy = true;
      try { nF = floors().length; } catch (eF) { nF = 1; }
      _rafBusy = false;
      return (nF >= 3) ? RF.big : RF.small;
    }
    var _rafBusy = false;
    function _sect() {
      var w = STATE.footprint.w, e = STATE.roof.eave || 0.30, p = (STATE.roof.pitch || 60) * Math.PI / 180;
      var top = wallTop(), half = w / 2 + e, d = _rafSize().d;
      /* the section is read off the core's own roof planes where they exist,
         so the eave reach the core keeps per side (and a project may have
         dragged) is the one the floors and the frame use */
      try {
        var PL = roofPlanes() || [], q, cx = STATE.origin.x;
        for (q = 0; q < PL.length; q++) {
          if (PL[q].kind !== 'slope' || !PL[q].eave || !PL[q].ridge) continue;
          top = PL[q].eave[0][1]; half = Math.abs(PL[q].eave[0][0] - cx); e = half - w / 2;
          var riseP = PL[q].ridge[0][1] - top;
          if (riseP > 0.1 && half > 0.1) p = Math.atan2(riseP, half);
          break;
        }
      } catch (eS) {}
      var rise = half * Math.tan(p), deck = _deckY();
      return { w: w, e: e, p: p, deg: Math.round(p * 180 / Math.PI), top: top, half: half, ridgeY: top + rise, deck: deck,
               tan: Math.tan(p), sin: Math.sin(p), cos: Math.cos(p), rafD: d,
               /* the clear width between the rafters' undersides at height y */
               widthAt: function (y) { return 2 * (half - (y - top) / Math.tan(p) - d / Math.sin(p)); } };
    }

    /* -------------------------------------------------------------------------
       THE FLOORS, OUT OF THE SECTION. The ground floor is the deck on the
       plinth. Each next floor goes a clear height plus a floor zone higher,
       and it exists if a bed 900 wide fits with 800 over the floor -- read as
       the clear width 800 above the deck being at least 900 plus the boards'
       end trims. Three at the most (Marek).
       ------------------------------------------------------------------------- */
    function floors() {
      var S = _sect(), out = [], deck = _deckY();
      var zone = FLOOR.joist.d + FLOOR.deck.t;
      out.push({ i: 0, y: deck, clear: CLEAR.ground, width: S.widthAt(deck + BED.at), floorWidth: S.widthAt(deck) });
      var y = deck + CLEAR.ground + zone, k;
      for (k = 1; k < 3; k++) {
        var wAt = S.widthAt(y + BED.at);
        if (wAt < BED.w + 0.10) break;
        out.push({ i: k, y: y, clear: CLEAR.upper, width: wAt, floorWidth: S.widthAt(y) });
        y += CLEAR.upper + zone;
      }
      return out;
    }

    /* -------------------------------------------------------------------------
       THE FOOTING RULE (Marek: urci ty sam pravidlo). A cabin with the ground
       floor only may stand on ground screws or precast piers; the moment the
       section gives a second floor -- more load, more wind on a taller A --
       strips with a slab are the one footing, and the lighter ones are locked.
       Since aframe-v6 the one-floor kinds are built: ground screws, precast
       pads or poured piers, with the timber floor frame on them (core
       pointBase, copied from the ADU).
       ------------------------------------------------------------------------- */
    function footingKinds() {
      return (floors().length >= 2) ? ['strips'] : ['screws', 'pads', 'piers', 'strips'];
    }

    /* -------------------------------------------------------------------------
       THE BASE
       ------------------------------------------------------------------------- */
    /* THE TIMBER FLOOR ON POINT FOOTINGS INSULATED (aframe-v132, plan C). The
       core's pointBase lays the footings, the rim, the doubled beam, the joists
       and the OSB deck, nothing between. Under a heated room over open air the
       bays are filled, bottom up, as practice has it for a raised floor:
       galvanised rodent mesh (hardware cloth) across the joists' undersides,
       held by furring strips screwed along every joist; a breather membrane on
       it, lapped up the joist sides, holding the wool and keeping the wind out
       of it; mineral wool the full joist depth; on the joists' tops the vapour
       barrier, taped, under the OSB. Only under the house: the porch zones
       carry decking and stay open. The OSB is the core's; it is taken off the
       stage while a lower layer is reviewed, and is magenta while it is. */
    function _timberFloorLayers(ctx, n0, RB, BH) {
      var T = ctx.THREE, g = ctx.group, J = { t: 0.060, d: 0.240 }, dT = 0.018, top = _deckY();
      var yT = top - dT, yB = yT - J.d, x0 = RB.x0, x1 = RB.x1, w = x1 - x0, cx = (x0 + x1) / 2;
      var hz0 = Math.max(RB.z0, BH.z0), hz1 = Math.min(RB.z1, BH.z1);
      /* the core's OSB: its own colour, among what the call added */
      var cOsb = new T.Color(0xB9A88C).getHex(), kids = g.children.slice(n0), rvO = _isRv('gfloor', _gfIdx('OSB')), nO = 0;
      kids.forEach(function (m) {
        if (!m || !m.isMesh || !m.material || !m.material.color || m.material.color.getHex() !== cOsb) return;
        nO++;
        if (rvO) { m.material = new T.MeshStandardMaterial({ color: MAGENTA, roughness: 0.95 }); _rvTag(m); }
        else if (!_gfOn('OSB')) g.remove(m);
      });
      /* the joists as the core sets them out: from z0 + t every grid, the last one t + t/2 short of z1 */
      var sp = ctx.grid || 0.60, jp = [], zz = RB.z0 + J.t;
      while (zz < RB.z1 - 2 * J.t) { jp.push(zz); zz += sp; }
      jp.push(RB.z1 - J.t - J.t / 2);
      var lines = [RB.z0 + J.t / 2].concat(jp).concat([RB.z1 - J.t / 2]);
      lines.sort(function (a, b) { return a - b; });
      /* the bays in x: rim to the doubled beam, each side */
      var run = (w - 2 * J.t) / 2 - J.t, xs = [[x0 + J.t, x0 + J.t + run], [x1 - J.t - run, x1 - J.t]];
      var bays = [], q, h;
      for (q = 0; q + 1 < lines.length; q++) {
        var za = Math.max(hz0, lines[q] + J.t / 2), zb = Math.min(hz1, lines[q + 1] - J.t / 2);
        if (zb - za < 0.05) continue;
        for (h = 0; h < 2; h++) bays.push({ x0: xs[h][0], x1: xs[h][1], z0: za, z1: zb });
      }
      var aB = 0; bays.forEach(function (b) { aB += (b.x1 - b.x0) * (b.z1 - b.z0); });
      var aH = w * (hz1 - hz0), nLines = 0; lines.forEach(function (z) { if (z >= hz0 - 0.01 && z <= hz1 + 0.01) nLines++; });
      var WF = woolFill(J.d);
      /* each layer its own item; one a review step does not draw is built hidden, so the paint on the furring stays (aframe-v137) */
      var LAYM = { 'rodent mesh': ['layer_rodent_mesh', 'Rodent mesh', 'TBD.rodentMesh'], 'breather membrane': ['layer_breather_membrane', 'Breathable membrane', 'INS00002'],
                   'wool between': ['layer_floor_wool', 'Floor wool', (WF.mix[0] && WF.mix[0].code) || ''], 'vapour barrier': ['layer_vapour_barrier', 'Vapour barrier', 'ROV00001'] };
      var lay = function (name, col, fn) {
        var on = _gfOn(name), M = LAYM[name];
        if (M) _am(ctx, M[0], M[1], M[2], 'top');
        var rv = _isRv('gfloor', _gfIdx(name)), gL = new T.Group(); gL.userData.afNs = true; if (rv) _rvTag(gL);
        fn(gL, rv ? MAGENTA : col);
        if (on) g.add(gL); else _afHid(ctx).add(gL);
      };
      var bx = function (gL, col, bw, bh, bd, px, py, pz) { var m = _box(T, gL, bw, bh, bd, px, py, pz, 0, col, 1); m.userData.afNs = true; return m; };
      /* 2: the mesh under the joists, and a furring strip along each joist line */
      lay('rodent mesh', 0x8A8F94, function (gL, col) {
        bx(gL, col, w, 0.002, hz1 - hz0, cx, yB - 0.001 - 0.030, (hz0 + hz1) / 2);
        var it0 = ctx.item; _am(ctx, 'layer_furring', 'Furring', 'KVR50030', 'top'); var mkF = ctx.item; ctx.item = it0;
        lines.forEach(function (z) { if (z >= hz0 - 0.01 && z <= hz1 + 0.01) bx(gL, col === MAGENTA ? col : WOOD, w, 0.030, 0.050, cx, yB - 0.015, z).userData.asm = mkF; });
      });
      /* 3: the membrane in each bay, on the mesh, lapped up the joist sides */
      lay('breather membrane', 0x5D7FA6, function (gL, col) { bays.forEach(function (b) { bx(gL, col, b.x1 - b.x0, 0.001, b.z1 - b.z0, (b.x0 + b.x1) / 2, yB + 0.0005, (b.z0 + b.z1) / 2); }); });
      /* 4: the wool, the full depth */
      lay('wool between', FWOOL.col, function (gL, col) { bays.forEach(function (b) { bx(gL, col, b.x1 - b.x0 - 0.004, WF.t - 0.004, b.z1 - b.z0 - 0.004, (b.x0 + b.x1) / 2, yB + 0.001 + WF.t / 2, (b.z0 + b.z1) / 2); }); });
      /* 5: the vapour barrier on the joists' tops */
      lay('vapour barrier', 0x3E4A56, function (gL, col) { bx(gL, col, w, 0.001, hz1 - hz0, cx, yT - 0.0005, (hz0 + hz1) / 2); });
      /* THE BILL, whatever is drawn */
      var L0 = 'aframe-base', furL = nLines * w, nScr = Math.ceil(furL / 0.40);
      API.billAdd(L0, 'TBD.rodentMesh', Math.round(aH * 1.10 * 100) / 100);
      API.billAdd(L0, 'KVR50030', Math.round(furL * 1.05 * 100) / 100);
      API.billAdd(L0, 'FAS60100', nScr);
      var lapA = 0; bays.forEach(function (b) { lapA += 2 * (b.x1 - b.x0) * 0.10; });   /* lapped 100 up both joist sides */
      API.billAdd(L0, 'INS00002', Math.round((aB + lapA) * 1.10 * 100) / 100);
      WF.mix.forEach(function (mx) { API.billAdd(L0, mx.code, Math.round(aB * mx.n * 1.05 * 100) / 100); });
      API.billAdd(L0, 'ROV00001', Math.round(aH * 1.10 * 100) / 100);
      API.billAdd(L0, 'INS01005', Math.round((aH / 1.4 + 2 * (w + (hz1 - hz0))) * 10) / 10);
      /* the membrane under the joists and the barrier on them stapled (aframe-v153) */
      _chemBill(L0, 0, aB + lapA + aH, 0); _chemNote(ctx, 'timber floor', 0, aB + lapA + aH, 0);
      /* THE CORE'S OSB GLUED DOWN TOO (aframe-v134, as the upper floors): a bead
         along every joist line under the house, both rims and the doubled beam */
      var glueG = nLines * w + 3 * (hz1 - hz0), nGlueG = Math.ceil(glueG * SUBGLUE.edges / SUBGLUE.mPerTube);
      API.billAdd(L0, SUBGLUE.code, nGlueG);
      ctx.log('gfloor   OSB glue ' + SUBGLUE.code + ' ' + nGlueG + ' cartridge(s) of 10 oz: a 6 mm bead ' + glueG.toFixed(1) + ' m (' + nLines + ' joist line(s) x ' + Math.round(w * 1000) + ', the rims and the beam) + 10% at the sheet joints');
      ctx.log('gfloor   timber floor on ' + STATE.foundation + ': ' + bays.length + ' bay(s) ' + aB.toFixed(2) + ' m2 under the house (' + Math.round(w * 1000) + ' x ' + Math.round((hz1 - hz0) * 1000) + '), the porch zones open; OSB from the core ' + nO + ' piece(s)' + (rvO ? ' UNDER REVIEW in magenta' : (_gfOn('OSB') ? '' : ' taken off the stage')) +
              ' | BILL rodent mesh TBD.rodentMesh ' + (aH * 1.10).toFixed(2) + ' m2, furring KVR50030 ' + (furL * 1.05).toFixed(1) + ' m on ' + nLines + ' joist lines + ' + nScr + ' x FAS60100, membrane INS00002, wool ' + WF.mix.map(function (mx) { return mx.n + ' x ' + mx.mm + ' ' + mx.code; }).join(' + ') + ' ' + (aB * 1.05).toFixed(2) + ' m2, vapour barrier ROV00001 ' + (aH * 1.10).toFixed(2) + ' m2 + tape INS01005');
    }
    /* THE SLAB'S SAWCUT JOINTS (aframe-v171; COPIED from the garage
       apartment's slab, garageapt 2c: "the concrete ... with sawcut control
       joints FFM00008 at 10 ft at the most", drawn "lines on the top at 10
       ft at the most": ceil(w / 10 ft) bays across, ceil(l / 10 ft) along,
       a line between each two, 6 wide on the top, in the cut's grey). The
       A's slab on strips (the house's, and a side wing's) had none: a 6 x 9
       slab with no joint cracks where it likes. Returns the metres. */
    var SLABJ = { step: 10 * 0.3048, code: 'FFM00008', iso: 'FFM00009', col: 0x6E6B66, w: 0.006, h: 0.002 };
    function _slabJoints(ctx, x0, x1, z0, z1, yTop, draw) {
      var T = ctx.THREE, g = ctx.group, w = x1 - x0, l = z1 - z0, q, m = 0;
      var jx = Math.max(1, Math.ceil(w / SLABJ.step - 1e-6)), jz = Math.max(1, Math.ceil(l / SLABJ.step - 1e-6));
      if (draw && (jx > 1 || jz > 1)) _am(ctx, 'slab_joints', 'Sawcut control joint', SLABJ.code, 'top');
      for (q = 1; q < jx; q++) { if (draw) _box(T, g, SLABJ.w, SLABJ.h, l - 0.01, x0 + w * q / jx, yTop + SLABJ.h / 2 + 0.0005, (z0 + z1) / 2, 0, SLABJ.col, 1); m += l; }
      for (q = 1; q < jz; q++) { if (draw) _box(T, g, w - 0.01, SLABJ.h, SLABJ.w, (x0 + x1) / 2, yTop + SLABJ.h / 2 + 0.0005, z0 + l * q / jz, 0, SLABJ.col, 1); m += w; }
      return { m: m, jx: jx, jz: jz, bx: w / jx, bz: l / jz };
    }
    function _buildBase(ctx) {
      _bill['aframe-base'] = {};
      var kinds = footingKinds(), fl = floors(), was = STATE.foundation;
      if (kinds.indexOf(STATE.foundation) < 0) { STATE.foundation = 'strips'; }
      ctx.log('base     rule: ' + fl.length + ' floor(s) -> ' + (kinds.length === 1 ? 'strips + slab only (screws, pads and piers locked)' : 'screws, pads, piers or strips allowed') +
              '; chosen ' + STATE.foundation + (was !== STATE.foundation ? (' (was ' + was + ', locked by the second floor)') : ''));
      ctx.log(_gfNote());
      if (STATE.foundation === 'strips') {
        _asmMark(ctx, 'grd_concrete', 'top', 'Footing', 'grd.concrete');
        var used = _deckY(), nKid0 = ctx.group.children.length;
        var rS = API.buildStripSlab(ctx, { layer: 'aframe-base', stripW: 0.40, footH: 0.25, slabT: 0.15, gravelT: 0.0005, minDepth: 0.80, out: 0.20, rect: _stripRect(), rebar: true });
        /* THE SLAB HIDDEN UNDER REVIEW (aframe-v129): the core draws strips and
           slab in one call; while a layer under the slab is reviewed the slab's
           bodies -- 150 deep, their top on the slab top -- and the bars inside
           it are taken off the stage again (billed as before); the strips stay */
        var rvSlab = _isRv('gfloor', _gfIdx('concrete slab'));
        if ((rvSlab || !_gfOn('concrete slab')) && rS && typeof rS.slabTop === 'number') {
          var kidsS = ctx.group.children.slice(nKid0), nOff = 0;
          kidsS.forEach(function (m) {
            if (!m || !m.isMesh || !m.geometry) return;
            m.geometry.computeBoundingBox(); var bb = m.geometry.boundingBox; if (!bb) return;
            var yT = m.position.y + bb.max.y, yB = m.position.y + bb.min.y;
            var inSlab = (yT <= rS.slabTop + 0.002) && (yB >= rS.slabTop - 0.152);
            var isSlab = inSlab && (m.userData.rebar || (Math.abs(yT - rS.slabTop) < 0.002 && (bb.max.x - bb.min.x) > 0.5 && (bb.max.z - bb.min.z) > 0.5));
            if (!isSlab) return;
            if (rvSlab) { if (!m.userData.rebar) { m.material = new ctx.THREE.MeshStandardMaterial({ color: MAGENTA, roughness: 0.9 }); } _rvTag(m); }
            else ctx.group.remove(m);
            nOff++;
          });
          ctx.log('gfloor   the slab and its mesh ' + (rvSlab ? 'UNDER REVIEW, in magenta (the bars in their own colour)' : 'taken off the stage for the review, billed as before') + ': ' + nOff + ' bod(ies)');
        }
        ctx.log('base     strips run 200 inside the base line, so their outer face, the slab edge and the plate\'s outer edge are one plane -- no concrete ledge outside the rafter feet (aframe-v13)');
        ctx.log('base     slab runs 200 past the footprint line, to the strips\' outer face (aframe-v11: it stopped on the strips\' centre line)');
        var top = (rS && typeof rS.slabTop === 'number') ? rS.slabTop : null;
        /* UNDER THE SLAB, BETWEEN THE STRIPS (aframe-v16, Marek: vrstva
           koliduje s pasy a glitchuje -- staci ji dat jen pod desku). The
           core drew its gravel bed under the whole slab, through the tops of
           the strip stems, and the two flickered where they overlapped. The
           core is now asked for no bed at all (gravelT 0.5 mm, which it does
           not draw) and this product lays the build-up itself, only inside
           the strips, bottom up: gravel bed 150 (grd.gravelSlab), EPS 150
           (INS01502), the 6 mil vapour barrier (ROV00001, laps taped
           INS01005), then the core's slab. The film is billed over the whole
           slab, since it runs over the strips' tops too, but drawn only
           inside, where it cannot share a face with the concrete. */
        if (top != null) {
          var TT = ctx.THREE, gU = ctx.group, BRi = _stripRect(), inW = (BRi.x1 - BRi.x0) - 0.40, inL = (BRi.z1 - BRi.z0) - 0.40;
          var mxU = (BRi.x0 + BRi.x1) / 2, mzU = (BRi.z0 + BRi.z1) / 2, slabBotU = top - 0.15;
          var UL = { film: 0.002, eps: 0.150, gravel: 0.150 };
          var yFilm = slabBotU - UL.film / 2, yEpsTop = slabBotU - UL.film, yEpsBot = yEpsTop - UL.eps, yGrBot = yEpsBot - UL.gravel;
          var layerBox = function (h, yC, col, mark, tex, rvN) {
            if (!(inW > 0.05 && inL > 0.05)) return;
            if (mark) _asmMark(ctx, mark[0], 'top', mark[1], mark[2]);
            var rvB = _isRv('gfloor', rvN), mtx = (tex && !rvB) ? _layerTex(TT, tex) : null;
            var mU = new TT.Mesh(new TT.BoxGeometry(inW - 0.004, h, inL - 0.004),
              mtx ? new TT.MeshStandardMaterial({ map: mtx, roughness: 0.95 }) : new TT.MeshStandardMaterial({ color: rvB ? MAGENTA : col, roughness: 0.9 }));
            mU.position.set(mxU, yC, mzU); mU.userData.afNs = true; if (rvB) _rvTag(mU); gU.add(mU);
          };
          if (_gfOn('gravel bed')) layerBox(UL.gravel, (yEpsBot + yGrBot) / 2, 0xB8B0A2, ['grd_gravel', 'Gravel base', 'grd.gravelSlab'], 'stone', _gfIdx('gravel bed'));
          if (_gfOn('EPS')) layerBox(UL.eps, (yEpsTop + yEpsBot) / 2, 0xECECE4, ['layer_insulation', 'Insulation under the slab', 'INS01502'], 'eps', _gfIdx('EPS'));
          if (_gfOn('vapour barrier')) layerBox(UL.film, yFilm, 0x3E4A56, ['layer_vapour_barrier', 'Vapour barrier', 'ROV00001'], null, _gfIdx('vapour barrier'));
          var inA = Math.max(0, inW * inL), slabA = (BRi.x1 - BRi.x0 + 0.40) * (BRi.z1 - BRi.z0 + 0.40);
          var vbTape = Math.round((slabA / 1.5 + 2 * ((BRi.x1 - BRi.x0 + 0.40) + (BRi.z1 - BRi.z0 + 0.40))) * 10) / 10;
          API.billAdd('aframe-base', 'grd.gravelSlab', inA * UL.gravel);
          API.billAdd('aframe-base', 'INS01502', inA * 1.05);
          API.billAdd('aframe-base', 'ROV00001', slabA * 1.10);
          API.billAdd('aframe-base', 'INS01005', vbTape);
          if (yGrBot < 0) API.billAdd('aframe-base', 'grd.excavation', inA * (-yGrBot));
          ctx.log('base     under the slab, inside the strips ' + Math.round(inW * 1000) + ' x ' + Math.round(inL * 1000) + ': gravel ' + Math.round(UL.gravel * 1000) + ' grd.gravelSlab ' + (inA * UL.gravel).toFixed(2) + ' m3, EPS ' + Math.round(UL.eps * 1000) +
                  ' INS01502 ' + (inA * 1.05).toFixed(1) + ' m2 (+5%), vapour barrier ROV00001 ' + (slabA * 1.10).toFixed(1) + ' m2 over the whole slab (+10% laps), tape INS01005 ' + vbTape + ' m' +
                  '; bed from ' + Math.round(yGrBot * 1000) + ' to the slab underside ' + Math.round(slabBotU * 1000) + (yGrBot < 0 ? ('; dig ' + (inA * (-yGrBot)).toFixed(2) + ' m3') : ''));
          /* aframe-v171: the slab's sawcut joints (the garage apartment's 2c), on the slab as it is drawn */
          (function () {
            var J = _slabJoints(ctx, BRi.x0 - 0.20, BRi.x1 + 0.20, BRi.z0 - 0.20, BRi.z1 + 0.20, top, _gfOn('concrete slab') && !rvSlab);
            if (J.m > 0) API.billAdd('aframe-base', SLABJ.code, Math.round(J.m * 100) / 100);
            ctx.log('base     slab sawcut joints (aframe-v171, the garage apartment\'s): ' + (J.jx - 1) + ' line(s) along the ridge, ' + (J.jz - 1) + ' across it, bays ' + Math.round(J.bx * 1000) + ' x ' + Math.round(J.bz * 1000) + ' (10 ft at the most), ' + J.m.toFixed(2) + ' m ' + SLABJ.code +
                    (J.m > 0 ? '' : ' -- none needed') + '; no isolation joint here (no landing or apron is cast against the house: the entrance steps are a kit)');
          })();
          /* THE PERIMETER INSULATION (aframe-v131, plan B2): XPS 50 (INS00503, the
             porch's board, R-10 -- the IRC slab-edge figure) glued with low
             expansion foam outside the slab edge and the strip stem, from the
             slab top down to the footing's top, round the whole base line; over
             it above grade the plinth finish as on the ADU -- reinforcing base
             coat with glass mesh, primer, plinth render, a corner bead at each
             corner. Under grade the board is backfilled bare. */
          (function () {
            var BRp = _baseRect(), PX = { t: PERIM.t, fin: PERIM.fin }, ffP = true;
            try { ffP = (typeof __CORE._footFull === 'function') ? !!__CORE._footFull() : true; } catch (eF) { ffP = true; }
            var yFt = -Math.max(0.80, STATE.climateZone || 0) + 0.25, yTopP = top, yLoD = ffP ? yFt : 0;
            var wP = BRp.x1 - BRp.x0, lP = BRp.z1 - BRp.z0, perim = 2 * (wP + lP) + 4 * PX.t;
            /* UNDER A SIDE WING THE EAVE'S RUN IS LEFT OUT (aframe-v149, plan H): the wing's slab joins the house's
               there, inside; the wing's own XPS and plinth go round its three outer sides (aframe-wingbase) */
            var wgP = _wingSides().map(function (ws) { return { sd: ws, R: _wingRect(ws) }; }), wCutP = 0;
            wgP.forEach(function (W9) { wCutP += W9.R.l + 2 * PX.t; });
            perim -= wCutP;
            var aX = perim * (yTopP - yFt), aF = perim * Math.max(0, yTopP), hAbove = Math.max(0, yTopP);
            var rvX = _isRv('gfloor', _gfIdx('perimeter XPS')), rvF = _isRv('gfloor', _gfIdx('plinth finish'));
            var sideBox = function (t, off, y0, y1, col, rv, tex) {
              if (!(y1 - y0 > 0.002)) return 0;
              var mtx = (tex && !rv) ? _layerTex(TT, tex) : null, n = 0;
              var mk = function (w, d, x, z) {
                var m = new TT.Mesh(new TT.BoxGeometry(w, y1 - y0, d), mtx ? new TT.MeshStandardMaterial({ map: mtx, roughness: 0.95 }) : new TT.MeshStandardMaterial({ color: rv ? MAGENTA : col, roughness: 0.9 }));
                m.position.set(x, (y0 + y1) / 2, z); m.userData.afNs = true; if (rv) _rvTag(m); gU.add(m); n++;
              };
              var o0 = off, o1 = off + t, cxP = (BRp.x0 + BRp.x1) / 2, czP = (BRp.z0 + BRp.z1) / 2;
              var mkZ = function (sdZ, xC) {
                var rz = [[czP - lP / 2 - o1, czP + lP / 2 + o1]];
                wgP.forEach(function (W9) { if (W9.sd !== sdZ) return; var c0 = W9.R.z0 - o1, c1 = W9.R.z1 + o1, nx = []; rz.forEach(function (r) { if (c1 <= r[0] || c0 >= r[1]) { nx.push(r); return; } if (c0 > r[0]) nx.push([r[0], c0]); if (c1 < r[1]) nx.push([c1, r[1]]); }); rz = nx; });
                rz.forEach(function (r) { if (r[1] - r[0] > 0.01) mk(t, r[1] - r[0], xC, (r[0] + r[1]) / 2); });
              };
              mkZ(-1, BRp.x0 - o0 - t / 2); mkZ(1, BRp.x1 + o0 + t / 2);
              mk(wP + 2 * o0, t, cxP, BRp.z0 - o0 - t / 2); mk(wP + 2 * o0, t, cxP, BRp.z1 + o0 + t / 2);
              return n;
            };
            if (_gfOn('perimeter XPS')) { _asmMark(ctx, 'layer_insulation', 'side', 'Slab edge insulation', 'INS00503'); sideBox(PX.t, 0, yLoD, yTopP, 0xC6D8E8, rvX, null); }
            if (_gfOn('plinth finish') && hAbove > 0.01) { _asmMark(ctx, 'layer_render', 'side', 'Plinth render', 'FCP00002'); sideBox(PX.fin, PX.t, 0, yTopP, 0x8E8A82, rvF, null); }
            API.billAdd('aframe-base', 'INS00503', Math.round(aX * 1.05 * 100) / 100);
            API.billAdd('aframe-base', 'FCP00005', Math.max(1, Math.ceil(aX * 0.10)));
            if (aF > 0.01) {
              API.billAdd('aframe-base', 'FFR00051', Math.round(aF * 1.05 * 100) / 100);
              API.billAdd('aframe-base', 'GTM00001', Math.round(aF * 1.10 * 100) / 100);
              API.billAdd('aframe-base', 'PEN00001', Math.round(aF * 1.05 * 100) / 100);
              API.billAdd('aframe-base', 'FCP00002', Math.round(aF * 1.05 * 100) / 100);
              API.billAdd('aframe-base', 'FCP00006', Math.round(4 * hAbove * 1.05 * 100) / 100);
            }
            if (wCutP > 0) ctx.log('gfloor   perimeter under the side wing(s) (aframe-v149): the eave\'s run left out over ' + wCutP.toFixed(2) + ' m -- the wing\'s slab joins the house\'s there; its own XPS and plinth round its outer sides (wingbase)');
            ctx.log('gfloor   perimeter: XPS ' + Math.round(PX.t * 1000) + ' INS00503 outside the slab edge and the stem, ' + Math.round(yFt * 1000) + ' (the footing top) to the slab top ' + Math.round(yTopP * 1000) + ', ' + perim.toFixed(2) + ' m round, ' + (aX * 1.05).toFixed(2) + ' m2 (+5%), foam FCP00005 ' + Math.max(1, Math.ceil(aX * 0.10)) + ' pcs' +
                    (aF > 0.01 ? ('; plinth above grade ' + Math.round(hAbove * 1000) + ' high: base coat FFR00051 ' + (aF * 1.05).toFixed(2) + ' m2, mesh GTM00001 ' + (aF * 1.10).toFixed(2) + ' m2 (+10% laps), primer PEN00001 and plinth render FCP00002 ' + (aF * 1.05).toFixed(2) + ' m2, corner bead FCP00006 ' + (4 * hAbove * 1.05).toFixed(2) + ' m') : '; the slab top is at grade, no plinth finish') +
                    (ffP ? '' : ' (below grade drawn on the Roof & Base step only)'));
          })();
        }
        ctx.log('base     slab top ' + (top == null ? '? (the core did not say)' : Math.round(top * 1000)) + ', STACK.slab ' + Math.round(((__CORE.STACK && __CORE.STACK.slab) || 0) * 1000) +
                ', this build set the plate and the rafters on ' + Math.round(used * 1000) + (top != null && Math.abs(top - used) > 0.001 ? ' -- MISMATCH, built again on the slab top' : ' OK'));
        if (top != null) {
          var diff = (_slabTopSeen == null) ? Math.abs(top - used) : Math.abs(top - _slabTopSeen);
          _slabTopSeen = top;
          if (diff > 0.001 && !_slabRebuilt) {
            _slabRebuilt = true;
            _loadTrace.push('load     the slab came out at ' + Math.round(top * 1000) + ', the build stood on ' + Math.round(used * 1000) + ' -- built AGAIN at +' + (Date.now() - _loadT0) + ' ms (the first build is shown for a frame: a flash)');
            setTimeout(function () { try { __PROD.beforeBuild(); API.rebuild(); } catch (eRb) {} _slabRebuilt = false; }, 0);
          }
        }
        return;
      }
      if (typeof API.pointBase !== 'function') { ctx.log('base     none -- the core is ' + (__CORE.CORE_VERSION || '?') + ', point footings need core-v467: upload configurator-ui.js'); return; }
      /* SCREWS, PADS OR PIERS WITH THE TIMBER FLOOR ON THEM, from the shared
         drawer (aframe-v6, A3; the drawer is the ADU's, copied into the core).
         The deck is the ground floor, 350 above grade; the rafters' feet land
         on it, so the whole A comes down with the floor. */
      /* ONE FRAME UNDER THE HOUSE AND ITS PORCHES (aframe-v119, Marek: pokud je
         zalozeni vruty / piers / patky, maji byt krokve zalozene na tomto
         systemu cele -- ram je jednotny i pro terasu). The floor frame runs on
         out under a covered porch to the porch rafters' end, on the same
         footings in the same grid; over the porch it carries no OSB but the
         decking (a strip of OSB stays along each rim, under the plates), so the
         whole eave side stands on one system (core-v528 open zones). */
      var BRb = _baseRect(), RGb = _rafGrid(), Rb = _rafSize(), PFb = _plateFit(), rectB = { x0: BRb.x0, x1: BRb.x1, z0: BRb.z0, z1: BRb.z1 }, openB = [];
      if (RGb.porch && RGb.porch[0]) { var zE0 = RGb.z0 - Rb.t / 2; openB.push({ z0: zE0, z1: BRb.z0, keep: PFb.w }); rectB.z0 = zE0; }
      if (RGb.porch && RGb.porch[1]) { var zE1 = RGb.z1 + Rb.t / 2; openB.push({ z0: BRb.z1, z1: zE1, keep: PFb.w }); rectB.z1 = zE1; }
      var nPB0 = ctx.group.children.length;
      API.pointBase(ctx, { layer: 'aframe-base', kind: STATE.foundation, deckTop: _deckY(), rect: rectB, open: openB,
                           joist: { t: 0.060, d: 0.240, code: 'KVH60240' }, deckT: 0.018, spacing: 1.83, wood: WOOD });
      try { _timberFloorLayers(ctx, nPB0, rectB, BRb); } catch (eTF) { ctx.log('gfloor   ERROR the timber floor\'s layers: ' + ((eTF && eTF.message) || eTF)); }
      if (openB.length) ctx.log('base     one frame under the house and ' + openB.length + ' porch(es): ' + Math.round((rectB.z1 - rectB.z0) * 1000) + ' along on ' + STATE.foundation + ', the porch part decked over the joists (needs core-v528: ' + (__CORE.CORE_VERSION || '?') + ')');
    }
    /* -------------------------------------------------------------------------
       OVERHEAD -- WHAT THE BUILDING COSTS BESIDE ITS MATERIALS (aframe-v135,
       copied from the ADU, as RANCH, BARNDO and the THOW have it). One lump sum
       each: a jurisdiction charges for a permit whatever the cabin measures.
       The ADU's list word for word -- survey and documents, zoning, permits and
       fees, utility connection and trenching, temporary utilities and site
       protection, plant and delivery, fuel, insurance, inspections and testing,
       sales tax, contingency, waste and handover. Left out as in the ADU: on-site
       water and wastewater, site facilities and security, bonds, contractor
       markup, project administration and financing. Registered FIRST and not
       through _regLayer: it draws nothing, so the plan's spare group and the
       review have nothing to do with it, and a plan on screen still prices it.
       ------------------------------------------------------------------------- */
    var OVERHEAD = [
      'OVH01001', 'OVH01002',
      'OVH02001', 'OVH02002', 'OVH02003',
      'OVH03001', 'OVH03003',
      'OVH04001', 'OVH04003',
      'OVH05001', 'OVH05002', 'OVH05003',
      'OVH06001',
      'OVH07001', 'OVH07002',
      'OVH08004', 'OVH08005',
      'OVH10001', 'OVH10002'
    ];
    function _buildOverhead(ctx) {
      var q;
      _bill['aframe-overhead'] = {};
      for (q = 0; q < OVERHEAD.length; q++) API.billAdd('aframe-overhead', OVERHEAD[q], 1);
      ctx.log('ovh      ' + OVERHEAD.length + ' lump sum(s), 1 ls each: ' + OVERHEAD.join(' ') + ' -- survey, permits and fees, utility connection, site setup, plant and delivery, insurance, inspections, sales tax, contingency, waste and handover (the ADU list)');
    }
    API.registerLayer({
      id: 'aframe-overhead', version: VERSION, role: 'rezie', claims: [],
      build3d: _buildOverhead, boq: function () { return _rows('aframe-overhead'); }
    });
    /* THE WAY IN OFF THE GROUND (aframe-v170; COPIED from the RANCH's base,
       ranch-lib: "the floor stands ... above grade, so every exterior door
       needs steps -- a flight at each, risers no more than 190 and treads
       280, the whole flight one catalogue piece (SES28011). Drawn as its
       steps so the model shows how you get in (Marek)"; and "NO STEPS WHERE
       THE TERRACE IS ... the deck is laid a step under the floor"). The A's
       ground floor stands 300 over grade on strips (more on point footings)
       and its front door had nothing in front of it. ADAPTED: the A's doors
       are in its gables and a side wing's walls (the ground floor's plan,
       _mepSegs(0)); a gable with a porch (the roof pulled out past 600, its
       deck a step under the floor) takes none; the flight starts at the
       facade's face (_facT); a fixed glazing to the floor is no door. */
    var ENTRY = { code: 'SES28011', rise: 0.190, tread: 0.280, minRise: 0.20, col: 0x9A9A96 };
    function _entranceSteps(ctx) {
      var T = ctx.THREE, g = ctx.group, fl = floors(), riseTop = fl[0].y + FIT.lift, flights = 0, said = [];
      if (!(riseTop > ENTRY.minRise)) { ctx.log('base     entrance steps: none -- the floor is within a step of the ground (' + Math.round(riseTop * 1000) + ')'); return; }
      var SG = _mepSegs(0), B = _barRect(), cx = (B.x0 + B.x1) / 2, cz = (B.z0 + B.z1) / 2, q, j, fT = _facT();
      var nStep = Math.max(1, Math.ceil(riseTop / ENTRY.rise - 1e-6)), rise = riseTop / nStep;
      for (q = 0; q < SG.length; q++) {
        var sg = SG[q], ux = (sg.x1 - sg.x0) / sg.len, uz = (sg.z1 - sg.z0) / sg.len;
        for (j = 0; j < sg.openings.length; j++) {
          var op = sg.openings[j];
          if ((op.sill || 0) > 0.05) continue;                                   /* a window */
          if (op.kind !== 'door' && op.kind !== 'french') continue;              /* a fixed glazing to the floor is no door */
          var dx = sg.x0 + ux * op.at, dz = sg.z0 + uz * op.at, nx = -uz, nz = ux;
          if ((dx - cx) * nx + (dz - cz) * nz < 0) { nx = -nx; nz = -nz; }        /* outward from the wall */
          var e = (Math.abs(dz - B.z0) < 0.05) ? 0 : ((Math.abs(dz - B.z1) < 0.05) ? 1 : -1);
          if (e >= 0 && _porch(e)) { said.push('none at the ' + (e ? 'back' : 'front') + ' gable\'s ' + op.kind + ' -- the porch is there, its deck a step under the floor'); continue; }
          var wStep = Math.max(0.90, (op.w || 0.9) + 0.20), k;
          _am(ctx, 'entrance_steps', 'Entrance steps', ENTRY.code, 'top');
          for (k = 0; k < nStep; k++) {
            var outAt = fT + 0.02 + (nStep - 1 - k) * ENTRY.tread + ENTRY.tread / 2, yTop = rise * (k + 1), sx = dx + nx * outAt, sz = dz + nz * outAt;
            if (Math.abs(ux) > Math.abs(uz)) _box(T, g, wStep, yTop, ENTRY.tread, sx, yTop / 2, sz, 0, ENTRY.col, 1);
            else _box(T, g, ENTRY.tread, yTop, wStep, sx, yTop / 2, sz, 0, ENTRY.col, 1);
          }
          API.billAdd('aframe-base', ENTRY.code, 1);
          flights++;
          said.push((e === 0 ? 'the front gable' : (e === 1 ? 'the back gable' : ('the wall ' + (sg.tag || sg.id)))) + '\'s ' + op.kind + ' ' + Math.round((op.w || 0) * 1000) + ': ' + nStep + ' riser(s) of ' + Math.round(rise * 1000) + ', ' + Math.round(wStep * 1000) + ' wide, out ' + Math.round((fT + 0.02 + nStep * ENTRY.tread) * 1000) + ' from the frame');
        }
      }
      ctx.log('base     entrance steps (aframe-v170, the RANCH\'s): ' + (flights ? (flights + ' flight(s) ' + ENTRY.code + ', the floor ' + Math.round(riseTop * 1000) + ' above grade -- ') : 'none -- ') + (said.length ? said.join('; ') : 'no exterior door on the ground floor'));
    }
    _regLayer({
      id: 'aframe-base', version: VERSION, role: 'zaklady', claims: ['base'],
      build3d: function (ctx) {
        _buildBase(ctx);
        try { _entranceSteps(ctx); } catch (eES) { ctx.log('base     entrance steps THREW ' + ((eES && eES.message) || eES)); }
      },
      boq: function () { return _rows('aframe-base'); }
    });

    /* -------------------------------------------------------------------------
       THE GABLES. Two triangles, the short walls of the A, drawn as masses
       for now -- the timber frame with its glazing is a later step. The
       triangle is the roof's own outline at each end: plinth line at the
       eaves, ridge on top, the rafter's depth inside the roof plane.
       ------------------------------------------------------------------------- */
    /* THE LEAVES THAT OPEN IN THE WALK-THROUGH (aframe-v161, plan P7; COPIED
       from the ADU, adu-v1431 _arSwing / _arSlide, Marek: muzou se automaticky
       otevirat dvere? I HS portaly? Pri prochazeni). The AR export (core-v629)
       keeps a mesh carrying userData.arLeaf as a node of its own, so the walk
       page can open it when someone comes near; meshes sharing one arLeaf move
       as one (a leaf, its frame, its pull). The leaf is drawn exactly where it
       was. Everything in the coordinates of the group the leaf is added to.
       Swing: hinge (x, z); c the way from the hinge to the far edge with the
       leaf shut; s the side it swings onto. A turn about +Y by a positive
       angle carries c towards (c.z, -c.x), so that is the sign that opens.
       Slide: (ux, uz) the way it opens, at how far it is drawn open, travel
       fully open; (shx, shz) a step aside before it runs */
    var _arTally = { swing: 0, slide: 0, where: {} };
    function _arCount(kind, where) { _arTally[kind]++; _arTally.where[where] = (_arTally.where[where] || 0) + 1; }
    function _arSwing(m, hx, hz, cx, cz, sx, sz, ajar, ext, ox, oz) {
      if (!m) return null;
      var L = { type: 'swing', hinge: [hx, 0, hz], dir: ((sx * cz - sz * cx) >= 0) ? 1 : -1, ajar: ajar || 0, max: 1.45 };
      if (ext) { L.ext = true; L.out = [ox, 0, oz]; }
      m.userData.arLeaf = L;
      return L;
    }
    function _arSlide(m, ux, uz, at, travel, shx, shz, ext, ox, oz) {
      if (!m) return null;
      var L = { type: 'slide', dir: [ux, 0, uz], at: at || 0, travel: travel || 0 };
      if (shx || shz) L.shift = [shx || 0, 0, shz || 0];
      if (ext) { L.ext = true; L.out = [ox, 0, oz]; }
      m.userData.arLeaf = L;
      return L;
    }
    /* ONE UNIT IN A GABLE, drawn the way the core draws its own (core-v377):
       a frame of four boards, the glass in leaves -- or a door leaf -- and a
       sill board on each face of a window, a threshold under a door. x is its
       centre across the A, yB the underside of its frame, z the middle of the
       wall, out the side the outside is on (-1 front, +1 back). */
    function _drawUnit(T, g, o, x, yB, z, out) {
      var fr = 0.060, fd = 0.068, w = Math.max(0.2, (o.w || 0.9) - 0.020), h = Math.max(0.2, (o.h || 1.2) - 0.020), y0 = yB + 0.010;
      var door = (o.kind === 'door' || o.kind === 'garage'), floor = (o.kind === 'door' || o.kind === 'french' || o.kind === 'garage');
      var col = DOOR.col, mk = function (bw, bh, bd, bx, by, bz, c, op) { return _box(T, g, bw, bh, bd, bx, by, bz, 0, c, op == null ? 1 : op); };
      mk(w, fr, fd, x, y0 + h - fr / 2, z, col);
      if (!floor) mk(w, fr, fd, x, y0 + fr / 2, z, col);
      mk(fr, h, fd, x - w / 2 + fr / 2, y0 + h / 2, z, col);
      mk(fr, h, fd, x + w / 2 - fr / 2, y0 + h / 2, z, col);
      var ib = floor ? 0.012 : fr, ih = h - fr - ib, iw = w - 2 * fr;
      if (door) {
        var mLf = mk(iw - 0.004, ih - 0.004, 0.052, x, y0 + ib + ih / 2, z + out * 0.008, DOOR.leaf);
        var hx = (o.hand === 'R') ? (x + iw / 2 - 0.10) : (x - iw / 2 + 0.10);
        var mHd = mk(0.14, 0.02, 0.05, hx, y0 + 1.05, z + out * 0.045, 0xB9BCBF);
        /* the leaf swings into the room on the edge away from the handle (aframe-v161) */
        var hgX = (o.hand === 'R') ? (x - iw / 2) : (x + iw / 2), cXd = (o.hand === 'R') ? iw : -iw;
        var Ld = _arSwing(mLf, hgX, z + out * 0.008, cXd, 0, 0, -out, 0, true, 0, out);
        if (Ld) { mHd.userData.arLeaf = Ld; _arCount('swing', 'door'); }
      } else {
        var leaves = Math.max(1, o.leaves || Math.round(iw / 0.9)), q, gw = iw / leaves;
        for (q = 0; q < leaves; q++) {
          var off = -iw / 2 + gw * (q + 0.5);
          var mGl = mk(gw - 0.03, ih - 0.03, 0.012, x + off, y0 + ib + ih / 2, z, 0x9FC4D6, 0.45);
          if (q) mk(0.05, ih, fd, x + off - gw / 2, y0 + ib + ih / 2, z, col);
          /* a French door's leaves swing in, each on its outer edge (aframe-v161); a window's sashes stay */
          if (o.kind === 'french') {
            var lft = (q < leaves / 2), hgF = lft ? (x + off - gw / 2) : (x + off + gw / 2);
            if (_arSwing(mGl, hgF, z, lft ? gw : -gw, 0, 0, -out, 0, true, 0, out)) _arCount('swing', 'french');
          }
        }
      }
      if (floor) mk(w + 0.04, 0.02, GABLE.d, x, yB + 0.01, z, 0xBDB7A9);
      else {
        /* the outer sill out past the boards by 30 and under the trim's legs (aframe-v162) */
        var sOD = GABLE.d / 2 + _facT() + 0.03;
        mk(w + 0.22, 0.03, sOD, x, yB - 0.015, z + out * (sOD / 2), 0xE6E3DC);
        mk(w + 0.10, 0.03, GABLE.d / 2 + 0.05, x, yB - 0.015, z - out * (GABLE.d / 4 + 0.025), 0xEFEDE7);
      }
      return { floor: floor, w: w, h: h };
    }
    /* THE GABLES (aframe-v7 frame, aframe-v18 raked studs, aframe-v24 the
       core's openings in them). Studs every 600 from the ridge line, cut to
       the rake; round every unit the core placed in the gable the frame the
       whole line builds -- jacks and kings, a doubled header, a doubled sill
       under a window -- worked out by the core's own planner (wallLayout
       framePlan / studPieces) with the rake as the top of the wall. A full or
       half wall unit is the triangle (FIXF0001) or the band at its top
       (FIXH0001), drawn and billed here, with no stud inside the glass. */

    /* THE BALCONY OFF THE SECOND FLOOR (aframe-v58). Outside the gable, in
       front of the door in the full glazing: 1200 deep, 2400 wide (narrower
       where the glass is), its deck a step (20) under the floor. The DIY
       build, the ADU terrace's rows: a ledger 60 x 160 screwed through the
       facade into the gable's floor zone (FAS80200 every 400), joists
       60 x 160 every 500 on hangers (FAT00011) to a doubled rim beam on two
       posts 100 x 100 (KVH10100) standing on precast pads (FCO00009) in U
       post bases (FCO00004); decking TST00002 screwed 2 a joist (FAS55050);
       the rail SIS00001 on its three open sides. Magenta while under review. */
    var BALC = { d: 1.20, w: 2.40, step: 0.020, joist: 'KVH60160', jT: 0.060, jD: 0.160, jSp: 0.50,
                 board: 'TST00002', bT: 0.025, bW: 0.145, gap: 0.006, post: 'KVH10100', pS: 0.100, rail: 'SIS00001', railH: 1.00 };
    var BALC_REVIEW = false;
    function _balcony(ctx, T, g, yFloor, zOut, out, side, RU, e) {
      var col = BALC_REVIEW ? MAGENTA : WOOD, colB = BALC_REVIEW ? MAGENTA : 0xB68A5A;
      var face = zOut + out * 0.010;          /* the full glazing carries no facade build-up (aframe-v63) */
      var W = Math.min(BALC.w, 2 * Math.max(0.9, RU.b)), cx = RU.cx, yTop = yFloor - BALC.step, yJ = yTop - BALC.bT - BALC.jD / 2, Dp = BALC.d, under = false;
      /* UNDER A PORCH ROOF THE BALCONY GOES THE WHOLE WIDTH (aframe-v63, Marek:
         pokud bude vytazena strecha, tak bude balkon pres celou sirku): as wide
         as the roof leaves 1000 of rail height under the rafters, as deep as the
         porch less 100 */
      if (e != null && _porch(e)) {
        var S5 = _sect(), yRail = yTop + BALC.railH;
        W = Math.max(W, S5.widthAt(yRail) - 0.20); Dp = Math.max(BALC.d, _rakeOf(e) - 0.10); under = true;
      }
      var zA = face, zB = face + out * Dp, zm = (zA + zB) / 2;
      var bx = function (w, h, d, x, y, z2, c) { _box(T, g, w, h, d, x, y, z2, 0, c, 1); };
      if (under && e != null && _balcOnTies(e)) {
        /* ON THE PORCH TIES: no ledger, no joists, no posts -- the decking runs
           out from the glass across the ties (every rafter pair), between the
           rafters as wide as the roof leaves at the deck; the rail across the
           whole width of the roof at the porch's end, the slopes are its sides */
        var S6 = _sect(), Wd = Math.max(0.6, S6.widthAt(yTop) - 0.10), Wr = Math.max(0.6, S6.widthAt(yTop + BALC.railH) - 0.04);
        var DpT = Math.max(BALC.d, _rakeOf(e) - 0.05), zBT = face + out * DpT;
        /* JOISTS ON THE TIES (aframe-v79, Marek: klestiny po 600 jsou na prkno
           25 moc -- podelne tramky): 60 x 160 every 500 across the width,
           running out from the glass over the ties; the boards across them */
        var nJt = Math.max(2, Math.ceil(Wd / BALC.jSp) + 1), jq, yJt = yTop - BALC.bT - BALC.jD / 2;
        _am(ctx, 'balcony_frame', 'Balcony frame', BALC.joist, 'side'); for (jq = 0; jq < nJt; jq++) bx(BALC.jT, BALC.jD, DpT, cx - Wd / 2 + BALC.jT / 2 + jq * (Wd - BALC.jT) / (nJt - 1), yJt, (zA + zBT) / 2, col);
        var nBd = Math.floor(DpT / (BALC.bW + BALC.gap)), k2;
        _am(ctx, 'decking', 'Decking', BALC.board, 'side'); for (k2 = 0; k2 < nBd; k2++) bx(Wd, BALC.bT, BALC.bW, cx, yTop - BALC.bT / 2, zA + out * (BALC.bW / 2 + k2 * (BALC.bW + BALC.gap)), colB);
        var nTc = Math.max(2, Math.round(DpT / 0.60) + 1);
        _am(ctx, 'balcony_rail', 'Railing', BALC.rail, 'side'); bx(Wr, 0.05, 0.05, cx, yTop + BALC.railH, zBT - out * 0.025, col);
        var nRp = Math.ceil(Wr / 1.2) + 1, k3;
        for (k3 = 0; k3 < nRp; k3++) bx(0.04, BALC.railH, 0.04, cx - Wr / 2 + 0.02 + k3 * (Wr - 0.04) / (nRp - 1), yTop + BALC.railH / 2, zBT - out * 0.025, col);
        var aT = Wd * DpT;
        API.billAdd('aframe-balcony', BALC.joist, nJt * DpT * 1.05);
        API.billAdd('aframe-balcony', 'FAS60100', nJt * nTc * 2);
        API.billAdd('aframe-balcony', BALC.board, aT * 1.05);
        API.billAdd('aframe-balcony', 'FAS55050', nBd * nJt * 2);
        API.billAdd('aframe-balcony', BALC.rail, Wr);
        ctx.log('balcony  ' + side + ' gable, floor 2, ON THE PORCH TIES: ' + nJt + ' joist(s) ' + BALC.joist + ' every ' + Math.round(BALC.jSp * 1000) + ' out from the glass over the ties, decking ' + BALC.board + ' ' + Math.round(Wd * 1000) + ' x ' + Math.round(DpT * 1000) + ' (' + nBd + ' board(s) across the joists), top ' + Math.round(yTop * 1000) + '; no ledger, no posts; rail ' + BALC.rail + ' across the whole roof ' + Math.round(Wr * 1000) + ' at the porch end, no side rails (the slopes)');
        ctx.log('balcony  BILL joists ' + BALC.joist + ' ' + (nJt * DpT * 1.05).toFixed(1) + ' m, ' + (nJt * nTc * 2) + ' x FAS60100 (2 a joist a tie); decking ' + BALC.board + ' ' + (aT * 1.05).toFixed(2) + ' m2 (+5%), ' + (nBd * nJt * 2) + ' x FAS55050 (2 a board a joist); rail ' + BALC.rail + ' ' + Wr.toFixed(2) + ' m; the ties are the porch\'s (billed with the frame)');
        return;
      }
      /* ledger on the facade, rim beam doubled at the outer edge */
      _am(ctx, 'balcony_frame', 'Balcony frame', BALC.joist, 'side'); bx(W, BALC.jD, BALC.jT, cx, yJ, zA + out * BALC.jT / 2, col);
      bx(W, BALC.jD, BALC.jT, cx, yJ, zB - out * BALC.jT / 2, col);
      bx(W, BALC.jD, BALC.jT, cx, yJ, zB - out * 1.5 * BALC.jT, col);
      var nJ = Math.max(2, Math.ceil(W / BALC.jSp) + 1), k, jLen = Dp - 3 * BALC.jT;
      for (k = 0; k < nJ; k++) { var xj = cx - W / 2 + BALC.jT / 2 + k * (W - BALC.jT) / (nJ - 1); bx(BALC.jT, BALC.jD, jLen, xj, yJ, zA + out * (BALC.jT + jLen / 2), col); }
      /* decking along the facade */
      var nB = Math.floor(Dp / (BALC.bW + BALC.gap));
      _am(ctx, 'decking', 'Decking', BALC.board, 'side'); for (k = 0; k < nB; k++) bx(W, BALC.bT, BALC.bW, cx, yTop - BALC.bT / 2, zA + out * (BALC.bW / 2 + k * (BALC.bW + BALC.gap)), colB);
      /* two posts under the outer corners, on pads */
      var yPostTop = yJ - BALC.jD / 2, sp;
      /* ON GROUND SCREWS (aframe-v79, Marek: balkon bez terasy na vruty) */
      for (sp = -1; sp <= 1; sp += 2) {
        var xp = cx + sp * (W / 2 - BALC.pS / 2), zp = zB - out * BALC.pS / 2;
        _am(ctx, 'balcony_posts', 'Posts', BALC.post, 'top'); bx(BALC.pS, yPostTop - 0.108, BALC.pS, xp, (yPostTop + 0.108) / 2, zp, col);
        _am(ctx, 'base_screws', 'Ground screws', 'steel.screwPile', 'top');
        if (typeof API.screwPile === 'function') API.screwPile(ctx, xp, zp, 0.10, {}); else bx(0.102, 0.10, 0.102, xp, 0.05, zp, 0x6E7275);
        bx(0.14, 0.008, 0.14, xp, 0.104, zp, 0x6E7275);
      }
      /* the rail on the three open sides */
      var rl = W + 2 * Dp;
      _am(ctx, 'balcony_rail', 'Railing', BALC.rail, 'side'); bx(W, 0.05, 0.05, cx, yTop + BALC.railH, zB - out * 0.025, col);
      for (sp = -1; sp <= 1; sp += 2) bx(0.05, 0.05, Dp, cx + sp * (W / 2 - 0.025), yTop + BALC.railH, zm, col);
      for (k = 0; k < Math.ceil(W / 1.2) + 1; k++) bx(0.04, BALC.railH, 0.04, cx - W / 2 + 0.02 + k * (W - 0.04) / Math.ceil(W / 1.2), yTop + BALC.railH / 2, zB - out * 0.025, col);
      var postL = 2 * (yPostTop - 0.108), jM = 3 * W + nJ * jLen, aD = W * Dp;
      API.billAdd('aframe-balcony', BALC.joist, jM * 1.05);
      API.billAdd('aframe-balcony', BALC.board, aD * 1.05);
      API.billAdd('aframe-balcony', 'FAS55050', nB * nJ * 2);
      API.billAdd('aframe-balcony', 'FAT00011', nJ * 2);
      API.billAdd('aframe-balcony', 'FAS80200', Math.ceil(W / 0.40) + 1);
      API.billAdd('aframe-balcony', 'FAS60100', 2 * Math.ceil(W / 0.40) + 4);
      API.billAdd('aframe-balcony', BALC.post, postL);
      API.billAdd('aframe-balcony', 'steel.screwPile', 2);
      API.billAdd('aframe-balcony', 'steel.saddle', 2);
      API.billAdd('aframe-balcony', BALC.rail, rl);
      ctx.log('balcony  ' + side + ' gable, floor 2: ' + Math.round(W * 1000) + ' x ' + Math.round(Dp * 1000) + (under ? ' (under the porch roof: the whole width it leaves, the porch deep)' : '') + ', deck top ' + Math.round(yTop * 1000) + ' (a step under the floor)' + (BALC_REVIEW ? ' -- MAGENTA, under review' : ''));
      ctx.log('balcony  BILL ' + BALC.joist + ' ' + (jM * 1.05).toFixed(1) + ' m (ledger, doubled rim, ' + nJ + ' joists at ' + Math.round(BALC.jSp * 1000) + '); decking ' + BALC.board + ' ' + (aD * 1.05).toFixed(2) + ' m2, ' + (nB * nJ * 2) + ' x FAS55050; ' + (nJ * 2) + ' x FAT00011 hangers; ledger ' + (Math.ceil(W / 0.40) + 1) + ' x FAS80200 every 400; rim ' + (2 * Math.ceil(W / 0.40) + 4) + ' x FAS60100; posts ' + BALC.post + ' ' + postL.toFixed(2) + ' m on 2 ground screws FGR00004 with U heads FGR00002; rail ' + BALC.rail + ' ' + rl.toFixed(2) + ' m');
    }
    /* the doors the full glazing takes, the core catalogue's own (aframe-v63) */
    var GLZ_DOORS = {
      ground: [{ code: 'OWR20001', w: 2.00, h: 2.59, leaves: 2, name: 'HS sliding door' },
               { code: 'OWR15002', w: 1.50, h: 2.59, leaves: 2, name: 'HS sliding door' }],
      upper: { code: 'OWR10001', w: 1.00, h: 2.59, leaves: 1, name: 'French door' }
    };
    /* A DOOR IN THE GLAZING IS NO TALLER THAN ITS STOREY (aframe-v92, Marek:
       dvere v druhem patre zasahuji do tretiho patra): under a floor above,
       the door's head with its 60 transom stays under that floor's joists;
       the catalogue door is 2590 high, in the curtain wall it is made to the
       storey. Under the rake alone (the top storey) it keeps its height.
       Under 1980 there is no door. */
    function _glzDoorFit(D, yF, st) {
      var fl = floors(), H = D.h;
      if (st + 1 < fl.length) H = Math.min(D.h, fl[st + 1].y - FLOOR.deck.t - FLOOR.joist.d - yF - 0.060);
      H = Math.floor(H * 100 + 1e-6) / 100;
      if (H < 1.98) return null;
      var o = {}, k; for (k in D) if (D.hasOwnProperty(k)) o[k] = D[k];
      o.h = H; o.cat = D.h; return o;
    }
    function _glazeVar(rk) { return _glzVarOf(rk); }
    /* THE BALCONY ON THE PORCH TIES (aframe-v72, Marek: pokud je strecha
       vytazena, balkon lezi na klestinach, bez podper, zabradli pres celou
       sirku strechy, na klestinach skladba podlahy balkonu): a porch in front
       of a full glazing set with the balcony, on a house of two floors or
       more, has its ties set at floor 2 so the balcony's decking lies on them */
    function _balcOnTies(e) {
      if (!_porch(e) || floors().length < 2 || !_gableFull(e)) return false;
      var GS = _gableSegs(), B = _barRect(), zO = e ? B.z1 : B.z0, q, sg = null;
      for (q = 0; q < GS.length; q++) if (Math.abs(GS[q].z0 - zO) < 0.01) sg = GS[q];
      var ops = sg ? (sg.openings || []) : [];
      for (q = 0; q < ops.length; q++) if (ops[q].rake || ops[q].fullW || ops[q].halfW) return _glzVarOf(ops[q]) === 'balcony';
      return false;
    }
    /* the height of a porch's ties (their middle): at head height, or under the balcony's decking at floor 2 */
    function _tieMidY(e, yDeck) {
      if (_balcOnTies(e)) return floors()[1].y - BALC.step - BALC.bT - BALC.jD - 0.160 / 2;
      return yDeck + PORCH_TIE;
    }
    /* is the gable (0 front, 1 back) fully glazed */
    function _gableFull(e) {
      var GS = _gableSegs(), B = _barRect(), zO = e ? B.z1 : B.z0, q, sg = null;
      for (q = 0; q < GS.length; q++) if (Math.abs(GS[q].z0 - zO) < 0.01) sg = GS[q];
      var ops = sg ? (sg.openings || []) : [];
      for (q = 0; q < ops.length; q++) if (ops[q].rake || ops[q].fullW || ops[q].halfW) return !!GLZ_FULL[_glzVarOf(ops[q])];
      return false;
    }
    var _glzTileSaid = 0;
    /* a glazed door: frame, glass leaves with their meeting stile, a pull */
    function _glassDoor(T, g, x, yB, D, z, out) {
      var fr = 0.060, fd = 0.070, w = D.w - 0.010, h = D.h - 0.010, y0 = yB + 0.005, col = GLAZE.frame, i;
      var mk = function (bw, bh, bd, bx, by, bz, c, op) { return _box(T, g, bw, bh, bd, bx, by, bz, 0, c, op == null ? 1 : op); };
      mk(w, fr, fd, x, y0 + h - fr / 2, z, col);
      mk(w, 0.020, fd, x, y0 + 0.010, z, 0x6E7275);
      mk(fr, h, fd, x - w / 2 + fr / 2, y0 + h / 2, z, col);
      mk(fr, h, fd, x + w / 2 - fr / 2, y0 + h / 2, z, col);
      var lw = (w - 2 * fr) / D.leaves, slideD = (D.leaves >= 2) || /HS|slid/i.test(D.name || '');
      for (i = 0; i < D.leaves; i++) {
        var lx = x - w / 2 + fr + lw * (i + 0.5), zo = z + out * ((i % 2) ? 0.012 : -0.012), pcs = [];
        pcs.push(mk(lw, 0.050, 0.050, lx, y0 + 0.045, zo, col));
        pcs.push(mk(lw, 0.050, 0.050, lx, y0 + h - fr - 0.025, zo, col));
        pcs.push(mk(0.050, h - fr - 0.07, 0.050, lx - lw / 2 + 0.025, y0 + (h - fr) / 2 + 0.035, zo, col));
        pcs.push(mk(0.050, h - fr - 0.07, 0.050, lx + lw / 2 - 0.025, y0 + (h - fr) / 2 + 0.035, zo, col));
        pcs.push(mk(lw - 0.10, h - fr - 0.12, 0.008, lx, y0 + (h - fr) / 2 + 0.035, zo, GLAZE.glass, 0.35));
        pcs.push(mk(0.020, 0.30, 0.030, lx + ((i === 0) ? (lw / 2 - 0.08) : (-lw / 2 + 0.08)), y0 + 1.05, zo + out * 0.035, 0xB9BCBF));
        /* THE LEAF IN THE WALK-THROUGH (aframe-v161): an HS door's first (inner) sash runs over the other, a single
           glazed door swings into the room on the edge away from its pull; every piece of the leaf shares one arLeaf */
        var Lg = null;
        if (slideD) { if (i === 0) Lg = _arSlide(pcs[0], 1, 0, 0, lw * 0.95, 0, 0, true, 0, out); }
        else Lg = _arSwing(pcs[0], x - w / 2 + fr, zo, lw, 0, 0, -out, 0, true, 0, out);
        if (Lg) { pcs.forEach(function (pc) { if (pc) pc.userData.arLeaf = Lg; }); _arCount(slideD ? 'slide' : 'swing', slideD ? 'HS' : 'glazed'); }
      }
    }
    var _gMem = {};
    var DBL = 0xB08E5E;
    /* the gable glazing's frame under review (aframe-v57): magenta while true */
    var GLASS_REVIEW = false;      /* the second ply of a doubled member, a shade darker (aframe-v44) */
    function _buildGables(ctx) {
      var T = ctx.THREE, g = ctx.group, G = _gGeo(), S = G.S, B = G.B;
      _bill['aframe-gables'] = {}; _bill['aframe-balcony'] = {}; _gMem = {}; _arTally = { swing: 0, slide: 0, where: {} };
      var kG0 = g.children.length;
      if (REVIEW === 'stairs') { ctx.log('review   gables hidden while the stairs are under review (REVIEW)'); return; }
      if (_opNote) { ctx.log('open     ' + _opNote); _opNote = ''; }
      var cx = G.cx, t = GABLE.t, d = GABLE.d, ySole = G.ySole, yStud0 = G.yStud0, yUnder = G.yUnder, yPlate = G.yPlate, xIn = G.xIn;
      var apex = yUnder(cx), WL = API.wallLayout;
      var mat = new T.MeshStandardMaterial({ color: WOOD, roughness: 0.85, metalness: 0.0 });
      var studMat = new T.MeshStandardMaterial({ color: WOOD, roughness: 0.85, side: T.DoubleSide });
      var studLen = 0, plateLen = 0, sealLen = 0, nStud = 0, nNail2 = 0, k, e, q;
      var U = { codes: {}, perim: 0, sill: 0, sillIn: 0, thresh: 0, n: 0 }, GL = { codes: {}, area: 0, perim: 0, n: 0, cap: 0, timber: 0, panes: 0, ends: 0, maxSpan: 0 }, sheathA = 0;
      var AF = function () { _am(ctx, 'wall_frame', 'Gable wall', GABLE.code, 'side'); }; AF();
      var GS = _gableSegs();
      if (GS.length !== 2) ctx.log('open     ' + GS.length + ' gable segment(s) from the core -- expected 2 (front and back); units in a missing one are not drawn');
      if (!(WL && WL.framePlan && WL.studPieces)) ctx.log('open     ERROR the core has no wallLayout.framePlan -- the gables are framed without their units');
      /* ONE STUD, CUT TO THE RAKE, standing from y0 at x (aframe-v18) */
      var stud = function (x, y0, z) {
        var xa = x - t / 2, xb = x + t / 2, shS = new T.Shape();
        shS.moveTo(xa, y0); shS.lineTo(xb, y0); shS.lineTo(xb, yPlate(xb));
        if (xa < cx && xb > cx) shS.lineTo(cx, yPlate(cx));
        shS.lineTo(xa, yPlate(xa)); shS.lineTo(xa, y0);
        var gS = new T.ExtrudeGeometry(shS, { depth: d, bevelEnabled: false });
        gS.translate(0, 0, z - d / 2);
        AF(); g.add(new T.Mesh(gS, studMat));
        verts.push({ x: x, y0: y0, y1: yPlate(x) });
        return yPlate(x) - y0;
      };
      var soleW = Math.max(0.2, S.w - 2 * _plateFit().w), verts = [];
      /* THE GABLE AS A CARPENTER FRAMES IT (aframe-v28, Marek: jen wood
         framing tak jak ma byt, podle praxe). Balloon framed: the studs run
         from the sole to the rake through every floor, so the frame is
         blocked across -- fire blocking at every floor line, and more rows so
         no stud bay stands open more than 10 ft (3050) high -- one row of
         60 x 160 blocks between the members, nailed 2 through each end. On
         the concrete slab the sole is pressure treated and held by the same
         M16 anchors as the eave plates (300 from each end, 1.8 m apart); on
         the timber floor it is screwed down through the deck every 600. */
      var BLK = { maxOpen: 3.05, nails: 4 }, onSlabG = (STATE.foundation === 'strips');
      var fl = floors(), blkLen = 0, nBlk = 0, soleLen = 0, soleAnch = 0, soleScrew = 0, blkNotes = [];
      for (e = 0; e < 2; e++) {
        AF(); var zOut = (e === 0) ? B.z0 : B.z1, z = (e === 0) ? B.z0 + d / 2 : B.z1 - d / 2, side = (e === 0) ? 'front' : 'back', out = (e === 0) ? -1 : 1;
        var sg = null;
        for (q = 0; q < GS.length; q++) if (Math.abs(GS[q].z0 - zOut) < 0.01) sg = GS[q];
        var ux = sg ? _segUx(sg) : 1, x0s = sg ? sg.x0 : cx;
        var xOf = function (u) { return x0s + ux * u; }, uOf = function (x) { return (x - x0s) * ux; };
        verts = [];
        var lum0 = studLen + plateLen + (onSlabG ? 0 : soleLen), ops = sg ? (sg.openings || []) : [], rects = [], rk = null;
        for (q = 0; q < ops.length; q++) {
          if (ops[q].rake || ops[q].fullW || ops[q].halfW) { if (!rk) rk = ops[q]; else ctx.log('open     ' + side + ' gable: a second full/half unit is ignored -- one to a gable'); }
          else rects.push(ops[q]);
        }
        var RU = (rk && sg) ? _rakeUnit(sg, rk) : null;
        if (RU && !RU.half && rects.length) { ctx.log('open     ' + side + ' gable: the full glazing fills it -- ' + rects.length + ' other unit(s) there are not built, take them out'); rects = []; }
        /* the module studs, as positions along the wall, and the frames round the units */
        var studsU = [], xs = [cx];
        for (q = 1; q * GABLE.sp < xIn; q++) { xs.push(cx - q * GABLE.sp); xs.push(cx + q * GABLE.sp); }
        for (q = 0; q < xs.length; q++) if (yPlate(cx + Math.abs(xs[q] - cx) + t / 2) - yStud0 >= 0.10) studsU.push(uOf(xs[q]));
        studsU.sort(function (a, b) { return a - b; });
        var topAt = function (u) { return yPlate(xOf(u)); };
        var frames = [];
        if (sg && rects.length && WL && WL.framePlan) {
          try { frames = WL.framePlan({ id: sg.id, len: sg.len, y0: sg.y0, openings: rects }, studsU, topAt, yStud0, { t: t, ply: t, plies: 2 }) || []; }
          catch (eFP) { ctx.log('open     ERROR framePlan threw on the ' + side + ' gable: ' + ((eFP && eFP.message) || eFP)); frames = []; }
        }
        /* BOTH SIDES OF A UNIT FRAMED ALIKE (aframe-v46, Marek: uzka spara mezi
           profily, zbytecna, kdyz se z druhe strany stavi profil navic). Where
           the frame plan takes a module stud standing a little off the opening
           as its jack, the opening is left that much wide on one side only; so
           a new jack is set tight to the opening and a new king against it, as
           on the other side, and the module stud gives way to them */
        var nTight = 0;
        for (q = 0; q < frames.length; q++) {
          var fT = frames[q], sT2;
          for (sT2 = 0; sT2 < 2; sT2++) {
            var nmT = sT2 ? 'R' : 'L', PT = fT.plan && fT.plan[nmT], sg2 = sT2 ? 1 : -1;
            if (!PT || !PT.jack || PT.jack.isNew || PT.jack.out) continue;
            var edge = sT2 ? fT.eR : fT.eL;
            if (Math.abs(PT.jack.x - (edge + sg2 * t / 2)) < 0.003) continue;
            PT.jack = { x: edge + sg2 * t / 2, isNew: true, gap: 0 };
            PT.king = { x: edge + sg2 * 1.5 * t, isNew: true, gap: 0 };
            if (sT2) { fT.jiR = fT.eR; fT.xh1 = fT.eR; } else { fT.jiL = fT.eL; fT.xh0 = fT.eL; }
            nTight++;
          }
        }
        /* the sole plate, flat on the deck, the seal under it; cut under a door */
        var sA = uOf(cx - soleW / 2), sB2 = uOf(cx + soleW / 2), pcs = [[Math.min(sA, sB2), Math.max(sA, sB2)]], f, pp, nx;
        for (q = 0; q < frames.length; q++) {
          f = frames[q]; if (!f.floor) continue;
          nx = [];
          for (pp = 0; pp < pcs.length; pp++) {
            if (f.jiR <= pcs[pp][0] || f.jiL >= pcs[pp][1]) { nx.push(pcs[pp]); continue; }
            if (f.jiL > pcs[pp][0]) nx.push([pcs[pp][0], f.jiL]);
            if (f.jiR < pcs[pp][1]) nx.push([f.jiR, pcs[pp][1]]);
          }
          pcs = nx;
        }
        for (pp = 0; pp < pcs.length; pp++) {
          var sw = pcs[pp][1] - pcs[pp][0]; if (sw < 0.02) continue;
          var sxm = xOf((pcs[pp][0] + pcs[pp][1]) / 2);
          if (onSlabG) _am(ctx, 'sill_plate', 'Sole plate', 'KVP60160', 'side'); else AF();
          _box(T, g, sw, t, d, sxm, ySole + t / 2, z, 0, onSlabG ? 0xA9A77A : WOOD, 1);
          _am(ctx, 'sill_seal', 'Sill seal', GABLE.seal, 'side');
          _box(T, g, sw, GABLE.sealT, d - 0.010, sxm, ySole - GABLE.sealT / 2 + 0.005, z, 0, 0x3C3F42, 1);
          soleLen += sw; sealLen += sw;
          if (onSlabG) soleAnch += (sw < 0.60) ? 1 : Math.max(2, Math.ceil((sw - 0.60) / 1.80) + 1);
          else soleScrew += Math.ceil(sw / 0.60) + 1;
        }
        /* the raked top plates, one per side, from the deck to the apex */
        var rakeLen = Math.hypot(xIn, yUnder(cx) - yUnder(cx + xIn));
        /* each plate plumb-cut where the two meet on the ridge line, and at its
           foot on the sole (aframe-v44): they butt, they do not cross */
        var fullGl = !!(RU && !RU.half);
        if (fullGl) ctx.log('gable    ' + side + ' gable: full glazing -- no raked top plates, the glass goes up under the gable rafter (its head frame screwed into it)');
        /* where a partly glazed gable's glass (with the header over it and the
           sill under it) takes the plate's place, the plate is left out; the
           pieces that remain are cut plumb at the glass (aframe-v89) */
        var plateGone = function (x) {
          if (!(RU && RU.half)) return false;
          for (var rg = 0; rg < RU.rects.length; rg++) {
            var Rg = RU.rects[rg], lo = Rg[2], hi = Rg[3], hg;
            for (hg = 0; hg < RU.heads.length; hg++) if (Math.abs(RU.heads[hg] - Rg[3]) < 1e-6) hi += 2 * t;
            for (hg = 0; hg < RU.sills.length; hg++) if (Math.abs(RU.sills[hg] + 2 * t - Rg[2]) < 1e-6) lo -= 2 * t;
            if (x > Rg[0] && x < Rg[1] && yUnder(x) > lo && yPlate(x) < hi) return true;
          }
          return false;
        };
        var platePcs = [];
        for (k = -1; k <= 1 && !fullGl; k += 2) {
          var brk = [0, xIn], rg2;
          if (RU && RU.half) for (rg2 = 0; rg2 < RU.rects.length; rg2++) {
            var Rb = RU.rects[rg2], hiB = Rb[3], loB = Rb[2], hb;
            for (hb = 0; hb < RU.heads.length; hb++) if (Math.abs(RU.heads[hb] - Rb[3]) < 1e-6) hiB += 2 * t;
            for (hb = 0; hb < RU.sills.length; hb++) if (Math.abs(RU.sills[hb] + 2 * t - Rb[2]) < 1e-6) loB -= 2 * t;
            [k * (Rb[0] - cx), k * (Rb[1] - cx), (yPlate(cx) - hiB) / S.tan, (yUnder(cx) - loB) / S.tan].forEach(function (dv) { if (dv > 0 && dv < xIn) brk.push(dv); });
          }
          brk.sort(function (a, b) { return a - b; });
          var run = null, bi2;
          for (bi2 = 0; bi2 + 1 < brk.length; bi2++) {
            var da = brk[bi2], db = brk[bi2 + 1]; if (db - da < 1e-4) continue;
            var keep = !plateGone(cx + k * (da + db) / 2);
            if (keep && run && Math.abs(run[1] - da) < 1e-6) run[1] = db;
            else if (keep) { run = [da, db]; platePcs.push({ k: k, r: run }); }
            else run = null;
          }
        }
        platePcs = platePcs.filter(function (P) { return P.r[1] - P.r[0] >= 0.05; });   /* no sliver at the foot beyond the glass */
        for (q = 0; q < platePcs.length; q++) {
          var PPc = platePcs[q], xA = cx + PPc.k * PPc.r[0], xE = cx + PPc.k * PPc.r[1], shP = new T.Shape();
          shP.moveTo(xA, yUnder(xA)); shP.lineTo(xE, yUnder(xE)); shP.lineTo(xE, yPlate(xE)); shP.lineTo(xA, yPlate(xA)); shP.lineTo(xA, yUnder(xA));
          var gPl = new T.ExtrudeGeometry(shP, { depth: d, bevelEnabled: false });
          gPl.translate(0, 0, z - d / 2);
          AF(); g.add(new T.Mesh(gPl, studMat));
          plateLen += (PPc.r[1] - PPc.r[0]) / S.cos;
        }
        if (RU && RU.half) ctx.log('gable    ' + side + ' gable: "' + RU.v + '" glazing up under the gable rafter where it meets the rake; raked plate piece(s) kept: ' +
                                   (platePcs.length ? platePcs.map(function (P) { return (P.k < 0 ? 'L ' : 'R ') + Math.round(P.r[0] * 1000) + '..' + Math.round(P.r[1] * 1000); }).join(', ') : 'none') + ' (from the ridge line out)');
        /* the module studs, or what the units leave of them */
        var yBand = null, nCrip = 0, nCrowd = 0, nModJack = 0, hdrs = [], nBandOut = 0;
        /* A PARTLY GLAZED GABLE (aframe-v64): a module stud standing within two
           plies of a jamb gives way to the doubled jamb; every other stud is
           cut round the glass and round the header over it / the sill under
           it, and stands on the header up to the rake */
        var inBand = function (x) {
          if (!(RU && RU.half)) return false;
          for (var jq = 0; jq < RU.jambs.length; jq++) { var dJ = RU.jambs[jq].s * (x - RU.jambs[jq].x); if (dJ > -0.001 && dJ < 2 * t - 0.001) return true; }
          return false;
        };
        var glzCut = function (x) {
          var o = [], rq;
          if (!(RU && RU.half)) return o;
          for (rq = 0; rq < RU.rects.length; rq++) {
            var R = RU.rects[rq]; if (x < R[0] - t / 2 || x > R[1] + t / 2) continue;
            var lo = R[2], hi = R[3], hq;
            for (hq = 0; hq < RU.heads.length; hq++) if (Math.abs(RU.heads[hq] - R[3]) < 1e-6) hi += 2 * t;
            for (hq = 0; hq < RU.sills.length; hq++) if (Math.abs(RU.sills[hq] + 2 * t - R[2]) < 1e-6) lo -= 2 * t;
            o.push([lo, hi]);
          }
          return o;
        };
        var cutPcs = function (pcs, cuts) {
          var out = pcs.slice(), c, i2;
          for (c = 0; c < cuts.length; c++) {
            var nx2 = [];
            for (i2 = 0; i2 < out.length; i2++) {
              var a = out[i2][0], b = out[i2][1];
              if (b <= cuts[c][0] || a >= cuts[c][1]) { nx2.push(out[i2]); continue; }
              if (a < cuts[c][0]) nx2.push([a, cuts[c][0]]);
              if (b > cuts[c][1]) nx2.push([cuts[c][1], b]);
            }
            out = nx2;
          }
          return out;
        };
        if (!(RU && !RU.half)) {
          for (q = 0; q < studsU.length; q++) {
            var uS = studsU[q], xS = xOf(uS), topS = topAt(uS), SP = { pcs: [[yStud0, topS]], role: 'full' };
            if (frames.length) { try { SP = WL.studPieces(uS, yStud0, topS, frames, t); } catch (eSP) {} }
            if (SP.role === 'gave way') continue;
            if (inBand(xS)) { nBandOut++; continue; }
            /* A MODULE STUD A HAIR OFF A NEW KING IS LEFT OUT (aframe-v44, Marek:
               ram kolem dveri neni spravne postaveny): the king takes its place,
               rather than two studs standing 10 apart with a sliver between */
            /* ...BUT NEVER ONE THE FRAME USES (aframe-v45, Marek: zdvojeny profil
               jen na jedne strane): where the module stud is itself the jack, the
               new king stands against it and the stud stays -- v44 dropped it and
               left the door with a gap and a single stud on that side */
            var crowd = false, isJack = false, fJ = null, fq2, sq2;
            for (fq2 = 0; fq2 < frames.length; fq2++) for (sq2 = 0; sq2 < 2; sq2++) {
              var PS = frames[fq2].plan && frames[fq2].plan[sq2 ? 'R' : 'L'], KG = PS && PS.king, JK = PS && PS.jack;
              if (JK && !JK.isNew && !JK.out && Math.abs(JK.x - uS) < 0.001) { isJack = true; fJ = frames[fq2]; }
              if (KG && KG.isNew && !KG.out && Math.abs(KG.x - uS) > 0.001 && Math.abs(KG.x - uS) < 2 * t) crowd = true;
            }
            if (crowd && !isJack) { nCrowd++; continue; }
            /* such a jack stops under the header, which bears on it; over the
               header the stud goes on up to the rake as a cripple */
            if (isJack) {
              nModJack++;
              if (fJ && !fJ.plateHead) { SP = { pcs: [[yStud0, fJ.yHB]], role: 'jack' }; if (topS - fJ.yHT > 0.05) SP.pcs.push([fJ.yHT, topS]); }
            }
            if (RU && RU.half) SP = { pcs: cutPcs(SP.pcs, glzCut(xS)), role: SP.role };
            for (pp = 0; pp < SP.pcs.length; pp++) {
              var lo = SP.pcs[pp][0], hi = SP.pcs[pp][1];
              if (yBand != null && hi > yBand) hi = yBand;
              if (hi - lo < 0.05) continue;
              if (Math.abs(hi - topS) < 0.002) studLen += stud(xS, lo, z);
              else { var jkP = isJack && lo < yStud0 + 0.01; _box(T, g, jkP ? t - 0.004 : t, hi - lo, d, xS, (lo + hi) / 2, z, 0, jkP ? DBL : WOOD, 1); studLen += hi - lo; verts.push({ x: xS, y0: lo, y1: hi }); }
              nStud++;
              if (SP.role === 'hole') nCrip++;
            }
          }
        }
        /* the members round every unit, and the unit */
        var holes = [];
        for (q = 0; q < frames.length; q++) {
          f = frames[q];
          var o = f.o, sidesLR = ['L', 'R'], sq;
          for (sq = 0; sq < 2; sq++) {
            var PL = f.plan[sidesLR[sq]], jk = PL && PL.jack, kg = PL && PL.king;
            if (kg && kg.isNew && !kg.out) { studLen += stud(xOf(kg.x), yStud0, z); nStud++; }
            if (jk && jk.isNew && !jk.out) {
              var jb = f.floor ? ySole : yStud0, jt = f.yHB;
              if (jt - jb > 0.05) { _box(T, g, t - 0.004, jt - jb, d, xOf(jk.x), (jb + jt) / 2, z, 0, DBL, 1); studLen += jt - jb; nStud++; nNail2 += Math.ceil((jt - jb) / 0.40); verts.push({ x: xOf(jk.x), y0: jb, y1: jt }); }
            }
          }
          var hL = Math.abs(f.xh1 - f.xh0), hX = xOf((f.xh0 + f.xh1) / 2);
          /* THE HEADER BEARS ON THE JACKS (aframe-v44, Marek: nejsou vyplnene
             rohy): it runs from king to king over the jacks' tops, not between
             the jacks, so the corners are closed; its two plies and the jack
             beside the king are drawn a shade darker and a hair apart, so a
             doubled member reads as two pieces */
          var kLq = f.plan && f.plan.L && f.plan.L.king, kRq = f.plan && f.plan.R && f.plan.R.king, hHL = hL, hHX = hX;
          if (kLq && kRq && !kLq.out && !kRq.out) { hHL = Math.abs(kRq.x - kLq.x) - t; hHX = xOf((kLq.x + kRq.x) / 2); }
          if (!f.plateHead && hHL > 0.05) {
            _box(T, g, hHL, t - 0.003, d, hHX, f.yHB + t / 2, z, 0, DBL, 1);
            _box(T, g, hHL, t - 0.003, d, hHX, f.yHB + 1.5 * t, z, 0, WOOD, 1);
            plateLen += 2 * hHL; nNail2 += 2 * 2 * 2 + Math.ceil(hHL / 0.40) * 2;
            hdrs.push({ x0: hHX - hHL / 2, x1: hHX + hHL / 2, y0: f.yHB, y1: f.yHB + 2 * t });
          }
          if (f.sillPlies && hL > 0.05) {
            for (pp = 0; pp < f.sillPlies; pp++) _box(T, g, hL, t - 0.003, d, hX, f.ySB + (pp + 0.5) * t, z, 0, (pp % 2) ? WOOD : DBL, 1);
            hdrs.push({ x0: hX - hL / 2, x1: hX + hL / 2, y0: f.ySB, y1: f.ySB + f.sillPlies * t });
            plateLen += f.sillPlies * hL; nNail2 += f.sillPlies * 2 * 2 + (f.sillPlies > 1 ? Math.ceil(hL / 0.40) * 2 : 0);
          }
          _am(ctx, 'windows_doors', 'Windows & doors', o.code || '', 'side');
          var yB = sg.y0 + (o.sill || 0), du = _drawUnit(T, g, o, xOf(o.at), yB, z, out); AF();
          U.n++;
          if (o.code) { U.codes[o.code] = (U.codes[o.code] || 0) + 1; if (!__CORE.CATALOG[o.code]) __CORE.CATALOG[o.code] = { code: o.code, unit: 'pcs', label: o.code }; }
          if (du.floor) U.thresh += du.w + 0.04; else { U.sill += du.w + 0.22; U.sillIn += du.w + 0.10; }
          U.perim += 2 * (du.w + du.h);
          holes.push({ x0: xOf(o.at) - o.w / 2, x1: xOf(o.at) + o.w / 2, y0: du.floor ? ySole : yB, y1: yB + o.h, door: !!du.floor, yB: yB });
          ctx.log('open     ' + side + ' gable: ' + (o.code || o.kind) + ' ' + Math.round(o.w * 1000) + 'x' + Math.round(o.h * 1000) + ' at ' + Math.round(o.at * 1000) +
                  ' along the wall, sill ' + Math.round((o.sill || 0) * 1000) + '; jacks ' + ((f.plan.L.jack && f.plan.L.jack.isNew) ? 'new' : 'module') + '/' + ((f.plan.R.jack && f.plan.R.jack.isNew) ? 'new' : 'module') +
                  ', header ' + (f.plateHead ? 'none (under the rake)' : (Math.round(f.yHB * 1000) + '..' + Math.round(f.yHT * 1000))) + (f.headShort > 0.001 ? (' -- ' + Math.round(f.headShort * 1000) + ' SHORT of room under the rake') : '') +
                  ', sill plies ' + (f.sillPlies || 0) + (f.floor ? ', sole cut ' + Math.round(Math.abs(f.jiR - f.jiL) * 1000) : ''));
        }
        /* the full or half unit: the triangle, no stud inside it */
        if (RU) {
          /* A TIMBER CURTAIN WALL (aframe-v91, Marek: ramy celoproskleneho
             stitu drevene -- drevo + hlinikovy pritlak, sloupky po 1200). Glued
             laminated posts 60 x 160 stand in the gable frame's own depth, from
             the sole to the rafter's underside, every 1200 about the ridge line
             (a post at each door jamb, none nearer a jamb than 300); a transom
             60 x 160 of the same stock covers each floor edge; the insulating
             glass sits on the posts' outer face on gaskets and is held by an
             aluminium pressure plate with its snap-on cap on every joint --
             posts, transoms, and all round the glass, the raked edges into the
             gable rafter. The sole, the headers and the jamb studs are the
             frame round it. */
          var CW = { post: 0.060, depth: 0.160, glassOff: 0.022, capW: 0.050, capD: 0.045, sp: 1.20, near: 0.30 };
          var zG = zOut + out * CW.glassOff, zPost = z, zCap = zOut + out * (CW.glassOff + 0.022 + CW.capD / 2);
          var colGl = GLASS_REVIEW ? MAGENTA : GLAZE.frame, gpq, colPost = GLASS_REVIEW ? MAGENTA : WOOD;
          var cwL = { post: 0, tr: 0, cap: 0, ends: 0, maxSpan: 0 };
          var capBox = function (w, h, x, y) { var it9 = ctx.item; _am(ctx, 'glazing_cap', 'Pressure plate', 'OWP00004', 'side'); _box(T, g, w, h, CW.capD, x, y, zCap, 0, colGl, 1); ctx.item = it9; };
          var glMat = new T.MeshStandardMaterial({ color: GLAZE.glass, roughness: 0.1, metalness: 0.1, transparent: true, opacity: 0.35, side: T.DoubleSide, depthWrite: false });
          for (gpq = 0; gpq < RU.polys.length; gpq++) {
            var gG = new T.ShapeGeometry(_polyPath(T, RU.polys[gpq], true)); gG.translate(0, 0, zG);
            _am(ctx, 'glazing', 'Glass', 'OWI00001', 'side'); g.add(new T.Mesh(gG, glMat));
            /* the cap all round the glass: level, upright and raked edges */
            var PQ = RU.polys[gpq], eq;
            for (eq = 0; eq < PQ.length; eq++) {
              var E1 = PQ[eq], E2 = PQ[(eq + 1) % PQ.length], dxE = E2[0] - E1[0], dyE = E2[1] - E1[1], lE = Math.hypot(dxE, dyE);
              if (lE < 0.05) continue;
              var cE = new T.Mesh(new T.BoxGeometry(lE, CW.capW, CW.capD), new T.MeshStandardMaterial({ color: colGl, roughness: 0.5, metalness: 0.3 }));
              cE.position.set((E1[0] + E2[0]) / 2, (E1[1] + E2[1]) / 2, zCap); cE.rotation.z = Math.atan2(dyE, dxE); _am(ctx, 'glazing_cap', 'Pressure plate', 'OWP00004', 'side'); g.add(cE);
              cwL.cap += lE;
            }
          }
          var nMul = 0, nTr = 0;
          /* THE DOORS IN THE FULL GLAZING (aframe-v58, Marek: full wall window
             v prvnim patre s dvermi, v druhem s balkonem, pokud se tam vlezou
             dvere): the entrance door in the middle of the glass on the ground
             floor, and on the second floor a door onto a balcony when a door
             of the house's size stands under the rake there with its frame */
          /* THE FULL GLAZING'S THREE SETS (aframe-v63, Marek: cykler -- bez
             dveri / s dvermi (dvojitymi) v prvnim patre / dvere a balkon v patre;
             dvere prosklene, dole jakoby HS portal): kept on the unit as afVar,
             'plain' | 'door' | 'balcony' (the default). The ground floor takes
             the widest HS sliding door of the catalogue that stands under the
             rake with its frame (OWR20001 2000, else OWR15002 1500), floor 2 a
             glazed French door (OWR10001 1000) when it stands there too */
          var gDoors = [], vAF = _glazeVar(rk);
          if (!RU.half && vAF !== 'plain') {
            var dG = null, cq9;
            for (cq9 = 0; cq9 < GLZ_DOORS.ground.length; cq9++) { var C9 = _glzDoorFit(GLZ_DOORS.ground[cq9], RU.yB, 0); if (C9 && RU.wAt(RU.yB + C9.h + GLAZE.mull) >= C9.w / 2 + GLAZE.mull + 0.05) { dG = C9; break; } }
            if (dG) gDoors.push({ y: RU.yB, lvl: 'ground floor', d: dG });
            else ctx.log('glass    ' + side + ' gable: no HS door of the catalogue stands under the rake on the ground floor -- the glass is left plain');
            if (vAF === 'balcony' && fl.length > 1) {
              var yD2 = fl[1].y, dU = _glzDoorFit(GLZ_DOORS.upper, fl[1].y, 1) || GLZ_DOORS.upper;
              if (_glzDoorFit(GLZ_DOORS.upper, fl[1].y, 1) && RU.wAt(yD2 + dU.h + GLAZE.mull) >= dU.w / 2 + GLAZE.mull + 0.05) gDoors.push({ y: yD2, lvl: 'floor 2', balcony: true, d: dU });
              else ctx.log('balcony  ' + side + ' gable: a ' + Math.round(dU.w * 1000) + 'x' + Math.round(dU.h * 1000) + ' door does not stand under the rake on floor 2 (the glass is ' + Math.round(2 * RU.wAt(yD2 + dU.h + GLAZE.mull) * 1000) + ' wide at its head) -- no balcony door, no balcony');
            }
          }
          ctx.log('glass    ' + side + ' gable: variant "' + RU.v + '" (' + _glzLabel(RU.v) + ')' + ((rk && rk.afVar && rk.afVar !== RU.v) ? (' -- asked ' + rk.afVar + ', not possible with ' + fl.length + ' floor(s)') : '') + ' -- step it with the icon on the gable in Edit (core-v505)');
          var xsP = [], kp, jx = [];
          for (kp = 0; 0.6 + kp * CW.sp < xIn + 1; kp++) { xsP.push(cx - (0.6 + kp * CW.sp)); xsP.push(cx + (0.6 + kp * CW.sp)); }
          RU.jambs.forEach(function (J) { jx.push(J.x); });
          RU.rects.forEach(function (Rr) { jx.push(Rr[0]); jx.push(Rr[1]); });
          gDoors.forEach(function (D0) { jx.push(RU.cx - D0.d.w / 2 - GLAZE.mull); jx.push(RU.cx + D0.d.w / 2 + GLAZE.mull); });
          xsP = xsP.filter(function (xp) { return !jx.some(function (xj) { return Math.abs(xj - xp) < CW.near; }); });
          for (q = 0; q < xsP.length; q++) {
            var inR = false, rq8, segs = [], k8, xq8 = xsP[q];
            for (rq8 = 0; rq8 < RU.rects.length; rq8++) if (xq8 > RU.rects[rq8][0] + 0.05 && xq8 < RU.rects[rq8][1] - 0.05) inR = true;
            if (!inR) continue;
            segs = RU.yRuns(xq8 - 0.0005, xq8 + 0.0005);
            for (k8 = 0; k8 < gDoors.length; k8++) if (Math.abs(xq8 - RU.cx) < gDoors[k8].d.w / 2 + GLAZE.mull) {
              var ns = [], sq8; for (sq8 = 0; sq8 < segs.length; sq8++) { var a8 = segs[sq8][0], b8 = segs[sq8][1], c0 = gDoors[k8].y, c1 = gDoors[k8].y + gDoors[k8].d.h + GLAZE.mull; if (b8 <= c0 || a8 >= c1) { ns.push(segs[sq8]); continue; } if (a8 < c0) ns.push([a8, c0]); if (b8 > c1) ns.push([c1, b8]); } segs = ns;
            }
            for (k8 = 0; k8 < segs.length; k8++) {
              var hM = segs[k8][1] - segs[k8][0];
              if (hM < 0.10) continue;
              _am(ctx, 'curtain_wall', 'Glazing frame', 'KVG60160', 'side'); _box(T, g, CW.post, hM, CW.depth, xq8, segs[k8][0] + hM / 2, zPost, 0, colPost, 1);
              capBox(CW.capW, hM, xq8, segs[k8][0] + hM / 2);
              cwL.post += hM; cwL.cap += hM; cwL.ends += 2; nMul++;
              /* its longest free span: between the floor edges it passes */
              var cutsF = [segs[k8][0]], fq7;
              for (fq7 = 1; fq7 < fl.length; fq7++) { var yF7 = fl[fq7].y - FLOOR.deck.t - FLOOR.joist.d / 2; if (yF7 > segs[k8][0] && yF7 < segs[k8][1]) cutsF.push(yF7); }
              cutsF.push(segs[k8][1]);
              for (fq7 = 0; fq7 + 1 < cutsF.length; fq7++) cwL.maxSpan = Math.max(cwL.maxSpan, cutsF[fq7 + 1] - cutsF[fq7]);
            }
          }
          var dq, dArea = 0;
          for (dq = 0; dq < gDoors.length; dq++) {
            var GD = gDoors[dq], DD = GD.d, hJ = RU.topAt(RU.cx + DD.w / 2 + GLAZE.mull) - GD.y, sj2;
            /* the door's jambs in the glazing, full height to the rake, and a transom over its head */
            for (sj2 = -1; sj2 <= 1; sj2 += 2) {
              var xDJ = RU.cx + sj2 * (DD.w / 2 + CW.post / 2);
              _am(ctx, 'curtain_wall', 'Glazing frame', 'KVG60160', 'side'); _box(T, g, CW.post, hJ, CW.depth, xDJ, GD.y + hJ / 2, zPost, 0, colPost, 1);
              capBox(CW.capW, hJ, xDJ, GD.y + hJ / 2);
              cwL.post += hJ; cwL.cap += hJ; cwL.ends += 2;
            }
            _am(ctx, 'curtain_wall', 'Glazing frame', 'KVG60160', 'side'); _box(T, g, DD.w, CW.post, CW.depth, RU.cx, GD.y + DD.h + CW.post / 2, zPost, 0, colPost, 1);
            capBox(DD.w, CW.capW, RU.cx, GD.y + DD.h + CW.post / 2);
            cwL.tr += DD.w; cwL.cap += DD.w; cwL.ends += 2;
            _am(ctx, 'windows_doors', 'Windows & doors', DD.code || '', 'side'); _glassDoor(T, g, RU.cx, GD.y, DD, zG, out);
            U.n++; U.codes[DD.code] = (U.codes[DD.code] || 0) + 1; U.thresh += DD.w + 0.04;
            dArea += DD.w * DD.h;
            ctx.log('glass    ' + side + ' gable: ' + DD.name + ' ' + DD.code + ' ' + Math.round(DD.w * 1000) + 'x' + Math.round(DD.h * 1000) + ' (' + DD.leaves + ' glazed leaf/leaves)' + ((DD.cat && DD.cat > DD.h + 0.001) ? (' -- made to the storey, ' + Math.round(DD.h * 1000) + ' high (the catalogue unit is ' + Math.round(DD.cat * 1000) + '), its head and transom under the floor above') : '') + ' in the glass on the ' + GD.lvl + ' at ' + Math.round(GD.y * 1000) + (GD.balcony ? ', onto the balcony' : ', the entrance') + ' (set in the glazing system: its threshold billed, no tape or foam of its own)');
            if (GD.balcony) { var kB9 = g.children.length; _balcony(ctx, T, g, GD.y, zOut, out, side, RU, e); _outFlag(ctx, kB9, 'balcony'); }
          }
          /* a transom where each upper floor meets the glass: the floor's edge stands behind it */
          for (fq = 1; fq < fl.length; fq++) {
            var yTr = fl[fq].y - FLOOR.deck.t - FLOOR.joist.d / 2, hTr = FLOOR.joist.d + FLOOR.deck.t, xrT = RU.xRuns(yTr - hTr / 2 + FLOOR.deck.t / 2, yTr + hTr / 2 + FLOOR.deck.t / 2), rT;
            for (rT = 0; rT < xrT.length; rT++) {
              var wT = xrT[rT][1] - xrT[rT][0]; if (wT < 0.20) continue;
              /* a transom 60 x 160 on the floor edge's line, the glass above and below it */
              _am(ctx, 'curtain_wall', 'Glazing frame', 'KVG60160', 'side'); _box(T, g, wT, CW.post, CW.depth, (xrT[rT][0] + xrT[rT][1]) / 2, yTr + FLOOR.deck.t / 2, zPost, 0, colPost, 1);
              capBox(wT, CW.capW, (xrT[rT][0] + xrT[rT][1]) / 2, yTr + FLOOR.deck.t / 2);
              cwL.tr += wT; cwL.cap += wT; cwL.ends += 2;
              nTr++;
            }
          }
          var nHd = 0, nJb = 0;
          if (RU.half) {
            /* THE JAMBS OF AN UPRIGHT BAND: a doubled stud against each upright
               glass edge, sole to rake, the second ply darker; the module studs
               there are left out; the raked plates run on over the glass */
            var jq2; AF();
            for (jq2 = 0; jq2 < RU.jambs.length; jq2++) {
              var JB = RU.jambs[jq2], xJ1 = JB.x + JB.s * t / 2, xJ2 = JB.x + JB.s * 1.5 * t;
              studLen += stud(xJ1, yStud0, z);
              var hJ2 = yPlate(xJ2 + JB.s * t / 2) - yStud0;
              _box(T, g, t - 0.004, hJ2, d, xJ2, yStud0 + hJ2 / 2, z, 0, DBL, 1); studLen += hJ2;
              verts.push({ x: xJ2, y0: yStud0, y1: yStud0 + hJ2 });
              nStud += 2; nNail2 += 2 * Math.ceil(hJ2 / 0.40); nJb++;
            }
            /* THE HEADER OVER A LEVEL BAND AND THE SILL UNDER ONE: two plies
               from rake plate to rake plate, the studs above stand on it */
            var hsq, HS2 = RU.heads.map(function (y) { return { y0: y, why: 'header' }; }).concat(RU.sills.map(function (y) { return { y0: y, why: 'sill' }; }));
            for (hsq = 0; hsq < HS2.length; hsq++) {
              var pl2;
              for (pl2 = 0; pl2 < 2; pl2++) {
                var PBH = _polyBand(RU.tri, HS2[hsq].y0 + pl2 * t, HS2[hsq].y0 + (pl2 + 1) * t - 0.003).poly;
                if (PBH.length < 3) continue;
                var gH = new T.ExtrudeGeometry(_polyPath(T, PBH, true), { depth: d, bevelEnabled: false }); gH.translate(0, 0, z - d / 2);
                g.add(new T.Mesh(gH, new T.MeshStandardMaterial({ color: pl2 ? WOOD : DBL, roughness: 0.85 })));
                var wH = PBH.reduce(function (m, p) { return Math.max(m, p[0]); }, -1e9) - PBH.reduce(function (m, p) { return Math.min(m, p[0]); }, 1e9);
                plateLen += wH; nNail2 += Math.ceil(wH / 0.40) * 2;
                if (!pl2) hdrs.push({ x0: cx - wH / 2, x1: cx + wH / 2, y0: HS2[hsq].y0, y1: HS2[hsq].y0 + 2 * t });
              }
              nHd++;
            }
          }
          var gCode = RU.code;
          /* the panes: each band between the level lines, each run in it split by the posts */
          var hl = [RU.yB, RU.apex], fq8, nPane = 0;
          for (fq8 = 1; fq8 < fl.length; fq8++) hl.push(fl[fq8].y - FLOOR.deck.t - FLOOR.joist.d / 2 + FLOOR.deck.t / 2);
          RU.heads.forEach(function (y) { hl.push(y); }); RU.sills.forEach(function (y) { hl.push(y + 2 * t); });
          hl.sort(function (a, b) { return a - b; });
          for (fq8 = 0; fq8 + 1 < hl.length; fq8++) {
            var ym = (hl[fq8] + hl[fq8 + 1]) / 2; if (hl[fq8 + 1] - hl[fq8] < 0.10) continue;
            RU.xRuns(ym - 0.005, ym + 0.005).forEach(function (rn) { nPane += 1 + xsP.filter(function (xp) { return xp > rn[0] + 0.05 && xp < rn[1] - 0.05; }).length; });
          }
          nPane += gDoors.length ? gDoors.length : 0;   /* the sidelights beside a door come out as one more pane each side, roughly */
          var netG = Math.max(0, RU.area - dArea - (cwL.post + cwL.tr) * CW.post);
          GL.area += netG; GL.perim += RU.perim; GL.n++;
          GL.cap += cwL.cap; GL.timber += cwL.post + cwL.tr; GL.panes += nPane; GL.ends += cwL.ends; GL.maxSpan = Math.max(GL.maxSpan, cwL.maxSpan);
          ctx.log('glass    ' + side + ' gable: TIMBER CURTAIN WALL -- ' + nMul + ' post piece(s) glulam 60x160 every ' + Math.round(CW.sp * 1000) + ' (' + cwL.post.toFixed(1) + ' m), transoms ' + cwL.tr.toFixed(1) + ' m, longest free span ' + Math.round(cwL.maxSpan * 1000) + (cwL.maxSpan > 3.0 ? ' -- OVER 3000: a deeper post (60x200) wants checking' : '') + '; about ' + nPane + ' insulating pane(s) ' + netG.toFixed(2) + ' m2; aluminium pressure plate + cap ' + cwL.cap.toFixed(1) + ' m on every joint and round the glass');
          ctx.log('glass    ' + side + ' gable: ' + gCode + ' "' + RU.v + '" ' + RU.polys.length + ' glazed part(s) ' + RU.polys.map(function (P) { var y0 = 1e9, y1 = -1e9, x0 = 1e9, x1 = -1e9; P.forEach(function (p) { x0 = Math.min(x0, p[0]); x1 = Math.max(x1, p[0]); y0 = Math.min(y0, p[1]); y1 = Math.max(y1, p[1]); }); return Math.round((x1 - x0) * 1000) + ' wide, ' + Math.round(y0 * 1000) + '..' + Math.round(y1 * 1000); }).join(' + ') +
                  ', ' + RU.area.toFixed(2) + ' m2' + (dArea > 0 ? (' less ' + dArea.toFixed(2) + ' m2 of door(s) = ' + (RU.area - dArea).toFixed(2) + ' m2 of glass') : '') + ', edge ' + RU.perim.toFixed(2) + ' m; ' + nMul + ' post(s), ' + nTr + ' transom(s) at the floor lines (the timber curtain wall, billed by its parts); no studs inside it' +
                  (RU.half ? ('; ' + nJb + ' doubled jamb(s) sole to rake, ' + nHd + ' header/sill(s) of 2 plies rake to rake, ' + nBandOut + ' module stud(s) left out by a jamb') : '') + (GLASS_REVIEW ? ' -- frame MAGENTA, under review' : ''));
        }
        /* THE BLOCKING ROWS: every upper floor line, then rows so no bay stands
           open more than 3050; a block between each two members that both pass
           the row, and between the last member and the raked plate, never
           across a unit or its header and sill, never in the glass */
        if (!(RU && !RU.half)) {
          var rows = [], lv = [yStud0], fq, yTopG = yPlate(cx);
          for (fq = 1; fq < fl.length; fq++) {
            var yb = fl[fq].y - FLOOR.deck.t - FLOOR.joist.d / 2;
            if (yb < yTopG - 0.40) { rows.push({ y: yb, why: 'floor ' + (fq + 1) }); lv.push(yb); }
          }
          lv.push(yTopG);
          for (fq = 0; fq + 1 < lv.length; fq++) {
            var gapV = lv[fq + 1] - lv[fq], nAdd = Math.ceil(gapV / BLK.maxOpen) - 1, ia;
            for (ia = 1; ia <= nAdd; ia++) rows.push({ y: lv[fq] + gapV * ia / (nAdd + 1), why: '10 ft rule' });
          }
          var rowNote = [], rowYs = [];
          for (fq = 0; fq < rows.length; fq++) {
            var yR = rows[fq].y, halfW = (yPlate(cx) - (yR + t / 2)) / S.tan;
            if (halfW < 0.15) continue;
            var xsR = [cx - halfW, cx + halfW], vq;
            for (vq = 0; vq < verts.length; vq++) if (verts[vq].y0 <= yR - t / 2 + 0.002 && verts[vq].y1 >= yR + t / 2 - 0.002) xsR.push(verts[vq].x);
            xsR.sort(function (a, b) { return a - b; });
            var nRow = 0, pcsR = [];
            for (vq = 0; vq + 1 < xsR.length; vq++) {
              var bxa = xsR[vq] + ((vq === 0) ? 0 : t / 2), bxb = xsR[vq + 1] - ((vq + 1 === xsR.length - 1) ? 0 : t / 2), gw = bxb - bxa;
              if (gw < 0.03) continue;
              var bmx = (bxa + bxb) / 2, inHole = false, hq2, rq3;
              if (RU && RU.half) for (rq3 = 0; rq3 < RU.rects.length; rq3++) { var R3 = RU.rects[rq3]; if (bmx > R3[0] - t && bmx < R3[1] + t && yR > R3[2] - 3 * t && yR < R3[3] + 3 * t) inHole = true; }
              if (inBand(bmx)) inHole = true;
              for (hq2 = 0; hq2 < holes.length; hq2++) {
                var Hh2 = holes[hq2], hxa = Math.min(Hh2.x0, Hh2.x1) - t, hxb = Math.max(Hh2.x0, Hh2.x1) + t;
                if (bmx > hxa && bmx < hxb && yR > Hh2.y0 - 3 * t && yR < Hh2.y1 + 3 * t) inHole = true;
              }
              if (inHole) continue;
              /* drawn 3 short of each face and a shade darker, so each block reads
                 as the piece it is -- cut between two studs, not one board across them */
              AF(); _box(T, g, Math.max(0.01, gw - 0.006), t, d - 0.004, bmx, yR, z, 0, 0xB08E5E, 1);
              blkLen += gw; nBlk++; nRow++;
              pcsR.push(Math.round((bxa - cx) * 1000) + '..' + Math.round((bxb - cx) * 1000));
            }
            rowNote.push(rows[fq].why + ' at ' + Math.round(yR * 1000) + ' (' + nRow + ')'); rowYs.push(yR);
            ctx.log('block    ' + side + ' ' + rows[fq].why + ' row at ' + Math.round(yR * 1000) + ': ' + (xsR.length - 2) + ' member(s) pass it, ' + nRow + ' block(s) between them, x from the ridge line: ' + pcsR.join(' '));
          }
          blkNotes.push(side + ': ' + (rowNote.length ? rowNote.join(', ') : 'no row'));
        }
        /* what the wool of the lining (layer 4) fills between: the members, the units and the blocking rows of this gable (aframe-v43) */
        _gMem[e] = { ru: RU, zOut: zOut, out: out, frames: frames, hdrs: hdrs, bandY: (RU && RU.half) ? yBand : null, z: z, verts: verts.slice(), holes: holes.slice(), rows: (typeof rowYs !== 'undefined' && !(RU && !RU.half)) ? rowYs.slice() : [], full: !!(RU && !RU.half), yBand: yBand };
        /* THE SHEATHING AND THE MEMBRANE on the outer face (aframe-v23), every unit cut out */
        var apexS = yUnder(cx) - ySole, aS = xIn * apexS, cutA = 0;
        var shS2 = new T.Shape();
        shS2.moveTo(cx - xIn, ySole); shS2.lineTo(cx + xIn, ySole); shS2.lineTo(cx, ySole + apexS); shS2.lineTo(cx - xIn, ySole);
        for (q = 0; q < holes.length; q++) {
          var Hq = holes[q], hP = new T.Path(), hx0 = Math.min(Hq.x0, Hq.x1), hx1 = Math.max(Hq.x0, Hq.x1);
          hP.moveTo(hx0, Hq.y0); hP.lineTo(hx0, Hq.y1); hP.lineTo(hx1, Hq.y1); hP.lineTo(hx1, Hq.y0); hP.lineTo(hx0, Hq.y0);
          shS2.holes.push(hP); cutA += (hx1 - hx0) * (Hq.y1 - Hq.y0);
        }
        var partS = null;
        if (RU && RU.half) {
          var rrS = holes.map(function (H) { return [Math.min(H.x0, H.x1), Math.max(H.x0, H.x1), H.y0, H.y1]; });
          partS = _gableMinus([[cx - xIn, ySole], [cx + xIn, ySole], [cx, ySole + apexS]], rrS, RU);
          cutA = aS - partS.reduce(function (m, P) { return m + _polyArea(P); }, 0);
        } else if (RU) {
          shS2.holes.push(_polyPath(T, RU.poly, false)); cutA += RU.area;
        }
        /* while the gable frames are under review the boards and the membrane
           are not drawn -- only the timber shows; they are billed all the same */
        var fullG = !!(RU && !RU.half);
        if (fullG) { aS = 0; cutA = 0; }        /* nor OSB and membrane round a full glazing: the slivers along the plates went (aframe-v63) */
        if (REVIEW !== 'gables' && !fullG) {
          var shList = partS ? partS.map(function (P) { return _polyPath(T, P, true); }) : [shS2], shq;
          var mSh = new T.MeshStandardMaterial({ color: SHEATH.col, roughness: 0.9, side: T.DoubleSide }), mMb = new T.MeshStandardMaterial({ color: SHEATH.membCol, roughness: 1, side: T.DoubleSide });
          for (shq = 0; shq < shList.length; shq++) {
            /* aframe-v172: the piece's own area for the qty audit (its box is the triangle's rectangle, twice it) */
            var aQ = partS ? _polyArea(partS[shq]) : Math.max(0, aS - cutA);
            var gSh = new T.ExtrudeGeometry(shList[shq], { depth: SHEATH.t, bevelEnabled: false });
            gSh.translate(0, 0, (e === 0) ? zOut - SHEATH.t : zOut);
            _am(ctx, 'layer_osb', 'OSB sheathing', SHEATH.code, 'side'); var mQs = new T.Mesh(gSh, mSh); mQs.userData.qtyV = aQ; g.add(mQs);
            var gMb = new T.ExtrudeGeometry(shList[shq], { depth: 0.001, bevelEnabled: false });
            gMb.translate(0, 0, (e === 0) ? zOut - SHEATH.t - 0.0015 : zOut + SHEATH.t + 0.0005);
            _am(ctx, 'layer_breather_membrane', 'Breathable membrane', SHEATH.memb, 'side'); var mQm = new T.Mesh(gMb, mMb); mQm.userData.qtyV = aQ; g.add(mQm);
          }
        }
        var netA = Math.max(0, aS - cutA);
        sheathA += netA;
        ctx.log('sheath   ' + side + ' gable: triangle ' + Math.round(2 * xIn * 1000) + ' x ' + Math.round(apexS * 1000) + ' = ' + aS.toFixed(2) + ' m2, ' + cutA.toFixed(2) + ' m2 of units cut out -> ' + netA.toFixed(2) + ' m2');
        ctx.log('gable    ' + side + ' gable: ' + rects.length + ' unit(s)' + (RU ? (' + ' + (RU.half ? 'half' : 'full') + ' glazing') : '') + ', ' + nCrip + ' cripple piece(s)' + (nCrowd ? (', ' + nCrowd + ' module stud(s) left out beside a new king') : '') + (nTight ? (', ' + nTight + ' side(s) re-framed tight to the opening (new jack + king, the module stud off the edge gives way)') : '') + (nModJack ? (', ' + nModJack + ' module stud(s) kept as the jack, a new king against it') : '') + (hdrs.length ? ', header(s) from king to king over the jacks (the darker ply and jack = the doubling)' : '') + '; lumber ' + GABLE.code + ' ' + (studLen + plateLen - lum0).toFixed(1) + ' m' +
                (RU ? (' (glazed area ' + RU.area.toFixed(2) + ' m2 excluded)') : ''));
      }
      /* THE BILL: the frame, its nails, the units by the piece with the core's frame rule, the glazing by the m2, the sheathing */
      plateLen += blkLen;
      if (onSlabG) {
        API.billAdd('aframe-gables', 'KVP60160', soleLen * 1.05);
        API.billAdd('aframe-gables', 'FAT16010', Math.ceil(soleAnch / 2));
        API.billAdd('aframe-gables', 'FAT16011', soleAnch);
        API.billAdd('aframe-gables', 'FAT16001', soleAnch * 2);
        API.billAdd('aframe-gables', 'FAT16002', soleAnch);
        ctx.log('sole     on the slab: ' + soleLen.toFixed(2) + ' m pressure treated 60x160 KVP60160 ' + (soleLen * 1.05).toFixed(2) + ' m (+5%; 2x6 in imperial, the catalogue row); ' + soleAnch +
                ' anchor(s) M16 (300 from the ends, 1.8 m apart; 1 in a piece under 600): ' + Math.ceil(soleAnch / 2) + ' x FAT16010 rod in 500 pieces, ' + soleAnch + ' x FAT16011, ' + (soleAnch * 2) + ' x FAT16001, ' + soleAnch + ' x FAT16002');
      } else {
        plateLen += soleLen;
        API.billAdd('aframe-gables', 'FAS75132', soleScrew);
        ctx.log('sole     on the timber floor: ' + soleLen.toFixed(2) + ' m ' + GABLE.code + ' (in the frame metres), ' + soleScrew + ' x FAS75132 down through the deck every 600');
      }
      if (nBlk) nNail2 += nBlk * BLK.nails;
      ctx.log('block    ' + nBlk + ' block(s) ' + GABLE.code + ' ' + blkLen.toFixed(2) + ' m, ' + (nBlk * BLK.nails) + ' x FAS45145 (2 through each end); rows -- ' + blkNotes.join(' | ') + ' (fire blocking at every floor line, no bay open over ' + Math.round(BLK.maxOpen * 1000) + ')');
      if (REVIEW === 'gables') ctx.log('sheath   the boards and the membrane are not drawn while the gable frames are under review (REVIEW) -- still billed below');
      API.billAdd('aframe-gables', GABLE.code, (studLen + plateLen) * 1.05);
      API.billAdd('aframe-gables', GABLE.seal, sealLen);
      var nNail = nStud * 2 * 2 + nNail2, cc, cl = [];
      API.billAdd('aframe-gables', 'FAS45145', nNail);
      for (cc in U.codes) if (U.codes.hasOwnProperty(cc)) { API.billAdd('aframe-gables', cc, U.codes[cc]); cl.push(U.codes[cc] + ' x ' + cc); }
      if (U.perim > 0.01) {
        API.billAdd('aframe-gables', DOOR.tape, U.perim * 2 * 1.05);
        API.billAdd('aframe-gables', DOOR.foam, Math.ceil(U.perim / DOOR.foamM));
        API.billAdd('aframe-gables', DOOR.anchor, Math.ceil(U.perim / DOOR.anchorSp));
      }
      if (U.thresh > 0.01) API.billAdd('aframe-gables', DOOR.thresh, U.thresh * 1.05);
      if (U.sill > 0.01) API.billAdd('aframe-gables', 'OWW00002', U.sill * 1.05);
      if (U.sillIn > 0.01) API.billAdd('aframe-gables', 'OWW00001', U.sillIn * 1.05);
      if (U.n) ctx.log('BILL  gable units ' + (cl.length ? cl.join(', ') : 'none coded') + '; joint ' + U.perim.toFixed(2) + ' m: ' + DOOR.tape + ' ' + (U.perim * 2 * 1.05).toFixed(2) + ' m both faces, ' +
                       Math.ceil(U.perim / DOOR.foamM) + ' can(s) ' + DOOR.foam + ', ' + Math.ceil(U.perim / DOOR.anchorSp) + ' x ' + DOOR.anchor + ' at 700; sills OWW00002 ' + (U.sill * 1.05).toFixed(2) +
                       ' m / OWW00001 ' + (U.sillIn * 1.05).toFixed(2) + ' m, threshold ' + DOOR.thresh + ' ' + (U.thresh * 1.05).toFixed(2) + ' m (the core\'s frame rule)');
      if (GL.n) {
        var gl = [];
        /* THE CURTAIN WALL'S BILL (aframe-v91): the glass by the m2 made to
           size, the glulam by the m, the pressure plate with its cap, the two
           gasket lines, the plate's stainless screws every 250, two setting
           blocks a pane, the posts and transoms screwed at each end, and the
           joint to the frame taped inside and out */
        var cwScr = Math.ceil(GL.cap / 0.25), cwBlk = GL.panes * 2, cwEnd = GL.ends * 2;
        API.billAdd('aframe-gables', 'OWI00001', Math.round(GL.area * 100) / 100);
        API.billAdd('aframe-gables', 'KVG60160', GL.timber * 1.05);
        API.billAdd('aframe-gables', 'OWP00004', GL.cap * 1.05);
        API.billAdd('aframe-gables', 'OWP00005', GL.cap * 2 * 1.05);
        API.billAdd('aframe-gables', 'FAS65090', cwScr);
        API.billAdd('aframe-gables', 'OWP00006', cwBlk);
        API.billAdd('aframe-gables', 'FAS75132', cwEnd);
        API.billAdd('aframe-gables', DOOR.tape, GL.perim * 2 * 1.05);
        gl.push('OWI00001 ' + GL.area.toFixed(2) + ' m2 (' + GL.panes + ' pane(s)), KVG60160 ' + (GL.timber * 1.05).toFixed(1) + ' m (+5%), OWP00004 ' + (GL.cap * 1.05).toFixed(1) + ' m, OWP00005 ' + (GL.cap * 2 * 1.05).toFixed(1) + ' m (inner + outer), ' + cwScr + ' x FAS65090, ' + cwBlk + ' x OWP00006, ' + cwEnd + ' x FAS75132 (2 each end of a post or transom)');
        ctx.log('BILL  gable glazing, timber curtain wall: ' + gl.join(', ') + '; joint to the frame ' + GL.perim.toFixed(2) + ' m taped inside and out ' + DOOR.tape + ' ' + (GL.perim * 2 * 1.05).toFixed(1) + ' m' + (GL.maxSpan > 3.0 ? ('; longest post span ' + Math.round(GL.maxSpan * 1000) + ' -- check the section') : ''));
        ctx.log('BILL  gable framing lumber ' + GABLE.code + ' m ' + ((studLen + plateLen) * 1.05).toFixed(1) + ' (glazed area ' + GL.area.toFixed(2) + ' m2 excluded)');
      }
      if (sheathA > 0.01) {
        var shNail = Math.round(sheathA * SHEATH.nailPerM2);
        var mbBought = sheathA * SHEATH.roll / (SHEATH.roll - SHEATH.lap), mbTape = (mbBought - sheathA) / SHEATH.lap;
        API.billAdd('aframe-gables', SHEATH.code, sheathA * 1.05);
        API.billAdd('aframe-gables', SHEATH.nail, shNail);
        API.billAdd('aframe-gables', SHEATH.memb, mbBought);
        _chemBill('aframe-gables', 0, sheathA, 0); _chemNote(ctx, 'gables membrane', 0, sheathA, 0);
        API.billAdd('aframe-gables', SHEATH.tape, mbTape);
        ctx.log('BILL  gable sheathing OSB25002 ' + (sheathA * 1.05).toFixed(2) + ' m2 (' + sheathA.toFixed(2) + ' drawn +5%, units cut out); membrane ' + SHEATH.memb + ' ' + mbBought.toFixed(2) +
                ' m2, tape ' + SHEATH.tape + ' ' + mbTape.toFixed(1) + ' m (the ADU wall rule)');
        ctx.log('FIX  gable sheathing ' + sheathA.toFixed(2) + ' m2 -> ' + shNail + ' x ' + SHEATH.nail + ' at ' + SHEATH.nailPerM2 + '/m2 (the ADU wall rule)');
      }
      ctx.log('gable    2 frame(s), outer face on the footprint line, ' + Math.round(d * 1000) + ' deep: sole ' + Math.round(soleW * 1000) + ' between the eave plates at ' + Math.round(ySole * 1000) +
              ', apex under the rafters at ' + Math.round(apex * 1000) + ', rake at ' + S.deg + ' deg');
      ctx.log('gable    ' + nStud + ' studs and pieces ' + Math.round(t * 1000) + 'x' + Math.round(d * 1000) + ', ' + studLen.toFixed(1) + ' m + plates, headers and sills ' + plateLen.toFixed(1) + ' m = ' + GABLE.code + ' ' +
              ((studLen + plateLen) * 1.05).toFixed(1) + ' m (+5%); sill seal ' + GABLE.seal + ' ' + sealLen.toFixed(1) + ' m');
      ctx.log('FIX  gable frame ' + nNail + ' x FAS45145: ' + nStud + ' member(s) 2 through the plate at each end, ' + nNail2 + ' for jacks to kings every 400 and the headers, sills and band plates');
      ctx.log('open     Doors & Windows is the core\'s (as in the ADU): the units go in the two gables only, a roof window on a slope; ' + (STATE.openings || []).length + ' opening(s) in the project');
      ctx.log('gable    the build-up, outside in (aframe-v148): OSB + membrane + the units (here), rainscreen battens + rodent mesh + cladding (aframe-facade), the soffit under the rake overhang (aframe-frame); the wool, the barrier, the service battens, the gypsum and the casings from the room (aframe-lining)');
      /* THE GABLES UNDER REVIEW (aframe-v148, plan G): this layer's OSB, membrane and units by their walk item; the frame is the bearing structure round them */
      if (_isAdmin() && AF_STEP.gable < 99) {
        var nGr = _rvTagList(T, g.children.slice(kG0), function (o) { var k = _asmKey(o); return k === 'layer_osb' ? 'osb' : k === 'layer_breather_membrane' ? 'memb' : /^(windows_doors|glazing|glazing_cap|curtain_wall)$/.test(k) ? 'units' : ''; }, _gableDefs(), AF_STEP.gable);
        ctx.log(_gableRvNote('gable    ', nGr) + ' -- the OSB, the membrane and the units of this layer');
      }
      (function () { var ks = [], kM; for (kM in MISSING) if (MISSING.hasOwnProperty(kM)) ks.push(kM + ' = ' + MISSING[kM]);
        ctx.log('MISSING  catalogue items still to make (billed on placeholders where used): ' + (ks.length ? ks.join(' | ') : 'none -- every item is billed on its catalogue row')); })();
    }
    _regLayer({
      id: 'aframe-gables', version: VERSION, role: 'nosna', claims: ['wall'],
      build3d: _buildGables, boq: function () { return _rows('aframe-gables').concat(_rows('aframe-balcony') || []); }
    });

    /* -------------------------------------------------------------------------
       THE GABLES' FACADE, A RAINSCREEN (aframe-v47, layer 6 of the envelope,
       the ADU's wall rule). Outside the OSB and the membrane:
         vertical battens KVH40060 (40 x 60) on every stud that runs to the
         rake -- the kings round the units among them -- and one along each
         rake, so the board ends under the verge are held; screwed FAS60100
         every 600 (two at the least);
         horizontal boards FVW01351, 135 x 15, laid with a 6 mm open joint,
         from the deck up to the underside of the rake overhang (the lookouts),
         so the gable rafter's face is covered too; cut round every unit and a
         glazed triangle; nailed FAS70000, two where a board crosses a batten;
         the rodent mesh FEC00034 across the cavity's foot, the doors left out.
       The boards take the Facade finish colour; while the layer is under
       review (LAYER_STEP 6) they are magenta and the battens show between.
       ------------------------------------------------------------------------- */
    var FAC = { batt: { code: 'KVH40060', d: 0.040, f: 0.060, screw: 'FAS60100', step: 0.600 },
                clad: { code: 'FVW01351', w: 0.135, t: 0.015, gap: 0.006, nail: 'FAS70000', step: 0.600 },
                mesh: 'FEC00034', memb: 0.002 };
    /* the rodent mesh drawn at the cavity's foot (aframe-v148): magenta for an admin until Marek has checked it */
    var MESH_REVIEW = true;
    /* THE UNITS' OUTSIDE TRIM (aframe-v162): since the EPS the reveal round a
       window or a door showed the battens' and the EPS's edges 120 - 160
       deep. Now: the reveal lined with a planed plank ripped to its depth
       (KVR16019, 19 thick, from the unit's frame out to the boards' face) on
       the sides and the head; on the boards' face a casing of 100 x 19
       (KVR10019) round it, the head over the legs, the legs standing on the
       outer sill (a window) or the threshold (a door); a drip cap over the
       head (ROM02401, the roof's drip edge); stainless screws FAS45070 every
       400, two a piece at the least; the frame's joint sealed (FEC00038, a
       cartridge per 10 m). The outer sill now reaches 30 past the boards and
       runs under the casing's legs. Outdoor wood: sealed and top coated */
    var TRIM = { lin: 'KVR16019', cas: 'KVR10019', t: 0.019, w: 0.100, drip: 'ROM02401', screw: 'FAS45070', step: 0.40, seal: 'FEC00038', sealM: 10, col: 0xD9D2C3, frameD: 0.068 };
    /* one unit's trim in its own frame: a(u) across the wall, b(v) up, c(w) out of the wall from the frame's outer face (0) to
       the boards' face (dep) and on; box(a0, a1, b0, b1, c0, c1) draws; returns the lengths billed */
    function _trimUnit(box, a0, a1, b0, b1, dep, door) {
      var t = TRIM.t, w = TRIM.w, L = { lin: 0, cas: 0, drip: 0, n: 0 };
      /* aframe-v172: each piece says what it is -- the reveals 'lin' (KVR16019 ripped), the casing 'cas' (KVR10019) */
      box(a0, a0 + t, b0, b1, 0, dep, 'lin'); box(a1 - t, a1, b0, b1, 0, dep, 'lin'); box(a0, a1, b1 - t, b1, 0, dep, 'lin');
      L.lin += 2 * (b1 - b0) + (a1 - a0); L.n += 3;
      var cl0 = a0 - w + t, cl1 = a1 + w - t;
      box(cl0, a0 + t, b0, b1 - t, dep, dep + t, 'cas'); box(a1 - t, cl1, b0, b1 - t, dep, dep + t, 'cas'); box(cl0, cl1, b1 - t, b1 - t + w, dep, dep + t, 'cas');
      L.cas += 2 * (b1 - t - b0) + (cl1 - cl0); L.n += 3;
      box(cl0 - 0.010, cl1 + 0.010, b1 - t + w, b1 - t + w + 0.002, dep - 0.010, dep + t + 0.012, 'drip');
      box(cl0 - 0.010, cl1 + 0.010, b1 - t + w - 0.015, b1 - t + w, dep + t + 0.010, dep + t + 0.012, 'drip');
      L.drip += cl1 - cl0 + 0.02;
      L.screw = Math.max(2, Math.ceil((b1 - b0) / TRIM.step)) * 4 + Math.max(2, Math.ceil((a1 - a0) / TRIM.step)) * 2;
      L.perim = 2 * (b1 - b0) + 2 * (a1 - a0) - (door ? (a1 - a0) : 0);
      return L;
    }
    function _trimBill(L0, T9, ctx, who) {
      if (!T9 || !T9.n) return;
      API.billAdd(L0, TRIM.lin, Math.round(T9.lin * 1.10 * 100) / 100);
      API.billAdd(L0, TRIM.cas, Math.round(T9.cas * 1.10 * 100) / 100);
      API.billAdd(L0, TRIM.drip, Math.round(T9.drip * 1.05 * 100) / 100);
      API.billAdd(L0, TRIM.screw, T9.screw);
      API.billAdd(L0, TRIM.seal, Math.max(1, Math.ceil(T9.perim / TRIM.sealM)));
      ctx.log('trim     outside, ' + who + ' (aframe-v162): ' + T9.units + ' unit(s) -- the reveals lined ' + TRIM.lin + ' ' + (T9.lin * 1.10).toFixed(2) + ' m (ripped to ' + Math.round(T9.dep * 1000) + ' deep, +10 %), casing ' + TRIM.cas + ' ' + (T9.cas * 1.10).toFixed(2) + ' m, drip cap ' + TRIM.drip + ' ' + (T9.drip * 1.05).toFixed(2) + ' m, ' + T9.screw + ' x ' + TRIM.screw + ', ' + Math.max(1, Math.ceil(T9.perim / TRIM.sealM)) + ' x ' + TRIM.seal + ' at the frame (' + T9.perim.toFixed(1) + ' m); outdoor wood');
    }
    function _buildFacade(ctx) {
      var T = ctx.THREE, g = ctx.group;
      _bill['aframe-facade'] = {};
      var kF0 = g.children.length, meshD = 0;
      if (REVIEW === 'stairs' || REVIEW === 'gables') { ctx.log('facade   hidden while the ' + REVIEW + ' are under review (REVIEW)'); return; }
      var G = _gGeo(), S = G.S, cx = G.cx, tG = GABLE.t, e, q;
      var yTop0 = S.top + S.half * S.tan, lkH = 0.060 / S.cos;
      /* the boards' top line: the underside of the lookouts under the rake overhang */
      var yTopL = function (x) { return yTop0 - Math.abs(x - cx) * S.tan - lkH; };
      var y0 = S.deck, xHalf = (yTopL(cx) - y0) / S.tan;
      var colC = _layerCol(6, (API.colorSlotOf ? API.colorSlotOf('gable') : 0xB8875A));
      var cMat = new T.MeshStandardMaterial({ color: colC, roughness: 0.8 });
      var bMat = new T.MeshStandardMaterial({ color: WOOD, roughness: 0.85 });
      var tent = function (poly) {
        var L2 = [[S.tan, yTopL(cx) - S.tan * cx], [-S.tan, yTopL(cx) + S.tan * cx]], li, out = poly;
        for (li = 0; li < 2; li++) {
          var m = L2[li][0], c = L2[li][1], inp = out, k2; out = [];
          var ins = function (P) { return P[1] <= m * P[0] + c + 1e-9; };
          for (k2 = 0; k2 < inp.length; k2++) {
            var P = inp[k2], Q = inp[(k2 + 1) % inp.length], iP = ins(P), iQ = ins(Q);
            if (iP) out.push(P);
            if (iP !== iQ) { var fP = P[1] - (m * P[0] + c), fQ = Q[1] - (m * Q[0] + c), tq = fP / (fP - fQ); out.push([P[0] + tq * (Q[0] - P[0]), P[1] + tq * (Q[1] - P[1])]); }
          }
          if (out.length < 3) return [];
        }
        return out;
      };
      var area = function (P) { var a = 0, i; for (i = 0; i < P.length; i++) { var p1 = P[i], p2 = P[(i + 1) % P.length]; a += p1[0] * p2[1] - p2[0] * p1[1]; } return Math.abs(a) / 2; };
      var slab = function (P, zA, dz, mat) {
        var sh = new T.Shape(), i; sh.moveTo(P[0][0], P[0][1]); for (i = 1; i < P.length; i++) sh.lineTo(P[i][0], P[i][1]); sh.lineTo(P[0][0], P[0][1]);
        var geo = new T.ExtrudeGeometry(sh, { depth: dz, bevelEnabled: false }); geo.translate(0, 0, zA); g.add(new T.Mesh(geo, mat));
      };
      var cutRun = function (a0, a1, cuts) {
        var out = [[a0, a1]], c2, p2;
        for (c2 = 0; c2 < cuts.length; c2++) { var nx = []; for (p2 = 0; p2 < out.length; p2++) { if (cuts[c2][1] <= out[p2][0] || cuts[c2][0] >= out[p2][1]) { nx.push(out[p2]); continue; } if (cuts[c2][0] > out[p2][0]) nx.push([out[p2][0], cuts[c2][0]]); if (cuts[c2][1] < out[p2][1]) nx.push([cuts[c2][1], out[p2][1]]); } out = nx; }
        return out;
      };
      var battLen = 0, nScrew = 0, cladA = 0, nNail = 0, meshL = 0, nBoard = 0, notes = [], ciT = _ciT(), ciA = 0, nCi = 0;
      var trimT = { lin: 0, cas: 0, drip: 0, screw: 0, perim: 0, n: 0, units: 0, dep: 0 };
      var ciMat = new T.MeshStandardMaterial({ color: CI.col, roughness: 0.95 });
      for (e = 0; e < 2; e++) {
        var M = _gMem[e], side = e ? 'back' : 'front';
        if (!M) { notes.push(side + ': the gable frame was not built, no facade'); continue; }
        /* A FULLY GLAZED GABLE CARRIES NO CLADDING (aframe-v63, Marek: full wall
           window nema mit okolo dreveny obklad) -- the glass reaches the rake */
        if (M.full) { notes.push(side + ': full glazing, no rainscreen'); continue; }
        /* the EPS between the membrane and the battens from zone 4 (aframe-v158) */
        var zO = M.zOut, o = M.out, zE0 = zO + o * (SHEATH.t + FAC.memb), zB0 = zE0 + o * ciT, zC0 = zB0 + o * FAC.batt.d;
        var zBat = (o < 0) ? zB0 - FAC.batt.d : zB0, zCl = (o < 0) ? zC0 - FAC.clad.t : zC0;
        /* what the boards and battens stop at: the units (their frames' outer face) and a glazed triangle */
        var holes = [], hq;
        for (hq = 0; hq < M.holes.length; hq++) { var H = M.holes[hq]; holes.push([Math.min(H.x0, H.x1), Math.max(H.x0, H.x1), H.y0, H.y1]); }
        var RU = M.ru;
        /* WHERE THE GLASS REACHES THE RAFTER NOTHING IS CLAD OVER IT (aframe-v89,
           Marek: zadne dorezavane obklady okolo): over those columns the boards
           and the rake batten stop, from the glass's foot up to the rake
           overhang -- the gable rafter's face shows there, as over a full glazing */
        var cols = [];
        if (RU && RU.half) RU.rects.forEach(function (Rc) {
          var dMin = (G.yUnder(cx) - Rc[3]) / S.tan, a1 = Math.max(Rc[0], -1e9), b1 = Math.min(Rc[1], cx - dMin), a2 = Math.max(Rc[0], cx + dMin), b2 = Math.min(Rc[1], 1e9);
          if (dMin < 1e-6) { cols.push({ a: Rc[0], b: Rc[1], y0: Rc[2] }); return; }
          if (b1 - a1 > 0.005) cols.push({ a: a1, b: b1, y0: Rc[2] });
          if (b2 - a2 > 0.005) cols.push({ a: a2, b: b2, y0: Rc[2] });
        });
        var xCutAt = function (ya, yb) {
          var cs = [], k;
          for (k = 0; k < holes.length; k++) if (holes[k][3] > ya + 0.001 && holes[k][2] < yb - 0.001) cs.push([holes[k][0], holes[k][1]]);
          if (RU && RU.apex > ya && RU.yB < yb) { var xr = RU.xRuns(ya, yb), kx; for (kx = 0; kx < xr.length; kx++) cs.push(xr[kx]); }
          for (k = 0; k < cols.length; k++) if (yb > cols[k].y0 + 0.001) cs.push([cols[k].a, cols[k].b]);
          return cs;
        };
        /* the battens: every member that runs to the rake, split round the units */
        var xs = [], vq, nB = 0, lenE = 0;
        for (vq = 0; vq < M.verts.length; vq++) {
          var V = M.verts[vq];
          /* on a partly glazed gable the studs standing on a header over the glass carry battens too (aframe-v64) */
          var toRake = Math.abs(V.y1 - G.yPlate(V.x)) < 0.01, fromSole = V.y0 < G.yStud0 + 0.02, onHead = !!(RU && RU.half && RU.heads.length);
          if (toRake && (fromSole || onHead) && !xs.some(function (x9) { return Math.abs(x9 - V.x) < 0.01; })) xs.push(V.x);
        }
        xs.sort(function (a, b) { return a - b; });
        for (vq = 0; vq < xs.length; vq++) {
          var xb = xs[vq], topB = Math.min(yTopL(xb - FAC.batt.f / 2), yTopL(xb + FAC.batt.f / 2)) - 0.005, cy = [], hk;
          for (hk = 0; hk < holes.length; hk++) if (xb > holes[hk][0] - FAC.batt.f / 2 && xb < holes[hk][1] + FAC.batt.f / 2) cy.push([holes[hk][2], holes[hk][3]]);
          if (RU) { var yr = RU.yRuns(xb - FAC.batt.f / 2, xb + FAC.batt.f / 2), ky; for (ky = 0; ky < yr.length; ky++) cy.push(yr[ky]); }
          var ys = cutRun(y0, topB, cy);
          for (hk = 0; hk < ys.length; hk++) {
            var hB = ys[hk][1] - ys[hk][0]; if (hB < 0.10) continue;
            var bb = new T.Mesh(new T.BoxGeometry(FAC.batt.f, hB, FAC.batt.d), bMat);
            bb.position.set(xb, (ys[hk][0] + ys[hk][1]) / 2, zBat + FAC.batt.d / 2); _am(ctx, 'layer_vented_battens', 'Battens', FAC.batt.code, 'side'); g.add(bb);
            lenE += hB; nB++; nScrew += Math.max(2, Math.round(hB / FAC.batt.step) + 1);
          }
        }
        /* one along each rake, under the boards' top line */
        var sd, nRakeCut = 0;
        for (sd = -1; sd <= 1; sd += 2) {
          /* the rake batten in the pieces the glass columns leave (aframe-v89) */
          var dCuts = [], cq;
          for (cq = 0; cq < cols.length; cq++) { var da9 = sd * (cols[cq].a - cx), db9 = sd * (cols[cq].b - cx); dCuts.push([Math.min(da9, db9), Math.max(da9, db9)]); }
          var dPcs = cutRun(0, xHalf, dCuts), dq9;
          if (dPcs.length !== 1 || dPcs[0][1] - dPcs[0][0] < xHalf - 1e-6) nRakeCut++;
          for (dq9 = 0; dq9 < dPcs.length; dq9++) {
            var dm = (dPcs[dq9][0] + dPcs[dq9][1]) / 2, rakeL = (dPcs[dq9][1] - dPcs[dq9][0]) / S.cos;
            if (rakeL < 0.10) continue;
            var rb = new T.Mesh(new T.BoxGeometry(rakeL, FAC.batt.f, FAC.batt.d), bMat);
            rb.position.set(cx + sd * dm, yTopL(cx) - dm * S.tan - (FAC.batt.f / 2) / S.cos, zBat + FAC.batt.d / 2);
            rb.rotation.z = -sd * S.p; _am(ctx, 'layer_vented_battens', 'Battens', FAC.batt.code, 'side'); g.add(rb);
            lenE += rakeL; nB++; nScrew += Math.max(2, Math.round(rakeL / FAC.batt.step) + 1);
          }
        }
        if (cols.length) notes.push(side + ': no boards over the glass where it reaches the rafter (' + cols.map(function (c) { return Math.round((c.a - cx) * 1000) + '..' + Math.round((c.b - cx) * 1000); }).join(', ') + ' from the ridge line), the rake batten cut there (' + nRakeCut + ' side(s))');
        battLen += lenE;
        /* the boards, course by course from the deck */
        var pitch = FAC.clad.w + FAC.clad.gap, yc, aE = 0, nE = 0;
        for (yc = y0; yc < yTopL(cx) - 0.005; yc += pitch) {
          var yd = Math.min(yc + FAC.clad.w, yTopL(cx)), hw0 = Math.max(0, (yTopL(cx) - yc) / S.tan);
          var runs = cutRun(cx - hw0, cx + hw0, xCutAt(yc, yd)), rq;
          for (rq = 0; rq < runs.length; rq++) {
            if (runs[rq][1] - runs[rq][0] < 0.02) continue;
            var P = tent([[runs[rq][0], yc], [runs[rq][1], yc], [runs[rq][1], yd], [runs[rq][0], yd]]);
            if (P.length < 3) continue;
            var aP = area(P); if (aP < 0.0005) continue;
            _am(ctx, 'sauna_ui_cladding', 'Cladding', FAC.clad.code, 'side'); slab(P, zCl, FAC.clad.t, cMat);
            aE += aP; nE++;
            var nX = 0, bx;
            for (bx = 0; bx < xs.length; bx++) if (xs[bx] > runs[rq][0] && xs[bx] < runs[rq][1]) nX++;
            nNail += 2 * (nX + 2);          /* the studs' battens it crosses, and the rake battens at its two ends */
          }
        }
        cladA += aE; nBoard += nE;
        /* THE UNITS' OUTSIDE TRIM (aframe-v162): from the frame's outer face (the unit stands in the middle of the 160 wall) out */
        var zFr = (M.z != null ? M.z : zO - o * GABLE.d / 2) + o * TRIM.frameD / 2, zBd = zC0 + o * FAC.clad.t, depT = Math.abs(zBd - zFr);
        /* in the Facade finish's colour, the drip cap in the metal's (the Colors step drives both) */
        var tMat = new T.MeshStandardMaterial({ color: colC, roughness: 0.8 }), dMat = new T.MeshStandardMaterial({ color: API.colorSlotOf ? API.colorSlotOf('metal') : 0x8A8F94, roughness: 0.5, metalness: 0.5 });
        var tBox = function (a0, a1, b0, b1, c0, c1, kind) {
          if (a1 - a0 < 0.001 || b1 - b0 < 0.001) return;
          var za = zFr + o * c0, zb = zFr + o * c1;
          var m9 = new T.Mesh(new T.BoxGeometry(a1 - a0, b1 - b0, Math.abs(zb - za)), kind === 'drip' ? dMat : tMat);
          m9.position.set((a0 + a1) / 2, (b0 + b1) / 2, (za + zb) / 2);
          if (kind === 'drip') _am(ctx, 'windows_doors', 'Drip cap', TRIM.drip, 'side');
          else if (kind === 'lin') _am(ctx, 'windows_doors', 'Reveal lining', TRIM.lin, 'side');   /* aframe-v172: the reveals were tagged the casing's code */
          else _am(ctx, 'windows_doors', 'Exterior trim', TRIM.cas, 'side');
          g.add(m9);
        };
        for (hq = 0; hq < M.holes.length; hq++) {
          var HT = M.holes[hq], hx0 = Math.min(HT.x0, HT.x1), hx1 = Math.max(HT.x0, HT.x1), hb0 = HT.door ? Math.max(HT.y0, y0) : (HT.yB != null ? HT.yB : HT.y0);
          var LT = _trimUnit(tBox, hx0, hx1, hb0, HT.y1, depT, HT.door);
          trimT.lin += LT.lin; trimT.cas += LT.cas; trimT.drip += LT.drip; trimT.screw += LT.screw; trimT.perim += LT.perim; trimT.n += LT.n; trimT.units++; trimT.dep = depT;
        }
        /* THE EPS (aframe-v158): courses of 600 from the deck, cut round the units and the glass as the boards are, up under the rake overhang */
        if (ciT > 0) {
          var ycE, aCi = 0;
          for (ycE = y0; ycE < yTopL(cx) - 0.005; ycE += 0.600) {
            var ydE = Math.min(ycE + 0.600, yTopL(cx)), hwE = Math.max(0, (yTopL(cx) - ycE) / S.tan);
            var runsE = cutRun(cx - hwE, cx + hwE, xCutAt(ycE, ydE)), rqE;
            for (rqE = 0; rqE < runsE.length; rqE++) {
              if (runsE[rqE][1] - runsE[rqE][0] < 0.02) continue;
              var PE = tent([[runsE[rqE][0], ycE], [runsE[rqE][1], ycE], [runsE[rqE][1], ydE], [runsE[rqE][0], ydE]]);
              if (PE.length < 3) continue;
              var aPE = area(PE); if (aPE < 0.0005) continue;
              _am(ctx, 'layer_eps', 'EPS insulation', CI.code, 'side'); slab(PE, (o < 0) ? zB0 : zE0, ciT, ciMat);
              aCi += aPE; nCi++;
            }
          }
          ciA += aCi;
          notes.push(side + ': EPS ' + Math.round(ciT * 1000) + ' ' + CI.code + ' ' + aCi.toFixed(2) + ' m2 in courses of 600 under the battens');
        }
        /* the mesh across the cavity's foot, the doors left out */
        var footW = 2 * Math.max(0, (yTopL(cx) - y0) / S.tan), dW = 0, mCuts = [];
        for (hq = 0; hq < holes.length; hq++) if (holes[hq][2] < y0 + 0.05) { dW += holes[hq][1] - holes[hq][0]; mCuts.push([holes[hq][0], holes[hq][1]]); }
        if (RU && RU.yB < y0 + 0.10) RU.xRuns(RU.yB, RU.yB + 0.05).forEach(function (r) { dW += r[1] - r[0]; mCuts.push([r[0], r[1]]); });
        meshL += Math.max(0, footW - dW);
        /* THE MESH DRAWN (aframe-v148, plan G): a perforated angle closing the
           cavity's foot -- the leg across the cavity under the battens and the
           boards, the upstand on the membrane -- broken at the doors; it was
           billed and not drawn */
        var mRuns = cutRun(cx - footW / 2, cx + footW / 2, mCuts), mq, mMat = new T.MeshStandardMaterial({ color: (MESH_REVIEW && _isAdmin()) ? MAGENTA : 0x3A3D40, roughness: 0.6, metalness: 0.4 });
        _am(ctx, 'layer_rodent_mesh', 'Rodent mesh', FAC.mesh, 'side');
        for (mq = 0; mq < mRuns.length; mq++) {
          var mw = mRuns[mq][1] - mRuns[mq][0]; if (mw < 0.05) continue;
          var mxm = (mRuns[mq][0] + mRuns[mq][1]) / 2, mzA = zB0 + o * FAC.batt.d / 2, mzU = zB0 + o * 0.001;
          var mB = new T.Mesh(new T.BoxGeometry(mw, 0.002, FAC.batt.d), mMat); mB.position.set(mxm, y0 - 0.001, mzA); g.add(mB);
          var mU = new T.Mesh(new T.BoxGeometry(mw, 0.050, 0.002), mMat); mU.position.set(mxm, y0 + 0.025, mzU); g.add(mU);
          meshD += mw;
        }
        notes.push(side + ': ' + nB + ' batten(s) ' + lenE.toFixed(1) + ' m (' + xs.length + ' on the studs, 2 along the rakes), ' + nE + ' board piece(s) ' + aE.toFixed(2) + ' m2, ' + holes.length + ' unit(s)' + (RU ? ' and the glazing' : '') + ' cut out, mesh ' + Math.max(0, footW - dW).toFixed(2) + ' m');
      }
      _envA = { gab: cladA, wingW: 0, dormW: 0, dormT: 0 };   /* the opaque gable for the total UA check (aframe-v160) */
      _trimBill('aframe-facade', trimT, ctx, 'gables');
      API.billAdd('aframe-facade', FAC.batt.code, battLen * 1.05);
      API.billAdd('aframe-facade', (ciT > 0) ? CI.battScrew : FAC.batt.screw, nScrew);
      if (ciA > 0.01) {
        var nBdCi = Math.ceil(ciA / CI.board), nFoamCi = Math.ceil(ciA / CI.foamPer);
        API.billAdd('aframe-facade', CI.code, Math.round(ciA * 1.05 * 100) / 100);
        API.billAdd('aframe-facade', CI.plate, nBdCi * CI.perBoard);
        API.billAdd('aframe-facade', CI.screw, nBdCi * CI.perBoard);
        API.billAdd('aframe-facade', CI.foam, nFoamCi);
        ctx.log('facade   CONTINUOUS LAYER (aframe-v158, zone ' + _iecc().cz + '): EPS ' + Math.round(ciT * 1000) + ' ' + CI.code + ' R-' + _rOf(ciT, R_IN.eps) + ' on the membrane under the battens, ' + ciA.toFixed(2) + ' m2 in ' + nCi + ' piece(s) -> ' + (ciA * 1.05).toFixed(2) + ' m2 (+5%), ' + nBdCi + ' board(s) x ' + CI.perBoard + ' plate anchors ' + CI.plate + ' + ' + CI.screw + ', PU foam ' + CI.foam + ' ' + nFoamCi + ' (one per ' + CI.foamPer + ' m2); the battens screwed through it with ' + CI.battScrew);
      } else ctx.log('facade   no continuous layer: zone ' + _iecc().cz + ' takes the R-25 cavity alone (aframe-v158; from zone 4 EPS ' + Math.round(CI.t * 1000) + ' goes on)');
      API.billAdd('aframe-facade', FAC.clad.code, cladA * 1.08);
      API.billAdd('aframe-facade', FAC.clad.nail, nNail);
      API.billAdd('aframe-facade', FAC.mesh, meshL * 1.05);
      ctx.log('facade   rainscreen on the gables: battens ' + FAC.batt.code + ' 40x60 on the OSB and membrane, boards ' + FAC.clad.code + ' 135x15 laid level with a 6 open joint, from the deck at ' + Math.round(y0 * 1000) + ' up to the rake overhang\'s underside (the lookouts), the Facade finish colour' + (LAYER_STEP === 6 ? ' -- MAGENTA, under review' : ''));
      for (q = 0; q < notes.length; q++) ctx.log('facade   ' + notes[q]);
      ctx.log('facade   rodent mesh ' + FAC.mesh + ' drawn (aframe-v148): an angle at the cavity\'s foot, ' + meshD.toFixed(2) + ' m on both gables, broken at the doors' + ((MESH_REVIEW && _isAdmin()) ? ' -- MAGENTA until checked' : ''));
      /* THE GABLES UNDER REVIEW (aframe-v148, plan G): the battens with the mesh, the boards */
      if (_isAdmin() && AF_STEP.gable < 99) {
        var nFr = _rvTagList(T, g.children.slice(kF0), function (o) { var k = _asmKey(o); return (k === 'layer_vented_battens' || k === 'layer_rodent_mesh') ? 'batt' : (k === 'sauna_ui_cladding' || k === 'windows_doors') ? 'clad' : k === 'layer_eps' ? 'ci' : ''; }, _gableDefs(), AF_STEP.gable);
        ctx.log(_gableRvNote('facade   ', nFr) + ' -- the rainscreen battens with the mesh and the boards');
      }
      ctx.log('facade   BILL ' + FAC.batt.code + ' ' + (battLen * 1.05).toFixed(1) + ' m (+5%), ' + nScrew + ' x ' + FAC.batt.screw + ' (every 600, 2 at the least); ' + FAC.clad.code + ' ' + (cladA * 1.08).toFixed(2) + ' m2 (' + cladA.toFixed(2) + ' + 8% for the raked cuts), ' + nNail + ' x ' + FAC.clad.nail + ' (2 a batten crossing); ' + FAC.mesh + ' ' + (meshL * 1.05).toFixed(2) + ' m (+5%)');
    }
    _regLayer({
      id: 'aframe-facade', version: VERSION, role: 'finishes', claims: ['facade'],
      build3d: _buildFacade, boq: function () { return _rows('aframe-facade'); }
    });

    /* -------------------------------------------------------------------------
       THE FRAME AND THE FLOORS. Rafters on both slopes every 600 from the
       plinth to the ridge beam, a ridge beam under the ridge, and on every
       upper floor its joists across the A -- which are the collar ties -- with
       the deck on them. 60x200 rafters up to 6 m wide, 60x240 above.
       ------------------------------------------------------------------------- */
    /* WHERE THE ROOF WINDOWS GO, AND THE RAFTERS ROUND THEM (aframe-v25).
       Each window is a record in STATE.openings with host 'roof', in the
       middle of a bay. That bay's two rafter pairs are moved apart to the
       window's width plus the fitting room -- the pairs cross the ridge, so
       they move on both slopes -- and the bays either side give up as much.
       Two windows may not pull one rafter line both ways. s is the distance
       down the top face from the ridge line, u = s cos p its reach. */
    function _roofWinPlan(S, R, B, RG, yTop0) {
      var n = RG.n, bw = function (kq) { return (kq >= 0 && kq < n) ? (RG.lines[kq + 1] - RG.lines[kq]) : 1; };
      var out = { wins: [], lines: [], sisters: [], skipped: [], moved: {} }, OP = STATE.openings || [], i, k, tt = R.t, Q = _roofGeo();
      var move = [], used = {}, cand = [];
      for (k = 0; k <= n; k++) { out.lines.push(RG.lines[k]); move.push(0); }
      for (i = 0; i < OP.length; i++) {
        var o = OP[i];
        if (!o || o.host !== 'roof') continue;
        if (_winUnderWing(o)) { out.skipped.push(((o.plane === 'left') ? 'left' : 'right') + ' ' + (o.code || 'roof window') + ' at z ' + Math.round((+o.along || 0) * 1000) + ': put away while the side wing is there (kept in the project)'); continue; }
        _roofFit(o);
        var side = (o.plane === 'left') ? -1 : 1, nm = (side < 0) ? 'left' : 'right', sz = _rwSizeOf(o);
        if (o.fitNote) { out.skipped.push(nm + ' ' + (sz.code || 'roof window') + ': ' + o.fitNote); continue; }
        var kb = _bayOf(RG, +o.along || 0), spB = bw(kb);
        if (_wingSides().length) { var WGw = _wingGrid(); if (RG.lines[kb + 1] > WGw.cz - WGw.half - 0.001 && RG.lines[kb] < WGw.cz + WGw.half + 0.001) { out.skipped.push(nm + ' ' + (sz.code || 'roof window') + ' in bay ' + (kb + 1) + ': the rafters there are set by the side wing -- put away while the wing is there'); continue; } }
        if (kb < 0 || kb >= n) { out.skipped.push(nm + ' ' + sz.code + ': not over a bay'); continue; }
        var roHc = sz.h + 2 * ROOFWIN.gap, sMc = Q.Ltop - o.up, prev = used[kb];
        if (prev && prev.code !== sz.code) { out.skipped.push(nm + ' ' + sz.code + ' in bay ' + (kb + 1) + ': that bay holds ' + prev.code + ' -- only the same window goes in one bay'); continue; }
        if (prev) {
          var ovl = false, pj;
          for (pj = 0; pj < prev.list.length; pj++) if (prev.list[pj][2] === nm && Math.abs(sMc - prev.list[pj][0]) < (prev.list[pj][1] + roHc) / 2 + 2 * tt - 1e-6) ovl = true;
          if (ovl) { out.skipped.push(nm + ' ' + sz.code + ' in bay ' + (kb + 1) + ': it overlaps the window above or below it -- move one'); continue; }
        }
        var clr = sz.w + ROOFWIN.fit, dd = Math.max(0, (clr - (spB - tt)) / 2);
        /* line kb goes towards z0, line kb+1 away from it; neither may already be pulled the other way */
        if (!prev && (move[kb] > 1e-6 || move[kb + 1] < -1e-6)) { out.skipped.push(nm + ' ' + sz.code + ' in bay ' + (kb + 1) + ': the bay next to it has a window, the rafter between them cannot move both ways -- leave a bay between them'); continue; }
        var nb0 = (kb > 0) ? (bw(kb - 1) - tt - dd - Math.max(0, move[kb - 1])) : 1;
        var nb1 = (kb + 1 < n) ? (bw(kb + 1) - tt - dd + Math.min(0, move[kb + 2] || 0)) : 1;
        if (!prev && (nb0 < ROOFWIN.minBay || nb1 < ROOFWIN.minBay)) { out.skipped.push(nm + ' ' + sz.code + ' in bay ' + (kb + 1) + ': a bay beside it would close under ' + Math.round(ROOFWIN.minBay * 1000)); continue; }
        move[kb] = Math.min(move[kb], -dd); move[kb + 1] = Math.max(move[kb + 1], dd);
        if (!prev) used[kb] = prev = { code: sz.code, list: [] };
        prev.list.push([sMc, roHc, nm]);
        cand.push({ i: i, o: o, side: side, nm: nm, sz: sz, kb: kb, clr: clr, dd: dd });
      }
      for (k = 0; k <= n; k++) { out.lines[k] += move[k]; if (Math.abs(move[k]) > 1e-6) out.moved[k] = move[k]; }
      var sis = {};
      for (i = 0; i < cand.length; i++) {
        var C = cand[i], zc = (out.lines[C.kb] + out.lines[C.kb + 1]) / 2, roH = C.sz.h + 2 * ROOFWIN.gap;
        var sM = Q.Ltop - C.o.up, sT = sM - roH / 2, sB = sM + roH / 2;
        C.o.along = zc;
        var kA = C.side + '|' + C.kb, kB = C.side + '|' + (C.kb + 1);
        if (!sis[kA]) { sis[kA] = 1; out.sisters.push({ side: C.side, z: out.lines[C.kb] - tt }); }
        if (!sis[kB]) { sis[kB] = 1; out.sisters.push({ side: C.side, z: out.lines[C.kb + 1] + tt }); }
        out.wins.push({ idx: C.i, side: C.side, z: zc, kb: C.kb, clr: out.lines[C.kb + 1] - out.lines[C.kb] - tt, sz: C.sz, roH: roH, sT: sT, sB: sB, st: C.o.storey | 0,
                        ySill: yTop0 - sB * S.sin - R.d / S.cos, yHead: yTop0 - sT * S.sin - R.d / S.cos });
      }
      return out;
    }
    /* THE WINDOWS, THE DOUBLED RAFTERS AND THE BLOCKS, drawn and billed
       (aframe-v25). The window's meshes carry opRoof / opIndex, which is how
       the core's Edit picks one up. */
    function _buildRoofWins(ctx, RW, rafter, S, R, cx, yTop0) {
      var T = ctx.THREE, g = ctx.group, i, k, tt = R.t;
      var mv = [], km;
      for (km in RW.moved) if (RW.moved.hasOwnProperty(km)) mv.push('line ' + km + ' ' + (RW.moved[km] > 0 ? '+' : '') + Math.round(RW.moved[km] * 1000));
      if (RW.skipped.length) ctx.log('roofwin  skipped: ' + RW.skipped.join('; '));
      if (_rwTrimmed) ctx.log('roofwin  ' + _rwTrimmed);
      if (!RW.wins.length) { ctx.log('roofwin  none on the slopes (tap a slope with a roof window picked in Doors & Windows); the rafters stay on the plain ' + Math.round(RAF.sp * 1000) + ' grid'); return; }
      var at = function (side, s, o) { return { x: cx + side * (s * S.cos + o * S.sin), y: yTop0 - s * S.sin + o * S.cos }; };
      var slab = function (side, s, o, along, thick, len, z, col, op, idx) {
        var P = at(side, s, o), m = new T.Mesh(new T.BoxGeometry(along, thick, len),
          new T.MeshStandardMaterial({ color: col, roughness: 0.6, transparent: op < 1, opacity: op, depthWrite: op >= 1 }));
        m.position.set(P.x, P.y, z); m.rotation.z = -side * S.p;
        if (idx != null) { m.userData.opRoof = true; m.userData.opIndex = idx; }
        g.add(m);
        return m;
      };
      var lumS = 0, lumB = 0, nSis = RW.sisters.length, nBlk = 0, nNail = 0, perim = 0, codes = {}, cc, cl = [], Lr = (S.w / 2) / S.cos;
      /* the doubling rafters, full length, on the outer face of the bay's two rafters, on the window's slope */
      for (i = 0; i < RW.sisters.length; i++) {
        var wbS = _wingBeamAt(RW.sisters[i].side, RW.sisters[i].z);      /* a doubling rafter under a side wing stops on its beam too (aframe-v103) */
        lumS += rafter(RW.sisters[i].side, RW.sisters[i].z, null);      /* whole to the plate since aframe-v123 */
        nNail += 2 * Math.ceil(Lr / 0.40);
      }
      for (i = 0; i < RW.wins.length; i++) {
        var W = RW.wins[i], side = W.side, z = W.z, sz = W.sz, sT = W.sT, sB = W.sB;
        /* a single block at the head and at the sill, the rafter's depth, between the two rafters */
        slab(side, sT - tt / 2, -R.d / 2, tt, R.d, W.clr, z, WOOD, 1);
        slab(side, sB + tt / 2, -R.d / 2, tt, R.d, W.clr, z, WOOD, 1);
        lumB += 2 * W.clr; nBlk += 2; nNail += 2 * 2 * 3;
        var fw = 0.07, sM = (sT + sB) / 2, oF = ROOFWIN.frameH / 2 - 0.02 + ((_pirT() > 0) ? _pirT() + 0.02 : 0);   /* over the PIR when it lies above the rafters (aframe-v99) or on the deck of the hybrid (aframe-v157) */
        var itRf = ctx.item; _am(ctx, 'roof_windows', 'Roof windows', sz.code || '', 'top');
        slab(side, sT + ROOFWIN.gap + fw / 2, oF, fw, ROOFWIN.frameH, sz.w, z, ROOFWIN.col, 1, W.idx);
        slab(side, sB - ROOFWIN.gap - fw / 2, oF, fw, ROOFWIN.frameH, sz.w, z, ROOFWIN.col, 1, W.idx);
        for (k = -1; k <= 1; k += 2) slab(side, sM, oF, sz.h, ROOFWIN.frameH, fw, z + k * (sz.w / 2 - fw / 2), ROOFWIN.col, 1, W.idx);
        slab(side, sM, oF + 0.01, sz.h - 2 * fw, 0.010, sz.w - 2 * fw, z, ROOFWIN.glass, 0.4, W.idx);
        ctx.item = itRf;
        perim += 2 * (sz.w + sz.h);
        if (sz.code) { codes[sz.code] = (codes[sz.code] || 0) + 1; if (!__CORE.CATALOG[sz.code]) __CORE.CATALOG[sz.code] = { code: sz.code, unit: 'pcs', label: sz.code }; }
        var Fl = floors()[W.st];
        ctx.log('roofwin  ' + (side < 0 ? 'left' : 'right') + ' ' + (sz.code || '?') + ' ' + Math.round(sz.w * 1000) + 'x' + Math.round(sz.h * 1000) + ' in bay ' + (W.kb + 1) + ' at z ' + Math.round(z * 1000) +
                ', storey ' + (W.st + 1) + ': clear between its rafters ' + Math.round(W.clr * 1000) + ' (window + ' + Math.round(ROOFWIN.fit * 1000) + '), sill ' + Math.round(W.ySill * 1000) +
                (Fl ? (' = ' + Math.round((W.ySill - Fl.y) * 1000) + ' over the floor' + ({ row: ' (the storey row, ' + Math.round(ROOFWIN.sill * 1000) + ')', nearest: ' (the ' + Math.round(ROOFWIN.sill * 1000) + ' row does not fit this storey: the nearest height that does, the same for every window here)', stacked: ' (stacked in a bay over or under another window: its own height)' })[(STATE.openings[W.idx] || {}).rowSnap] || '') : '') + ', head ' + Math.round(W.yHead * 1000) + ' (inside); no rafter cut, both rafters doubled, a block at head and sill');
      }
      var nW = RW.wins.length, Lsum = (lumS + lumB) * 1.05;
      for (cc in codes) if (codes.hasOwnProperty(cc)) { API.billAdd('aframe-frame', cc, codes[cc]); cl.push(codes[cc] + ' x ' + cc); }
      API.billAdd('aframe-frame', R.code, Lsum);
      API.billAdd('aframe-frame', 'FAS45145', nNail);
      API.billAdd('aframe-frame', 'ROT00007', nSis);
      API.billAdd('aframe-frame', 'FAS38038', nSis * 10);
      API.billAdd('aframe-frame', DOOR.tape, perim * 2 * 1.05);
      API.billAdd('aframe-frame', DOOR.foam, Math.ceil(perim / DOOR.foamM));
      API.billAdd('aframe-frame', DOOR.anchor, Math.ceil(perim / DOOR.anchorSp));
      ctx.log('roofwin  rafter grid ' + Math.round(RAF.sp * 1000) + ' with the window bays set apart: ' + (mv.length ? mv.join(', ') : 'nothing moved') + ' (a pair moves on both slopes)');
      ctx.log('BILL  roof windows ' + cl.join(', ') + '; ' + R.code + ' ' + Lsum.toFixed(1) + ' m (' + nSis + ' doubling rafter(s) ' + lumS.toFixed(1) + ' m + ' + nBlk + ' block(s) ' + lumB.toFixed(1) +
              ' m, +5%); joint ' + perim.toFixed(2) + ' m: ' + DOOR.tape + ' ' + (perim * 2 * 1.05).toFixed(2) + ' m, ' + Math.ceil(perim / DOOR.foamM) + ' can(s) ' + DOOR.foam + ', ' + Math.ceil(perim / DOOR.anchorSp) + ' x ' + DOOR.anchor);
      ctx.log('FIX  roof windows ' + nNail + ' x FAS45145 (doubling rafters stitched in 2 rows at 400, blocks 3 through each end); doubling rafter feet ' + nSis + ' x ROT00007 + ' + (nSis * 10) + ' x FAS38038');
      var kits = {}, kl = [], kMiss = 0, kq;
      for (kq = 0; kq < RW.wins.length; kq++) { var wc = RW.wins[kq].code || (RW.wins[kq].sz && RW.wins[kq].sz.code) || ''; var kc = FLASH_KIT[wc] || 'TBD.roofWinFlash'; if (kc === 'TBD.roofWinFlash') kMiss++; kits[kc] = (kits[kc] || 0) + 1; }
      for (kq in kits) if (kits.hasOwnProperty(kq)) { API.billAdd('aframe-frame', kq, kits[kq]); kl.push(kits[kq] + ' x ' + kq); }
      _flashKitLabel = kl.join(', ') || 'none'; _flashKitCode = Object.keys(kits)[0] || '';
      ctx.log('BILL  roof window flashing kit(s) ' + _flashKitLabel + ' (one a window, by its size)' + (kMiss ? (' -- MISSING ' + kMiss + ' on TBD.roofWinFlash: no kit row for that size yet') : ''));
    }
    /* THE FLOOR JOISTS ARE COLLAR TIES (aframe-v38, Marek: nosne profily se
       jen dotykaji krokvi, maji licovat bocnimi plochami a byt serizle podle
       uhlu podel vnejsi plochy krokve). Each joist lies side by side with a
       rafter pair -- one joist to every common rafter line, on the side away
       from any doubling rafter -- runs right across the A and is cut at both
       ends along the rafters' top face, so each end laps the full depth of
       its rafter and is screwed through into it. At a gable the floor's edge
       sits on a ledger fixed to the gable studs, the gable rafter being over
       the wall. A stair opening cuts the joists it crosses into tails, hung
       on doubled headers that run along the ridge from the last whole joist
       before the opening to the first after it; a single block closes each
       end of the opening between the headers. */
    var JOIST_SIZES = [{ code: 'KVH60200', t: 0.060, d: 0.200, upTo: 4.20 }, { code: 'KVH60240', t: 0.060, d: 0.240, upTo: 99 }];
    var _joistNote = '';
    function _sizeJoists() {
      var pick = JOIST_SIZES[0], q;
      for (q = 0; q < JOIST_SIZES.length; q++) {
        FLOOR.joist = { code: JOIST_SIZES[q].code, t: JOIST_SIZES[q].t, d: JOIST_SIZES[q].d, sp: 0.600 };
        var fl = floors(), span = (fl.length > 1) ? fl[1].floorWidth : 0;
        pick = JOIST_SIZES[q];
        _joistNote = 'joists   ' + pick.code + ' ' + Math.round(pick.t * 1000) + 'x' + Math.round(pick.d * 1000) + ' for every upper floor: the widest spans ' + Math.round(span * 1000) +
                     ' between the rafters (rule: 60x200 up to 4200, 60x240 over)';
        if (span <= pick.upTo + 1e-6) break;
      }
    }
    function _joistLayout(k, lines, sisters) {
      var fl = floors(), F = fl[k], B = _barRect(), R = _rafSize(), tJ = FLOOR.joist.t, tt = R.t, out = { joists: [], ledgers: [], hole: _hole(k) }, i;
      if (!F) return out;
      var n = lines.length - 1, sis = {}, GI = _rafGrid().gable;
      for (i = 0; i < (sisters || []).length; i++) sis[Math.round(sisters[i].z * 1000)] = true;
      for (i = GI[0] + 1; i <= GI[1] - 1; i++) {
        var zl = lines[i], sgn = (i === GI[1] - 1) ? -1 : 1;
        if (sis[Math.round((zl + sgn * tt) * 1000)]) sgn = -sgn;
        out.joists.push({ z: zl + sgn * (tt / 2 + tJ / 2), line: i });
      }
      out.ledgers.push(B.z0 + GABLE.d + tJ / 2, B.z1 - GABLE.d - tJ / 2);
      out.joists.sort(function (a, b) { return a.z - b.z; });
      return out;
    }

    /* THE PORCH UNDER A ROOF PULLED OUT OVER A GABLE (aframe-v59): its
       plates, the posts under them on the footing chosen (ground screws in
       place of the slab), and a tie across each porch rafter pair at head
       height. Magenta while under review. The deck under it comes next. */

    /* THE SOFFIT (aframe-v60, Marek: podbiti sikminy z vnitrni strany v
       exterieru): the underside of the roof outside the gables boarded with
       the facade's own board (FVW01351, the Facade finish colour), across the
       rafters -- under the lookouts of a rake, from the facade out to the end
       rafter, and under the rafters of a porch, over its whole length -- on
       both slopes from the plate up to the ridge; nailed FAS70000, two where a
       board crosses a rafter or a lookout (about 24 a m2). Magenta while under
       review. */
    var SOFFIT_REVIEW = false;
    function _buildSoffit(ctx, RG, S, R, B) {
      var T = ctx.THREE, g = ctx.group, cx = (B.x0 + B.x1) / 2, yTop0 = S.top + S.half * S.tan, e, sd, area = 0, notes = [];
      var fT = _facT(), seat = _deckY() + _plateFit().h, tB = 0.015;   /* the EPS in it from zone 4 (aframe-v158) */
      var mat = new T.MeshStandardMaterial({ color: SOFFIT_REVIEW ? MAGENTA : (API.colorSlotOf ? API.colorSlotOf('gable') : 0xB8875A), roughness: 0.8 });
      for (e = 0; e < 2; e++) {
        var porch = RG.porch[e], o = porch ? -R.d : -0.060;          /* under the rafters, or under the lookouts */
        /* over a full glazing the soffit runs to the glass: no facade there (aframe-v79) */
        var fTe = _gableFull(e) ? 0 : fT;
        var za = e ? B.z1 + fTe : RG.z0 - R.t / 2, zb = e ? RG.z1 + R.t / 2 : B.z0 - fTe;
        if (porch) {
          /* UNDER A PORCH ONLY T&G BOARDS BETWEEN THE RAFTERS (aframe-v74,
             Marek: pri vytazene strese jen palubky mezi krokvemi, zadne vrstvy
             zateplovani, ze spodu na osb zaklop; estetika i uspora): the boards
             are nailed up to the underside of the OSB deck in every porch bay,
             the rafters stay visible; no wool, no vapour barrier, no lining
             there -- those stop at the gable */
          var lo = e ? RG.gable[1] : 0, hi = e ? RG.n : RG.gable[0], bi, aP = 0, nBay = 0, nBoardP = 0;
          var grooveMat = new T.MeshStandardMaterial({ color: 0x2E2620, roughness: 1 });
          var sP0 = 0.05, sP1 = (yTop0 - seat) / S.sin;
          for (sd = -1; sd <= 1; sd += 2) {
            var PP = function (s4, o4) { return [cx + sd * (s4 * S.cos + o4 * S.sin), yTop0 - s4 * S.sin + o4 * S.cos]; };
            for (bi = lo; bi < hi; bi++) {
              var zA = RG.lines[bi] + R.t / 2 + 0.002, zB = RG.lines[bi + 1] - R.t / 2 - 0.002;
              if (zB - zA < 0.05) continue;
              /* THE BOARDS ACROSS THE BAY, THE GROOVES SHOWING (aframe-v75 / v77,
                 Marek: viditelne spary T&G; napric mezi krokvemi, ne podel):
                 135 boards from rafter to rafter, one after another down the
                 slope, the V-joint between each two a 4 mm dark line; the
                 bay's boards are one piece of geometry */
              var p1 = PP(sP0, 0), p2 = PP(sP1, 0), p3 = PP(sP1, -tB), p4 = PP(sP0, -tB), shP = new T.Shape();
              shP.moveTo(p1[0], p1[1]); shP.lineTo(p2[0], p2[1]); shP.lineTo(p3[0], p3[1]); shP.lineTo(p4[0], p4[1]); shP.lineTo(p1[0], p1[1]);
              var gBk = new T.ExtrudeGeometry(shP, { depth: zB - zA, bevelEnabled: false }); gBk.translate(0, 0, zA);
              g.add(new T.Mesh(gBk, grooveMat));
              var bW = FAC.clad.w || 0.135, gJ = 0.004, sc = sP0, shs = [];
              while (sc < sP1 - 0.01) {
                var sN = Math.min(sP1, sc + bW), sE2 = sN - ((sN < sP1 - 0.001) ? gJ : 0);
                var q1 = PP(sc, -0.002), q2 = PP(sE2, -0.002), q3 = PP(sE2, -tB - 0.001), q4 = PP(sc, -tB - 0.001), shB = new T.Shape();
                shB.moveTo(q1[0], q1[1]); shB.lineTo(q2[0], q2[1]); shB.lineTo(q3[0], q3[1]); shB.lineTo(q4[0], q4[1]); shB.lineTo(q1[0], q1[1]);
                shs.push(shB); sc = sN; nBoardP++;
              }
              if (shs.length) { var gB = new T.ExtrudeGeometry(shs, { depth: zB - zA - 0.002, bevelEnabled: false }); gB.translate(0, 0, zA + 0.001); g.add(new T.Mesh(gB, mat)); }
              aP += (sP1 - sP0) * (zB - zA); nBay++;
            }
          }
          area += aP;
          notes.push((e ? 'back' : 'front') + ' porch: T&G boards up under the OSB deck between the rafters, ' + nBay + ' bay(s), ' + nBoardP + ' board(s) of ' + Math.round((FAC.clad.w || 0.135) * 1000) + ' across the bays, rafter to rafter, the T&G joints showing, ' + aP.toFixed(2) + ' m2, the rafters left in view; no wool, vapour barrier or lining over the porch (they stop at the gable)');
          continue;
        }
        if (zb - za < 0.05) continue;
        var s0 = -o * S.tan, s1 = (yTop0 + o * S.cos - seat) / S.sin, aE = 0;
        for (sd = -1; sd <= 1; sd += 2) {
          var P = function (s4, o4) { return [cx + sd * (s4 * S.cos + o4 * S.sin), yTop0 - s4 * S.sin + o4 * S.cos]; };
          var a = P(s0, o), b = P(s1, o), c = P(s1, o - tB), d = P(s0 + tB * S.tan, o - tB), sh = new T.Shape();
          sh.moveTo(a[0], a[1]); sh.lineTo(b[0], b[1]); sh.lineTo(c[0], c[1]); sh.lineTo(d[0], d[1]); sh.lineTo(a[0], a[1]);
          var geo = new T.ExtrudeGeometry(sh, { depth: zb - za, bevelEnabled: false }); geo.translate(0, 0, za);
          g.add(new T.Mesh(geo, mat));
          aE += (s1 - s0) * (zb - za);
        }
        area += aE;
        notes.push((e ? 'back' : 'front') + (porch ? ' porch, under the rafters' : ' rake, under the lookouts') + ' ' + Math.round((zb - za) * 1000) + ' deep: ' + aE.toFixed(2) + ' m2');
      }
      if (area < 0.01) { ctx.log('soffit   none'); return; }
      API.billAdd('aframe-frame', FAC.clad.code, area * 1.08);
      API.billAdd('aframe-frame', FAC.clad.nail, Math.ceil(area * 24));
      ctx.log('soffit   ' + notes.join(' | ') + (SOFFIT_REVIEW ? ' -- MAGENTA, under review' : ''));
      ctx.log('soffit   BILL ' + FAC.clad.code + ' ' + (area * 1.08).toFixed(2) + ' m2 (+8% cuts), ' + Math.ceil(area * 24) + ' x ' + FAC.clad.nail + ' (2 a crossing, about 24 a m2)');
    }
    var PORCH_REVIEW = false;
    function _buildPorch(ctx, RG, RW, S, R, B) {
      var T = ctx.THREE, g = ctx.group, e, notes = [];
      var col = PORCH_REVIEW ? MAGENTA : WOOD, PF = _plateFit(), yP = _deckY(), cx = (B.x0 + B.x1) / 2, BR = _baseRect();
      /* WHAT STANDS UNDER THE PORCH (aframe-v71, Marek: na vrutech zalozit jen
         terasy, krokve protazene strechy nechat na pasech, pokud je stavba na
         pasech / desce): the plates under the porch rafters go on the house's
         own footing -- on strips the two eave strips run on under the porch,
         their stem up to the plate; on screws or pads the plates stand on
         posts on the same kind. The deck is always on ground screws. */
      var fnd = STATE.foundation, onStrip = (fnd === 'strips'), useScrew = (fnd === 'screws'), nSup = 0, postL = 0, plL = 0, nTie = 0, tieL = 0;
      /* THE SAME STRIP AS UNDER THE HOUSE (aframe-v73, Marek: pas v jinych
         dimenzich, presahuje kraj strechy, ma to byt pokracovani toho pod
         domem): the house's buildStripSlab figures -- stem 400, footing 700 x
         250, frost depth -- on the house strip's own line, 200 inside the base
         edge, from the end rafter's face to the house's cross strip; below
         grade drawn only on Roof & Base, as the core draws the house's */
      var SR = _stripRect(), SP = { w: 0.40, foot: 0.70, footH: 0.25, depth: Math.max(0.80, STATE.climateZone || 0) }, spLen = 0, spFoot = 0, spStem = 0, nHang = 0;
      var ffull = true; try { ffull = (typeof __CORE._footFull === 'function') ? !!__CORE._footFull() : true; } catch (eFF) { ffull = true; }
      var concM = new T.MeshStandardMaterial({ color: PORCH_REVIEW ? MAGENTA : 0x9E9B93, roughness: 0.95 });
      var screwAt = function (px, pz, headY) { if (typeof API.screwPile === 'function') API.screwPile(ctx, px, pz, headY, { review: PORCH_REVIEW }); else _box(T, g, 0.102, headY, 0.102, px, headY / 2, pz, 0, 0x6E7275, 1); };
      var yTop0 = S.top + S.half * S.tan, tJ = 0.060, dT = 0.160, yTie = yP + PORCH_TIE;
      var nKnee = 0, kneeL = 0;
      var colD = PORCH_REVIEW ? MAGENTA : 0xB68A5A, dBear = 0, dJoist = 0, dSup = 0, dPost = 0, dArea = 0, dScrew = 0, dJS = 0;
      var PS = { slabT: 0.15, gravelT: 0.15, xps: 0.05, sleeperH: 0.060, sleeperW: 0.160, sleeperSp: 0.50, step: 0.020 };
      PS.drop = PS.sleeperH + 0.025 + PS.step;      /* the porch slab under the house's: sleepers + boards + a 20 step (aframe-v100) */
      var pSlab = { area: 0, conc: 0, gravel: 0, dig: 0, xps: 0, sleeper: 0, anchor: 0, deck: 0, boardScrew: 0 };
      for (e = 0; e < 2; e++) {
        if (!RG.porch[e]) continue;
        var za = e ? BR.z1 : RG.z0 - R.t / 2, zb = e ? RG.z1 + R.t / 2 : BR.z0, Lp = zb - za, sd;
        /* the plates run on over the porch, on posts every 1800 at the most */
        for (sd = -1; sd <= 1; sd += 2) {
          var xP = cx + sd * (S.w / 2 - PF.w / 2);
          _am(ctx, 'porch_plate', 'Porch plate', PF.code, 'top'); _box(T, g, PF.w - 0.002, PF.h, Lp, xP, yP + PF.h / 2, (za + zb) / 2, 0, col, 1);
          plL += Lp * PF.n;
          /* on screws, pads or piers the plates lie on the house's own frame run on under the porch (aframe-v119): no posts */
          var nP = 0, q;
          if (onStrip) {
            /* the eave strip on under the porch: the spread footing at frost depth, the stem up under the plate */
            var xS = (sd < 0) ? SR.x0 : SR.x1, zsA = e ? BR.z1 : za, zsB = e ? zb : BR.z0, Ls = Math.abs(zsB - zsA), zsM = (zsA + zsB) / 2;
            var yFootTop = -SP.depth + SP.footH, stH = yP - yFootTop, yStem0 = ffull ? yFootTop : 0;
            _am(ctx, 'grd_concrete', 'Footing', 'grd.concrete', 'top');
            if (ffull) { var sfM = new T.Mesh(new T.BoxGeometry(SP.foot, SP.footH, Ls), concM); sfM.position.set(xS, -SP.depth + SP.footH / 2, zsM); g.add(sfM); }
            /* the stem carries the plate at the house's level; its inner part is
               formed lower, a rebate the porch deck lies on (aframe-v100) */
            var wOut = Math.min(SP.w, PF.w), yReb = yP - PS.drop, xOutC = (sd < 0) ? (xS - SP.w / 2 + wOut / 2) : (xS + SP.w / 2 - wOut / 2), xInC = (sd < 0) ? (xS - SP.w / 2 + wOut + (SP.w - wOut) / 2) : (xS + SP.w / 2 - wOut - (SP.w - wOut) / 2);
            var stM = new T.Mesh(new T.BoxGeometry(wOut, yP - yStem0, Ls), concM); stM.position.set(xOutC, (yP + yStem0) / 2, zsM); g.add(stM);
            if (SP.w - wOut > 0.005) { var stR = new T.Mesh(new T.BoxGeometry(SP.w - wOut, yReb - yStem0, Ls), concM); stR.position.set(xInC, (yReb + yStem0) / 2, zsM); g.add(stR); }
            spLen += Ls; spFoot += SP.foot * SP.footH * Ls; spStem += SP.w * stH * Ls;
          }
          /* KNEE BRACES (aframe-v61, Marek: ztuzeni sloupku pasky): from each post up
             to the plate at 45 degrees, 600 along each way it has a neighbour, so the
             porch cannot rack along its length; 100 x 100 (the post's own 4x4), two FAS75132 each end */
          for (q = 0; q < nP && !onStrip; q++) {
            var zqB = za + 0.10 + (Lp - 0.20) * q / (nP - 1), kb;
            for (kb = -1; kb <= 1; kb += 2) {
              if ((q === 0 && kb < 0) || (q === nP - 1 && kb > 0)) continue;
              _am(ctx, 'porch_braces', 'Knee braces', 'KVH10100', 'side'); var kL = 0.60 * Math.SQRT2, km = new T.Mesh(new T.BoxGeometry(0.100, kL, 0.100), new T.MeshStandardMaterial({ color: col, roughness: 0.85 }));
              km.position.set(xP, yP - 0.30, zqB + kb * 0.30); km.rotation.x = kb * Math.PI / 4; g.add(km);
              nKnee++; kneeL += kL;
            }
          }
          for (q = 0; q < nP; q++) {
            var zq = za + 0.10 + (Lp - 0.20) * q / (nP - 1), yPostB = useScrew ? 0.10 : 0.0;
            _am(ctx, 'terrace_supports', 'Posts', 'KVH10100', 'top'); _box(T, g, 0.100, yP - yPostB, 0.100, xP, (yP + yPostB) / 2, zq, 0, col, 1);
            if (useScrew) { _am(ctx, 'base_screws', 'Ground screws', 'steel.screwPile', 'top'); screwAt(xP, zq, 0.10); }
            else { _am(ctx, 'base_pads', 'Pads', 'grd.padBlock', 'top'); _box(T, g, 0.40, 0.10, 0.40, xP, -0.05, zq, 0, 0x9A9A96, 1); }
            nSup++; postL += yP - yPostB;
          }
        }
        /* a tie across each porch pair at head height, beside the rafter */
        var i0 = e ? RG.gable[1] + 1 : 1, i1 = e ? RG.n : RG.gable[0] - 1, i;
        yTie = _tieMidY(e, yP);
        if (_balcOnTies(e)) notes.push((e ? 'back' : 'front') + ' ties set at floor 2 (' + Math.round(yTie * 1000) + ') -- the balcony lies on them');
        for (i = i0; i <= i1; i++) {
          var xTop = (yTop0 - (yTie + dT / 2)) / S.tan, zL = RW.lines[i] + (e ? -1 : 1) * (R.t / 2 + tJ / 2);
          if (xTop < 0.5) continue;
          _am(ctx, 'porch_ties', 'Porch ties', 'KVH60160', 'side'); _box(T, g, 2 * xTop, dT, tJ, cx, yTie, zL, 0, col, 1);
          nTie++; tieL += 2 * xTop;
        }
        notes.push((e ? 'back' : 'front') + ' ' + Math.round(_rakeOf(e) * 1000) + ' deep: ' + (i1 - i0 + 1) + ' porch pair(s), plates ' + Lp.toFixed(2) + ' m a side');
        /* THE PORCH DECK (aframe-v60, Marek: vyplnit to skladbou terasy): the
           ADU terrace's build-up a step under the house floor -- supports on a
           1800 grid on the chosen footing (screws in place of the slab),
           bearers across on them, joists along every 500 on the bearers,
           decking TST00002 across the joists; from the porch's end to the
           gable's facade, between the plates */
        var fT = _facT(), dz0 = e ? (B.z1 + fT) : (RG.z0 - R.t / 2), dz1 = e ? (RG.z1 + R.t / 2) : (B.z0 - fT);
        var dx0 = cx - (S.w / 2 - PF.w), dx1 = cx + (S.w / 2 - PF.w);
        /* on strips the deck stands between the stems' inner faces and its
           bearers hang on them (a hanger bolted to the concrete) -- no screw
           at a bearer's ends (aframe-v73, Marek: na krajich kde je pas by se
           nosne profily terasy pridelaly k pasu) */
        /* ON STRIPS THE PORCH LIES ON CONCRETE (aframe-v89, Marek: prkna az ke
           stitu a az ke krokvim, terasu mirne zvysit, at lezi na betonove desce
           / pasu). The eave strips already run on under the porch; a strip
           across its end closes them into a U, a slab 150 on gravel fills it
           flush with the house slab (a 50 XPS strip INS00503 between the two,
           so the porch slab is not a cold bridge into the insulated one), and
           the deck lies on the concrete: pressure treated sleepers 60 x 160
           KVP60160 laid flat every 500 on a sill seal, screwed down with
           FAS80060, the decking across them -- from the gable's facade over
           the house slab's edge out to the porch end, and across to where the
           rafters' undersides come down to the boards. Its top is 85 over the
           slab (it was 20 under it, hung between the strips). */
        /* ON STRIPS THE INNER PART OF THE PORCH IS ON GROUND SCREWS (aframe-v119, Marek: jen u betonove desky
           ma byt vnitrni cast terasy na vrutech, pro usporu): the eave strips run on under the plates as before,
           the deck between them is the core's, its bearers hung on the stems -- no porch slab any more */
        if (onStrip) { dx0 = Math.max(dx0, SR.x0 + SP.w / 2); dx1 = Math.min(dx1, SR.x1 - SP.w / 2); }
        var DW = dx1 - dx0, DL = dz1 - dz0;
        /* THE DECK IS THE CORE'S (API.deck, core-v512, moved there from here) -- off the strips */
        if (!onStrip) { /* on the house's own frame, decked by the point base (aframe-v119) */ }
        else if (typeof API.deck !== 'function') { ctx.log('porch    ERROR the deck is not built -- the core is ' + (__CORE.CORE_VERSION || '?') + ', the porch deck needs core-v512: upload configurator-ui.js'); }
        else {
          var kDk = ctx.group.children.length;
          var DK = API.deck(ctx, { layer: 'aframe-frame', x0: dx0, x1: dx1, z0: dz0, z1: dz1, top: yP - 0.020, hangEnds: onStrip, anchorCode: 'FAS80060', review: PORCH_REVIEW, col: WOOD, colD: 0xB68A5A });
          /* the core's deck marks nothing: its bodies told apart by their colour (aframe-v137) */
          if (!PORCH_REVIEW) _asmByColour(ctx, kDk, [[new T.Color(0xB68A5A).getHex(), 'decking', 'Decking', 'TST00002'], [new T.Color(WOOD).getHex(), 'terrace_frame', 'Deck frame', 'KVH60160']], ['base_screws', 'Ground screws', 'steel.screwPile']);
          dBear += DK.bear; dJoist += DK.joist; dSup += DK.sup; dPost += DK.post; dArea += DK.area; dScrew += DK.boardScrews; dJS += DK.joistScrews; nHang += DK.hang;
          notes.push('deck ' + DW.toFixed(2) + ' x ' + DL.toFixed(2) + ' m at ' + Math.round((yP - 0.020) * 1000) + ' (' + DK.nBz + ' bearer(s), ' + DK.nJz + ' joist(s), ' + DK.sup + ' ground screw(s)' + (onStrip ? ', bearer ends on the strips' : '') + ', core API.deck)');
        }
      }
      if (!notes.length) { ctx.log('porch    none -- both gables keep the ' + Math.round(RAKE * 1000) + ' to ' + Math.round(PORCH_MIN * 1000) + ' rake on lookouts (drag a gable edge in Roof & Base past ' + Math.round(PORCH_MIN * 1000) + ' for a covered porch)'); return; }
      API.billAdd('aframe-frame', PF.code, plL * 1.05);
      if (onStrip) {
        API.billAdd('aframe-frame', 'grd.excavation', spLen * SP.foot * SP.depth);
        API.billAdd('aframe-frame', 'grd.gravel', spLen * SP.foot * 0.10);
        API.billAdd('aframe-frame', 'grd.concrete', spFoot + spStem);
        API.billAdd('aframe-frame', 'FCO00003', spLen * 4 * 1.05);
        API.billAdd('aframe-frame', 'WWR00061', Math.ceil(spLen / 0.30));
        var nAnP = 0, pqA;
        for (pqA = 0; pqA < 2; pqA++) if (RG.porch[pqA]) nAnP += 2 * (Math.ceil(Math.max(0, _rakeOf(pqA) - 0.30) / 1.80) + 1);
        API.billAdd('aframe-frame', 'FAT16010', Math.ceil(nAnP / 2));
        API.billAdd('aframe-frame', 'FAT16011', nAnP);
        API.billAdd('aframe-frame', 'FAT16001', nAnP * 2);
        API.billAdd('aframe-frame', 'FAT16002', nAnP);
      } else {
        if (nSup) {
          API.billAdd('aframe-frame', 'KVH10100', postL * 1.05);
          if (useScrew) { API.billAdd('aframe-frame', 'steel.screwPile', nSup); API.billAdd('aframe-frame', 'steel.saddle', nSup); }
          else { API.billAdd('aframe-frame', 'grd.padBlock', nSup); API.billAdd('aframe-frame', 'FCO00004', nSup); }
          API.billAdd('aframe-frame', 'FAS60100', nSup * 4);
        }
      }
      API.billAdd('aframe-frame', 'KVH60160', tieL * 1.05);
      API.billAdd('aframe-frame', 'FAS75132', nTie * 8);
      if (nKnee) { API.billAdd('aframe-frame', 'KVH10100', kneeL * 1.10); API.billAdd('aframe-frame', 'FAS75132', nKnee * 4); }
      if (pSlab.deck > 0) {
        var meshS = Math.ceil(pSlab.area * 1.12 / 6);
        API.billAdd('aframe-frame', 'grd.concreteSlab', pSlab.conc);
        API.billAdd('aframe-frame', 'grd.gravelSlab', pSlab.gravel);
        API.billAdd('aframe-frame', 'grd.excavation', pSlab.dig);
        API.billAdd('aframe-frame', 'grd.geotextile', pSlab.area * 1.10);
        API.billAdd('aframe-frame', 'FFR30002', meshS);
        API.billAdd('aframe-frame', 'FFM00004', Math.ceil(pSlab.area * 2));
        API.billAdd('aframe-frame', 'FEC00026', Math.round(pSlab.area * 0.03 * 100) / 100);
        API.billAdd('aframe-frame', 'INS00503', Math.round(pSlab.xps * 1.05 * 100) / 100);
        API.billAdd('aframe-frame', 'KVP60160', pSlab.sleeper * 1.05);
        API.billAdd('aframe-frame', 'INS01003', pSlab.sleeper * 1.05);
        API.billAdd('aframe-frame', 'FAS80060', pSlab.anchor);
        API.billAdd('aframe-frame', 'TST00002', pSlab.deck * 1.05);
        API.billAdd('aframe-frame', 'FAS55050', pSlab.boardScrew);
        ctx.log('porch    SLAB BILL concrete grd.concreteSlab ' + pSlab.conc.toFixed(2) + ' m3 (150), gravel grd.gravelSlab ' + pSlab.gravel.toFixed(2) + ' m3 (150 bed + fill to grade), dig ' + pSlab.dig.toFixed(2) + ' m3, geotextile ' + (pSlab.area * 1.10).toFixed(2) + ' m2, mesh ' + meshS + ' x FFR30002, ' + Math.ceil(pSlab.area * 2) + ' x FFM00004, wire FEC00026 ' + (Math.round(pSlab.area * 0.03 * 100) / 100) + ' kg; joint XPS INS00503 ' + (Math.round(pSlab.xps * 1.05 * 100) / 100) + ' m2');
        ctx.log('porch    DECK ON THE CONCRETE BILL sleepers KVP60160 ' + (pSlab.sleeper * 1.05).toFixed(1) + ' m (+5%) on sill seal INS01003 ' + (pSlab.sleeper * 1.05).toFixed(1) + ' m, ' + pSlab.anchor + ' x FAS80060 (every 800 + the ends); decking TST00002 ' + (pSlab.deck * 1.05).toFixed(2) + ' m2 (+5%), ' + pSlab.boardScrew + ' x FAS55050 (2 a board a sleeper); no ground screws, no bearers');
      }
      if (nHang) ctx.log('porch    DECK ON THE STRIPS ' + nHang + ' bearer end(s) hung on the stems (FAT00011, 4 x FAS80060, 6 x FAS38038 each -- billed by the core deck); no ground screw at the bearer ends');
      ctx.log('porch    ' + notes.join(' | ') + (PORCH_REVIEW ? ' -- MAGENTA, under review' : ''));
      if (nKnee) ctx.log('porch    KNEE BRACES ' + nKnee + ' x 100x100 KVH10100 (a 4x4, the post stock) at 45 deg from the posts up to the plates, ' + (kneeL * 1.10).toFixed(2) + ' m (+10% cuts), ' + (nKnee * 4) + ' x FAS75132 (2 each end)');
      if (dArea > 0) ctx.log('porch    DECK BILL decking TST00002 ' + (dArea * 1.05).toFixed(2) + ' m2 (+5%), ' + dScrew + ' x FAS55050 (2 a board a joist); bearers + joists KVH60160 ' + ((dBear + dJoist) * 1.05).toFixed(1) + ' m, ' + (dJS + dSup * 4) + ' x FAS60100; ' + dSup + ' ground screw(s) FGR00004 + U head(s) FGR00002 under the bearers (always screws under the deck), posts KVH10100 ' + (dPost * 1.05).toFixed(2) + ' m where the bearer stands over the screw head' + (PORCH_REVIEW ? ' -- screws MAGENTA, under review' : ''));
      if (onStrip) ctx.log('porch    UNDER THE PLATES the house eave strips run on under the porch, on their own line 200 inside the base edge (the house is on strips): ' + spLen.toFixed(2) + ' m from the end rafter to the cross strip, footing ' + Math.round(SP.foot * 1000) + ' x ' + Math.round(SP.footH * 1000) + ' at ' + Math.round(SP.depth * 1000) + ' deep, stem ' + Math.round(SP.w * 1000) + ' up to the plate at ' + Math.round(yP * 1000) + (ffull ? ', drawn whole (Roof & Base)' : ', drawn from grade (below it only on Roof & Base)') + '; BILL excavation ' + (spLen * SP.foot * SP.depth).toFixed(2) + ' m3, gravel ' + (spLen * SP.foot * 0.10).toFixed(2) + ' m3, concrete ' + (spFoot + spStem).toFixed(2) + ' m3, 4 bars FCO00003 ' + (spLen * 4 * 1.05).toFixed(1) + ' m, ' + Math.ceil(spLen / 0.30) + ' stirrups WWR00061, the plates anchored M16 every 1800 as on the house (FAT16010 rod, FAT16011, FAT16001, FAT16002); no posts, no knee braces');
      ctx.log('porch    BILL plates ' + PF.code + ' ' + (plL * 1.05).toFixed(1) + ' m; ' + (onStrip ? 'on the eave strips run on under the porch' : (nSup + ' post(s) KVH10100 ' + (postL * 1.05).toFixed(2) + ' m on ' + (useScrew ? (nSup + ' ground screw(s) FGR00004 + ' + nSup + ' U head(s) FGR00002') : (nSup + ' precast pad(s) FCO00009 + ' + nSup + ' U base(s) FCO00004')) + ', ' + (nSup * 4) + ' x FAS60100')) + '; ' + nTie + ' tie(s) 60x160 KVH60160 ' + (tieL * 1.05).toFixed(1) + ' m at ' + Math.round(yTie * 1000) + ', ' + (nTie * 8) + ' x FAS75132 (4 a tie end)');
    }
    function _buildFrame(ctx) {
      var T = ctx.THREE, g = ctx.group, S = _sect(), B = _barRect(), R = _rafSize(), fl = floors();
      _bill['aframe-frame'] = {};
      var rafCode = ((S.w / 2) / S.cos > LVL.over) ? LVL.code : R.code, AR = function () { _am(ctx, 'roof_framing', 'Roof framing', rafCode, 'top'); }; AR();
      ctx.log('rafters  ' + R.code + ' ' + Math.round(R.t * 1000) + 'x' + Math.round(R.d * 1000) + ' for ' + fl.length + ' floor(s) -- the rule: 60x200 up to two floors, 60x240 with three (lean DIY sizing); ' + ((INSUL === 'between') ? ('the wool fills the rafters full, PIR ' + Math.round(_pirT() * 1000) + ' on the deck (the hybrid, aframe-v157)') : ('the PIR ' + Math.round(_pirT() * 1000) + ' over the deck')));
      var cx = (B.x0 + B.x1) / 2, L = B.z1 - B.z0, rake = RAKE;
      var RG = _rafGrid(), z0 = RG.z0, z1 = RG.z1, n = RG.n, spB = RG.sp;
      var slopeL = Math.sqrt(S.half * S.half + (S.ridgeY - S.top) * (S.ridgeY - S.top));
      var rafLen = 0, nRaf = 0, k, side;
      _rafMembers = [];
      var xT = S.w / 2, xU = S.w / 2 - R.d / S.sin, yF = _deckY() + _plateFit().h;
      var yTop0 = S.top + S.half * S.tan, yUnd0 = yTop0 - R.d / S.cos;
      var rafMat = new T.MeshStandardMaterial({ color: WOOD, roughness: 0.8, side: T.DoubleSide });
      /* ONE RAFTER, OR WHAT IS LEFT OF IT ROUND A ROOF WINDOW. Its profile
         across the A (aframe-v8): a level seat at the foot, a plumb cut at
         the ridge. cut = [u1, u2], the stretch (horizontal distance from the
         ridge line, measured on the top face) taken out for an opening, the
         two ends cut square to the rafter (aframe-v22). */
      var yTopU = function (u) { return yTop0 - u * S.tan; };
      var rafter = function (side, z, cut) {
        var polys = [], i, j;
        if (!cut) polys.push([[xT, yF], [xU, yF], [0, yUnd0], [0, yTop0]]);
        else {
          var u1 = cut[0], u2 = cut[1], ds = R.d * S.sin, dc = R.d * S.cos;
          if (u1 - ds > 0.02) polys.push([[0, yTop0], [u1, yTopU(u1)], [u1 - ds, yTopU(u1) - dc], [0, yUnd0]]);
          if (u2 < xT - 0.05) polys.push([[u2, yTopU(u2)], [xT, yF], [xU, yF], [u2 - ds, yTopU(u2) - dc]]);
        }
        for (i = 0; i < polys.length; i++) {
          var sh = new T.Shape(), P = polys[i];
          sh.moveTo(side * P[0][0], P[0][1]);
          for (j = 1; j < P.length; j++) sh.lineTo(side * P[j][0], P[j][1]);
          sh.lineTo(side * P[0][0], P[0][1]);
          var geo = new T.ExtrudeGeometry(sh, { depth: R.t, bevelEnabled: false });
          geo.translate(cx, 0, z - R.t / 2);
          g.add(new T.Mesh(geo, rafMat));
        }
        return cut ? ((xT - (cut[1] - cut[0])) / S.cos) : (xT / S.cos);
      };
      var RW = _roofWinPlan(S, R, B, RG, yTop0), nRafCut = 0;
      for (k = 0; k <= n; k++) {
        var z = RW.lines[k];                /* the grid, with the bays of the roof windows set apart (aframe-v25) */
        _rafMembers.push([cx, z, 1, 0]);   /* a rafter pair stands here, running across the A (aframe-v3) */
        for (side = -1; side <= 1; side += 2) {
          /* UNDER A SIDE WING THE RAFTER STOPS ON THE WING'S BEAM (aframe-v103) */
          var wbR = _wingBeamAt(side, z), dmR = _dormerAt(side, z);
          if (wbR) nRafCut++;      /* THE RAFTERS RUN ON WHOLE THROUGH THE WING (aframe-v123, Marek: krokve maji jit pres cele kridlo az dolu, neprerusuji se) */
          var kRo = g.children.length;
          rafLen += rafter(side, z, null); nRaf++;
          /* a rafter pair past the gables stands over a porch, open from below between its T&G: outdoor wood (aframe-v154) */
          if (k < RG.gable[0] || k > RG.gable[1]) _outFlag(ctx, kRo, 'porch rafters');
        }
      }
      _buildRoofWins(ctx, RW, rafter, S, R, cx, yTop0); AR();
      /* THE DOOR BAYS' TRIMMERS DOUBLED (aframe-v106): a second rafter inside
         each, screwed to it every 400 in two rows, on each wing's side; cut on
         the wing's beam like the rafter it doubles */
      var nWSis = 0, wSisL = 0;
      _wingSides().forEach(function (sdW) {
        var WGs = _wingGrid(), WBs = _wingBeam(sdW);
        [[WGs.trim[0], 1], [WGs.trim[1], -1]].forEach(function (TR) {
          var zS = TR[0] + TR[1] * R.t; wSisL += rafter(sdW, zS, null); nWSis++;
        });
      });
      if (nWSis) {
        API.billAdd('aframe-frame', R.code, wSisL * 1.05);
        API.billAdd('aframe-frame', 'FAS75132', Math.ceil(wSisL / 0.40) * 2);
        var WGl = _wingGrid(); ctx.log('wingraf  the wing\'s rafters: ' + WGl.n + ' bay(s) round its axis at ' + Math.round(WGl.cz * 1000) + ' -- ' + (WGl.odd ? ('one door bay ' + Math.round(WGl.db * 1000) + ' centred on it between two trimmers') : ('a rafter on it, a door bay ' + Math.round(WGl.db * 1000) + ' each side')) + ', ' + WGl.k + ' bay(s) of ' + Math.round(RAF.sp * 1000) + ' each side; ' + nWSis + ' doubling rafter(s) inside the trimmers');
      }
      if (nRafCut) ctx.log('wingbeam ' + nRafCut + ' rafter(s) run on whole through the side wing down to the plate, the beam hung under them -- the house and the wing are one room between them');
      /* THE RAFTERS AT THE RIDGE (aframe-v27, S3). Each pair meets plumb-cut
         over the ridge beam; a connector plate 250 x 150 (ROT00006, the
         catalogue's big truss plate) on each face ties the two rafters
         together, hand-nailed with 8 x FAS38038 into each rafter, and every
         rafter -- the doubling ones round the roof windows too -- is screwed
         down into the ridge beam with one FAS75132 through its plumb cut. */
      var GUS = { code: 'ROT00006', l: 0.250, w: 0.150, t: 0.003, nailsPerRafter: 8, col: 0x9AA3AB };
      var gMat = new T.MeshStandardMaterial({ color: GUS.col, roughness: 0.4, metalness: 0.6 });
      /* THE PLATE LIES WHOLLY ON THE RAFTERS (aframe-v44, Marek: stycnikove
         desky trci do prostoru): its top corners sit 5 under the rafters' top
         face where they fall, half its length out from the ridge line, so no
         corner stands proud of the pair; its foot must stay above the plumb
         cut's lower end, or it would hang under the rafters */
      var yGusTop = yTop0 - (GUS.l / 2) * S.tan - 0.005, gusLow = (yGusTop - GUS.w) - (yTop0 - R.d / S.cos);
      ctx.log('ridge    connector plates ' + GUS.code + ' ' + Math.round(GUS.l * 1000) + 'x' + Math.round(GUS.w * 1000) + ' set down onto the rafters: top ' + Math.round((yTop0 - yGusTop) * 1000) + ' under the ridge line, foot ' + Math.round(gusLow * 1000) + ' above the plumb cut\'s lower end' + (gusLow < 0 ? ' -- ERROR the plate hangs under the rafters at this pitch' : ' -- whole on the rafters'));
      for (k = 0; k <= n; k++) {
        for (side = -1; side <= 1; side += 2) {
          _am(ctx, 'ridge_plates', 'Connector plates', GUS.code, 'top'); var gp = new T.Mesh(new T.BoxGeometry(GUS.l, GUS.w, GUS.t), gMat);
          gp.position.set(cx, yGusTop - GUS.w / 2, RW.lines[k] + side * (R.t / 2 + GUS.t / 2 + 0.0005));
          g.add(gp);
        }
      }
      /* THE RAKE OVERHANG (aframe-v31): lookouts, 60 x 160 laid flat, their
         top flush with the rafters' top face, every 600 down the slope from
         300 under the ridge; each runs from the fly rafter's inner face over
         the gable rafter (notched into its top) to the first common rafter,
         nailed 3 through the fly rafter into its end, 2 down into the gable
         rafter, 3 through the common rafter into its other end. The gable
         rafter is nailed down into the gable's raked top plate every 400. */
      var LKO = { code: 'KVH60160', w: 0.160, h: 0.060, sp: 0.60, first: 0.30, nails: 8 };
      var LtopF = (S.w / 2) / S.cos, lkLen = 0, nLk = 0, rakeNail = 0, lkNote = [], ee;
      var atF = function (sd, s0, o0) { return { x: cx + sd * (s0 * S.cos + o0 * S.sin), y: yTop0 - s0 * S.sin + o0 * S.cos }; };
      if (n >= 4) {
        for (ee = 0; ee < 2; ee++) {
          if (RG.porch[ee]) { lkNote.push((ee === 0 ? 'front' : 'back') + ': a porch, no lookouts (the pairs go on over it)'); continue; }
          var GIk = RG.gable, zf = (ee === 0) ? RW.lines[0] : RW.lines[n], zgR = (ee === 0) ? RW.lines[GIk[0]] : RW.lines[GIk[1]], zi = (ee === 0) ? RW.lines[GIk[0] + 1] : RW.lines[GIk[1] - 1];
          var dirE = (ee === 0) ? 1 : -1, la = zf + dirE * R.t / 2, lb = zi - dirE * R.t / 2, lL = Math.abs(lb - la), nE = 0;
          for (side = -1; side <= 1; side += 2) {
            for (var sL = LKO.first; sL < LtopF - 0.40; sL += LKO.sp) {
              _am(ctx, 'roof_framing_lookouts', 'Lookouts', LKO.code, 'side'); var PL = atF(side, sL, -LKO.h / 2), lk = new T.Mesh(new T.BoxGeometry(LKO.w, LKO.h, lL), rafMat);
              lk.position.set(PL.x, PL.y, (la + lb) / 2); lk.rotation.z = -side * S.p; g.add(lk);
              lkLen += lL; nLk++; nE++;
            }
            if (!_gableFull(ee)) rakeNail += Math.ceil(LtopF / 0.40);
          }
          if (_gableFull(ee)) lkNote.push((ee === 0 ? 'front' : 'back') + ': full glazing -- no raked plate to nail the gable rafter down into');
          lkNote.push((ee === 0 ? 'front' : 'back') + ': fly rafter at ' + Math.round((zf - (ee === 0 ? B.z0 : B.z1)) * 1000) + ' from the gable face, gable rafter over the wall at ' +
                      Math.round((zgR - (ee === 0 ? B.z0 : B.z1)) * 1000) + ', first common at ' + Math.round((zi - (ee === 0 ? B.z0 : B.z1)) * 1000) + '; ' + nE + ' lookout(s) ' + Math.round(lL * 1000) + ' long');
        }
        API.billAdd('aframe-frame', LKO.code, lkLen * 1.05);
        API.billAdd('aframe-frame', 'FAS45145', nLk * LKO.nails + rakeNail);
        ctx.log('rake     ' + lkNote.join(' | '));
        ctx.log('BILL  rake ' + nLk + ' lookout(s) ' + LKO.code + ' ' + (lkLen * 1.05).toFixed(1) + ' m (+5%), every ' + Math.round(LKO.sp * 1000) + ' down the slope from ' + Math.round(LKO.first * 1000) + ' under the ridge');
        ctx.log('FIX  rake ' + (nLk * LKO.nails) + ' x FAS45145 on the lookouts (3 + 2 + 3 each) + ' + rakeNail + ' x FAS45145 gable rafters down into the raked top plates every 400');
      } else ctx.log('rake     too few rafter lines for lookouts (' + (n + 1) + ')');
      if (_joistNote) ctx.log(_joistNote);
      /* THE US STOCK LENGTH (aframe-v41): dimensional lumber is sold to about
         24 ft (7315); a longer rafter is spliced or made of LVL / glulam */
      /* LVL, NOT A SPLICE (aframe-v88, Marek: rozhodni ty sam podle praxe).
         An A-frame rafter spliced would be joined mid-span where it bends the
         most, each joint an engineered plate pair on every rafter; the US
         practice past sawn stock is a one-piece LVL rafter, sold to 60 ft.
         So a rafter over 24 ft is billed whole as KVI45240 (45 x 240, 2.0E):
         against sawn 60 x 240 it is as stiff (13.8 against 11 GPa on three
         quarters of the width) and far stronger in bending. The drawing keeps
         the rafter's own section; the lining and the floors are unchanged. */
      var rafL = (S.w / 2) / S.cos, useLVL = rafL > LVL.over;
      ctx.log('length   rafters ' + (rafL * 1000).toFixed(0) + ' long' + (useLVL ? (' -- OVER the 24 ft (7315) US stock length: every rafter billed as one-piece LVL ' + LVL.code + ' 45x240 instead of ' + R.code + ' (no splice)') : ' -- within the 24 ft US stock length, ' + R.code));
      var nPair = n + 1, nGus = 2 * nPair, nGusNail = nGus * 2 * GUS.nailsPerRafter, nRidgeScrew = nRaf + RW.sisters.length;
      API.billAdd('aframe-frame', GUS.code, nGus);
      API.billAdd('aframe-frame', 'FAS38038', nGusNail);
      API.billAdd('aframe-frame', 'FAS75132', nRidgeScrew);
      ctx.log('ridge    ' + nPair + ' rafter pair(s) meet plumb-cut over the ridge beam: ' + nGus + ' x ' + GUS.code + ' ' + Math.round(GUS.l * 1000) + 'x' + Math.round(GUS.w * 1000) + ' (one on each face of a pair), its top 10 under the ridge line at ' + Math.round(yTop0 * 1000));
      ctx.log('FIX  ridge ' + nGusNail + ' x FAS38038 (' + GUS.nailsPerRafter + ' into each rafter through each plate); ' + nRidgeScrew + ' x FAS75132 7.5x132 down through each rafter\'s plumb cut into the ridge beam (' + nRaf + ' rafters + ' + RW.sisters.length + ' doubling)');
      /* the ridge beam, its top under the rafters' meeting point */
      var yRb = S.ridgeY - R.d / S.cos;
      _am(ctx, 'ridge_beam', 'Ridge beam', RIDGE.code, 'top'); _box(T, g, RIDGE.w, RIDGE.h, z1 - z0, cx, yRb - RIDGE.h / 2, (z0 + z1) / 2, 0, WOOD, 1);
      API.billAdd('aframe-frame', useLVL ? LVL.code : R.code, rafLen * 1.05);
      API.billAdd('aframe-frame', RIDGE.code, (z1 - z0) * 1.05);
      /* THE PLATES THE FEET STAND ON, AND WHAT HOLDS THEM (aframe-v8, S1) */
      var BR = _baseRect(), onSlab = (STATE.foundation === 'strips'), yP = _deckY(), plateL = BR.z1 - BR.z0, sideP, nBolt = 0, nScrew = 0;
      var PF = _plateFit(), bq, amPl = function () { _am(ctx, 'sill_plate', 'Sill plate', PF.code, 'top'); }; amPl();
      var steelM = new T.MeshStandardMaterial({ color: 0x7C838A, roughness: 0.5, metalness: 0.7 });
      for (sideP = -1; sideP <= 1; sideP += 2) {
        for (bq = 0; bq < PF.n; bq++) {
          var xB = cx + sideP * (S.w / 2 - PF.bw / 2 - bq * PF.bw);
          amPl(); _box(T, g, PF.bw - 0.002, PF.h, plateL, xB, yP + PF.h / 2, (BR.z0 + BR.z1) / 2, 0, WOOD, 1);
        }
        var xP = cx + sideP * (S.w / 2 - PF.w / 2);
        if (onSlab) {
          _am(ctx, 'sill_seal', 'Sill seal', 'INS01003', 'top'); _box(T, g, PF.w - 0.010, 0.005, plateL, xP, yP - 0.0025 + 0.005, (BR.z0 + BR.z1) / 2, 0, 0x3C3F42, 1);
          /* anchor bolts every 1.8 m, one within 300 of each end -- the ADU's
             sill rule; with two boards they alternate between them */
          var nA = Math.max(2, Math.ceil(plateL / 1.8) + 1), a;
          for (a = 0; a < nA; a++) {
            var zb = BR.z0 + 0.3 + (plateL - 0.6) * a / (nA - 1);
            var xBolt = cx + sideP * (S.w / 2 - PF.bw / 2 - ((PF.n > 1 && a % 2) ? PF.bw : 0));
            /* THE ANCHOR (aframe-v15, F5): a 500 piece of M16 threaded rod
               FAT16010 cast into the slab, a nut FAT16011 and washer FAT16001
               on its buried end to hold it, and on the plate a washer
               FAT16001 under a cap nut FAT16002 */
            _am(ctx, 'anchor_bolts', 'Anchor bolts', 'FAT16010', 'top'); var rod = new T.Mesh(new T.CylinderGeometry(0.008, 0.008, 0.50, 8), steelM);
            rod.position.set(xBolt, yP + PF.h + 0.025 - 0.25, zb); g.add(rod);
            var nutB = new T.Mesh(new T.CylinderGeometry(0.013, 0.013, 0.013, 6), steelM);
            nutB.position.set(xBolt, yP + PF.h + 0.025 - 0.50 + 0.02, zb); g.add(nutB);
            var wsh = new T.Mesh(new T.CylinderGeometry(0.017, 0.017, 0.003, 12), steelM);
            wsh.position.set(xBolt, yP + PF.h + 0.0015, zb); g.add(wsh);
            var cap = new T.Mesh(new T.CylinderGeometry(0.009, 0.013, 0.022, 6), steelM);
            cap.position.set(xBolt, yP + PF.h + 0.003 + 0.011, zb); g.add(cap);
            nBolt++;
          }
        } else {
          nScrew += (Math.ceil(plateL / 0.6) + 1) * PF.n;
        }
      }
      /* A HURRICANE TIE ON EVERY RAFTER'S FOOT, drawn as the bent strap it is
         (aframe-v11, Marek: pasy trcici nahoru): one leg up the rafter's side,
         a web across the plate's top, a leg down the plate's inner face */
      var nTie = 0, tieCol = 0x9EA3A8, seatIn = S.w / 2 - PF.seat; _am(ctx, 'hurricane_ties', 'Hurricane ties', 'ROT00007', 'side');
      for (k = 0; k <= n; k++) {
        var zt = RW.lines[k];
        if (zt < BR.z0 - 0.01 || zt > BR.z1 + 0.01) continue;
        for (sideP = -1; sideP <= 1; sideP += 2) {
          var zs = zt + R.t / 2 + 0.001, xLegA = cx + sideP * (seatIn + 0.03), xInner = cx + sideP * (S.w / 2 - PF.w);
          var yTopP = yP + PF.h;
          _box(T, g, 0.040, 0.150, 0.002, xLegA, yTopP + 0.075, zs, 0, tieCol, 1);
          var webL = Math.abs(xLegA - xInner);
          if (webL > 0.005) _box(T, g, webL, 0.002, 0.040, (xLegA + xInner) / 2, yTopP + 0.001, zs + 0.019, 0, tieCol, 1);
          _box(T, g, 0.002, PF.h, 0.040, xInner - sideP * 0.001, yP + PF.h / 2, zs + 0.019, 0, tieCol, 1);
          nTie++;
        }
      }
      var nFeetAir = (nRaf / 2 - (function () { var c = 0, kk; for (kk = 0; kk <= n; kk++) { var zz = RW.lines[kk]; if ((zz >= BR.z0 - 0.01 && zz <= BR.z1 + 0.01) || (RG.porch[0] && zz < BR.z0) || (RG.porch[1] && zz > BR.z1)) c++; } return c; })()) * 2;
      API.billAdd('aframe-frame', PF.code, 2 * PF.n * plateL * 1.05);
      /* two boards side by side are one plate: nailed through each other at
         400 (the ADU's stitching rule for doubled members) */
      var nStitch = (PF.n > 1) ? 2 * Math.ceil(plateL / 0.40) : 0;
      if (nStitch) API.billAdd('aframe-frame', 'FAS45145', nStitch);
      if (nBolt) {
        API.billAdd('aframe-frame', 'FAT16010', Math.ceil(nBolt / 2));   /* two 500 pieces out of each 1 m rod */
        API.billAdd('aframe-frame', 'FAT16011', nBolt);
        API.billAdd('aframe-frame', 'FAT16001', nBolt * 2);
        API.billAdd('aframe-frame', 'FAT16002', nBolt);
        API.billAdd('aframe-frame', 'INS01003', 2 * PF.n * plateL);
      }
      if (nScrew) API.billAdd('aframe-frame', 'FAS75132', nScrew);
      API.billAdd('aframe-frame', 'ROT00007', nTie);
      API.billAdd('aframe-frame', 'FAS38038', nTie * 10);
      ctx.log('plate    2 x ' + (PF.n > 1 ? (PF.n + ' boards x ') : '') + plateL.toFixed(2) + ' m ' + PF.code + ' ' + Math.round(PF.h * 1000) + 'x' + Math.round(PF.bw * 1000) + ' flat (' + Math.round(PF.w * 1000) + ' wide for a ' + Math.round(PF.seat * 1000) + ' seat) on the ' + (onSlab ? 'slab' : 'timber floor') + ' at ' + Math.round(yP * 1000) +
              ', top at ' + Math.round((yP + PF.h) * 1000) + ' = the rafters\' level seat; ' +
              (onSlab ? (nBolt + ' anchors M16 (1.8 m, 300 from the ends): ' + Math.ceil(nBolt / 2) + ' x FAT16010 rod 1 m cut in two 500 pieces, ' + nBolt + ' x FAT16011 nut + ' + (nBolt * 2) + ' x FAT16001 washer + ' + nBolt + ' x FAT16002 cap nut; through a sill seal INS01003 ' + (2 * PF.n * plateL).toFixed(1) + ' m')
                      : (nScrew + ' x FAS75132 7.5x132 down through the deck into the rim (every 600)')));
      var seatY = _deckY() + PF.h, topAtEdge = S.top + (S.half - S.w / 2) * S.tan;
      ctx.log('plate    rafter foot: top face meets the plate outer edge at ' + Math.round(topAtEdge * 1000) + ' (plate top ' + Math.round(seatY * 1000) + (Math.abs(topAtEdge - seatY) < 0.002 ? ' OK' : ' -- MISMATCH') +
              '), level seat ' + Math.round(R.d / S.sin * 1000) + ' long from the outer edge inwards on a ' + Math.round(PF.w * 1000) + ' plate' + (R.d / S.sin > PF.w + 0.001 ? (' -- the seat is longer than the plate, ' + Math.round((R.d / S.sin - PF.w) * 1000) + ' of it bears on the deck inside') : ' -- the whole seat on the plate') +
              '; the core roof plane runs ' + Math.round(_eaveOut * 1000) + ' past the foot (its minimum eave plus cladding) -- the skin will be trimmed to the foot when it is switched back on');
      ctx.log('plate    ' + nTie + ' hurricane ties ROT00007 on the rafter feet, ' + (nTie * 10) + ' x FAS38038 (10 a tie, the ADU truss rule); no birdsmouth at ' + S.deg +
              ' deg, the foot is cut level; eave overhang held at 0 (no tails into the slab edge)' +
              (nFeetAir > 0 ? ('; ERROR ' + nFeetAir + ' rafter(s) stand past the base with no plate under their feet') : '; every rafter on the plate, the base runs ' + Math.round((BR.z1 - BR.z0) * 1000) + ' under the house' + ((RG.porch[0] || RG.porch[1]) ? ', the porch plates on posts beyond it (porch)' : ' and its rake')));
      if (nStitch) ctx.log('FIX  plate 2 boards stitched -> ' + nStitch + ' x FAS45145 at 400 (the ADU doubled-member rule)');
      ctx.log('plate    ties: bent strap, leg up the rafter side, web over the plate, leg down its inner face; anchors cast in, a nut and washer on the buried end, a washer and cap nut on the plate');
      if (onSlab) ctx.log('plate    on concrete the plate is pressure-treated ' + PF.code + ' 45x290' + (PF.n > 1 ? ' (two side by side)' : '') + '; on the timber floor it stays untreated');

      /* the upper floors: joists across, every 600 along, the deck on top.
         Where the floor has a stair opening (aframe-v4) the joists that run
         through it are cut into tails on doubled headers, the opening is
         framed by doubled trimmers, and the deck is laid round it. */
      var joistLen = 0, nJ = 0, deckArea = 0, f, holeNote = [], jScrew = 0, jNail = 0, nLedger = 0, glueL = 0, glueNote = [];
      /* THE UPPER FLOORS IN REVIEW (aframe-v134): layer 1 (the joists, ledgers,
         headers and blocks) magenta while it is under review, layer 2 (the OSB
         deck) magenta at its step and not drawn below it; both billed always */
      var rvJ = _ufRv(UF.joists), colJ = rvJ ? MAGENTA : WOOD, rvO = _ufRv(UF.osb), onO = _ufOn(UF.osb);
      /* THE JOISTS AND THE DECK ARE ITEMS OF THEIR OWN (aframe-v134): until now
         they went in under the sill plate's mark, so the walk called them sill
         plates and the core's coating painted the OSB decks as timber. Two
         marks, switched as the pieces go in, and the plate's put back after. */
      var mkPrev = ctx.item, mkJ = null, mkO = null;
      if (fl.length > 1) {
        _asmMark(ctx, 'layer_floor_joists', 'top', 'Floor joists', FLOOR.joist.code); mkJ = ctx.item;
        _asmMark(ctx, 'layer_floor_subfloor', 'top', 'Subfloor OSB', FLOOR.deck.code); mkO = ctx.item;
        ctx.item = mkJ;
      }
      var jBox = function (w, h, d, x, y, z) { if (mkJ) ctx.item = mkJ; return _rvTag2(_box(T, g, w, h, d, x, y, z, 0, colJ, 1), rvJ); };
      var deckBox = function (w, d, x, y, z) {
        if (mkO) ctx.item = mkO;
        if (rvO) _rvTag(_box(T, g, w, FLOOR.deck.t, d, x, y, z, 0, MAGENTA, 1));
        else if (onO) _osbBox(T, g, w, FLOOR.deck.t, d, x, y, z);
      };
      for (f = 1; f < fl.length; f++) {
        var F = fl[f], wF = F.floorWidth, tJ = FLOOR.joist.t, q, Hh = _hole(f), deck0 = deckArea;
        var yJ1 = F.y - FLOOR.deck.t, yJ0 = yJ1 - FLOOR.joist.d, yJ = (yJ0 + yJ1) / 2;
        var xTop = (yTop0 - yJ1) / S.tan, xBot = (yTop0 - yJ0) / S.tan, xa = cx - wF / 2, xb = cx + wF / 2;
        var JL = _joistLayout(f, RW.lines, RW.sisters);
        /* one joist, or a tail of one, as its profile across the A: the ends
           that meet a rafter are cut along the rafters' top face */
        var jMat = new T.MeshStandardMaterial({ color: colJ, roughness: 0.85, side: T.DoubleSide });
        var jPiece = function (xl, xr, cutL, cutR, z) {
          var P = [[cutL ? cx - xBot : xl, yJ0], [cutR ? cx + xBot : xr, yJ0], [cutR ? cx + xTop : xr, yJ1], [cutL ? cx - xTop : xl, yJ1]];
          var sh = new T.Shape(), pq;
          sh.moveTo(P[0][0], P[0][1]); for (pq = 1; pq < 4; pq++) sh.lineTo(P[pq][0], P[pq][1]); sh.lineTo(P[0][0], P[0][1]);
          var ge = new T.ExtrudeGeometry(sh, { depth: tJ, bevelEnabled: false }); ge.translate(0, 0, z - tJ / 2);
          if (mkJ) ctx.item = mkJ;
          g.add(_rvTag2(new T.Mesh(ge, jMat), rvJ));
          var len = Math.max(P[1][0], P[2][0]) - Math.min(P[0][0], P[3][0]);
          joistLen += len; nJ++;
          jScrew += ((cutL ? 1 : 0) + (cutR ? 1 : 0)) * 4;
          return len;
        };
        var inHoleZ = function (z) { return Hh && z > Hh.z0 - tJ && z < Hh.z1 + tJ; };
        var hx0 = Hh ? Hh.x0 - 2 * tJ : 0, hx1 = Hh ? Hh.x1 + 2 * tJ : 0, zPrev = null, zNext = null, nTail = 0;
        var SLf = _slotRects(f), nSlotTail = 0;
        for (q = 0; q < JL.joists.length; q++) {
          var zj = JL.joists[q].z, cutsX = [], sq;
          if (inHoleZ(zj)) cutsX.push([hx0, hx1]);
          for (sq = 0; sq < SLf.length; sq++) if (zj + tJ / 2 > SLf[sq].z0 && zj - tJ / 2 < SLf[sq].z1) { cutsX.push(SLf[sq].sd < 0 ? [cx - 99, SLf[sq].xD] : [SLf[sq].xD, cx + 99]); nSlotTail++; }
          if (!inHoleZ(zj)) {
            if (Hh && zj <= Hh.z0 - tJ) zPrev = zj;
            if (Hh && zj >= Hh.z1 + tJ && zNext == null) zNext = zj;
          }
          if (!cutsX.length) { jPiece(cx - xBot, cx + xBot, true, true, zj); continue; }
          /* the joist less the cuts, piece by piece; a cut end sits in a hanger (3 nails) */
          cutsX.sort(function (a, b) { return a[0] - b[0]; });
          var xs = cx - xBot, cq9;
          for (cq9 = 0; cq9 <= cutsX.length; cq9++) {
            var xe = (cq9 < cutsX.length) ? cutsX[cq9][0] : cx + xBot;
            xe = Math.min(xe, cx + xBot);
            if (xe - xs > 0.05) { jPiece(xs, xe, xs <= cx - xBot + 1e-6, xe >= cx + xBot - 1e-6, zj); nTail++; jNail += 3; }
            if (cq9 < cutsX.length) xs = Math.max(xs, cutsX[cq9][1]);
          }
        }
        /* a header across each slot at its door wall, joist-sized, in hangers on the rafters */
        SLf.forEach(function (r) {
          jBox(tJ, FLOOR.joist.d, r.z1 - r.z0, r.xD - r.sd * tJ / 2, yJ, (r.z0 + r.z1) / 2);
          joistLen += r.z1 - r.z0; nJ++; jNail += 2 * 3; glueL += r.z1 - r.z0;
        });
        if (_slotClash) ctx.log(_slotClash);
        if (SLf.length) holeNote.push('floor ' + (f + 1) + ': ' + SLf.length + ' slot(s) of the sunk dormer, ' + nSlotTail + ' joist(s) cut back to a header at the door wall');
        /* the ledgers on the gables' inner face, the floor's edge */
        for (q = 0; q < JL.ledgers.length; q++) {
          jBox(wF, FLOOR.joist.d, tJ, cx, yJ, JL.ledgers[q]);
          joistLen += wF; nJ++; nLedger++;
          jNail += 2 * Math.ceil(wF / GABLE.sp);
        }
        if (Hh) {
          var zA = (zPrev != null) ? zPrev : JL.ledgers[0], zB = (zNext != null) ? zNext : JL.ledgers[1], hl = zB - zA;
          /* doubled headers along the ridge, each side of the opening, from whole joist to whole joist */
          var hs = [Hh.x0 - tJ / 2, Hh.x0 - 1.5 * tJ, Hh.x1 + tJ / 2, Hh.x1 + 1.5 * tJ], hq;
          for (hq = 0; hq < hs.length; hq++) {
            jBox(tJ, FLOOR.joist.d, hl - tJ, hs[hq], yJ, (zA + zB) / 2);
            joistLen += hl - tJ; nJ++; jNail += 2 * 3;
          }
          /* a block across each end of the opening, between the inner headers */
          jBox(Hh.x1 - Hh.x0, FLOOR.joist.d, tJ, (Hh.x0 + Hh.x1) / 2, yJ, Hh.z0 - tJ / 2);
          jBox(Hh.x1 - Hh.x0, FLOOR.joist.d, tJ, (Hh.x0 + Hh.x1) / 2, yJ, Hh.z1 + tJ / 2);
          joistLen += 2 * (Hh.x1 - Hh.x0); nJ += 2; jNail += 2 * 2 * 3;
          glueL += 2 * (hl - tJ) + 2 * (Hh.x1 - Hh.x0);       /* the opening's inner headers and blocks carry the deck's edge */
          var dk = function (x0, x1, z0, z1) {
            if (x1 - x0 < 0.02 || z1 - z0 < 0.02) return;
            deckBox(x1 - x0, z1 - z0, (x0 + x1) / 2, F.y - FLOOR.deck.t / 2, (z0 + z1) / 2);
            deckArea += (x1 - x0) * (z1 - z0);
          };
          _rectMinus({ x0: xa, x1: xb, z0: B.z0 + GABLE.d, z1: B.z1 - GABLE.d }, [Hh].concat(SLf)).forEach(function (P) { dk(P.x0, P.x1, P.z0, P.z1); });
          holeNote.push('floor ' + f + ' opening ' + Math.round((Hh.x1 - Hh.x0) * 1000) + ' x ' + Math.round((Hh.z1 - Hh.z0) * 1000) + ': ' + nTail + ' tail(s) on doubled headers ' + Math.round((hl - tJ) * 1000) + ' long, a block at each end');
        } else {
          _rectMinus({ x0: xa, x1: xb, z0: B.z0 + GABLE.d, z1: B.z1 - GABLE.d }, SLf).forEach(function (P) {
            deckBox(P.x1 - P.x0, P.z1 - P.z0, (P.x0 + P.x1) / 2, F.y - FLOOR.deck.t / 2, (P.z0 + P.z1) / 2);
            deckArea += (P.x1 - P.x0) * (P.z1 - P.z0);
          });
        }
        /* THE GLUE ON THIS FLOOR (aframe-v134): each joist and each ledger runs
           right across the deck, so the bead on them is the deck's mean width
           (its area over its length) once a line; plus the headers and blocks
           counted above */
        var dA = deckArea - deck0, Lz = (JL.ledgers.length > 1) ? Math.abs(JL.ledgers[1] - JL.ledgers[0]) + tJ : (B.z1 - B.z0 - 2 * GABLE.d), nLine = JL.joists.length + JL.ledgers.length;
        var bead = (Lz > 0.1) ? dA / Lz * nLine : 0;
        glueL += bead;
        glueNote.push('floor ' + (f + 1) + ' ' + nLine + ' line(s) x ' + Math.round((Lz > 0.1 ? dA / Lz : 0) * 1000) + ' = ' + bead.toFixed(1) + ' m');
        ctx.log('joists   floor ' + (f + 1) + ': ' + JL.joists.length + ' joist(s) beside the rafters, ' + Math.round(2 * xBot * 1000) + ' long at the underside, ' + Math.round(2 * xTop * 1000) + ' at the top -- both ends cut along the rafters\' top face, lapping the rafter over its full depth; ' +
                JL.ledgers.length + ' ledger(s) on the gables\' inner face');
      }
      ctx.item = mkPrev;
      if (jScrew) API.billAdd('aframe-frame', 'FAS75132', jScrew);
      if (jNail) API.billAdd('aframe-frame', 'FAS45145', jNail);
      ctx.log('FIX  joists ' + jScrew + ' x FAS75132 (4 through each joist end into its rafter), ' + jNail + ' x FAS45145 (ledgers 2 into each gable stud, headers and tails 3 a joint, blocks 3 each end)');
      API.billAdd('aframe-frame', FLOOR.joist.code, joistLen * 1.05);
      API.billAdd('aframe-frame', FLOOR.deck.code, deckArea * 1.08);
      /* the deck screwed down to the joists (aframe-v39), the rate the core's timber floor uses */
      var nDeckScrew = Math.round(deckArea * 22);
      if (nDeckScrew) API.billAdd('aframe-frame', 'FAS50060', nDeckScrew);
      /* THE DECK IS GLUED AS WELL AS SCREWED (aframe-v134, US practice: a glued
         floor does not squeak and is stiffer): FEC00031 by the cartridge */
      var nGlue = (glueL > 0.01) ? Math.ceil(glueL * SUBGLUE.edges / SUBGLUE.mPerTube) : 0;
      if (nGlue) API.billAdd('aframe-frame', SUBGLUE.code, nGlue);
      if (fl.length > 1) {
        ctx.log('ufloor   L1 joists ' + FLOOR.joist.code + ' ' + joistLen.toFixed(1) + ' m in ' + nJ + ' piece(s) (joists, ledgers, headers, blocks), billed ' + (joistLen * 1.05).toFixed(1) + ' m; ' + jScrew + ' x FAS75132 into the rafters, ' + jNail + ' x FAS45145' + (rvJ ? ' -- MAGENTA, under review' : ''));
        ctx.log('ufloor   L2 OSB deck OSB25002 18: ' + deckArea.toFixed(2) + ' m2, billed ' + (deckArea * 1.08).toFixed(2) + ' m2 (+8%); ' + nDeckScrew + ' x FAS50060 (22/m2); glue ' + SUBGLUE.code + ' ' + nGlue + ' cartridge(s) of 10 oz for a 6 mm bead ' + glueL.toFixed(1) + ' m + 10% at the sheet joints, about ' + Math.round(SUBGLUE.mPerTube) + ' m a cartridge (' + glueNote.join('; ') + ')' +
                (rvO ? ' -- MAGENTA, under review' : (onO ? '' : ' -- not drawn below its step')));
      }
      var fls = [];
      for (f = 0; f < fl.length; f++) fls.push('floor ' + f + ' at ' + Math.round(fl[f].y * 1000) + ' (clear width at bed height ' + Math.round(fl[f].width * 1000) + ')');
      ctx.log('floors   ' + fl.length + ' -- ' + fls.join('; ') + (fl.length < 3 ? ' -- next floor would have ' + Math.round(S.widthAt(fl[fl.length - 1].y + fl[fl.length - 1].clear + FLOOR.joist.d + FLOOR.deck.t + BED.at) * 1000) + ' at bed height, under ' + Math.round((BED.w + 0.10) * 1000) : ''));
      ctx.log('frame    rafter lines: end ' + Math.round(RW.lines[0] * 1000) + ' / ' + Math.round(RW.lines[n] * 1000) + ', gable ' + Math.round(RW.lines[RG.gable[0]] * 1000) + ' / ' + Math.round(RW.lines[RG.gable[1]] * 1000) + ', ' + (RG.gable[1] - RG.gable[0]) + ' common bay(s) of ' + Math.round(spB * 1000) + ' between the gable rafters; porch pairs ' + (RG.gable[0] - 1) + ' front / ' + (n - 1 - RG.gable[1]) + ' back');
      var kPo = g.children.length; _buildPorch(ctx, RG, RW, S, R, B); _outFlag(ctx, kPo, 'porch');
      var kSo = g.children.length; _am(ctx, 'soffit', 'Soffit', FAC.clad.code, 'top'); _buildSoffit(ctx, RG, S, R, B);
      /* the soffit is step 6 of the gables' build-up (aframe-v148, plan G) */
      if (_isAdmin() && AF_STEP.gable < 99) ctx.log(_gableRvNote('gable    soffit: ', _rvTagList(ctx.THREE, g.children.slice(kSo), function (o) { return _asmKey(o) === 'soffit' ? 'soffit' : ''; }, _gableDefs(), AF_STEP.gable)));
      ctx.log('frame    rafters ' + nRaf + ' x ' + Math.round(R.t * 1000) + 'x' + Math.round(R.d * 1000) + ' (' + R.code + ') every ' + Math.round(spB * 1000) + ', ' + Math.round((S.w / 2) / S.cos * 100) / 100 + ' m each, ' + Math.round(rafLen) + ' m' +
              ' | ridge beam ' + Math.round((z1 - z0) * 10) / 10 + ' m ' + RIDGE.code + ' | joists ' + nJ + ', ' + Math.round(joistLen) + ' m ' + FLOOR.joist.code + ' | deck ' + Math.round(deckArea) + ' m2 | insulation ' + INSUL + ' the rafters' + (holeNote.length ? (' | ' + holeNote.join('; ')) : ''));
    }
    _regLayer({
      id: 'aframe-frame', version: VERSION, role: 'strecha', claims: ['roof-frame', 'floor'],
      build3d: _buildFrame, boq: function () { return _rows('aframe-frame'); }
    });

    /* -------------------------------------------------------------------------
       THE STAIR OPENINGS (aframe-v4, A2). One per upper floor, kept in the
       project (STATE.product.aframeHoles) and dragged on that floor's plan
       through the core's floor-hole grips. Until it is dragged it is placed
       by the flight: a landing in front of the gable, the run, and the top
       step on the opening's edge towards the middle of the cabin; floor 1's
       flight climbs from the front gable, floor 2's from the back one. The
       opening is always held inside the floor that is there at that height.
       ------------------------------------------------------------------------- */
    function _zone() { return FLOOR.joist.d + FLOOR.deck.t; }
    function _holeDefault(k) {
      var fl = floors(), B = _barRect(), cx = (B.x0 + B.x1) / 2;
      if (k < 1 || k >= fl.length || typeof API.stairKit !== 'function') return null;
      var SP = API.stairPlan({ rise: fl[k].y - fl[k - 1].y, floorZone: _zone(), kind: _stairKind() });
      var KT = API.stairKit(_stairKind(), fl[k].y - fl[k - 1].y), kw = (KT && KT.w > 0) ? KT.w : STAIR.w;
      /* the opening IS the flight's footprint from aframe-v81, so it starts as
         long as the ordinary flight: every going plus the top one */
      var len = Math.ceil(Math.max(SP.needHole, SP.n * SP.G) / 0.05 - 1e-9) * 0.05, hw = kw + 0.10;
      var z0in = B.z0 + STAIR.gable, z1in = B.z1 - STAIR.gable, foot, e1;
      /* WITH ONE SIDE WING the opening into floor 2 starts off the slots' side (aframe-v115): the sunk dormer's
         slots take floor 2 back to their door walls near the ridge line, so the flight is moved over clear of them */
      var hx0 = cx - hw / 2;
      if (k === 1) { try { var sw = _wingOk() ? _wingSides() : []; if (sw.length === 1) { var Dw = _dormer(sw[0]); if (Dw) hx0 = (sw[0] < 0) ? cx - Dw.dD + 0.01 : cx + Dw.dD - 0.01 - hw; } } catch (eSw) {} }
      /* THE LANDING IS A FULL 900 (aframe-v163): the flight is fitted to the opening (_fitFlight, goings of len / n) and starts
         one going in from the opening's far end, so the opening is set from that -- placed by the core's own run it left the
         landing 34 short on the default 6x9 ("the flight runs into the wall") */
      var FFd = _fitFlight(fl[k].y - fl[k - 1].y, len);
      if (k % 2 === 1) { foot = z0in + STAIR.landing; return { x0: hx0, x1: hx0 + hw, z0: foot - FFd.G, z1: foot - FFd.G + len }; }
      foot = z1in - STAIR.landing;
      return { x0: hx0, x1: hx0 + hw, z0: foot + FFd.G - len, z1: foot + FFd.G };
    }
    function _holeFit(k, R) {
      var fl = floors(), B = _barRect(), cx = (B.x0 + B.x1) / 2;
      if (!R || k < 1 || k >= fl.length) return null;
      var hwMax = Math.max(0.6, fl[k].floorWidth / 2 - 0.20);
      var x0 = Math.max(cx - hwMax, Math.min(R.x0, R.x1 - 0.6)), x1 = Math.min(cx + hwMax, Math.max(R.x1, x0 + 0.6));
      if (x1 - x0 < 0.6) { x0 = cx - 0.3; x1 = cx + 0.3; }
      var zl = B.z0 + STAIR.gable, zh = B.z1 - STAIR.gable;
      var z0 = Math.max(zl, Math.min(R.z0, zh - 0.6)), z1 = Math.min(zh, Math.max(R.z1, z0 + 0.6));
      return { x0: x0, z0: z0, x1: x1, z1: z1 };
    }
    function _holeBag() {
      var P = STATE.product = STATE.product || {};
      return P.aframeHoles || (P.aframeHoles = {});
    }
    /* THE FLIGHT CAN BE TURNED (aframe-v19, K1, Marek: schody s moznosti
       presunu a rotace). Each upper floor keeps the way its flight climbs,
       '+z', '+x', '-z' or '-x'; until it is turned it climbs along the
       ridge towards the middle of the cabin, as before. The Rotate tile on
       the Floorplan step turns the flight of the storey on the plan by a
       quarter, clockwise seen from above, and turns its opening with it
       about the opening's centre; the opening is still dragged by its
       grips. Across the A the upper floor is narrow, so a flight turned
       across it may not fit -- the drawer's headroom line says so. */
    var DIRS = ['+z', '+x', '-z', '-x'];
    function _dirBag() { var P = STATE.product = STATE.product || {}; return P.aframeStairDir || (P.aframeStairDir = {}); }
    function _stairDir(k, H) {
      var d = _dirBag()[String(k)];
      if (DIRS.indexOf(d) >= 0) return d;
      var B = _barRect(), cz = (B.z0 + B.z1) / 2;
      return (H && (H.z0 + H.z1) / 2 < cz) ? '+z' : '-z';
    }
    function _rotateStair(k) {
      var H = _hole(k); if (!H) { _log('stairs   rotate: floor ' + k + ' has no opening'); return; }
      var d0 = _stairDir(k, H), d1 = DIRS[(DIRS.indexOf(d0) + 1) % 4];
      var cxH = (H.x0 + H.x1) / 2, czH = (H.z0 + H.z1) / 2, hw = (H.x1 - H.x0) / 2, hl = (H.z1 - H.z0) / 2;
      _holeBag()[String(k)] = { x0: cxH - hl, x1: cxH + hl, z0: czH - hw, z1: czH + hw };
      _dirBag()[String(k)] = d1;
      try { if (API.savePref) API.savePref(); } catch (eSv) {}
      API.rebuild();
      var H2 = _hole(k);
      _log('stairs   floor ' + k + ' flight turned ' + d0 + ' -> ' + d1 + ', opening ' + Math.round((H2.x1 - H2.x0) * 1000) + ' x ' + Math.round((H2.z1 - H2.z0) * 1000) +
           ' about its centre' + ((Math.abs((H2.x1 - H2.x0) - 2 * hl) > 0.01 || Math.abs((H2.z1 - H2.z0) - 2 * hw) > 0.01) ? ' -- CUT BACK to fit the floor' : ''));
    }
    function _hole(k) {
      var H = _holeBag()[String(k)];
      return _holeFit(k, (H && typeof H.x0 === 'number') ? H : _holeDefault(k));
    }
    /* THE SUNK DORMER'S SLOTS CUT FLOOR 2 BACK TO THEIR DOOR WALLS (aframe-v115).
       On floor 2 (k = 1) each slot is a rectangle from the door wall's outer
       face out past the slope, between the slot's rafters: the joists in it
       are cut there onto a header, and the deck, the wool, the underlay, the
       vinyl and the ceiling under it are cut out. Where the stair opening
       reaches into a slot the slot is kept clear of it (the two never
       overlap as holes) and the log says so. */
    var _slotClash = '';
    function _slotRects(k) {
      var out = [];
      if (k !== 1) return out;
      var ok = false; try { ok = _wingOk(); } catch (eO) { ok = false; }
      if (!ok) return out;
      var B = _barRect(), cx = (B.x0 + B.x1) / 2, H = _hole(k), clash = [];
      _wingSides().forEach(function (sd) {
        var D = _dormer(sd); if (!D) return;
        var xD = cx + sd * D.dD, far = cx + sd * 9;
        [[D.bays[0][0], D.bays[D.bays.length - 1][1]]].forEach(function (b) {      /* one rect over all the slots and the axis rafter between them (aframe-v125) */
          var r = { sd: sd, xD: xD, x0: Math.min(xD, far), x1: Math.max(xD, far), z0: b[0], z1: b[1] };
          if (H && H.z1 > r.z0 && H.z0 < r.z1 && H.x1 > r.x0 && H.x0 < r.x1) {
            clash.push((sd < 0 ? 'left' : 'right') + ' slot ' + Math.round(b[0] * 1000) + '..' + Math.round(b[1] * 1000));
            if (sd < 0) r.x1 = Math.min(r.x1, H.x0 - 0.002); else r.x0 = Math.max(r.x0, H.x1 + 0.002);
          }
          if (r.x1 - r.x0 > 0.02) out.push(r);
        });
      });
      _slotClash = clash.length ? ('dormer   WARNING the stair opening on floor 2 reaches into the ' + clash.join(', ') + ' -- the slot is kept clear of the opening; move the stairs away from the wing\'s middle on the plan') : '';
      return out;
    }
    /* a rectangle less a set of rectangles, as rectangles (for the decks) */
    function _rectMinus(R, cuts) {
      var parts = [R];
      cuts.forEach(function (C) {
        var nx = [];
        parts.forEach(function (P) {
          if (C.x1 <= P.x0 || C.x0 >= P.x1 || C.z1 <= P.z0 || C.z0 >= P.z1) { nx.push(P); return; }
          if (C.z0 > P.z0) nx.push({ x0: P.x0, x1: P.x1, z0: P.z0, z1: C.z0 });
          if (C.z1 < P.z1) nx.push({ x0: P.x0, x1: P.x1, z0: C.z1, z1: P.z1 });
          var za = Math.max(P.z0, C.z0), zb = Math.min(P.z1, C.z1);
          if (C.x0 > P.x0) nx.push({ x0: P.x0, x1: C.x0, z0: za, z1: zb });
          if (C.x1 < P.x1) nx.push({ x0: C.x1, x1: P.x1, z0: za, z1: zb });
        });
        parts = nx;
      });
      return parts.filter(function (P) { return P.x1 - P.x0 > 0.01 && P.z1 - P.z0 > 0.01; });
    }
    /* holes for a floor-sized shape: the stair opening and the slots, clipped to the shape */
    function _floorHolePaths(T, k, x0, x1, z0, z1) {
      var list = [], out = { paths: [], area: 0 };
      var H = (k >= 1) ? _hole(k) : null; if (H) list.push(H);
      _slotRects(k).forEach(function (r) { list.push(r); });
      list.forEach(function (h) {
        var a0 = Math.max(x0, h.x0), a1 = Math.min(x1, h.x1), b0 = Math.max(z0, h.z0), b1 = Math.min(z1, h.z1);
        if (a1 - a0 < 0.01 || b1 - b0 < 0.01) return;
        if (a0 <= x0 + 0.002) a0 = x0 + 0.002; if (a1 >= x1 - 0.002) a1 = x1 - 0.002;
        var hp = new T.Path(); hp.moveTo(a0, b0); hp.lineTo(a0, b1); hp.lineTo(a1, b1); hp.lineTo(a1, b0); hp.lineTo(a0, b0);
        out.paths.push(hp); out.area += (a1 - a0) * (b1 - b0);
      });
      return out;
    }
    /* THE FLIGHT IS EDITED ON THE FLOOR IT STARTS FROM (aframe-v82, Marek:
       schody footprint se ma umistovat a editovat vzdy v podlazi, kde
       zacinaji): on storey p's plan the grips hold the opening of the flight
       that climbs from p to p + 1 -- the core shows them on that storey only
       (the hook's storey) */
    __PROD._floorHole = function () {
      var p = STATE.planStorey | 0, k = p + 1;
      if (k < 1 || k >= floors().length) return null;
      return {
        storey: p,
        get: function () { return _hole(k); },
        set: function (R) { if (R) { _holeBag()[String(k)] = { x0: R.x0, z0: R.z0, x1: R.x1, z1: R.z1 }; _pxRedraw(); } },
        /* for a turn handle on the plan (aframe-v30): the core calls rotate()
           and reads dir() for the arrow, once it draws the handle */
        rotate: function () { _rotateStair(k); },
        dir: function () { return _stairDir(k, _hole(k)); }
      };
    };
    /* THE GUARD ROUND THE STAIR OPENING, ONLY WHERE ONE CAN STAND (aframe-v30,
       Marek: zabradli se generuje po celem obvodu, leze i pres krokve ven).
       The drawer's guard runs round the whole opening; under the slope of an
       A nobody walks beside the opening, and the rails came out through the
       rafters. So the guard is this product's: on the sides the drawer would
       guard -- every side but the one the flight arrives at -- and only where
       the clear height over the upper floor, under the rafters, is at least
       GUARD.clear; a side along the climb is kept or left whole, a side
       across it is cut back to where that height is. Posts at the ends and at
       most 1200 apart, a top rail at 900, a bottom rail at 100, billed by the
       metre as the drawer bills it. */
    var GUARD = { h: 0.90, clear: 1.20, post: 0.07, maxSp: 1.20, code: 'SIS00001', col: 0x6B5A45 };
    function _stairGuard(ctx, H, up, yF, tag) {
      var T = ctx.THREE, g = ctx.group, G = _gGeo(), S = G.S, cx = G.cx;
      var clr = function (x) { return G.yUnder(x) - yF; };
      var xLim = S.half - S.rafD / S.sin - (yF + GUARD.clear - S.top) / S.tan;   /* |x - cx| up to which there is GUARD.clear */
      var alongX = (up === '+x' || up === '-x'), sgn = (up.charAt(0) === '-') ? -1 : 1, edges = [], x0 = H.x0, x1 = H.x1, z0 = H.z0, z1 = H.z1, notes = [], len = 0, ei, nPost = 0;
      if (alongX) {
        edges.push({ a: [x0, z0], b: [x1, z0], name: 'side z0' }, { a: [x0, z1], b: [x1, z1], name: 'side z1' });
        edges.push(sgn > 0 ? { a: [x0, z0], b: [x0, z1], name: 'end x0' } : { a: [x1, z0], b: [x1, z1], name: 'end x1' });
      } else {
        edges.push({ a: [x0, z0], b: [x0, z1], name: 'side x0' }, { a: [x1, z0], b: [x1, z1], name: 'side x1' });
        edges.push(sgn > 0 ? { a: [x0, z0], b: [x1, z0], name: 'end z0' } : { a: [x0, z1], b: [x1, z1], name: 'end z1' });
      }
      var mR = new T.MeshStandardMaterial({ color: GUARD.col, roughness: 0.6, metalness: 0.1 });
      var bx = function (w, h, d, x, y, z, ry) { var m = new T.Mesh(new T.BoxGeometry(w, h, d), mR); m.position.set(x, y, z); if (ry) m.rotation.y = ry; g.add(m); return m; };
      for (ei = 0; ei < edges.length; ei++) {
        var E = edges[ei], A = E.a.slice(), Bq = E.b.slice();
        if (Math.abs(A[0] - Bq[0]) < 1e-6) {
          /* along z, at one x: kept whole or left out */
          var c0 = clr(A[0]);
          if (c0 < GUARD.clear) { notes.push(E.name + ' left out (clear ' + Math.round(c0 * 1000) + ' under the rafters)'); continue; }
        } else {
          /* across x: cut back to the part with the clear height */
          var xa = Math.max(Math.min(A[0], Bq[0]), cx - xLim), xb = Math.min(Math.max(A[0], Bq[0]), cx + xLim);
          if (xb - xa < 0.20) { notes.push(E.name + ' left out (no ' + Math.round(GUARD.clear * 1000) + ' clear along it)'); continue; }
          if (xb - xa < Math.abs(Bq[0] - A[0]) - 0.005) notes.push(E.name + ' cut back to ' + Math.round((xb - xa) * 1000) + ' of ' + Math.round(Math.abs(Bq[0] - A[0]) * 1000));
          A = [xa, A[1]]; Bq = [xb, Bq[1]];
        }
        var L = Math.hypot(Bq[0] - A[0], Bq[1] - A[1]);
        if (L < 0.05) continue;
        var ry = Math.atan2(-(Bq[1] - A[1]), Bq[0] - A[0]), mx = (A[0] + Bq[0]) / 2, mz = (A[1] + Bq[1]) / 2;
        /* aframe-v172: the billed metre is the top rail's; the bottom rail and the posts are the railing's parts (qtyRun 0) */
        bx(L, 0.045, 0.045, mx, yF + GUARD.h, mz, ry).userData.qtyRun = L;
        bx(L, 0.030, 0.030, mx, yF + 0.10, mz, ry).userData.qtyRun = 0;
        var np = Math.max(1, Math.ceil(L / GUARD.maxSp)), pi;
        for (pi = 0; pi <= np; pi++) { var tq = pi / np; bx(GUARD.post, GUARD.h, GUARD.post, A[0] + (Bq[0] - A[0]) * tq, yF + GUARD.h / 2, A[1] + (Bq[1] - A[1]) * tq, 0).userData.qtyRun = 0; nPost++; }
        len += L;
        notes.push(E.name + ' ' + Math.round(L * 1000));
      }
      if (len > 0) API.billAdd('aframe-stairs', GUARD.code, len);
      /* every post screwed down through the floor into the joists (aframe-v163, the garage apartment's newel rule: 2 x FAS80200) */
      if (nPost) { API.billAdd('aframe-stairs', 'FAS80200', nPost * 2); notes.push(nPost + ' post(s), ' + (nPost * 2) + ' x FAS80200'); }
      ctx.log('guard    ' + tag + ': ' + (len > 0 ? (GUARD.code + ' ' + len.toFixed(2) + ' m') : 'none') + ' -- ' + notes.join(', ') + '; rule: a guard only where the clear height under the rafters is ' + Math.round(GUARD.clear * 1000) + ' or more, never on the side the flight arrives at');
      return len;
    }

    /* -------------------------------------------------------------------------
       THE STAIRS, FROM THE SHARED DRAWER. A flight in every opening, from the
       floor below to the floor the opening is in. It climbs along the ridge,
       towards the middle of the cabin, whichever end the opening is dragged to.
       ------------------------------------------------------------------------- */
    /* THE FLIGHT FITS ITS OPENING (aframe-v81, Marek: kdyz upravim delku
       stairs footprint, schody se maji prizpusobit -- dlouhe = siroke stupne a
       nizke prevyseni, kratke = skoro zebrik, stupne se prekryvaji). The
       opening's length along the climb is the flight: n goings of G = L / n,
       n risers of R = H / n; of the counts that give a riser 120..250 and a
       going 100..400 the one nearest the step rule 2R + G = 630 wins. A long
       opening gives low risers and deep goings, a short one a ladder-like
       flight (the core draws each tread going + 25 of nosing; treads that
       overlap need a least tread depth in the core, see the navod). */
    function _fitFlight(H, L) {
      var best = null, n;
      for (n = Math.max(2, Math.ceil(H / 0.25)); n <= Math.ceil(H / 0.12); n++) {
        var R = H / n, G = L / n;
        if (G < 0.10 || G > 0.40) continue;
        var cost = Math.abs(2 * R + G - 0.63);
        if (!best || cost < best.cost) best = { n: n, R: R, G: G, cost: cost };
      }
      if (!best) { var n2 = Math.max(2, Math.round(H / 0.19)); best = { n: n2, R: H / n2, G: Math.max(0.10, Math.min(0.40, L / n2)), cost: 1 }; }
      var feel = (best.R > 0.21 || best.G < 0.20) ? 'steep, ladder-like' : ((best.R < 0.16 && best.G > 0.30) ? 'long and easy' : 'ordinary');
      return { n: best.n, R: best.R, G: best.G, rule: 2 * best.R + best.G, feel: feel };
    }
    /* THE FLIGHT'S RAILING AND FIXINGS (aframe-v163; COPIED from the garage
       apartment's 8a, garageapt-v12: "the stair railing SIS00002 on the open
       side, newel at the foot, balusters 2 a tread, 2 x FAS80200 a newel;
       2 x FAT00005 (8 x FAS50040 each) to the header, 4 x FAS10075 into the
       slab"). Adapted: the A's flight stands free in the room, so EACH side
       is open unless a partition of the floor it starts from runs along it
       (within 200, over 80 % of the run) or a gable does -- then that side
       is the wall's (IRC R311.7.8 asks a handrail on one side at least,
       R312 a guard on an open side); the rail 900 over the nosing line from
       the foot's newel to the opening, where the floor's guard takes over;
       the foot into the slab with concrete screws, on a timber floor (point
       footings, or a flight from floor 2) 4 x FAS80100 */
    var SRAIL = { code: 'SIS00002', h: 0.90, newel: 0.090, bal: 0.032, rail: 0.050, col: 0x6B5A45, screw: 'FAS80200',
                  bracket: 'FAT00005', brackets: 2, bracketScrew: 'FAS50040', bracketScrews: 8, anchor: 'FAS10075', anchorWood: 'FAS80100', anchors: 4 };
    function _stairRail(ctx, H, up, FF, y0, y1, k) {
      var T = ctx.THREE, g = ctx.group, alongX = (up === '+x' || up === '-x'), sgn = (up.charAt(0) === '-') ? -1 : 1;
      var n = FF.n, R = FF.R, G = FF.G, run = (n - 1) * G, e1 = alongX ? (sgn > 0 ? H.x1 : H.x0) : (sgn > 0 ? H.z1 : H.z0), foot = e1 - sgn * run;
      var across0 = alongX ? H.z0 : H.x0, across1 = alongX ? H.z1 : H.x1, W = Math.max(0.6, (across1 - across0) - 0.10), mid = (across0 + across1) / 2;
      var mR = new T.MeshStandardMaterial({ color: SRAIL.col, roughness: 0.6, metalness: 0.1 }), B = _barRect(), notes = [], railL = 0, nNewel = 0, nBal = 0;
      var P3 = function (a, c) { return alongX ? [a, c] : [c, a]; };             /* (along, across) -> (x, z) */
      var bx = function (wa, h, wc, a, y, c, tilt) {
        var m = new T.Mesh(new T.BoxGeometry(alongX ? wa : wc, h, alongX ? wc : wa), mR), q = P3(a, c);
        m.position.set(q[0], y, q[1]); if (tilt) { if (alongX) m.rotation.z = sgn * tilt; else m.rotation.x = -sgn * tilt; }
        g.add(m); return m;
      };
      var parts = (STATE.parts || []).filter(function (p) { return p && ((p.st | 0) === k - 1); });
      var walled = function (c) {
        var lo = Math.min(foot, e1), hi = Math.max(foot, e1), cov = 0;
        parts.forEach(function (p) {
          var o = p.o || p.dir, cc = (p.c != null) ? p.c : p.at, pa = (p.a != null) ? p.a : -1e9, pb = (p.b != null) ? p.b : 1e9;
          if ((o === 'h') !== alongX || cc == null || Math.abs(cc - c) > 0.20) return;
          cov += Math.max(0, Math.min(hi, Math.max(pa, pb)) - Math.max(lo, Math.min(pa, pb)));
        });
        if (alongX && (Math.abs(c - (B.z0 + GABLE.d)) < 0.25 || Math.abs(c - (B.z1 - GABLE.d)) < 0.25)) return 'the gable';
        return (cov > 0.8 * (hi - lo)) ? 'a partition' : '';
      };
      _am(ctx, 'stairs', 'Stair railing', SRAIL.code, 'side');
      var tilt = Math.atan2(R, G), sl = Math.hypot(run, run * R / G), sd;
      for (sd = -1; sd <= 1; sd += 2) {
        var c = mid + sd * (W / 2 - SRAIL.newel / 2), wl = walled(mid + sd * W / 2);
        if (wl) { notes.push('side ' + (sd < 0 ? 'one' : 'two') + ' along ' + wl + ' (no railing)'); continue; }
        /* the newel at the foot, the rail 900 over the nosing line to the opening, two balusters a tread */
        var yN0 = y0 + R + SRAIL.h;
        /* aframe-v172: the billed metre is the rail's; the newel and the balusters are its parts (qtyRun 0) */
        bx(SRAIL.newel, yN0 + 0.06 - y0, SRAIL.newel, foot - sgn * SRAIL.newel / 2, y0 + (yN0 + 0.06 - y0) / 2, c).userData.qtyRun = 0; nNewel++;
        bx(sl, SRAIL.rail, SRAIL.rail, foot + sgn * run / 2, (yN0 + y1 + SRAIL.h) / 2, c, tilt).userData.qtyRun = sl;
        var kq;
        for (kq = 1; kq <= n - 1; kq++) {
          [0.25, 0.75].forEach(function (f9) {
            var a9 = foot + sgn * ((kq - 1) + f9) * G, yT = y0 + kq * R, yRl = yN0 + ((kq - 1) + f9) * R - SRAIL.rail / 2;
            if (yRl - yT > 0.05) { bx(SRAIL.bal, yRl - yT, SRAIL.bal, a9, (yT + yRl) / 2, c).userData.qtyRun = 0; nBal++; }
          });
        }
        railL += sl;
        notes.push('side ' + (sd < 0 ? 'one' : 'two') + ' open: railing ' + sl.toFixed(2) + ' m');
      }
      if (railL > 0) { API.billAdd('aframe-stairs', SRAIL.code, Math.round(railL * 100) / 100); API.billAdd('aframe-stairs', SRAIL.screw, nNewel * 2); }
      /* the flight's own fixings: to the header at the top, into the floor at the foot */
      var onSlab = (k === 1 && STATE.foundation === 'strips');
      API.billAdd('aframe-stairs', SRAIL.bracket, SRAIL.brackets); API.billAdd('aframe-stairs', SRAIL.bracketScrew, SRAIL.brackets * SRAIL.bracketScrews);
      API.billAdd('aframe-stairs', onSlab ? SRAIL.anchor : SRAIL.anchorWood, SRAIL.anchors);
      ctx.log('stairs   flight ' + k + ' railing (aframe-v163): ' + notes.join(', ') + (railL > 0 ? (' -- ' + SRAIL.code + ' ' + railL.toFixed(2) + ' m, ' + nNewel + ' newel(s) at the foot (' + (nNewel * 2) + ' x ' + SRAIL.screw + '), ' + nBal + ' baluster(s), 2 a tread') : '') +
              '; fixed ' + SRAIL.brackets + ' x ' + SRAIL.bracket + ' + ' + (SRAIL.brackets * SRAIL.bracketScrews) + ' x ' + SRAIL.bracketScrew + ' to the header, ' + SRAIL.anchors + ' x ' + (onSlab ? (SRAIL.anchor + ' into the slab') : (SRAIL.anchorWood + ' into the floor')));
    }
    /* THE STAIRWELL'S EDGE (aframe-v164; COPIED from the barndominium's 7f,
       barndo-v23: "the stairwell's sides and ends boarded from the ceiling to
       the deck, a bead on each edge below", and the garage apartment's 8b,
       garageapt-v13: the gypsum WDD24001 on the opening's four faces,
       "screwed, taped and filled at the partitions' rates"). The floor zone
       round each opening -- the ceiling board and its battens, the joists',
       the headers' and the trimmers' faces, the deck's edge -- lined with the
       ceiling's own board 12.5 from the ceiling's face up to the deck top, in
       the Ceiling colour; WDS00001 20 a m2, tape, compound, the primer of
       plan J (PEN00001), and a corner bead WIW00001 round its foot where it
       meets the ceiling. Over it, where the underlay and the vinyl end at the
       opening, a stair nose: on the edge the flight arrives at it is the top
       step's nosing, on the guarded edges the cover of the vinyl's cut edge;
       glued (FEC00031, a cartridge per 10 m: the tiny house's tread rule,
       thow-v34) and screwed (FAS50060 every 400, 2 a piece at the least: the
       outside trim's rule, aframe-v162); no catalogue row yet, so it is
       billed on TBD.stairNose (MISSING in status/aframe.md) */
    var SWELL = { bead: 'WIW00001', nose: 'TBD.stairNose', noseW: 0.050, noseTop: 0.013, lip: 0.030, lipT: 0.006, noseWaste: 1.10,
                  glue: 'FEC00031', glueM: 10, screw: 'FAS50060', step: 0.40 };
    function _stairWell(ctx, H, up, k) {
      var T = ctx.THREE, g = ctx.group, fl = floors(), BD = LINE.board, bt = BD.t, S = _sect();
      var yTop = fl[k].y, yJ0 = yTop - FLOOR.deck.t - FLOOR.joist.d;
      /* the ceiling under this floor as L5 lays it (none where it is under 600 wide between the slopes' lining) */
      var R5 = _rafSize(), yT0 = S.top + S.half * S.tan, oB = -(R5.d + LINE.batt + LINE.vb + bt / 2);
      var yCb = yJ0 - LINE.batt - bt / 2, hwC = (yT0 + oB * S.cos - yCb) / S.tan + oB * S.sin, ceil = (hwC >= 0.30);
      var yBot = ceil ? (yJ0 - LINE.batt - bt) : yJ0, hL = yTop - yBot, Lx = H.x1 - H.x0, Lz = H.z1 - H.z0;
      if (!(hL > 0.05) || Lx < 0.10 || Lz < 0.10) { ctx.log('stairs   flight ' + k + ' well (aframe-v164): nothing to line (' + Math.round(hL * 1000) + ' high)'); return; }
      var col = BD.col; try { if (API.colorSlotOf) { var cs = API.colorSlotOf('ceiling'); if (cs != null) col = cs; } } catch (eCs) {}
      var yM = (yBot + yTop) / 2;
      _am(ctx, 'layer_plasterboard', 'Plasterboard', BD.code, 'side');
      _box(T, g, bt, hL, Lz, H.x0 + bt / 2, yM, (H.z0 + H.z1) / 2, 0, col, 1);
      _box(T, g, bt, hL, Lz, H.x1 - bt / 2, yM, (H.z0 + H.z1) / 2, 0, col, 1);
      _box(T, g, Lx - 2 * bt, hL, bt, (H.x0 + H.x1) / 2, yM, H.z0 + bt / 2, 0, col, 1);
      _box(T, g, Lx - 2 * bt, hL, bt, (H.x0 + H.x1) / 2, yM, H.z1 - bt / 2, 0, col, 1);
      var aL = (2 * Lz + 2 * (Lx - 2 * bt)) * hL, bead = 2 * (Lx + Lz);
      /* the nose: a cap over the vinyl's edge and the lining's top, its lip down the lining's face */
      var colN = 0xC9AA78; try { if (API.colorSlotOf) { var cf = API.colorSlotOf('floor'); if (cf != null) colN = cf; } } catch (eCf) {}
      _am(ctx, 'stair_nose', 'Stair nosing', SWELL.nose, 'top');
      var yC = yTop + SWELL.noseTop / 2, yLp = yTop + SWELL.noseTop - SWELL.lip / 2, nScr = 0, dA = SWELL.noseW - bt;
      _box(T, g, SWELL.noseW, SWELL.noseTop, Lz, H.x0 + bt - SWELL.noseW / 2, yC, (H.z0 + H.z1) / 2, 0, colN, 1);
      _box(T, g, SWELL.noseW, SWELL.noseTop, Lz, H.x1 - bt + SWELL.noseW / 2, yC, (H.z0 + H.z1) / 2, 0, colN, 1);
      _box(T, g, Lx + 2 * dA, SWELL.noseTop, SWELL.noseW, (H.x0 + H.x1) / 2, yC, H.z0 + bt - SWELL.noseW / 2, 0, colN, 1);
      _box(T, g, Lx + 2 * dA, SWELL.noseTop, SWELL.noseW, (H.x0 + H.x1) / 2, yC, H.z1 - bt + SWELL.noseW / 2, 0, colN, 1);
      /* aframe-v172: the lip is the same nosing's leg, not a second metre (qtyRun 0) */
      _box(T, g, SWELL.lipT, SWELL.lip, Lz - 2 * bt, H.x0 + bt + SWELL.lipT / 2, yLp, (H.z0 + H.z1) / 2, 0, colN, 1).userData.qtyRun = 0;
      _box(T, g, SWELL.lipT, SWELL.lip, Lz - 2 * bt, H.x1 - bt - SWELL.lipT / 2, yLp, (H.z0 + H.z1) / 2, 0, colN, 1).userData.qtyRun = 0;
      _box(T, g, Lx - 2 * bt, SWELL.lip, SWELL.lipT, (H.x0 + H.x1) / 2, yLp, H.z0 + bt + SWELL.lipT / 2, 0, colN, 1).userData.qtyRun = 0;
      _box(T, g, Lx - 2 * bt, SWELL.lip, SWELL.lipT, (H.x0 + H.x1) / 2, yLp, H.z1 - bt - SWELL.lipT / 2, 0, colN, 1).userData.qtyRun = 0;
      [Lx, Lx, Lz, Lz].forEach(function (e9) { nScr += Math.max(2, Math.ceil(e9 / SWELL.step)); });
      var alongX = (up === '+x' || up === '-x'), sgn = (up.charAt(0) === '-') ? -1 : 1;
      var head = alongX ? ('x ' + (sgn > 0 ? 'x1' : 'x0')) : ('z ' + (sgn > 0 ? 'z1' : 'z0'));
      var nGlue = Math.max(1, Math.ceil(bead / SWELL.glueM)), r2 = function (v) { return Math.round(v * 100) / 100; };
      var L = 'aframe-stairs';
      API.billAdd(L, BD.code, r2(aL * BD.waste));
      API.billAdd(L, BD.screw, Math.round(aL * BD.screwPerM2));
      API.billAdd(L, BD.tape, Math.round(aL / 2.88 * 3.6 * 10) / 10);
      API.billAdd(L, BD.filler, Math.round(aL * BD.fillerKgM2 * 10) / 10);
      _chemBill(L, aL, 0, 0);
      API.billAdd(L, SWELL.bead, r2(bead));
      API.billAdd(L, SWELL.nose, r2(bead * SWELL.noseWaste));
      API.billAdd(L, SWELL.glue, nGlue);
      API.billAdd(L, SWELL.screw, nScr);
      ctx.log('stairs   flight ' + k + ' well (aframe-v164): the opening ' + Math.round(Lx * 1000) + ' x ' + Math.round(Lz * 1000) + ' lined on its 4 faces ' + Math.round(hL * 1000) + ' high (' + (ceil ? 'from the ceiling\'s face' : 'from the joists\' underside, no ceiling under it') + ' to the deck) -- ' +
              BD.code + ' ' + aL.toFixed(2) + ' m2, BILL ' + (aL * BD.waste).toFixed(2) + ' (+10 %), ' + Math.round(aL * BD.screwPerM2) + ' x ' + BD.screw + ', tape ' + BD.tape + ' ' + (Math.round(aL / 2.88 * 3.6 * 10) / 10) + ' m, compound ' + BD.filler + ' ' + (Math.round(aL * BD.fillerKgM2 * 10) / 10) + ' kg, primer PEN00001 ' + (aL * 1.05).toFixed(2) + ' m2; corner bead ' + SWELL.bead + ' ' + bead.toFixed(2) + ' m round its foot; ' +
              'nose ' + SWELL.nose + ' ' + (bead * SWELL.noseWaste).toFixed(2) + ' m (' + bead.toFixed(2) + ' +10 %; the top step\'s on the ' + head + ' edge, the vinyl\'s edge cover on the others, NO CODE YET), ' + nGlue + ' x ' + SWELL.glue + ', ' + nScr + ' x ' + SWELL.screw);
    }
    function _buildStairs(ctx) {
      _bill['aframe-stairs'] = {};
      var fl = floors(), B = _barRect(), cx = (B.x0 + B.x1) / 2, cz = (B.z0 + B.z1) / 2, k;
      if (typeof API.stairKit !== 'function') { ctx.log('stairs   none -- the core is ' + (__CORE.CORE_VERSION || '?') + ', the stairs drawer needs core-v466: upload configurator-ui.js'); return; }
      if (fl.length < 2) { ctx.log('stairs   none -- one floor only (' + Math.round(STATE.footprint.w * 1000) + ' wide at ' + (STATE.roof.pitch || 60) + ' deg gives no upper floor)'); return; }
      for (k = 1; k < fl.length; k++) {
        var H = _hole(k), stored = !!_holeBag()[String(k)];
        if (!H) { ctx.log('stairs   floor ' + k + ': no opening'); continue; }
        var up = _stairDir(k, H), upAuto = !(_dirBag()[String(k)]);
        var fwLo = fl[k - 1].floorWidth, kind = _stairKind();
        if (kind === 'loft') {
          var rk = fl[k].y - fl[k - 1].y, PS = API.stairPlan({ rise: rk, floorZone: _zone(), kind: 'straight' }), PL = API.stairPlan({ rise: rk, floorZone: _zone(), kind: 'loft' });
          ctx.log('stairs   floor ' + k + ' LOFT stair: risers ' + Math.round(PL.R * 1000) + ' (ordinary ' + Math.round(PS.R * 1000) + '), goings ' + Math.round(PL.G * 1000) + ' (ordinary ' + Math.round(PS.G * 1000) + '), headroom ' + Math.round(PL.headroom * 1000) + ' (ordinary ' + Math.round(PS.headroom * 1000) + ')' +
                  ' -> opening needs ' + Math.round(PL.needHole * 1000) + ' instead of ' + Math.round(PS.needHole * 1000) + ', shorter by ' + Math.round((PS.needHole - PL.needHole) * 1000) + '; run ' + Math.round(PL.run * 1000) + ' instead of ' + Math.round(PS.run * 1000));
        }
        ctx.log('stairs   floor ' + k + ' opening ' + Math.round((H.x1 - H.x0) * 1000) + ' x ' + Math.round((H.z1 - H.z0) * 1000) +
                ' at ' + Math.round(((H.x0 + H.x1) / 2 - cx) * 1000) + ', ' + Math.round(((H.z0 + H.z1) / 2 - cz) * 1000) + ' from the centre, ' +
                (stored ? 'dragged' : 'placed by the flight') + '; climbs ' + up + (upAuto ? ' (towards the middle, not turned)' : ' (turned by hand)') + '; floor there ' + Math.round(fl[k].floorWidth * 1000) + ' wide');
        var alongXf = (up === '+x' || up === '-x'), Lf = alongXf ? (H.x1 - H.x0) : (H.z1 - H.z0), FF = _fitFlight(fl[k].y - fl[k - 1].y, Lf);
        ctx.log('stairs   floor ' + k + ' flight FITTED to the opening ' + Math.round(Lf * 1000) + ' long: ' + FF.n + ' risers of ' + Math.round(FF.R * 1000) + ', goings ' + Math.round(FF.G * 1000) + ' (2R + G = ' + Math.round(FF.rule * 1000) + ') -- ' + FF.feel + '; drag the opening longer for an easier flight, shorter for a steeper one');
        var kSt = ctx.group.children.length, stOut = API.stairs(ctx, {
          riser: { min: FF.R - 1e-6, max: FF.R + 1e-6 }, going: { min: FF.G, max: FF.G }, rule: FF.rule, treadMin: 0.20,
          layer: 'aframe-stairs', tag: 'flight ' + k, kind: kind, hole: H, y0: fl[k - 1].y, y1: fl[k].y, up: up,
          width: Math.max(0.6, (H.x1 - H.x0) - 0.10), floorZone: _zone(), landing: STAIR.landing,
          room: { x0: cx - fwLo / 2, x1: cx + fwLo / 2, z0: B.z0 + STAIR.gable, z1: B.z1 - STAIR.gable },
          guard: false, color: WOOD, railColor: 0x6B5A45,
          mark: function (a, d, l, c) { _asmMark(ctx, a, d, l, c); }
        });
        /* the drawer adds the flight before it marks it: the flight's own item (aframe-v137) */
        _asmByColour(ctx, kSt, [], ['stairs', 'Stairs', (stOut && stOut.kit && stOut.kit.code) || '']);
        _am(ctx, 'stair_guard', 'Guard', GUARD.code, 'side'); _stairGuard(ctx, H, up, fl[k].y, 'flight ' + k);
        _stairRail(ctx, H, up, FF, fl[k - 1].y, fl[k].y, k);
        _stairWell(ctx, H, up, k);
      }
    }
    /* THE STAIR ARROW ON THE PLAN (aframe-v83, Marek: sipka na schodech,
       odkud kam vedou, klasicke znaceni v projektu). Drawn over the plan
       through the core's PLAN_EXTRA host: on the floor a flight starts from,
       its treads as lines across the footprint and the walking line along
       its middle -- a dot at the first step, an arrowhead at the top; on the
       floor it arrives at, the opening outlined dashed with the arrow's head
       end. The plan's own world-to-screen map places it, so it follows every
       pan and pinch. */
    var _stairArrowNote = '', _pxBox = null, _pxM = null, _pxLive = false, _pxRaf = 0, _pxMoves = 0;
    /* THE SYMBOL FOLLOWS THE FINGER (aframe-v86, Marek: footprint a tvar
       schodu se dynamicky nemeni pri tazeni). The core calls PLAN_EXTRA only
       when the plan is drawn again, and while a stairwell grip is held it
       does not redraw (the floor is rebuilt once, on release). So the hole's
       set() asks for one redraw a frame on the box and map of the last draw
       -- the view cannot pan while a grip is held -- and the treads are
       fitted to the new length there and then. The 3D flight still waits
       for the release. */
    function _pxRedraw() {
      if (!_pxBox || !_pxM || _pxRaf) return;
      var raf = (typeof window !== 'undefined' && window.requestAnimationFrame) ? window.requestAnimationFrame.bind(window) : function (fn) { return setTimeout(fn, 16); };
      _pxRaf = raf(function () {
        _pxRaf = 0; _pxLive = true; _pxMoves++;
        try { __CORE.PLAN_EXTRA(_pxBox, _pxM); } catch (eR) {}
        _pxLive = false;
      });
    }
    __CORE.PLAN_EXTRA = function (box, m) {
      if (!box || !m) return;
      if (!_pxLive) { if (_pxMoves) { _log('plan     stair symbol redrawn live ' + _pxMoves + ' time(s) during the drag'); _pxMoves = 0; } }
      _pxBox = box; _pxM = { ox: m.ox, oy: m.oy, ppm: m.ppm };
      var NS = 'http://www.w3.org/2000/svg', sv = box.querySelector('svg[data-af-stairs]');
      if (!sv) { sv = document.createElementNS(NS, 'svg'); sv.setAttribute('data-af-stairs', '1'); sv.setAttribute('style', 'position:absolute;left:0;top:0;width:100%;height:100%;overflow:visible;pointer-events:none;'); box.appendChild(sv); }
      while (sv.firstChild) sv.removeChild(sv.firstChild);
      var fl = floors(), ps = STATE.planStorey | 0, notes = [];
      var X = function (x) { return m.ox + x * m.ppm; }, Z = function (z) { return m.oy + z * m.ppm; };
      var el = function (tag, at) { var e = document.createElementNS(NS, tag), k; for (k in at) if (at.hasOwnProperty(k)) e.setAttribute(k, at[k]); sv.appendChild(e); return e; };
      var k;
      /* THE CLEAR-HEIGHT LINES UNDER THE SLOPES (aframe-v85, Marek: muzes to
         udelat, uvidime jak to bude vypadat). As drawn in projects: on the
         storey on show, dashed lines where the lining under the rafters is
         1500 and 2000 over the floor -- outside them one cannot stand. Both
         sides of the ridge, gable to gable inside the gable frames; the 2000
         line lighter. A line is left out where the storey's ceiling is lower
         than that height anyway. Figures only, no words to translate. */
      var kotaF = function (p0, p1, off, txt) {
        var ddx = p1[0] - p0[0], ddz = p1[1] - p0[1], dd = Math.hypot(ddx, ddz) || 1, nx = -ddz / dd, nz = ddx / dd;
        var A = [p0[0] + nx * off, p0[1] + nz * off], Bq = [p1[0] + nx * off, p1[1] + nz * off];
        el('line', { x1: p0[0], y1: p0[1], x2: A[0] + nx * 4, y2: A[1] + nz * 4, stroke: '#1A1C1D', 'stroke-width': 0.7, 'stroke-opacity': 0.6 });
        el('line', { x1: p1[0], y1: p1[1], x2: Bq[0] + nx * 4, y2: Bq[1] + nz * 4, stroke: '#1A1C1D', 'stroke-width': 0.7, 'stroke-opacity': 0.6 });
        el('line', { x1: A[0], y1: A[1], x2: Bq[0], y2: Bq[1], stroke: '#1A1C1D', 'stroke-width': 1 });
        var tk = function (P) { el('line', { x1: P[0] - 4, y1: P[1] + 4, x2: P[0] + 4, y2: P[1] - 4, stroke: '#1A1C1D', 'stroke-width': 1.4 }); };
        tk(A); tk(Bq);
        var mx = (A[0] + Bq[0]) / 2, mz = (A[1] + Bq[1]) / 2, tw = txt.length * 7 + 14;
        el('rect', { x: mx - tw / 2, y: mz - 10, width: tw, height: 20, rx: 9, ry: 9, fill: 'rgba(20,20,20,0.82)' });
        var tE = el('text', { x: mx, y: mz + 4, 'text-anchor': 'middle', fill: '#F4E3C1', 'font-family': 'system-ui,-apple-system,sans-serif', 'font-size': 12, 'font-weight': 600 });
        tE.textContent = txt;
      };
      /* THE ROOF WINDOWS ON THEIR STOREY'S PLAN (aframe-v90): each window
         seen from above where it sits in the slope -- dashed, as anything over
         the cutting plane is drawn -- with its width across the bay as a
         kota; only on the storey the window belongs to */
      (function () {
        var OPw = STATE.openings || [], Qw = _roofGeo(), nW = 0, wq, lst = [];
        for (wq = 0; wq < OPw.length; wq++) {
          var ow = OPw[wq]; if (!ow || ow.host !== 'roof' || (ow.storey | 0) !== ps || ow.fitNote || _winUnderWing(ow)) continue;
          var szw = _rwSizeOf(ow), sdw = (ow.plane === 'left') ? -1 : 1, sC = Qw.Ltop - (+ow.up || 0);
          var xa = Qw.cx + sdw * (sC - szw.h / 2) * Qw.S.cos, xb = Qw.cx + sdw * (sC + szw.h / 2) * Qw.S.cos, za = (+ow.along || 0) - szw.w / 2, zb2 = (+ow.along || 0) + szw.w / 2;
          var rx = Math.min(X(xa), X(xb)), ry = Math.min(Z(za), Z(zb2)), rw = Math.abs(X(xb) - X(xa)), rh = Math.abs(Z(zb2) - Z(za));
          el('rect', { x: rx, y: ry, width: rw, height: rh, fill: 'rgba(159,195,214,0.25)', stroke: '#1A1C1D', 'stroke-width': 1.1, 'stroke-dasharray': '6 4' });
          el('line', { x1: rx, y1: ry, x2: rx + rw, y2: ry + rh, stroke: '#1A1C1D', 'stroke-width': 0.6, 'stroke-opacity': 0.5, 'stroke-dasharray': '4 4' });
          el('line', { x1: rx + rw, y1: ry, x2: rx, y2: ry + rh, stroke: '#1A1C1D', 'stroke-width': 0.6, 'stroke-opacity': 0.5, 'stroke-dasharray': '4 4' });
          /* the kota of the width on the side towards the ridge */
          var xk = (sdw < 0) ? rx + rw : rx;
          kotaF([xk, ry + rh], [xk, ry], sdw < 0 ? 18 : -18, fmtLen(szw.w));
          nW++; lst.push((ow.plane || '?') + ' ' + (szw.code || '?') + ' at z ' + Math.round((+ow.along || 0) * 1000));
        }
        notes.push('roof windows on storey ' + (ps + 1) + ': ' + (nW ? lst.join(', ') : 'none'));
      })();
      var chNotes = [];
      (function () {
        var F = fl[ps]; if (!F) return;
        var S = _sect(), B = _barRect(), cx = (B.x0 + B.x1) / 2;
        var linT = LINE.vb + LINE.batt + LINE.board.t, zone = FLOOR.joist.d + FLOOR.deck.t;
        var ceil = (ps + 1 < fl.length) ? (fl[ps + 1].y - zone) : S.ridgeY;
        var hwF = (F.floorWidth || (B.x1 - B.x0)) / 2;
        var zA = B.z0 + GABLE.d, zB = B.z1 - GABLE.d;
        var HS = [{ h: 1.50, op: 0.85, w: 1.3, dash: '9 5' }, { h: 2.00, op: 0.45, w: 1.1, dash: '5 5' }], q;
        for (q = 0; q < HS.length; q++) {
          var hh = HS[q].h;
          if (F.y + hh >= ceil - 0.01) { chNotes.push(Math.round(hh * 1000) + ' none (ceiling ' + Math.round((ceil - F.y) * 1000) + ')'); continue; }
          var a = S.half - (S.rafD + linT) / S.sin - (F.y + hh - S.top) / S.tan;
          if (!(a > 0.05) || a >= hwF - 0.01) { chNotes.push(Math.round(hh * 1000) + ' none (a ' + Math.round(a * 1000) + ')'); continue; }
          var sd;
          for (sd = -1; sd <= 1; sd += 2) {
            var xl = X(cx + sd * a);
            el('line', { x1: xl, y1: Z(zA), x2: xl, y2: Z(zB), stroke: '#1A1C1D', 'stroke-width': HS[q].w, 'stroke-opacity': HS[q].op, 'stroke-dasharray': HS[q].dash });
            var tx = el('text', { x: xl - sd * 5, y: Math.min(Z(zA), Z(zB)) + 14, 'text-anchor': sd < 0 ? 'start' : 'end', fill: '#1A1C1D', 'fill-opacity': Math.min(1, HS[q].op + 0.1), 'font-family': 'system-ui,-apple-system,sans-serif', 'font-size': 11, 'font-weight': 600 });
            tx.textContent = fmtLen(hh);
          }
          chNotes.push(Math.round(hh * 1000) + ' at +-' + Math.round(a * 1000) + ' (floor half ' + Math.round(hwF * 1000) + ')');
        }
      })();
      notes.push('clear height lines storey ' + (ps + 1) + ': ' + (chNotes.length ? chNotes.join(', ') : 'none'));
      /* UNDER THE WING, ON THE GROUND FLOOR'S PLAN (aframe-v123, Marek: naznacit hranu podlahy druheho patra, v miste
         kridla krokve zaznacit): the open space under the wing shows what is over it -- the edge of floor 2 (a long
         dash and dot), the rafters running on down to the plate (dashed, their own width) and the beam hung under them */
      (function () {
        if (ps !== 0 || fl.length < 2) return;
        var ws = []; try { ws = _wingSides(); } catch (eWs) { ws = []; }
        if (!ws.length) return;
        var B = _barRect(), cx = (B.x0 + B.x1) / 2, t9 = _rafSize().t, WG9 = _wingGrid(), wn = [];
        ws.forEach(function (sd) {
          var WR = _wingRect(sd), WB = _wingBeam(sd), xE = sd < 0 ? B.x0 : B.x1, xF = cx + sd * (fl[1].floorWidth || (B.x1 - B.x0)) / 2;
          el('line', { x1: X(xF), y1: Z(WB.zIa), x2: X(xF), y2: Z(WB.zIb), stroke: '#1A1C1D', 'stroke-width': 1.3, 'stroke-dasharray': '14 4 2 4' });
          var zR = WG9.lines.filter(function (z) { return z > WB.zIa && z < WB.zIb; }), nR = 0;
          zR.concat([WG9.trim[0] + t9, WG9.trim[1] - t9]).forEach(function (z) {
            var xa = Math.min(X(xF), X(xE)), xb = Math.max(X(xF), X(xE));
            el('rect', { x: xa, y: Z(z - t9 / 2), width: xb - xa, height: Math.max(1, t9 * m.ppm), fill: 'rgba(185,139,87,0.18)', stroke: '#1A1C1D', 'stroke-width': 0.8, 'stroke-dasharray': '5 3' });
            nR++;
          });
          var xB0 = X(cx + sd * (WB.dB - WBEAM.w / 2)), xB1 = X(cx + sd * (WB.dB + WBEAM.w / 2));
          el('rect', { x: Math.min(xB0, xB1), y: Z(WB.zIa), width: Math.abs(xB1 - xB0), height: Z(WB.zIb) - Z(WB.zIa), fill: 'none', stroke: '#1A1C1D', 'stroke-width': 0.9, 'stroke-dasharray': '8 3' });
          wn.push((sd < 0 ? 'left' : 'right') + ': floor 2 edge at ' + Math.round((xF - cx) * 1000) + ', ' + nR + ' rafter(s) overhead to the plate, the beam at ' + Math.round(sd * WB.dB * 1000));
        });
        notes.push('under the wing ' + wn.join('; '));
      })();
      for (k = 1; k < fl.length; k++) {
        if (ps !== k - 1 && ps !== k) continue;
        var H = _hole(k); if (!H) continue;
        var up = _stairDir(k, H), alongX = (up === '+x' || up === '-x'), sg = (up.charAt(0) === '-') ? -1 : 1;
        var L = alongX ? (H.x1 - H.x0) : (H.z1 - H.z0), FF = _fitFlight(fl[k].y - fl[k - 1].y, L);
        var cxH = (H.x0 + H.x1) / 2, czH = (H.z0 + H.z1) / 2;
        /* the walking line from the foot to the top */
        var fx = alongX ? (sg > 0 ? H.x0 : H.x1) : cxH, fz = alongX ? czH : (sg > 0 ? H.z0 : H.z1);
        var tx = alongX ? (sg > 0 ? H.x1 : H.x0) : cxH, tz = alongX ? czH : (sg > 0 ? H.z1 : H.z0);
        var a0 = [X(fx), Z(fz)], a1 = [X(tx), Z(tz)], dx = a1[0] - a0[0], dz = a1[1] - a0[1], dl = Math.hypot(dx, dz) || 1, ux = dx / dl, uz = dz / dl;
        var inset = Math.min(14, dl * 0.08);
        a0 = [a0[0] + ux * inset, a0[1] + uz * inset]; a1 = [a1[0] - ux * inset, a1[1] - uz * inset];
        var ah = Math.max(8, Math.min(16, m.ppm * 0.18)), aw = ah * 0.55;
        if (ps === k - 1) {
          el('rect', { x: Math.min(X(H.x0), X(H.x1)), y: Math.min(Z(H.z0), Z(H.z1)), width: Math.abs(X(H.x1) - X(H.x0)), height: Math.abs(Z(H.z1) - Z(H.z0)), fill: 'none', stroke: '#1A1C1D', 'stroke-width': 1.2 });
          var n = FF.n, q;
          for (q = 1; q < n; q++) {
            var tq = q / n;
            if (alongX) { var xq = X(sg > 0 ? H.x0 + L * tq : H.x1 - L * tq); el('line', { x1: xq, y1: Z(H.z0), x2: xq, y2: Z(H.z1), stroke: '#1A1C1D', 'stroke-width': 0.8, 'stroke-opacity': 0.7 }); }
            else { var zq = Z(sg > 0 ? H.z0 + L * tq : H.z1 - L * tq); el('line', { x1: X(H.x0), y1: zq, x2: X(H.x1), y2: zq, stroke: '#1A1C1D', 'stroke-width': 0.8, 'stroke-opacity': 0.7 }); }
          }
          el('circle', { cx: a0[0], cy: a0[1], r: 4, fill: '#1A1C1D' });
          el('line', { x1: a0[0], y1: a0[1], x2: a1[0] - ux * ah * 0.8, y2: a1[1] - uz * ah * 0.8, stroke: '#1A1C1D', 'stroke-width': 1.6 });
          el('polygon', { points: [a1[0], a1[1], a1[0] - ux * ah - uz * aw, a1[1] - uz * ah + ux * aw, a1[0] - ux * ah + uz * aw, a1[1] - uz * ah - ux * aw].join(','), fill: '#1A1C1D' });
          /* THE KOTY, AS ON THE OTHER PIECES (aframe-v84, Marek: ke schodum koty
             jako u jinych prvku, delka a sirka): a dimension line outside the
             footprint along each of two sides, ticks at the ends, the figure on
             the platform's dark pill */
          var kota = kotaF;
          var rx0 = Math.min(X(H.x0), X(H.x1)), rx1 = Math.max(X(H.x0), X(H.x1)), rz0 = Math.min(Z(H.z0), Z(H.z1)), rz1 = Math.max(Z(H.z0), Z(H.z1));
          kota([rx1, rz0], [rx0, rz0], 22, fmtLen(H.x1 - H.x0));
          kota([rx1, rz1], [rx1, rz0], 22, fmtLen(H.z1 - H.z0));
          notes.push('flight ' + k + ' drawn on storey ' + (ps + 1) + ': ' + n + ' treads, arrow ' + up + ', koty ' + Math.round((H.x1 - H.x0) * 1000) + ' x ' + Math.round((H.z1 - H.z0) * 1000));
        } else {
          el('rect', { x: Math.min(X(H.x0), X(H.x1)), y: Math.min(Z(H.z0), Z(H.z1)), width: Math.abs(X(H.x1) - X(H.x0)), height: Math.abs(Z(H.z1) - Z(H.z0)), fill: 'none', stroke: '#1A1C1D', 'stroke-width': 1.2, 'stroke-dasharray': '6 4' });
          var mid = [(a0[0] + a1[0]) / 2, (a0[1] + a1[1]) / 2];
          el('line', { x1: mid[0], y1: mid[1], x2: a1[0] - ux * ah * 0.8, y2: a1[1] - uz * ah * 0.8, stroke: '#1A1C1D', 'stroke-width': 1.6 });
          el('polygon', { points: [a1[0], a1[1], a1[0] - ux * ah - uz * aw, a1[1] - uz * ah + ux * aw, a1[0] - ux * ah + uz * aw, a1[1] - uz * ah - ux * aw].join(','), fill: '#1A1C1D' });
          notes.push('flight ' + k + ' arriving on storey ' + (ps + 1) + ': opening dashed, arrow head');
        }
      }
      var nt = 'plan     extras: ' + notes.join('; ') + (notes.some(function (n9) { return n9.indexOf('flight') === 0; }) ? '' : '; no flight on this storey');
      if (!_pxLive && nt !== _stairArrowNote) { _stairArrowNote = nt; _log(nt); }
    };
    _regLayer({
      id: 'aframe-stairs', version: VERSION, role: 'fitout', claims: ['stairs'],
      build3d: _buildStairs, boq: function () { return _rows('aframe-stairs'); }
    });

    /* the bar rect: the footprint rectangle, as the core keeps it */
    /* -------------------------------------------------------------------------
       THE ROOF SKIN, FROM THE SHARED DRAWER (aframe-v3, the first step of the
       A-frame on the shared UI). The two long sides of the A are the roof, so
       the drawer covers them: deck, underlay, battens on every rafter, drip
       and verge, the covering chosen on Roof and Base, ridge cap over the
       vent strip. The plane the core publishes IS the rafters' top face here
       (the rafters hang under it by their depth), so the lift is nought. The
       fascia and the gutters wait, as on the T house.
       ------------------------------------------------------------------------- */
    function _buildSkin(ctx) {
      _bill['aframe-skin'] = {};
      if (REVIEW === 'stairs' || REVIEW === 'gables') { ctx.log('review   roof skin hidden while the ' + REVIEW + ' are under review (REVIEW)'); return; }
      var PLs = roofPlanes() || [];
      if (!PLs.length) { ctx.log('skin     none -- no roof planes'); return; }
      var C = null; try { C = API.covDef(); } catch (eC) { C = null; }
      if (!C) { ctx.log('skin     none -- no covering chosen'); return; }
      /* THE LOAD, BUILD BY BUILD (aframe-v92, Marek: pri nacitani probliknou
         battens pod krytinou, jen ve spodni polovine): for the first 15 s
         every build of the skin says when it came and what it was built on --
         if two builds disagree (the plinth, the eave, the pitch, the
         covering), the one shown first is the flash */
      _loadN++;
      if (Date.now() - _loadT0 < 15000) {
        var P0 = PLs[0] || {}, eY = (P0.eave && P0.eave[0]) ? Math.round(P0.eave[0][1] * 1000) : '?', eX = (P0.eave && P0.eave[0]) ? Math.round(P0.eave[0][0] * 1000) : '?';
        _loadTrace.push('load     skin build #' + _loadN + ' at +' + (Date.now() - _loadT0) + ' ms: ' + PLs.length + ' plane(s), eave y ' + eY + ' x ' + eX + ', pitch ' + Math.round(STATE.roof.pitch || 0) + ', covering ' + C.key + (C.batten ? (' (battens every ' + Math.round(C.batten * 1000) + ')') : ' (no battens)') +
                ', plinth ' + Math.round(_deckY() * 1000) + (_slabTopSeen == null ? ' (the slab not seen yet)' : '') + ', foundation ' + STATE.foundation + ', view ' + STATE.view +
                ', size ' + Math.round(STATE.footprint.w * 1000) + ' x ' + Math.round(STATE.footprint.l * 1000) + ', rake ' + Math.round(_rakeOf(0) * 1000) + '/' + Math.round(_rakeOf(1) * 1000) + ', roof openings ' + (STATE.openings || []).filter(function (o) { return o && o.host === 'roof'; }).length);
      }
      /* the trace is kept across the builds, so the first ones are still there to read */
      _loadTrace.forEach(function (ln) { ctx.log(ln); });
      var spec = {
        layer: 'aframe-skin', planes: PLs,
        lift: function () { return 0; },
        deck: { code: 'OSB25002', t: 0.018, nail: 'FAS70000', nailPerM2: 22 },
        underlay: { code: 'ROR00008', roll: 1.50, lap: 0.20, staple: 'FAS63000', t: 0.0006 },
        battens: { counter: { code: 'KVR50030', w: 0.050, h: 0.030 }, batten: { code: 'KVR50031', w: 0.050, h: 0.030 }, screw: 'FAS60100', col: WOOD },
        members: _rafMembers, spacing: RAF.sp,
        edges: { drip: { code: 'ROM02401', face: 0.055, top: 0.060, t: 0.0007 },
                 verge: { code: 'ROR00006', face: 0.060, top: 0.070, t: 0.0007, rake: true, ridgeGap: 0.030, eaveOut: 0.050 },
                 fix: 'FAS00318', fixSpacing: 0.300, color: (SKIN_REVIEW === 'edges') ? MAGENTA : 0x8A8F94, fascia: null },
        covering: { kind: C.key, picked: C.key, gauge: C.batten, code: C.code, def: C.def, color: 0x4A4E52 },
        ridge: { code: 'ROR00009', vent: 'ROR00007', width: 0.250, t: 0.0007, stand: 0.006, fix: 'FAS00225', fixSpacing: 0.300 },
        sheet: { l: 2.44, w: 1.22 },
        mark: function (k, d, l, c) { _asmMark(ctx, k, d, l, c); }
      };
      /* INSULATION ABOVE THE RAFTERS (aframe-v99): the core's own layers, the
         T house's -- on the rafters the deck, under it between the rafters
         T&G boards seen from the room (the porch soffit's board), on the deck
         the vapour layer, two layers of PIR 80 = 160, the long screws that
         hold the counter-battens down through them into the rafters; the
         underlay, the battens and the covering go up by the PIR */
      /* THE HYBRID (aframe-v157): the same core layer on the deck, the PIR as
         thick as the zone asks (_pirAbove), with no vapour layer under it --
         the core lays one anyway (unbilled without a code): taken out of the
         drawing below; the barrier is the one under the rafters */
      var PA = _pirAbove();
      if (PA) {
        spec.insulation = { code: PA.code, t: PA.t, layers: PA.layers, board: { l: 1.2, w: 0.6 }, waste: 1.05,
                            vcl: (PA.mode === 'above') ? { code: 'ROV00001', tape: 'INS01005', roll: 1.50 } : {}, screw: { code: PA.screw, spacing: 0.60 }, tape: 'INS01005' };
      }
      if (INSUL === 'above') {
        spec.lining = { code: FAC.clad.code, t: FAC.clad.t, w: FAC.clad.w, memberW: RAF.small.t, nail: FAC.clad.nail, nailSpacing: 0.30, waste: 1.10, color: 0xD8B887 };
      }
      /* THE EDGES UNDER REVIEW (aframe-v48, Marek: schovej krytinu, musime
         odladit okapove a zavetrne listy): the drawer runs twice -- deck,
         underlay, battens and the edges first, then the covering and the
         ridge cap, whose pieces are hidden; everything is billed as before,
         the drip edge and the verge are drawn magenta */
      var out, nSk0 = ctx.group.children.length, nVclOut = 0;
      /* ONE PHASE AT A TIME, EACH UNDER ITS OWN MARK (aframe-v137): the drawer
         takes spec.only, so the deck, the underlay, the battens, the edges, the
         covering and the ridge are called one by one in the drawer's own order,
         the same bodies and the same bill as one call */
      var PHM = { ceiling: ['roof_lining', 'Roof lining', FAC.clad.code], deck: ['roof_sheathing', 'Roof sheathing', 'OSB25002'],
                  insulation: ['roof_insulation', 'Roof insulation', PA ? PA.code : ABOVE.pir], underlay: ['roof_underlay', 'Roof underlay', 'ROR00008'],
                  battens: ['roof_battens', 'Roof battens', 'KVR50031'], edges: ['roof_edges', 'Roof edges', 'ROM02401'],
                  covering: ['roof_covering', 'Roof covering', C.code || ''], ridge: ['roof_ridge', 'Ridge', (C.key === 'shingle') ? 'ROR00007' : 'ROR00009'], gutters: ['gutters', 'Gutters', ''] };
      var skinRun = function () {
        var ord = ['ceiling', 'deck', 'insulation', 'underlay', 'battens', 'edges', 'covering', 'ridge', 'gutters'], only0 = spec.only || null, acc = { built: [], pending: [], area: 0 }, q;
        for (q = 0; q < ord.length; q++) {
          var ph = ord[q];
          if (!spec[ph] || (only0 && only0.indexOf(ph) < 0)) continue;
          var M = PHM[ph], k0 = ctx.group.children.length;
          if (M) _am(ctx, M[0], M[1], M[2], 'top');
          spec.only = [ph];
          var o = API.roofSkin(ctx, spec) || {};
          acc.built = acc.built.concat(o.built || []); acc.pending = acc.pending.concat(o.pending || []); acc.area = Math.max(acc.area, o.area || 0);
          /* the hybrid: the core's vapour layer on the deck out of the drawing (none there, the barrier is under the rafters) */
          if (ph === 'insulation' && PA && PA.mode === 'hybrid') {
            var qv, rmV = [];
            for (qv = k0; qv < ctx.group.children.length; qv++) { var mV = ctx.group.children[qv]; if (mV.isMesh && mV.name !== 'insulation' && mV.material && mV.material.color && mV.material.color.getHex() === 0x4A5A6A) rmV.push(mV); }
            rmV.forEach(function (mv) { ctx.group.remove(mv); if (mv.geometry) mv.geometry.dispose(); });
            nVclOut += rmV.length;
          }
          /* the T&G seen from the room is drawn with the deck: its own item */
          if (ph === 'deck' && spec.lining) _asmByColour(ctx, k0, [[new ctx.THREE.Color(spec.lining.color).getHex(), 'roof_lining', 'Roof lining', spec.lining.code]], null);
        }
        spec.only = only0;
        return acc;
      };
      /* AN INNER LAYER UNDER REVIEW HIDES THE WHOLE SKIN (aframe-v50, Marek:
         magenta vidim jen profily strechy, zadne kliny). The vent baffles lie
         under the deck and over the wool, so from outside the deck hid them
         and from inside the wool did; while LAYER_STEP is an inner layer the
         skin is built and billed but not drawn, and the bays are open to the
         eye from outside */
      if (LAYER_STEP <= 4) {
        var n00 = ctx.group.children.length, qi, nHi = 0;
        out = skinRun();
        for (qi = n00; qi < ctx.group.children.length; qi++) { ctx.group.children[qi].visible = false; nHi++; }
        ctx.log('skin     NOT DRAWN while layer ' + LAYER_STEP + ' (inside the deck) is under review -- ' + nHi + ' piece(s) hidden, billed as before; look at the bays from outside');
      } else if (SKIN_REVIEW === 'edges') {
        spec.only = ['deck', 'underlay', 'battens', 'edges'];
        out = skinRun();
        var n0 = ctx.group.children.length, qh, nHid = 0;
        spec.only = ['covering', 'ridge'];
        var out2 = skinRun();
        for (qh = n0; qh < ctx.group.children.length; qh++) { ctx.group.children[qh].visible = false; nHid++; }
        out.built = (out.built || []).concat(out2.built || []); out.pending = (out.pending || []).concat(out2.pending || []);
        ctx.log('skin     review EDGES: the covering and the ridge cap NOT DRAWN (' + nHid + ' piece(s) hidden, billed as before); the drip edge and the verge in magenta');
      } else out = skinRun();
      if (PA) {
        var RGa = _rafGrid(), Sa = _sect(), aDeck = 2 * (RGa.z1 - RGa.z0) * (Sa.half / Sa.cos);
        if (PA.mode === 'above') ctx.log('skin     insulation ABOVE the rafters: T&G ' + FAC.clad.code + ' between the rafters seen from the room, deck, vapour layer ROV00001, PIR ' + _pirTxt(PA) + ' R-' + PA.r + ' (zone ' + PA.cz + ': the assembly U-' + PA.u.toFixed(4) + ' vs U-' + PA.uMax + ', IECC R402.1.2, aframe-v158), long screws ' + PA.screw + ' through it into the rafters; the roof windows sit ' + Math.round(PA.t * 1000) + ' higher, on the insulation');
        else ctx.log('skin     HYBRID (aframe-v157): PIR on the deck ' + _pirTxt(PA) + ' R-' + PA.r + ' (zone ' + PA.cz + ': at least R-' + PA.cond + ' for condensation, IRC R806.5, and R-' + PA.ceil + ' - R-' + PA.rW + ' of the wool = R-' + (Math.round(PA.need * 10) / 10) + '), joints taped INS01005, no vapour layer on the deck (' + nVclOut + ' piece(s) of the core\'s out of the drawing, none billed) -- the barrier is under the rafters; counter battens held down through it by ' + PA.screw + '; the roof windows sit ' + Math.round(PA.t * 1000) + ' higher, on the PIR');
        if (C.key === 'shingle') {
          /* SHINGLES NEED A NAILABLE DECK OVER THE PIR, VENTED UNDER IT: counter
             battens down the slope on every rafter line, a second OSB on them --
             billed; the core draws the shingles on the underlay over the PIR */
          var nRa = Math.max(2, RGa.n + 1), cbL = nRa * 2 * (Sa.half / Sa.cos);
          API.billAdd('aframe-skin', 'OSB25002', aDeck * 1.08);
          API.billAdd('aframe-skin', 'KVR50030', cbL * 1.05);
          API.billAdd('aframe-skin', 'FAS70000', Math.round(aDeck * 22));
          ctx.log('skin     shingles over PIR: a vented nail base BILLED -- counter battens KVR50030 ' + (cbL * 1.05).toFixed(1) + ' m on the ' + nRa + ' rafter lines, OSB25002 ' + (aDeck * 1.08).toFixed(2) + ' m2 (+8%), ' + Math.round(aDeck * 22) + ' x FAS70000; NOT DRAWN (the shingles lie on the underlay over the PIR in the model)');
        }
      }
      _am(ctx, 'roof_flashing', 'Roof window flashing', _flashKitCode, 'top');
      try { _skinCut(ctx, nSk0, C); } catch (eCut) { ctx.log('roofwin  ERROR cutting the skin round the windows: ' + ((eCut && eCut.message) || eCut)); }
      /* aframe-v172: a piece that lay wholly inside a cut comes back from the core with no triangles left -- an
         empty body the qty audit read as Infinity (two PIR boards on the 6x9); taken out of the scene, the bill is the core's */
      (function () {
        var q, nE = 0, cE = {};
        for (q = ctx.group.children.length - 1; q >= nSk0; q--) {
          var mE = ctx.group.children[q], pE = mE && mE.isMesh && mE.geometry && mE.geometry.attributes && mE.geometry.attributes.position;
          if (mE && mE.isMesh && (!pE || pE.count === 0)) {
            var cdE = (mE.userData && mE.userData.asm && mE.userData.asm.code) || '?';
            cE[cdE] = (cE[cdE] || 0) + 1; ctx.group.remove(mE); if (mE.geometry) mE.geometry.dispose(); nE++;
          }
        }
        if (nE) ctx.log('skin     ' + nE + ' empty piece(s) out of the scene after the cuts (aframe-v172, wholly inside an opening): ' + Object.keys(cE).map(function (c) { return cE[c] + ' x ' + c; }).join(', ') + ' -- nothing billed changes');
      })();
      /* WHAT THE BUILD-UP OVER THE RAFTERS LACKED (aframe-v146, plan E): the
         oil on the wood seen from the room (the T&G and the rafters' sides and
         undersides), PU foam at the PIR's edges, joints and penetrations, the
         insect comb in the ventilated batten space at both eaves */
      if (PA && PA.mode === 'hybrid') {
        /* the hybrid's (aframe-v157): PU foam at the PIR's edges, joints and penetrations, the insect comb at the eaves in the batten space (no channel under the deck now) */
        var RGh = _rafGrid(), Sh = _sect(), Lzh = RGh.z1 - RGh.z0, aPh = 2 * Lzh * (Sh.half / Sh.cos), nFh = Math.ceil(aPh / 6), eaveH = 0;
        [-1, 1].forEach(function (sdE) { var lE = Lzh; if (_wingSides().indexOf(sdE) >= 0) { try { lE -= _wingRect(sdE).l; } catch (eW) {} } eaveH += Math.max(0, lE); });
        _am(ctx, 'roof_insulation', 'Roof insulation', PA.code, 'top');
        API.billAdd('aframe-skin', 'FCP00005', nFh);
        _am(ctx, 'roof_battens', 'Roof battens', 'KVR50031', 'top');
        API.billAdd('aframe-skin', VENT.strip, Math.round(eaveH * 1.05 * 100) / 100);
        ctx.log('skin     hybrid, round the PIR (aframe-v157): PU foam FCP00005 ' + nFh + ' can(s) at its edges, joints and penetrations (one per 6 m2 of ' + aPh.toFixed(1) + '), insect comb ' + VENT.strip + ' ' + (eaveH * 1.05).toFixed(2) + ' m in the batten space at both eaves (+5%' + (eaveH < 2 * Lzh - 0.01 ? ', not under a side wing' : '') + ')');
      }
      if (INSUL === 'above') {
        var RGo = _rafGrid(), So = _sect(), Ro = _rafSize(), Lz = RGo.z1 - RGo.z0, tgB = (_bill['aframe-skin'] || {})[FAC.clad.code] || 0, tgA = tgB / 1.10;
        var nRo = (RGo.gable && RGo.gable.length === 2) ? (RGo.gable[1] - RGo.gable[0] + 1) : (RGo.n + 1), rafL = (So.w / 2) / So.cos, rafA = 2 * nRo * rafL * (2 * Ro.d + Ro.t), oilA = tgA + rafA;
        var aPir = 2 * Lz * (So.half / So.cos), nFoam = Math.ceil(aPir / 6), eaveC = 0;
        [-1, 1].forEach(function (sdE) { var lE = Lz; if (_wingSides().indexOf(sdE) >= 0) { try { lE -= _wingRect(sdE).l; } catch (eW) {} } eaveC += Math.max(0, lE); });
        _am(ctx, 'roof_lining', 'Roof lining', FAC.clad.code, 'top');
        API.billAdd('aframe-skin', 'TBD.woodOil', Math.round(oilA * 100) / 100);
        _am(ctx, 'roof_insulation', 'Roof insulation', PA.code, 'top');
        API.billAdd('aframe-skin', 'FCP00005', nFoam);
        _am(ctx, 'roof_battens', 'Roof battens', 'KVR50031', 'top');
        API.billAdd('aframe-skin', VENT.strip, Math.round(eaveC * 1.05 * 100) / 100);
        ctx.log('skin     above the rafters, what it lacked (aframe-v146): oil TBD.woodOil ' + oilA.toFixed(2) + ' m2 on the wood seen inside (T&G ' + tgA.toFixed(2) + ' m2 + ' + nRo + ' rafter(s) a slope, sides and underside, ' + rafA.toFixed(2) + ' m2; NO CODE YET, billed pending), PU foam FCP00005 ' + nFoam + ' can(s) at the PIR\'s edges, joints and penetrations (one per 6 m2 of ' + aPir.toFixed(1) + '), insect comb ' + VENT.strip + ' ' + (eaveC * 1.05).toFixed(2) + ' m in the batten space at both eaves (+5%' + (eaveC < 2 * Lz - 0.01 ? ', not under a side wing' : '') + ')');
      }
      /* THE VERGE BOARD OVER THE PIR'S EDGE AT THE RAKES (aframe-v157): with
         PIR on the deck (the hybrid, or above the rafters) the deck and the
         boards stood bare at both gables' rakes under the verge trim's 60 mm
         face. A planed plank closes them: in the gable's plane outside the
         rake, from 40 below the rafters' top (screwed into the verge rafter)
         up to the PIR's top, from the eave cut to the ridge, where the two
         sides' boards meet in the vertical plane; KVR16019 160 x 19 (or with
         a KVR10019 100 x 19 over it where the PIR is thicker), +10 % for the
         cuts, two FAS60080 every 600 (the verge rafter, the outer counter
         batten). Outdoor wood: sealed and top coated with the facade */
      if (PA) {
        var VB9 = { t: 0.019, down: 0.040, col: 0xB98B57 }, hV9 = VB9.down + 0.021 + PA.t + 0.002, vbRows = _vergeRows(PA);
        var mVb9 = new ctx.THREE.MeshStandardMaterial({ color: (SKIN_REVIEW === 'edges') ? MAGENTA : VB9.col, roughness: 0.85 }), vbLen = 0, nVb9 = 0;
        _am(ctx, 'roof_verge_board', 'Verge board', vbRows[0][0], 'side');
        PLs.forEach(function (pl) {
          var P9 = pl.pts || [], n9 = pl.n || [0, 1, 0];
          if (P9.length < 4 || Math.abs(n9[1]) < 0.2) return;
          var zs = P9.map(function (p) { return p[2]; }), zLo = Math.min.apply(null, zs), zHi = Math.max.apply(null, zs);
          [[zLo, -1], [zHi, 1]].forEach(function (zr) {
            var at9 = P9.filter(function (p) { return Math.abs(p[2] - zr[0]) < 0.01; });
            if (at9.length !== 2) return;
            at9.sort(function (a9, b9) { return a9[1] - b9[1]; });
            var E9 = at9[0], R9 = at9[1], o0 = -VB9.down, o1 = hV9 - VB9.down;
            var pts9 = [[E9[0] + n9[0] * o0, E9[1] + n9[1] * o0], [R9[0] + n9[0] * o0, R9[1] + n9[1] * o0], [R9[0], R9[1] + o1 / n9[1]], [E9[0] + n9[0] * o1, E9[1] + n9[1] * o1]];
            var sh9 = new ctx.THREE.Shape(), q9;
            sh9.moveTo(pts9[0][0], pts9[0][1]); for (q9 = 1; q9 < 4; q9++) sh9.lineTo(pts9[q9][0], pts9[q9][1]); sh9.lineTo(pts9[0][0], pts9[0][1]);
            var gV9 = new ctx.THREE.ExtrudeGeometry(sh9, { depth: VB9.t, bevelEnabled: false });
            gV9.translate(0, 0, zr[1] < 0 ? (zr[0] - VB9.t) : zr[0]);
            var mb9 = new ctx.THREE.Mesh(gV9, mVb9); mb9.name = 'verge board'; mb9.userData.afOut = 'verge board'; ctx.group.add(mb9);
            vbLen += Math.hypot(R9[0] - E9[0], R9[1] - E9[1]) + o1 * Math.abs(n9[0]) / Math.abs(n9[1]); nVb9++;
          });
        });
        if (nVb9) {
          vbRows.forEach(function (rw) { API.billAdd('aframe-skin', rw[0], Math.round(vbLen * 1.10 * 100) / 100); });
          var nScr9 = 2 * Math.ceil(vbLen / 0.60) * vbRows.length;
          API.billAdd('aframe-skin', 'FAS60080', nScr9);
          ctx.log('skin     verge board over the PIR\'s edge (aframe-v157): ' + nVb9 + ' board(s) at the rakes, ' + vbLen.toFixed(2) + ' m, ' + Math.round(hV9 * 1000) + ' high (40 over the verge rafter + deck + PIR ' + Math.round(PA.t * 1000) + ') -> ' + vbRows.map(function (rw) { return rw[0]; }).join(' + ') + ' ' + (vbLen * 1.10).toFixed(2) + ' m each (+10 %), ' + nScr9 + ' x FAS60080; outdoor wood');
        }
      }
      /* THE SLOPES' BUILD-UP UNDER REVIEW (aframe-v146): the phase at the step magenta, those under it in their colours, those over it left to the review's strip (hidden, billed) */
      if (_isAdmin() && AF_STEP.slope < 99) {
        var stS = AF_STEP.slope, chS = ctx.group.children, qs, nUn = 0, nRvS = 0, nAb = 0, SDs = _slopeDefs();
        for (qs = nSk0; qs < chS.length; qs++) {
          var oS = chS[qs], itS = oS.userData && oS.userData.asm, ixS = _slopeIdxOf(itS && (typeof itS === 'object') ? itS.key : '', SDs);
          if (!ixS || ixS > stS) { nAb++; continue; }
          oS.userData.afReview = true;
          if (ixS === stS) { nRvS++; oS.traverse(function (m) { if (m.isMesh && m.material) { var mm = (Array.isArray(m.material) ? m.material[0] : m.material).clone(); mm.map = null; mm.color = new ctx.THREE.Color(MAGENTA); m.material = mm; } }); }
          else nUn++;
        }
        ctx.log('skin     review slope step ' + stS + ' of ' + _slopeLayers().length + ' (' + (_slopeLayers()[stS - 1] || '?') + '): ' + nRvS + ' bod(ies) MAGENTA, ' + nUn + ' under it in their colours, ' + nAb + ' over it hidden (billed)');
      }
      ctx.log('skin     A-frame: ' + (out.built || []).join(', ') + ' over ' + PLs.length + ' plane(s), ' + C.key + ', from the shared drawer' + ((out.pending || []).length ? ('; waiting on ' + out.pending.join(', ')) : ''));
    }


    /* -------------------------------------------------------------------------
       THE EAVE DRIP STRIP, NOT GUTTERS (aframe-v55, decided: an A-frame's
       eave sits under a metre off the ground and a 60 degree roof sheds its
       snow and ice straight into a gutter, so the rain falls free onto a
       gravel strip that keeps the splash off the cladding and the slab).
       Along both eaves, the length of the roof and past each gable under the
       rake: 600 wide from the wall line out past the drip edge, dug 150,
       lined with geotextile (up the trench sides), filled with gravel 16-32,
       held at its outer edge by landscape edging (no catalogue row yet, TBD).
       ------------------------------------------------------------------------- */
    var DRIP = { w: 0.600, d: 0.150, col: 0x9C968C };
    var DRIP_REVIEW = false;
    function _buildDrip(ctx) {
      var T = ctx.THREE, g = ctx.group, B = _barRect(), sd;
      _bill['aframe-drip'] = {};
      var z0 = B.z0 - _rakeOf(0), z1 = B.z1 + _rakeOf(1), L = z1 - z0, col = DRIP_REVIEW ? MAGENTA : DRIP.col;
      var mat = null; try { var tx = _layerTex(T, 'stone'); if (tx && !DRIP_REVIEW) { mat = new T.MeshStandardMaterial({ map: tx.clone(), roughness: 1 }); mat.map.needsUpdate = true; mat.map.wrapS = mat.map.wrapT = T.RepeatWrapping; mat.map.repeat.set(DRIP.w / 0.5, L / 0.5); } } catch (eT) {}
      if (!mat) mat = new T.MeshStandardMaterial({ color: col, roughness: 1 });
      /* NOT UNDER A SIDE WING (aframe-v100): the eave there is inside the wing */
      var Lall = 0, wingCut = [];
      /* BESIDE THE FOOTINGS, NOT OVER THEM (aframe-v121, Marek: chodnik koliduje se zakladovymi prvky, ma byt vedle,
         na stejne rovine; sedi jen u pasu). On strips the strip's outer face is the base line and the gravel starts
         there; on point footings the pads (with their gravel bed), piers or screw saddles stand ON that line, so the
         strip starts past their outer edge: pads 300 (the 600 bed), piers 200, screws 80 -- plus 20 of clearance */
      var fnD = STATE.foundation, offD = (fnD === 'pads') ? 0.32 : (fnD === 'piers') ? 0.22 : (fnD === 'screws') ? 0.10 : (PERIM.t + PERIM.fin);
      for (sd = -1; sd <= 1; sd += 2) {
        var xIn = ((sd < 0) ? B.x0 : B.x1) + sd * offD, xm = xIn + sd * DRIP.w / 2, runsD = [[z0, z1]];
        _wingSides().forEach(function (ws) { if (ws !== sd) return; var WRd = _wingRect(ws), nx = []; runsD.forEach(function (r) { if (WRd.z1 <= r[0] || WRd.z0 >= r[1]) { nx.push(r); return; } if (WRd.z0 > r[0]) nx.push([r[0], WRd.z0]); if (WRd.z1 < r[1]) nx.push([WRd.z1, r[1]]); }); runsD = nx; wingCut.push((ws < 0 ? 'left' : 'right') + ' ' + Math.round(WRd.l * 1000)); });
        runsD.forEach(function (r) {
          var Lr = r[1] - r[0]; if (Lr < 0.05) return;
          var m = new T.Mesh(new T.BoxGeometry(DRIP.w, DRIP.d, Lr), mat);
          m.position.set(xm, -DRIP.d / 2 + 0.012, (r[0] + r[1]) / 2); _am(ctx, 'drip_strip', 'Drip strip', 'grd.gravel', 'top'); g.add(m);
          _am(ctx, 'drip_edging', 'Landscape edging', 'SFF00003', 'side'); _box(T, g, 0.004, DRIP.d + 0.02, Lr, xIn + sd * DRIP.w, -DRIP.d / 2 + 0.02, (r[0] + r[1]) / 2, 0, 0x2E3032, 1);
          Lall += Lr;
        });
      }
      if (wingCut.length) ctx.log('drip     left out under the side wing(s): ' + wingCut.join(', '));
      ctx.log('drip     ' + (fnD !== 'strips' ? ('on ' + fnD + ' the strip starts ' + Math.round(offD * 1000) + ' out from the base line, past the footings\' outer edge (aframe-v121)') : ('on strips the strip starts ' + Math.round(offD * 1000) + ' out from the base line, on the face of the plinth render over the perimeter XPS (aframe-v131)')));
      var vol = DRIP.w * DRIP.d * Lall, geo = (DRIP.w + 2 * DRIP.d) * Lall, edge = Lall;
      API.billAdd('aframe-drip', 'grd.excavation', vol);
      API.billAdd('aframe-drip', 'grd.geotextile', geo * 1.10);
      API.billAdd('aframe-drip', 'grd.gravel', vol * 1.05);
      API.billAdd('aframe-drip', 'SFF00003', edge * 1.05);
      ctx.log('drip     eave drip strips instead of gutters: ' + Lall.toFixed(2) + ' m along the two eaves (of 2 x ' + L.toFixed(2) + ')' + ' m (the roof and the rake overhangs), ' + Math.round(DRIP.w * 1000) + ' wide from the wall line, ' + Math.round(DRIP.d * 1000) + ' deep' + (DRIP_REVIEW ? ' -- MAGENTA, under review' : ''));
      ctx.log('drip     BILL excavation FEE00001 ' + vol.toFixed(2) + ' m3; geotextile FEC00003 ' + (geo * 1.10).toFixed(2) + ' m2 (bottom and both sides, +10% laps); gravel 16-32 FCO00001 ' + (vol * 1.05).toFixed(2) + ' m3 (+5%); edging SFF00003 ' + (edge * 1.05).toFixed(2) + ' m (+5%)');
    }
    _regLayer({
      id: 'aframe-drip', version: VERSION, role: 'zaklady', claims: ['site'],
      build3d: _buildDrip, boq: function () { return _rows('aframe-drip'); }
    });

    /* THE SKIN IS CUT ROUND THE ROOF WINDOWS (aframe-v51, Marek: krytina je
       i pres vlozena okna). The shared drawer lays the deck, underlay,
       battens and covering over the whole plane; here every piece it drew is
       cut afterwards: each triangle that reaches into a window's opening is
       clipped to what lies outside it -- the part below, above, and to each
       side -- so any piece, flat or thick, loses exactly the window's
       rectangle and keeps its own colours and texture. The opening is the
       unit plus the flashing gap (20 each way), the whole height of the skin.
       The drawer billed the full plane, so the openings' area comes off the
       deck (+8 as it bills), the underlay (+11) and the covering; the battens
       and fixings lost there are left in (a few metres). */
    /* THE SKIN CUT ROUND THE ROOF WINDOWS AND THEIR FLASHING KIT are the
       core's from core-v506 (API.roofOpenings, moved there from here: v51
       cut, v54 kit, v56 apron on the measured top). This file only hands it
       the windows as openings in the slope's own axes: from the ridge line on
       the rafters' top face, s down the slope, a along the ridge, n out of
       the roof; each the unit plus the flashing gap all round. The openings'
       area comes off the deck (+8 as it bills), the underlay (+11) and the
       covering. */
    function _skinCut(ctx, n0, C) {
      var S = _sect(), B = _barRect(), R = _rafSize(), cx = (B.x0 + B.x1) / 2, yTop0 = S.top + S.half * S.tan;
      var RW = _roofWinPlan(S, R, B, _rafGrid(), yTop0);
      /* UNDER A SIDE WING the skin goes below the wing's beam (aframe-v103) */
      var wh = [];
      _wingSides().forEach(function (sd2) {
        var WB = _wingBeam(sd2);
        wh.push({ o: [cx, yTop0, 0], s: [sd2 * S.cos, -S.sin, 0], a: [0, 0, 1], n: [sd2 * S.sin, S.cos, 0], s0: WB.sFoot, s1: (S.half + 1.0) / S.cos, a0: WB.zIa, a1: WB.zIb });
      });
      _wingSides().forEach(function (sd3) {
        var DM = _dormer(sd3); if (!DM) return;
        /* ONE CUT OVER ALL THE SLOTS (aframe-v125): between them the axis rafter carries only its cap, no skin */
        wh.push({ o: [cx, yTop0, 0], s: [sd3 * S.cos, -S.sin, 0], a: [0, 0, 1], n: [sd3 * S.sin, S.cos, 0], s0: DM.sTop, s1: DM.WB.sFoot + 0.01, a0: DM.bays[0][0], a1: DM.bays[DM.bays.length - 1][1] });
      });
      if (wh.length && typeof API.roofOpenings === 'function') {
        var PAw = _pirAbove();   /* the PIR on the deck comes off with the deck (aframe-v157) */
        var rW = API.roofOpenings(ctx, n0, wh, { billKey: 'aframe-skin', takeOff: [{ code: 'OSB25002', f: 1.08 }, { code: 'ROR00008', f: 1.11 }].concat((C && C.code) ? [{ code: C.code, f: 1 }] : []).concat(PAw ? [{ code: PAw.code, f: 1.05 * PAw.layers }] : []), cov: (C && C.key) || 'shingle', flash: false });
        ctx.log('wingbeam the skin cut away below its foot on the wing\'s roof and in the dormer(s), ' + wh.length + ' cut(s): ' + wh.map(function (h) { return Math.round((h.a1 - h.a0) * 1000) + ' along from ' + Math.round(h.s0 * 1000) + ' down the slope'; }).join(', ') + ' (the area off the deck, the underlay and the covering)');
      }
      if (!RW.wins.length) { ctx.log('roofwin  skin: no roof window, nothing cut'); return; }
      if (typeof API.roofOpenings !== 'function') { ctx.log('roofwin  ERROR the skin is not cut round the windows -- the core is ' + (__CORE.CORE_VERSION || '?') + ', the cut and the flashing need core-v506: upload configurator-ui.js'); return; }
      var holes = [], q;
      for (q = 0; q < RW.wins.length; q++) {
        var W = RW.wins[q], hw = (W.sz.w || 0.78) / 2 + ROOFWIN.gap, sd = W.side;
        holes.push({ o: [cx, yTop0, 0], s: [sd * S.cos, -S.sin, 0], a: [0, 0, 1], n: [sd * S.sin, S.cos, 0], s0: W.sT, s1: W.sB, a0: W.z - hw, a1: W.z + hw });
      }
      var take = [{ code: 'OSB25002', f: 1.08 }, { code: 'ROR00008', f: 1.11 }], PAr = _pirAbove();
      if (C && C.code) take.push({ code: C.code, f: 1 });
      if (PAr) take.push({ code: PAr.code, f: 1.05 * PAr.layers });   /* the PIR round the window (aframe-v157) */
      API.roofOpenings(ctx, n0, holes, { billKey: 'aframe-skin', takeOff: take, cov: (C && C.key) || 'shingle', flash: true, review: FLASH_REVIEW,
                                         flashCol: API.colorSlotOf ? API.colorSlotOf('metal') : 0x3A3D40, kitCode: _flashKitLabel });
    }
    _regLayer({
      id: 'aframe-skin', version: VERSION, role: 'strecha', claims: ['roof'],
      build3d: _buildSkin, boq: function () { return _rows('aframe-skin'); }
    });

    /* -------------------------------------------------------------------------
       LIGHTNING PROTECTION -- aframe-lps (aframe-v136), COPIED FROM THE ADU's
       adu-lps (the RANCH and the BARNDO carry the same). The rules (NFPA 780 /
       UL 96): air terminals on the ridge, one within 600 of each end and none
       more than 6 m apart; the conductor along the ridge and down the rake to
       the eave corner; at least two down conductors at corners as far apart as
       the building allows, to a ground rod 2.4 m long driven 600 out; a clip
       every 900; a connector at every terminal base and every corner; a guard
       over each down conductor for the first 2.4 m; a bond to a metal roof.
       Adapted, nothing else: the A's eave is at the ground, so a down
       conductor drops plumb from the eave corner -- no posts, no run under an
       overhang, which the ADU needs and the A has not -- and the finished roof
       is the rafters' top face plus the skin (100, and the PIR when the
       insulation is above the rafters). Copper in the model; magenta for an
       admin until Marek has checked it (LPS_REVIEW).
       ------------------------------------------------------------------------- */
    var LPS = {
      on: true,
      rod: 'LPS00001', cable: 'LPS00002', clip: 'LPS00003', conn: 'LPS00004',
      ground: 'LPS00005', gclamp: 'LPS00006', bond: 'LPS00007', guard: 'LPS00008',
      rodH: 0.300, rodD: 0.010, baseW: 0.060, cableD: 0.013,
      termMax: 6.0, termEnd: 0.6, clipStep: 0.9,
      groundL: 2.4, groundD: 0.016, groundOut: 0.6, guardL: 2.4, guardD: 0.030,
      cableLift: 0.030
    };
    var LPS_REVIEW = true;
    function _lpsOn() { var P = STATE.product || {}; return (P.lps === undefined) ? LPS.on : !!P.lps; }
    function _buildLps(ctx) {
      _bill['aframe-lps'] = {};
      if (!_lpsOn()) { ctx.log('lps      off'); return; }
      var T = ctx.THREE, g = ctx.group, B = _barRect(), i, k, q;
      var planes = []; try { planes = roofPlanes() || []; } catch (eP) { planes = []; }
      if (!planes.length) { ctx.log('lps      none -- no roof planes'); return; }
      var mag = LPS_REVIEW && _isAdmin();
      var mCu = new T.MeshStandardMaterial({ color: mag ? MAGENTA : 0xB87333, roughness: 0.45, metalness: 0.7 });
      var mBr = new T.MeshStandardMaterial({ color: mag ? MAGENTA : 0x8A6A3A, roughness: 0.5, metalness: 0.6 });
      var mGd = new T.MeshStandardMaterial({ color: mag ? MAGENTA : 0x555A5E, roughness: 0.8, metalness: 0.2 });
      var tally = { term: 0, cable: 0, clips: 0, conn: 0, downs: 0, rods: 0, bond: 0, guard: 0 };
      var asm = function (code, dir) { try { if (__CORE._asmCode) __CORE._asmCode(ctx, code, dir); } catch (eA) {} };
      var tube = function (a, b, r, m, nm) {
        var dx = b[0] - a[0], dy = b[1] - a[1], dz = b[2] - a[2], L = Math.hypot(dx, dy, dz);
        if (!(L > 0.01)) return 0;
        var mesh = new T.Mesh(new T.CylinderGeometry(r, r, L, 8), m);
        mesh.quaternion.setFromUnitVectors(new T.Vector3(0, 1, 0), new T.Vector3(dx / L, dy / L, dz / L));
        mesh.position.set((a[0] + b[0]) / 2, (a[1] + b[1]) / 2, (a[2] + b[2]) / 2);
        mesh.name = nm; g.add(mesh);
        return L;
      };
      var lerp = function (a, b, t) { return [a[0] + (b[0] - a[0]) * t, a[1] + (b[1] - a[1]) * t, a[2] + (b[2] - a[2]) * t]; };
      var joint = function (p) { var j = new T.Mesh(new T.SphereGeometry(LPS.cableD * 0.6, 8, 6), mCu); j.position.set(p[0], p[1], p[2]); j.name = 'lps-cable'; g.add(j); };
      var key = function (p) { return Math.round(p[0] * 100) + ',' + Math.round(p[1] * 100) + ',' + Math.round(p[2] * 100); };
      var same = function (p, r) { return Math.hypot(p[0] - r[0], p[1] - r[1], p[2] - r[2]) < 0.02; };
      var skinT = 0.10 + _pirT();
      var lift = function (pl) { var pt = (pl.pitch || 0) * Math.PI / 180; return (skinT + LPS.cableLift) / Math.max(0.2, Math.cos(pt)); };
      /* the ridges carry the terminals; the rakes join a ridge end to an eave corner */
      var ridges = [], edges = [], seen = {};
      for (i = 0; i < planes.length; i++) {
        var pl = planes[i], lf = lift(pl), rd = pl.ridge, ev = pl.eave, P = pl.pts || [];
        if (rd && rd.length >= 2 && Math.hypot(rd[1][0] - rd[0][0], rd[1][2] - rd[0][2]) > 0.2) {
          var a = [rd[0][0], rd[0][1] + lf, rd[0][2]], b = [rd[1][0], rd[1][1] + lf, rd[1][2]], kk = key(lerp(a, b, 0.5));
          if (!seen[kk]) { seen[kk] = 1; ridges.push([a, b]); }
        }
        for (k = 0; k < P.length; k++) {
          var p0 = P[k], p1 = P[(k + 1) % P.length];
          var isEave = ev && ((same(p0, ev[0]) && same(p1, ev[1])) || (same(p0, ev[1]) && same(p1, ev[0])));
          var isRidge = rd && rd.length >= 2 && ((same(p0, rd[0]) && same(p1, rd[1])) || (same(p0, rd[1]) && same(p1, rd[0])));
          if (isEave || isRidge) continue;
          if (Math.hypot(p1[0] - p0[0], p1[2] - p0[2]) < 0.2) continue;
          var e0 = [p0[0], p0[1] + lf, p0[2]], e1 = [p1[0], p1[1] + lf, p1[2]], ke = key(lerp(e0, e1, 0.5));
          if (!seen[ke]) { seen[ke] = 1; edges.push([e0, e1]); }
        }
      }
      /* air terminals: one 600 in from each ridge end, the rest at most 6 m apart */
      var termPts = [];
      for (i = 0; i < ridges.length; i++) {
        var ra = ridges[i][0], rb = ridges[i][1], L = Math.hypot(rb[0] - ra[0], rb[1] - ra[1], rb[2] - ra[2]);
        var inner = Math.max(0, L - 2 * LPS.termEnd), n = Math.max(1, Math.ceil(inner / LPS.termMax));
        for (k = 0; k <= n; k++) {
          var t = (LPS.termEnd + inner * k / n) / L;
          if (L < 2 * LPS.termEnd) t = 0.5;
          var p = lerp(ra, rb, t), kt = key(p);
          if (seen['T' + kt]) continue;
          seen['T' + kt] = 1; termPts.push(p);
          if (L < 2 * LPS.termEnd) break;
        }
        asm(LPS.cable, 'top');
        tally.cable += tube(ra, rb, LPS.cableD / 2, mCu, 'lps-cable');
        joint(ra); joint(rb);
      }
      for (i = 0; i < termPts.length; i++) {
        var tp = termPts[i];
        asm(LPS.rod, 'top');
        var base = new T.Mesh(new T.BoxGeometry(LPS.baseW, 0.012, LPS.baseW), mBr);
        base.position.set(tp[0], tp[1] + 0.006, tp[2]); base.name = 'lps-terminal'; g.add(base);
        tube([tp[0], tp[1] + 0.012, tp[2]], [tp[0], tp[1] + 0.012 + LPS.rodH, tp[2]], LPS.rodD / 2, mCu, 'lps-terminal');
        tally.term++; tally.conn++;
      }
      /* two ways down, at the two rake feet farthest apart (opposite corners) */
      var cands = [];
      for (i = 0; i < edges.length; i++) {
        var eA = edges[i][0], eB = edges[i][1], hiE = eA[1] >= eB[1] ? eA : eB, loE = eA[1] >= eB[1] ? eB : eA, atRidge = false, rq;
        for (rq = 0; rq < ridges.length && !atRidge; rq++) if (same(hiE, ridges[rq][0]) || same(hiE, ridges[rq][1])) atRidge = true;
        if (atRidge) cands.push({ edge: [hiE, loE], corner: loE });
      }
      var pick = [];
      if (cands.length >= 2) {
        var best = -1, bi = 0, bj = 1;
        for (i = 0; i < cands.length; i++) for (q = i + 1; q < cands.length; q++) {
          var d2 = Math.hypot(cands[i].corner[0] - cands[q].corner[0], cands[i].corner[2] - cands[q].corner[2]);
          if (d2 > best) { best = d2; bi = i; bj = q; }
        }
        pick = [cands[bi], cands[bj]];
      } else if (cands.length === 1) pick = [cands[0]];
      var ffull = true; try { ffull = (typeof __CORE._footFull === 'function') ? !!__CORE._footFull() : true; } catch (eF) { ffull = true; }
      var downNote = [];
      for (i = 0; i < pick.length; i++) {
        var c = pick[i].corner;
        asm(LPS.cable, 'side');
        tally.cable += tube(pick[i].edge[0], pick[i].edge[1], LPS.cableD / 2, mCu, 'lps-cable');
        joint(pick[i].edge[1]); tally.conn++;
        /* the eave corner is at the plinth: straight down from it to the ground */
        var sx = (Math.abs(c[0] - B.x0) < Math.abs(c[0] - B.x1)) ? -1 : 1, sz = (Math.abs(c[2] - B.z0) < Math.abs(c[2] - B.z1)) ? -1 : 1;
        var wx = c[0], wz = c[2], foot = [wx, 0, wz];
        if (c[1] > 0.02) { tally.cable += tube(c, foot, LPS.cableD / 2, mCu, 'lps-cable'); joint(foot); }
        tube([wx, 0, wz], [wx, Math.max(0.05, Math.min(c[1], LPS.guardL)), wz], LPS.guardD / 2, mGd, 'lps-guard');
        tally.guard++;
        var rx = wx + sx * LPS.groundOut, rz = wz + sz * LPS.groundOut;
        asm(LPS.ground, 'bottom');
        tally.cable += tube(foot, [rx, -0.02, rz], LPS.cableD / 2, mCu, 'lps-cable');
        if (ffull) tube([rx, 0.05, rz], [rx, -LPS.groundL, rz], LPS.groundD / 2, mCu, 'lps-ground');
        else tube([rx, 0.05, rz], [rx, -0.05, rz], LPS.groundD / 2, mCu, 'lps-ground');
        var clamp = new T.Mesh(new T.BoxGeometry(0.04, 0.03, 0.04), mBr);
        clamp.position.set(rx, 0.03, rz); clamp.name = 'lps-ground'; g.add(clamp);
        tally.rods++; tally.downs++; tally.conn++;
        downNote.push('corner ' + Math.round(c[0] * 1000) + '/' + Math.round(c[2] * 1000) + ' from ' + Math.round(c[1] * 1000) + ' up');
      }
      if (!pick.length) ctx.log('lps      no route down -- no roof edge leaves a ridge end');
      tally.clips = Math.ceil(tally.cable / LPS.clipStep);
      var covK = ''; try { covK = (API.covDef() || {}).key || ''; } catch (eC) { covK = ''; }
      tally.bond = (covK === 'trapez' || covK === 'seam') ? planes.length : 0;
      var row = function (code, qty) { if (qty > 0) API.billAdd('aframe-lps', code, qty); };
      row(LPS.rod, tally.term); row(LPS.cable, tally.cable); row(LPS.clip, tally.clips); row(LPS.conn, tally.conn);
      row(LPS.ground, tally.rods); row(LPS.gclamp, tally.rods); row(LPS.guard, tally.guard); row(LPS.bond, tally.bond);
      ctx.log('lps      ' + tally.term + ' air terminal(s) on ' + ridges.length + ' ridge line(s), ' + (Math.round(tally.cable * 10) / 10) + ' m of conductor (ridge, one rake down at each end, ' +
              tally.downs + ' down conductor(s) at opposite corners -- NFPA 780: ' + downNote.join(', ') + '), ' + tally.clips + ' clip(s) at ' + Math.round(LPS.clipStep * 1000) + ', ' + tally.conn + ' connector(s), ' +
              tally.rods + ' ground rod(s) ' + Math.round(LPS.groundL * 1000) + ' long ' + Math.round(LPS.groundOut * 1000) + ' out, ' + tally.guard + ' guard(s), ' + tally.bond + ' bond(s) (' + (covK || '?') + ' roof)' +
              ' -- LPS00001..8 billed to aframe-lps' + (mag ? ' -- MAGENTA (admin, until checked)' : ''));
    }
    _regLayer({
      id: 'aframe-lps', version: VERSION, role: 'tzb', claims: ['lps'],
      build3d: _buildLps, boq: function () { return _rows('aframe-lps'); }
    });

    /* -------------------------------------------------------------------------
       THE BUILD-UP OF THE ENVELOPE, FROM THE INSIDE OUT (aframe-v32, Marek:
       zatepleni, vrstvy od vnitrni po vnejsi, resena vrstva magenta). With the
       insulation between the rafters (the Structure step) the slopes and the
       gables are lined the same way, room side first:
         1  gypsum board 12.5 on the service battens      (this step)
         2  service battens 30 x 50 every 400, across the rafters and studs
         3  vapour barrier, lapped and taped
         4  mineral wool between the rafters and the studs
       and outside them what is already there: the roof deck, underlay,
       battens and covering (the roof skin), on the gables OSB and membrane.
       LAYER_STEP is the layer under review: it is drawn magenta, the ones
       inside it in their own colours, the ones outside it not at all.
       ------------------------------------------------------------------------- */
    var LAYER_STEP = 7;
    /* THE LAYERS INSIDE THE ONE UNDER REVIEW ARE NOT DRAWN (aframe-v35,
       Marek: schovat sdk at mam vizualni kontrolu) -- they are billed all
       the same; true draws them in their own colours */
    /* every layer accepted (aframe-v52): all drawn in their own colours */
    var LAYER_SHOW_INNER = true;
    function _layerDraw(n) { return n >= LAYER_STEP || LAYER_SHOW_INNER; }
    var LINE = { batt: 0.030, vb: 0.0002,
                 board: { code: 'WDD24001', t: 0.0125, col: 0xEDEAE3, screw: 'WDS00001', screwPerM2: 20, tape: 'WDF00008', filler: 'WDF00009', fillerKgM2: 0.45, waste: 1.10 } };
    var MAGENTA = 0xFF00FF;
    /* WHAT THICKNESS OF WOOL GOES IN, out of what the catalogue carries --
       copied from the ADU (woolFill, itself from tiny): a shortfall is scored
       four times as harshly as an overfill, then the fewest layers win; only
       depths the catalogue stocks */
    var WOOL_STOCK = [['INS02001', 0.200], ['INS01601', 0.160], ['INS01201', 0.120],
                      ['INS01151', 0.115], ['INS00601', 0.060]];
    function woolFill(hM) {
      var best = null, i, j, n, m;
      function look(mix, t) {
        var short = hM - t;
        if (short > 0.05 || short < -0.05) return;
        var nL = 0, q;
        for (q = 0; q < mix.length; q++) nL += mix[q].n;
        var score = (short > 0 ? short * 400 : -short * 80) + nL * 3;
        if (!best || score < best.score) best = { mix: mix, score: score, t: t };
      }
      for (i = 0; i < WOOL_STOCK.length; i++) {
        for (n = 1; n <= 4; n++) {
          look([{ code: WOOL_STOCK[i][0], mm: Math.round(WOOL_STOCK[i][1] * 1000), n: n }],
               WOOL_STOCK[i][1] * n);
          for (j = i + 1; j < WOOL_STOCK.length; j++) {
            for (m = 1; m <= 2; m++) {
              look([{ code: WOOL_STOCK[i][0], mm: Math.round(WOOL_STOCK[i][1] * 1000), n: n },
                    { code: WOOL_STOCK[j][0], mm: Math.round(WOOL_STOCK[j][1] * 1000), n: m }],
                   WOOL_STOCK[i][1] * n + WOOL_STOCK[j][1] * m);
            }
          }
        }
      }
      return best || { mix: [{ code: 'INS01601', mm: 160, n: 1 }], t: 0.160 };
    }
    /* WOOL THAT MUST NOT OVERFILL (aframe-v49): under a vent channel the
       batt may not reach into the air gap, so the thickest mix that stays
       within the depth wins, then the fewest layers */
    function woolUpTo(hM) {
      var best = null, i, j, n, m;
      function look(mix, t) {
        if (t > hM + 0.002) return;
        var nL = 0, q; for (q = 0; q < mix.length; q++) nL += mix[q].n;
        var score = (hM - t) * 400 + nL * 3;
        if (!best || score < best.score) best = { mix: mix, score: score, t: t };
      }
      for (i = 0; i < WOOL_STOCK.length; i++) {
        for (n = 1; n <= 4; n++) {
          look([{ code: WOOL_STOCK[i][0], mm: Math.round(WOOL_STOCK[i][1] * 1000), n: n }], WOOL_STOCK[i][1] * n);
          for (j = i + 1; j < WOOL_STOCK.length; j++) for (m = 1; m <= 2; m++)
            look([{ code: WOOL_STOCK[i][0], mm: Math.round(WOOL_STOCK[i][1] * 1000), n: n },
                  { code: WOOL_STOCK[j][0], mm: Math.round(WOOL_STOCK[j][1] * 1000), n: m }], WOOL_STOCK[i][1] * n + WOOL_STOCK[j][1] * m);
        }
      }
      return best || { mix: [{ code: 'INS00601', mm: 60, n: 1 }], t: 0.060 };
    }
    /* THE VENT CHANNEL IN EVERY RAFTER BAY (aframe-v49, decided for the US
       market -- a vented cathedral ceiling, IRC R806): the ADU's rule, 50 mm
       of clear air under the deck held open by a vent baffle (ROV00101, 10
       thick, by the metre of bay), the eaves strip ROV00100 at the air's way
       in along both eaves, the ridge vent (the skin's) its way out. The wool
       takes what is left of the rafter under the baffle. */
    var VENT = { gap: 0.050, baffle: 'ROV00101', baffleT: 0.010, strip: 'ROV00100', col: 0xC8D0D6 };
    function _woolTxt(W) { var a = [], q; for (q = 0; q < W.mix.length; q++) a.push(W.mix[q].n + ' x ' + W.mix[q].mm + ' ' + W.mix[q].code); return a.join(' + '); }
    function _layerCol(n, own) { return (n === LAYER_STEP) ? MAGENTA : own; }
    /* a flat panel in a slope's plane: a in s (down the top face from the
       ridge line), b in z; o is the offset from the rafters' top face, out +
       in - ; holes are rectangles [a0, a1, b0, b1] */
    function _slopePanel(T, g, S, cx, yTop0, sd, o, a0, a1, b0, b1, holes, col) {
      var sh = new T.Shape(), q;
      sh.moveTo(a0, b0); sh.lineTo(a1, b0); sh.lineTo(a1, b1); sh.lineTo(a0, b1); sh.lineTo(a0, b0);
      var area = (a1 - a0) * (b1 - b0);
      for (q = 0; q < holes.length; q++) {
        var H = holes[q], ha0 = Math.max(a0, H[0]), ha1 = Math.min(a1, H[1]), hb0 = Math.max(b0, H[2]), hb1 = Math.min(b1, H[3]);
        if (ha1 - ha0 < 0.01 || hb1 - hb0 < 0.01) continue;
        var hp = new T.Path();
        hp.moveTo(ha0, hb0); hp.lineTo(ha0, hb1); hp.lineTo(ha1, hb1); hp.lineTo(ha1, hb0); hp.lineTo(ha0, hb0);
        sh.holes.push(hp); area -= (ha1 - ha0) * (hb1 - hb0);
      }
      var geo = new T.ShapeGeometry(sh), pos = geo.attributes.position, i;
      for (i = 0; i < pos.count; i++) {
        var a = pos.getX(i), b = pos.getY(i);
        pos.setXYZ(i, cx + sd * (a * S.cos + o * S.sin), yTop0 - a * S.sin + o * S.cos, b);
      }
      pos.needsUpdate = true; geo.computeVertexNormals();
      if (col != null) g.add(new T.Mesh(geo, new T.MeshStandardMaterial({ color: col, roughness: 0.9, side: T.DoubleSide })));
      return Math.max(0, area);
    }
    function _buildLining(ctx) {
      var T = ctx.THREE, g = ctx.group;
      _bill['aframe-lining'] = {};
      ctx.log('layer    insulation ' + INSUL + ' the rafters (Structure step; kept with the project as ' + ((STATE.product && STATE.product.aframeInsul) || 'not set -- the default') + ')');
      /* INSULATION ABOVE THE RAFTERS (aframe-v99, Marek: funguje prepinani
         nadkrokevni a krokevni izolace? -- it did not: 'above' drew and billed
         nothing at all). Above the rafters the slopes are the skin's: T&G
         boards on the rafters seen from inside, the vapour layer, PIR, the
         underlay, the battens (_buildSkin). Here only the slopes' own layers
         are left out; the gables and the ceilings under the floors are lined
         as before. */
      var slopeOn = (INSUL === 'between');
      if (!slopeOn) ctx.log('layer    insulation ABOVE the rafters: no board, battens, barrier or wool on the slopes here -- the skin lays them over the rafters; the gables and the ceilings lined as before');
      var S = _sect(), B = _barRect(), R = _rafSize(), cx = (B.x0 + B.x1) / 2, fl = floors();
      var yTop0 = S.top + S.half * S.tan, BD = LINE.board;
      /* layer 1: the board's middle plane under the rafters, the battens and the barrier between */
      var oB = -(R.d + LINE.batt + LINE.vb + BD.t / 2);
      var sMin = -oB * S.tan, sMax = (yTop0 + oB * S.cos - S.deck) / S.sin;
      var sOf = function (y) { return (yTop0 + oB * S.cos - y) / S.sin; };
      var zIn0 = B.z0 + GABLE.d + LINE.batt + LINE.vb + BD.t, zIn1 = B.z1 - GABLE.d - LINE.batt - LINE.vb - BD.t;
      /* the floors cut the lining: over each upper floor's zone (joists + deck) it stops */
      var bands = [], k;
      for (k = 1; k < fl.length; k++) bands.push([sOf(fl[k].y), sOf(fl[k].y - FLOOR.deck.t - FLOOR.joist.d)]);
      bands.sort(function (a, b) { return a[0] - b[0]; });
      var spans = [], cur = sMin;
      for (k = 0; k < bands.length; k++) { if (bands[k][0] > cur + 0.02) spans.push([cur, bands[k][0]]); cur = Math.max(cur, bands[k][1]); }
      if (sMax > cur + 0.02) spans.push([cur, sMax]);
      /* the roof windows cut it: the rough opening, as the frame layer sets it */
      var RG = _rafGrid(), RW = _roofWinPlan(S, R, B, RG, yTop0), holesL = { '-1': [], '1': [] }, q;
      for (q = 0; q < RW.wins.length; q++) {
        var W = RW.wins[q];
        holesL[String(W.side)].push([W.sT, W.sB, W.z - W.clr / 2, W.z + W.clr / 2]);
      }
      /* under a side wing the slope's lining goes below the wing's beam (aframe-v103) */
      _wingSides().forEach(function (ws) { var WB = _wingBeam(ws); holesL[String(ws)].push([WB.dB / S.cos, (S.half + 1.0) / S.cos, WB.zIa, WB.zIb]);
        var DM = _dormer(ws); if (DM) DM.bays.forEach(function (b) { holesL[String(ws)].push([DM.sTop - 0.02, WB.uCut / S.cos, b[0], b[1]]); }); });
      /* the board takes the Walls colour of the Colors step (aframe-v53): white by default, or the picked shade */
      var bdCol = BD.col; try { if (API.colorSlotOf) { var cs = API.colorSlotOf('ceiling'); if (cs != null) bdCol = cs; } } catch (eCs) {}
      var colB = _layerDraw(1) ? _layerCol(1, bdCol) : null, aSlope = 0, sd, sp;
      _am(ctx, 'layer_plasterboard', 'Plasterboard', BD.code, 'in');
      /* A FULL GLAZED GABLE HAS NO LINING FOR THE SLOPES' TO STOP AGAINST
         (aframe-v147, plan F FIX: the battens showed under the rafters): the
         slopes' battens and board run on to the glazing frame's inner face
         (the gable frame's), and a casing along both rakes on the room side
         covers their ends */
      var fullGl = { 0: false, 1: false };
      _gableSegs().forEach(function (sgF) {
        var rkF = null; (sgF.openings || []).forEach(function (oF) { if (!rkF && (oF.rake || oF.fullW || oF.halfW)) rkF = oF; });
        var RUF = null; try { RUF = rkF ? _rakeUnit(sgF, rkF) : null; } catch (eRF) { RUF = null; }
        if (RUF && !RUF.half) fullGl[(Math.abs(sgF.z0 - B.z0) < 0.01) ? 0 : 1] = true;
      });
      var zS0 = fullGl[0] ? (B.z0 + GABLE.d) : zIn0, zS1 = fullGl[1] ? (B.z1 - GABLE.d) : zIn1;
      /* the slopes' own bodies, for the review on the arrows (aframe-v147): child ranges and their step */
      var SLR = [], kS0 = g.children.length;
      for (sd = -1; sd <= 1 && slopeOn; sd += 2) {
        for (sp = 0; sp < spans.length; sp++) aSlope += _slopePanel(T, g, S, cx, yTop0, sd, oB, spans[sp][0], spans[sp][1], zS0, zS1, holesL[String(sd)], colB);
      }
      SLR.push({ k0: kS0, k1: g.children.length, ph: 'board' });
      /* the gables' own bodies, for their review on the arrows (aframe-v148, plan G) */
      var GLR = [], kGc0 = g.children.length;
      var gcL = 0, gcN = 0;
      if (slopeOn && (fullGl[0] || fullGl[1])) {
        var cwF = _caseW(), ctF = _caseT(), colF = (TRIM_REVIEW && _isAdmin()) ? MAGENTA : CASE.col, gF9 = (colB != null) ? g : _afHid(ctx), eF;
        _am(ctx, 'casing', 'Casing', CASE.code, 'side');
        for (eF = 0; eF < 2; eF++) {
          if (!fullGl[eF]) continue;
          var zA9 = eF ? (zS1 - cwF) : zS0, zB9 = eF ? zS1 : (zS0 + cwF);
          for (sd = -1; sd <= 1; sd += 2) for (sp = 0; sp < spans.length; sp++) { _slopePanel(T, gF9, S, cx, yTop0, sd, oB - BD.t / 2 - ctF / 2, spans[sp][0], spans[sp][1], zA9, zB9, [], colF); gcL += spans[sp][1] - spans[sp][0]; }
          gcN++;
        }
        API.billAdd('aframe-lining', CASE.code, Math.round(gcL * 1.05 * 100) / 100);
        API.billAdd('aframe-lining', CASE.nail, CASE.rows * Math.ceil(gcL / CASE.step));
        ctx.log('trim     glazed gable(s) (aframe-v147): ' + gcN + ' full glazing -- the slopes\' battens and board run on to the glazing frame (' + Math.round((GABLE.d) * 1000) + ' in from the gable\'s outer face instead of ' + Math.round((GABLE.d + LINE.batt + LINE.vb + BD.t) * 1000) + '), a casing ' + CASE.code + ' along both rakes on the room side over their ends: ' + gcL.toFixed(2) + ' m, BILL ' + (gcL * 1.05).toFixed(2) + ' m + ' + (CASE.rows * Math.ceil(gcL / CASE.step)) + ' x ' + CASE.nail);
      }
      GLR.push({ k0: kGc0, k1: g.children.length, ph: 'case' });
      /* the gables' inner face: the triangle inside the slopes' lining, less the floor zones and the units */
      var kGb0 = g.children.length;
      var hw = function (y) { return (yTop0 + oB * S.cos - y) / S.tan + oB * S.sin; };
      var yApex = yTop0 + oB * S.cos + oB * S.sin * S.tan;
      var GS = _gableSegs(), aGable = 0, e, caseG = { len: 0, n: 0, doors: 0, wins: 0 };
      for (e = 0; e < 2; e++) {
        var zOut = (e === 0) ? B.z0 : B.z1, zL = (e === 0) ? (B.z0 + GABLE.d + LINE.batt + LINE.vb + BD.t / 2) : (B.z1 - GABLE.d - LINE.batt - LINE.vb - BD.t / 2);
        var sg = null; for (q = 0; q < GS.length; q++) if (Math.abs(GS[q].z0 - zOut) < 0.01) sg = GS[q];
        var ux = sg ? _segUx(sg) : 1, rects = [], rk = null, ops = sg ? (sg.openings || []) : [];
        for (q = 0; q < ops.length; q++) { if (ops[q].rake || ops[q].fullW || ops[q].halfW) rk = rk || ops[q]; else rects.push(ops[q]); }
        var RU = (rk && sg) ? _rakeUnit(sg, rk) : null;
        if (RU && !RU.half) continue;          /* a full glazing: no lining on that gable (aframe-v63) */
        /* bands of the gable between the floor zones, each a trapezoid (the top one a triangle) */
        var yb = [[S.deck, fl.length > 1 ? fl[1].y - FLOOR.deck.t - FLOOR.joist.d : yApex]];
        for (k = 1; k < fl.length; k++) yb.push([fl[k].y, (k + 1 < fl.length) ? (fl[k + 1].y - FLOOR.deck.t - FLOOR.joist.d) : yApex]);
        for (k = 0; k < yb.length; k++) {
          var y0 = yb[k][0], y1 = Math.min(yb[k][1], yApex);
          if (y1 - y0 < 0.02) continue;
          var w0 = hw(y0), w1 = Math.max(0, hw(y1)), shp = new T.Shape();
          shp.moveTo(cx - w0, y0); shp.lineTo(cx + w0, y0); shp.lineTo(cx + w1, y1);
          if (w1 > 0.001) shp.lineTo(cx - w1, y1);
          shp.lineTo(cx - w0, y0);
          var aBand = (w0 + w1) * (y1 - y0);
          for (q = 0; q < rects.length; q++) {
            var o2 = rects[q], xa = sg.x0 + ux * (o2.at - o2.w / 2), xb = sg.x0 + ux * (o2.at + o2.w / 2), hx0 = Math.min(xa, xb), hx1 = Math.max(xa, xb);
            var hy0 = Math.max(y0 + 0.001, sg.y0 + (o2.sill || 0)), hy1 = Math.min(y1 - 0.001, sg.y0 + (o2.sill || 0) + o2.h);
            if (hy1 - hy0 < 0.01) continue;
            var hp2 = new T.Path();
            hp2.moveTo(hx0, hy0); hp2.lineTo(hx0, hy1); hp2.lineTo(hx1, hy1); hp2.lineTo(hx1, hy0); hp2.lineTo(hx0, hy0);
            shp.holes.push(hp2); aBand -= (hx1 - hx0) * (hy1 - hy0);
          }
          if (RU && !RU.half) {
            /* the glazed triangle: the lining keeps only what lies outside it (approximated by its band) */
            var PB = _polyBand(RU.poly, y0 + 0.001, y1 - 0.001);
            if (PB.poly.length >= 3) { shp.holes.push(_polyPath(T, PB.poly, false)); aBand -= PB.area; }
          }
          /* a partly glazed gable: the band's pieces round the units and the glass (aframe-v64) */
          var shL = [shp];
          if (RU && RU.half) {
            var outlL = [[cx - w0, y0], [cx + w0, y0], [cx + w1, y1]]; if (w1 > 0.001) outlL.push([cx - w1, y1]);
            var rrL = rects.map(function (o3) { var xa3 = sg.x0 + ux * (o3.at - o3.w / 2), xb3 = sg.x0 + ux * (o3.at + o3.w / 2); return [Math.min(xa3, xb3), Math.max(xa3, xb3), sg.y0 + (o3.sill || 0), sg.y0 + (o3.sill || 0) + o3.h]; });
            var pcL = _gableMinus(outlL, rrL, RU);
            shL = pcL.map(function (P) { return _polyPath(T, P, true); });
            aBand = pcL.reduce(function (m, P) { return m + _polyArea(P); }, 0);
          }
          /* the board's walk item again: the casings of the gable before took it over (aframe-v148) */
          _am(ctx, 'layer_plasterboard', 'Plasterboard', BD.code, 'in');
          var mL = new T.MeshStandardMaterial({ color: colB == null ? 0xffffff : colB, roughness: 0.9, side: T.DoubleSide }), lq;
          for (lq = 0; lq < shL.length; lq++) {
            var gGeo = new T.ShapeGeometry(shL[lq]); gGeo.translate(0, 0, zL);
            if (colB != null) g.add(new T.Mesh(gGeo, mL));
          }
          aGable += Math.max(0, aBand);
        }
        /* THE UNITS CASED INSIDE (aframe-v144): a door on three sides, a window round all four, on the board's face */
        var cwG = _caseW(), ctG = _caseT(), zC = zL + (e === 0 ? 1 : -1) * (BD.t / 2 + ctG / 2), gC = (colB != null) ? g : _afHid(ctx), mC = _trimMat(T, CASE.col);
        for (q = 0; q < rects.length; q++) {
          var oC = rects[q], xaC = sg.x0 + ux * (oC.at - oC.w / 2), xbC = sg.x0 + ux * (oC.at + oC.w / 2), cx0 = Math.min(xaC, xbC), cx1 = Math.max(xaC, xbC);
          var cy0 = sg.y0 + (oC.sill || 0), cy1 = cy0 + oC.h, isDoor = (oC.kind === 'door' || oC.kind === 'french' || oC.kind === 'garage');
          _am(ctx, 'casing', 'Casing', CASE.code, 'side');
          _box(T, gC, cwG, cy1 - cy0 + (isDoor ? 0 : 2 * cwG), ctG, cx0 - cwG / 2, (cy0 + cy1) / 2, zC, 0, 0, 1).material = mC;
          _box(T, gC, cwG, cy1 - cy0 + (isDoor ? 0 : 2 * cwG), ctG, cx1 + cwG / 2, (cy0 + cy1) / 2, zC, 0, 0, 1).material = mC;
          _box(T, gC, cx1 - cx0 + 2 * cwG, cwG, ctG, (cx0 + cx1) / 2, cy1 + cwG / 2, zC, 0, 0, 1).material = mC;
          if (!isDoor) _box(T, gC, cx1 - cx0 + 2 * cwG, cwG, ctG, (cx0 + cx1) / 2, cy0 - cwG / 2, zC, 0, 0, 1).material = mC;
          var lC = isDoor ? (2 * (cy1 - cy0) + (cx1 - cx0) + 2 * cwG) : (2 * (cy1 - cy0) + 2 * (cx1 - cx0) + 8 * cwG);
          caseG.len += lC; caseG.n++; caseG[isDoor ? 'doors' : 'wins']++;
        }
      }
      GLR.push({ k0: kGb0, k1: g.children.length, ph: 'board' });
      /* THE CEILINGS UNDER THE UPPER FLOORS (aframe-v35) LEFT THE LINING IN
         aframe-v134: their battens and board are layers 4 and 5 of the upper
         floors' build-up, drawn and billed in _buildFloors (ufloor). */
      /* LAYER 2: THE SERVICE BATTENS (aframe-v34). 30 x 50 (KVR50030) every
         400, across the rafters on the slopes -- so they run along the ridge --
         and across the studs on the gables -- so they run level; the board
         of layer 1 is screwed to them, the vapour barrier lies behind them.
         They stop at the floor zones and round every window and unit; one
         FAS60100 screw where a batten crosses a rafter or a stud. */
      if (LAYER_STEP >= 2) {
        var BT = { code: 'KVR50030', w: 0.050, h: 0.030, sp: 0.40, screw: 'FAS60100', col: 0xC9A87A };
        var drT = _layerDraw(2), colT = _layerCol(2, BT.col), bMat = new T.MeshStandardMaterial({ color: colT, roughness: 0.85 });
        _am(ctx, 'layer_service_battens', 'Service battens', BT.code, 'in');
        var oT = -(R.d + LINE.vb + BT.h / 2), btLen = 0, btScrew = 0, nRowS = 0, nRowG = 0;
        var rafZ = RW.lines.slice(1, RW.lines.length - 1);
        var cutRun = function (a0, a1, cuts) {           /* [a0, a1] less the cut ranges */
          var out = [[a0, a1]], c2, p2;
          for (c2 = 0; c2 < cuts.length; c2++) {
            var nx2 = [];
            for (p2 = 0; p2 < out.length; p2++) {
              if (cuts[c2][1] <= out[p2][0] || cuts[c2][0] >= out[p2][1]) { nx2.push(out[p2]); continue; }
              if (cuts[c2][0] > out[p2][0]) nx2.push([out[p2][0], cuts[c2][0]]);
              if (cuts[c2][1] < out[p2][1]) nx2.push([cuts[c2][1], out[p2][1]]);
            }
            out = nx2;
          }
          return out;
        };
        var sB0 = -oT * S.tan + 0.10, sB1 = (yTop0 + oT * S.cos - S.deck) / S.sin - 0.05, sq, kT0 = g.children.length;
        for (sd = -1; sd <= 1 && slopeOn; sd += 2) {
          for (sq = sB0; sq <= sB1 + 1e-6; sq += BT.sp) {
            var inBand = false, bq;
            for (bq = 0; bq < bands.length; bq++) if (sq > bands[bq][0] - BT.w && sq < bands[bq][1] + BT.w) inBand = true;
            if (inBand) continue;
            var cutsZ = [], wq;
            for (wq = 0; wq < holesL[String(sd)].length; wq++) { var HL = holesL[String(sd)][wq]; if (sq > HL[0] - BT.w / 2 && sq < HL[1] + BT.w / 2) cutsZ.push([HL[2], HL[3]]); }
            var runs = cutRun(zS0, zS1, cutsZ), rq;
            for (rq = 0; rq < runs.length; rq++) {
              var rl = runs[rq][1] - runs[rq][0]; if (rl < 0.10) continue;
              var P0 = { x: cx + sd * (sq * S.cos + oT * S.sin), y: yTop0 - sq * S.sin + oT * S.cos };
              var bm = new T.Mesh(new T.BoxGeometry(BT.w, BT.h, rl), bMat);
              bm.position.set(P0.x, P0.y, (runs[rq][0] + runs[rq][1]) / 2); bm.rotation.z = -sd * S.p; if (drT) g.add(bm);
              btLen += rl;
              for (var zq = 0; zq < rafZ.length; zq++) if (rafZ[zq] > runs[rq][0] && rafZ[zq] < runs[rq][1]) btScrew++;
            }
            nRowS++;
          }
        }
        SLR.push({ k0: kT0, k1: g.children.length, ph: 'sbatt' });
        /* the gables: level battens every 400 from the deck up, inside the frame */
        var hwT = function (y) { return (yTop0 + oT * S.cos - y) / S.tan + oT * S.sin; }, kGt0 = g.children.length;
        for (e = 0; e < 2; e++) {
          var zOutT = (e === 0) ? B.z0 : B.z1, zT = (e === 0) ? (B.z0 + GABLE.d + LINE.vb + BT.h / 2) : (B.z1 - GABLE.d - LINE.vb - BT.h / 2);
          var sgT = null; for (q = 0; q < GS.length; q++) if (Math.abs(GS[q].z0 - zOutT) < 0.01) sgT = GS[q];
          var uxT = sgT ? _segUx(sgT) : 1, opsT = sgT ? (sgT.openings || []) : [], rkT = null, recT = [];
          for (q = 0; q < opsT.length; q++) { if (opsT[q].rake || opsT[q].fullW || opsT[q].halfW) rkT = rkT || opsT[q]; else recT.push(opsT[q]); }
          var RUT = (rkT && sgT) ? _rakeUnit(sgT, rkT) : null;
          if (RUT && !RUT.half) continue;
          for (var yq = S.deck + 0.10; yq < yApex - 0.15; yq += BT.sp) {
            var inZ = false;
            for (k = 1; k < fl.length; k++) if (yq > fl[k].y - FLOOR.deck.t - FLOOR.joist.d - BT.w && yq < fl[k].y + BT.w) inZ = true;
            if (inZ) continue;
            var hwy = hwT(yq); if (hwy < 0.10) continue;
            var cutsX = [];
            for (q = 0; q < recT.length; q++) {
              var oo = recT[q], ya = sgT.y0 + (oo.sill || 0) - BT.w / 2, yb2 = sgT.y0 + (oo.sill || 0) + oo.h + BT.w / 2;
              if (yq > ya && yq < yb2) { var xa2 = sgT.x0 + uxT * (oo.at - oo.w / 2), xb2 = sgT.x0 + uxT * (oo.at + oo.w / 2); cutsX.push([Math.min(xa2, xb2), Math.max(xa2, xb2)]); }
            }
            if (RUT && yq > RUT.yB - BT.w / 2 && yq < RUT.apex) { RUT.xRuns(yq - BT.w / 2, yq + BT.w / 2).forEach(function (r) { cutsX.push(r); }); }
            var runsX = cutRun(cx - hwy, cx + hwy, cutsX);
            for (rq = 0; rq < runsX.length; rq++) {
              var rlx = runsX[rq][1] - runsX[rq][0]; if (rlx < 0.10) continue;
              if (drT) _box(T, g, rlx, BT.w, BT.h, (runsX[rq][0] + runsX[rq][1]) / 2, yq, zT, 0, colT, 1);
              btLen += rlx; btScrew += Math.max(1, Math.round(rlx / GABLE.sp) + 1);
            }
            nRowG++;
          }
        }
        GLR.push({ k0: kGt0, k1: g.children.length, ph: 'sbatt' });
        API.billAdd('aframe-lining', BT.code, btLen * 1.05);
        API.billAdd('aframe-lining', BT.screw, btScrew);
        ctx.log('layer 2  service battens ' + BT.code + ' 30x50 every ' + Math.round(BT.sp * 1000) + ': ' + nRowS + ' row(s) on the slopes along the ridge, ' + nRowG + ' level row(s) on the gables, stopped at the floor zones and round the windows and units; ' +
                btLen.toFixed(1) + ' m' + (drT ? ' drawn' : ' -- NOT DRAWN (inner layer)'));
        ctx.log('layer 2  BILL ' + BT.code + ' ' + (btLen * 1.05).toFixed(1) + ' m (+5%), ' + btScrew + ' x ' + BT.screw + ' (one where a batten crosses a rafter or a stud)');
      }
      /* LAYER 3: THE VAPOUR BARRIER (aframe-v36). ROV00001 against the
         underside of the rafters and the inner face of the gable studs, behind
         the service battens, one skin over the slopes and the gables; it is
         not cut at the floors -- the joist ends pass it in a lapped, taped
         collar -- only round the roof windows and the units. Bought on a
         1500 roll lapped 100 (the ADU barrier rule); tape on every lap, round
         every window and unit, along every floor line and every corner where
         a slope meets a gable or the deck. The ceilings get none: warm on
         both sides. */
      if (LAYER_STEP >= 3) {
        var VB = { code: 'ROV00001', tape: 'INS01005', roll: 1.50, lap: 0.10, col: 0x9FB6C8 };
        var colV = _layerDraw(3) ? _layerCol(3, VB.col) : null, oV = -(R.d + LINE.vb / 2);
        _am(ctx, 'layer_vapour_barrier', 'Vapour barrier', VB.code, 'in');
        var sV0 = -oV * S.tan, sV1 = (yTop0 + oV * S.cos - S.deck) / S.sin, zV0 = B.z0 + GABLE.d + LINE.vb, zV1 = B.z1 - GABLE.d - LINE.vb;
        var aVs = 0, aVg = 0, perimV = 0, butV = 0;
        var kV0 = g.children.length;
        for (sd = -1; sd <= 1 && slopeOn; sd += 2) aVs += _slopePanel(T, g, S, cx, yTop0, sd, oV, sV0, sV1, zV0, zV1, holesL[String(sd)], colV);
        SLR.push({ k0: kV0, k1: g.children.length, ph: 'vb' });
        for (q = 0; q < RW.wins.length && slopeOn; q++) perimV += 2 * ((RW.wins[q].sB - RW.wins[q].sT) + RW.wins[q].clr);
        var hwV = function (y) { return (yTop0 + oV * S.cos - y) / S.tan + oV * S.sin; };
        var yApV = yTop0 + oV * S.cos + oV * S.sin * S.tan, kGv0 = g.children.length;
        for (e = 0; e < 2; e++) {
          var zOV = (e === 0) ? B.z0 : B.z1, zVg = (e === 0) ? (B.z0 + GABLE.d + LINE.vb / 2) : (B.z1 - GABLE.d - LINE.vb / 2);
          var sgV = null; for (q = 0; q < GS.length; q++) if (Math.abs(GS[q].z0 - zOV) < 0.01) sgV = GS[q];
          var uxV = sgV ? _segUx(sgV) : 1, opsV = sgV ? (sgV.openings || []) : [], rkV = null, recV = [];
          for (q = 0; q < opsV.length; q++) { if (opsV[q].rake || opsV[q].fullW || opsV[q].halfW) rkV = rkV || opsV[q]; else recV.push(opsV[q]); }
          var RUV = (rkV && sgV) ? _rakeUnit(sgV, rkV) : null;
          if (RUV && !RUV.half) continue;
          var w0V = hwV(S.deck), shV = new T.Shape();
          shV.moveTo(cx - w0V, S.deck); shV.lineTo(cx + w0V, S.deck); shV.lineTo(cx, yApV); shV.lineTo(cx - w0V, S.deck);
          var aG = w0V * (yApV - S.deck);
          for (q = 0; q < recV.length; q++) {
            var oV2 = recV[q], xaV = sgV.x0 + uxV * (oV2.at - oV2.w / 2), xbV = sgV.x0 + uxV * (oV2.at + oV2.w / 2), hx0V = Math.min(xaV, xbV), hx1V = Math.max(xaV, xbV);
            var hy0V = sgV.y0 + (oV2.sill || 0), hy1V = hy0V + oV2.h, hpV = new T.Path();
            hpV.moveTo(hx0V, hy0V); hpV.lineTo(hx0V, hy1V); hpV.lineTo(hx1V, hy1V); hpV.lineTo(hx1V, hy0V); hpV.lineTo(hx0V, hy0V);
            shV.holes.push(hpV); aG -= (hx1V - hx0V) * (hy1V - hy0V); perimV += 2 * ((hx1V - hx0V) + (hy1V - hy0V));
          }
          var shVL = [shV];
          if (RUV) {
            /* round a partly glazed gable in pieces (aframe-v64) */
            var rrV = recV.map(function (o4) { var xa4 = sgV.x0 + uxV * (o4.at - o4.w / 2), xb4 = sgV.x0 + uxV * (o4.at + o4.w / 2); return [Math.min(xa4, xb4), Math.max(xa4, xb4), sgV.y0 + (o4.sill || 0), sgV.y0 + (o4.sill || 0) + o4.h]; });
            var pcV = _gableMinus([[cx - w0V, S.deck], [cx + w0V, S.deck], [cx, yApV]], rrV, RUV);
            shVL = pcV.map(function (P) { return _polyPath(T, P, true); });
            aG = pcV.reduce(function (m, P) { return m + _polyArea(P); }, 0); perimV += RUV.perim;
          }
          if (colV != null) {
            var mV = new T.MeshStandardMaterial({ color: colV, roughness: 1, side: T.DoubleSide }), vq3;
            for (vq3 = 0; vq3 < shVL.length; vq3++) { var gV = new T.ShapeGeometry(shVL[vq3]); gV.translate(0, 0, zVg); g.add(new T.Mesh(gV, mV)); }
          }
          aVg += Math.max(0, aG);
          perimV += 2 * Math.hypot(w0V, yApV - S.deck);        /* the gable's two corners with the slopes */
          /* the gable's foot on the floor, butyl (aframe-v153): its width less the doors and a half glazing reaching the floor */
          var ftV = 2 * w0V;
          recV.forEach(function (o5) { if ((o5.sill || 0) < 0.05) ftV -= o5.w; });
          if (RUV && RUV.yB < S.deck + 0.10) RUV.xRuns(RUV.yB, RUV.yB + 0.05).forEach(function (r5) { ftV -= r5[1] - r5[0]; });
          butV += Math.max(0, ftV);
        }
        GLR.push({ k0: kGv0, k1: g.children.length, ph: 'vb' });
        var slopeLen = (sV1 - sV0), zLenV = zV1 - zV0, nFloorLines = Math.max(0, fl.length - 1);
        if (slopeOn) {
          butV += 2 * zLenV;                                       /* along the deck, both slopes: butyl since aframe-v153, no longer the membrane tape */
          perimV += nFloorLines * 2 * (zLenV + 2 * hwV(fl.length > 1 ? fl[1].y : S.deck));   /* the collars round the joist ends at each floor line */
        }
        var aV = aVs + aVg, boughtV = aV * VB.roll / (VB.roll - VB.lap), lapTape = (boughtV - aV) / VB.lap, tapeV = lapTape + perimV;
        API.billAdd('aframe-lining', VB.code, boughtV);
        API.billAdd('aframe-lining', VB.tape, tapeV);
        _chemBill('aframe-lining', 0, aV, butV); _chemNote(ctx, 'lining barrier', 0, aV, butV);
        ctx.log('layer 3  vapour barrier ' + VB.code + ' under the rafters and inside the gable studs: slopes ' + aVs.toFixed(2) + ' m2 (' + RW.wins.length + ' roof window(s) cut out, ' + slopeLen.toFixed(2) + ' m down each slope), gables ' + aVg.toFixed(2) + ' m2; not cut at the floors, a taped collar round the joist ends' + (colV == null ? ' -- NOT DRAWN (inner layer)' : ''));
        ctx.log('layer 3  BILL ' + VB.code + ' ' + boughtV.toFixed(2) + ' m2 (' + aV.toFixed(2) + ' laid, on a ' + Math.round(VB.roll * 1000) + ' roll lapped ' + Math.round(VB.lap * 1000) + '); tape ' + VB.tape + ' ' + tapeV.toFixed(1) + ' m (' + lapTape.toFixed(1) + ' on the laps + ' + perimV.toFixed(1) + ' round windows, units, corners, deck and floor lines)');
      }
      /* LAYER 4: THE MINERAL WOOL (aframe-v43). The full depth of the rafters
         on the slopes and of the studs on the gables, in the thicknesses the
         catalogue stocks (woolFill, the ADU rule). On the slopes it runs bay by
         bay between the rafters (the doubled ones round a roof window count),
         from the plumb cut at the ridge down to the level seat on the plate,
         stopped round each roof window and its blocks, and round the joist
         ends where a floor ties the rafters. On the gables it fills each bay
         between the studs, from the sole up under the raked plate, stopped at
         the blocking rows and round every unit with its header and sill; no
         wool behind a full glazed gable, none in a half one's band. Held by
         friction, the barrier and the battens -- no fixings. The roof is
         vented over the underlay (the counter battens), so the bay is filled
         full. 5% for the cuts. */
      if (LAYER_STEP >= 4) {
        var drW = _layerDraw(4), colWl = 0xE9D98B, wMat = new T.MeshStandardMaterial({ color: colWl, roughness: 1 });
        var vMat = new T.MeshStandardMaterial({ color: _layerCol(4, VENT.col), roughness: 0.7 });
        var oW = -R.d, oWt = -(VENT.gap + VENT.baffleT), oB0 = -(VENT.gap + VENT.baffleT), oB1 = -VENT.gap;
        /* the hybrid (aframe-v157): the PIR on the deck, no channel -- the wool fills the rafter, no baffle */
        var HY4 = _pirAbove(), hyb4 = !!(HY4 && HY4.mode === 'hybrid');
        var WS = hyb4 ? HY4.wool : woolUpTo(R.d - VENT.gap - VENT.baffleT), baffleL = 0, baffleA = 0, WG = woolFill(GABLE.d), tt4 = R.t, seat4 = S.deck + _plateFit().h;
        var sTop1 = (yTop0 - seat4) / S.sin, sBot0 = R.d * S.tan, sBot1 = (yTop0 - R.d * S.cos - seat4) / S.sin;
        var P4 = function (sd4, s4, o4) { return [cx + sd4 * (s4 * S.cos + o4 * S.sin), yTop0 - s4 * S.sin + o4 * S.cos]; };
        var n4 = RW.lines.length - 1, aWs = 0, nBayS = 0, nPcS = 0, aJoistOut = 0;
        /* the joist ends in the bays: z and, per floor, the band down the slope (at the wool's mid depth) */
        var jEnds = [], jk4, jq4;
        for (jk4 = 1; jk4 < fl.length; jk4++) {
          var JL4 = _joistLayout(jk4, RW.lines, RW.sisters), yJ4 = fl[jk4].y - FLOOR.deck.t - FLOOR.joist.d, om = -R.d / 2;
          var sJa = (yTop0 + om * S.cos - (yJ4 + FLOOR.joist.d)) / S.sin, sJb = (yTop0 + om * S.cos - yJ4) / S.sin;
          for (jq4 = 0; jq4 < JL4.joists.length; jq4++) jEnds.push({ z: JL4.joists[jq4].z, s0: sJa, s1: sJb });
        }
        var tJ4 = FLOOR.joist.t;
        /* a slab in the bay between two depths oHi (nearer the deck) and oLo,
           plumb at the ridge and level on the plate like the rafter */
        var sA = function (o) { return -o * S.tan; }, sE = function (o) { return (yTop0 + o * S.cos - seat4) / S.sin; };
        var bayPiece = function (sd4, a4, b4, za4, zb4, oHi, oLo, mat) {
          var t0 = Math.max(a4, sA(oHi)), t1 = Math.min(b4, sE(oHi)), u0 = Math.max(a4, sA(oLo)), u1 = Math.min(b4, sE(oLo));
          if (t1 - t0 < 0.02 && u1 - u0 < 0.02) return 0;
          if (t1 < t0) t1 = t0; if (u1 < u0) u1 = u0;
          var pts = [P4(sd4, t0, oHi), P4(sd4, t1, oHi), P4(sd4, u1, oLo), P4(sd4, u0, oLo)], shW = new T.Shape(), iq;
          shW.moveTo(pts[0][0], pts[0][1]); for (iq = 1; iq < 4; iq++) shW.lineTo(pts[iq][0], pts[iq][1]); shW.lineTo(pts[0][0], pts[0][1]);
          if (drW) {
            var gW = new T.ExtrudeGeometry(shW, { depth: zb4 - za4 - 0.004, bevelEnabled: false });
            gW.translate(0, 0, za4 + 0.002); g.add(new T.Mesh(gW, mat));
          }
          return ((t1 - t0) + (u1 - u0)) / 2 * (zb4 - za4);
        };
        var woolPiece = function (sd4, a4, b4, za4, zb4) {
          _am(ctx, 'layer_rafter_wool', 'Mineral wool', (WS.mix[0] && WS.mix[0].code) || '', 'in'); var aP = bayPiece(sd4, a4, b4, za4, zb4, oW + WS.t, oW, wMat);
          if (aP > 0) nPcS++;
          if (!hyb4) { _am(ctx, 'eave_baffle', 'Vent baffle', VENT.baffle, 'in'); baffleA += bayPiece(sd4, a4, b4, za4, zb4, oB1, oB0, vMat); }
          return aP;
        };
        var kW0 = g.children.length;
        for (sd = -1; sd <= 1 && slopeOn; sd += 2) {
          var zm = [], iz;
          for (iz = 1; iz <= n4 - 1; iz++) if (RW.lines[iz] > B.z0 - 0.001 && RW.lines[iz] < B.z1 + 0.001) zm.push(RW.lines[iz]);
          for (iz = 0; iz < RW.sisters.length; iz++) if (RW.sisters[iz].side === sd) zm.push(RW.sisters[iz].z);
          zm.sort(function (a, b) { return a - b; });
          for (iz = 0; iz + 1 < zm.length; iz++) {
            var za = zm[iz] + tt4 / 2, zb = zm[iz + 1] - tt4 / 2;
            if (zb - za < 0.03) continue;
            nBayS++;
            var cutS = [], wq4;
            for (wq4 = 0; wq4 < RW.wins.length; wq4++) { var W4 = RW.wins[wq4]; if (W4.side === sd && W4.z > za && W4.z < zb) cutS.push([W4.sT - tt4, W4.sB + tt4]); }
            _wingSides().forEach(function (ws) { if (ws !== sd) return; var WB = _wingBeam(ws); if ((za + zb) / 2 > WB.zIa && (za + zb) / 2 < WB.zIb) cutS.push([WB.dB / S.cos, 99]);
              var DM = _dormer(ws); if (DM && DM.bays.some(function (b) { return (za + zb) / 2 > b[0] && (za + zb) / 2 < b[1]; })) cutS.push([DM.sTop - 0.05, 99]); });
            /* the bay split along z at the joist ends in it: the strip beside the rafter where a joist stands gets the joist bands cut too */
            var zc4 = [za, zb], jIn = [], jq5;
            for (jq5 = 0; jq5 < jEnds.length; jq5++) if (jEnds[jq5].z - tJ4 / 2 > za - 0.001 && jEnds[jq5].z + tJ4 / 2 < zb + 0.001) jIn.push(jEnds[jq5]);
            for (jq5 = 0; jq5 < jIn.length; jq5++) { zc4.push(Math.max(za, jIn[jq5].z - tJ4 / 2)); zc4.push(Math.min(zb, jIn[jq5].z + tJ4 / 2)); }
            zc4.sort(function (a, b) { return a - b; });
            var pz4;
            for (pz4 = 0; pz4 + 1 < zc4.length; pz4++) {
              var pa = zc4[pz4], pb = zc4[pz4 + 1]; if (pb - pa < 0.005) continue;
              var cuts4 = cutS.slice(), zmid = (pa + pb) / 2;
              for (jq5 = 0; jq5 < jIn.length; jq5++) if (Math.abs(jIn[jq5].z - zmid) < tJ4 / 2 - 0.001) { cuts4.push([jIn[jq5].s0, jIn[jq5].s1]); aJoistOut += (jIn[jq5].s1 - jIn[jq5].s0) * (pb - pa); }
              var runs4 = [[-1, sTop1 + 1]], c4, r4;
              for (c4 = 0; c4 < cuts4.length; c4++) {
                var nx4 = [];
                for (r4 = 0; r4 < runs4.length; r4++) {
                  if (cuts4[c4][1] <= runs4[r4][0] || cuts4[c4][0] >= runs4[r4][1]) { nx4.push(runs4[r4]); continue; }
                  if (cuts4[c4][0] > runs4[r4][0]) nx4.push([runs4[r4][0], cuts4[c4][0]]);
                  if (cuts4[c4][1] < runs4[r4][1]) nx4.push([cuts4[c4][1], runs4[r4][1]]);
                }
                runs4 = nx4;
              }
              for (r4 = 0; r4 < runs4.length; r4++) aWs += woolPiece(sd, runs4[r4][0], runs4[r4][1], pa, pb);
            }
          }
        }
        SLR.push({ k0: kW0, k1: g.children.length, ph: 'wool', baffle: vMat });
        /* THE GABLES (aframe-v44, Marek: defekty v izolaci ve stitu): the wool
           is what is left of the gable's inside once every member is taken
           out -- studs and their pieces, jacks, headers from king to king,
           sills, blocking rows, the units -- cut into cells on the members'
           edges, the cells stacked into columns, and each column clipped by
           the raked plates' underside, so it runs into the corner under the
           rake instead of stopping square short of it */
        _am(ctx, 'layer_studs_wool', 'Mineral wool', (WG.mix[0] && WG.mix[0].code) || '', 'side');
        var G4 = _gGeo(), tG = GABLE.t, aWg = 0, gNote = [], eg;
        var A4 = G4.yPlate(G4.cx);
        var clipTent = function (poly) {
          var lines = [[S.tan, A4 - S.tan * G4.cx], [-S.tan, A4 + S.tan * G4.cx]], li, out = poly;
          for (li = 0; li < 2; li++) {
            var m = lines[li][0], c = lines[li][1], inp = out, k2;
            out = [];
            var inside = function (P) { return P[1] <= m * P[0] + c + 1e-9; };
            for (k2 = 0; k2 < inp.length; k2++) {
              var P = inp[k2], Q = inp[(k2 + 1) % inp.length], iP = inside(P), iQ = inside(Q);
              if (iP) out.push(P);
              if (iP !== iQ) {
                var fP = P[1] - (m * P[0] + c), fQ = Q[1] - (m * Q[0] + c), tq = fP / (fP - fQ);
                out.push([P[0] + tq * (Q[0] - P[0]), P[1] + tq * (Q[1] - P[1])]);
              }
            }
            if (out.length < 3) return [];
          }
          return out;
        };
        var kGw0 = g.children.length;
        for (eg = 0; eg < 2; eg++) {
          var M4 = _gMem[eg], sideG = eg ? 'back' : 'front';
          if (!M4) { gNote.push(sideG + ': the frame was not built (REVIEW), no wool'); continue; }
          if (M4.full) { gNote.push(sideG + ': full glazing, no wool'); continue; }
          var capY = (M4.yBand != null) ? M4.yBand : A4, y04 = G4.yStud0, xE0 = G4.cx - G4.xIn, xE1 = G4.cx + G4.xIn, vg, aE = 0, nPcG = 0;
          /* every solid piece in the gable's plane, as a rectangle */
          var RR = [];
          for (vg = 0; vg < M4.verts.length; vg++) { var VV = M4.verts[vg]; RR.push([VV.x - tG / 2, VV.x + tG / 2, VV.y0, (Math.abs(VV.y1 - G4.yPlate(VV.x)) < 0.01) ? Math.max(VV.y1, G4.yPlate(VV.x - tG / 2), G4.yPlate(VV.x + tG / 2)) : VV.y1]); }
          for (vg = 0; vg < (M4.hdrs || []).length; vg++) RR.push([M4.hdrs[vg].x0, M4.hdrs[vg].x1, M4.hdrs[vg].y0, M4.hdrs[vg].y1]);
          for (vg = 0; vg < M4.rows.length; vg++) RR.push([xE0 - 1, xE1 + 1, M4.rows[vg] - tG / 2, M4.rows[vg] + tG / 2]);
          if (M4.ru && M4.ru.half) M4.ru.rects.forEach(function (R) { RR.push([R[0], R[1], R[2], (R[3] >= M4.ru.apex - 1e-6) ? M4.ru.apex + 1 : R[3]]); });
          for (vg = 0; vg < M4.holes.length; vg++) { var H4 = M4.holes[vg]; RR.push([Math.min(H4.x0, H4.x1), Math.max(H4.x0, H4.x1), H4.y0, H4.y1]); }
          var xsC = [xE0, xE1, G4.cx], ysC = [y04, capY], rq4;
          for (rq4 = 0; rq4 < RR.length; rq4++) { xsC.push(RR[rq4][0], RR[rq4][1]); ysC.push(RR[rq4][2], RR[rq4][3]); }
          var uniq = function (A, a, b) { A = A.filter(function (v) { return v >= a - 1e-6 && v <= b + 1e-6; }).sort(function (p, q) { return p - q; }); var o = [], i2; for (i2 = 0; i2 < A.length; i2++) if (!o.length || A[i2] - o[o.length - 1] > 0.001) o.push(A[i2]); return o; };
          xsC = uniq(xsC, xE0, xE1); ysC = uniq(ysC, y04, capY);
          var solid = function (x, y) { var r5; for (r5 = 0; r5 < RR.length; r5++) if (x > RR[r5][0] && x < RR[r5][1] && y > RR[r5][2] && y < RR[r5][3]) return true; return false; };
          /* the free runs up each column, then the neighbouring columns with the same runs taken as one piece */
          var cols = [], ix, iy;
          for (ix = 0; ix + 1 < xsC.length; ix++) {
            var xa4 = xsC[ix], xb4 = xsC[ix + 1], xm4 = (xa4 + xb4) / 2, runLo = null, runs5 = [];
            for (iy = 0; iy + 1 <= ysC.length; iy++) {
              var free = (iy + 1 < ysC.length) && !solid(xm4, (ysC[iy] + ysC[iy + 1]) / 2);
              if (free && runLo == null) runLo = ysC[iy];
              if (!free && runLo != null) { runs5.push([runLo, ysC[iy]]); runLo = null; }
            }
            var key = runs5.map(function (r6) { return r6[0].toFixed(4) + ':' + r6[1].toFixed(4); }).join('|');
            if (cols.length && cols[cols.length - 1].key === key && Math.abs(cols[cols.length - 1].x1 - xa4) < 1e-6) cols[cols.length - 1].x1 = xb4;
            else cols.push({ x0: xa4, x1: xb4, key: key, runs: runs5 });
          }
          for (ix = 0; ix < cols.length; ix++) {
            var CL = cols[ix];
            for (iy = 0; iy < CL.runs.length; iy++) {
              var polyG = clipTent([[CL.x0, CL.runs[iy][0]], [CL.x1, CL.runs[iy][0]], [CL.x1, CL.runs[iy][1]], [CL.x0, CL.runs[iy][1]]]);
              if (polyG.length < 3) continue;
              var ar = 0, ip;
              for (ip = 0; ip < polyG.length; ip++) { var p1 = polyG[ip], p2 = polyG[(ip + 1) % polyG.length]; ar += p1[0] * p2[1] - p2[0] * p1[1]; }
              ar = Math.abs(ar) / 2;
              if (ar < 0.0005) continue;
              if (drW) {
                var shG4 = new T.Shape(); shG4.moveTo(polyG[0][0], polyG[0][1]);
                for (ip = 1; ip < polyG.length; ip++) shG4.lineTo(polyG[ip][0], polyG[ip][1]);
                shG4.lineTo(polyG[0][0], polyG[0][1]);
                var gG4 = new T.ExtrudeGeometry(shG4, { depth: GABLE.d - 0.004, bevelEnabled: false });
                gG4.translate(0, 0, M4.z - GABLE.d / 2 + 0.002); g.add(new T.Mesh(gG4, wMat));
              }
              aE += ar; nPcG++;
            }
          }
          aWg += aE;
          gNote.push(sideG + ': ' + aE.toFixed(2) + ' m2 in ' + nPcG + ' piece(s) round ' + RR.length + ' member(s) / unit(s) / row(s), run into the corners under the rake' + (M4.yBand != null ? ', stopped under the half glazing' : ''));
        }
        GLR.push({ k0: kGw0, k1: g.children.length, ph: 'wool' });
        var bayW = Math.max(0.30, (RW.lines.length > 4 ? (RW.lines[3] - RW.lines[2]) : 0.6) - tt4);
        baffleL = baffleA / bayW;          /* by the metre of bay: the baffle is one bay wide */
        var q4, wBill = [], eaveL = 2 * (B.z1 - B.z0);
        if (slopeOn && !hyb4) {
          API.billAdd('aframe-lining', VENT.baffle, baffleL * 1.05);
          API.billAdd('aframe-lining', VENT.strip, eaveL * 1.05);
          wBill.push(VENT.baffle + ' ' + (baffleL * 1.05).toFixed(1) + ' m', VENT.strip + ' ' + (eaveL * 1.05).toFixed(1) + ' m');
        }
        for (q4 = 0; q4 < WS.mix.length; q4++) { API.billAdd('aframe-lining', WS.mix[q4].code, aWs * WS.mix[q4].n * 1.05); wBill.push(WS.mix[q4].code + ' ' + (aWs * WS.mix[q4].n * 1.05).toFixed(2) + ' m2'); }
        for (q4 = 0; q4 < WG.mix.length; q4++) { API.billAdd('aframe-lining', WG.mix[q4].code, aWg * WG.mix[q4].n * 1.05); wBill.push(WG.mix[q4].code + ' ' + (aWg * WG.mix[q4].n * 1.05).toFixed(2) + ' m2'); }
        if (slopeOn && hyb4) ctx.log('layer 4  NO vent channel under the deck (the hybrid, aframe-v157): the PIR ' + Math.round(HY4.t * 1000) + ' lies on the deck, the roof is vented over it in the counter battens (insect comb at the eaves, billed with the skin); the wool fills the rafters');
        if (slopeOn && !hyb4) ctx.log('layer 4  vent channel in every rafter bay: ' + Math.round(VENT.gap * 1000) + ' clear under the deck, held by a vent baffle ' + VENT.baffle + ' ' + Math.round(VENT.baffleT * 1000) + ' thick' + (LAYER_STEP === 4 ? ' (MAGENTA)' : '') + ', ' + baffleL.toFixed(1) + ' m of bay from the eave to the ridge; air in at the eaves through ' + VENT.strip + ' ' + eaveL.toFixed(1) + ' m, out at the ridge vent (the skin\'s)');
        ctx.log('layer 4  mineral wool on the slopes: rafters ' + Math.round(R.d * 1000) + ' deep, ' + (hyb4 ? 'filled full' : (Math.round((R.d - VENT.gap - VENT.baffleT) * 1000) + ' under the baffle')) + ' -> ' + _woolTxt(WS) + ' (' + Math.round(WS.t * 1000) + '), ' + nBayS + ' bay(s) between the rafters and the doubled ones, ' + nPcS + ' piece(s), ' + aWs.toFixed(2) + ' m2 from the ridge to the plate; ' + RW.wins.length + ' roof window(s) and their blocks left out, ' + jEnds.length + ' joist(s) with an end in each slope (' + aJoistOut.toFixed(2) + ' m2 both slopes) left out' + (drW ? '' : ' -- NOT DRAWN'));
        ctx.log('layer 4  mineral wool in the gables: studs ' + Math.round(GABLE.d * 1000) + ' deep -> ' + _woolTxt(WG) + '; ' + gNote.join('; '));
        ctx.log('layer 4  BILL ' + wBill.join(', ') + ' (+5% cuts; each layer of a mix billed on its own); held by friction, the barrier and the battens -- no fixings; the slopes vented in the bay over the wool, the gables in the rainscreen');
      }
      var aAll = aSlope + aGable, WBL = Math.min(aAll, _wetBoardAreas().lining);
      API.billAdd('aframe-lining', BD.code, (aAll - WBL) * BD.waste);
      if (WBL > 0.01) {
        API.billAdd('aframe-lining', WET_BOARD, WBL * BD.waste);
        ctx.log('WET  board lining (aframe-v144): ' + WBL.toFixed(2) + ' m2 of the slopes\' and the gables\' board bound a wet room -- ' + WET_BOARD + ' ' + (WBL * BD.waste).toFixed(2) + ' m2 (+10%) instead of ' + BD.code + ' (drawn in the Walls colour, painted)');
      }
      API.billAdd('aframe-lining', BD.screw, Math.round(aAll * BD.screwPerM2));
      _chemBill('aframe-lining', aAll, 0, 0); _chemNote(ctx, 'lining board', aAll, 0, 0);
      if (caseG.len > 0.01) {
        API.billAdd('aframe-lining', CASE.code, Math.round(caseG.len * 1.05 * 100) / 100);
        API.billAdd('aframe-lining', CASE.nail, CASE.rows * Math.ceil(caseG.len / CASE.step));
        ctx.log('trim     gables (aframe-v144): ' + caseG.n + ' unit(s) cased inside on the lining -- ' + caseG.doors + ' door(s) on three sides, ' + caseG.wins + ' window(s) round all four (the bottom one is the apron under the inner sill OWW00001), ' + Math.round(_caseW() * 1000) + ' x ' + Math.round(_caseT() * 1000) + ': ' + caseG.len.toFixed(2) + ' m, BILL ' + CASE.code + ' ' + (caseG.len * 1.05).toFixed(2) + ' m (+5% mitres), ' + (CASE.rows * Math.ceil(caseG.len / CASE.step)) + ' x ' + CASE.nail + ' (two rows every 12 in.); a full or half glazed gable has its own frame' + ((TRIM_REVIEW && _isAdmin()) ? ' -- MAGENTA (under review)' : ''));
      } else ctx.log('trim     gables (aframe-v144): no window or door in a lined gable -- no casing');
      API.billAdd('aframe-lining', BD.tape, Math.round(aAll / 2.88 * 3.6 * 10) / 10);
      API.billAdd('aframe-lining', BD.filler, Math.round(aAll * BD.fillerKgM2 * 10) / 10);
      /* THE SLOPES' INNER LAYERS UNDER REVIEW (aframe-v147, plan F): the step magenta, the ones under it in their colours, the rest left to the review's strip */
      if (slopeOn && _isAdmin() && AF_STEP.slope < 99) {
        var stL = AF_STEP.slope, nMl = 0, nUl = 0, nAl = 0, SDl = _slopeDefs();
        SLR.forEach(function (r) {
          var q9;
          for (q9 = r.k0; q9 < r.k1; q9++) {
            var o9 = g.children[q9]; if (!o9) continue;
            var ix9 = _slopeIdx((r.ph === 'wool' && o9.material === r.baffle) ? 'baffle' : r.ph, SDl);
            if (!ix9 || ix9 > stL) { nAl++; continue; }
            o9.userData.afReview = true;
            if (ix9 === stL) { nMl++; o9.traverse(function (m) { if (m.isMesh && m.material) { var mm9 = (Array.isArray(m.material) ? m.material[0] : m.material).clone(); mm9.map = null; mm9.color = new T.Color(MAGENTA); m.material = mm9; } }); }
            else nUl++;
          }
        });
        ctx.log('layer    review slope step ' + stL + ' of ' + _slopeLayers().length + ' (' + (_slopeLayers()[stL - 1] || '?') + '): ' + nMl + ' slope bod(ies) MAGENTA, ' + nUl + ' under it in their colours, ' + nAl + ' over it hidden (billed); the gables\' lining hidden (their own build-up)');
      }
      /* THE GABLES' INNER LAYERS UNDER REVIEW (aframe-v148, plan G): steps 7-11 of the gables' build-up */
      if (_isAdmin() && AF_STEP.gable < 99) {
        var nGl = { rv: 0, un: 0, ab: 0 }, GDl = _gableDefs();
        GLR.forEach(function (r) {
          var nn = _rvTagList(T, g.children.slice(r.k0, r.k1), function (o) { return (r.ph === 'board') ? (_asmKey(o) === 'casing' ? 'case' : 'board') : r.ph; }, GDl, AF_STEP.gable);
          nGl.rv += nn.rv; nGl.un += nn.un; nGl.ab += nn.ab;
        });
        ctx.log(_gableRvNote('layer    ', nGl) + ' -- the gables\' wool, barrier, service battens, gypsum and casings; the slopes\' lining hidden');
      }
      ctx.log('layer    step ' + LAYER_STEP + ' under review (magenta): 1 gypsum board' + (LAYER_STEP === 1 ? ' <- this one' : '') + ' | 2 service battens' + (LAYER_STEP === 2 ? ' <- this one' : '') + ' | 3 vapour barrier' + (LAYER_STEP === 3 ? ' <- this one' : '') + ' | 4 mineral wool' + (LAYER_STEP === 4 ? ' <- this one' : '') + ' -- outer layers not drawn');
      if (colB == null) ctx.log('layer 1  the board is NOT DRAWN while layer ' + LAYER_STEP + ' is under review (LAYER_SHOW_INNER) -- it is billed below');
      ctx.log('layer 1  gypsum board ' + BD.code + ' 12.5 on the room side, ' + Math.round((R.d + LINE.batt) * 1000) + ' in from the rafters\' top face (rafter ' + Math.round(R.d * 1000) + ' + battens ' + Math.round(LINE.batt * 1000) + '): slopes ' + aSlope.toFixed(2) + ' m2 (' + spans.length + ' band(s) a slope between the floor zones, ' + RW.wins.length + ' roof window(s) cut out), gables ' + aGable.toFixed(2) + ' m2 (units cut out); the ceilings under the floors are the upper floors\' layer 5 (ufloor)');
      ctx.log('layer 1  BILL '  + BD.code + ' ' + (aAll * BD.waste).toFixed(2) + ' m2 (' + aAll.toFixed(2) + ' + 10% for the cuts on the slopes); ' + Math.round(aAll * BD.screwPerM2) + ' x ' + BD.screw + ' (20/m2), tape ' + BD.tape + ' ' + (Math.round(aAll / 2.88 * 3.6 * 10) / 10) + ' m, compound ' + BD.filler + ' ' + (Math.round(aAll * BD.fillerKgM2 * 10) / 10) + ' kg (the ADU ceiling rule)');
    }
    /* -------------------------------------------------------------------------
       THE PARTITIONS (aframe-v83, Marek: nestavi se pricky; dreveny profil,
       vypln kvuli akustice a sdk desky). The ADU's partition, adapted to the
       A: studs 60 x 100 (KVH10060) every 600 on a sole plate and under a top
       plate, acoustic wool 60 (INS00601) in the bays, 12.5 gypsum board
       (WDD24001) both faces, screwed, taped and filled at the ceiling's rates.
       Each stands on the floor of its storey and reaches the ceiling under the
       floor above -- or, where the slopes come lower, the slope lining: a
       partition across the A is a gable shape, cut to the lining on both
       sides; one along the ridge is as high as the lining lets it be where it
       stands. A doorway (the plan's doors on that partition) is left open
       under a doubled header at 2000; its leaf is not built yet.
       ------------------------------------------------------------------------- */
    var PARTA = { t: 0.060, d: 0.100, code: 'KVH10060', sp: 0.60, doorH: 2.00, hdr: 0.12 };
    var PWOOL = { code: 'INS00601', t: 0.060, col: 0xE8D9A0 };
    function _aDoorSet(T, g, vert, pAt, lo, hole, dh, y0, ctx) {
      var mat = new T.MeshStandardMaterial({ color: 0xF4F3F0, roughness: 0.55, metalness: 0.0 });
      var dw = hole.a1 - hole.a0, jamb = 0.03, leafT = 0.042, aCtr = (hole.a0 + hole.a1) / 2;
      var at3 = function (along) { return vert ? { x: pAt, z: lo + along } : { x: lo + along, z: pAt }; };
      var lining = function (w, h, d, along, y) { var m = new T.Mesh(new T.BoxGeometry(w, h, d), mat), q = at3(along); m.position.set(q.x, y, q.z); if (!vert) m.rotation.y = Math.PI / 2; g.add(m); };
      var dep = PARTA.d + 2 * LINE.board.t + 0.01;
      lining(dep, dh, jamb, hole.a0 + jamb / 2, y0 + dh / 2);
      lining(dep, dh, jamb, hole.a1 - jamb / 2, y0 + dh / 2);
      lining(dep, jamb, dw, aCtr, y0 + dh - jamb / 2);
      /* THE CASING ON BOTH FACES (aframe-v144, barndo-v26): two legs and a head over them */
      if (_aCase) {
        var cw = _caseW(), ct = _caseT(), cOff = PARTA.d / 2 + LINE.board.t + ct / 2, mCs = _trimMat(T, CASE.col), sgC;
        /* the casings walk as casings, not with the door (aframe-v152): their own item, the door's put back after them */
        var itD = ctx ? ctx.item : null; if (ctx) _am(ctx, 'casing', 'Casing', CASE.code, 'side');
        var casing = function (len, h, along, y, sgn) {
          var m = new T.Mesh(new T.BoxGeometry(ct, h, len), mCs), q = at3(along);
          if (vert) m.position.set(q.x + sgn * cOff, y, q.z); else { m.position.set(q.x, y, q.z + sgn * cOff); m.rotation.y = Math.PI / 2; }
          m.userData.afCase = true; g.add(m);
        };
        for (sgC = -1; sgC <= 1; sgC += 2) {
          casing(cw, dh, hole.a0 - cw / 2, y0 + dh / 2, sgC);
          casing(cw, dh, hole.a1 + cw / 2, y0 + dh / 2, sgC);
          casing(dw + 2 * cw, cw, aCtr, y0 + dh + cw / 2, sgC);
        }
        _aCase.len += 2 * (2 * dh + dw + 2 * cw); _aCase.n++;
        if (ctx) ctx.item = itD;
      }
      if (hole.pass) return;
      if (hole.slide) {
        var park = 0.70, face = PARTA.d / 2 + LINE.board.t + leafT / 2 + 0.004, sh = dh - jamb;
        /* ACROSS THE WALL IS LOCAL X, ALONG IT LOCAL Z (aframe-v161, the ADU's adu-v1431 fix, copied): the box was
           (wid, sh, leafT), so every sliding leaf stood square to its wall like a fin */
        var slab = function (wid, alongCtr, offSide) {
          var g2 = new T.Mesh(new T.BoxGeometry(leafT, sh, wid), mat), q2 = at3(alongCtr), nOff = offSide * face;
          g2.position.set(q2.x + (vert ? nOff : 0), y0 + sh / 2, q2.z + (vert ? 0 : nOff)); if (!vert) g2.rotation.y = Math.PI / 2; g.add(g2);
          return g2;
        };
        /* along the wall in the group's coordinates: z on a 'v' wall, x on an 'h' one (the ADU's) */
        var auX = vert ? 0 : 1, auZ = vert ? 1 : 0;
        if (hole.slide === 3) {
          var hw = dw / 2, sA = slab(hw, aCtr - dw / 4 - park * hw, +1), sB = slab(hw, aCtr + dw / 4 + park * hw, -1);
          if (_arSlide(sA, -auX, -auZ, park * hw, hw * 0.95)) _arCount('slide', 'interior');
          if (_arSlide(sB, auX, auZ, park * hw, hw * 0.95)) _arCount('slide', 'interior');
        } else {
          var dirS = (hole.slide === 2) ? 1 : -1, sC = slab(dw, aCtr + dirS * park * dw, +1);
          if (_arSlide(sC, dirS * auX, dirS * auZ, park * dw, dw * 0.95)) _arCount('slide', 'interior');
        }
        return;
      }
      var open = 0.52, right = (hole.sw & 1) === 1, side = (hole.sw & 2) ? -1 : 1, lw = dw - jamb * 2;
      if (lw < 0.30) return;
      var geo = new T.BoxGeometry(lw, dh - jamb, leafT); geo.translate(lw / 2, 0, 0);
      var leaf = new T.Mesh(geo, mat), q0 = at3(right ? (hole.a1 - jamb) : (hole.a0 + jamb));
      leaf.position.set(q0.x, y0 + (dh - jamb) / 2, q0.z);
      var theta;
      if (vert) theta = right ? (Math.PI / 2 - side * open) : (-Math.PI / 2 + side * open);
      else theta = right ? (Math.PI - side * open) : (side * open);
      leaf.rotation.y = theta;
      /* THE HANDLE ON BOTH FACES (aframe-v152): the billed handle set ODD00001, a lever at 1050 by the leaf's free edge */
      var hdl = new T.Mesh(new T.BoxGeometry(0.12, 0.02, leafT + 0.10), new T.MeshStandardMaterial({ color: 0xB9BCBF, roughness: 0.35, metalness: 0.7 }));
      hdl.position.set(lw - 0.07, 1.05 - (dh - jamb) / 2, 0);
      if (ctx) { var itH = ctx.item; _am(ctx, 'interior_doors', 'Handle set', 'ODD00001', 'side'); hdl.userData.asm = ctx.item; ctx.item = itH; }
      leaf.add(hdl); g.add(leaf);
      /* shut it is theta less the open, and every case above adds the open with the sign right ? -side : side -- the turn that opens it (the ADU's, copied, aframe-v161) */
      leaf.userData.arLeaf = { type: 'swing', hinge: [q0.x, 0, q0.z], dir: right ? -side : side, ajar: open, max: 1.45 }; _arCount('swing', 'interior');
      if (_aCase) _aCase.handles = (_aCase.handles || 0) + 1;
    }
    var _aCase = null;
    function _buildPartitions(ctx) {
      var T = ctx.THREE, g = ctx.group;
      _bill['aframe-partitions'] = {};
      _aCase = { len: 0, n: 0 };
      var parts = STATE.parts || [], fl = floors(), S = _sect(), B = _barRect(), cx = (B.x0 + B.x1) / 2, BD = LINE.board;
      try { if (API.setPartThickness) API.setPartThickness(PARTA.d); } catch (eSp) {}
      if (_wpNote) ctx.log(_wpNote);
      if (!parts.length) { ctx.log('parts    none -- draw one on the Floorplan step'); return; }
      var linT = LINE.vb + LINE.batt + BD.t;
      var yIn = function (x) { return S.top + S.tan * (S.half - (S.rafD + linT) / S.sin - Math.abs(x - cx)); };
      var bdCol = BD.col; try { if (API.colorSlotOf) { var cs = API.colorSlotOf('ceiling'); if (cs != null) bdCol = cs; } } catch (eCs) {}
      var mW = new T.MeshStandardMaterial({ color: WOOD, roughness: 0.85 }), mWool = new T.MeshStandardMaterial({ color: PWOOL.col, roughness: 1 }), mB = new T.MeshStandardMaterial({ color: bdCol, roughness: 0.92 });
      /* the two faces apart (aframe-v152): one is boarded before the wool goes in, the other after -- two steps of the review */
      var mB2 = new T.MeshStandardMaterial({ color: bdCol, roughness: 0.92 }), kP0 = g.children.length;
      var zIn0 = B.z0 + GABLE.d + linT, zIn1 = B.z1 - GABLE.d - linT;
      var amP = function (m) {
        if (m === mW) _am(ctx, 'partition_frame', 'Partition frame', PARTA.code, 'side');
        else if (m === mWool) _am(ctx, 'partition_wool', 'Partition wool', PWOOL.code, 'side');
        else if (m === mB || m === mB2) _am(ctx, 'layer_plasterboard', 'Plasterboard', BD.code, 'side');
      };
      var tl = { walls: 0, timber: 0, studs: 0, wool: 0, board: 0, doors: 0, sole: 0, soleSlab: 0 }, notes = [], i;
      for (i = 0; i < parts.length; i++) {
        var p = parts[i]; if (!p) continue;
        var st = (typeof p.st === 'number') ? (p.st | 0) : 0;
        if (st >= fl.length) { notes.push('#' + p.id + ' on storey ' + (st + 1) + ' which the A does not have -- skipped'); continue; }
        if (p.cutOn && p.cutOn.indexOf(st) >= 0) continue;
        var vert = ((p.dir || p.o) === 'v'), at = (typeof p.at === 'number') ? p.at : p.c;
        var y0 = fl[st].y, yCeil = (st + 1 < fl.length) ? (fl[st + 1].y - FLOOR.deck.t - FLOOR.joist.d - LINE.batt - BD.t) : 1e9;
        /* a piece of the wing's partition stands under the wing's beam (aframe-v109) */
        var wSd = _wingPartOf(p.id), wBot = null;
        if (wSd && st === 0) { try { wBot = _wingBeam(wSd).bot; } catch (eWb) { wBot = null; } }
        var spn = null; try { spn = API.partSpan ? API.partSpan(p) : null; } catch (eS) { spn = null; }
        if (!(spn && typeof spn[0] === 'number' && typeof spn[1] === 'number')) spn = null;
        var lo = spn ? spn[0] : Math.min(p.a, p.b), hi = spn ? spn[1] : Math.max(p.a, p.b);
        if (vert) {
          lo = Math.max(lo, zIn0); hi = Math.min(hi, zIn1);
          if (wBot == null && yIn(at) - y0 < 0.60) { notes.push('#' + p.id + ' v@' + Math.round((at - cx) * 1000) + ' SKIPPED -- under the slope there is ' + Math.round((yIn(at) - y0) * 1000) + ' of height'); continue; }
        } else {
          var aMax = S.half - (S.rafD + linT) / S.sin - (y0 + 0.30 - S.top) / S.tan;   /* |x - cx| where 300 of height is left */
          lo = Math.max(lo, cx - aMax); hi = Math.min(hi, cx + aMax);
        }
        var len = hi - lo;
        if (len < 0.30) { notes.push('#' + p.id + ' ' + (vert ? 'v' : 'h') + '@' + Math.round(at * 1000) + ' SKIPPED -- ' + Math.round(len * 1000) + ' left inside the storey'); continue; }
        /* the partition's top along it, and the corners of that line */
        var xOfU = function (u) { return vert ? at : lo + u; };
        var topAt = function (u) { return (wBot != null) ? wBot : Math.min(yCeil, yIn(xOfU(u))); };
        var brk = function (ua, ub) {
          var cand = [ua, ub], out = [], q;
          if (!vert) {
            var uC = cx - lo; cand.push(uC);
            if (yCeil < 1e8) { var aC = S.half - (S.rafD + linT) / S.sin - (yCeil - S.top) / S.tan; cand.push(cx - aC - lo, cx + aC - lo); }
          }
          cand = cand.filter(function (u) { return u >= ua - 1e-9 && u <= ub + 1e-9; }).sort(function (a, b) { return a - b; });
          for (q = 0; q < cand.length; q++) if (!out.length || cand[q] - out[out.length - 1] > 1e-4) out.push(cand[q]);
          return out;
        };
        /* a flat piece in the partition's plane between ua..ub, from yLo up to the top less dTop, dd thick, off the centre line */
        var slab = function (ua, ub, yLo, dTop, dd, off, m) {
          var us = brk(ua, ub), sh = new T.Shape(), q;
          if (us.length < 2) return 0;
          var ptsT = us.map(function (u) { return [u, Math.max(yLo, topAt(u) - dTop)]; });
          sh.moveTo(ua, yLo); sh.lineTo(ub, yLo);
          for (q = ptsT.length - 1; q >= 0; q--) sh.lineTo(ptsT[q][0], ptsT[q][1]);
          sh.lineTo(ua, yLo);
          var gE = new T.ExtrudeGeometry(sh, { depth: dd, bevelEnabled: false }); gE.translate(0, 0, -dd / 2 + off);
          var ms = new T.Mesh(gE, m);
          if (vert) { ms.rotation.y = -Math.PI / 2; ms.position.set(at, 0, lo); } else ms.position.set(lo, 0, at);
          amP(m); g.add(ms);
          var a = 0; for (q = 0; q + 1 < ptsT.length; q++) a += ((ptsT[q][1] - yLo) + (ptsT[q + 1][1] - yLo)) / 2 * (ptsT[q + 1][0] - ptsT[q][0]);
          return a;
        };
        var box = function (u, w, y, h, m) {
          var ms = new T.Mesh(new T.BoxGeometry(vert ? PARTA.d : w, h, vert ? w : PARTA.d), m);
          ms.position.set(vert ? at : lo + u, y, vert ? lo + u : at); amP(m); g.add(ms);
        };
        /* the doorways on it */
        var holes = [], dRec = [], ds = STATE.doors || [], dq;
        for (dq = 0; dq < ds.length; dq++) {
          var d = ds[dq]; if (!d || d.pid !== p.id) continue;
          var dw = d.w || 0.80, a0 = (d.u != null ? d.u : (d.at != null ? d.at : d.c)) - dw / 2 - lo, a1 = a0 + dw;
          if (a1 <= 0.05 || a0 >= len - 0.05) continue;
          holes.push([Math.max(0, a0 - PARTA.t), Math.min(len, a1 + PARTA.t)]);
          dRec.push({ a0: Math.max(0, a0), a1: Math.min(len, a1), pass: !!d.pass, sw: (d.sw | 0), slide: (d.slide | 0), w: dw, hand: (d.sw | 0) ? 'L' : 'R' });
        }
        holes.sort(function (a, b) { return a[0] - b[0]; });
        var inHole = function (u) { for (var h = 0; h < holes.length; h++) if (u > holes[h][0] + 0.001 && u < holes[h][1] - 0.001) return true; return false; };
        var runs = [], cur = 0, hq;
        for (hq = 0; hq < holes.length; hq++) { if (holes[hq][0] > cur + 0.02) runs.push([cur, holes[hq][0]]); cur = Math.max(cur, holes[hq][1]); }
        if (len - cur > 0.02) runs.push([cur, len]);
        /* sole plate on the runs, top plate along the whole top line */
        var rq;
        for (rq = 0; rq < runs.length; rq++) { box((runs[rq][0] + runs[rq][1]) / 2, runs[rq][1] - runs[rq][0], y0 + PARTA.t / 2, PARTA.t, mW); tl.timber += runs[rq][1] - runs[rq][0]; tl.sole += runs[rq][1] - runs[rq][0]; if (st === 0 && STATE.foundation === 'strips') tl.soleSlab += runs[rq][1] - runs[rq][0]; }
        var tops = brk(0, len), topLen = 0;
        for (rq = 0; rq + 1 < tops.length; rq++) topLen += Math.hypot(tops[rq + 1] - tops[rq], topAt(tops[rq + 1]) - topAt(tops[rq]));
        (function () {
          var us = brk(0, len), sh = new T.Shape(), q;
          sh.moveTo(us[0], topAt(us[0]));
          for (q = 1; q < us.length; q++) sh.lineTo(us[q], topAt(us[q]));
          for (q = us.length - 1; q >= 0; q--) sh.lineTo(us[q], topAt(us[q]) - PARTA.t);
          sh.lineTo(us[0], topAt(us[0]));
          var gT = new T.ExtrudeGeometry(sh, { depth: PARTA.d, bevelEnabled: false }); gT.translate(0, 0, -PARTA.d / 2);
          var mT = new T.Mesh(gT, mW);
          if (vert) { mT.rotation.y = -Math.PI / 2; mT.position.set(at, 0, lo); } else mT.position.set(lo, 0, at);
          amP(mW); g.add(mT);
        })();
        tl.timber += topLen;
        /* studs every 600 from the start, at both ends and both sides of every doorway */
        var sus = [PARTA.t / 2, len - PARTA.t / 2], k;
        /* in the wing's partition a post under the beam stands at a joint: no end stud there, the post is it (aframe-v118) */
        if (wSd && vert) { var zPo9 = []; try { zPo9 = _wingPosts(wSd); } catch (eP9) { zPo9 = []; } var nS0 = sus.length; sus = sus.filter(function (u) { return !zPo9.some(function (zp) { return Math.abs(lo + u - zp) < 0.09; }); }); tl.postEnds = (tl.postEnds || 0) + nS0 - sus.length; }
        for (k = 1; k * PARTA.sp < len - PARTA.t; k++) sus.push(k * PARTA.sp);
        for (hq = 0; hq < holes.length; hq++) { sus.push(holes[hq][0] + PARTA.t / 2, holes[hq][1] - PARTA.t / 2); }
        sus = sus.filter(function (u) { return !inHole(u); }).sort(function (a, b) { return a - b; });
        var su2 = []; for (k = 0; k < sus.length; k++) if (!su2.length || sus[k] - su2[su2.length - 1] > PARTA.t) su2.push(sus[k]);
        for (k = 0; k < su2.length; k++) {
          var hS = Math.min(topAt(su2[k] - PARTA.t / 2), topAt(su2[k] + PARTA.t / 2)) - PARTA.t - (y0 + PARTA.t);
          if (hS < 0.10) continue;
          box(su2[k], PARTA.t, y0 + PARTA.t + hS / 2, hS, mW); tl.timber += hS; tl.studs++;
        }
        /* a doubled header over each doorway, where there is height for it */
        for (hq = 0; hq < holes.length; hq++) {
          var hw0 = holes[hq][0] + PARTA.t, hw1 = holes[hq][1] - PARTA.t, yH = y0 + PARTA.doorH;
          if (Math.min(topAt(hw0), topAt(hw1)) - PARTA.t - yH < PARTA.hdr) { notes.push('#' + p.id + ' doorway at ' + Math.round((hw0 + hw1) / 2 * 1000) + ': no room for a 2000 door under the slope'); continue; }
          box((holes[hq][0] + holes[hq][1]) / 2, holes[hq][1] - holes[hq][0], yH + PARTA.hdr / 2, PARTA.hdr, mW); tl.timber += 2 * (holes[hq][1] - holes[hq][0]); tl.doors++;
        }
        /* THE DOOR IN EACH DOORWAY (aframe-v84, copied from the ADU's
           _doorSet3D and its bill): a white lining through the wall -- two
           jambs and a head -- and the leaf hung on the jamb the plan's swing
           names, 30 degrees ajar onto the face the plan draws; a slider parked
           over the wall; a pass-through gets the lining only. Billed by width
           and hand: ODI06/08/09 LH or RH, ODI12001 / ODI16001 double, with a
           handle set ODD00001 and three hinges ODD00005 */
        for (dq = 0; dq < dRec.length; dq++) {
          var DR = dRec[dq], dh = Math.min(topAt(DR.a0), topAt(DR.a1)) - PARTA.t - PARTA.hdr - y0;
          dh = Math.min(PARTA.doorH, dh);
          if (dh < 1.2) continue;
          var wmm = Math.round(DR.w * 1000), hnd = DR.hand === 'L' ? 1 : 2;
          var dcode = (wmm >= 1450) ? 'ODI16001' : (wmm >= 1150) ? 'ODI12001' : (wmm >= 850) ? ('ODI090' + '0' + hnd) : (wmm >= 700) ? ('ODI080' + '0' + hnd) : ('ODI060' + '0' + hnd);
          _am(ctx, 'interior_doors', 'Interior doors', DR.pass ? '' : dcode, 'side');
          _aDoorSet(T, g, vert, at, lo, DR, dh, y0, ctx);
          if (!DR.pass) {
            tl.doorCodes = tl.doorCodes || {}; tl.doorCodes[dcode] = (tl.doorCodes[dcode] || 0) + 1; tl.leaves = (tl.leaves || 0) + 1;
          } else tl.pass = (tl.pass || 0) + 1;
        }
        /* the wool in the bays, the boards on both faces */
        var aW = 0, aB = 0, bq;
        for (rq = 0; rq < runs.length; rq++) {
          var cuts = [runs[rq][0]];
          for (k = 0; k < su2.length; k++) if (su2[k] - PARTA.t / 2 > runs[rq][0] + 0.001 && su2[k] + PARTA.t / 2 < runs[rq][1] - 0.001) cuts.push(su2[k] - PARTA.t / 2, su2[k] + PARTA.t / 2);
          cuts.push(runs[rq][1]);
          for (bq = 0; bq + 1 < cuts.length; bq += 2) {
            var ca = cuts[bq] + (bq === 0 ? PARTA.t : 0), cb = cuts[bq + 1] - (bq + 2 >= cuts.length ? PARTA.t : 0);
            if (cb - ca > 0.03) aW += slab(ca, cb, y0 + PARTA.t, PARTA.t, PWOOL.t, 0, mWool);
          }
          aB += slab(runs[rq][0], runs[rq][1], y0, 0, BD.t, PARTA.d / 2 + BD.t / 2, mB);
          aB += slab(runs[rq][0], runs[rq][1], y0, 0, BD.t, -(PARTA.d / 2 + BD.t / 2), mB2);
        }
        for (hq = 0; hq < holes.length; hq++) {
          var yO = y0 + PARTA.doorH;
          if (Math.min(topAt(holes[hq][0]), topAt(holes[hq][1])) - yO < 0.05) continue;
          aW += slab(holes[hq][0] + PARTA.t, holes[hq][1] - PARTA.t, yO + PARTA.hdr, PARTA.t, PWOOL.t, 0, mWool);
          aB += slab(holes[hq][0], holes[hq][1], yO, 0, BD.t, PARTA.d / 2 + BD.t / 2, mB);
          aB += slab(holes[hq][0], holes[hq][1], yO, 0, BD.t, -(PARTA.d / 2 + BD.t / 2), mB2);
        }
        tl.wool += aW; tl.board += aB; tl.walls++;
        notes.push('#' + p.id + ' ' + (vert ? 'along the ridge' : 'across the A') + ' at ' + Math.round((vert ? at - cx : at) * 1000) + ', storey ' + (st + 1) + ', ' + Math.round(lo * 1000) + '..' + Math.round(hi * 1000) + ' (' + Math.round(len * 1000) + ' long), top ' + (vert ? Math.round((topAt(0) - y0) * 1000) : ('up to ' + Math.round((topAt(cx - lo) - y0) * 1000))) + ' over the floor' + (holes.length ? (', ' + holes.length + ' doorway(s)') : '') + ', ' + su2.length + ' stud(s)');
      }
      if (!tl.walls) { ctx.log('parts    nothing built: ' + notes.join('; ')); return; }
      if (tl.postEnds) notes.push(tl.postEnds + ' end stud(s) left out where a post under the wing\'s beam stands at the joint');
      API.billAdd('aframe-partitions', PARTA.code, tl.timber * 1.05);
      API.billAdd('aframe-partitions', 'FAS45145', tl.studs * 4);
      if (tl.soleSlab > 0) API.billAdd('aframe-partitions', 'FAS80060', Math.ceil(tl.soleSlab / 0.60) + tl.walls);
      if (tl.sole - tl.soleSlab > 0) API.billAdd('aframe-partitions', 'FAS50060', Math.ceil((tl.sole - tl.soleSlab) / 0.60) + tl.walls);
      API.billAdd('aframe-partitions', PWOOL.code, tl.wool);
      var WBP = Math.min(tl.board, _wetBoardAreas().part);
      API.billAdd('aframe-partitions', BD.code, (tl.board - WBP) * BD.waste);
      if (WBP > 0.01) API.billAdd('aframe-partitions', WET_BOARD, WBP * BD.waste);
      API.billAdd('aframe-partitions', BD.screw, Math.round(tl.board * BD.screwPerM2));
      _chemBill('aframe-partitions', tl.board, 0, 0); _chemNote(ctx, 'partitions', tl.board, 0, 0);
      API.billAdd('aframe-partitions', BD.tape, Math.round(tl.board / 2.88 * 3.6 * 10) / 10);
      API.billAdd('aframe-partitions', BD.filler, Math.round(tl.board * BD.fillerKgM2 * 10) / 10);
      if (tl.leaves) {
        var kd; for (kd in tl.doorCodes) if (tl.doorCodes.hasOwnProperty(kd)) API.billAdd('aframe-partitions', kd, tl.doorCodes[kd]);
        API.billAdd('aframe-partitions', 'ODD00001', tl.leaves);
        API.billAdd('aframe-partitions', 'ODD00005', tl.leaves * 3);
      }
      ctx.log('parts    DOORS ' + (tl.leaves || 0) + ' interior door unit(s)' + (tl.leaves ? (': ' + Object.keys(tl.doorCodes).map(function (c) { return c + ' x' + tl.doorCodes[c]; }).join(', ') + ' + ' + tl.leaves + ' x ODD00001 handle set, ' + (tl.leaves * 3) + ' x ODD00005 hinges') : '') + (tl.pass ? ('; ' + tl.pass + ' pass-through(s), lining only') : ''));
      ctx.log('parts    ' + tl.walls + ' partition(s): ' + notes.join('; '));
      ctx.log('parts    BILL studs and plates ' + PARTA.code + ' 60x100 ' + (tl.timber * 1.05).toFixed(1) + ' m (+5%), ' + tl.studs + ' stud(s), ' + (tl.studs * 4) + ' x FAS45145 (2 each end); the sole fixed every 600' + (tl.soleSlab > 0 ? (' into the slab with FAS80060') : '') + (tl.sole - tl.soleSlab > 0 ? ' into the floor with FAS50060' : '') +
              '; acoustic wool ' + PWOOL.code + ' ' + tl.wool.toFixed(2) + ' m2 in the bays; board ' + BD.code + ' ' + ((tl.board - WBP) * BD.waste).toFixed(2) + ' m2' + (WBP > 0.01 ? (' + ' + WET_BOARD + ' ' + (WBP * BD.waste).toFixed(2) + ' m2 on the faces of a wet room') : '') + ' (' + tl.board.toFixed(2) + ' both faces, +10%), ' + Math.round(tl.board * BD.screwPerM2) + ' x ' + BD.screw + ', tape ' + BD.tape + ' ' + (Math.round(tl.board / 2.88 * 3.6 * 10) / 10) + ' m, filler ' + BD.filler + ' ' + (Math.round(tl.board * BD.fillerKgM2 * 10) / 10) + ' kg; ' + tl.doors + ' doorway(s) framed under a doubled header');
      if (WBP > 0.01) ctx.log('WET  board partitions (aframe-v144): ' + WBP.toFixed(2) + ' m2 of the partitions\' faces bound a wet room -- ' + WET_BOARD + ' ' + (WBP * BD.waste).toFixed(2) + ' m2 (+10%) instead of ' + BD.code);
      /* the casings (aframe-v144) */
      if (_aCase && _aCase.len > 0.01) {
        API.billAdd('aframe-partitions', CASE.code, Math.round(_aCase.len * 1.05 * 100) / 100);
        API.billAdd('aframe-partitions', CASE.nail, CASE.rows * Math.ceil(_aCase.len / CASE.step));
        ctx.log('trim     doorways (aframe-v144): ' + _aCase.n + ' doorway(s) cased on both faces, ' + Math.round(_caseW() * 1000) + ' x ' + Math.round(_caseT() * 1000) + ': ' + _aCase.len.toFixed(2) + ' m, BILL ' + CASE.code + ' ' + (_aCase.len * 1.05).toFixed(2) + ' m (+5% mitres), ' + (CASE.rows * Math.ceil(_aCase.len / CASE.step)) + ' x ' + CASE.nail + ' (two rows every 12 in.)' + ((TRIM_REVIEW && _isAdmin()) ? ' -- MAGENTA (under review)' : ''));
      }
      /* the closets fitted out (aframe-v144) */
      var cTot = { len: 0, rooms: [] }, kC;
      for (kC = 0; kC < fl.length; kC++) _aClosets(ctx, g, kC, cTot);
      if (cTot.len > 0.01) {
        var nCs = 2 * Math.ceil(cTot.len / CLO.every);
        API.billAdd('aframe-partitions', CLO.code, Math.round(cTot.len * 100) / 100);
        API.billAdd('aframe-partitions', CLO.screw, nCs);
        ctx.log('trim     closets (aframe-v144): a 12 in. shelf at 66 in. with a rod under it round the walls (partitions and gable, never a slope; where the slope leaves room over it) -- ' + cTot.rooms.join(', ') + '; BILL ' + CLO.code + ' ' + (Math.round(cTot.len * 100) / 100) + ' m, ' + nCs + ' x ' + CLO.screw + ' (two at every stud, 16 in.)');
      } else ctx.log('trim     closets (aframe-v144): none -- no room named closet or wardrobe (or no wall in it with room for the shelf)');
      if (_aCase && _aCase.handles) ctx.log('parts    handles drawn (aframe-v152): ' + _aCase.handles + ' lever(s) ODD00001 on the leaves, both faces (billed one set a leaf)');
      /* THE PARTITIONS UNDER REVIEW (aframe-v152, plan I): the frame is the structure, the rest by its walk item */
      if (_isAdmin() && AF_STEP.part < 99) {
        var phP = { partition_wool: 'wool', interior_doors: 'door', casing: 'case', closet_shelf: 'closet' };
        var nPr = _rvTagList(T, g.children.slice(kP0), function (o) {
          if (o.userData && o.userData.afCase) return 'case';
          if (o.material === mB) return 'board1'; if (o.material === mB2) return 'board2';
          return phP[_asmKey(o)] || '';
        }, _partDefs(), AF_STEP.part), LPr = _partLayers();
        ctx.log('parts    review step ' + AF_STEP.part + ' of ' + LPr.length + ' (' + (LPr[AF_STEP.part - 1] || '?') + '): ' + nPr.rv + ' bod(ies) MAGENTA, ' + nPr.un + ' under it in their colours, ' + nPr.ab + ' over it hidden (billed); the frame drawn');
      }
    }
    /* -------------------------------------------------------------------------
       THE SIDE WING (aframe-v97, Marek: u A-frame bocni kridlo s rovnou
       strechou, idealne pochozi strechou / balkonem z druheho patra; jen u
       dvoupatrovych; prepinac off / leva / prava / obe ve Structure a overlay
       ghost footprint pod kazdym kridlem). A one-storey wing with a flat roof
       along an eave side of the A, the roof walkable at the second floor.
       STEP 1: the switch and the ghost only -- nothing is built or billed
       yet. The wing's footprint: from the eave line (the base's long edge,
       where the rafter feet stand) WING.w out, WING.l along the ridge,
       centred on the house (off moves it along), kept inside the gables.
         STATE.product.aframeWing = { mode: 'off'|'left'|'right'|'both', w, l, off }
       ------------------------------------------------------------------------- */
    var WING = { w: 3.00, wMin: 2.00, wMax: 5.00, lMin: 2.40, ghost: 0xC49A4A, doorBay: 1.00 + 0.04 + 2 * 0.060 };
    function _wingBag() {
      var P = STATE.product = STATE.product || {};
      var W = P.aframeWing || (P.aframeWing = { mode: 'off' });
      if (['off', 'left', 'right', 'both'].indexOf(W.mode) < 0) W.mode = 'off';
      return W;
    }
    function _wingOk() { return floors().length >= 2; }
    function _wingModeLabel() {
      var m = _wingBag().mode;
      return ({ off: _t('sauna_ui_off', 'Off'), left: _t('view_left', 'Left'), right: _t('view_right', 'Right'), both: _t('both', 'Both') })[m] || m;
    }
    /* A ROOF WINDOW OVER A SIDE WING IS PUT AWAY (aframe-v105, Marek: okna na
       strane kridla musi zmizet pri prepinani kridel): a window on the wing's
       slope within the wing's length is not built or billed while the wing
       is there; it stays in the project and comes back when the wing goes */
    function _winUnderWing(o) {
      if (!o || o.host !== 'roof') return false;
      var sd = (o.plane === 'left') ? -1 : 1, sides = _wingSides(), q;
      for (q = 0; q < sides.length; q++) if (sides[q] === sd) { var WR = _wingRect(sd), z = +o.along || 0, hw = ((+o.w) || 0.78) / 2 + 0.10; if (z + hw > WR.z0 && z - hw < WR.z1) return true; }
      return false;
    }
    function _wingSides() {
      var W = _wingBag();
      if (!_wingOk() || W.mode === 'off') return [];
      return W.mode === 'both' ? [-1, 1] : [W.mode === 'left' ? -1 : 1];
    }
    /* the wing's rect on the ground for side sd (-1 = x0, the left slope) */
    /* THE WING ON THE RAFTERS (aframe-v106, Marek: kridlo defaultne na 4
       sirky krokvi uprostred, v ose; vstup dvoje dvere v prostrednich polich,
       zadna krokev prerusena, mezi dvermi jedna krokev). Both wings share one
       grid, on the house's axis unless slid: a rafter on the axis, the two
       door bays either side of it widened to a 1000 door with its frame and
       the doubling inside each trimmer (centre to centre WING.doorBay), then
       k ordinary bays of 600 outward (k = 1 by default: 4 bays in all). The
       wing ends on the outermost of these rafters. Dragging its ends adds or
       takes whole bays; sliding moves the grid along the house. */
    /* THE WING IS n BAYS WIDE, THE DOORS ALWAYS ON ITS AXIS (aframe-v122, Marek:
       kridlo pretahnout kamkoliv, dvere porad na ose; minimum dve pole, pak po
       jednom; dve pole = dvoje dvere, tri = jedny dvere na ose, ctyri = dve
       dvere na ose, pet = jedny...). n >= 2 bays counted round the wing's own
       centre: with n even a rafter stands on the axis and a door bay either
       side of it (two doors, the axis rafter whole between them); with n odd
       one door bay is centred on the axis between two trimmers (one door).
       Either way the rest are ordinary 600 bays, as many each side. */
    function _wingHalf(n) { var odd = (n % 2 === 1), db = WING.doorBay; return (odd ? db / 2 : db) + (odd ? (n - 1) / 2 : (n - 2) / 2) * RAF.sp; }
    function _wingN() {
      var W = _wingBag();
      if (!(W.n >= 2)) W.n = (W.k >= 1) ? (2 + 2 * Math.round(W.k)) : 4;
      var B = _barRect(), tt = _rafSize().t, L = B.z1 - B.z0, n = Math.max(2, Math.round(W.n));
      while (n > 2 && _wingHalf(n) > L / 2 - tt - GABLE.d - 0.3) n--;
      return n;
    }
    function _wingGrid() {
      var W = _wingBag(), B = _barRect(), tt = _rafSize().t, db = WING.doorBay, n = _wingN(), odd = (n % 2 === 1);
      var k = odd ? (n - 1) / 2 : (n - 2) / 2, half = _wingHalf(n), cz = (B.z0 + B.z1) / 2 + (+W.zOff || 0);
      var lo = B.z0 + tt / 2 + RAF.sp * 0.5 + half, hi = B.z1 - tt / 2 - RAF.sp * 0.5 - half;
      cz = Math.max(lo, Math.min(hi, cz));
      var dh = odd ? db / 2 : db, lines = [], j;
      for (j = k; j >= 1; j--) lines.push(cz - dh - j * RAF.sp);
      lines.push(cz - dh);
      if (!odd) lines.push(cz);
      lines.push(cz + dh);
      for (j = 1; j <= k; j++) lines.push(cz + dh + j * RAF.sp);
      return { cz: cz, half: half, k: k, n: n, odd: odd, db: db, lines: lines, trim: [cz - dh, cz + dh], doors: odd ? 1 : 2, axis: odd ? null : cz };
    }
    function _wingRect(sd) {
      var W0 = _wingBag(), W = W0[sd < 0 ? 'L' : 'R'] || W0, BR = _baseRect(), WG = _wingGrid(), tt = _rafSize().t;
      var w = Math.max(WING.wMin, Math.min(WING.wMax, +W.w || WING.w));
      var z0 = WG.cz - WG.half - tt / 2, z1 = WG.cz + WG.half + tt / 2;
      var xE = (sd < 0) ? BR.x0 : BR.x1;
      return { sd: sd, x0: (sd < 0) ? xE - w : xE, x1: (sd < 0) ? xE : xE + w, z0: z0, z1: z1, w: w, l: z1 - z0, xEave: xE, grid: WG };
    }
    /* THE WING'S GHOST TAKES DRAG POINTS ON ROOF & BASE (aframe-v98, through
       the core's product rects, core-v523): the outer edge sets its width out
       from the eave (2..5 m), the two ends its length, the body slides it
       along the house; the edge on the eave has no grip. Each wing keeps its
       own figures, STATE.product.aframeWing.L / .R = { w, l, off } */
    __PROD._rects = function (step) {
      /* ON THE FLOORPLAN, on the ground floor's plan (aframe-v124, core-v530, Marek: pudorys kridla upravovat ve
         floorplanu); Structure and Roof & Base no longer carry them */
      if (step !== 'layout' || (STATE.planStorey | 0) !== 0) return [];
      return _wingSides().map(function (sd) {
        var WR = _wingRect(sd);
        return { key: 'p:wing-' + (sd < 0 ? 'L' : 'R'), style: 'secondary', snap: 0.05, movable: true, noGrip: [sd < 0 ? 'x1' : 'x0'],
                 x0: WR.x0, x1: WR.x1, z0: WR.z0, z1: WR.z1 };
      });
    };
    __PROD._rectApply = function (key, r) {
      var m = /^p:wing-(L|R)$/.exec(key || ''); if (!m) return;
      var sd = (m[1] === 'L') ? -1 : 1, W0 = _wingBag(), cur = _wingRect(sd), B = _barRect();
      var S0 = W0[m[1]] || (W0[m[1]] = { w: cur.w, l: cur.l, off: 0 });
      if (r.x0 != null && r.x1 != null) {
        var wN = r.x1 - r.x0;
        if (Math.abs(wN - cur.w) > 0.001) S0.w = Math.round(Math.max(WING.wMin, Math.min(WING.wMax, wN)) * 100) / 100;
      }
      if (r.z0 != null && r.z1 != null) {
        /* whole bays: the ends add or take 600 bays both sides alike, a slide moves the grid (both wings) */
        /* an end dragged: the nearest whole count of bays (2 at least), the other end stays put; a slide moves it whole */
        var lN = r.z1 - r.z0, tt2 = _rafSize().t, Bcz = (B.z0 + B.z1) / 2;
        if (Math.abs(lN - cur.l) > 0.02) {
          /* every 600 dragged is one bay more or less: an odd and an even count come out nearly the same length
             (one door bay of 1160 against two), so the count follows the drag, not the length */
          var nCur = _wingN(), dN = Math.round((lN - cur.l) / RAF.sp);
          if (dN === 0) dN = (lN > cur.l) ? 1 : -1;
          W0.n = Math.max(2, nCur + dN); delete W0.k;
          var nEff = _wingN(), hN = _wingHalf(nEff), movedLo = Math.abs(r.z0 - cur.z0) > Math.abs(r.z1 - cur.z1);
          var czN = movedLo ? (cur.z1 - tt2 / 2 - hN) : (cur.z0 + tt2 / 2 + hN);
          W0.zOff = Math.round((czN - Bcz) * 1000) / 1000;
        } else W0.zOff = Math.round(((r.z0 + r.z1) / 2 - Bcz) * 1000) / 1000;
      }
      var nw = _wingRect(sd);
      var WGn = _wingGrid(); _wingNote = 'wing     ' + (sd < 0 ? 'left' : 'right') + ' dragged -> ' + Math.round(nw.w * 1000) + ' out x ' + Math.round(nw.l * 1000) + ' along, ' + WGn.n + ' bay(s) (' + (WGn.odd ? 'one door on the axis' : 'two doors, the axis rafter between them') + '), centre ' + Math.round(((nw.z0 + nw.z1) / 2) * 1000);
    };
    __PROD._rectDims = function (key) {
      var m = /^p:wing-(L|R)$/.exec(key || ''); if (!m) return [];
      var WR = _wingRect(m[1] === 'L' ? -1 : 1), xo = (m[1] === 'L') ? WR.x0 : WR.x1, dO = (m[1] === 'L') ? -1 : 1;
      return [{ text: fmtLen(WR.w), x: (WR.x0 + WR.x1) / 2, z: WR.z0 - 0.8 },
              { text: fmtLen(WR.l), x: xo + dO * 0.8, z: (WR.z0 + WR.z1) / 2 }];
    };
    var _wingNote = '';
    function _wingSet(mode) {
      var W = _wingBag(), was = W.mode;
      W.mode = mode;
      try { if (API.savePref) API.savePref(); } catch (eS) {}
      API.rebuild();
      _log('wing     side wing -> ' + mode + ' (was ' + was + ')');
    }
    /* THE GHOST: a gold footprint on the ground under each wing, on
       Structure and on Roof & Base, the house line's ghost colour */
    function _buildWing(ctx) {
      var T = ctx.THREE, g = ctx.group, W = _wingBag();
      _bill['aframe-wing'] = {};
      if (!_wingOk()) { if (W.mode !== 'off') ctx.log('wing     ' + W.mode + ' asked, but the A has ' + floors().length + ' floor -- a side wing needs two; not shown'); else ctx.log('wing     off (one floor: the switch is not offered)'); return; }
      var sides = _wingSides();
      if (!sides.length) { ctx.log('wing     off'); return; }
      var show = false; try { show = !!(API.editing && API.editing('layout')); } catch (eE) { show = false; }
      var notes = [], q;
      for (q = 0; q < sides.length; q++) {
        var WR = _wingRect(sides[q]);
        notes.push((WR.sd < 0 ? 'left' : 'right') + ' ' + Math.round(WR.w * 1000) + ' out x ' + Math.round(WR.l * 1000) + ' along (x ' + Math.round(WR.x0 * 1000) + '..' + Math.round(WR.x1 * 1000) + ', z ' + Math.round(WR.z0 * 1000) + '..' + Math.round(WR.z1 * 1000) + ')');
        if (!show) continue;
        var mF = new T.MeshBasicMaterial({ color: WING.ghost, transparent: true, opacity: 0.28, depthWrite: false, side: T.DoubleSide });
        var pl = new T.Mesh(new T.PlaneGeometry(WR.x1 - WR.x0, WR.z1 - WR.z0), mF);
        pl.rotation.x = -Math.PI / 2; pl.position.set((WR.x0 + WR.x1) / 2, 0.015, (WR.z0 + WR.z1) / 2); pl.renderOrder = 5; g.add(pl);
        /* on Structure the core draws the outline with its grips (aframe-v117, core-v526); the plain gold edge only for an older core */
        if (typeof __CORE.CORE_VERSION === 'string' && +(__CORE.CORE_VERSION.replace(/[^0-9]/g, '')) >= 530) continue;
        var mE = new T.MeshBasicMaterial({ color: WING.ghost }), lw = 0.035;
        [[WR.x0, WR.z0, WR.x1, WR.z0], [WR.x1, WR.z0, WR.x1, WR.z1], [WR.x1, WR.z1, WR.x0, WR.z1], [WR.x0, WR.z1, WR.x0, WR.z0]].forEach(function (E) {
          var len = Math.hypot(E[2] - E[0], E[3] - E[1]), eM = new T.Mesh(new T.BoxGeometry(len + lw, 0.004, lw), mE);
          eM.position.set((E[0] + E[2]) / 2, 0.02, (E[1] + E[3]) / 2); eM.rotation.y = -Math.atan2(E[3] - E[1], E[2] - E[0]); g.add(eM);
        });
      }
      if (_wingNote) ctx.log(_wingNote);
      try { _buildWingWalls(ctx); } catch (eWW) { ctx.log('wingwall ERROR ' + ((eWW && eWW.message) || eWW)); }
      try { _buildWingRoof(ctx); } catch (eWR) { ctx.log('wingroof ERROR ' + ((eWR && eWR.message) || eWR)); }
      /* ONE LINE FOR THE WHOLE WING (aframe-v118) */
      try {
        var sm = sides.map(function (sd) {
          var WG9 = _wingGrid(), WR9 = _wingRect(sd), key9 = (sd < 0) ? 'L' : 'R', E9 = (_wingBag().parts || {})[key9] || {}, ids9 = E9.ids || [];
          var nOp = (STATE.openings || []).filter(function (o) { return o && typeof o.seg === 'string' && o.seg.indexOf('WG-' + key9 + '-') === 0; }).length, D9 = _dormer(sd);
          return (sd < 0 ? 'left' : 'right') + ' ' + Math.round(WR9.w * 1000) + ' x ' + Math.round(WR9.l * 1000) + ', ' + (WG9.lines.length - 1) + ' bay(s) on the axis ' + Math.round(WG9.cz * 1000) +
                 ', the ground floor under it open (no partition, no posts), ' + nOp + ' opening(s) in its walls' +
                 (D9 ? (', ' + D9.bays.length + ' slot(s) in the slope to door(s) ' + Math.round(D9.dD * 1000) + ' from the ridge line') : '');
        });
        ctx.log('wingsum  ' + sm.join(' | '));
      } catch (eSm) { ctx.log('wingsum  ERROR ' + ((eSm && eSm.message) || eSm)); }
      ctx.log('wing     ' + W.mode + ': ' + notes.join('; ') + (show ? ' -- the gold ghost on the ground (Floorplan)' : ' -- the ghost and its drag points are on the Floorplan, ground floor') + ' (needs core-v530: ' + (typeof __CORE.CORE_VERSION === 'string' ? __CORE.CORE_VERSION : '?') + '); the footing is built (wingbase), the walls and the roof come next');
    }
    /* THE WING'S FOOTING (aframe-v100, wing step 3): the house's own --
       strips 400 on a footing 700 x 250 at frost depth round the three outer
       sides (the house's eave strip is the fourth, inside), a slab 150 over
       the whole wing flush with the house slab, under it inside the strips
       the house's build-up: gravel 150, EPS 150 (INS01502), the vapour
       barrier ROV00001 taped. Below grade drawn on Roof & Base only. */
    function _buildWingBase(ctx) {
      var T = ctx.THREE, g = ctx.group, L0 = 'aframe-wingbase';
      _bill[L0] = {};
      var sides = _wingSides();
      if (!sides.length) { ctx.log('wingbase none'); return; }
      if (STATE.foundation !== 'strips') { ctx.log('wingbase the house is on ' + STATE.foundation + ' -- the wing needs strips (two floors lock them); nothing built'); return; }
      var ffull = true; try { ffull = (typeof __CORE._footFull === 'function') ? !!__CORE._footFull() : true; } catch (eFF) { ffull = true; }
      var yP = _deckY(), SP = { w: 0.40, foot: 0.70, footH: 0.25, depth: Math.max(0.80, STATE.climateZone || 0) }, slabT = 0.15;
      var UL = { film: 0.002, eps: 0.150, gravel: 0.150 }, ySb = yP - slabT, yEps = ySb - UL.film, yGr = yEps - UL.eps, yGrB = yGr - UL.gravel;
      var mC = new T.MeshStandardMaterial({ color: 0x9E9B93, roughness: 0.95 }), mG = new T.MeshStandardMaterial({ color: 0xB8B0A2, roughness: 1 });
      var mE = new T.MeshStandardMaterial({ color: 0xECECE4, roughness: 0.9 }), mF = new T.MeshStandardMaterial({ color: 0x3E4A56, roughness: 0.8 });
      var clipY = function (y) { return ffull ? y : Math.max(0, y); };
      var amB = function (m) {
        if (m === mC) _am(ctx, 'grd_concrete', 'Footing', 'grd.concrete', 'top');
        else if (m === mF) _am(ctx, 'layer_vapour_barrier', 'Vapour barrier', 'ROV00001', 'top');
        else if (m === mE) _am(ctx, 'layer_insulation', 'Insulation under the slab', 'INS01502', 'top');
        else if (m === mG) _am(ctx, 'grd_gravel', 'Gravel base', 'grd.gravelSlab', 'top');
      };
      var box = function (x0, x1, y0, y1, z0, z1, m) { amB(m); y0 = clipY(y0); y1 = clipY(y1); if (y1 - y0 < 0.002 || x1 - x0 < 0.002 || z1 - z0 < 0.002) return; var b = new T.Mesh(new T.BoxGeometry(x1 - x0, y1 - y0, z1 - z0), m); b.position.set((x0 + x1) / 2, (y0 + y1) / 2, (z0 + z1) / 2); g.add(b); };
      var yFt = -SP.depth + SP.footH, tot = { strip: 0, foot: 0, stem: 0, slabA: 0, inA: 0, dig: 0 }, notes = [], q;
      for (q = 0; q < sides.length; q++) {
        var sd = sides[q], WR = _wingRect(sd), xE = WR.xEave, xO = (sd < 0) ? WR.x0 : WR.x1;
        var xa = Math.min(xE, xO), xb = Math.max(xE, xO), xOs = (sd < 0) ? [xO, xO + SP.w] : [xO - SP.w, xO];
        /* the three strips: along the outer edge, and across each end from the house eave out */
        var runs = [{ x0: xOs[0], x1: xOs[1], z0: WR.z0, z1: WR.z1 }, { x0: xa, x1: xb, z0: WR.z0, z1: WR.z0 + SP.w }, { x0: xa, x1: xb, z0: WR.z1 - SP.w, z1: WR.z1 }], r;
        for (r = 0; r < runs.length; r++) {
          var RR = runs[r], along = Math.max(RR.x1 - RR.x0, RR.z1 - RR.z0), isX = (RR.x1 - RR.x0) > (RR.z1 - RR.z0);
          var fx0 = isX ? RR.x0 : (RR.x0 + RR.x1) / 2 - SP.foot / 2, fx1 = isX ? RR.x1 : (RR.x0 + RR.x1) / 2 + SP.foot / 2;
          var fz0 = isX ? (RR.z0 + RR.z1) / 2 - SP.foot / 2 : RR.z0, fz1 = isX ? (RR.z0 + RR.z1) / 2 + SP.foot / 2 : RR.z1;
          box(fx0, fx1, -SP.depth, yFt, fz0, fz1, mC);
          box(RR.x0, RR.x1, yFt, ySb, RR.z0, RR.z1, mC);
          tot.strip += along; tot.foot += SP.foot * SP.footH * along; tot.stem += SP.w * (ySb - yFt) * along;
        }
        /* the slab over the whole wing, from the house's base edge out */
        box(xa, xb, ySb, yP, WR.z0, WR.z1, mC);
        tot.slabA += (xb - xa) * (WR.z1 - WR.z0);
        /* aframe-v171: its sawcut joints (the garage apartment's 2c), and the isolation joint FFM00009 along the house's
           slab it is cast against (the garage apartment's: "an isolation joint FFM00009 where each meets the building") */
        var JW = _slabJoints(ctx, xa, xb, WR.z0, WR.z1, yP, _gfOn('concrete slab'));
        tot.joints = (tot.joints || 0) + JW.m; tot.iso = (tot.iso || 0) + WR.l;
        notes.push('sawcut joints ' + (JW.jx - 1) + ' / ' + (JW.jz - 1) + ' ' + JW.m.toFixed(2) + ' m, isolation joint ' + WR.l.toFixed(2) + ' m along the house');
        /* inside the strips: film, EPS, gravel (the house eave strip inside at xE) */
        var ia = (sd < 0) ? xOs[1] : xE, ib = (sd < 0) ? xE : xOs[0], iz0 = WR.z0 + SP.w, iz1 = WR.z1 - SP.w;
        if (ib - ia > 0.05 && iz1 - iz0 > 0.05) {
          box(ia, ib, yEps, ySb, iz0, iz1, mF);
          box(ia, ib, yGr, yEps, iz0, iz1, mE);
          box(ia, ib, yGrB, yGr, iz0, iz1, mG);
          var aIn = (ib - ia) * (iz1 - iz0); tot.inA += aIn; tot.dig += aIn * Math.max(0, -yGrB);
        }
        notes.push((sd < 0 ? 'left' : 'right') + ' ' + Math.round(WR.w * 1000) + ' x ' + Math.round(WR.l * 1000) + ': 3 strips ' + (WR.l + 2 * WR.w).toFixed(2) + ' m, slab ' + ((xb - xa) * (WR.z1 - WR.z0)).toFixed(2) + ' m2');
      }
      var B1 = function (c, q2) { if (q2 > 0) API.billAdd(L0, c, q2); };
      /* THE WING'S PERIMETER INSULATION AND PLINTH (aframe-v149, plan H): the
         house's (aframe-v131) round the wing's three outer sides -- XPS 50
         INS00503 glued with foam outside the slab edge and the stem, from the
         footing's top to the slab top; above grade the plinth finish over it
         (base coat with mesh, primer, render, a bead on each outer corner).
         The house's run along that eave is left out over the wing's length
         (aframe-base); the wing's end boards close the corners against it */
      var PXw = { t: PERIM.t, fin: PERIM.fin }, yLoW = ffull ? yFt : 0, hAbW = Math.max(0, yP), pW = 0, nCnr = 0;
      var rvXw = _isRv('gfloor', _gfIdx('perimeter XPS')), rvFw = _isRv('gfloor', _gfIdx('plinth finish')), nwW = WPERIM_REVIEW && _isAdmin();
      var mXw = new T.MeshStandardMaterial({ color: (rvXw || nwW) ? MAGENTA : 0xC6D8E8, roughness: 0.9 }), mFw = new T.MeshStandardMaterial({ color: (rvFw || nwW) ? MAGENTA : 0x8E8A82, roughness: 0.9 });
      sides.forEach(function (sdP) {
        var WRp = _wingRect(sdP), xEp = WRp.xEave, wp = WRp.w, zp0 = WRp.z0, zp1 = WRp.z1;
        var xs = function (a, b) { var p1 = xEp + sdP * a, p2 = xEp + sdP * b; return [Math.min(p1, p2), Math.max(p1, p2)]; };
        var bx = function (xr, za, zb, y0, y1, m, rv) {
          if (y1 - y0 < 0.002 || xr[1] - xr[0] < 0.002 || zb - za < 0.002) return;
          var b = new T.Mesh(new T.BoxGeometry(xr[1] - xr[0], y1 - y0, zb - za), m); b.position.set((xr[0] + xr[1]) / 2, (y0 + y1) / 2, (za + zb) / 2);
          b.userData.afNs = true; if (rv) _rvTag(b); g.add(b);
        };
        if (_gfOn('perimeter XPS')) {
          _am(ctx, 'layer_insulation', 'Slab edge insulation', 'INS00503', 'side');
          bx(xs(0, wp + PXw.t), zp0 - PXw.t, zp0, yLoW, yP, mXw, rvXw); bx(xs(0, wp + PXw.t), zp1, zp1 + PXw.t, yLoW, yP, mXw, rvXw); bx(xs(wp, wp + PXw.t), zp0, zp1, yLoW, yP, mXw, rvXw);
        }
        if (_gfOn('plinth finish') && hAbW > 0.01) {
          var f1 = PXw.t, f2 = PXw.t + PXw.fin;
          _am(ctx, 'layer_render', 'Plinth render', 'FCP00002', 'side');
          bx(xs(f1, wp + f2), zp0 - f2, zp0 - f1, 0, yP, mFw, rvFw); bx(xs(f1, wp + f2), zp1 + f1, zp1 + f2, 0, yP, mFw, rvFw); bx(xs(wp + f1, wp + f2), zp0 - f1, zp1 + f1, 0, yP, mFw, rvFw);
        }
        pW += WRp.l + 2 * (wp + PXw.t); nCnr += 2;
      });
      var aXw = pW * (yP - yFt), aFw = pW * hAbW;
      B1('INS00503', Math.round(aXw * 1.05 * 100) / 100); B1('FCP00005', pW > 0 ? Math.max(1, Math.ceil(aXw * 0.10)) : 0);
      if (aFw > 0.01) {
        B1('FFR00051', Math.round(aFw * 1.05 * 100) / 100); B1('GTM00001', Math.round(aFw * 1.10 * 100) / 100); B1('PEN00001', Math.round(aFw * 1.05 * 100) / 100);
        B1('FCP00002', Math.round(aFw * 1.05 * 100) / 100); B1('FCP00006', Math.round(nCnr * hAbW * 1.05 * 100) / 100);
      }
      ctx.log('wingbase perimeter (aframe-v149): XPS ' + Math.round(PXw.t * 1000) + ' INS00503 round the wing\'s outer sides ' + pW.toFixed(2) + ' m, ' + Math.round(yFt * 1000) + ' to ' + Math.round(yP * 1000) + ' -> ' + (aXw * 1.05).toFixed(2) + ' m2 (+5%), foam FCP00005 ' + Math.max(1, Math.ceil(aXw * 0.10)) + (aFw > 0.01 ? ('; plinth ' + Math.round(hAbW * 1000) + ' high: FFR00051 ' + (aFw * 1.05).toFixed(2) + ' m2, GTM00001 ' + (aFw * 1.10).toFixed(2) + ', PEN00001 + FCP00002 ' + (aFw * 1.05).toFixed(2) + ', bead FCP00006 ' + (nCnr * hAbW * 1.05).toFixed(2) + ' m (' + nCnr + ' outer corner(s))') : '; the slab top at grade, no plinth') + (nwW ? ' -- MAGENTA until checked' : ''));
      B1('grd.excavation', tot.strip * SP.foot * SP.depth + tot.dig);
      B1('grd.gravel', tot.strip * SP.foot * 0.10);
      B1('grd.concrete', tot.foot + tot.stem);
      B1('FCO00003', tot.strip * 4 * 1.05);
      B1('WWR00061', Math.ceil(tot.strip / 0.30));
      B1('grd.concreteSlab', tot.slabA * slabT);
      B1(SLABJ.code, Math.round((tot.joints || 0) * 100) / 100);
      B1(SLABJ.iso, Math.round((tot.iso || 0) * 1.05 * 100) / 100);
      B1('FFR30002', Math.ceil(tot.slabA * 1.12 / 6));
      B1('FFM00004', Math.ceil(tot.slabA * 2));
      B1('FEC00026', Math.round(tot.slabA * 0.03 * 100) / 100);
      B1('grd.gravelSlab', tot.inA * UL.gravel);
      B1('INS01502', tot.inA * 1.05);
      B1('ROV00001', tot.slabA * 1.10);
      B1('INS01005', Math.round((tot.slabA / 1.5 + 2 * tot.strip) * 10) / 10);
      ctx.log('wingbase ' + notes.join('; ') + '; top ' + Math.round(yP * 1000) + ' flush with the house slab' + (ffull ? ', drawn whole (Roof & Base)' : ', drawn from grade'));
      ctx.log('wingbase BILL strips ' + tot.strip.toFixed(2) + ' m: dig ' + (tot.strip * SP.foot * SP.depth + tot.dig).toFixed(2) + ' m3 (with the slab bed), gravel under the footings ' + (tot.strip * SP.foot * 0.10).toFixed(2) + ' m3, concrete ' + (tot.foot + tot.stem).toFixed(2) + ' m3, FCO00003 ' + (tot.strip * 4 * 1.05).toFixed(1) + ' m, ' + Math.ceil(tot.strip / 0.30) + ' x WWR00061; slab ' + tot.slabA.toFixed(2) + ' m2: concrete ' + (tot.slabA * slabT).toFixed(2) + ' m3, ' + Math.ceil(tot.slabA * 1.12 / 6) + ' x FFR30002, ' + Math.ceil(tot.slabA * 2) + ' x FFM00004, FEC00026; under it gravel ' + (tot.inA * UL.gravel).toFixed(2) + ' m3, EPS INS01502 ' + (tot.inA * 1.05).toFixed(2) + ' m2, ROV00001 ' + (tot.slabA * 1.10).toFixed(2) + ' m2 taped INS01005');
    }
    /* THE WING'S HEIGHTS (aframe-v101). The flat roof is walked on from the
       second floor, one step (150) down: its deck boards' top is that far
       under floor 2. Under them, top down: decking 25 on sleepers 40, the
       EPDM, OSB 22, joists 240 (the insulation between them) -- they stand on
       the walls' double top plate. That leaves about 2.2 m clear inside. */
    /* aframe-v102: the sleepers are the porch's pressure treated 60 x 160 laid
       flat, the deck OSB the roof's 18; the fall of 2 per cent out to the
       gutter is made on the joists by tapered firring strips, so the deck is
       its step under floor 2 at the house and lower at the outer edge, and
       the walls stand that much lower */
    var WROOF = { step: 0.100, board: 0.025, sleeper: 0.060, memb: 0.002, osb: 0.018, joist: 0.240, fall: 0.02 };
    function _wingH(sd) {
      var fl = floors(), yP = _deckY(), y2 = (fl.length > 1) ? fl[1].y : yP + 2.7;
      var deckTop = y2 - WROOF.step, base = WROOF.board + WROOF.sleeper + WROOF.memb + WROOF.osb + WROOF.joist;
      var S = _sect(), B = _barRect(), cx = (B.x0 + B.x1) / 2, skinT = 0.10 + _pirT();
      var wallTop = deckTop - base, span = 0, fire = 0, dMeet = 0, it;
      var dAt = function (y) { return S.half - (y - S.top - skinT / S.cos) / S.tan; };
      var dO = (sd == null) ? S.half + 2 : Math.abs(((sd < 0) ? _wingRect(sd).x0 : _wingRect(sd).x1) - cx);
      for (it = 0; it < 3; it++) { dMeet = dAt(wallTop); span = Math.max(0.5, dO - dMeet); fire = WROOF.fall * span; wallTop = deckTop - base - fire; }
      return { yP: yP, y2: y2, deckTop: deckTop, wallTop: wallTop, span: span, fire: fire, dMeet: dMeet, dO: dO, skinT: skinT, dAt: dAt, cx: cx };
    }
    /* THE WING'S OPENINGS ARE THE CORE'S (aframe-v113, core-v525). Each
       wing's three walls are handed to the core as walls of their own,
       __PROD._extraSegs(): 'WG-L-outer', 'WG-L-z0', 'WG-L-z1' (R for the
       right wing), on the ground storey, in the segments' shape and
       direction (a clockwise ring: the outer wall and the end walls run as
       the plan's outline runs round the wing). An opening in them is an
       ordinary record in STATE.openings { seg, at, w, h, sill, kind, code }:
       placed from the Doors & Windows tiles, tapped, dragged, binned and drawn
       on the plan by the core as in the gables; built, framed and billed here.
       A new wing gets one window in the middle of its outer wall, the core
       catalogue's 1200 x 1500 (the walls are 2195 high: sill 400, the head
       1900, the doubled header under the plates); a wing switched off takes
       its openings with it. The v112 list in the bag is moved over once. */
    var WOPS = { win: { code: 'OWR12001', kind: 'window', w: 1.20, h: 1.50, sill: 0.40, leaves: 2 }, hdr: 0.160, gap: 0.010 };
    function _isWingSeg(sg) { return !!(sg && typeof sg.id === 'string' && sg.id.indexOf('WG-') === 0); }
    function _wingSegs(sd) {
      var WR = _wingRect(sd), H = _wingH(sd), xO = (sd < 0) ? WR.x0 : WR.x1, xE = WR.xEave, k = (sd < 0) ? 'L' : 'R', hh = H.wallTop - H.yP;
      var mk = function (nm, a, b) {
        var dx = b[0] - a[0], dz = b[1] - a[1], len = Math.hypot(dx, dz) || 1e-6;
        return { id: 'WG-' + k + '-' + nm, wing: sd, wall: nm, storey: 0, edge: -1, x0: a[0], z0: a[1], x1: b[0], z1: b[1], len: len, nx: dz / len, nz: -dx / len,
                 y0: H.yP, y1: H.wallTop, h: hh, full: hh, head: H.wallTop, area: len * hh, openings: (STATE.openings || []).filter(function (o) { return o && o.seg === 'WG-' + k + '-' + nm; }) };
      };
      /* left: the eave wall runs toward -z, so round the wing: z1 end outwards, the outer wall back, the z0 end inwards */
      if (sd < 0) return [mk('z1', [xE, WR.z1], [xO, WR.z1]), mk('outer', [xO, WR.z1], [xO, WR.z0]), mk('z0', [xO, WR.z0], [xE, WR.z0])];
      return [mk('z0', [xE, WR.z0], [xO, WR.z0]), mk('outer', [xO, WR.z0], [xO, WR.z1]), mk('z1', [xO, WR.z1], [xE, WR.z1])];
    }
    __PROD._extraSegs = function () {
      var ok = false; try { ok = _wingOk(); } catch (eO) { ok = false; }
      if (!ok) return [];
      var out = []; _wingSides().forEach(function (sd) { out = out.concat(_wingSegs(sd)); });
      return out;
    };
    var _wopNote = '';
    function _wingOpsSync() {
      var W0 = _wingBag(), ok = false, notes = [];
      try { ok = _wingOk(); } catch (eO) { ok = false; }
      var on = ok ? _wingSides() : [];
      STATE.openings = STATE.openings || [];
      ['L', 'R'].forEach(function (key) {
        var sd = (key === 'L') ? -1 : 1, E = W0[key] = W0[key] || {}, pre = 'WG-' + key + '-';
        if (on.indexOf(sd) < 0) {
          var n0 = STATE.openings.length;
          STATE.openings = STATE.openings.filter(function (o) { return !(o && typeof o.seg === 'string' && o.seg.indexOf(pre) === 0); });
          if (STATE.openings.length < n0) notes.push(key + ': ' + (n0 - STATE.openings.length) + ' opening(s) went with the wing');
          E.opSeeded = false; return;
        }
        if (E.opSeeded) return;
        var SG = _wingSegs(sd), byWall = {}; SG.forEach(function (g2) { byWall[g2.wall] = g2; });
        var WR = _wingRect(sd), made = [];
        if (Array.isArray(E.ops) && E.ops.length) {
          E.ops.forEach(function (o) {
            var g3 = byWall[o.wall]; if (!g3) return;
            var px = (o.wall === 'outer') ? g3.x0 : ((sd < 0 ? WR.x0 : WR.x1) - sd * o.at), pz = (o.wall === 'outer') ? o.at : g3.z0;
            var at = (px - g3.x0) * (g3.x1 - g3.x0) / g3.len + (pz - g3.z0) * (g3.z1 - g3.z0) / g3.len;
            STATE.openings.push({ seg: g3.id, at: at, w: o.w, h: o.h, sill: o.sill, kind: o.kind, code: o.code, leaves: o.leaves || 1, hand: o.hand || 'L' });
            made.push(o.code + ' on ' + g3.id + ' (from v112)');
          });
        } else {
          var g4 = byWall.outer;
          STATE.openings.push({ seg: g4.id, at: g4.len / 2, w: WOPS.win.w, h: WOPS.win.h, sill: WOPS.win.sill, kind: WOPS.win.kind, code: WOPS.win.code, leaves: WOPS.win.leaves, hand: 'L' });
          made.push(WOPS.win.code + ' on ' + g4.id + ' (the default)');
        }
        delete E.ops; E.opSeeded = true;
        notes.push(key + ': ' + made.join(', '));
      });
      if (notes.length) _wopNote = 'wingops  seeded ' + notes.join('; ');
    }
    /* the wing's openings on one wall, for the builder: a copy with u along the builder's own frame */
    function _wingOpsOn(sd, wall, W) {
      var SG = _wingSegs(sd), g5 = null, q; for (q = 0; q < SG.length; q++) if (SG[q].wall === wall) g5 = SG[q];
      if (!g5) return [];
      return (STATE.openings || []).filter(function (o) { return o && o.seg === g5.id; }).map(function (o) {
        var t9 = (+o.at || 0) / g5.len, px = g5.x0 + (g5.x1 - g5.x0) * t9, pz = g5.z0 + (g5.z1 - g5.z0) * t9, c = {}, k9;
        for (k9 in o) if (o.hasOwnProperty(k9)) c[k9] = o[k9];
        c.u = (px - W.o[0]) * W.u[0] + (pz - W.o[1]) * W.u[1];
        return c;
      });
    }
    /* THE WING'S WALLS (aframe-v101, wing step 4): timber frame 60 x 160 like
       the gables -- a pressure treated sole on the slab (M16 anchors, sill
       seal), studs every 600, a double top plate -- round the three outer
       sides. The two end walls run in from the outer corner to where the A's
       roof comes up to the wing's roof: on the slab out to the rafter tips,
       then their foot rides up the A's roof covering on a raked plate. Out:
       OSB 18, the membrane, battens 40 and the gables' boards; in: wool 160,
       the vapour barrier, service battens 30, gypsum 12.5. No openings yet. */
    function _buildWingWalls(ctx) {
      var T = ctx.THREE, g = ctx.group, L0 = 'aframe-wing';
      var sides = _wingSides(); if (!sides.length) return;
      var H = _wingH(sides[0]), S = _sect(), B = _barRect(), cx = (B.x0 + B.x1) / 2, t = 0.060, d = GABLE.d;
      var skinT = H.skinT;
      var yR = function (dd) { return S.top + (S.half - dd) * S.tan + skinT / S.cos; };          /* the A's roof surface at distance dd from the ridge line */
      var dMeet = H.dMeet;
      var cWood = WOOD, cPT = 0xA9A77A, cOsb = SHEATH.col, cClad = (API.colorSlotOf ? API.colorSlotOf('gable') : 0xB8875A), cIn = LINE.board.col;
      try { if (API.colorSlotOf) { var cs0 = API.colorSlotOf('ceiling'); if (cs0 != null) cIn = cs0; } } catch (eC) {}
      var mat = function (c) { return new T.MeshStandardMaterial({ color: c, roughness: 0.85, side: T.DoubleSide }); };
      var mW = mat(cWood), mPT = mat(cPT), mO = mat(cOsb), mCl = mat(cClad), mIn = mat(cIn), mDbl = mat(0xB08E5E);
      /* the layers drawn since aframe-v149 (plan H); the battens a shade off the frame's timber, so a review never keeps them as the structure */
      var WFw = woolFill(d), mMb = mat(SHEATH.membCol), mBt = mat(0xC8A679), mWo = mat(0xE9D98B), mVb = mat(0x9FB6C8), mSb = mat(0xC4A374);
      /* the EPS on the membrane from zone 4, as on the gables (aframe-v159) */
      var ciW = _ciT(), mCi = mat(CI.col);
      /* the units' outside trim (aframe-v162) */
      var mTr = mat(cClad), mTrL = mat(cClad), mTd = new T.MeshStandardMaterial({ color: API.colorSlotOf ? API.colorSlotOf('metal') : 0x8A8F94, roughness: 0.5, metalness: 0.5, side: T.DoubleSide }), trimW = { lin: 0, cas: 0, drip: 0, screw: 0, perim: 0, n: 0, units: 0, dep: 0 };
      var mMe = new T.MeshStandardMaterial({ color: (MESH_REVIEW && _isAdmin()) ? MAGENTA : 0x3A3D40, roughness: 0.6, metalness: 0.4, side: T.DoubleSide });
      var kWw0 = g.children.length;
      var amW = function (m) {
        if (m === mMb) _am(ctx, 'layer_breather_membrane', 'Breathable membrane', SHEATH.memb, 'side');
        else if (m === mCi) _am(ctx, 'layer_eps', 'EPS insulation', CI.code, 'side');
        else if (m === mTr) _am(ctx, 'windows_doors', 'Exterior trim', TRIM.cas, 'side');
        else if (m === mTrL) _am(ctx, 'windows_doors', 'Reveal lining', TRIM.lin, 'side');   /* aframe-v172 */
        else if (m === mTd) _am(ctx, 'windows_doors', 'Drip cap', TRIM.drip, 'side');
        else if (m === mBt) _am(ctx, 'layer_vented_battens', 'Battens', FAC.batt.code, 'side');
        else if (m === mMe) _am(ctx, 'layer_rodent_mesh', 'Rodent mesh', FAC.mesh, 'side');
        else if (m === mWo) _am(ctx, 'layer_studs_wool', 'Mineral wool', (WFw.mix[0] && WFw.mix[0].code) || '', 'side');
        else if (m === mVb) _am(ctx, 'layer_vapour_barrier', 'Vapour barrier', 'ROV00001', 'in');
        else if (m === mSb) _am(ctx, 'layer_service_battens', 'Service battens', 'KVR50030', 'in');
        else if (m === mPT) _am(ctx, 'sill_plate', 'Sole plate', 'KVP60160', 'side');
        else if (m === mW || m === mDbl) _am(ctx, 'wall_frame', 'Wing wall', GABLE.code, 'side');
        else if (m === mO) _am(ctx, 'layer_osb', 'OSB sheathing', SHEATH.code, 'side');
        else if (m === mCl) _am(ctx, 'sauna_ui_cladding', 'Cladding', FAC.clad.code, 'side');
        else if (m === mIn) _am(ctx, 'layer_plasterboard', 'Plasterboard', LINE.board.code, 'in');
      };
      var tot = { sole: 0, raked: 0, studs: 0, nStud: 0, plates: 0, area: 0, anch: 0, walls: 0, hdr: 0, units: {}, perim: 0, thresh: 0, sill: 0, sillIn: 0, opNotes: [], cas: 0, nCas: 0, battD: 0, nBattD: 0, mesh: 0, sbD: 0, ciA: 0, cornerA: 0 }, notes = [];
      var mCs = _trimMat(T, CASE.col);
      /* one member: a polygon in the wall's (u, v) extruded w0..w1 into the wall (w = 0 the outer face of the frame) */
      var mk = function (W, P, w0, w1, m, holes) {
        if (P.length < 3) return;
        var sh = new T.Shape(), i; sh.moveTo(P[0][0], P[0][1]); for (i = 1; i < P.length; i++) sh.lineTo(P[i][0], P[i][1]); sh.lineTo(P[0][0], P[0][1]);
        (holes || []).forEach(function (h) { var hp = new T.Path(); hp.moveTo(h[0], h[1]); hp.lineTo(h[2], h[1]); hp.lineTo(h[2], h[3]); hp.lineTo(h[0], h[3]); hp.lineTo(h[0], h[1]); sh.holes.push(hp); });
        var geo = new T.ExtrudeGeometry(sh, { depth: w1 - w0, bevelEnabled: false }); geo.translate(0, 0, w0);
        var M = new T.Matrix4(); M.makeBasis(new T.Vector3(W.u[0], 0, W.u[1]), new T.Vector3(0, 1, 0), new T.Vector3(W.i[0], 0, W.i[1])); M.setPosition(W.o[0], 0, W.o[1]);
        geo.applyMatrix4(M); amW(m); g.add(new T.Mesh(geo, m));
      };
      var area = function (P) { var a = 0, i; for (i = 0; i < P.length; i++) { var p = P[i], q = P[(i + 1) % P.length]; a += p[0] * q[1] - q[0] * p[1]; } return Math.abs(a) / 2; };
      var wall = function (W) {
        /* the outline: bottom bot(u), top top(u), u 0..W.len */
        var n = Math.max(2, Math.ceil(W.len / 0.05)), P = [], i, u;
        for (i = 0; i <= n; i++) { u = W.len * i / n; P.push([u, W.bot(u)]); }
        P.push([W.len, H.wallTop]); P.push([0, H.wallTop]);
        /* the openings in it (aframe-v112): the rough opening u0..u1, y0..y1 */
        var RO = (W.ops || []).map(function (o) {
          var ro = { o: o, u0: o.u - o.w / 2 - WOPS.gap, u1: o.u + o.w / 2 + WOPS.gap, y0: H.yP + o.sill - WOPS.gap, y1: H.yP + o.sill + o.h + WOPS.gap };
          ro.floor = (o.kind === 'door' || o.kind === 'french');
          if (ro.floor) ro.y0 = H.yP + t;
          return ro;
        }).filter(function (r) {
          var fits = r.u0 > 2 * t && r.u1 < (W.uFlat == null ? W.len : Math.min(W.len, W.uFlat)) - 2 * t && r.y1 + WOPS.hdr <= H.wallTop - 2 * t + 1e-6;
          if (!fits) tot.opNotes.push(W.name + ' ' + (r.o.code || r.o.kind) + ' at ' + Math.round(r.o.u * 1000) + ' DOES NOT FIT (kept, not built: the wall is ' + Math.round((W.uFlat == null ? W.len : W.uFlat) * 1000) + ' long on the slab, the head under the header at ' + Math.round((H.wallTop - 2 * t - WOPS.hdr - H.yP) * 1000) + ')');
          return fits;
        });
        var holes = RO.map(function (r) { return [r.u0, r.y0, r.u1, r.y1]; });
        var A = area(P) - RO.reduce(function (a, r) { return a + (r.u1 - r.u0) * (r.y1 - r.y0); }, 0); tot.area += A; tot.walls++;
        /* the sole on the flat part, a raked plate where the foot rides the roof */
        var uFlat = W.uFlat == null ? W.len : W.uFlat;
        if (uFlat > 0.02) { mk(W, [[0, H.yP], [uFlat, H.yP], [uFlat, H.yP + t], [0, H.yP + t]], 0, d, mPT); tot.sole += uFlat; tot.anch += (uFlat < 0.6) ? 1 : Math.max(2, Math.ceil((uFlat - 0.6) / 1.8) + 1); }
        if (W.len - uFlat > 0.02) {
          var PR = [], j, m2 = 20; for (j = 0; j <= m2; j++) { u = uFlat + (W.len - uFlat) * j / m2; PR.push([u, W.bot(u)]); }
          for (j = m2; j >= 0; j--) { u = uFlat + (W.len - uFlat) * j / m2; PR.push([u, W.bot(u) + t / S.cos]); }
          mk(W, PR, 0, d, mW); tot.raked += (W.len - uFlat) / S.cos;
        }
        /* the double top plate */
        mk(W, [[0, H.wallTop - 2 * t], [W.len, H.wallTop - 2 * t], [W.len, H.wallTop - t], [0, H.wallTop - t]], 0, d, mDbl);
        mk(W, [[0, H.wallTop - t], [W.len, H.wallTop - t], [W.len, H.wallTop], [0, H.wallTop]], 0, d, mW);
        tot.plates += 2 * W.len;
        /* the studs every 600, and one at each end */
        var us = [t / 2], k; for (k = 1; k * GABLE.sp < W.len - t; k++) us.push(k * GABLE.sp); us.push(W.len - t / 2);
        var inRO = function (a, b) { for (var r = 0; r < RO.length; r++) if (b > RO[r].u0 - 2 * t && a < RO[r].u1 + 2 * t) return RO[r]; return null; };
        var yTopF = H.wallTop - 2 * t;
        RO.forEach(function (r) {
          /* kings to the plates, jacks to the header, a doubled header of 60 x 160 on edge, a doubled sill with cripples under it */
          var yS = H.yP + t, yHd = r.y1 + WOPS.hdr;
          [[r.u0 - 2 * t, r.u0 - t, yTopF], [r.u1 + t, r.u1 + 2 * t, yTopF], [r.u0 - t, r.u0, r.y1], [r.u1, r.u1 + t, r.y1]].forEach(function (m9) { mk(W, [[m9[0], yS], [m9[1], yS], [m9[1], m9[2]], [m9[0], m9[2]]], 0, d, mW); tot.studs += m9[2] - yS; tot.nStud++; });
          mk(W, [[r.u0 - t, r.y1], [r.u1 + t, r.y1], [r.u1 + t, yHd], [r.u0 - t, yHd]], 0, d, mDbl); tot.hdr += 2 * (r.u1 - r.u0 + 2 * t);
          if (yTopF - yHd > 0.05) { for (var uc = Math.ceil(r.u0 / GABLE.sp) * GABLE.sp; uc < r.u1; uc += GABLE.sp) { mk(W, [[uc - t / 2, yHd], [uc + t / 2, yHd], [uc + t / 2, yTopF], [uc - t / 2, yTopF]], 0, d, mW); tot.studs += yTopF - yHd; tot.nStud++; } }
          if (!r.floor) {
            mk(W, [[r.u0, r.y0 - 2 * t], [r.u1, r.y0 - 2 * t], [r.u1, r.y0], [r.u0, r.y0]], 0, d, mDbl); tot.hdr += 2 * (r.u1 - r.u0);
            var ucs = [r.u0 + t / 2, r.u1 - t / 2]; for (var uc2 = Math.ceil(r.u0 / GABLE.sp) * GABLE.sp; uc2 < r.u1 - t; uc2 += GABLE.sp) if (uc2 > r.u0 + t) ucs.push(uc2);
            ucs.forEach(function (uu) { if (r.y0 - 2 * t - yS < 0.05) return; mk(W, [[uu - t / 2, yS], [uu + t / 2, yS], [uu + t / 2, r.y0 - 2 * t], [uu - t / 2, r.y0 - 2 * t]], 0, d, mW); tot.studs += r.y0 - 2 * t - yS; tot.nStud++; });
          }
          /* the unit, drawn as the gables draw theirs, turned into the wall, in the middle of the frame */
          var gU = new T.Group(), o = r.o, lz = [-W.u[1], W.u[0]], out = -((W.i[0] * lz[0] + W.i[1] * lz[1]) >= 0 ? 1 : -1);
          var U9 = _drawUnit(T, gU, { kind: o.kind, w: o.w, h: o.h, leaves: o.leaves, hand: o.hand }, 0, r.y0 + WOPS.gap - 0.010, 0, out);
          gU.rotation.y = Math.atan2(-W.u[1], W.u[0]); gU.position.set(W.o[0] + W.u[0] * o.u + W.i[0] * d / 2, 0, W.o[1] + W.u[1] * o.u + W.i[1] * d / 2); _am(ctx, 'windows_doors', 'Windows & doors', o.code || '', 'side'); g.add(gU);
          tot.units[o.code] = (tot.units[o.code] || 0) + 1; tot.perim += 2 * (o.w + o.h);
          if (r.floor) tot.thresh += o.w; else { tot.sill += o.w + 0.22; tot.sillIn += o.w + 0.08; }
          /* THE CASING INSIDE (aframe-v145, as the gables' units): a door on three sides, a window round all four, on the gypsum */
          var cwW = _caseW(), ctW = _caseT(), wC0 = d + LINE.batt + LINE.board.t, wC1 = wC0 + ctW, ua9 = o.u - o.w / 2, ub9 = o.u + o.w / 2, ya9 = r.floor ? (H.yP + t) : (H.yP + o.sill), yb9 = H.yP + o.sill + o.h;
          _am(ctx, 'casing', 'Casing', CASE.code, 'side');
          mk(W, [[ua9 - cwW, ya9 - (r.floor ? 0 : cwW)], [ua9, ya9 - (r.floor ? 0 : cwW)], [ua9, yb9 + cwW], [ua9 - cwW, yb9 + cwW]], wC0, wC1, mCs);
          mk(W, [[ub9, ya9 - (r.floor ? 0 : cwW)], [ub9 + cwW, ya9 - (r.floor ? 0 : cwW)], [ub9 + cwW, yb9 + cwW], [ub9, yb9 + cwW]], wC0, wC1, mCs);
          mk(W, [[ua9, yb9], [ub9, yb9], [ub9, yb9 + cwW], [ua9, yb9 + cwW]], wC0, wC1, mCs);
          if (!r.floor) mk(W, [[ua9, ya9 - cwW], [ub9, ya9 - cwW], [ub9, ya9], [ua9, ya9]], wC0, wC1, mCs);
          tot.cas += r.floor ? (2 * (yb9 - ya9) + o.w + 2 * cwW) : (2 * (yb9 - ya9) + 2 * o.w + 8 * cwW); tot.nCas++;
          tot.opNotes.push(W.name + ' ' + o.code + ' ' + Math.round(o.w * 1000) + 'x' + Math.round(o.h * 1000) + ' at ' + Math.round(o.u * 1000) + ' along, sill ' + Math.round(o.sill * 1000));
          /* THE UNIT'S OUTSIDE TRIM (aframe-v162): c out of the wall from the frame's outer face (w = d/2 - 34) */
          var wF9 = d / 2 - TRIM.frameD / 2, clO9w = SHEATH.t + FAC.memb + ciW + FAC.batt.d + FAC.clad.t;
          var tBxW = function (a0, a1, b0, b1, c0, c1, kind) { if (a1 - a0 < 0.001 || b1 - b0 < 0.001) return; mk(W, [[a0, b0], [a1, b0], [a1, b1], [a0, b1]], wF9 - c1, wF9 - c0, kind === 'drip' ? mTd : (kind === 'lin' ? mTrL : mTr)); };
          var LTw = _trimUnit(tBxW, r.u0, r.u1, r.floor ? r.y0 : (r.y0 + WOPS.gap - 0.010), r.y1, wF9 + clO9w, r.floor);
          trimW.lin += LTw.lin; trimW.cas += LTw.cas; trimW.drip += LTw.drip; trimW.screw += LTw.screw; trimW.perim += LTw.perim; trimW.n += LTw.n; trimW.units++; trimW.dep = wF9 + clO9w;
        });
        for (k = 0; k < us.length; k++) {
          if (inRO(us[k] - t / 2, us[k] + t / 2)) continue;
          var ua = us[k] - t / 2, ub = us[k] + t / 2, fa = W.bot(ua) + ((ua < uFlat) ? t : t / S.cos), fb = W.bot(ub) + ((ub < uFlat) ? t : t / S.cos), top = H.wallTop - 2 * t;
          if (top - Math.max(fa, fb) < 0.05) continue;
          mk(W, [[ua, fa], [ub, fb], [ub, top], [ua, top]], 0, d, mW);
          tot.studs += top - (fa + fb) / 2; tot.nStud++;
        }
        /* THE CORNERS CLOSED (aframe-v159): an end wall's outside layers run on past the outer wall's frame and over its
           layers' ends, each to the outer wall's face of the same layer -- the corner stood open on the layers' edges
           (OSB, membrane, battens, the EPS from zone 4); billed with the wall */
        var PL = function (wa) {
          if (!W.corner) return P;
          var u0 = -W.corner + wa, Q = [[u0, H.yP]].concat(P); Q.push([u0, H.wallTop]); return Q;
        };
        var aC = W.corner ? (W.corner + _facT() / 2) * (H.wallTop - H.yP) : 0; tot.cornerA += aC;
        /* outside: OSB and the boards; inside: the gypsum */
        mk(W, PL(-SHEATH.t), -SHEATH.t, 0, mO, holes);
        mk(W, PL(-(SHEATH.t + FAC.memb + ciW + FAC.batt.d + FAC.clad.t)), -(SHEATH.t + FAC.memb + ciW + FAC.batt.d + FAC.clad.t), -(SHEATH.t + FAC.memb + ciW + FAC.batt.d), mCl, holes);
        mk(W, P, d + LINE.batt, d + LINE.batt + LINE.board.t, mIn, holes);
        /* THE LAYERS BILLED AND NOT DRAWN, DRAWN (aframe-v149, plan H): the
           membrane on the OSB; the rainscreen battens on every stud and beside
           every opening, cut round the openings; the rodent mesh at the
           cavity's foot along the sole, broken at the doors; the wool in the
           frame (the members show through it); the vapour barrier on the
           studs' inner face; the service battens level every 400, round the
           openings and stopped at the A's roof on an end wall */
        var wMo = -(SHEATH.t + FAC.memb), wEo = wMo - ciW, wBo = wEo - FAC.batt.d, fB = FAC.batt.f;
        mk(W, PL(wMo), wMo, -SHEATH.t, mMb, holes);
        if (ciW > 0) { mk(W, PL(wEo), wEo, wMo, mCi, holes); tot.ciA += A + aC; }
        var cutR = function (r0, cuts) { var out = [r0]; cuts.forEach(function (c) { var nx = []; out.forEach(function (p) { if (c[1] <= p[0] || c[0] >= p[1]) { nx.push(p); return; } if (c[0] > p[0]) nx.push([p[0], c[0]]); if (c[1] < p[1]) nx.push([c[1], p[1]]); }); out = nx; }); return out; };
        var ub0 = us.slice(); RO.forEach(function (r) { ub0.push(r.u0 - fB / 2, r.u1 + fB / 2); });
        ub0 = ub0.map(function (u9) { return Math.max(fB / 2, Math.min(W.len - fB / 2, u9)); }).sort(function (a9, b9) { return a9 - b9; });
        var ubs = []; ub0.forEach(function (u9) { if (!ubs.length || u9 - ubs[ubs.length - 1] > fB + 0.005) ubs.push(u9); });
        ubs.forEach(function (u9) {
          var ua9 = u9 - fB / 2, ub9 = u9 + fB / 2, yb9 = Math.max(W.bot(ua9), W.bot(ub9)), cy9 = [];
          RO.forEach(function (r) { if (ub9 > r.u0 + 0.001 && ua9 < r.u1 - 0.001) cy9.push([r.y0, r.y1]); });
          cutR([yb9, H.wallTop], cy9).forEach(function (pc) { if (pc[1] - pc[0] < 0.10) return; mk(W, [[ua9, pc[0]], [ub9, pc[0]], [ub9, pc[1]], [ua9, pc[1]]], wBo, wEo, mBt); tot.battD += pc[1] - pc[0]; tot.nBattD++; });
        });
        if (uFlat > 0.05) {
          cutR([0, uFlat], RO.filter(function (r) { return r.floor; }).map(function (r) { return [r.u0, r.u1]; })).forEach(function (pc) {
            if (pc[1] - pc[0] < 0.05) return;
            mk(W, [[pc[0], H.yP - 0.002], [pc[1], H.yP - 0.002], [pc[1], H.yP], [pc[0], H.yP]], wBo, wEo, mMe);
            mk(W, [[pc[0], H.yP], [pc[1], H.yP], [pc[1], H.yP + 0.05], [pc[0], H.yP + 0.05]], wEo - 0.002, wEo, mMe);
            tot.mesh += pc[1] - pc[0];
          });
        }
        var yWt = H.wallTop - 2 * t, PW = [], iW;
        for (iW = 0; iW <= n; iW++) { u = W.len * iW / n; PW.push([u, Math.min(yWt, W.bot(u) + ((u < uFlat) ? t : t / S.cos))]); }
        PW.push([W.len, yWt]); PW.push([0, yWt]);
        mk(W, PW, 0.003, d - 0.003, mWo, holes);
        mk(W, P, d, d + 0.001, mVb, holes);
        var bW = 0.050, yq9;
        for (yq9 = H.yP + 0.10; yq9 < H.wallTop - 0.08; yq9 += 0.40) {
          var uE9 = W.len, us9;
          if (W.len - uFlat > 0.02) for (us9 = uFlat; us9 <= W.len; us9 += 0.02) if (W.bot(us9) + t / S.cos > yq9 - bW / 2 - 0.01) { uE9 = us9; break; }
          var cx9 = []; RO.forEach(function (r) { if (yq9 + bW / 2 > r.y0 && yq9 - bW / 2 < r.y1) cx9.push([r.u0, r.u1]); });
          cutR([0, uE9], cx9).forEach(function (pc) { if (pc[1] - pc[0] < 0.10) return; mk(W, [[pc[0], yq9 - bW / 2], [pc[1], yq9 - bW / 2], [pc[1], yq9 + bW / 2], [pc[0], yq9 + bW / 2]], d + LINE.vb + 0.001, d + LINE.batt, mSb); tot.sbD += pc[1] - pc[0]; });
        }
        notes.push(W.name + ' ' + W.len.toFixed(2) + ' m, ' + A.toFixed(2) + ' m2');
      };
      var q;
      for (q = 0; q < sides.length; q++) {
        var sd = sides[q], WR = _wingRect(sd), xO = (sd < 0) ? WR.x0 : WR.x1, nm = (sd < 0) ? 'left' : 'right';
        H = _wingH(sd); dMeet = H.dMeet;
        /* the outer wall, along z; its outer face on the wing's edge, inside to -sd */
        var Wo = { name: nm + ' outer', o: [xO, WR.z0], u: [0, 1], i: [-sd, 0], len: WR.z1 - WR.z0, bot: function () { return H.yP; } };
        Wo.ops = _wingOpsOn(sd, 'outer', Wo); wall(Wo);
        /* the two end walls, from the outer wall's inner face in to where the A's roof meets the wing's */
        var xIn0 = xO - sd * d, dO = Math.abs(xIn0 - cx), lenE = Math.max(0.3, dO - dMeet), uTip = Math.max(0, dO - S.half);
        var botE = function (dO2, uTip2) { return function (u) { var dd = dO2 - u; return (dd >= S.half) ? H.yP : Math.max(H.yP, yR(dd)); }; };
        var We0 = { name: nm + ' end z0', o: [xIn0, WR.z0], u: [-sd, 0], i: [0, 1], len: lenE, uFlat: uTip, bot: botE(dO, uTip), corner: d };
        var We1 = { name: nm + ' end z1', o: [xIn0, WR.z1], u: [-sd, 0], i: [0, -1], len: lenE, uFlat: uTip, bot: botE(dO, uTip), corner: d };
        We0.ops = _wingOpsOn(sd, 'z0', We0); We1.ops = _wingOpsOn(sd, 'z1', We1); wall(We0); wall(We1);
      }
      /* THE BILL: frame, anchors, sheathing, membrane, rainscreen, wool, barrier, battens, gypsum */
      var A = tot.area, WF = woolFill(d), bt = A / 0.40 * 1.0, B1 = function (c, q2) { if (q2 > 0) API.billAdd(L0, c, q2); };
      B1('KVP60160', tot.sole * 1.05); B1(GABLE.seal, tot.sole * 1.05);
      B1('FAT16010', Math.ceil(tot.anch / 2)); B1('FAT16011', tot.anch); B1('FAT16001', tot.anch * 2); B1('FAT16002', tot.anch);
      B1(GABLE.code, (tot.studs + tot.plates + tot.raked + tot.hdr) * 1.05);
      /* the units and the rows the core fixes every frame with (aframe-v112) */
      var cU; for (cU in tot.units) if (tot.units.hasOwnProperty(cU)) B1(cU, tot.units[cU]);
      if (tot.perim > 0.01) { B1(DOOR.tape, tot.perim * 2 * 1.05); B1(DOOR.foam, Math.ceil(tot.perim / DOOR.foamM)); B1(DOOR.anchor, Math.ceil(tot.perim / DOOR.anchorSp)); }
      B1('OWW00002', tot.sill * 1.05); B1('OWW00001', tot.sillIn * 1.05); B1(DOOR.thresh, tot.thresh * 1.05); B1('FAS45145', tot.nStud * 4 + Math.ceil(tot.plates / 0.40) * 2);
      if (tot.cas > 0.01) {
        B1(CASE.code, Math.round(tot.cas * 1.05 * 100) / 100); B1(CASE.nail, CASE.rows * Math.ceil(tot.cas / CASE.step));
        ctx.log('trim     wing (aframe-v145): ' + tot.nCas + ' unit(s) cased inside on the gypsum -- ' + tot.cas.toFixed(2) + ' m, BILL ' + CASE.code + ' ' + (tot.cas * 1.05).toFixed(2) + ' m (+5%), ' + (CASE.rows * Math.ceil(tot.cas / CASE.step)) + ' x ' + CASE.nail + ((TRIM_REVIEW && _isAdmin()) ? ' -- MAGENTA (under review)' : ''));
      }
      /* the outside layers over the wall and its closed corners (aframe-v159), the inside ones over the wall */
      var AO = A + tot.cornerA; _envA.wingW = A;
      B1(SHEATH.code, AO * 1.05); B1(SHEATH.nail, Math.round(AO * SHEATH.nailPerM2)); B1(SHEATH.memb, AO * 1.15); B1(SHEATH.tape, Math.round(AO / 1.4 * 10) / 10);
      B1(FAC.batt.code, (AO / FAC.batt.step) * 1.05); B1((ciW > 0) ? CI.battScrew : FAC.batt.screw, Math.round(AO / FAC.batt.step / 0.6) + 2 * tot.walls); B1(FAC.clad.code, AO * 1.08); B1(FAC.clad.nail, Math.round(AO / FAC.clad.w * 2 / 0.6));
      /* THE WING'S WALLS FOLLOW THE ZONE (aframe-v159, plan K step 2c): the gables' EPS from zone 4, the same fixings */
      if (tot.ciA > 0.01) {
        var nBdW = Math.ceil(tot.ciA / CI.board), nFoW = Math.ceil(tot.ciA / CI.foamPer);
        B1(CI.code, Math.round(tot.ciA * 1.05 * 100) / 100); B1(CI.plate, nBdW * CI.perBoard); B1(CI.screw, nBdW * CI.perBoard); B1(CI.foam, nFoW);
        ctx.log('wingwall CONTINUOUS LAYER (aframe-v159, zone ' + _iecc().cz + '): EPS ' + Math.round(ciW * 1000) + ' ' + CI.code + ' on the membrane under the battens, ' + tot.ciA.toFixed(2) + ' m2 -> ' + (tot.ciA * 1.05).toFixed(2) + ' m2 (+5%), ' + nBdW + ' board(s) x ' + CI.perBoard + ' ' + CI.plate + ' + ' + CI.screw + ', ' + nFoW + ' x ' + CI.foam + '; battens ' + CI.battScrew + '; the boards, the roof\'s edges and its gutter 40 further out');
      } else ctx.log('wingwall no continuous layer: zone ' + _iecc().cz + ' takes the R-25 cavity alone (aframe-v159)');
      _trimBill(L0, trimW, ctx, 'the wing\'s walls');
      ctx.log('wingwall corners closed (aframe-v159): the end walls\' outside layers run over the outer wall\'s ends, ' + tot.cornerA.toFixed(2) + ' m2 more of wall billed (OSB, membrane, battens, boards' + (ciW > 0 ? ', EPS' : '') + ')');
      /* the rodent mesh the gables have, the wing's walls had not (aframe-v149) */
      B1(FAC.mesh, Math.round(tot.mesh * 1.05 * 100) / 100);
      ctx.log('wingwall drawn now (aframe-v149): membrane ' + SHEATH.memb + ', ' + tot.nBattD + ' rainscreen batten piece(s) ' + tot.battD.toFixed(1) + ' m (billed by the area: ' + (A / FAC.batt.step * 1.05).toFixed(1) + ' m), wool ' + _woolTxt(WFw) + ' in the frame, barrier ROV00001, service battens ' + tot.sbD.toFixed(1) + ' m (billed ' + (bt * 1.05).toFixed(1) + ' m); rodent mesh ' + FAC.mesh + ' ' + tot.mesh.toFixed(2) + ' m along the soles, broken at the doors -- BILL ' + (tot.mesh * 1.05).toFixed(2) + ' m (NEW, the gables\' rule)' + ((MESH_REVIEW && _isAdmin()) ? ' -- the mesh MAGENTA until checked' : ''));
      /* THE WING'S WALLS UNDER REVIEW (aframe-v149, plan H): the frame is the structure, the rest by its walk item */
      if (_isAdmin() && AF_STEP.wingwall < 99) {
        var phW = { layer_osb: 'osb', layer_breather_membrane: 'memb', windows_doors: 'units', layer_eps: 'ci', layer_vented_battens: 'batt', layer_rodent_mesh: 'batt', sauna_ui_cladding: 'clad',
                    layer_studs_wool: 'wool', layer_vapour_barrier: 'vb', layer_service_battens: 'sbatt', layer_plasterboard: 'board', casing: 'case' };
        var nWr = _rvTagList(T, g.children.slice(kWw0), function (o) { return phW[_asmKey(o)] || ''; }, _wingWallDefs(), AF_STEP.wingwall);
        var LWw = _wingWallLayers();
        ctx.log('wingwall review step ' + AF_STEP.wingwall + ' of ' + LWw.length + ' (' + (LWw[AF_STEP.wingwall - 1] || '?') + '): ' + nWr.rv + ' bod(ies) MAGENTA, ' + nWr.un + ' under it in their colours, ' + nWr.ab + ' over it hidden (billed); the frame drawn, the wing\'s roof as the structure');
      }
      WF.mix.forEach(function (mx) { B1(mx.code, A * mx.n * 1.05); });
      B1('ROV00001', A * 1.10); B1('INS01005', Math.round(A / 1.4 * 10) / 10);
      B1('KVR50030', bt * 1.05); B1('FAS60100', Math.round(bt / GABLE.sp));
      B1(LINE.board.code, A * LINE.board.waste); B1(LINE.board.screw, Math.round(A * LINE.board.screwPerM2)); B1(LINE.board.tape, Math.round(A / 2.88 * 3.6 * 10) / 10); B1(LINE.board.filler, Math.round(A * LINE.board.fillerKgM2 * 10) / 10);
      /* the primer on the gypsum, the barrier and the membrane stapled, the barrier's foot on the slab in butyl (aframe-v153) */
      _chemBill(L0, A, 2 * A, tot.sole); _chemNote(ctx, 'wing walls', A, 2 * A, tot.sole);
      ctx.log('wingwall heights: floor 2 at ' + Math.round(H.y2 * 1000) + ', the roof deck ' + Math.round(H.deckTop * 1000) + ' (a ' + Math.round(WROOF.step * 1000) + ' step down), walls to ' + Math.round(H.wallTop * 1000) + ' = ' + Math.round((H.wallTop - H.yP) * 1000) + ' over the slab, about ' + Math.round((H.wallTop - H.yP - LINE.batt - LINE.board.t) * 1000) + ' clear under the ceiling to come; the A\'s roof met at ' + Math.round(dMeet * 1000) + ' from the ridge line');
      ctx.log('wingwall ' + notes.join('; ') + ' (the openings taken off)');
      if (_wopNote) ctx.log(_wopNote);
      ctx.log('wingops  ' + (tot.opNotes.length ? tot.opNotes.join('; ') : 'none') + ' | BILL ' + Object.keys(tot.units).map(function (c) { return tot.units[c] + ' x ' + c; }).join(', ') + ', joint ' + tot.perim.toFixed(2) + ' m: ' + DOOR.tape + ' both faces, ' + DOOR.foam + ', ' + DOOR.anchor + ' at 700; sills OWW00002 ' + (tot.sill * 1.05).toFixed(2) + ' m / OWW00001 ' + (tot.sillIn * 1.05).toFixed(2) + ' m; kings, jacks, doubled headers and sills ' + GABLE.code + ' (headers and sills ' + tot.hdr.toFixed(2) + ' m, in the frame metres)');
      ctx.log('wingwall BILL sole KVP60160 ' + (tot.sole * 1.05).toFixed(1) + ' m + seal ' + GABLE.seal + ', ' + tot.anch + ' M16 anchor(s); frame ' + GABLE.code + ' ' + ((tot.studs + tot.plates + tot.raked) * 1.05).toFixed(1) + ' m (' + tot.nStud + ' studs, double top plate, raked plate on the roof ' + tot.raked.toFixed(1) + ' m), FAS45145; ' + A.toFixed(2) + ' m2 of wall: OSB ' + SHEATH.code + ', membrane ' + SHEATH.memb + ', battens ' + FAC.batt.code + ', boards ' + FAC.clad.code + ' +8%; wool ' + _woolTxt(WF) + ', barrier ROV00001, service battens KVR50030, gypsum ' + LINE.board.code + ' with screws, tape and filler');
    }
    /* THE WING OPENS INTO THE HOUSE (aframe-v103, Marek: plne otevrit). Under
       the wing's roof the A's slope is taken out: a beam of two 60 x 240
       along the house, its top under the rafters where their underside comes
       down to the wing's joist top, carries the rafters above it (they stop
       on it) and the wing's joists in hangers; posts 100 x 100 under it at
       both ends and no more than 3.0 m apart, on the slab with a pad in it.
       Below the beam the rafters, the skin and the lining go in the wing's
       length (between its end walls). */
    var WBEAM = { w: 0.120, h: 0.240, postW: 0.100, maxSp: 3.00 };
    function _wingBeam(sd) {
      var WR = _wingRect(sd), H = _wingH(sd), S = _sect(), R = _rafSize(), jt = H.wallTop + WROOF.joist;
      var dB = S.half - R.d / S.sin - (jt - S.top) / S.tan;
      /* THE SKIN'S FOOT (aframe-v108): the slope's skin goes on past the cut rafters down to the wing's OSB top (on sprockets), measured on the rafters' top face from the ridge line */
      var yT0 = S.top + S.half * S.tan, yFoot = jt + H.fire + WROOF.osb, sFoot = Math.max((dB + WBEAM.w / 2) / S.cos + 0.02, (yT0 - yFoot) / S.sin);
      return { sd: sd, dB: dB, uCut: dB + WBEAM.w / 2, top: jt, bot: jt - WBEAM.h, zIa: WR.z0 + GABLE.d, zIb: WR.z1 - GABLE.d, H: H, WR: WR,
               sFoot: sFoot, dFoot: sFoot * S.cos, yFoot: yT0 - sFoot * S.sin, yT0: yT0 };
    }
    /* THE POSTS UNDER THE BEAM STAND IN THE PARTITION'S JOINTS (aframe-v110):
       at both ends against the end walls, and on the rafter lines where two
       pieces of the partition meet -- always the axis (between the two doors),
       then outward on as few lines as keep the beam's span within its 3 m. A
       bay cut in the plan is then a clean opening between two posts, and no
       post ever stands in a doorway. */
    function _wingPosts(sd) { return []; }      /* no posts since aframe-v123: the beam hangs under the whole rafters */
    function _wingPostsOld(sd) {
      var WB = _wingBeam(sd), WG = _wingGrid(), hp = WBEAM.postW / 2, a = WB.zIa + hp, b = WB.zIb - hp, out = [a, b], i;
      var lines = WG.lines.filter(function (z) { return z > a + 0.05 && z < b - 0.05; });
      if (b - a > WBEAM.maxSp && lines.some(function (z) { return Math.abs(z - WG.cz) < 0.001; })) out.push(WG.cz);
      [[-1, a], [1, b]].forEach(function (E) {
        var dir = E[0], end = E[1], last = (out.indexOf(WG.cz) >= 0) ? WG.cz : end, far = (last === WG.cz) ? end : null;
        if (far == null) return;
        var cand = lines.filter(function (z) { return (dir < 0) ? (z < WG.cz - 0.001) : (z > WG.cz + 0.001); }).sort(function (p, q) { return dir < 0 ? q - p : p - q; });
        var prev = last, k2 = 0;
        while (Math.abs(far - prev) > WBEAM.maxSp && k2 < 50) {
          var best = null;
          for (i = 0; i < cand.length; i++) if (Math.abs(cand[i] - prev) <= WBEAM.maxSp && Math.abs(cand[i] - prev) > 0.01) best = cand[i];
          if (best == null) break;
          out.push(best); prev = best; k2++;
        }
      });
      if (out.indexOf(WG.cz) < 0 && b - a > WBEAM.maxSp) {
        var prv = a, guard = 0;
        while (b - prv > WBEAM.maxSp && guard++ < 50) { var bst = null; for (i = 0; i < lines.length; i++) if (lines[i] - prv <= WBEAM.maxSp && lines[i] > prv + 0.01) bst = lines[i]; if (bst == null) break; out.push(bst); prv = bst; }
      }
      return out.sort(function (p, q) { return p - q; });
    }
    function _wingBeamAt(side, z) {
      var sides = _wingSides(), q;
      for (q = 0; q < sides.length; q++) if (sides[q] === side) { var WB = _wingBeam(side); if (z > WB.zIa + 0.001 && z < WB.zIb - 0.001) return WB; }
      return null;
    }
    /* THE PARTITION BETWEEN THE HOUSE AND THE WING (aframe-v109, Marek:
       automaticky pricka, cut funkci mezi krokvemi zrusit a propojit, mezi
       krokve dvere). On the ground floor, under each wing's beam, a partition
       is laid for the floorplan: one piece per rafter bay, from rafter line to
       rafter line (the outer pieces from the end walls' faces), each its own
       partition, so the plan's cut takes away exactly one bay and opens the
       wing into the house there. The two middle bays -- the door bays under
       the dormer -- get a door each. The pieces are the core's ordinary
       partitions (STATE.parts, doors in STATE.doors): drawn, dragged, cut and
       billed as any other; this only lays them. Their ids are kept in the
       wing's bag with the grid they were laid on; a piece that is gone was cut
       and stays cut; when the grid changes (width in bays, slid along) the
       pieces are laid again on the new lines, the cut bays kept by their
       number; the wing switched off takes its pieces and their doors away. */
    var WPART = { doorW: 0.80 };
    var _wpNote = '';
    /* NO PARTITION UNDER THE WING ANY MORE (aframe-v123, Marek: nedelej pricku v prvnim patre pod hranou kridla,
       nech prazdny prostor, uzivatel sam zvoli; ani dvere): what an earlier version laid is taken away once, the
       rest of the plan is the user's; the floor 2 edge and the rafters are drawn over the ground floor's plan */
    function _wingPartsSync() {
      var W0 = _wingBag(), bag = W0.parts;
      if (!bag) { _wpNote = ''; return; }
      var kill = {}, n = 0, k; for (k in bag) if (bag.hasOwnProperty(k) && bag[k] && bag[k].ids) bag[k].ids.forEach(function (id) { if (id != null) { kill[id] = true; n++; } });
      STATE.parts = (STATE.parts || []).filter(function (p) { return !(p && kill[p.id]); });
      STATE.doors = (STATE.doors || []).filter(function (d) { return !(d && kill[d.pid]); });
      delete W0.parts;
      _wpNote = 'wingpart the partition under the wing\'s edge (laid by aframe-v109..v122) taken away: ' + n + ' piece(s) and their doors -- the ground floor under the wing is left open';
    }
    function _wingPartsSyncOld() {
      var W0 = _wingBag(), bag = W0.parts = W0.parts || {}, ps = (STATE.parts = STATE.parts || []), ds = (STATE.doors = STATE.doors || []);
      var ok = false; try { ok = _wingOk(); } catch (eOk) { ok = false; }
      var on = ok ? _wingSides() : [], notes = [], i;
      var have = {}; for (i = 0; i < ps.length; i++) if (ps[i] && ps[i].id != null) have[ps[i].id] = ps[i];
      var drop = function (ids) {
        var kill = {}; ids.forEach(function (id) { kill[id] = true; });
        STATE.parts = ps = ps.filter(function (p) { return !(p && kill[p.id]); });
        STATE.doors = ds = ds.filter(function (d) { return !(d && kill[d.pid]); });
      };
      ['L', 'R'].forEach(function (key) {
        var sd = (key === 'L') ? -1 : 1, E = bag[key];
        if (on.indexOf(sd) < 0) {
          if (E && E.ids) { drop(E.ids.filter(function (x) { return x != null; })); notes.push(key + ' removed (the wing is off)'); }
          delete bag[key]; return;
        }
        var WG = _wingGrid(), WB = _wingBeam(sd), S = _sect(), B = _barRect(), cx = (B.x0 + B.x1) / 2, x = cx + sd * WB.dB;
        var zs = WG.lines.slice(); zs[0] = Math.max(zs[0], WB.zIa); zs[zs.length - 1] = Math.min(zs[zs.length - 1], WB.zIb);
        var nB = zs.length - 1, sig = Math.round(x * 1000) + '|' + zs.map(function (z) { return Math.round(z * 1000); }).join(',');
        var cut = [];
        if (E && E.ids) E.ids.forEach(function (id, j) { if (id == null || !have[id]) cut.push(j); });
        if (E && E.sig === sig) {
          E.cut = cut;
          notes.push(key + ' ' + nB + ' bay(s), ' + (nB - cut.length) + ' standing' + (cut.length ? ', cut: ' + cut.join(',') : ''));
          return;
        }
        if (E && E.ids) drop(E.ids.filter(function (x2) { return x2 != null; }));
        var keepCut = (E && E.ids && E.ids.length === nB) ? cut : [];
        var next = 0; for (i = 0; i < ps.length; i++) if (ps[i] && (ps[i].id | 0) > next) next = ps[i].id | 0;
        var ids = [], mid = WG.odd ? [Math.floor(nB / 2)] : [nB / 2 - 1, nB / 2], nD = 0;
        for (var j = 0; j < nB; j++) {
          if (keepCut.indexOf(j) >= 0) { ids.push(null); continue; }
          var id = ++next;
          ps.push({ id: id, o: 'v', dir: 'v', c: x, at: x, a: zs[j], b: zs[j + 1], st: 0 });
          ids.push(id);
          if (mid.indexOf(j) >= 0 && zs[j + 1] - zs[j] > WPART.doorW + 0.20) { ds.push({ pid: id, u: (zs[j] + zs[j + 1]) / 2, w: WPART.doorW, sw: (j === mid[0]) ? 1 : 0, slide: 0, pass: false }); nD++; }
        }
        bag[key] = { sig: sig, ids: ids, cut: keepCut.slice() };
        notes.push(key + ' laid: ' + nB + ' piece(s) at x ' + Math.round(x * 1000) + ' under the beam, z ' + zs.map(function (z) { return Math.round(z * 1000); }).join('/') + ', ' + nD + ' door(s) ' + Math.round(WPART.doorW * 1000) + ' in the middle bay(s)' + (keepCut.length ? ', bays ' + keepCut.join(',') + ' kept cut' : '') + (E ? ' (the grid changed)' : ''));
      });
      _wpNote = notes.length ? ('wingpart ' + notes.join('; ')) : '';
    }
    function _wingPartOf(id) {
      var W0 = _wingBag(), bag = W0.parts || {}, k;
      for (k in bag) if (bag.hasOwnProperty(k) && bag[k] && bag[k].ids && bag[k].ids.indexOf(id) >= 0) return (k === 'L') ? -1 : 1;
      return 0;
    }
    /* THE WAY OUT ONTO THE WING'S ROOF, SUNK INTO THE SLOPE (aframe-v114,
       Marek: vikyr ma byt zapusteny dovnitr, zadny vystupek na strese). No
       box stands out of the roof any more: over the wing's two door bays the
       slope's skin is cut away from a line high up the roof down to the
       walked roof, and each bay becomes an open slot between its rafters --
       the rafter on the axis stays whole and runs through between the two
       slots, the trimmers (doubled) are the slots' sides. At the back of each
       slot, where the rafters' underside has come up high enough over floor 2
       for a door, stands a short wall with the door in it (the threshold on
       floor 2, a 100 step down onto the slot's floor); a header of the
       rafters' own stock closes the skin's cut edge over it. The slot's floor
       is the wing's walked roof carried on in: joists in hangers on a header
       at the door wall, OSB, the membrane, the sleepers and the decking, one
       level with the terrace. The rafters' tops in the slot get a metal cap. */
    var DORM = { doorW: 1.00, doorH: 2.10, plate: 0.060, wallT: 0.100, cap: 'TBD.recessCap', triT: 0.160, triCode: 'KVH60160' };
    /* THE DORMER FOLLOWS THE ZONE (aframe-v160, plan K step 2d, variant A):
       the side triangles' frame 160 deep instead of 100 (R-25 as the gables),
       grown INTO THE ROOM so the slot beside the door keeps its width; the
       door wall keeps its 100 frame (R-18.1) and takes the EPS outside, on
       the walked roof's side: none in zone 2 (13), one 40 in zone 3 (13+5),
       two 40 = 80 from zone 4 (13+10), the battens screwed through it
       (FAS60160 over 40, FAS80200 over 80). The triangles from zone 4 (20+5
       asked of R-25 alone) are carried by the total UA check (insul) */
    function _dormCi() {
      if (!IECC_Z) return 0;
      var Z = _iecc(), cav = _rOf(woolFill(DORM.wallT).t, R_IN.wool), n;
      for (n = 0; n <= 2; n++) { var rC = _rOf(n * CI.t, R_IN.eps); if (Z.wall.some(function (w) { return cav >= w[0] - 0.5 && rC >= w[1] - 0.5; })) return n * CI.t; }
      return 2 * CI.t;
    }
    function _dormer(sd) {
      var WR = _wingRect(sd), H = _wingH(sd), WB = _wingBeam(sd), S = _sect(), R = _rafSize(), fl = floors(), t = R.t;
      if (fl.length < 2) return null;
      var WG = _wingGrid(), y2 = fl[1].y, yT0 = S.top + S.half * S.tan, lin = R.d / S.cos;
      var yNeed = y2 + DORM.doorH + DORM.plate + 0.02;
      var dD = Math.max(0.10, (yT0 - lin - yNeed) / S.tan), yU = yT0 - dD * S.tan - lin;
      var sTop = (dD + R.d * S.sin) / S.cos;
      var zL = WG.trim[0], zR = WG.trim[1];
      var bays = WG.odd ? [[zL + 1.5 * t, zR - 1.5 * t]] : [[zL + 1.5 * t, WG.cz - t / 2], [WG.cz + t / 2, zR - 1.5 * t]];
      return { sd: sd, zc: WG.cz, zL: zL, zR: zR, t: t, bays: bays, axis: WG.axis, dD: dD, yU: yU, sTop: sTop, dTop: dD, y2: y2, yNeed: yNeed,
               deckTop: H.deckTop, dF: H.dAt(H.deckTop) - 0.02, H: H, WB: WB, cx: H.cx, R: R, yT0: yT0, floorW: S.widthAt(y2) / 2 };
    }
    function _dormerAt(side, z) {
      var sides = _wingSides(), q;
      for (q = 0; q < sides.length; q++) if (sides[q] === side) { var D = _dormer(side); if (D && Math.abs(z - D.zc) < 0.01) return D; }
      return null;
    }
    function _buildDormer(ctx, sd) {
      var T = ctx.THREE, g = ctx.group, D = _dormer(sd);
      if (!D) { ctx.log('dormer   ' + (sd < 0 ? 'left' : 'right') + ': no second floor, no way out'); return null; }
      /* SAID OUT LOUD (aframe-v151): where the A is too low at floor 2 the door wall goes to the ridge line and the door still does not fit */
      if (D.yU < D.yNeed - 0.001) ctx.log('dormer   ' + (sd < 0 ? 'left' : 'right') + ' SHORT: the door ' + Math.round(DORM.doorH * 1000) + ' with its plate needs the rafters\' underside at ' + Math.round(D.yNeed * 1000) + ', it is ' + Math.round(D.yU * 1000) + ' even at the door wall ' + Math.round(D.dD * 1000) + ' from the ridge line -- ' + Math.round((D.yNeed - D.yU) * 1000) + ' short (a steeper or wider A, or a lower door; the door stays drawn)');
      var S = _sect(), R = D.R, t = D.t, X = function (d) { return D.cx + sd * d; };
      var mat = function (c) { return new T.MeshStandardMaterial({ color: c, roughness: 0.85, side: T.DoubleSide }); };
      var cClad = (API.colorSlotOf ? API.colorSlotOf('gable') : 0xB8875A), mCl = mat(cClad), mW = mat(WOOD), mCap = mat(API.colorSlotOf ? API.colorSlotOf('metal') : 0x3A3D40);
      /* the layers' materials up front (aframe-v151): the door wall is drawn in them now, inside the slots' loop */
      var mWo = mat(PWOOL ? PWOOL.col : 0xE8D9A0), mOs = mat(SHEATH.col), mGy = mat((API.colorSlotOf && API.colorSlotOf('ceiling') != null) ? API.colorSlotOf('ceiling') : LINE.board.col);
      var mMb = mat(SHEATH.membCol), mBt = mat(0xC8A679), mVb = mat(0x9FB6C8), kD0 = g.children.length;
      /* the triangles' 160 wool and the door wall's EPS (aframe-v160) */
      var mWo6 = mat(PWOOL ? PWOOL.col : 0xE8D9A0), mCiD = mat(CI.col), ciD = _dormCi();
      var amD = function (m) {
        if (m === mMb) _am(ctx, 'layer_breather_membrane', 'Breathable membrane', SHEATH.memb, 'side');
        else if (m === mBt) _am(ctx, 'layer_vented_battens', 'Battens', FAC.batt.code, 'side');
        else if (m === mVb) _am(ctx, 'layer_vapour_barrier', 'Vapour barrier', 'ROV00001', 'in');
        else if (m === mW) _am(ctx, 'dormer_frame', 'Dormer frame', 'KVH10060', 'side');
        else if (m === mCl) _am(ctx, 'sauna_ui_cladding', 'Cladding', FAC.clad.code, 'side');
        else if (m === mWo) _am(ctx, 'dormer_wool', 'Mineral wool', ((woolFill(DORM.wallT).mix || [])[0] || {}).code || '', 'side');
        else if (m === mWo6) _am(ctx, 'dormer_wool', 'Mineral wool', ((woolFill(DORM.triT).mix || [])[0] || {}).code || '', 'side');
        else if (m === mCiD) _am(ctx, 'layer_eps', 'EPS insulation', CI.code, 'side');
        else if (m === mOs) _am(ctx, 'layer_osb', 'OSB sheathing', SHEATH.code, 'side');
        else if (m === mGy) _am(ctx, 'layer_plasterboard', 'Plasterboard', LINE.board.code, 'in');
        else if (m === mDr) _am(ctx, 'roof_edges', 'Drip edge', 'ROM02401', 'top');
        else if (m === mCap) _am(ctx, 'roof_edges', 'Cap', DORM.cap, 'top');
      };
      var sec = function (P, z0, z1, m) { if (z1 - z0 < 0.005) return; var sh = new T.Shape(), i; sh.moveTo(X(P[0][0]), P[0][1]); for (i = 1; i < P.length; i++) sh.lineTo(X(P[i][0]), P[i][1]); sh.lineTo(X(P[0][0]), P[0][1]); var geo = new T.ExtrudeGeometry(sh, { depth: z1 - z0, bevelEnabled: false }); geo.translate(0, 0, z0); amD(m); g.add(new T.Mesh(geo, m)); };
      var tot = { hdr: 0, wallA: 0, wallFr: 0, cap: 0, door: null, nDoor: 0, drip: 0, apron: 0, sideTape: 0, verge: 0, triFr: 0, axFr: 0, triOut: 0, triIn: 0, triA: 0, dM: 0, cas: 0, ciD: ciD };
      var mCsD = _trimMat(T, CASE.col);
      var nx = S.sin, ny = S.cos, dx = S.cos, dy = -S.sin;          /* out of the roof, down the slope, in the (d, y) section */
      /* ONE PIECE OF THE DOOR WALL IN ITS LAYERS (aframe-v151): d0..d1 across the wall, ya..yb, za..zb along the slot; the
         frame member or the wool in the frame (wI..dD), OSB, membrane, a batten where asked, the boards, the barrier, the gypsum */
      var wI = D.dD - DORM.wallT, clO9 = SHEATH.t + FAC.memb + ciD + FAC.batt.d + FAC.clad.t, nWp = 0, bO9 = SHEATH.t + FAC.memb + ciD;
      var rectD = function (d0, d1, ya, yb, za, zb, m) { if (d1 - d0 < 0.0004 || yb - ya < 0.005 || zb - za < 0.002) return; sec([[d0, ya], [d1, ya], [d1, yb], [d0, yb]], za, zb, m); };
      var wallPc = function (za, zb, ya, yb, inFrame, bz) {
        if (zb - za < 0.005 || yb - ya < 0.005) return;
        if (inFrame === 'stud') rectD(wI, D.dD, ya, yb, za, zb, mW);
        else { rectD(wI, D.dD, ya, ya + 0.06, za, zb, mW); rectD(wI, D.dD, yb - 0.06, yb, za, zb, mW); rectD(wI + 0.002, D.dD - 0.002, ya + 0.06, yb - 0.06, za + 0.002, zb - 0.002, mWo); }
        rectD(D.dD, D.dD + SHEATH.t, ya, yb, za, zb, mOs);
        rectD(D.dD + SHEATH.t, D.dD + SHEATH.t + FAC.memb, ya, yb, za, zb, mMb);
        if (ciD > 0) rectD(D.dD + SHEATH.t + FAC.memb, D.dD + bO9, ya, yb, za, zb, mCiD);
        if (bz) rectD(D.dD + bO9, D.dD + bO9 + FAC.batt.d, ya, yb, bz[0], bz[1], mBt);
        rectD(D.dD + clO9 - FAC.clad.t, D.dD + clO9, ya, yb, za, zb, mCl);
        rectD(wI - 0.001, wI, ya, yb, za, zb, mVb);
        rectD(wI - 0.001 - LINE.board.t, wI - 0.001, ya, yb, za, zb, mGy);
        nWp++;
      };
      var sFoot = D.WB.sFoot, pT = function (s9) { return [s9 * S.cos, D.yT0 - s9 * S.sin]; };
      D.bays.forEach(function (b) {
        var bw = b[1] - b[0], zm = (b[0] + b[1]) / 2;
        /* the header over the cut: the rafters' stock, square to the slope, from their underside at the door wall to their top */
        var u0 = [D.dD, D.yU], u1 = [D.dD + R.d * nx, D.yU + R.d * ny];
        sec([u0, u1, [u1[0] + t * dx, u1[1] + t * dy], [u0[0] + t * dx, u0[1] + t * dy]], b[0], b[1], mW); tot.hdr += bw;
        /* the door wall: its plate under the header, the panel over the door, clad outside */
        var DD = { w: Math.min(DORM.doorW, bw - 0.12), h: DORM.doorH, leaves: 1 }, yHd = D.y2 + DD.h;
        /* THE DOOR WALL IN ITS LAYERS (aframe-v151): a stud each side of the door to the plate, a head over it and the
           plate under the header with the wool between, outside OSB, membrane, a batten on each stud, the boards;
           inside the barrier and the gypsum (it was one block in the boards' colour) */
        var jw = (bw - DD.w) / 2;
        tot.wallA += bw * (D.yU - yHd); tot.wallFr += 2 * bw + 2 * (D.yU - D.y2);
        if (jw > 0.01) {
          wallPc(b[0], b[0] + jw, D.y2, D.yU, 'stud', [b[0], b[0] + Math.min(jw, FAC.batt.f)]);
          wallPc(b[1] - jw, b[1], D.y2, D.yU, 'stud', [b[1] - Math.min(jw, FAC.batt.f), b[1]]);
          tot.wallA += 2 * jw * DD.h;
        }
        wallPc(b[0] + Math.max(0, jw), b[1] - Math.max(0, jw), yHd, D.yU, 'panel', null);
        var gD = new T.Group(); _glassDoor(T, gD, 0, 0, DD, 0, 1);
        gD.rotation.y = (sd < 0) ? Math.PI / 2 : -Math.PI / 2; gD.position.set(X(D.dD - DORM.wallT / 2), D.y2, zm); _am(ctx, 'windows_doors', 'Windows & doors', GLZ_DOORS.upper.code, 'side'); g.add(gD);
        tot.door = DD; tot.nDoor++;
        /* THE CASING ON THE ROOM'S FACE (aframe-v145): two legs and a head round the door */
        var cwD = _caseW(), ctD = _caseT(), dI = wI - 0.001 - LINE.board.t, zl = zm - DD.w / 2, zr = zm + DD.w / 2;
        _am(ctx, 'casing', 'Casing', CASE.code, 'side');
        sec([[dI - ctD, D.y2], [dI, D.y2], [dI, yHd + cwD], [dI - ctD, yHd + cwD]], zl - cwD, zl, mCsD);
        sec([[dI - ctD, D.y2], [dI, D.y2], [dI, yHd + cwD], [dI - ctD, yHd + cwD]], zr, zr + cwD, mCsD);
        sec([[dI - ctD, yHd], [dI, yHd], [dI, yHd + cwD], [dI - ctD, yHd + cwD]], zl, zr, mCsD);
        tot.cas += 2 * DD.h + DD.w + 2 * cwD;
      });
      /* THE TRIANGLES AT THE SLOTS' SIDES, FILLED (aframe-v126, Marek: prazdne trojuhelniky na bocich -- z venku obklad,
         ram pro izolaci a dovnitr sdk; mezi dvermi vypln). Under each side of the cut, between the slot's floor, the door
         wall and the rafters' underside, a wall under the doubled trimmer: a sole on the floor, studs every 600 up to the
         rafters, wool between them, outside (into the slot) the gables' build-up -- OSB, membrane, battens, boards --
         inside the vapour barrier and gypsum. Under the axis rafter between two slots both faces are outside: the frame
         clad both ways. In the door wall the strip over the axis rafter's line is closed too. */
      var lin9 = R.d / S.cos, yFl = D.deckTop, dM = (D.yT0 - lin9 - yFl) / S.tan, yUn = function (d9) { return D.yT0 - d9 * S.tan - lin9; };
      var TRI = [[D.dD, yFl], [D.dD, D.yU], [dM, yFl]], triA = 0.5 * (dM - D.dD) * (D.yU - yFl);
      var clO = SHEATH.t + FAC.memb + FAC.batt.d + FAC.clad.t;
      var frame9 = function (za, zb, key) {
        key = key || 'triFr';
        sec([[D.dD, yFl], [dM, yFl], [dM - 0.06 / S.tan, yFl + 0.06], [D.dD, yFl + 0.06]], za, zb, mW); tot[key] += dM - D.dD;
        var dq9; for (dq9 = D.dD + 0.03; dq9 < dM - 0.10; dq9 += 0.60) { var yt9 = yUn(dq9 + 0.03); if (yt9 - yFl < 0.12) break; sec([[dq9 - 0.03, yFl + 0.06], [dq9 + 0.03, yFl + 0.06], [dq9 + 0.03, yUn(dq9 + 0.03)], [dq9 - 0.03, yUn(dq9 - 0.03)]], za, zb, mW); tot[key] += yt9 - yFl - 0.06; }
      };
      /* the triangle's battens between z0 and z1: on every stud, and one under the rake (aframe-v151) */
      var triBatt = function (z0, z1) {
        var dq9; for (dq9 = D.dD + 0.03; dq9 < dM - 0.10; dq9 += 0.60) { if (yUn(dq9 + 0.03) - yFl < 0.12) break; sec([[dq9 - 0.03, yFl], [dq9 + 0.03, yFl], [dq9 + 0.03, yUn(dq9 + 0.03)], [dq9 - 0.03, yUn(dq9 - 0.03)]], z0, z1, mBt); }
        sec([[D.dD, yUn(D.dD) - 0.06], [D.dD, yUn(D.dD)], [dM, yFl], [dM - 0.06 / S.tan, yFl]], z0, z1, mBt);
      };
      /* face: the slot side's plane; into: +1 when the slot is on +z of it */
      var sideWall = function (face, into) {
        var zi = function (a9, b9) { return into > 0 ? [face + a9, face + b9] : [face - b9, face - a9]; }, zz;
        /* the frame 160 deep into the room (aframe-v160): the slot keeps its width */
        var tT = DORM.triT;
        zz = zi(-tT, 0); frame9(zz[0], zz[1], 'triFr');
        zz = zi(-tT + 0.002, -0.002); sec(TRI, zz[0], zz[1], mWo6);
        zz = zi(0, SHEATH.t); sec(TRI, zz[0], zz[1], mOs);
        /* the membrane, a batten on every stud and one under the rake, the barrier (aframe-v151: billed, not drawn) */
        zz = zi(SHEATH.t, SHEATH.t + FAC.memb); sec(TRI, zz[0], zz[1], mMb);
        zz = zi(SHEATH.t + FAC.memb, SHEATH.t + FAC.memb + FAC.batt.d); triBatt(zz[0], zz[1]);
        zz = zi(clO - FAC.clad.t, clO); sec(TRI, zz[0], zz[1], mCl);
        zz = zi(-tT - 0.001, -tT); sec(TRI, zz[0], zz[1], mVb);
        zz = zi(-tT - 0.001 - LINE.board.t, -tT - 0.001); sec(TRI, zz[0], zz[1], mGy);
        tot.triOut += triA; tot.triIn += triA;
      };
      sideWall(D.bays[0][0], 1);
      sideWall(D.bays[D.bays.length - 1][1], -1);
      if (D.axis != null) {
        var za9 = D.zc - t / 2, zb9 = D.zc + t / 2;
        frame9(za9, zb9, 'axFr');
        sec(TRI, za9 - SHEATH.t, za9, mOs); sec(TRI, zb9, zb9 + SHEATH.t, mOs);
        sec(TRI, za9 - SHEATH.t - FAC.memb, za9 - SHEATH.t, mMb); sec(TRI, zb9 + SHEATH.t, zb9 + SHEATH.t + FAC.memb, mMb);
        triBatt(za9 - SHEATH.t - FAC.memb - FAC.batt.d, za9 - SHEATH.t - FAC.memb); triBatt(zb9 + SHEATH.t + FAC.memb, zb9 + SHEATH.t + FAC.memb + FAC.batt.d);
        sec(TRI, za9 - clO, za9 - clO + FAC.clad.t, mCl); sec(TRI, zb9 + clO - FAC.clad.t, zb9 + clO, mCl);
        tot.triOut += 2 * triA;
        /* the door wall over the axis rafter's line, in its layers (aframe-v151) */
        wallPc(za9, zb9, D.y2, D.yU, 'stud', [za9, zb9]);
        tot.wallA += t * (D.yU - D.y2); tot.wallFr += 2 * (D.yU - D.y2);
      }
      tot.triA = triA; tot.dM = dM;
      /* the metal cap on the rafters' tops in the slots: over the axis rafter, and over each slot's side where the skin is cut */
      var capRun = function (z0, z1) { var a = pT(D.sTop), b = pT(sFoot); sec([a, b, [b[0] + 0.004 * nx, b[1] + 0.004 * ny], [a[0] + 0.004 * nx, a[1] + 0.004 * ny]], z0, z1, mCap); tot.cap += sFoot - D.sTop; };
      /* a drip edge along the header's underside over each door wall, and an apron where the covering above meets the header (aframe-v116) */
      var mDr = mat(API.colorSlotOf ? API.colorSlotOf('metal') : 0x8A8F94);
      D.bays.forEach(function (b) {
        var u0 = [D.dD, D.yU], dn2 = [u0[0] + 0.06 * dx, u0[1] + 0.06 * dy];
        sec([u0, dn2, [dn2[0], dn2[1] - 0.04], [u0[0] + 0.002, u0[1] - 0.04]], b[0], b[1], mDr); tot.drip += b[1] - b[0];
        var tp = pT(D.sTop), tq = pT(D.sTop - 0.15);
        sec([[tp[0] + 0.10 * nx, tp[1] + 0.10 * ny], [tq[0] + 0.10 * nx, tq[1] + 0.10 * ny], [tq[0] + 0.104 * nx, tq[1] + 0.104 * ny], [tp[0] + 0.104 * nx, tp[1] + 0.104 * ny]], b[0] - 0.05, b[1] + 0.05, mDr); tot.apron += b[1] - b[0] + 0.10;
        tot.sideTape += 2 * (sFoot - D.sTop);
      });
      if (D.axis != null) capRun(D.zc - t / 2 - 0.02, D.zc + t / 2 + 0.02);
      /* THE CUT'S SIDES GET A VERGE TRIM (aframe-v125, Marek: kolem vyrezu plechove profily, zavetrne listy): the
         roof's own verge ROR00006, its top leg 70 on the covering beside the cut, its face down over the skin's cut
         edge and 40 on down the trimmer's side into the slot */
      var skT = D.H.skinT, vergeRun = function (zE, out9) {
        var a = pT(D.sTop), b = pT(sFoot), off = function (P, o) { return [P[0] + o * nx, P[1] + o * ny]; };
        sec([off(a, skT), off(b, skT), off(b, skT + 0.004), off(a, skT + 0.004)], out9 < 0 ? zE - 0.07 : zE - 0.002, out9 < 0 ? zE + 0.002 : zE + 0.07, mCap);
        sec([off(a, -0.04), off(b, -0.04), off(b, skT + 0.004), off(a, skT + 0.004)], out9 < 0 ? zE : zE - 0.002, out9 < 0 ? zE + 0.002 : zE, mCap);
        tot.verge += sFoot - D.sTop;
      };
      vergeRun(D.bays[0][0], -1);
      vergeRun(D.bays[D.bays.length - 1][1], 1);
      /* THE DORMER UNDER REVIEW (aframe-v151, plan H part 3): the header and the frames are the structure */
      if (_isAdmin() && AF_STEP.dormer < 99) {
        var phD = { layer_osb: 'osb', layer_breather_membrane: 'memb', windows_doors: 'door', layer_vented_battens: 'batt', layer_eps: 'batt', sauna_ui_cladding: 'clad', roof_edges: 'metal',
                    dormer_wool: 'wool', layer_vapour_barrier: 'vb', layer_plasterboard: 'board', casing: 'case' };
        var nDr = _rvTagList(T, g.children.slice(kD0), function (o) { return phD[_asmKey(o)] || ''; }, _dormerDefs(), AF_STEP.dormer), LDr = _dormerLayers();
        ctx.log('dormer   review step ' + AF_STEP.dormer + ' of ' + LDr.length + ' (' + (LDr[AF_STEP.dormer - 1] || '?') + ') ' + (sd < 0 ? 'left' : 'right') + ': ' + nDr.rv + ' bod(ies) MAGENTA, ' + nDr.un + ' under it in their colours, ' + nDr.ab + ' over it hidden (billed); the header and the frames drawn');
      }
      return { D: D, tot: tot, door: tot.door, nDoor: tot.nDoor, slotL: sFoot - D.sTop, nWp: nWp };
    }
    /* THE WING'S FLAT ROOF, WALKED ON (aframe-v102, wing step 5). Joists 60 x
       240 every 600 across the wing, on the outer wall's top plate (a
       hurricane tie each) and in hangers on a ledger 60 x 240 screwed through
       the A's roof into its rafters; tapered firring strips on them make the
       fall of 2 % out; OSB 18, the roofing membrane (the ADU's flat roof
       foil) turned up 300 under the A's covering and held by a termination
       bar and flashing tape, a geotextile, the porch's sleepers laid flat and
       loose on it, the decking across them; a railing round the three open
       sides; a drip edge and a gutter with its downspout on the outer edge.
       Under the joists: wool between them (a 40 air gap over it, vented at the
       eave), the vapour barrier, service battens, the gypsum ceiling. */
    function _buildWingRoof(ctx) {
      var T = ctx.THREE, g = ctx.group, L0 = 'aframe-wing';
      var sides = _wingSides(); if (!sides.length) return;
      var S = _sect(), t = 0.060, dW = GABLE.d, notes = [], q;
      var tot = { posts: 0, postL: 0, joist: 0, nJ: 0, ledger: 0, osb: 0, edge: 0, junc: 0, rail: 0, deck: 0, sleeper: 0, nSl: 0, nBd: 0, gut: 0, down: 0, ceil: 0, foot: 0, nSp: 0, spL: 0, riser: 0, skinT: 0, slotUp: 0, slotBar: 0 };
      var mat = function (c, r) { return new T.MeshStandardMaterial({ color: c, roughness: r == null ? 0.85 : r, side: T.DoubleSide }); };
      /* the sleepers a shade off the sole plates' treated timber (aframe-v150): a review kept them as the structure */
      var mJ = mat(WOOD), mO = mat(SHEATH.col), mM = mat(0x2B2E31, 0.6), mSl = mat(0xA6A478), mBd = mat(0xB68A5A, 0.8), mR = mat(0x6B5A45, 0.6), mG = mat(0x8A8F94, 0.4);
      var cIn = LINE.board.col; try { if (API.colorSlotOf) { var cs0 = API.colorSlotOf('ceiling'); if (cs0 != null) cIn = cs0; } } catch (eC) {}
      var mC = mat(cIn, 0.9);
      /* drawn since aframe-v150 (plan H part 2); the timber a shade off the frame's, so a review never keeps it as the structure */
      var WFr = woolFill(0.20), mFi = mat(0xC2A272), mGeo = mat(0xD9D9D2, 1), mWr = mat(0xE9D98B, 1), mVr = mat(0x9FB6C8, 1), mBr = mat(0xC4A374), mEd = mat(0x8A8F94, 0.4);
      var kR0 = g.children.length, edS = 0, edN = 0;
      var amR = function (m) {
        if (m === mFi) _am(ctx, 'roof_firring', 'Firring', 'ROT00004', 'top');
        else if (m === mGeo) _am(ctx, 'deck_geotextile', 'Geotextile', 'FEC00003', 'top');
        else if (m === mWr) _am(ctx, 'layer_ceiling_insulation', 'Mineral wool', (WFr.mix[0] && WFr.mix[0].code) || '', 'in');
        else if (m === mVr) _am(ctx, 'layer_vapour_barrier', 'Vapour barrier', 'ROV00001', 'in');
        else if (m === mBr) _am(ctx, 'layer_ceiling_battens', 'Ceiling battens', 'KVR50030', 'in');
        else if (m === mEd) _am(ctx, 'roof_edges', 'Drip edge', 'ROM02401', 'top');
        else if (m === mJ) _am(ctx, 'roof_framing', 'Wing roof joists', 'KVH60240', 'top');
        else if (m === mO) _am(ctx, 'roof_sheathing', 'Roof sheathing', 'OSB25002', 'top');
        else if (m === mM) _am(ctx, 'roof_membrane', 'Roof membrane', 'ROR00002', 'top');
        else if (m === mSl) _am(ctx, 'deck_sleepers', 'Sleepers', 'KVP60160', 'top');
        else if (m === mBd) _am(ctx, 'decking', 'Decking', 'TST00002', 'top');
        else if (m === mC) _am(ctx, 'layer_ceiling_board', 'Ceiling board', LINE.board.code, 'in');
      };
      /* a slab in the section (x, y) from u0 to u1 (u in from the outer face), its bottom and top given by u, along z */
      var slab = function (xO, sd, u0, u1, yb, yt, z0, z1, m) {
        var dMin = (m === mEd) ? 0.001 : 0.01;          /* the drip edge's leg is 1.5 thick (aframe-v150) */
        if (u1 - u0 < dMin || z1 - z0 < dMin) return;
        var sh = new T.Shape(), pts = [[u0, yb(u0)], [u1, yb(u1)], [u1, yt(u1)], [u0, yt(u0)]], i;
        sh.moveTo(xO - sd * pts[0][0], pts[0][1]); for (i = 1; i < 4; i++) sh.lineTo(xO - sd * pts[i][0], pts[i][1]); sh.lineTo(xO - sd * pts[0][0], pts[0][1]);
        var geo = new T.ExtrudeGeometry(sh, { depth: z1 - z0, bevelEnabled: false }); geo.translate(0, 0, z0); amR(m);
        var ms9 = new T.Mesh(geo, m); if (m === mBd || m === mSl) ms9.userData.afOut = 'wing deck'; g.add(ms9);
      };
      /* THE CEILING'S HIDDEN LAYERS (aframe-v150): wool 200 at the joists' foot between them (40 vented over it), the
         barrier under the joists, the battens across them every 400 -- in u0..u1 (in from the outer face), z0..z1, the
         joists at zs; the side's own xO, sd, H set by the loop below before it is called */
      var cB = { xO: 0, sd: 1, H: null }, ceilB = function (u0, u1, z0, z1, zs) {
        if (u1 - u0 < 0.05 || z1 - z0 < 0.05) return;
        var Hc = cB.H, yW = Hc.wallTop, zz = zs.slice().sort(function (a9, b9) { return a9 - b9; }), qz;
        var edges = [z0].concat(zz.filter(function (z9) { return z9 > z0 + t / 2 && z9 < z1 - t / 2; })).concat([z1]);
        for (qz = 0; qz + 1 < edges.length; qz++) {
          var za9 = (qz === 0) ? edges[0] : edges[qz] + t / 2, zb9 = (qz + 1 === edges.length - 1) ? edges[qz + 1] : edges[qz + 1] - t / 2;
          if (zb9 - za9 > 0.03) slab(cB.xO, cB.sd, u0, u1, function () { return yW + 0.002; }, function () { return yW + WFr.t; }, za9 + 0.002, zb9 - 0.002, mWr);
        }
        slab(cB.xO, cB.sd, u0, u1, function () { return yW - 0.001; }, function () { return yW; }, z0, z1, mVr);
        var ub;
        for (ub = u0 + 0.10; ub < u1 - 0.03; ub += 0.40) slab(cB.xO, cB.sd, ub - 0.025, ub + 0.025, function () { return yW - LINE.batt; }, function () { return yW - 0.001; }, z0, z1, mBr);
      };
      for (q = 0; q < sides.length; q++) {
        var sd = sides[q], WR = _wingRect(sd), H = _wingH(sd), xO = (sd < 0) ? WR.x0 : WR.x1, nm = (sd < 0) ? 'left' : 'right';
        cB.xO = xO; cB.sd = sd; cB.H = H;
        tot.skinT = H.skinT;
        var jt = H.wallTop + WROOF.joist, fire = function (u) { return H.fire * Math.min(1, Math.max(0, u / H.span)); };
        var yOb = function (u) { return jt + fire(u); }, yOt = function (u) { return yOb(u) + WROOF.osb; }, yMt = function (u) { return yOt(u) + WROOF.memb; };
        var ySt = function (u) { return yMt(u) + WROOF.sleeper; }, yDt = function (u) { return ySt(u) + WROOF.board; };
        var uAt = function (y) { return H.dO - H.dAt(y); };            /* where a level y meets the A's roof, in from the outer face */
        var WB = _wingBeam(sd), uLed = H.dO - (WB.dB - WBEAM.w / 2) - 0.001, uOsb = H.dO - WB.uCut, uMem = H.dO - WB.dFoot, uDeck = uAt(yMt(H.span)) - 0.01;
        /* the posts under the beam, on the slab */
        var zPo = _wingPosts(sd), nPo = zPo.length, po, xB = H.cx + sd * WB.dB;
        for (po = 0; po < nPo; po++) { _box(T, g, WBEAM.postW, WB.bot - H.yP, WBEAM.postW, xB, (WB.bot + H.yP) / 2, zPo[po], 0, WOOD, 1); tot.posts++; tot.postL += WB.bot - H.yP; }
        var zA = WR.z0, zB = WR.z1, zIa = WR.z0 + dW, zIb = WR.z1 - dW, clad = _facT();   /* out to the boards' face, the EPS in it from zone 4 (aframe-v159) */
        /* the beam (two plies), and the joists in hangers on it */
        slab(xO, sd, uLed, uLed + WBEAM.w / 2, function () { return WB.bot; }, function () { return WB.top; }, zIa, zIb, mJ);
        slab(xO, sd, uLed + WBEAM.w / 2 + 0.002, uLed + WBEAM.w, function () { return WB.bot; }, function () { return WB.top; }, zIa, zIb, new T.MeshStandardMaterial({ color: 0xB08E5E, roughness: 0.85 }));
        tot.ledger += 2 * (zIb - zIa);
        /* THE JOISTS BESIDE THE RAFTERS (aframe-v123): the rafters now run on down through the wing, so a joist never
           shares a line with one -- each rafter line in the wing has its joist against it (on the side away from a
           doubling), the end walls theirs, and a bay wider than 700 (a door bay) one more in its middle */
        var WGj = _wingGrid(), zJ = [zIa + t / 2, zIb - t / 2], j;
        WGj.lines.forEach(function (zl, li) {
          if (zl <= zIa + t || zl >= zIb - t) return;
          var sgJ = (Math.abs(zl - WGj.trim[0]) < 0.001) ? -1 : (Math.abs(zl - WGj.trim[1]) < 0.001) ? 1 : ((zl < WGj.cz) ? -1 : 1);
          if (WGj.axis != null && Math.abs(zl - WGj.axis) < 0.001) sgJ = 1;
          zJ.push(zl + sgJ * t);
        });
        for (j = 0; j + 1 < WGj.lines.length; j++) { var bwJ = WGj.lines[j + 1] - WGj.lines[j]; if (bwJ > 0.70) zJ.push((WGj.lines[j] + WGj.lines[j + 1]) / 2); }
        zJ.sort(function (a9, b9) { return a9 - b9; });
        zJ = zJ.filter(function (z9, i9) { return !i9 || z9 - zJ[i9 - 1] > t + 0.01; });
        for (j = 0; j < zJ.length; j++) {
          var zj = zJ[j];
          slab(xO, sd, 0, uLed, function () { return H.wallTop; }, function () { return jt; }, zj - t / 2, zj + t / 2, mJ);
          /* the firring on it, from nothing at the gutter to the fall's full height (aframe-v150) */
          slab(xO, sd, 0, uLed, function () { return jt; }, function (u) { return jt + Math.max(0.004, fire(u)); }, zj - t / 2, zj + t / 2, mFi);
          tot.joist += uLed; tot.nJ++;
        }
        /* the beam hangs under the whole rafters: a hurricane tie each side at every crossing */
        tot.hang = (tot.hang || 0) + 2 * WGj.lines.filter(function (zl) { return zl > zIa && zl < zIb; }).length + 4;
        /* OSB and the membrane, out to the cladding's face, in to the A's roof */
        slab(xO, sd, -clad, uOsb, yOb, yOt, zA - clad, zB + clad, mO);
        slab(xO, sd, -clad - 0.01, uMem, yOt, yMt, zA - clad - 0.01, zB + clad + 0.01, mM);
        var aRoof = (uOsb + clad) * (zB - zA + 2 * clad); tot.osb += aRoof; tot.junc += zB - zA; tot.edge += (zB - zA) + 2 * (uOsb + clad);
        /* THE DRIP EDGE ROUND THE FREE EDGES (aframe-v150): its leg over the cladding's top on the outer edge (over the
           gutter) and on both ends, from the corner in to the A's roof; the ends were not billed */
        slab(xO, sd, -clad - 0.0015, -clad, function (u) { return yOt(u) - 0.06; }, function (u) { return yOt(u) + 0.002; }, zA - clad - 0.0015, zB + clad + 0.0015, mEd);
        slab(xO, sd, -clad, uOsb, function (u) { return yOt(u) - 0.06; }, function (u) { return yOt(u) + 0.002; }, zA - clad - 0.0015, zA - clad, mEd);
        slab(xO, sd, -clad, uOsb, function (u) { return yOt(u) - 0.06; }, function (u) { return yOt(u) + 0.002; }, zB + clad, zB + clad + 0.0015, mEd);
        edS += 2 * (uOsb + clad); edN++;
        /* the sleepers along the fall every 500, loose on a geotextile; the boards across them */
        var dz0 = zA + 0.10, dz1 = zB - 0.10;
        slab(xO, sd, 0.05, uDeck, yMt, function (u) { return yMt(u) + 0.002; }, dz0, dz1, mGeo);
        var nSl = Math.max(2, Math.ceil((dz1 - dz0 - 0.16) / 0.50) + 1), k;
        for (k = 0; k < nSl; k++) { var zs = dz0 + 0.08 + (dz1 - dz0 - 0.16) * k / (nSl - 1); slab(xO, sd, 0.05, uDeck, yMt, ySt, zs - 0.08, zs + 0.08, mSl); tot.sleeper += uDeck - 0.05; tot.nSl++; }
        var nBd = Math.max(1, Math.floor((uDeck - 0.05) / 0.151)), b;
        for (b = 0; b < nBd; b++) { var ub = 0.05 + b * 0.151; slab(xO, sd, ub, ub + 0.145, ySt, yDt, dz0, dz1, mBd); }
        tot.nBd += nBd; tot.deck += (uDeck - 0.05) * (dz1 - dz0);
        /* THE SLOPE'S SKIN DOWN TO THE WALKED ROOF (aframe-v108, Marek: krytina
           az k pochozi terase). Beside the door bays the A's deck, underlay,
           battens and covering go on past the rafters cut on the beam down to
           the wing's OSB: a sprocket beside each rafter there (its offcut,
           lapped 400 along it and screwed, sitting on the OSB) carries them;
           the wing's OSB runs in under it to the rafters' ends. The flat
           roof's membrane is turned up over the skin's cut foot and on up the
           slope under the underlay; a drip edge on the covering's foot sheds
           onto it. The decking stops 50 short of the covering, so the water
           off the slope falls onto the membrane and away along the fall. */
        var R8 = _rafSize(), X8 = function (d) { return H.cx + sd * d; }, pl8 = function (d) { return WB.yT0 - d * S.tan; };
        var poly8 = function (P, z0, z1, m) { if (z1 - z0 < 0.005) return; var sh = new T.Shape(), i; sh.moveTo(X8(P[0][0]), P[0][1]); for (i = 1; i < P.length; i++) sh.lineTo(X8(P[i][0]), P[i][1]); sh.lineTo(X8(P[0][0]), P[0][1]); var geo = new T.ExtrudeGeometry(sh, { depth: z1 - z0, bevelEnabled: false }); geo.translate(0, 0, z0); amR(m); g.add(new T.Mesh(geo, m)); };
        var DM8 = _dormer(sd), WG8 = _wingGrid(), runs8 = DM8 ? [[zIa, DM8.bays[0][0]], [DM8.bays[DM8.bays.length - 1][1], zIb]] : [[zIa, zIb]];
        var sn8 = S.sin, cs8 = S.cos, Pi8 = [WB.dFoot, WB.yFoot], Po8 = [WB.dFoot + H.skinT * sn8, WB.yFoot + H.skinT * cs8], mD8 = mEd;
        var yMh = yMt(H.span), leg8 = Math.max(0.015, Math.min(0.055, Po8[1] - yMh - 0.005));
        var dA8 = WB.uCut - 0.40 * cs8, lenSp = (WB.dFoot - dA8) / cs8, nSp8 = 0;
        WG8.lines.forEach(function (zl) {
          return;      /* no sprockets since aframe-v123: the rafters run on whole under the skin's foot */
          var sg = (zl < WG8.cz) ? -1 : 1, zc8 = zl + sg * R8.t;
          poly8([[dA8, pl8(dA8)], [WB.dFoot, WB.yFoot], [WB.uCut, WB.yFoot], [dA8, pl8(dA8) - R8.d / cs8]], zc8 - R8.t / 2, zc8 + R8.t / 2, mJ);
          nSp8++;
        });
        var foot0 = tot.foot;
        runs8.forEach(function (r8) {
          if (r8[1] - r8[0] < 0.02) return;
          poly8([Pi8, Po8, [Po8[0] + 0.003 * cs8, Po8[1] - 0.003 * sn8], [Pi8[0] + 0.003 * cs8, Pi8[1] - 0.003 * sn8]], r8[0], r8[1], mM);
          poly8([[Po8[0] - 0.06 * cs8, Po8[1] + 0.06 * sn8], Po8, [Po8[0] + 0.0015 * sn8, Po8[1] + 0.0015 * cs8], [Po8[0] - 0.06 * cs8 + 0.0015 * sn8, Po8[1] + 0.06 * sn8 + 0.0015 * cs8]], r8[0], r8[1], mD8);
          poly8([[Po8[0], Po8[1]], [Po8[0] + 0.0015, Po8[1]], [Po8[0] + 0.0015, Po8[1] - leg8], [Po8[0], Po8[1] - leg8]], r8[0], r8[1], mD8);
          tot.foot += r8[1] - r8[0];
        });
        tot.nSp += nSp8; tot.spL += nSp8 * lenSp;
        /* THE SLOTS' FLOOR (aframe-v114): the walked roof carried on into each slot to its door wall -- joists 60 x 240 in hangers
           from the beam to a header at the door wall, OSB, the membrane (turned up 150 at the door and the slot's sides),
           the sleepers and the decking level with the terrace; the step's face under each door a board */
        if (DM8) {
          var uDw = H.dO - DM8.dD, uBm = H.dO - (WB.dB - WBEAM.w / 2);
          [[DM8.bays[0][0], DM8.bays[DM8.bays.length - 1][1]]].forEach(function (b) {      /* one floor over all the slots (aframe-v125) */
            var z0 = b[0], z1 = b[1], bw = z1 - z0;
            slab(xO, sd, uBm, uDw, function () { return H.wallTop; }, function () { return jt; }, z0, z0 + t, mJ);
            var nJs = Math.max(2, Math.ceil(bw / 0.40) + 1), jq;
            var zSl = [];
            for (jq = 0; jq < nJs; jq++) { var zj2 = z0 + t / 2 + (bw - t) * jq / (nJs - 1); zSl.push(zj2); slab(xO, sd, uLed, uDw - t, function () { return H.wallTop; }, function () { return jt; }, zj2 - t / 2, zj2 + t / 2, mJ);
              slab(xO, sd, uLed, uDw - t, function () { return jt; }, function (u) { return jt + Math.max(0.004, fire(u)); }, zj2 - t / 2, zj2 + t / 2, mFi); tot.joist += uDw - t - uLed; tot.nJ++; }
            slab(xO, sd, uDw - t, uDw, function () { return H.wallTop; }, function () { return jt; }, z0, z1, mJ); tot.ledger += bw;
            var yC2 = H.wallTop - LINE.batt - LINE.board.t; slab(xO, sd, uLed, uDw - t, function () { return yC2; }, function () { return yC2 + LINE.board.t; }, z0, z1, mC); tot.ceil += (uDw - t - uLed) * bw;
            slab(xO, sd, uOsb, uDw, yOb, yOt, z0, z1, mO); slab(xO, sd, uMem, uDw, yOt, yMt, z0, z1, mM);
            tot.osb += (uDw - uOsb) * bw; tot.junc += 2 * (uDw - uMem) + bw;
            slab(xO, sd, uDeck, uDw - 0.01, yMt, function (u) { return yMt(u) + 0.002; }, z0, z1, mGeo);
            /* the slots' ceiling from below (aframe-v150): wool between the slot joists, the barrier, the battens */
            ceilB(uLed + WBEAM.w, uDw - t, z0, z1, zSl);
            var nSs = Math.max(2, Math.ceil((bw - 0.16) / 0.50) + 1), ks;
            for (ks = 0; ks < nSs; ks++) { var zs2 = z0 + 0.08 + (bw - 0.16) * ks / (nSs - 1); slab(xO, sd, uDeck, uDw - 0.01, yMt, ySt, zs2 - 0.08, zs2 + 0.08, mSl); tot.sleeper += uDw - 0.01 - uDeck; tot.nSl++; }
            /* THE TERRACE'S OWN BOARDS CARRIED ON IN (aframe-v125, Marek: prkna s drazkovanim az k pruchodu): the same
               145 boards on the same 151 pitch, the terrace's run continued board by board from its last one up to the
               door wall, across the slots' whole width -- no gap at the covering's line, the joints showing */
            var kB = nBd, nIn = 0;
            while (0.05 + kB * 0.151 + 0.145 <= uDw - 0.005) { var ubS = 0.05 + kB * 0.151; slab(xO, sd, ubS, ubS + 0.145, ySt, yDt, z0 + 0.003, z1 - 0.003, mBd); kB++; nIn++; }
            tot.deck += (uDw - (0.05 + nBd * 0.151)) * bw; tot.nBd += nIn;
            poly8([[DM8.dD, yDt(H.span)], [DM8.dD + 0.022, yDt(H.span)], [DM8.dD + 0.022, DM8.y2], [DM8.dD, DM8.y2]], z0, z1, mat(API.colorSlotOf ? API.colorSlotOf('gable') : 0xB8875A));
            tot.riser += bw * (DM8.y2 - yDt(H.span));
            /* THE SLOT MADE WATERTIGHT (aframe-v116): the membrane turned up 150 against each rafter side and up
               the door wall to the underside of the threshold, held by a termination bar and sealed with tape */
            var up9 = 0.15, dMem = WB.dFoot, yM = yMt(H.span), zc9;
            [[z0 - 0.003, z0], [z1, z1 + 0.003]].forEach(function (zz) { poly8([[dMem, yM], [DM8.dD, yM], [DM8.dD, yM + up9], [dMem, yM + up9]], zz[0], zz[1], mM); });
            poly8([[DM8.dD + 0.001, yM], [DM8.dD + 0.004, yM], [DM8.dD + 0.004, DM8.y2 - 0.005], [DM8.dD + 0.001, DM8.y2 - 0.005]], z0, z1, mM);
            tot.slotUp += 2 * (dMem - DM8.dD) * up9 + bw * (DM8.y2 - yM); tot.slotBar += 2 * (dMem - DM8.dD) + bw;
          });
        }
        notes.push(nm + ' foot: the skin down to ' + Math.round(WB.yFoot * 1000) + ' (the wing\'s OSB top) at ' + Math.round(WB.dFoot * 1000) + ' from the ridge line, the covering\'s foot ' + Math.round(Po8[1] * 1000) + ' against the deck ' + Math.round(yDt(H.span) * 1000) + ', drip edge and upturn ' + (tot.foot - foot0).toFixed(2) + ' m, the decking stopped ' + Math.round((uAt(yDt(H.span)) - uDeck) * 1000) + ' short of the covering');
        /* the railing: posts every 1200 at most, a top and a middle rail, round the three open sides */
        var railH = 1.00, post = 0.07, runs = [{ a: [0.10, dz0], b: [0.10, dz1] }, { a: [0.10, dz0 + 0.05], b: [uDeck - 0.05, dz0 + 0.05] }, { a: [0.10, dz1 - 0.05], b: [uDeck - 0.05, dz1 - 0.05] }], r;
        for (r = 0; r < runs.length; r++) {
          var R0 = runs[r], len = Math.hypot(R0.b[0] - R0.a[0], R0.b[1] - R0.a[1]), nP = Math.max(2, Math.ceil(len / 1.20) + 1), p;
          for (p = 0; p < nP; p++) {
            var fu = R0.a[0] + (R0.b[0] - R0.a[0]) * p / (nP - 1), fz = R0.a[1] + (R0.b[1] - R0.a[1]) * p / (nP - 1), yb = yDt(fu);
            _am(ctx, 'balcony_rail', 'Railing', 'SIS00001', 'side'); _box(T, g, post, railH, post, xO - sd * fu, yb + railH / 2, fz, 0, 0x6B5A45, 1);
          }
          var alongZ = Math.abs(R0.b[1] - R0.a[1]) > Math.abs(R0.b[0] - R0.a[0]), um = (R0.a[0] + R0.b[0]) / 2, zm = (R0.a[1] + R0.b[1]) / 2, yRail = yDt(um);
          [railH, railH / 2].forEach(function (hh) { _box(T, g, alongZ ? 0.05 : len, 0.05, alongZ ? len : 0.05, xO - sd * um, yRail + hh - 0.025, zm, 0, 0x6B5A45, 1); });
          tot.rail += len;
        }
        /* the gutter under the drip edge on the outer edge, the downspout at the z0 end */
        var xG = xO + sd * (clad + 0.07), yG = yOb(0) - 0.06;
        _am(ctx, 'gutters', 'Gutters', 'ROG01251', 'top'); _box(T, g, 0.12, 0.09, zB - zA + 2 * clad, xG, yG, (zA + zB) / 2, 0, 0x8A8F94, 1);
        _box(T, g, 0.08, yG - 0.045, 0.08, xG, (yG - 0.045) / 2, zA + 0.15, 0, 0x8A8F94, 1);
        tot.gut += zB - zA + 2 * clad; tot.down += yG;
        /* the ceiling inside: the gypsum under the service battens, wall face to the ledger */
        var yC = H.wallTop - LINE.batt - LINE.board.t;
        ceilB(dW, uLed, zIa, zIb, zJ);
        slab(xO, sd, dW + LINE.batt, uLed, function () { return yC; }, function () { return yC + LINE.board.t; }, zIa + LINE.batt, zIb - LINE.batt, mC);
        tot.ceil += (uLed - dW - LINE.batt) * (zIb - zIa - 2 * LINE.batt);
        notes.push(nm + ': beam 2 x 60x240 at ' + Math.round(WB.dB * 1000) + ' from the ridge line, top ' + Math.round(WB.top * 1000) + ', hung under the whole rafters, no posts; ' + tot.nJ + ' joist(s) so far, span ' + (uLed).toFixed(2) + ' m, the deck ' + Math.round(yDt(H.span) * 1000) + ' at the house (floor 2 ' + Math.round(H.y2 * 1000) + ') falling ' + Math.round(H.fire * 1000) + ' to ' + Math.round(yDt(0) * 1000) + ' at the rail');
      }
      var B1 = function (c, q2) { if (q2 > 0) API.billAdd(L0, c, q2); }, WF = woolFill(0.20), bt = tot.ceil / 0.40;
      /* the drip edge on the roof's two ends (aframe-v150): the outer edge's was billed with the gutter, the ends' not */
      B1('ROM02401', Math.round(edS * 1.05 * 100) / 100); B1('FAS00318', Math.ceil(edS / 0.30));
      ctx.log('wingroof drawn now (aframe-v150): firring ROT00004 on every joist (nothing at the gutter, ' + Math.round(((_wingH(sides[0]) || {}).fire || 0) * 1000) + ' at the house), the geotextile FEC00003 under the sleepers, the drip edge ROM02401 round the free edges, the ceiling\'s wool ' + _woolTxt(WF) + ', barrier ROV00001 and battens KVR50030 every 400; NEW BILL the drip edge on the roof\'s ends ' + edS.toFixed(2) + ' m -> ROM02401 ' + (edS * 1.05).toFixed(2) + ' m + ' + Math.ceil(edS / 0.30) + ' x FAS00318');
      /* THE WING'S ROOF UNDER REVIEW (aframe-v150, plan H part 2): the joists and the beam are the structure, the rest by its walk item; the dormers after it are not in this build-up */
      if (_isAdmin() && AF_STEP.wingroof < 99) {
        var phR = { roof_firring: 'firr', roof_sheathing: 'osb', roof_membrane: 'memb', roof_edges: 'edge', gutters: 'gut', deck_geotextile: 'geo', deck_sleepers: 'sleep', decking: 'deck',
                    balcony_rail: 'rail', layer_ceiling_insulation: 'wool', layer_vapour_barrier: 'vb', layer_ceiling_battens: 'batt', layer_ceiling_board: 'board' };
        var nRr = _rvTagList(T, g.children.slice(kR0), function (o) { return phR[_asmKey(o)] || ''; }, _wingRoofDefs(), AF_STEP.wingroof), LWr = _wingRoofLayers();
        ctx.log('wingroof review step ' + AF_STEP.wingroof + ' of ' + LWr.length + ' (' + (LWr[AF_STEP.wingroof - 1] || '?') + '): ' + nRr.rv + ' bod(ies) MAGENTA, ' + nRr.un + ' under it in their colours, ' + nRr.ab + ' over it hidden (billed); the joists, the beam and the walls\' frame drawn');
      }
      /* THE DORMERS (aframe-v104) */
      var dn = [];
      sides.forEach(function (sdD) {
        var DR = null; try { DR = _buildDormer(ctx, sdD); } catch (eD) { ctx.log('dormer   ERROR ' + ((eD && eD.message) || eD)); }
        if (!DR) return;
        var TT = DR.tot, DD9 = DR.door;
        _envA.dormW += TT.wallA; _envA.dormT += TT.triIn;   /* for the total UA check (aframe-v160) */
        B1(_rafSize().code, TT.hdr * 1.05); B1('FAT00011', 4 * DR.nDoor); B1('FAS75132', 8 * DR.nDoor);
        B1('KVH10060', TT.wallFr * 1.05); B1('FAS45145', 8 * DR.nDoor);
        B1(SHEATH.code, TT.wallA * 1.05); B1(SHEATH.memb, TT.wallA * 1.15); B1(FAC.batt.code, TT.wallA / FAC.batt.step * 1.05); B1(FAC.clad.code, TT.wallA * 1.08); B1(FAC.clad.nail, Math.round(TT.wallA / FAC.clad.w * 2 / 0.6) + 4);
        /* THE DOOR WALL'S EPS (aframe-v160): the layers, two plate anchors a board, the foam, the battens' screws through it */
        var dScr = (TT.ciD > 0.045) ? 'FAS80200' : (TT.ciD > 0 ? CI.battScrew : FAC.batt.screw);
        if (TT.ciD > 0) {
          var nLy = Math.round(TT.ciD / CI.t), nBdD = Math.ceil(TT.wallA * nLy / CI.board);
          B1(CI.code, Math.round(TT.wallA * nLy * 1.05 * 100) / 100); B1(CI.plate, nBdD * CI.perBoard); B1(CI.screw, nBdD * CI.perBoard); B1(CI.foam, 1);
          ctx.log('dormer   ' + (sdD < 0 ? 'left' : 'right') + ' door wall EPS (aframe-v160, zone ' + _iecc().cz + '): ' + nLy + ' x ' + Math.round(CI.t * 1000) + ' ' + CI.code + ' on ' + TT.wallA.toFixed(2) + ' m2 -> ' + (TT.wallA * nLy * 1.05).toFixed(2) + ' m2, ' + (nBdD * CI.perBoard) + ' x ' + CI.plate + ' + ' + CI.screw + ', 1 x ' + CI.foam + ', the battens screwed ' + dScr + '; R-' + _rOf(woolFill(DORM.wallT).t, R_IN.wool) + '+' + _rOf(TT.ciD, R_IN.eps) + 'ci');
        }
        /* THE DOOR WALL'S FIXINGS (aframe-v151, Marek: vruty do sadrokartonu): the OSB's nails, the membrane's and the barrier's tape, the
           battens' screws, the gypsum's tape and filler -- the triangles had them, the door wall not */
        var fxD = { n: Math.round(TT.wallA * SHEATH.nailPerM2), mt: Math.round(TT.wallA * 1.2 * 10) / 10, bs: Math.round(TT.wallA / FAC.batt.step / 0.6) + 4 * DR.nDoor, vt: Math.round(TT.wallA / 1.4 * 10) / 10, gt: Math.round(TT.wallA * 1.2 * 10) / 10, gf: Math.round(TT.wallA * LINE.board.fillerKgM2 * 10) / 10 };
        B1(SHEATH.nail, fxD.n); B1(SHEATH.tape, fxD.mt); B1(dScr, fxD.bs); B1('INS01005', fxD.vt); B1(LINE.board.tape, fxD.gt); B1(LINE.board.filler, fxD.gf);
        /* the primer on the door wall's and the triangles' gypsum, their barrier and membrane stapled (aframe-v153) */
        var chD = { pr: TT.wallA + TT.triIn, st: (TT.wallA + TT.triIn) + (TT.wallA + TT.triOut) };
        _chemBill(L0, chD.pr, chD.st, 0); _chemNote(ctx, 'dormer ' + (sdD < 0 ? 'left' : 'right'), chD.pr, chD.st, 0);
        ctx.log('dormer   ' + (sdD < 0 ? 'left' : 'right') + ' drawn now (aframe-v151): the door wall in its layers (' + DR.nWp + ' piece(s): studs, head, plate, wool, OSB, membrane, battens, boards, barrier, gypsum), the triangles\' membrane, battens and barrier; NEW BILL the door wall\'s fixings on ' + TT.wallA.toFixed(2) + ' m2: ' + fxD.n + ' x ' + SHEATH.nail + ', tape ' + SHEATH.tape + ' ' + fxD.mt + ' m (membrane) + INS01005 ' + fxD.vt + ' m (barrier), ' + fxD.bs + ' x ' + FAC.batt.screw + ', ' + LINE.board.tape + ' ' + fxD.gt + ' m, ' + LINE.board.filler + ' ' + fxD.gf + ' kg');
        woolFill(DORM.wallT).mix.forEach(function (mx) { B1(mx.code, TT.wallA * mx.n * 1.05); });
        B1('ROV00001', TT.wallA * 1.10); B1(LINE.board.code, TT.wallA * LINE.board.waste); B1(LINE.board.screw, Math.round(TT.wallA * LINE.board.screwPerM2));
        /* the side triangles (aframe-v126): frame, wool, barrier and gypsum inside, the gables' build-up outside */
        if (TT.triOut > 0) {
          /* the triangles' frame 160 (aframe-v160), the axis pier's as it was */
          B1(DORM.triCode, TT.triFr * 1.10); B1('KVH10060', TT.axFr * 1.10); B1('FAS45145', Math.ceil((TT.triFr + TT.axFr) / 0.5) * 2);
          woolFill(DORM.triT).mix.forEach(function (mx) { B1(mx.code, TT.triIn * mx.n * 1.05); });
          B1('ROV00001', TT.triIn * 1.10); B1('INS01005', Math.round(TT.triIn / 1.4 * 10) / 10);
          B1(LINE.board.code, TT.triIn * LINE.board.waste); B1(LINE.board.screw, Math.round(TT.triIn * LINE.board.screwPerM2)); B1(LINE.board.tape, Math.round(TT.triIn * 1.2 * 10) / 10); B1(LINE.board.filler, Math.round(TT.triIn * LINE.board.fillerKgM2 * 10) / 10);
          B1(SHEATH.code, TT.triOut * 1.10); B1(SHEATH.nail, Math.round(TT.triOut * SHEATH.nailPerM2)); B1(SHEATH.memb, TT.triOut * 1.20); B1(SHEATH.tape, Math.round(TT.triOut * 1.2 * 10) / 10);
          B1(FAC.batt.code, TT.triOut / FAC.batt.step * 1.10); B1(FAC.batt.screw, Math.round(TT.triOut / FAC.batt.step / 0.6) + 4); B1(FAC.clad.code, TT.triOut * 1.12); B1(FAC.clad.nail, Math.round(TT.triOut / FAC.clad.w * 2 / 0.6) + 4);
        }
        B1(DORM.cap, (TT.cap + TT.apron) * 1.05); B1('FAS00225', Math.ceil((TT.cap + TT.apron) / 0.30) * 2);
        B1('ROM02401', TT.drip * 1.05); B1('FAS00318', Math.ceil(TT.drip / 0.30) + 2 * DR.nDoor + Math.ceil(TT.verge / 0.30)); B1('ROR00012', TT.sideTape * 1.05); B1('ROR00006', TT.verge * 1.05);
        if (TT.cas > 0.01) {
          B1(CASE.code, Math.round(TT.cas * 1.05 * 100) / 100); B1(CASE.nail, CASE.rows * Math.ceil(TT.cas / CASE.step));
          ctx.log('trim     dormer ' + (sdD < 0 ? 'left' : 'right') + ' (aframe-v145): ' + DR.nDoor + ' door(s) cased on the room\'s face, three sides -- ' + TT.cas.toFixed(2) + ' m, BILL ' + CASE.code + ' ' + (TT.cas * 1.05).toFixed(2) + ' m (+5%), ' + (CASE.rows * Math.ceil(TT.cas / CASE.step)) + ' x ' + CASE.nail);
        }
        B1(GLZ_DOORS.upper.code, DR.nDoor); B1(DOOR.thresh, DR.nDoor * (DD9.w + 0.04)); B1(DOOR.tape, DR.nDoor * 2 * (DD9.w + 2 * DD9.h) * 1.05); B1(DOOR.foam, DR.nDoor); B1(DOOR.anchor, DR.nDoor * Math.ceil(2 * (DD9.w + DD9.h) / DOOR.anchorSp));
        dn.push((sdD < 0 ? 'left' : 'right') + ' sunk into the slope: ' + DR.D.bays.length + ' slot(s) ' + DR.D.bays.map(function (b) { return Math.round((b[1] - b[0]) * 1000); }).join(' + ') + ' wide between the rafters' + (DR.D.axis != null ? ' (the axis rafter whole between them)' : ' (one, on the axis, between the doubled trimmers)') + ', the door wall ' + Math.round(DR.D.dD * 1000) + ' from the ridge line where the rafters\'s underside is ' + Math.round(DR.D.yU * 1000) + ' (floor 2 ' + Math.round(DR.D.y2 * 1000) + ', the door ' + Math.round(DR.door.w * 1000) + ' x ' + Math.round(DR.door.h * 1000) + '), the skin cut from ' + Math.round(DR.D.sTop * 1000) + ' down the slope to the walked roof (' + DR.slotL.toFixed(2) + ' m of slope); floor 2 is ' + Math.round(DR.D.floorW * 1000) + ' out from the ridge line, the slots take ' + Math.round((DR.D.floorW - DR.D.dD) * 1000) + ' of it; the side triangles filled, ' + DR.tot.triA.toFixed(2) + ' m2 each (from the door wall out to ' + Math.round(DR.tot.dM * 1000) + ' where the rafters\' underside meets the slot floor)' + (DR.D.axis != null ? ', the pier under the axis rafter clad both ways' : ''));
      });
      if (dn.length) ctx.log('dormer   ' + dn.join('; ') + ' | BILL header ' + _rafSize().code + ' with hangers FAT00011, the door wall KVH10060 clad as the gables (OSB, membrane, battens, boards, wool, barrier, gypsum), verge trim ROR00006 down both sides of the cut, a cap on the axis rafter and the apron over the header ' + DORM.cap + ' (NO CODE YET) with FAS00225, drip edge ROM02401 under each header, the covering\'s cut edges along the slots taped ROR00012, doors ' + GLZ_DOORS.upper.code + ' with threshold, tape, foam, anchors; the slots\' floor in the walked roof\'s rows');
      B1('KVH60240', (tot.joist + tot.ledger) * 1.05); B1('ROT00004', tot.joist * 1.05); B1('ROT00007', tot.nJ); B1('FAS38038', tot.nJ * 10 + tot.nJ * 6); B1('FAT00011', tot.nJ);
      B1('FAS75132', Math.ceil(tot.ledger / 0.40) + tot.nJ);          /* the plies stitched every 400 (both plies counted), a screw down through each cut rafter */
      B1('KVH10100', tot.postL * 1.05); B1('FCO00004', tot.posts); B1('FAS60100', tot.posts * 8); B1('grd.concrete', tot.posts * 0.6 * 0.6 * 0.5);
      B1('OSB25002', tot.osb * 1.08); B1('FAS70000', Math.round(tot.osb * 22));
      B1('ROR00002', tot.osb * 1.10 + tot.junc * 0.30 + tot.foot * tot.skinT + tot.edge * 0.15); B1('ROA00001', tot.junc * 1.05); B1('FAS45070', Math.ceil(tot.junc / 0.20)); B1('ROR00012', tot.junc * 1.05); B1('FEC00038', Math.ceil(tot.junc / 10));
      /* the skin's foot (aframe-v108): sprockets of the rafter's stock, screwed 4 each; the drip edge nailed every 300; the step's face board */
      B1(_rafSize().code, tot.spL * 1.05); B1('FAS75132', tot.nSp * 4); B1('ROM02401', tot.foot * 1.05); B1('FAS00318', Math.ceil(tot.foot / 0.30));
      if (tot.slotBar > 0) {
        B1('ROR00002', tot.slotUp * 1.15); B1('ROA00001', tot.slotBar * 1.05); B1('FAS45070', Math.ceil(tot.slotBar / 0.20)); B1('ROR00012', tot.slotBar * 1.05); B1('FEC00038', Math.ceil(tot.slotBar / 10));
        ctx.log('wingslot BILL the slots\' membrane turned up (150 on the rafters, to the threshold on the door wall) ROR00002 ' + (tot.slotUp * 1.15).toFixed(2) + ' m2, termination bar ROA00001 ' + (tot.slotBar * 1.05).toFixed(2) + ' m with FAS45070 every 200, tape ROR00012, sealant FEC00038');
      }
      B1(FAC.clad.code, tot.riser * 1.08); B1(FAC.clad.nail, Math.round(tot.riser / FAC.clad.w * 2 / 0.6) + 2);
      ctx.log('wingfoot BILL sprockets ' + _rafSize().code + ' ' + (tot.spL * 1.05).toFixed(2) + ' m (' + tot.nSp + ' x ' + (tot.nSp ? (tot.spL / tot.nSp).toFixed(2) : '0') + ', 4 x FAS75132 each), drip edge ROM02401 ' + (tot.foot * 1.05).toFixed(2) + ' m with FAS00318 every 300, the membrane up over the foot ' + (tot.foot * tot.skinT).toFixed(2) + ' m2 more (in ROR00002), the step\'s face ' + FAC.clad.code + ' ' + (tot.riser * 1.08).toFixed(2) + ' m2');
      B1('FEC00003', tot.deck * 1.10); B1('KVP60160', tot.sleeper * 1.05); B1('TST00002', tot.deck * 1.05); B1('FAS55050', tot.nBd * tot.nSl * 2);
      B1('SIS00001', tot.rail);
      B1('ROM02401', tot.gut * 1.05); B1('FAS00318', Math.ceil(tot.gut / 0.30));
      B1('ROG01251', tot.gut * 1.05); B1('ROA01251', Math.ceil(tot.gut / 0.60) + 1); B1('ROG00001', 2 * sides.length); B1('ROG00005', sides.length);
      B1('ROG01252', tot.down * 1.05); B1('ROG00006', 2 * sides.length); B1('ROG00009', sides.length); B1('ROG00011', Math.ceil(tot.down / 1.5) + sides.length);
      WF.mix.forEach(function (mx) { B1(mx.code, tot.ceil * mx.n * 1.05); });
      B1('ROV00001', tot.ceil * 1.10); B1('INS01005', Math.round((tot.ceil / 1.4 + tot.edge) * 10) / 10); B1('KVR50030', bt * 1.05); B1('FAS60100', Math.round(bt * 1.6));
      B1(LINE.board.code, tot.ceil * LINE.board.waste); B1(LINE.board.screw, Math.round(tot.ceil * LINE.board.screwPerM2)); B1(LINE.board.tape, Math.round(tot.ceil / 2.88 * 3.6 * 10) / 10); B1(LINE.board.filler, Math.round(tot.ceil * LINE.board.fillerKgM2 * 10) / 10);
      _chemBill(L0, tot.ceil, tot.ceil, 0); _chemNote(ctx, 'wing ceiling', tot.ceil, tot.ceil, 0);
      ctx.log('wingroof ' + notes.join('; '));
      if (tot.hang) { B1('ROT00007', tot.hang); B1('FAS38038', tot.hang * 10); }
      ctx.log('wingbeam BILL beam 2 x KVH60240 (in the KVH60240 total), no posts: hung under the whole rafters with ' + (tot.hang || 0) + ' x ROT00007 hurricane tie (' + ((tot.hang || 0) * 10) + ' x FAS38038) -- the ground floor under the wing open (aframe-v123)');
      ctx.log('wingroof BILL joists + beam KVH60240 ' + ((tot.joist + tot.ledger) * 1.05).toFixed(1) + ' m (' + tot.nJ + ' joists), firring ROT00004 ' + (tot.joist * 1.05).toFixed(1) + ' m (the 2 % fall), ' + tot.nJ + ' x ROT00007 + ' + tot.nJ + ' x FAT00011 with FAS38038, ledger FAS75132; OSB25002 ' + (tot.osb * 1.08).toFixed(2) + ' m2; membrane ROR00002 ' + (tot.osb * 1.10 + tot.junc * 0.30 + tot.edge * 0.15).toFixed(2) + ' m2 (up 300 at the A, 150 at the edges), termination bar ROA00001 ' + (tot.junc * 1.05).toFixed(1) + ' m, FAS45070, ROR00012, FEC00038; deck: geotextile FEC00003, sleepers KVP60160 ' + (tot.sleeper * 1.05).toFixed(1) + ' m loose, decking TST00002 ' + (tot.deck * 1.05).toFixed(2) + ' m2, ' + (tot.nBd * tot.nSl * 2) + ' x FAS55050; railing SIS00001 ' + tot.rail.toFixed(2) + ' m; drip edge ROM02401, gutter ROG01251 ' + (tot.gut * 1.05).toFixed(1) + ' m with brackets, caps, hopper, downspout ROG01252 ' + (tot.down * 1.05).toFixed(1) + ' m; ceiling ' + tot.ceil.toFixed(2) + ' m2: wool ' + _woolTxt(WF) + ' (40 vented over it), ROV00001, KVR50030, gypsum ' + LINE.board.code);
    }
    _regLayer({
      id: 'aframe-wingbase', version: VERSION, role: 'zaklady', claims: ['wingbase'],
      build3d: _buildWingBase, boq: function () { return _rows('aframe-wingbase'); }
    });
    _regLayer({
      id: 'aframe-wing', version: VERSION, role: 'fitout', claims: ['wing'],
      build3d: _buildWing, boq: function () { return _rows('aframe-wing'); }
    });

    _regLayer({
      id: 'aframe-partitions', version: VERSION, role: 'pricky', claims: ['partitions'],
      build3d: _buildPartitions, boq: function () { return _rows('aframe-partitions'); }
    });

    _regLayer({
      id: 'aframe-lining', version: VERSION, role: 'finishes', claims: ['lining'],
      build3d: _buildLining, boq: function () { return _rows('aframe-lining'); }
    });

    /* -------------------------------------------------------------------------
       THE FLOORS AND CEILINGS (aframe-v37; on the review steps since
       aframe-v134). An upper floor is the ufloor build-up (UF, _ufLayers):
         1 joists (frame)   2 OSB deck, glued and screwed (frame)
         3 wool 120 between the joists   4 ceiling battens   5 gypsum ceiling
         6 impact underlay   7 vinyl plank   8 skirting
       The ground floor's underlay, vinyl and skirting are gfloor's last three.
       The wool stays as sound insulation, not heat (aframe-v39: it is warm on
       both sides; the footsteps are the underlay's job).
       ------------------------------------------------------------------------- */
    var FWOOL = { code: 'INS01201', t: 0.120, col: 0xE8D9A0 };
    function _buildFloors(ctx) {
      var T = ctx.THREE, g = ctx.group;
      _bill['aframe-floors'] = {};
      var S = _sect(), B = _barRect(), cx = (B.x0 + B.x1) / 2, fl = floors(), L = B.z1 - B.z0, k, q;
      ctx.log(_ufNote());
      /* L3: the wool between the joists of every upper floor, 120 thick, lying on the ceiling battens */
      var rvW = _ufRv(UF.wool), woolA = 0, nBay = 0, colW = rvW ? MAGENTA : FWOOL.col, drawW = _ufOn(UF.wool);
      _am(ctx, 'layer_floor_wool', 'Floor wool', FWOOL.code, 'top');
      var gW = rvW ? _rvTag(new T.Group()) : g; if (rvW) g.add(gW);
      ctx.log('floorsL  F2 OSB drawn with its sheets: ' + (STATE.isMetric ? '1250 x 2500' : '4 x 8 ft') + ', the long side across the joists, the short joints staggered half a sheet (' + (STATE.isMetric ? '1250' : '4 ft') + ') row to row');
      for (k = 1; k < fl.length; k++) {
        var F = fl[k], wF = F.floorWidth, tJ = FLOOR.joist.t, yJ0 = F.y - FLOOR.deck.t - FLOOR.joist.d, Hh = _hole(k);
        /* the bays between the joists as the frame lays them (aframe-v38): beside the rafters, the ledgers at the gables */
        var RGw = _rafGrid(), RWw = _roofWinPlan(S, _rafSize(), B, RGw, S.top + S.half * S.tan), JLw = _joistLayout(k, RWw.lines, RWw.sisters), zs = JLw.ledgers.slice();
        for (q = 0; q < JLw.joists.length; q++) zs.push(JLw.joists[q].z);
        if (Hh) { zs.push(Hh.z0 - tJ / 2, Hh.z1 + tJ / 2); }
        zs.sort(function (a, b) { return a - b; });
        var xa = cx - wF / 2, xb = cx + wF / 2, yW = yJ0 + FWOOL.t / 2, aF = 0;
        for (q = 0; q + 1 < zs.length; q++) {
          var za = zs[q] + tJ / 2, zb = zs[q + 1] - tJ / 2;
          if (zb - za < 0.05) continue;
          var runs = [[xa, xb]];
          if (Hh && za >= Hh.z0 - 0.01 && zb <= Hh.z1 + 0.01) runs = [[xa, Hh.x0 - 2 * tJ], [Hh.x1 + 2 * tJ, xb]];
          /* the slots of the sunk dormer take the wool out beyond their door wall (aframe-v115) */
          _slotRects(k).forEach(function (r9) {
            if (zb <= r9.z0 + 0.01 || za >= r9.z1 - 0.01) return;
            var nr = []; runs.forEach(function (ru) { if (r9.x1 <= ru[0] || r9.x0 >= ru[1]) { nr.push(ru); return; } if (r9.x0 > ru[0]) nr.push([ru[0], r9.x0]); if (r9.x1 < ru[1]) nr.push([r9.x1, ru[1]]); }); runs = nr;
          });
          for (var r = 0; r < runs.length; r++) {
            var rw = runs[r][1] - runs[r][0]; if (rw < 0.05) continue;
            if (drawW) _box(T, gW, rw, FWOOL.t, zb - za, (runs[r][0] + runs[r][1]) / 2, yW, (za + zb) / 2, 0, colW, 1);
            aF += rw * (zb - za); nBay++;
          }
        }
        woolA += aF;
        ctx.log('floorsL  L3 floor ' + (k + 1) + ': wool ' + FWOOL.code + ' 120 in ' + nBay + ' bay(s) between the joists, ' + aF.toFixed(2) + ' m2, from the joists\' underside at ' + Math.round(yJ0 * 1000) + ' (the joists are ' + Math.round(FLOOR.joist.d * 1000) + ' deep, 80 of air over the wool)');
      }
      if (woolA > 0.01) {
        API.billAdd('aframe-floors', FWOOL.code, woolA * 1.05);
        ctx.log('ufloor   L3 wool ' + FWOOL.code + ' ' + woolA.toFixed(2) + ' m2, BILL ' + (woolA * 1.05).toFixed(2) + ' m2 (+5%) -- sound insulation between the storeys; no vapour barrier, it is warm on both sides' + (rvW ? ' -- MAGENTA, under review' : (drawW ? '' : ' -- not drawn below its step')));
      }
      /* L4 + L5: THE CEILINGS UNDER THE UPPER FLOORS (aframe-v35, moved here
         from the lining in aframe-v134). Service battens 30 x 50 every 400 along
         the ridge, across the joists' undersides, screwed once a joist; the
         gypsum board 12.5 on them, between the slopes' lining and the gables',
         the stair opening and the sunk dormer's slots cut out of both. No vapour
         barrier: warm on both sides. */
      (function () {
        if (fl.length < 2) return;
        var R5 = _rafSize(), BD = LINE.board, yTop0 = S.top + S.half * S.tan;
        var oB = -(R5.d + LINE.batt + LINE.vb + BD.t / 2);
        var hw = function (y) { return (yTop0 + oB * S.cos - y) / S.tan + oB * S.sin; };
        var zIn0 = B.z0 + GABLE.d + LINE.batt + LINE.vb + BD.t, zIn1 = B.z1 - GABLE.d - LINE.batt - LINE.vb - BD.t;
        var BT = { code: 'KVR50030', w: 0.050, h: 0.030, sp: 0.40, screw: 'FAS60100', col: 0xC9A87A };
        var rvB = _ufRv(UF.batt), onB = _ufOn(UF.batt), rvC = _ufRv(UF.board), onC = _ufOn(UF.board);
        _am(ctx, 'layer_ceiling_battens', 'Ceiling battens', BT.code, 'in');
        var gB = rvB ? _rvTag(new T.Group()) : g; if (rvB) g.add(gB);
        var bdCol = BD.col; try { if (API.colorSlotOf) { var cs = API.colorSlotOf('ceiling'); if (cs != null) bdCol = cs; } } catch (eCs) {}
        var cutRun = function (a0, a1, cuts) {
          var out = [[a0, a1]], c2, p2;
          for (c2 = 0; c2 < cuts.length; c2++) {
            var nx2 = [];
            for (p2 = 0; p2 < out.length; p2++) {
              if (cuts[c2][1] <= out[p2][0] || cuts[c2][0] >= out[p2][1]) { nx2.push(out[p2]); continue; }
              if (cuts[c2][0] > out[p2][0]) nx2.push([out[p2][0], cuts[c2][0]]);
              if (cuts[c2][1] < out[p2][1]) nx2.push([cuts[c2][1], out[p2][1]]);
            }
            out = nx2;
          }
          return out;
        };
        var aCeil = 0, btLen = 0, btScrew = 0, nRowC = 0, notes = [], kc;
        for (kc = 1; kc < fl.length; kc++) {
          var yJ0 = fl[kc].y - FLOOR.deck.t - FLOOR.joist.d, yCb = yJ0 - LINE.batt - BD.t / 2, hwC = hw(yCb);
          if (hwC < 0.30) continue;
          var cx0 = cx - hwC, cx1 = cx + hwC, shC = new T.Shape();
          shC.moveTo(cx0, zIn0); shC.lineTo(cx1, zIn0); shC.lineTo(cx1, zIn1); shC.lineTo(cx0, zIn1); shC.lineTo(cx0, zIn0);
          var aC = (cx1 - cx0) * (zIn1 - zIn0);
          var FHc = _floorHolePaths(T, kc, cx0, cx1, zIn0, zIn1); FHc.paths.forEach(function (hp) { shC.holes.push(hp); }); aC -= FHc.area;
          if (onC) {
            var gC = new T.ShapeGeometry(shC); gC.rotateX(Math.PI / 2); gC.translate(0, yCb, 0);
            _am(ctx, 'layer_ceiling_board', 'Ceiling board', BD.code, 'in'); g.add(_rvTag2(new T.Mesh(gC, new T.MeshStandardMaterial({ color: rvC ? MAGENTA : bdCol, roughness: 0.9, side: T.DoubleSide })), rvC));
          }
          aCeil += Math.max(0, aC);
          /* the battens, cut at the stair opening and at the slots like the board */
          var cutsAll = [], HC = _hole(kc), lB = 0, nR = 0, xq, rq;
          if (HC) cutsAll.push(HC);
          _slotRects(kc).forEach(function (r9) { cutsAll.push(r9); });
          var yBt = yJ0 - BT.h / 2;
          for (xq = cx0 + 0.10; xq <= cx1 - 0.10 + 1e-6; xq += BT.sp) {
            var cutsC = [];
            cutsAll.forEach(function (H9) { if (xq > H9.x0 - BT.w / 2 && xq < H9.x1 + BT.w / 2) cutsC.push([H9.z0, H9.z1]); });
            var runsC = cutRun(zIn0, zIn1, cutsC);
            for (rq = 0; rq < runsC.length; rq++) {
              var rlc = runsC[rq][1] - runsC[rq][0]; if (rlc < 0.10) continue;
              _am(ctx, 'layer_ceiling_battens', 'Ceiling battens', BT.code, 'in'); _box(T, onB ? gB : _afHid(ctx), BT.w, BT.h, rlc, xq, yBt, (runsC[rq][0] + runsC[rq][1]) / 2, 0, rvB ? MAGENTA : BT.col, 1);
              lB += rlc; btScrew += Math.round(rlc / FLOOR.joist.sp) + 1;
            }
            nR++;
          }
          btLen += lB; nRowC += nR;
          notes.push('floor ' + (kc + 1) + ': ' + Math.round(2 * hwC * 1000) + ' wide between the slopes\' lining, ' + Math.max(0, aC).toFixed(2) + ' m2 of board, ' + nR + ' batten row(s) ' + lB.toFixed(1) + ' m' + (cutsAll.length ? (', ' + cutsAll.length + ' opening(s) cut out') : ''));
        }
        if (aCeil < 0.01 && btLen < 0.01) return;
        API.billAdd('aframe-floors', BT.code, btLen * 1.05);
        API.billAdd('aframe-floors', BT.screw, btScrew);
        var WBC = Math.min(aCeil, _wetBoardAreas().ceil);
        API.billAdd('aframe-floors', BD.code, (aCeil - WBC) * BD.waste);
        if (WBC > 0.01) {
          API.billAdd('aframe-floors', WET_BOARD, WBC * BD.waste);
          ctx.log('WET  board ceilings (aframe-v144): ' + WBC.toFixed(2) + ' m2 of ceiling over a wet room -- ' + WET_BOARD + ' ' + (WBC * BD.waste).toFixed(2) + ' m2 (+10%) instead of ' + BD.code);
        }
        API.billAdd('aframe-floors', BD.screw, Math.round(aCeil * BD.screwPerM2));
        _chemBill('aframe-floors', aCeil, 0, 0); _chemNote(ctx, 'ceilings', aCeil, 0, 0);
        API.billAdd('aframe-floors', BD.tape, Math.round(aCeil / 2.88 * 3.6 * 10) / 10);
        API.billAdd('aframe-floors', BD.filler, Math.round(aCeil * BD.fillerKgM2 * 10) / 10);
        ctx.log('ufloor   L4 ceiling battens ' + BT.code + ' 30x50 every ' + Math.round(BT.sp * 1000) + ' along the ridge under the joists: ' + btLen.toFixed(1) + ' m, BILL ' + (btLen * 1.05).toFixed(1) + ' m (+5%), ' + btScrew + ' x ' + BT.screw + ' (one a joist)' + (rvB ? ' -- MAGENTA, under review' : (onB ? '' : ' -- not drawn below its step')));
        ctx.log('ufloor   L5 gypsum ceiling ' + BD.code + ' 12.5, the Walls colour: ' + aCeil.toFixed(2) + ' m2, BILL ' + (aCeil * BD.waste).toFixed(2) + ' m2 (+10%), ' + Math.round(aCeil * BD.screwPerM2) + ' x ' + BD.screw + ', tape ' + BD.tape + ' ' + (Math.round(aCeil / 2.88 * 3.6 * 10) / 10) + ' m, compound ' + BD.filler + ' ' + (Math.round(aCeil * BD.fillerKgM2 * 10) / 10) + ' kg' + (rvC ? ' -- MAGENTA, under review' : (onC ? '' : ' -- not drawn below its step')) + ' | ' + notes.join('; '));
      })();
      /* F3: THE IMPACT UNDERLAY (aframe-v40), on every floor -- the upper
         floors' OSB and the ground floor (the slab, or the timber floor on
         footings) -- out to the face of the lining board on the slopes and
         the gables, the stair openings cut out; 5% for the laps and cuts */
      var upA = { ul: 0, v: 0, sk: 0 };
      {
        var UL = { code: 'INS01004', t: 0.003, col: 0xB9C2A8 };
        var Rr = _rafSize(), yT0 = S.top + S.half * S.tan, oF = -(Rr.d + LINE.batt + LINE.vb + LINE.board.t);
        var hwF = function (y) { return (yT0 + oF * S.cos - y) / S.tan + oF * S.sin; };
        var zF0 = B.z0 + GABLE.d + LINE.batt + LINE.vb + LINE.board.t, zF1 = B.z1 - GABLE.d - LINE.batt - LINE.vb - LINE.board.t;
        var ulA = 0, ulNote = [];
        for (k = 0; k < fl.length; k++) {
          var yF = fl[k].y, hwK = hwF(yF + 0.02), HF = (k >= 1) ? _hole(k) : null;
          if (hwK < 0.20) continue;
          var shF = new T.Shape(), fx0 = cx - hwK, fx1 = cx + hwK;
          shF.moveTo(fx0, zF0); shF.lineTo(fx1, zF0); shF.lineTo(fx1, zF1); shF.lineTo(fx0, zF1); shF.lineTo(fx0, zF0);
          var aK = (fx1 - fx0) * (zF1 - zF0);
          var FHf = _floorHolePaths(T, k, fx0, fx1, zF0, zF1); FHf.paths.forEach(function (hp) { shF.holes.push(hp); }); aK -= FHf.area;
          /* the ground floor's underlay by its own step (aframe-v129): drawn while it is the top layer shown */
          /* ...and an upper floor's by the ufloor step (aframe-v134): drawn while it is the top layer shown, under the vinyl it is not */
          var rvU = (k === 0) ? _isRv('gfloor', _gfIdx('impact underlay')) : _ufRv(UF.under);
          var showU = (k === 0) ? (_gfOn('impact underlay') && !_gfOn('vinyl')) : (_ufOn(UF.under) && !_ufOn(UF.vinyl));
          var colUk = showU ? (rvU ? MAGENTA : UL.col) : null;
          /* THE WET ROOMS LEAVE THE UNDERLAY (aframe-v143): their tile goes on the tanking (aframe-wet) */
          var WHf = _wetHoles(T, k, fx0, fx1, zF0, zF1);
          /* THE EDGE STRIP (aframe-v131): foam 8 x 50 round the ground floor on the slab before the levelling bed,
             so the bed does not bond to the walls; billed by the floor's perimeter, drawn until the underlay goes down */
          if (k === 0 && STATE.foundation === 'strips') {
            var eS = PERIM.edge, pE = 2 * ((fx1 - fx0) + (zF1 - zF0)), rvE = _isRv('gfloor', _gfIdx('edge strip'));
            API.billAdd('aframe-floors', eS.code, Math.round(pE * 1.05 * 100) / 100);
            if (_gfOn('edge strip') && !_gfOn('impact underlay')) {
              _am(ctx, 'edge_strip', 'Edge strip', eS.code, 'top'); var gE = rvE ? _rvTag(new T.Group()) : g; if (rvE) g.add(gE);
              var cE = rvE ? MAGENTA : 0x7FA3C9, yE = yF + eS.h / 2;
              _box(T, gE, eS.t, eS.h, zF1 - zF0, fx0 + eS.t / 2, yE, (zF0 + zF1) / 2, 0, cE, 1);
              _box(T, gE, eS.t, eS.h, zF1 - zF0, fx1 - eS.t / 2, yE, (zF0 + zF1) / 2, 0, cE, 1);
              _box(T, gE, fx1 - fx0 - 2 * eS.t, eS.h, eS.t, (fx0 + fx1) / 2, yE, zF0 + eS.t / 2, 0, cE, 1);
              _box(T, gE, fx1 - fx0 - 2 * eS.t, eS.h, eS.t, (fx0 + fx1) / 2, yE, zF1 - eS.t / 2, 0, cE, 1);
            }
            ctx.log('gfloor   edge strip ' + eS.code + ' 8 x 50 round the ground floor on the slab: ' + pE.toFixed(2) + ' m, BILL ' + (pE * 1.05).toFixed(2) + ' m (+5%)');
          }
          if (k === 0 && STATE.foundation === 'strips' && _gfOn('levelling') && !_gfOn('impact underlay')) {
            var gLv = new T.ShapeGeometry(shF); gLv.rotateX(Math.PI / 2); gLv.translate(0, yF + 0.0015, 0);
            var rvLv = _isRv('gfloor', _gfIdx('levelling')); _am(ctx, 'layer_levelling', 'Levelling bed', 'FFC00007', 'top');
            g.add(_rvTag2(new T.Mesh(gLv, new T.MeshStandardMaterial({ color: rvLv ? MAGENTA : 0xA7A49C, roughness: 1, side: T.DoubleSide })), rvLv));
            ctx.log('gfloor   levelling bed FFC00007 drawn on the slab as a sheet (3 mm, the underlay not shown yet), ' + aK.toFixed(2) + ' m2 between the linings');
          }
          WHf.paths.forEach(function (hp) { shF.holes.push(hp); }); aK -= WHf.area;
          if (colUk != null) {
            _am(ctx, 'layer_floor_underlay', 'Impact underlay', UL.code, 'top'); var gF = new T.ShapeGeometry(shF); gF.rotateX(Math.PI / 2); gF.translate(0, yF + UL.t / 2 + 0.001, 0);
            g.add(_rvTag2(new T.Mesh(gF, new T.MeshStandardMaterial({ color: colUk, roughness: 1, side: T.DoubleSide })), rvU));
          }
          ulA += aK; if (k > 0) upA.ul += aK;
          ulNote.push('floor ' + (k + 1) + ' ' + aK.toFixed(2) + ' m2 (' + Math.round(2 * hwK * 1000) + ' wide between the linings' + (k === 0 ? ', on the ' + (STATE.foundation === 'strips' ? 'slab' : 'timber floor') : ', on the OSB, the stair opening cut out') + (WHf.n ? (', ' + WHf.n + ' wet room part(s) ' + WHf.area.toFixed(2) + ' m2 left out') : '') + ')');
        }
        API.billAdd('aframe-floors', UL.code, ulA * 1.05);
        ctx.log('floorsL  F3 impact underlay ' + UL.code + ' 3 mm: ' + ulNote.join('; '));
        ctx.log('floorsL  F3 BILL ' + UL.code + ' ' + (ulA * 1.05).toFixed(2) + ' m2 (' + ulA.toFixed(2) + ' + 5% laps and cuts) -- the footsteps; the wool between the joists takes the airborne sound');
      }
      /* F4: THE VINYL PLANK (aframe-v41), FFC00005, the colour of Floor in
         the Color step, drawn as 180 x 1200 planks laid along the ridge; on
         the slab a 3 mm self-levelling bed under it (4.5 kg/m2, no catalogue
         row yet); 5% for the cuts */
      {
        var VN = { code: 'FFC00005', t: 0.005, pw: 0.180, pl: 1.200, waste: 1.05, lev: 'FFC00007', levKgM2: 4.5, prim: 'FEC00020', primWaste: 1.05,
                   stag: [0, 0.50, 0.20, 0.70, 0.35, 0.85, 0.10, 0.60] };
        var colN = null, vA = 0, vNote = [], levA = 0, skRuns = [];
        var Rv = _rafSize(), yTv = S.top + S.half * S.tan, oFv = -(Rv.d + LINE.batt + LINE.vb + LINE.board.t);
        var hwV2 = function (y) { return (yTv + oFv * S.cos - y) / S.tan + oFv * S.sin; };
        var zN0 = B.z0 + GABLE.d + LINE.batt + LINE.vb + LINE.board.t, zN1 = B.z1 - GABLE.d - LINE.batt - LINE.vb - LINE.board.t;
        var vTex = null;
        if (colN == null) {
          try {
            /* EIGHT ROWS OF PLANKS, THE END JOINTS STAGGERED (aframe-v43, Marek:
               cikcak, at kratke spary nenavazuji presne na sebe): each row's
               joint set on by VN.stag of a plank length, never nearer than 300
               to the next row's, and no staircase to the eye */
            var cvN = global.document.createElement('canvas'); cvN.width = 64 * VN.stag.length; cvN.height = 256;
            var cN = cvN.getContext('2d'), baseHex = (API.colorSlotOf ? API.colorSlotOf('floor') : 0xC9AA78), bh = '#' + ('000000' + baseHex.toString(16)).slice(-6);
            cN.fillStyle = bh; cN.fillRect(0, 0, cvN.width, 256);
            var shade = [0.00, 0.05, -0.04, 0.03, -0.06, 0.02, 0.06, -0.02], cq2, gq;
            for (cq2 = 0; cq2 < VN.stag.length; cq2++) {
              var sh2 = shade[cq2 % shade.length];
              cN.fillStyle = sh2 > 0 ? ('rgba(255,255,255,' + sh2 + ')') : ('rgba(0,0,0,' + (-sh2) + ')');
              cN.fillRect(cq2 * 64, 0, 64, 256);
            }
            cN.fillStyle = 'rgba(0,0,0,0.06)'; for (gq = 0; gq < 40; gq++) cN.fillRect(0, gq * 6.4, cvN.width, 1);
            cN.strokeStyle = 'rgba(40,28,16,0.85)'; cN.lineWidth = 2.5; cN.beginPath();
            for (cq2 = 0; cq2 < VN.stag.length; cq2++) {
              var jy = Math.round(VN.stag[cq2] * 256) + 0.5;
              cN.moveTo(cq2 * 64 + 0.5, 0); cN.lineTo(cq2 * 64 + 0.5, 256);
              cN.moveTo(cq2 * 64, jy); cN.lineTo(cq2 * 64 + 64, jy);
            }
            cN.stroke();
            vTex = new T.CanvasTexture(cvN); vTex.wrapS = vTex.wrapT = T.RepeatWrapping;
          } catch (eV) { vTex = null; }
        }
        for (k = 0; k < fl.length; k++) {
          var yFv = fl[k].y + 0.003, hwKv = hwV2(yFv + 0.02), HV = (k >= 1) ? _hole(k) : null;
          if (hwKv < 0.20) continue;
          var shN = new T.Shape(), nx0 = cx - hwKv, nx1 = cx + hwKv;
          shN.moveTo(nx0, zN0); shN.lineTo(nx1, zN0); shN.lineTo(nx1, zN1); shN.lineTo(nx0, zN1); shN.lineTo(nx0, zN0);
          var aN = (nx1 - nx0) * (zN1 - zN0);
          var FHv = _floorHolePaths(T, k, nx0, nx1, zN0, zN1); FHv.paths.forEach(function (hp) { shN.holes.push(hp); }); aN -= FHv.area;
          /* the wet rooms' floor is tile (aframe-v143, aframe-wet): cut out of the vinyl; the levelling bed stays under the whole floor */
          var WHv = _wetHoles(T, k, nx0, nx1, zN0, zN1); WHv.paths.forEach(function (hp) { shN.holes.push(hp); }); aN -= WHv.area;
          /* A BODY, NOT A SHEET (aframe-v45, Marek: spary v podlaze na rezu
             nejsou videt vubec): the section fills every closed body it cuts
             by stencil, and a lone flat sheet counts as open all the way down
             -- the cut laid its flat cap over the whole floor and hid the
             planks. As a 5 mm slab the floor is closed, only its cut edge is
             capped, and the planks show on its top */
          var gN = new T.ExtrudeGeometry(shN, { depth: VN.t, bevelEnabled: false }), matN;
          if (vTex) {
            var uvN = gN.attributes.uv, pN = gN.attributes.position, iu;
            for (iu = 0; iu < pN.count; iu++) uvN.setXY(iu, pN.getX(iu) / (VN.pw * VN.stag.length), pN.getY(iu) / VN.pl);
            uvN.needsUpdate = true;
            matN = new T.MeshStandardMaterial({ map: vTex, roughness: 0.6 });
          } else matN = new T.MeshStandardMaterial({ color: colN != null ? colN : 0xC9AA78, roughness: 0.6 });
          gN.rotateX(Math.PI / 2); gN.translate(0, yFv + VN.t + 0.001, 0);
          var rvV = (k === 0) ? _isRv('gfloor', _gfIdx('vinyl')) : _ufRv(UF.vinyl);
          if (rvV) matN = new T.MeshStandardMaterial({ color: MAGENTA, roughness: 0.6 });
          _am(ctx, 'layer_floor_finish', 'Vinyl plank', VN.code, 'top');
          if ((k === 0) ? _gfOn('vinyl') : _ufOn(UF.vinyl)) g.add(_rvTag2(new T.Mesh(gN, matN), rvV));
          vA += aN; if (k > 0) upA.v += aN;
          skRuns.push({ k: k, y: yFv + VN.t, x0: nx0, x1: nx1, z0: zN0, z1: zN1 });
          if (k === 0 && STATE.foundation === 'strips') levA += aN + WHv.area;
          vNote.push('floor ' + (k + 1) + ' ' + aN.toFixed(2) + ' m2' + (WHv.n ? (' (' + WHv.area.toFixed(2) + ' m2 of wet room tiled instead)') : ''));
        }
        API.billAdd('aframe-floors', VN.code, vA * VN.waste);
        if (levA > 0.01) {
          API.billAdd('aframe-floors', VN.lev, Math.round(levA * VN.levKgM2 * 10) / 10);
          /* the primer under the compound, by the m2 of floor (aframe-v87) */
          API.billAdd('aframe-floors', VN.prim, Math.round(levA * VN.primWaste * 100) / 100);
        }
        (function () { var st = [], mn = 1, q7, dq; for (q7 = 0; q7 < VN.stag.length; q7++) { st.push(Math.round(VN.stag[q7] * VN.pl * 1000)); dq = Math.abs(VN.stag[q7] - VN.stag[(q7 + 1) % VN.stag.length]); mn = Math.min(mn, dq, 1 - dq); }
          ctx.log('floorsL  F4 planks laid staggered: the end joints row to row at ' + st.join(' / ') + ' along the plank, never nearer than ' + Math.round(mn * VN.pl * 1000) + ' (the 300 minimum), repeating every ' + VN.stag.length + ' rows'); })();
        ctx.log('floorsL  F4 vinyl plank ' + VN.code + ' 180 x 1200 along the ridge, the Floor colour: ' + vNote.join('; ') + (levA > 0.01 ? ('; on the slab a 3 mm self-levelling bed under it, ' + levA.toFixed(2) + ' m2') : ''));
        /* F5: THE SKIRTING (aframe-v42), FFW00002, 70 high on the vinyl round
           every floor -- along both slopes' lining and both gables' -- broken
           at the doors that stand on the ground floor; none round a stair
           opening, the guard is there. Screwed every 600 (FAS50060), the ADU
           rule; 5% for the mitres. */
        {
          var SK = { code: 'FFW00002', h: 0.070, t: 0.012, screw: 'FAS50060', sp: 0.60, col: 0xE4DED2 }, colS = SK.col, skL = 0, skNote = [], rr;
          var GSk = _gableSegs(), doorsX = { '0': [], '1': [] }, qd;
          for (qd = 0; qd < GSk.length; qd++) {
            var eK = (Math.abs(GSk[qd].z0 - B.z0) < 0.01) ? '0' : '1', uxK = _segUx(GSk[qd]), opK = GSk[qd].openings || [], od;
            for (od = 0; od < opK.length; od++) {
              var oK = opK[od];
              if (oK.kind === 'door' || oK.kind === 'french' || oK.kind === 'garage') {
                var xa3 = GSk[qd].x0 + uxK * (oK.at - oK.w / 2), xb3 = GSk[qd].x0 + uxK * (oK.at + oK.w / 2);
                doorsX[eK].push([Math.min(xa3, xb3), Math.max(xa3, xb3)]);
              }
            }
          }
          var runX = function (a0, a1, cuts) {
            var out = [[a0, a1]], c3, p3;
            for (c3 = 0; c3 < cuts.length; c3++) { var nx3 = []; for (p3 = 0; p3 < out.length; p3++) { if (cuts[c3][1] <= out[p3][0] || cuts[c3][0] >= out[p3][1]) { nx3.push(out[p3]); continue; } if (cuts[c3][0] > out[p3][0]) nx3.push([out[p3][0], cuts[c3][0]]); if (cuts[c3][1] < out[p3][1]) nx3.push([cuts[c3][1], out[p3][1]]); } out = nx3; }
            return out;
          };
          for (rr = 0; rr < skRuns.length; rr++) {
            var SR = skRuns[rr], yS = SR.y + SK.h / 2, lR = 0, ps2, pz;
            /* not in a wet room (aframe-v143): its tile band runs down to the floor */
            var WSk = _wetRects(SR.k, { x0: SR.x0, x1: SR.x1, z0: SR.z0, z1: SR.z1 });
            /* the ground floor's skirting by its own step (aframe-v129), an upper floor's by the ufloor step
               (aframe-v134): when not drawn, still measured and billed */
            var rvS = (SR.k === 0) ? _isRv('gfloor', _gfIdx('skirting')) : _ufRv(UF.skirt);
            var onSk = (SR.k === 0) ? _gfOn('skirting') : _ufOn(UF.skirt);
            colS = rvS ? MAGENTA : SK.col;
            _am(ctx, 'layer_floor_skirting', 'Skirting', SK.code, 'side');
            var gSk = onSk ? g : _afHid(ctx);
            if (rvS && gSk === g) { gSk = _rvTag(new T.Group()); g.add(gSk); }
            /* along the slopes, at x0 and x1, the whole length */
            for (ps2 = 0; ps2 < 2; ps2++) {
              var xs3 = ps2 ? SR.x1 - SK.t / 2 : SR.x0 + SK.t / 2, sdK = ps2 ? 1 : -1, cutZ = [];
              /* NOT THROUGH THE WING (aframe-v127, Marek: skrz vikyr vede podlahova lista): on the ground floor the slope
                 is open into a side wing over its length; on floor 2 the sunk dormer's slots cut the floor back to their
                 door walls -- the skirting stops at both, and runs round the slots' sides inside instead */
              try {
                if (_wingSides().indexOf(sdK) >= 0) {
                  if (SR.k === 0) { var WBk = _wingBeam(sdK); cutZ.push([WBk.zIa, WBk.zIb]); }
                  if (SR.k === 1) _slotRects(1).forEach(function (r9) { if (r9.sd === sdK) {
                    cutZ.push([r9.z0 - 0.12, r9.z1 + 0.12]);
                    [r9.z0 - 0.12 - SK.t / 2, r9.z1 + 0.12 + SK.t / 2].forEach(function (zq) { var xa4 = Math.min(r9.xD, xs3), xb4 = Math.max(r9.xD, xs3); if (xb4 - xa4 > 0.05) { _box(T, gSk, xb4 - xa4, SK.h, SK.t, (xa4 + xb4) / 2, yS, zq, 0, colS, 1); lR += xb4 - xa4; } });
                  } });
                }
              } catch (eSk) {}
              WSk.forEach(function (Rw) { if (Rw.e[ps2 ? 'x1' : 'x0'] === 'slope') cutZ.push([Rw.z0, Rw.z1]); });
              var runsZ = runX(SR.z0, SR.z1, cutZ), qz;
              for (qz = 0; qz < runsZ.length; qz++) { var lZ = runsZ[qz][1] - runsZ[qz][0]; if (lZ < 0.05) continue; _box(T, gSk, SK.t, SK.h, lZ, xs3, yS, (runsZ[qz][0] + runsZ[qz][1]) / 2, 0, colS, 1); lR += lZ; }
            }
            /* along the gables, broken at the doors on the ground floor */
            for (pz = 0; pz < 2; pz++) {
              var cutG = (SR.k === 0 ? doorsX[String(pz)] : []).concat(WSk.filter(function (Rw) { return Rw.e[pz ? 'z1' : 'z0'] === 'gable'; }).map(function (Rw) { return [Rw.x0, Rw.x1]; }));
              var zs3 = pz ? SR.z1 - SK.t / 2 : SR.z0 + SK.t / 2, runsS = runX(SR.x0, SR.x1, cutG), qr;
              for (qr = 0; qr < runsS.length; qr++) {
                var lS = runsS[qr][1] - runsS[qr][0]; if (lS < 0.05) continue;
                _box(T, gSk, lS, SK.h, SK.t, (runsS[qr][0] + runsS[qr][1]) / 2, yS, zs3, 0, colS, 1); lR += lS;
              }
            }
            /* ALONG THE PARTITIONS (aframe-v144): both faces, broken at the doorways and their casings, none in a wet room */
            var lP = 0, offP = PARTA.d / 2 + LINE.board.t, cwP = _caseW();
            _partRunsK(SR.k).forEach(function (PR) {
              [-1, 1].forEach(function (sP) {
                var cutsP = PR.doors.map(function (d) { return [d[0] - cwP, d[1] + cwP]; }), fP = PR.at + sP * offP;
                WSk.forEach(function (Rw) {
                  if (PR.vert) { if (Math.abs((sP > 0 ? Rw.x0 : Rw.x1) - fP) < 0.03) cutsP.push([Rw.z0, Rw.z1]); }
                  else if (Math.abs((sP > 0 ? Rw.z0 : Rw.z1) - fP) < 0.03) cutsP.push([Rw.x0, Rw.x1]);
                });
                var rP = runX(PR.lo, PR.hi, cutsP), qP;
                for (qP = 0; qP < rP.length; qP++) {
                  var lq = rP[qP][1] - rP[qP][0], mq = (rP[qP][0] + rP[qP][1]) / 2, cP = PR.at + sP * (offP + SK.t / 2);
                  if (lq < 0.05) continue;
                  if (PR.vert) _box(T, gSk, SK.t, SK.h, lq, cP, yS, mq, 0, colS, 1); else _box(T, gSk, lq, SK.h, SK.t, mq, yS, cP, 0, colS, 1);
                  lR += lq; lP += lq;
                }
              });
            });
            skL += lR; if (SR.k > 0) upA.sk += lR; skNote.push('floor ' + (SR.k + 1) + ' ' + lR.toFixed(2) + ' m' + (lP > 0.01 ? (' (' + lP.toFixed(2) + ' m along the partitions)') : ''));
          }
          var nSkScrew = Math.ceil(skL / SK.sp);
          API.billAdd('aframe-floors', SK.code, skL * 1.05);
          API.billAdd('aframe-floors', SK.screw, nSkScrew);
          ctx.log('floorsL  F5 skirting ' + SK.code + ' 70 high round every floor and along both faces of every partition (aframe-v144), broken at the doors and their casings, none round the stair openings or in a wet room: ' + skNote.join('; '));
          ctx.log('floorsL  F5 BILL ' + SK.code + ' ' + (skL * 1.05).toFixed(2) + ' m (+5% mitres), ' + nSkScrew + ' x ' + SK.screw + ' (every 600, the ADU rule)');
        }
        ctx.log('floorsL  F4 BILL ' + VN.code + ' ' + (vA * VN.waste).toFixed(2) + ' m2 (+5% cuts)' + (levA > 0.01 ? ('; ' + VN.lev + ' ' + (Math.round(levA * VN.levKgM2 * 10) / 10) + ' kg (4.5 kg/m2); primer ' + VN.prim + ' ' + (Math.round(levA * VN.primWaste * 100) / 100) + ' m2 (the floor under it, +5%)') : ''));
      }
      if (fl.length > 1) {
        var st6 = function (n) { return _ufRv(n) ? ' MAGENTA' : (_ufOn(n) ? '' : ' (not drawn)'); };
        ctx.log('ufloor   L6 underlay INS01004 ' + upA.ul.toFixed(2) + ' m2' + st6(UF.under) + (_ufOn(UF.vinyl) ? ' (under the vinyl: not drawn)' : '') + ', L7 vinyl FFC00005 ' + upA.v.toFixed(2) + ' m2' + st6(UF.vinyl) + ', L8 skirting FFW00002 ' + upA.sk.toFixed(2) + ' m' + st6(UF.skirt) +
                ' on the upper floor(s) -- each billed in one row with the ground floor\'s (floorsL F3 / F4 / F5)');
      }
    }
    _regLayer({
      id: 'aframe-floors', version: VERSION, role: 'finishes', claims: ['floor-finish'],
      build3d: _buildFloors, boq: function () { return _rows('aframe-floors'); }
    });

    /* -------------------------------------------------------------------------
       THE WET ROOMS -- aframe-wet (aframe-v143, the barndominium's and the
       ADU's wet rooms). COPIED from the ADU: WET_ROOMS (a room the plan names
       bathroom, WC or laundry), its wet floor -- white tile 400 x 400
       FFC00003 on a flex bed FEC00018 (4 kg/m2), grout SBG00001 (0.24 kg/m2),
       on a 2K tanking FEC00025 (1.5 kg/m2) turned 150 up the walls -- its
       tile band to 1200 (WET_TILE_H: SBC00001 300 x 600 laid across, FEC00018
       3.5 kg/m2, SBG00001 0.3 kg/m2), the door transition strip ODD00003
       where a wet room's door meets a dry floor, and the colour slots
       Bathroom tiles / Bathroom floor.
       ADAPTED to the A:
         every storey, its rooms as the plan shows them (_mepRoomsOf);
         a room's floor between the linings, half a partition and its board
           in from a partition (the plan's room ends on its centre line);
         the vinyl and its underlay leave the room (aframe-floors cuts them
           out, the levelling bed stays under the whole floor), and so does
           the vinyl skirting along a slope or a gable;
         the band on a partition or a gable follows the lining where the
           slope comes lower than 1200; on a slope it is laid up the lining to
           1200 over the floor; a gable window with its sill under 1200 stops
           it at the sill, a door leaves it out;
         no ceramic plinth (the ADU bills one under its band): the band runs
           down to the tile, a sanitary silicone joint FEC00040 round the
           floor (a cartridge per 10 m);
         tiles +10 % for the cuts.
       Magenta for an admin until checked (WET_REVIEW).
       ------------------------------------------------------------------------- */
    var WET_REVIEW = true, WET_ROOMS = { 'rooms.bathroom': 1, 'rooms.laundry': 1, 'rooms.wc': 1 };
    var WET = { h: 0.013, tank: 'FEC00025', tankKg: 1.5, up: 0.15, glue: 'FEC00018', floorKg: 4.0, tile: 'FFC00003', tileW: 0.40, grout: 'SBG00001', floorGrout: 0.24,
                band: 'SBC00001', bandH: 1.20, bandT: 0.012, wallKg: 3.5, wallGrout: 0.3, tw: 0.60, th: 0.30, waste: 1.10,
                strip: 'ODD00003', stripW: 0.040, stripT: 0.005, sil: 'FEC00040', silPer: 10 };
    /* storey k's floor between the linings, as aframe-floors lays it */
    function _wetIn(k) {
      var S = _sect(), B = _barRect(), cx = (B.x0 + B.x1) / 2, F = floors()[k] || floors()[0], linT = LINE.batt + LINE.vb + LINE.board.t;
      var yT0 = S.top + S.half * S.tan, oF = -(_rafSize().d + linT), hw = (yT0 + oF * S.cos - (F.y + 0.02)) / S.tan + oF * S.sin;
      return { x0: cx - hw, x1: cx + hw, z0: B.z0 + GABLE.d + linT, z1: B.z1 - GABLE.d - linT };
    }
    /* the wet rooms of storey k cut to the floor IN, each side named: 'slope'
       or 'gable' (on the lining), 'open' (on another rect of the same room),
       'part' (a partition: the rect drawn in to its board) */
    function _wetRects(k, IN) {
      var out = [], U = null, i, j, q;
      out.skip = [];
      if (k >= floors().length) return out;
      try { U = _mepRoomsOf(k); } catch (eU) { U = null; }
      if (!U || !U.rooms) return out;
      IN = IN || _wetIn(k);
      var ins = PARTA.d / 2 + LINE.board.t, H = [], Hk = (k >= 1) ? _hole(k) : null;
      if (Hk) H.push(Hk);
      try { _slotRects(k).forEach(function (r) { H.push(r); }); } catch (eS) {}
      for (i = 0; i < U.rooms.length; i++) {
        var rm = U.rooms[i]; if (!rm || rm.closet || !WET_ROOMS[rm.key]) continue;
        var RS = rm.rects || [];
        for (j = 0; j < RS.length; j++) {
          var s = RS[j], R = { x0: Math.max(s.x0, IN.x0), x1: Math.min(s.x1, IN.x1), z0: Math.max(s.z0, IN.z0), z1: Math.min(s.z1, IN.z1), st: k, room: i, name: rm.name || rm.def || 'WET ROOM', e: {} };
          if (R.x1 - R.x0 < 0.30 || R.z1 - R.z0 < 0.30) continue;
          var sideOf = function (ky) {
            var isX = (ky.charAt(0) === 'x'), v = s[ky], lim = IN[ky], q2;
            if (Math.abs(R[ky] - lim) < 0.10) return isX ? 'slope' : 'gable';
            for (q2 = 0; q2 < RS.length; q2++) {
              if (q2 === j) continue;
              var o = RS[q2], ov = isX ? (Math.min(o.z1, s.z1) - Math.max(o.z0, s.z0)) : (Math.min(o.x1, s.x1) - Math.max(o.x0, s.x0));
              var vo = o[{ x0: 'x1', x1: 'x0', z0: 'z1', z1: 'z0' }[ky]];
              if (Math.abs(vo - v) < 0.02 && ov > 0.10) return 'open';
            }
            return 'part';
          };
          R.e = { x0: sideOf('x0'), x1: sideOf('x1'), z0: sideOf('z0'), z1: sideOf('z1') };
          if (R.e.x0 === 'slope') R.x0 = IN.x0; else if (R.e.x0 === 'part') R.x0 += ins;
          if (R.e.x1 === 'slope') R.x1 = IN.x1; else if (R.e.x1 === 'part') R.x1 -= ins;
          if (R.e.z0 === 'gable') R.z0 = IN.z0; else if (R.e.z0 === 'part') R.z0 += ins;
          if (R.e.z1 === 'gable') R.z1 = IN.z1; else if (R.e.z1 === 'part') R.z1 -= ins;
          if (R.x1 - R.x0 < 0.30 || R.z1 - R.z0 < 0.30) continue;
          var over = null;
          for (q = 0; q < H.length; q++) if (Math.min(H[q].x1, R.x1) - Math.max(H[q].x0, R.x0) > 0.01 && Math.min(H[q].z1, R.z1) - Math.max(H[q].z0, R.z0) > 0.01) over = H[q];
          if (over) { out.skip.push(R.name + ' on floor ' + (k + 1) + ' over the stair opening / a slot -- left in vinyl'); continue; }
          out.push(R);
        }
      }
      return out;
    }
    /* the wet rooms as holes in a floor's sheet x0..x1 / z0..z1 */
    function _wetHoles(T, k, x0, x1, z0, z1) {
      var W = _wetRects(k, { x0: x0, x1: x1, z0: z0, z1: z1 }), out = { paths: [], area: 0, n: W.length }, i;
      for (i = 0; i < W.length; i++) {
        var R = W[i], a0 = Math.max(x0 + 0.002, R.x0 + 0.001), a1 = Math.min(x1 - 0.002, R.x1 - 0.001), b0 = Math.max(z0 + 0.002, R.z0 + 0.001), b1 = Math.min(z1 - 0.002, R.z1 - 0.001);
        var hp = new T.Path(); hp.moveTo(a0, b0); hp.lineTo(a0, b1); hp.lineTo(a1, b1); hp.lineTo(a1, b0); hp.lineTo(a0, b0);
        out.paths.push(hp); out.area += (R.x1 - R.x0) * (R.z1 - R.z0);
      }
      return out;
    }
    /* the doors in storey k's partitions: the line, the span along it */
    function _wetDoors(k) {
      var P = STATE.parts || [], D = STATE.doors || [], byId = {}, out = [], i;
      for (i = 0; i < P.length; i++) if (P[i] && ((typeof P[i].st === 'number') ? (P[i].st | 0) : 0) === k) byId[P[i].id] = P[i];
      for (i = 0; i < D.length; i++) {
        var d = D[i], p = d ? byId[d.pid] : null; if (!p) continue;
        var u = (d.u != null) ? d.u : ((d.at != null) ? d.at : d.c), w = d.w || 0.80;
        if (typeof u !== 'number') continue;
        out.push({ vert: (p.dir || p.o) === 'v', line: (typeof p.at === 'number') ? p.at : p.c, a: u - w / 2, b: u + w / 2, w: w });
      }
      return out;
    }
    /* the openings of storey k's gables over x: [x0, x1, the band's cap over the floor] */
    function _wetGableOps(k) {
      var SG = _mepSegs(k), BX = _mepPlan(k).box, out = { z0: [], z1: [] }, q, j;
      for (q = 0; q < SG.length; q++) {
        var sg = SG[q]; if (Math.abs(sg.z1 - sg.z0) > 0.01) continue;
        var side = (Math.abs(sg.z0 - BX.z0) < Math.abs(sg.z0 - BX.z1)) ? 'z0' : 'z1', ux = (sg.x1 - sg.x0) / sg.len;
        for (j = 0; j < sg.openings.length; j++) {
          var o = sg.openings[j], xa = sg.x0 + ux * (o.at - o.w / 2), xb = sg.x0 + ux * (o.at + o.w / 2);
          if (o.sill >= WET.bandH) continue;
          out[side].push([Math.min(xa, xb), Math.max(xa, xb), (o.sill < 0.05) ? 0 : o.sill]);
        }
      }
      return out;
    }
    var _wetTexC = {};
    function _wetTex(T, kind, col) {
      var key = kind + ':' + col;
      if (_wetTexC.hasOwnProperty(key)) return _wetTexC[key];
      var tx = null;
      try {
        var wide = (kind === 'wall'), cv = global.document.createElement('canvas');
        cv.width = wide ? 256 : 128; cv.height = 128;
        var c = cv.getContext('2d');
        c.fillStyle = '#C9C4B8'; c.fillRect(0, 0, cv.width, cv.height);
        c.fillStyle = '#' + ('000000' + (col >>> 0).toString(16)).slice(-6); c.fillRect(2, 2, cv.width - 4, cv.height - 4);
        tx = new T.CanvasTexture(cv); tx.wrapS = tx.wrapT = T.RepeatWrapping;
        tx.repeat.set(1 / (wide ? WET.tw : WET.tileW), 1 / (wide ? WET.th : WET.tileW));
      } catch (eT) { tx = null; }
      _wetTexC[key] = tx;
      return tx;
    }
    function _buildWet(ctx) {
      var T = ctx.THREE, g = ctx.group, L = 'aframe-wet';
      _bill[L] = {};
      var fl = floors(), S = _sect(), B = _barRect(), cx = (B.x0 + B.x1) / 2, linT = LINE.vb + LINE.batt + LINE.board.t, ins = PARTA.d / 2 + LINE.board.t;
      var yT0 = S.top + S.half * S.tan, oF = -(_rafSize().d + linT);
      var hwAt = function (y) { return (yT0 + oF * S.cos - y) / S.tan + oF * S.sin; };
      var yLin = function (x) { return S.top + S.tan * (S.half - (S.rafD + linT) / S.sin - Math.abs(x - cx)); };
      var mag = WET_REVIEW && _isAdmin(), colF = 0xF2F2EE, colW = 0xF4EFE1;
      try { if (API.colorSlotOf) { var c1 = API.colorSlotOf('bathFloor'), c2 = API.colorSlotOf('bathTiles'); if (c1 != null) colF = c1; if (c2 != null) colW = c2; } } catch (eC) {}
      var txF = mag ? null : _wetTex(T, 'floor', colF), txW = mag ? null : _wetTex(T, 'wall', colW);
      var mF = new T.MeshStandardMaterial(txF ? { map: txF, roughness: 0.35 } : { color: mag ? MAGENTA : colF, roughness: 0.35 });
      var mW = new T.MeshStandardMaterial(txW ? { map: txW, roughness: 0.35 } : { color: mag ? MAGENTA : colW, roughness: 0.35 });
      var mTk = new T.MeshStandardMaterial({ color: mag ? MAGENTA : 0x4F7C9A, roughness: 0.6 });
      var mSt = new T.MeshStandardMaterial({ color: mag ? MAGENTA : 0xB8B8B4, roughness: 0.4, metalness: 0.6 });
      var put = function (geo, m, x, y, z, ry, rz) { var ms = new T.Mesh(geo, m); ms.position.set(x, y, z); if (ry) ms.rotation.y = ry; if (rz) ms.rotation.z = rz; ms.name = 'wet'; g.add(ms); return ms; };
      var uvFrom = function (geo, a, b) { var P = geo.attributes.position, U = geo.attributes.uv, i; for (i = 0; i < P.count; i++) U.setXY(i, a(P, i), b(P, i)); U.needsUpdate = true; return geo; };
      /* a run a0..a1 cut by [c0, c1, cap]: the pieces with the lowest cap over each */
      var pieces = function (a0, a1, cuts) {
        var pts = [a0, a1], out = [], q;
        cuts.forEach(function (c) { if (c[0] > a0 && c[0] < a1) pts.push(c[0]); if (c[1] > a0 && c[1] < a1) pts.push(c[1]); });
        pts.sort(function (p1, p2) { return p1 - p2; });
        for (q = 0; q + 1 < pts.length; q++) {
          var u0 = pts[q], u1 = pts[q + 1], um = (u0 + u1) / 2, cap = WET.bandH;
          if (u1 - u0 < 0.01) continue;
          cuts.forEach(function (c) { if (um > c[0] && um < c[1]) cap = Math.min(cap, c[2]); });
          out.push([u0, u1, cap]);
        }
        return out;
      };
      /* ALONG X (a gable, a partition across the A): from yB up to cap over the floor, under the lining */
      var bandX = function (xa, xb, yF, yB, cap, zFace, dirZ, t, m) {
        var yC = yF + cap, aC = S.half - (S.rafD + linT) / S.sin - (yC - S.top) / S.tan, us = [xa, xb, cx, cx - aC, cx + aC], q, top = [], a = 0;
        us = us.filter(function (u) { return u >= xa - 1e-9 && u <= xb + 1e-9; }).sort(function (p1, p2) { return p1 - p2; });
        for (q = 0; q < us.length; q++) top.push(Math.max(yB, Math.min(yC, yLin(us[q]) - 0.002)));
        for (q = 0; q + 1 < us.length; q++) a += ((top[q] - yB) + (top[q + 1] - yB)) / 2 * (us[q + 1] - us[q]);
        if (a < 0.002) return 0;
        var sh = new T.Shape(); sh.moveTo(xa, yB); sh.lineTo(xb, yB);
        for (q = us.length - 1; q >= 0; q--) sh.lineTo(us[q], top[q]);
        sh.lineTo(xa, yB);
        var ge = new T.ExtrudeGeometry(sh, { depth: t, bevelEnabled: false });
        put(ge, m, 0, 0, dirZ > 0 ? zFace : zFace - t);
        return a;
      };
      /* ALONG Z at x (a partition along the ridge): a flat band */
      var bandZ = function (za, zb, yF, yB, cap, xFace, dirX, t, m) {
        var yC = Math.min(yF + cap, yLin(xFace) - 0.002);
        if (yC - yB < 0.02) return 0;
        var sh = new T.Shape(); sh.moveTo(za, yB); sh.lineTo(zb, yB); sh.lineTo(zb, yC); sh.lineTo(za, yC); sh.lineTo(za, yB);
        var ge = new T.ExtrudeGeometry(sh, { depth: t, bevelEnabled: false });
        if (dirX > 0) ge.translate(0, 0, -t);
        put(ge, m, xFace, 0, 0, -Math.PI / 2);
        return (yC - yB) * (zb - za);
      };
      /* UP A SLOPE (side sd) from yB to yF + cap, off the lining by off */
      var bandS = function (za, zb, sd, yF, yB, cap, off, t, m) {
        var y1 = yF + cap, Ls = (y1 - yB) / S.sin; if (!(Ls > 0.02)) return 0;
        var xb = cx + sd * hwAt(yB), xt = cx + sd * hwAt(y1), nx = -sd * S.sin, ny = -S.cos;
        var ge = new T.BoxGeometry(t, Ls, zb - za);
        uvFrom(ge, function (P, i) { return P.getZ(i); }, function (P, i) { return P.getY(i); });
        put(ge, m, (xb + xt) / 2 + nx * (off + t / 2), (yB + y1) / 2 + ny * (off + t / 2), (za + zb) / 2, 0, sd * (Math.PI / 2 - S.p));
        return Ls * (zb - za);
      };
      /* the sill plate at a slope's foot stands proud of the lining on the ground floor: the band starts on its face */
      var PFw = _plateFit(), PLT = { off: S.w / 2 - PFw.w, top: _deckY() + PFw.h }, nPl = 0;
      var tl = { a: 0, run: 0, band: 0, strip: 0, nStrip: 0, n: 0 }, notes = [], skip = [], k, i, e;
      for (k = 0; k < fl.length; k++) {
        var IN = _wetIn(k), W = _wetRects(k, IN);
        W.skip.forEach(function (t2) { skip.push(t2); });
        if (!W.length) continue;
        var yF = fl[k].y, yT = yF + WET.h, DK = _wetDoors(k), GO = _wetGableOps(k), wingZ = {};
        if (k === 0) { try { _wingSides().forEach(function (sd) { var WB = _wingBeam(sd); wingZ[sd] = [WB.zIa, WB.zIb, 0]; }); } catch (eWg) {} }
        for (i = 0; i < W.length; i++) {
          var R = W[i], aR = (R.x1 - R.x0) * (R.z1 - R.z0), runR = 0, bandR = 0, sideTxt = [], strips = 0;
          /* the tanking under the tile, turned up the walls below */
          _am(ctx, 'layer_waterproofing', 'Waterproofing', WET.tank, 'top');
          put(new T.BoxGeometry(R.x1 - R.x0, 0.001, R.z1 - R.z0), mTk, (R.x0 + R.x1) / 2, yF + 0.0005, (R.z0 + R.z1) / 2);
          /* the floor tile */
          _am(ctx, 'layer_floor_finish', 'Floor finish', WET.tile, 'top');
          put(uvFrom(new T.BoxGeometry(R.x1 - R.x0, WET.h - 0.001, R.z1 - R.z0), function (P, q) { return P.getX(q) + (R.x0 + R.x1) / 2; }, function (P, q) { return P.getZ(q) + (R.z0 + R.z1) / 2; }),
              mF, (R.x0 + R.x1) / 2, yF + 0.001 + (WET.h - 0.001) / 2, (R.z0 + R.z1) / 2);
          var EDGES = ['z0', 'z1', 'x0', 'x1'];
          for (e = 0; e < 4; e++) {
            var ky = EDGES[e], ty = R.e[ky], isX = (ky.charAt(0) === 'x'), dir = (ky.charAt(1) === '0') ? 1 : -1, face = R[ky];
            if (ty === 'open') continue;
            var a0 = isX ? R.z0 : R.x0, a1 = isX ? R.z1 : R.x1, cuts = [];
            if (ty === 'part') {
              var line = face - dir * ins;
              DK.forEach(function (d) {
                if (d.vert !== isX || Math.abs(d.line - line) > 0.04 || d.b <= a0 || d.a >= a1) return;
                cuts.push([d.a, d.b, 0]);
                /* the transition strip where the other side is dry */
                var um = (d.a + d.b) / 2, px = isX ? (line - dir * (ins + 0.25)) : um, pz = isX ? um : (line - dir * (ins + 0.25)), wetO = false;
                W.forEach(function (R2) { if (px > R2.x0 && px < R2.x1 && pz > R2.z0 && pz < R2.z1) wetO = true; });
                if (wetO) return;
                _am(ctx, 'door_transition', 'Door transition strip', WET.strip, 'top');
                put(new T.BoxGeometry(isX ? WET.stripW : d.w, WET.stripT, isX ? d.w : WET.stripW), mSt, isX ? line : um, yT + WET.stripT / 2, isX ? um : line);
                tl.strip += d.w; tl.nStrip++; strips++;
              });
            } else if (ty === 'gable') GO[ky].forEach(function (c) { cuts.push(c); });
            else if (ty === 'slope' && wingZ[isX ? (ky === 'x0' ? -1 : 1) : 0]) cuts.push(wingZ[ky === 'x0' ? -1 : 1]);
            var PC = pieces(a0, a1, cuts), q;
            for (q = 0; q < PC.length; q++) {
              var pa = PC[q][0], pb = PC[q][1], cap = PC[q][2];
              if (cap < 0.05) continue;
              runR += pb - pa;
              /* the tanking's turn-up, 150, then the tile band over it */
              var sdS = dir > 0 ? -1 : 1, xPl = cx + sdS * PLT.off, onPl = (ty === 'slope' && k === 0 && PLT.top > yT + 0.005 && PLT.top < yF + WET.up && Math.abs(xPl - cx) < Math.abs(face - cx) - 0.002);
              _am(ctx, 'layer_waterproofing', 'Waterproofing', WET.tank, 'top');
              if (onPl) { bandZ(pa, pb, yF, yF, PLT.top - yF, xPl, dir, 0.002, mTk); bandS(pa, pb, sdS, yF, PLT.top, Math.min(cap, WET.up), 0, 0.002, mTk); }
              else if (ty === 'slope') bandS(pa, pb, sdS, yF, yF, Math.min(cap, WET.up), 0, 0.002, mTk);
              else if (isX) bandZ(pa, pb, yF, yF, Math.min(cap, WET.up), face, dir, 0.002, mTk);
              else bandX(pa, pb, yF, yF, Math.min(cap, WET.up), face, dir, 0.002, mTk);
              _am(ctx, 'wall_tile', 'Wall tile', WET.band, 'side');
              if (onPl) { bandR += bandZ(pa, pb, yF, yT, PLT.top + 0.003 - yF, xPl + dir * 0.002, dir, WET.bandT, mW) + bandS(pa, pb, sdS, yF, PLT.top + 0.003, cap, 0.002, WET.bandT, mW); nPl++; }
              else if (ty === 'slope') bandR += bandS(pa, pb, sdS, yF, yT, cap, 0.002, WET.bandT, mW);
              else if (isX) bandR += bandZ(pa, pb, yF, yT, cap, face + dir * 0.002, dir, WET.bandT, mW);
              else bandR += bandX(pa, pb, yF, yT, cap, face + dir * 0.002, dir, WET.bandT, mW);
            }
            sideTxt.push(ky + ' ' + ty);
          }
          tl.a += aR; tl.run += runR; tl.band += bandR; tl.n++;
          notes.push(R.name + ' on floor ' + (k + 1) + ' ' + (R.x1 - R.x0).toFixed(2) + ' x ' + (R.z1 - R.z0).toFixed(2) + ' = ' + aR.toFixed(2) + ' m2 tile, band ' + bandR.toFixed(2) + ' m2 (' + sideTxt.join(', ') + '), joint ' + runR.toFixed(2) + ' m' + (strips ? (', ' + strips + ' transition strip(s)') : ''));
        }
      }
      if (!tl.n) {
        ctx.log('WET  none -- no room named bathroom, WC or laundry on the plan (' + _mepRoomsOf(0).how + ')' + (skip.length ? ('; ' + skip.join('; ')) : '') + ' -- nothing billed');
        return;
      }
      var r1 = function (v) { return Math.round(v * 10) / 10; }, r2 = function (v) { return Math.round(v * 100) / 100; };
      var add = function (c, q) { if (q > 0.005) API.billAdd(L, c, q); };
      var tankKg = r1((tl.a + tl.run * WET.up) * WET.tankKg), glue = Math.ceil(tl.a * WET.floorKg + tl.band * WET.wallKg), grout = r1(tl.a * WET.floorGrout + tl.band * WET.wallGrout), nSil = Math.ceil(tl.run / WET.silPer);
      add(WET.tank, tankKg); add(WET.tile, r2(tl.a * WET.waste)); add(WET.glue, glue); add(WET.grout, grout);
      add(WET.band, r2(tl.band * WET.waste)); add(WET.strip, r2(tl.strip)); add(WET.sil, nSil);
      ctx.log('WET  ' + tl.n + ' wet room part(s) (bathroom / WC / laundry, the ADU\'s WET_ROOMS): ' + notes.join('; ') + (skip.length ? ('; ' + skip.join('; ')) : ''));
      ctx.log('WET  floor: tanking ' + WET.tank + ' 2K under the tile turned ' + Math.round(WET.up * 1000) + ' up the walls, tile ' + WET.tile + ' 400 x 400 on ' + WET.glue + ', grout ' + WET.grout + ', ' + Math.round(WET.h * 1000) + ' over the deck -- the vinyl, its underlay and its skirting left out of these rooms (floorsL)');
      ctx.log('WET  band: ' + WET.band + ' 300 x 600 laid across to ' + Math.round(WET.bandH * 1000) + ' over the floor on the partitions, the gables (stopped at a window sill, none at a door) and up the slopes (to 1200 over the floor), under the lining where the slope is lower' + (nPl ? ('; at ' + nPl + ' slope foot / feet it starts on the sill plate\'s face (' + Math.round((PLT.top - fl[0].y) * 1000) + ' over the floor, proud of the lining)') : '') + '; no plinth -- the band runs down to the tile, a silicone joint ' + WET.sil + ' round the floor');
      ctx.log('WET  BILL ' + WET.tank + ' ' + tankKg + ' kg ((' + tl.a.toFixed(2) + ' m2 + ' + tl.run.toFixed(2) + ' m x ' + WET.up + ') x ' + WET.tankKg + '), ' + WET.tile + ' ' + r2(tl.a * WET.waste) + ' m2 (+10%), ' + WET.band + ' ' + r2(tl.band * WET.waste) + ' m2 (' + tl.band.toFixed(2) + ' + 10%), ' + WET.glue + ' ' + glue + ' kg (4 / 3.5 kg/m2), ' + WET.grout + ' ' + grout + ' kg (0.24 / 0.3 kg/m2), ' +
              WET.sil + ' ' + nSil + ' (' + tl.run.toFixed(2) + ' m of joint, one per 10 m)' + (tl.nStrip ? (', ' + WET.strip + ' ' + r2(tl.strip) + ' m (' + tl.nStrip + ' door(s) to a dry floor)') : ', no door to a dry floor') + (mag ? ' -- MAGENTA (under review)' : ''));
    }
    _regLayer({
      id: 'aframe-wet', version: VERSION, role: 'finishes', claims: ['wet'],
      build3d: _buildWet, boq: function () { return _rows('aframe-wet'); }
    });

    /* -------------------------------------------------------------------------
       THE TRIM AND THE WET BOARD (aframe-v144, the barndominium's barndo-v26
       and the ADU's wet board).
       COPIED: the casing ODD00022 round every interior doorway on both faces
         (two legs and a head) with two rows of finish nails FAS18032 every
         12 in. (barndo PF_CASE); the closet fitted out -- a 12 in. shelf with
         a hanging rod FMA00011 at 66 in. round the walls of a closet or a
         wardrobe, the doorway and the corners already taken left out, two
         FAS50060 at every stud (barndo PF_CLO); the moisture-resistant board
         WDD24002 instead of WDD24001 wherever the board bounds a wet room --
         its walls and its ceiling (the ADU's CEIL_BOARD.wet).
       ADAPTED to the A:
         the gables' units are cased inside on the lining's face: a door or a
           balcony door on three sides, a window round all four (aframe-v145:
           the bottom piece is the apron under the inner sill OWW00001 the
           gables bill) -- the full or half glazed gable has its own frame
           and no casing; the side wing's units the same on its gypsum
           (aframe-v145), the dormer's door on three sides;
         the skirting runs along both faces of every partition too (it went
           round the linings only), broken at the doorways and their casings,
           none in a wet room;
         a closet's shelf goes on its partitions and its gable, where the
           slope leaves room over it -- never on a slope;
         the wet board is counted by the layer that puts the board up (the
           lining, the partitions, the ceilings) from the wet rooms' outline:
           the slope from its foot to the room's far side, the ridge or the
           ceiling, the gable and the partitions' faces to the ceiling or
           the slope less the units and doors -- drawn in the Walls colour
           (it is painted).
       Magenta for an admin until checked (TRIM_REVIEW).
       ------------------------------------------------------------------------- */
    var TRIM_REVIEW = true, WET_BOARD = 'WDD24002';
    var CASE = { code: 'ODD00022', nail: 'FAS18032', rows: 2, step: 12 * 0.0254, col: 0xF4F3F0 };
    function _caseW() { return STATE.isMetric === false ? 2.25 * 0.0254 : 0.070; }
    function _caseT() { return STATE.isMetric === false ? 0.6875 * 0.0254 : 0.018; }
    var CLO = { code: 'FMA00011', screw: 'FAS50060', d: 12 * 0.0254, y: 66 * 0.0254, rodDrop: 0.05, rodIn: 0.28, every: 16 * 0.0254, minRun: 0.30 };
    function _trimMat(T, col) { return new T.MeshStandardMaterial({ color: (TRIM_REVIEW && _isAdmin()) ? MAGENTA : col, roughness: 0.55, metalness: 0.0 }); }
    /* storey k's partitions as built (_buildPartitions' own clipping): the line, the span, the doorways */
    function _partRunsK(k) {
      var parts = STATE.parts || [], fl = floors(), out = [], i, q;
      if (k >= fl.length) return out;
      var S = _sect(), B = _barRect(), cx = (B.x0 + B.x1) / 2, linT = LINE.vb + LINE.batt + LINE.board.t, y0 = fl[k].y;
      var yIn = function (x) { return S.top + S.tan * (S.half - (S.rafD + linT) / S.sin - Math.abs(x - cx)); };
      var zIn0 = B.z0 + GABLE.d + linT, zIn1 = B.z1 - GABLE.d - linT, DS = STATE.doors || [];
      for (i = 0; i < parts.length; i++) {
        var p = parts[i]; if (!p) continue;
        var st = (typeof p.st === 'number') ? (p.st | 0) : 0;
        if (st !== k || (p.cutOn && p.cutOn.indexOf(st) >= 0)) continue;
        var vert = ((p.dir || p.o) === 'v'), at = (typeof p.at === 'number') ? p.at : p.c, wing = !!(_wingPartOf(p.id) && st === 0);
        var spn = null; try { spn = API.partSpan ? API.partSpan(p) : null; } catch (eS) { spn = null; }
        if (!(spn && typeof spn[0] === 'number' && typeof spn[1] === 'number')) spn = null;
        var lo = spn ? spn[0] : Math.min(p.a, p.b), hi = spn ? spn[1] : Math.max(p.a, p.b);
        if (vert) { lo = Math.max(lo, zIn0); hi = Math.min(hi, zIn1); if (!wing && yIn(at) - y0 < 0.60) continue; }
        else { var aMax = S.half - (S.rafD + linT) / S.sin - (y0 + 0.30 - S.top) / S.tan; lo = Math.max(lo, cx - aMax); hi = Math.min(hi, cx + aMax); }
        if (!(hi - lo >= 0.30)) continue;
        var dr = [];
        for (q = 0; q < DS.length; q++) {
          var d = DS[q]; if (!d || d.pid !== p.id) continue;
          var u = (d.u != null) ? d.u : ((d.at != null) ? d.at : d.c), w = d.w || 0.80;
          if (typeof u === 'number') dr.push([u - w / 2, u + w / 2]);
        }
        out.push({ id: p.id, vert: vert, at: at, lo: lo, hi: hi, doors: dr });
      }
      return out;
    }
    /* THE WET ROOMS' BOARD: { lining, part, ceil } m2 */
    function _wetBoardAreas() {
      var out = { lining: 0, part: 0, ceil: 0, n: 0 }, fl = floors(), S = _sect(), B = _barRect(), cx = (B.x0 + B.x1) / 2, linT = LINE.vb + LINE.batt + LINE.board.t, k, i;
      var yLin = function (x) { return S.top + S.tan * (S.half - (S.rafD + linT) / S.sin - Math.abs(x - cx)); };
      var aAt = function (y) { return S.half - (S.rafD + linT) / S.sin - (y - S.top) / S.tan; };
      var GS = _gableSegs(), fullG = {};
      GS.forEach(function (sg) {
        var rk = null; (sg.openings || []).forEach(function (o) { if (!rk && (o.rake || o.fullW || o.halfW)) rk = o; });
        var RU = null; try { RU = rk ? _rakeUnit(sg, rk) : null; } catch (eR) { RU = null; }
        if (RU && !RU.half) fullG[(Math.abs(sg.z0 - B.z0) < 0.01) ? 'z0' : 'z1'] = true;
      });
      for (k = 0; k < fl.length; k++) {
        var IN = _wetIn(k), W = _wetRects(k, IN); if (!W.length) continue;
        var yF = fl[k].y, yC = (k + 1 < fl.length) ? (fl[k + 1].y - FLOOR.deck.t - FLOOR.joist.d - LINE.batt - LINE.board.t) : 1e9, aC = (yC < 1e8) ? aAt(yC) : 0;
        var hAt = function (x) { return Math.max(0, Math.min(yC, yLin(x)) - yF); };
        var integ = function (xa, xb) { var n = 24, s = 0, q; for (q = 0; q < n; q++) s += hAt(xa + (xb - xa) * (q + 0.5) / n); return s * (xb - xa) / n; };
        var DK = _wetDoors(k), SG = _mepSegs(k), BX = _mepPlan(k).box;
        for (i = 0; i < W.length; i++) {
          var R = W[i]; out.n++;
          if (yC < 1e8) { var c0 = Math.max(R.x0, cx - aC), c1 = Math.min(R.x1, cx + aC); if (c1 > c0) out.ceil += (c1 - c0) * (R.z1 - R.z0); }
          ['x0', 'x1', 'z0', 'z1'].forEach(function (ky) {
            var ty = R.e[ky], isX = (ky.charAt(0) === 'x'), dir = (ky.charAt(1) === '0') ? 1 : -1, face = R[ky], a = 0;
            if (ty === 'open') return;
            if (ty === 'slope') {
              if (INSUL !== 'between') return;
              var oth = R[ky === 'x0' ? 'x1' : 'x0'], dStop = Math.max(0, (oth - cx) * (ky === 'x0' ? -1 : 1), aC);
              a = Math.max(0, Math.abs(face - cx) - dStop) / S.cos * (R.z1 - R.z0);
              out.lining += a; return;
            }
            if (ty === 'gable') {
              if (fullG[ky]) return;
              a = integ(R.x0, R.x1);
              SG.forEach(function (sg) {
                if (Math.abs(sg.z1 - sg.z0) > 0.01) return;
                if (((Math.abs(sg.z0 - BX.z0) < Math.abs(sg.z0 - BX.z1)) ? 'z0' : 'z1') !== ky) return;
                var ux = (sg.x1 - sg.x0) / sg.len;
                sg.openings.forEach(function (o) {
                  var xa = sg.x0 + ux * (o.at - o.w / 2), xb = sg.x0 + ux * (o.at + o.w / 2), oa = Math.max(R.x0, Math.min(xa, xb)), ob = Math.min(R.x1, Math.max(xa, xb));
                  if (ob - oa < 0.01) return;
                  a -= (ob - oa) * Math.max(0, Math.min(o.sill + o.h, hAt((oa + ob) / 2)) - o.sill);
                });
              });
              out.lining += Math.max(0, a); return;
            }
            /* a partition's face */
            var line = face - dir * (PARTA.d / 2 + LINE.board.t);
            a = isX ? hAt(face) * (R.z1 - R.z0) : integ(R.x0, R.x1);
            DK.forEach(function (d) {
              if (d.vert !== isX || Math.abs(d.line - line) > 0.04) return;
              var da = Math.max(isX ? R.z0 : R.x0, d.a), db = Math.min(isX ? R.z1 : R.x1, d.b);
              if (db > da) a -= (db - da) * Math.min(PARTA.doorH, hAt(isX ? face : (da + db) / 2));
            });
            out.part += Math.max(0, a);
          });
        }
      }
      return out;
    }
    /* THE CLOSETS (barndo-v26 PF_CLO) on storey k into g; returns the shelf run */
    function _aClosets(ctx, g, k, tot) {
      var T = ctx.THREE, U = null, fl = floors(), i, j, e, q;
      try { U = _mepRoomsOf(k); } catch (eU) { U = null; }
      if (!U || !U.rooms) return;
      var S = _sect(), B = _barRect(), cx = (B.x0 + B.x1) / 2, linT = LINE.vb + LINE.batt + LINE.board.t, IN = _wetIn(k), ins = PARTA.d / 2 + LINE.board.t;
      var yF = fl[k].y + FIT.lift, ySh = yF + CLO.y, yC = (k + 1 < fl.length) ? (fl[k + 1].y - FLOOR.deck.t - FLOOR.joist.d - LINE.batt - LINE.board.t) : 1e9;
      var yLin = function (x) { return S.top + S.tan * (S.half - (S.rafD + linT) / S.sin - Math.abs(x - cx)); };
      var aAt = function (y) { return S.half - (S.rafD + linT) / S.sin - (y - S.top) / S.tan; };
      if (yC - ySh < 0.10) return;
      var DK = _wetDoors(k), mS = _trimMat(T, CASE.col), mR = new T.MeshStandardMaterial({ color: (TRIM_REVIEW && _isAdmin()) ? MAGENTA : 0xC0C3C6, roughness: 0.35, metalness: 0.7 });
      var aOk = aAt(ySh + 0.05);   /* |x - cx| where the slope leaves room over the shelf */
      /* the units in the gables under the shelf's height, with their casings */
      var GOc = [], BXo = _mepPlan(k).box;
      _mepSegs(k).forEach(function (sg) {
        if (Math.abs(sg.z1 - sg.z0) > 0.01) return;
        var ux = (sg.x1 - sg.x0) / sg.len, zk = (Math.abs(sg.z0 - BXo.z0) < Math.abs(sg.z0 - BXo.z1)) ? 'z0' : 'z1';
        sg.openings.forEach(function (o) { if (o.sill > CLO.y + 0.05) return; var xa = sg.x0 + ux * (o.at - o.w / 2), xb = sg.x0 + ux * (o.at + o.w / 2); GOc.push({ z: zk, x0: Math.min(xa, xb) - _caseW() - 0.02, x1: Math.max(xa, xb) + _caseW() + 0.02 }); });
      });
      for (i = 0; i < U.rooms.length; i++) {
        var rm = U.rooms[i]; if (!rm || !(rm.closet || rm.key === 'rooms.wardrobe' || /wardrobe|closet|walk-?in/i.test(rm.name || ''))) continue;
        var RS = rm.rects || [], runL = 0, taken = [];
        for (j = 0; j < RS.length; j++) {
          var s = RS[j], R = { x0: Math.max(s.x0, IN.x0), x1: Math.min(s.x1, IN.x1), z0: Math.max(s.z0, IN.z0), z1: Math.min(s.z1, IN.z1) };
          if (R.x1 - R.x0 < 0.30 || R.z1 - R.z0 < 0.30) continue;
          var E = { x0: 'part', x1: 'part', z0: 'part', z1: 'part' };
          ['x0', 'x1', 'z0', 'z1'].forEach(function (ky) {
            if (Math.abs(R[ky] - IN[ky]) < 0.10) { E[ky] = (ky.charAt(0) === 'x') ? 'slope' : 'gable'; R[ky] = IN[ky]; return; }
            var isX = ky.charAt(0) === 'x', v = s[ky], q2;
            for (q2 = 0; q2 < RS.length; q2++) {
              if (q2 === j) continue;
              var o = RS[q2], vo = o[{ x0: 'x1', x1: 'x0', z0: 'z1', z1: 'z0' }[ky]], ov = isX ? (Math.min(o.z1, s.z1) - Math.max(o.z0, s.z0)) : (Math.min(o.x1, s.x1) - Math.max(o.x0, s.x0));
              if (Math.abs(vo - v) < 0.02 && ov > 0.10) { E[ky] = 'open'; return; }
            }
            R[ky] += (ky.charAt(1) === '0' ? 1 : -1) * ins;
          });
          for (e = 0; e < 4; e++) {
            var ky = ['z0', 'z1', 'x0', 'x1'][e], ty = E[ky]; if (ty === 'open' || ty === 'slope') continue;
            var isX = ky.charAt(0) === 'x', n = (ky.charAt(1) === '0') ? 1 : -1, face = R[ky], a0 = isX ? R.z0 : R.x0, a1 = isX ? R.z1 : R.x1, cut = [];
            if (isX) { if (Math.max(Math.abs(face - cx), Math.abs(face + n * CLO.d - cx)) > aOk) continue; }
            else { a0 = Math.max(a0, cx - aOk); a1 = Math.min(a1, cx + aOk); }
            var line = face - n * ins;
            var cwK = _caseW() + 0.02;
            DK.forEach(function (d) { if (ty === 'part' && d.vert === isX && Math.abs(d.line - line) < 0.04) cut.push([d.a - cwK, d.b + cwK]); });
            /* a unit in the gable under the shelf's height: left clear with its casing */
            if (ty === 'gable') GOc.forEach(function (go) { if (go.z === ky) cut.push([go.x0, go.x1]); });
            cut.sort(function (c1, c2) { return c1[0] - c2[0]; });
            var segs = [], cur = a0;
            for (q = 0; q < cut.length; q++) { if (cut[q][0] - cur >= CLO.minRun) segs.push([cur, Math.min(cut[q][0], a1)]); cur = Math.max(cur, cut[q][1]); }
            if (a1 - cur >= CLO.minRun) segs.push([cur, a1]);
            for (q = 0; q < segs.length; q++) {
              var s0 = segs[q][0], s1 = segs[q][1], r;
              for (r = 0; r < taken.length; r++) {
                var tk = taken[r];
                if (isX) { if (face > tk.x0 - 0.01 && face < tk.x1 + 0.01) { if (tk.z0 <= s0 + 0.01 && tk.z1 > s0) s0 = tk.z1; if (tk.z1 >= s1 - 0.01 && tk.z0 < s1) s1 = tk.z0; } }
                else { if (face > tk.z0 - 0.01 && face < tk.z1 + 0.01) { if (tk.x0 <= s0 + 0.01 && tk.x1 > s0) s0 = tk.x1; if (tk.x1 >= s1 - 0.01 && tk.x0 < s1) s1 = tk.x0; } }
              }
              /* a shelf along a partition that ends on a gable beside a unit's casing: pulled back off it */
              if (isX) GOc.forEach(function (go) {
                var fx0 = Math.min(face, face + n * CLO.d), fx1 = Math.max(face, face + n * CLO.d);
                if (go.x1 <= fx0 || go.x0 >= fx1) return;
                if (go.z === 'z0' && s0 < IN.z0 + 0.06) s0 = IN.z0 + 0.06;
                if (go.z === 'z1' && s1 > IN.z1 - 0.06) s1 = IN.z1 - 0.06;
              });
              if (s1 - s0 < CLO.minRun) continue;
              var L = s1 - s0, mid = (s0 + s1) / 2, dIn = n * CLO.d;
              _am(ctx, 'closet_shelf', 'Closet shelf', CLO.code, 'side');
              var sh = new T.Mesh(isX ? new T.BoxGeometry(CLO.d, 0.02, L) : new T.BoxGeometry(L, 0.02, CLO.d), mS);
              sh.position.set(isX ? face + dIn / 2 : mid, ySh, isX ? mid : face + dIn / 2); g.add(sh);
              var rod = new T.Mesh(new T.CylinderGeometry(0.0125, 0.0125, L, 10), mR);
              if (isX) rod.rotation.x = Math.PI / 2; else rod.rotation.z = Math.PI / 2;
              rod.position.set(isX ? face + n * CLO.rodIn : mid, ySh - CLO.rodDrop, isX ? mid : face + n * CLO.rodIn); g.add(rod);
              taken.push(isX ? { x0: Math.min(face, face + dIn), x1: Math.max(face, face + dIn), z0: s0, z1: s1 } : { x0: s0, x1: s1, z0: Math.min(face, face + dIn), z1: Math.max(face, face + dIn) });
              runL += L;
            }
          }
        }
        if (runL > 0) { tot.len += runL; tot.rooms.push((rm.name || rm.def || 'closet') + ' on floor ' + (k + 1) + ' ' + (Math.round(runL * 100) / 100) + ' m'); }
      }
    }

    /* -------------------------------------------------------------------------
       THE FITOUT -- aframe-fitout (aframe-v138, P4 of the parity with the ADU).
       COPIED from the ADU's adu-fitout (_buildFitout, adu-v1427): the pieces
       placed with FITOUT on the Floorplan step drawn as blocks of their plan
       size and height -- kitchens with their worktop, sink, hob and wall
       units, baths, showers, basins, the toilet, beds, wardrobes, sofas,
       tables with their chairs, the appliances -- and billed with the rows
       that go with them (faucet, mattress, chairs, four FAS60080 for a piece
       on a wall, a tube of silicone FEC00040 for a wet one).
       ADAPTED to the A, as the garage apartment does its two storeys:
         - each piece stands on the floor of its own storey (f.st, stamped by
           the plan from the storey card lit when it went in -- the hook
           below), on the finish over the deck or the slab;
         - the gable runs through every storey, so an opening is in the way of
           the wall units by its height over that floor, and a full or half
           glazing whose glass comes into their band takes the whole run;
         - a wall unit under the slope (its back top corners outside the
           lining at 2150) is left out; any piece that still reaches into the
           roof is named in the log, drawn and billed as placed;
         - the plan's stair pieces are left to the A's own stairs layer.
       Magenta for an admin until checked (FIT_REVIEW).
       ------------------------------------------------------------------------- */
    var FIT = { lift: 0.008 };          /* underlay 3 + vinyl 5 over the deck or the slab */
    var FIT_REVIEW = true;
    function _fitHook(PL) {
      if (!PL || !PL.fixtures || !PL.fixtures.hooks) return;
      try { PL.fixtures.hooks({ storey: function () { return (floors().length > 1) ? (STATE.planStorey | 0) : 0; } }); } catch (eHk) {}
    }
    /* THE FITOUT PICKER (aframe-v168; COPIED from the T house, thouse-lib's
       _openFitouts / _fitGroupOf -- the same build(__CORE) shape as the A --
       which is the ADU's loop, adu-v1403's room groups with it). Every other
       house-line product hands the core __PROD._openFitouts, and the core
       draws the red plus in a room and the fitout icon on the plan strip only
       when a product does (core-v76 _fitHasCatalog): the A never did, so its
       aframe-fitout layer (v138) built what a library plan brought and the
       buyer could add nothing. ADAPTED: no stairs among the pieces (the A's
       flights come from the openings, aframe-stairs), and the piece lands on
       the storey the plan shows (the fixtures' storey hook, _fitHook). */
    function _fitGroupOf(name) {
      var n = String(name || '').toLowerCase();
      if (/bath|shower|toilet|wc|utility|laundry/.test(n)) return ['bathroom'];
      /* adu-v1403: a dining room gets the tables, a walk-in the wardrobes */
      if (/diningroom|dining room/.test(n)) return ['dining'];
      if (/wardrobe|walk-in/.test(n)) return ['bedroom'];
      if (/kitchen|dining|kitchenette/.test(n)) return ['kitchen', 'dining'];
      if (/bed|kids|nursery|children|office|study/.test(n)) return ['bedroom'];
      if (/living|lounge|hall|entry|entrance/.test(n)) return ['living', 'dining'];
      return null;
    }
    function _fitRoomKeyAt(PL, x, z) {
      var R = [], i, j;
      try { R = (PL && PL.rooms) ? (PL.rooms() || []) : []; } catch (eR) { return null; }
      for (i = 0; i < R.length; i++) {
        var RS = (R[i] && R[i].rects) || [], hit = false;
        for (j = 0; j < RS.length; j++) if (x >= RS[j].x0 - 0.01 && x <= RS[j].x1 + 0.01 && z >= RS[j].z0 - 0.01 && z <= RS[j].z1 + 0.01) { hit = true; break; }
        if (!hit) continue;
        var FL = global.FloorplanLib, T0 = (FL && FL.draw && FL.draw.roomTable) ? FL.draw.roomTable() : [], idx = PL.roomNameIdx ? PL.roomNameIdx(R[i], i) : i;
        var row = T0.length ? T0[(((idx | 0) % T0.length) + T0.length) % T0.length] : null;
        return row ? (String(row.i18n || '') + ' ' + String(row.def || '')) : null;
      }
      return null;
    }
    function _openFitouts(groups) {
      var U = _UI && _UI(), PL = null;
      try { PL = __CORE._P ? __CORE._P() : null; } catch (eP) { PL = null; }
      if (!U || !U.picker) { _log('fitouts: shared picker missing'); return; }
      if (!PL || !PL.fixtures || !PL.fixtures.catalog) { _log('fitouts: floorplan asset without fixtures'); return; }
      _fitHook(PL);
      var FX = PL.fixtures, at0 = __CORE._fitAt, rm0 = __CORE._fitRoom, px = at0 ? at0.x : (rm0 ? rm0.x : null), pz = at0 ? at0.z : (rm0 ? rm0.z : null);
      var rk = (px != null) ? _fitRoomKeyAt(PL, px, pz) : null;
      if (rk) groups = _fitGroupOf(rk);
      var cat = FX.catalog(), keys = FX.order ? FX.order() : Object.keys(cat), items = [], iK, nSt = 0;
      for (iK = 0; iK < keys.length; iK++) {
        var Dk = cat[keys[iK]];
        if (!Dk) continue;
        if (Dk.stair || Dk.grp === 'stairs') { nSt++; continue; }   /* the A's flights come from its openings */
        if (groups && groups.length) {
          var gD = Dk.grp === 'living' && /^table/.test(keys[iK]) ? 'dining' : Dk.grp;
          if (groups.indexOf(gD) < 0 && groups.indexOf(Dk.grp) < 0) continue;
        }
        items.push({ key: keys[iK], sub: _t(Dk.i18n, Dk.def) + (Dk.sub ? (' ' + Dk.sub) : ''),
                     w: Dk.w, h: Dk.d, glyph: FX.glyph(keys[iK]), glyphVb: FX.glyphVb ? FX.glyphVb(keys[iK]) : '24 24',
                     code: fmtLen(Dk.w) + ' x ' + fmtLen(Dk.d) });
      }
      _log('fitouts: storey ' + ((STATE.planStorey | 0) + 1) + ', room ' + (rk || '?') + ' -> groups ' + (groups ? groups.join(', ') : 'all') + '; ' + items.length + ' piece(s) offered' + (nSt ? (', ' + nSt + ' stair kind(s) left out (the stairs come from the openings)') : '') + ' (aframe-v168)');
      if (!items.length) return;
      U.picker({
        title: String(_t('container_int_fitout', 'FITOUT')).toUpperCase(),
        items: items,
        allLabel: _t('all', 'All'),
        fmt: fmtLen,
        noFilter: true,
        onPick: function (it) {
          var at = __CORE._fitAt; __CORE._fitAt = null;
          var rm = __CORE._fitRoom;
          var f = at ? FX.add(it.key, at.x, at.z)
                : (rm ? FX.add(it.key, null, null, rm.x, rm.z) : FX.add(it.key));
          if (f && at && FX.moveTo) FX.moveTo(f, f.x, f.z);   /* snap to the wall there */
          if (!f) { _log('fitout: nothing placed for ' + it.key); return; }
          _log('fitout placed: ' + it.key + ' on storey ' + ((f.st | 0) + 1) + ' at ' + f.x.toFixed(2) + ',' + f.z.toFixed(2) + ' rot ' + f.rot + ' (aframe-v168)');
          __CORE._fitLast = f;
          try { __CORE.savePref(); } catch (eS) {}
          API.rebuild();
          try { __CORE.drawPlan(); } catch (eD) {}
          try { __CORE.fitEdit(true); } catch (eF) {}
        }
      });
    }
    __PROD._openFitouts = _openFitouts;
    __PROD._fitGroupOf = _fitGroupOf;
    /* a piece's point in the piece's own frame (x across, z into the room, back at -z) to the world */
    function _fitWorld(f, lx, lz) {
      var rot = (f.rot | 0) % 4, c = Math.cos(rot * Math.PI / 2), s = Math.sin(rot * Math.PI / 2), mir = f.mirror ? -1 : 1;
      lx = lx * mir;
      return [f.x + lx * c - lz * s, f.z + lx * s + lz * c];
    }
    /* how far a point at height y over the piece's floor lies past the inside
       of the roof: the lining under the slope, the ceiling under the floor
       above, or in a side wing (ground floor) its ceiling; <= 0 = clear */
    function _fitPast(st, wx, wz, hh) {
      var fl = floors(), S = _sect(), B = _barRect(), cx = (B.x0 + B.x1) / 2, linT = LINE.vb + LINE.batt + LINE.board.t;
      var F = fl[st | 0] || fl[0], y = F.y + FIT.lift + hh, past = -1, q;
      if ((st | 0) + 1 < fl.length) {
        var yC = fl[(st | 0) + 1].y - FLOOR.joist.d - FLOOR.deck.t - LINE.batt - LINE.board.t;
        if (y > yC) past = Math.max(past, y - yC);
      }
      var xMax = S.half - (S.rafD + linT) / S.sin - (y - S.top) / S.tan, dx = Math.abs(wx - cx) - xMax;
      if (dx > 0 && (st | 0) === 0) {
        var sides = _wingSides();
        for (q = 0; q < sides.length; q++) {
          var WR = _wingRect(sides[q]);
          if (wz > WR.z0 && wz < WR.z1 && (wx - cx) * sides[q] > 0) {
            var Hw = _wingH(sides[q]), yW = Hw.wallTop - LINE.batt - LINE.board.t;
            dx = (y <= yW + 0.005) ? -1 : (y - yW);
          }
        }
      }
      return Math.max(past, dx);
    }
    function _fitClear(f, pts, hh) {
      var q;
      for (q = 0; q < pts.length; q++) { var W = _fitWorld(f, pts[q][0], pts[q][1]); if (_fitPast(f.st | 0, W[0], W[1], hh) > 0.005) return false; }
      return true;
    }
    /* the most a piece's top corners reach past the inside of the roof */
    function _fitPoke(f, w, d, h) {
      var C = [[-w / 2, -d / 2], [w / 2, -d / 2], [w / 2, d / 2], [-w / 2, d / 2]], m = 0, q;
      for (q = 0; q < 4; q++) { var W = _fitWorld(f, C[q][0], C[q][1]); m = Math.max(m, _fitPast(f.st | 0, W[0], W[1], h)); }
      return m;
    }
    /* A PIECE STANDS CLEAR OF THE SLOPE (aframe-v169). The plan snaps a piece
       with a back -- a sofa, a wardrobe, a kitchen run -- to the floor's edge,
       and on the A the floor's long edge is the foot of the slope: a sofa's
       back stood 421 into the roof on the 6x9 (logged since aframe-v138, never
       moved). Now the piece is moved out from that edge into the room, square
       to its back, until its top corners are clear of the lining (the plan
       shows it there, the project keeps it); a piece the move does not help
       (too tall under the floor above, against a gable) stays where it was
       and is named as before. At most 1.5 m. */
    function _fitNudge(f, w, d, h) {
      var pk0 = _fitPoke(f, w, d, h);
      if (!(pk0 > 0.005)) return 0;
      var rot = (f.rot | 0) % 4, nx = -Math.sin(rot * Math.PI / 2), nz = Math.cos(rot * Math.PI / 2);
      var x0 = f.x, z0 = f.z, moved = 0, pk = pk0, q;
      for (q = 0; q < 8 && pk > 0.005 && moved < 1.5 - 1e-6; q++) {
        var stp = Math.min(1.5 - moved, pk + 0.02);
        f.x += nx * stp; f.z += nz * stp; moved += stp;
        var pk2 = _fitPoke(f, w, d, h);
        if (pk2 > pk - 0.005) { f.x = x0; f.z = z0; return -pk0; }   /* not the slope behind it: left as placed */
        pk = pk2;
      }
      if (pk > 0.005) { f.x = x0; f.z = z0; return -pk0; }
      f.x = Math.round(f.x * 1000) / 1000; f.z = Math.round(f.z * 1000) / 1000;
      return moved;
    }
    function _buildFitout(ctx) {
      /* one step for every piece, named as the group (Marek) */
      _asmMark(ctx, 'container_int_fitout', 'top', 'Fitout', '', true);

      _bill['aframe-fitout'] = {};
      var _add = function (lay, code, q) { API.billAdd('aframe-fitout', code, q); };
      var T = ctx.THREE, g = ctx.group, i;
      var PL = null; try { PL = __CORE._P ? __CORE._P() : null; } catch (eP) { PL = null; }
      _fitHook(PL);
      var P = STATE.product || {}, L = P.fixtures || [];
      if (!PL || !PL.fixtures) { ctx.log('FIT  none -- floorplan asset without fixtures'); return; }
      if (!L.length) { ctx.log('FIT  none -- no piece placed (FITOUT in the floorplan)'); return; }
      var cat = PL.fixtures.catalog();
      /* the rows come from the asset's catalogue: registered here so _add
         knows them, by the piece (pcs) */
      var FIT_ROWS = { SKS08401: 'Kitchen sink', SFA00001: 'Washbasin faucet', SFA00002: 'Bathtub faucet set',
                       SFA00003: 'Shower faucet set', FMA00002: 'Mattress', FKB00004: 'Desk chair', FDI00002: 'Dining chair',
                       /* aframe-v145: the kitchen run's appliances (the shared fixture table, floorplan-lib-v206) */
                       FKI00013: 'Electric range', FKI00014: 'Dishwasher', FKI00015: 'Dishwasher installation kit', FKI00016: 'Range hood' };
      var kq, cq;
      for (kq in cat) {
        if (!cat.hasOwnProperty(kq)) continue;
        var Dq = cat[kq];
        if (Dq.code && !__CORE.CATALOG[Dq.code]) __CORE.CATALOG[Dq.code] = { code: Dq.code, unit: 'pcs', label: Dq.def };
        if (Dq.extra) for (cq = 0; cq < Dq.extra.length; cq++) {
          if (!__CORE.CATALOG[Dq.extra[cq]]) __CORE.CATALOG[Dq.extra[cq]] = { code: Dq.extra[cq], unit: 'pcs', label: FIT_ROWS[Dq.extra[cq]] || Dq.extra[cq] };
        }
      }
      /* THE FLOOR OF THE PIECE'S STOREY (aframe-v138, as the garage apartment
         does it): the plan stamps the storey whose card was lit when the piece
         went in (f.st, the hook above); the piece stands on that floor's
         finish, the underlay and the vinyl over the deck or the slab. A piece
         without a storey is a ground floor one. */
      var fl = floors(), yF = fl.map(function (F9) { return F9.y + FIT.lift; }), y0 = yF[0];
      var mag = FIT_REVIEW && _isAdmin();
      function M(col, o) {
        o = o || {};
        return new T.MeshStandardMaterial({ color: mag ? MAGENTA : col, roughness: o.r != null ? o.r : 0.85,
          metalness: o.m || 0, transparent: !!o.a, opacity: o.a != null ? o.a : 1, side: o.a ? T.DoubleSide : T.FrontSide });
      }
      var mWood = M(0xB8956A), mFab = M(0x9A8F82), mFabD = M(0x7E746A), mWhite = M(0xF2F2EE, { r: 0.4 }),
          mSteel = M(0xB7BCC0, { r: 0.35, m: 0.6 }), mGlass = M(0xBFD4DC, { r: 0.1, a: 0.35 }),
          mDark = M(0x3B3D40, { r: 0.6 }), mLinen = M(0xE9E4DA, { r: 0.9 }), mTop = M(0xD9D2C3, { r: 0.5 });
      var n = 0, tally = {};

      /* THE PIECES ARE BUILT IN THEIR OWN FRAME -- x across, z into the room,
         back at -z -- and turned by rot; part() takes a box in that frame. */
      function partOf(f) {
        var rot = (f.rot | 0) % 4, c = Math.cos(rot * Math.PI / 2), s = Math.sin(rot * Math.PI / 2);
        var mir = f.mirror ? -1 : 1;
        return function (w, h, d, lx, lz, ly, mat, geo) {
          lx = lx * mir;
          var rx = lx * c - lz * s, rz = lx * s + lz * c;
          var mesh = new T.Mesh(geo || new T.BoxGeometry(w, h, d), mat);
          var yP = yF[f.st | 0]; if (typeof yP !== 'number') yP = y0;
          mesh.position.set(f.x + rx, yP + (ly || 0) + h / 2, f.z + rz);
          mesh.rotation.y = -rot * Math.PI / 2;
          mesh.name = 'fitout';
          mesh.userData.hideInPlan = true;
          mesh.visible = !_inPlan();
          g.add(mesh);
          return mesh;
        };
      }
      function cyl(r, h, seg) { return new T.CylinderGeometry(r, r, h, seg || 20); }

      function sofaRun(part, w, d, h) {
        var seat = 0.42, back = 0.22, arm = 0.2;
        part(w, seat, d, 0, 0, 0, mFab);                                  /* the seat */
        part(w, h - seat, back, 0, -d / 2 + back / 2, seat, mFabD);        /* the back */
        part(arm, 0.2, d - back, -w / 2 + arm / 2, back / 2, seat, mFabD); /* arms */
        part(arm, 0.2, d - back, w / 2 - arm / 2, back / 2, seat, mFabD);
        /* rounded edges: a roll along the top of the back and each arm, and
           cushions with softened corners */
        part(w, 0.06, 0.06, 0, -d / 2 + back / 2, h - 0.03, mFabD, cyl(0.055, w, 12).rotateZ(Math.PI / 2));
        part(0.06, 0.06, d - back, -w / 2 + arm / 2, back / 2, seat + 0.2 - 0.03, mFabD, cyl(0.055, d - back, 12).rotateX(Math.PI / 2));
        part(0.06, 0.06, d - back, w / 2 - arm / 2, back / 2, seat + 0.2 - 0.03, mFabD, cyl(0.055, d - back, 12).rotateX(Math.PI / 2));
        var nC = Math.max(1, Math.round((w - 2 * arm) / 0.7)), cw = (w - 2 * arm) / nC, q;
        for (q = 0; q < nC; q++) {
          part(cw - 0.03, 0.08, d - back - 0.06, -w / 2 + arm + cw * (q + 0.5), back / 2, seat, mFab);
          part(cw - 0.06, 0.05, d - back - 0.09, -w / 2 + arm + cw * (q + 0.5), back / 2, seat + 0.08, mFab);
        }
      }
      function bed(part, w, d, tall) {
        part(w, 0.3, d, 0, 0, 0, mWood);                                   /* frame */
        part(w - 0.08, 0.2, d - 0.08, 0, 0.02, 0.3, mLinen);               /* mattress */
        part(w, tall ? 0.9 : 0.5, 0.06, 0, -d / 2 + 0.03, 0.3, mWood);     /* headboard */
        var pw = (w - 0.2) / 2 - 0.05, q;
        for (q = 0; q < (w > 1.2 ? 2 : 1); q++) {
          var px = (w > 1.2) ? (-w / 4 + (q ? w / 2 : 0)) : 0;
          part(w > 1.2 ? pw : w - 0.3, 0.1, 0.45, px, -d / 2 + 0.35, 0.5, mWhite);
        }
      }
      /* THE UPPER ROW: along the back run between lx0 and lx1 in the piece's
         own x, 600 units, only where the back stands on a wall, and never
         across a window in that wall -- a unit that would sit on a window is
         left out (Marek). The window spans come from the exterior segment the
         back stands against, in the piece's own x. */
      function windowSpans(f, D, dReal) {
        var out = [], rot = (f.rot | 0) % 4, SEGS = API.segments ? API.segments() : [], q, o;
        /* the back line in world: its centre and its direction (local +x) --
           adu-v1427: at the depth the piece is built at (an L drawn 3.60 deep
           is not the catalogue's), or the back line missed its wall */
        var c = Math.cos(rot * Math.PI / 2), s = Math.sin(rot * Math.PI / 2), dB = (dReal > 0) ? dReal : D.d;
        var bx = f.x + (0 * c - (-dB / 2) * s), bz = f.z + (0 * s + (-dB / 2) * c);
        /* local +x in world -- mirrored with the piece, so the spans land on
           the same units part() puts the cabinets on */
        var mir = f.mirror ? -1 : 1;
        var dx = c * mir, dz = s * mir;
        for (q = 0; q < SEGS.length; q++) {
          var sg = SEGS[q]; if (!sg || !(sg.len > 0.2)) continue;
          var ux = (sg.x1 - sg.x0) / sg.len, uz = (sg.z1 - sg.z0) / sg.len;
          /* parallel and within 450 mm of the line -- adu-v1427: the segment is the
             wall's axis, and a block house's 440 block with its plaster puts
             the room's face 0.24 in from it */
          if (Math.abs(ux * dz - uz * dx) > 0.2) continue;
          var nx = -uz, nz = ux;
          var dist = Math.abs((bx - sg.x0) * nx + (bz - sg.z0) * nz);
          if (dist > 0.45) continue;
          var ops = sg.openings || [], k2;
          for (k2 = 0; k2 < ops.length; k2++) {
            o = ops[k2];
            /* WHAT REACHES UP TO THE CABINETS IS IN THEIR WAY (adu-v1427, Marek:
               vrchni skrinky kuchynske linky jsou pres stavebni otvor / okno).
               A sill above the slab was the test for a window, and a door was
               never in the way of a cabinet at 1.45 -- so the 2.59 m HS sliding
               door behind the kitchen of plan 1000076010 had its glass under a
               row of wall units. Any opening whose head is above the units'
               underside is in the way: a window, French or sliding doors, a
               door; a low window under 1.45 is not. */
            /* THE A's GABLE RUNS UP THROUGH EVERY STOREY (aframe-v138): an
               opening is in the way when it reaches into the band of the wall
               units (1450..2150) over the floor the piece stands on; a full or
               half glazing whose glass comes down into that band takes the
               whole run */
            var yFl = yF[f.st | 0]; if (typeof yFl !== 'number') yFl = y0;
            if (o.rake || o.fullW || o.halfW) {
              var RUo = null; try { RUo = _rakeUnit(sg, o); } catch (eRu) { RUo = null; }
              if (RUo && RUo.yB - yFl < 2.15) out.push([-99, 99]);
              continue;
            }
            var oy0 = (sg.y0 || 0) + (o.sill || 0) - yFl, oy1 = oy0 + (o.h || 0);
            if (oy1 <= 1.45 || oy0 >= 2.15) continue;
            /* the window centre in world, then along the piece's x */
            var wx = sg.x0 + ux * o.at, wz = sg.z0 + uz * o.at;
            var lx = (wx - f.x) * dx + (wz - f.z) * dz;
            /* the frame plus the reveal lining and its trim on both jambs, and
               a hand's clearance: a cabinet that touches the trim is one too
               many (Marek: the cabinets ran into the window) */
            out.push([lx - o.w / 2 - 0.16, lx + o.w / 2 + 0.16]);
          }
        }
        return out;
      }
      function uppers(f, part, lx0, lx1, d) {
        var D = cat[f.kind];
        /* one step per piece, named as the catalogue names the piece (a
           kitchen is a kitchen, not the carcass line of its budget) -- Marek */

        if (!(PL.fixtures.backAtWall && PL.fixtures.backAtWall(f))) return;
        var spans = windowSpans(f, D, d), run = lx1 - lx0;
        var nU = Math.max(1, Math.round(run / 0.6)), uw = run / nU, qu, sq, skipped = 0, HIT = [], slopeOut = 0;
        for (qu = 0; qu < nU; qu++) {
          var a = lx0 + uw * qu, b = a + uw, hit = false;
          for (sq = 0; sq < spans.length; sq++) if (a < spans[sq][1] && b > spans[sq][0]) { hit = true; break; }
          HIT.push(hit);
        }
        /* adu-v1427: the counter stays, the wall units go where the opening
           is -- and a single unit left alone beside it goes too (Marek:
           pokud je tam okno, muzes nechat kuchynskou linku ale bez vrchnich
           skrinek) */
        for (qu = 0; qu < nU; qu++) {
          if (HIT[qu]) { skipped++; continue; }
          var lone = (qu === 0 || HIT[qu - 1]) && (qu === nU - 1 || HIT[qu + 1]) && HIT.indexOf(true) >= 0;
          if (lone) { skipped++; continue; }
          var a2 = lx0 + uw * qu, b2 = a2 + uw;
          /* UNDER THE SLOPE (aframe-v138): a wall unit whose back top corners
             are not inside the lining at 2150 is left out -- on a slope, or in
             the corner where a gable meets it */
          if (!_fitClear(f, [[a2 + 0.01, -d / 2], [b2 - 0.01, -d / 2]], 2.15)) { slopeOut++; continue; }
          part(uw - 0.02, 0.7, 0.35, (a2 + b2) / 2, -d / 2 + 0.175, 1.45, mWood);
        }
        ctx.log('FIT  uppers on ' + f.kind + ' (floor ' + ((f.st | 0) + 1) + '): ' + (nU - skipped - slopeOut) + ' of ' + nU + ' unit(s)' + (slopeOut ? (', ' + slopeOut + ' under the slope left out') : '') + ', ' + spans.length +
                ' window span(s) behind' + (spans.length ? (' ' + spans.map(function (sp) { return Math.round(sp[0] * 1000) + '..' + Math.round(sp[1] * 1000); }).join(' ')) : ''));
      }

      function chair(part, lx, lz, back) {
        part(0.42, 0.05, 0.42, lx, lz, 0.42, mWood);
        part(0.42, 0.45, 0.04, lx, lz + back * 0.19, 0.47, mWood);
        var q, o = 0.17;
        for (q = 0; q < 4; q++) part(0.03, 0.42, 0.03, lx + (q % 2 ? o : -o), lz + (q > 1 ? o : -o), 0, mWood);
      }
      /* a chair at the end of a table: its back along the piece's own x
         (adu-v1416, the table of eight) */
      function chairEnd(part, lx, lz, back) {
        part(0.42, 0.05, 0.42, lx, lz, 0.42, mWood);
        part(0.04, 0.45, 0.42, lx + back * 0.19, lz, 0.47, mWood);
        var q, o = 0.17;
        for (q = 0; q < 4; q++) part(0.03, 0.42, 0.03, lx + (q % 2 ? o : -o), lz + (q > 1 ? o : -o), 0, mWood);
      }
      /* a stool at a counter: round seat, steel post, round foot */
      function stool(part, lx, lz, seat) {
        part(0.36, 0.05, 0.36, lx, lz, seat, mDark, cyl(0.18, 0.05, 20));
        part(0.05, seat, 0.05, lx, lz, 0, mSteel, cyl(0.025, seat, 12));
        part(0.4, 0.02, 0.4, lx, lz, 0, mSteel, cyl(0.2, 0.02, 20));
      }
      var noRow = {}, sizedUS = 0, nCompact = 0, stackedBilled = 0;
      /* aframe-v138: each piece is read on its own storey -- the plan's walls
         of that card behind it (backAtWall), as the garage apartment does */
      var psKeep = STATE.planStorey, onSt = fl.map(function () { return 0; }), nOff = 0, nStair = 0, pokes = [], nudged = [];
      try {
      for (i = 0; i < L.length; i++) {
        var f = L[i], D = cat[f.kind];
        if (!D) continue;
        /* the A's stairs are its own layer (aframe-stairs), from its floor openings */
        if (D.stair) { nStair++; continue; }
        if ((f.st | 0) >= fl.length) { nOff++; continue; }   /* a piece of a storey the A no longer has */
        onSt[f.st | 0]++;
        STATE.planStorey = f.st | 0;
        var part = partOf(f), w = D.w, d = D.d, h = D.h, k = f.kind;
        /* AT THE SIZE THE PLAN DRAWS IT (adu-v1417): the asset gives an
           appliance its US stock size on an imperial page -- a 27 in washer
           and dryer, a 36 in fridge -- or the compact one where that does not
           fit (floorplan v151); the model was built from the catalogue's
           600 mm whatever the plan showed */
        try {
          var SZf = (PL.fixtures.size) ? PL.fixtures.size(f) : null;
          if (SZf && SZf.w > 0 && SZf.d > 0) { w = SZf.w; d = SZf.d; }
          if (PL.fixtures.height) { var Hf = +PL.fixtures.height(f); if (Hf > 0) h = Hf; }
        } catch (eSZ) {}
        if (D.appliance && D.wi > 0 && Math.abs(w - D.w) > 0.01) sizedUS = (sizedUS || 0) + 1;
        if (f.compact) nCompact++;
        /* aframe-v169: out from the slope's foot until it stands clear under the lining */
        var nud = _fitNudge(f, w, d, h);
        if (nud > 0) nudged.push(k + ' floor ' + ((f.st | 0) + 1) + ' ' + Math.round(nud * 1000));
        if (/^kitchen(24|30|36)$/.test(k)) {
          /* base cabinets, a worktop, the sink and the hob in the top -- no
             tall column (Marek); the fridge is in the row */
          var run = w;
          part(run, 0.85, d - 0.02, 0, 0.01, 0, mWood);
          part(run, 0.04, d, 0, 0, 0.85, mTop);
          part(0.5, 0.02, 0.4, -w / 2 + 0.45, 0, 0.89, mSteel);
          part(0.58, 0.015, 0.5, w / 2 - 0.55, 0, 0.89, mDark);
          var q1; for (q1 = 0; q1 < 4; q1++) part(0.18, 0.005, 0.18, w / 2 - 0.55 + (q1 % 2 ? 0.14 : -0.14), (q1 > 1 ? 0.12 : -0.12), 0.905, mSteel, cyl(0.09, 0.005, 24));
          uppers(f, part, -w / 2, w / 2, d);
        } else if (k === 'kitchenL' || k === 'kitchenU') {
          var leg = 0.6;
          part(w, 0.85, leg, 0, -d / 2 + leg / 2, 0, mWood); part(w, 0.04, leg, 0, -d / 2 + leg / 2, 0.85, mTop);
          part(leg, 0.85, d - leg, -w / 2 + leg / 2, leg / 2, 0, mWood); part(leg, 0.04, d - leg, -w / 2 + leg / 2, leg / 2, 0.85, mTop);
          if (k === 'kitchenU') { part(leg, 0.85, d - leg, w / 2 - leg / 2, leg / 2, 0, mWood); part(leg, 0.04, d - leg, w / 2 - leg / 2, leg / 2, 0.85, mTop); }
          part(0.5, 0.02, 0.4, 0, -d / 2 + leg / 2, 0.89, mSteel);
          part(0.58, 0.015, 0.5, -w / 2 + leg / 2, d / 2 - 0.5, 0.89, mDark);
          uppers(f, part, -w / 2, w / 2, d);
        } else if (k === 'island') {
          part(w, 0.85, d, 0, 0, 0, mWood); part(w + 0.1, 0.04, d + 0.1, 0, 0, 0.85, mTop);
        } else if (k === 'island18' || k === 'island24') {
          /* THE ISLAND WITH ITS STOOLS (adu-v1416): the counter at the back of
             the set -- cabinets, the worktop running 0.25 m over their front
             for the knees -- and a stool to every 0.6 m in front of it */
          var itw = D.tw || w, itd = D.td || 0.9, ibz = -d / 2 + itd / 2, nSt = D.stools || Math.max(1, Math.round(itw / 0.6));
          part(itw - 0.05, 0.85, itd - 0.3, 0, ibz - 0.15, 0, mWood);
          part(itw, 0.04, itd, 0, ibz, 0.86, mTop);
          var qi; for (qi = 0; qi < nSt; qi++) stool(part, -itw / 2 + itw * (qi + 0.5) / nSt, d / 2 - 0.2, 0.62);
        } else if (/^bath/.test(k)) {
          part(w, h, d, 0, 0, 0, mWhite);
          part(w - 0.16, 0.02, d - 0.16, 0, 0, h - 0.02, mGlass);   /* the water line, the tub reads hollow */
          part(0.06, 0.15, 0.06, -w / 2 + 0.15, 0, h, mSteel, cyl(0.02, 0.15, 12));
        } else if (/^shower/.test(k)) {
          part(w, 0.04, d, 0, 0, 0, mWhite);
          part(w, h, 0.01, 0, d / 2 - 0.005, 0.04, mGlass);           /* glass front */
          part(0.01, h, d, w / 2 - 0.005, 0, 0.04, mGlass);           /* glass side */
          part(0.04, 1.1, 0.04, -w / 2 + 0.05, -d / 2 + 0.05, 1.0, mSteel, cyl(0.015, 1.1, 12));
          part(0.2, 0.02, 0.2, -w / 2 + 0.2, -d / 2 + 0.2, 2.05, mSteel, cyl(0.1, 0.02, 20));
        } else if (/^basin/.test(k)) {
          part(w, 0.7, d, 0, 0, 0, mWood);
          part(w, 0.02, d, 0, 0, 0.7, mTop);
          part(w * 0.7, 0.13, d * 0.75, 0, 0, 0.72, mWhite);
          part(0.04, 0.2, 0.04, 0, -d / 2 + 0.06, 0.85, mSteel, cyl(0.015, 0.2, 12));
        } else if (k === 'wc') {
          part(0.18, 0.4, 0.18, 0, d / 2 - 0.2, 0, mWhite, cyl(0.16, 0.4, 20));
          part(0.36, 0.05, 0.5, 0, d / 2 - 0.25, 0.4, mWhite);
          part(w, 0.35, 0.16, 0, -d / 2 + 0.08, 0.4, mWhite);
        } else if (k === 'bedDouble' || k === 'bedSingle') {
          bed(part, w, d, false);
        } else if (k === 'bunk') {
          bed(part, w, d, true);
          part(w - 0.08, 0.2, d - 0.08, 0, 0.02, 1.35, mLinen);
          part(w, 0.2, 0.06, 0, -d / 2 + 0.03, 1.15, mWood);
          var qb; for (qb = 0; qb < 4; qb++) part(0.06, 1.55, 0.06, (qb % 2 ? w / 2 - 0.03 : -w / 2 + 0.03), (qb > 1 ? d / 2 - 0.03 : -d / 2 + 0.03), 0, mWood);
        } else if (k === 'bedside') {
          part(w, 0.5, d, 0, 0, 0, mWood); part(0.2, 0.3, 0.2, 0, 0, 0.5, mWhite, cyl(0.1, 0.3, 16));
        } else if (k === 'wardrobe') {
          part(w, h, d, 0, 0, 0, mWood);
          part(0.02, h - 0.1, 0.02, 0, d / 2 + 0.005, 0.05, mDark);
          part(0.02, 0.3, 0.02, -0.06, d / 2 + 0.02, h / 2 - 0.15, mSteel); part(0.02, 0.3, 0.02, 0.06, d / 2 + 0.02, h / 2 - 0.15, mSteel);
        } else if (k === 'desk') {
          part(w, 0.03, d, 0, 0, 0.72, mWood);
          var qd; for (qd = 0; qd < 4; qd++) part(0.04, 0.72, 0.04, (qd % 2 ? w / 2 - 0.05 : -w / 2 + 0.05), (qd > 1 ? d / 2 - 0.05 : -d / 2 + 0.05), 0, mSteel);
          part(0.5, 0.35, 0.02, 0.15, -d / 2 + 0.15, 0.78, mDark);
          chair(part, 0, d / 2 + 0.3, 1);
        } else if (/^sofa[234]$/.test(k)) {
          sofaRun(part, w, d, h);
        } else if (k === 'sofaL' || k === 'sofaU') {
          var seatD = 0.9, seat = 0.42, back = 0.22;
          sofaRun(part, w, seatD, h);
          /* the legs: seat, back on the outer side, and the same cushions at the
             same height, divided by the same joints (Marek) */
          function legRun(side) {
            var lx = side * (w / 2 - seatD / 2), ld = d - seatD;
            part(seatD, seat, ld, lx, seatD / 2, 0, mFab);
            part(back, h - seat, ld, side * (w / 2 - back / 2), seatD / 2, seat, mFabD);
            part(0.06, 0.06, ld, side * (w / 2 - back / 2), seatD / 2, h - 0.03, mFabD, cyl(0.055, ld, 12).rotateX(Math.PI / 2));
            var nC = Math.max(1, Math.round(ld / 0.7)), cw = ld / nC, q;
            for (q = 0; q < nC; q++) {
              var lz = seatD / 2 - ld / 2 + cw * (q + 0.5);
              part(seatD - back - 0.06, 0.08, cw - 0.03, lx - side * back / 2, lz, seat, mFab);
              part(seatD - back - 0.09, 0.05, cw - 0.06, lx - side * back / 2, lz, seat + 0.08, mFab);
            }
          }
          legRun(-1);
          if (k === 'sofaU') legRun(1);
        } else if (k === 'armchair') {
          sofaRun(part, w, d, h);
        } else if (k === 'coffee') {
          part(w, 0.03, d, 0, 0, 0.42, mWood);
          var qc; for (qc = 0; qc < 4; qc++) part(0.04, 0.42, 0.04, (qc % 2 ? w / 2 - 0.06 : -w / 2 + 0.06), (qc > 1 ? d / 2 - 0.06 : -d / 2 + 0.06), 0, mDark);
        } else if (k === 'tvStand') {
          part(w, 0.5, d, 0, 0, 0, mWood);
          part(1.2, 0.7, 0.03, 0, -d / 2 + 0.05, 0.55, mDark);
        } else if (k === 'table' || k === 'table6' || k === 'table8') {
          /* the set's footprint is w x d; the top is tw x td in its middle and
             the chairs sit inside the footprint on both long sides -- two a
             side, three on the table of six and of eight, and one at each end
             of the eight (adu-v1416, Marek: jidelni stul pro 6+2 osoby) */
          var tw = D.tw || w, td = D.td || d, cz = td / 2 + 0.24, nSd = D.side || 2;
          part(tw, 0.03, td, 0, 0, 0.72, mWood);
          var qt; for (qt = 0; qt < 4; qt++) part(0.05, 0.72, 0.05, (qt % 2 ? tw / 2 - 0.08 : -tw / 2 + 0.08), (qt > 1 ? td / 2 - 0.08 : -td / 2 + 0.08), 0, mWood);
          for (qt = 0; qt < nSd; qt++) {
            var cxT = -tw / 2 + tw * (qt + 0.5) / nSd;
            chair(part, cxT, -cz, -1); chair(part, cxT, cz, 1);
          }
          if (D.ends) { chairEnd(part, -tw / 2 - 0.24, 0, -1); chairEnd(part, tw / 2 + 0.24, 0, 1); }
        } else if (k === 'table2' || k === 'table2r') {
          var tw2 = D.tw || w, td2 = D.td || d, cz2 = td2 / 2 + 0.24;
          if (D.round) { part(tw2, 0.03, td2, 0, 0, 0.72, mWood, cyl(tw2 / 2, 0.03, 32)); part(0.08, 0.72, 0.08, 0, 0, 0, mDark, cyl(0.04, 0.72, 16)); part(0.5, 0.02, 0.5, 0, 0, 0, mDark, cyl(0.25, 0.02, 24)); }
          else { part(tw2, 0.03, td2, 0, 0, 0.72, mWood); var q2; for (q2 = 0; q2 < 4; q2++) part(0.05, 0.72, 0.05, (q2 % 2 ? tw2 / 2 - 0.07 : -tw2 / 2 + 0.07), (q2 > 1 ? td2 / 2 - 0.07 : -td2 / 2 + 0.07), 0, mWood); }
          chair(part, 0, -cz2, -1); chair(part, 0, cz2, 1);
        } else if (k === 'barTable') {
          /* the top at the back of the footprint, the two stools in front of
             it inside the footprint (w x d is the whole set) */
          var bw = D.tw || w, bd = D.td || 0.6, bz = -d / 2 + bd / 2, sz3 = d / 2 - 0.2;
          part(bw, 0.04, bd, 0, bz, 1.01, mTop);
          part(bw - 0.1, 0.97, bd - 0.1, 0, bz, 0.04, mWood);
          var qs; for (qs = 0; qs < 2; qs++) {
            var sx2 = -bw / 4 + (qs ? bw / 2 : 0);
            part(0.36, 0.05, 0.36, sx2, sz3, 0.72, mDark, cyl(0.18, 0.05, 20));
            part(0.05, 0.72, 0.05, sx2, sz3, 0, mSteel, cyl(0.025, 0.72, 12));
            part(0.4, 0.02, 0.4, sx2, sz3, 0, mSteel, cyl(0.2, 0.02, 20));
          }
        } else if (k === 'fridge') {
          part(w, h, d, 0, 0, 0, mWhite);
          part(w, 0.02, d, 0, 0, h * 0.7, mSteel);
          part(0.03, 0.4, 0.02, w / 2 - 0.08, d / 2 + 0.01, h * 0.75, mSteel);
        } else if (k === 'washer') {
          part(w, h, d, 0, 0, 0, mWhite);
          part(0.44, 0.44, 0.02, 0, d / 2 + 0.01, 0.2, mDark, cyl(0.22, 0.02, 24).rotateX(Math.PI / 2));
          part(0.16, 0.16, 0.02, 0, d / 2 + 0.02, 0.34, mGlass, cyl(0.08, 0.02, 20).rotateX(Math.PI / 2));
          /* A DRYER ON TOP (adu-v1416, floorplan v150 stacks them where the
             laundry has no room for the two side by side) */
          if (f.stack === 'dryer') {
            part(w, 0.02, d, 0, 0, h, mSteel);
            part(w, h, d, 0, 0, h + 0.02, mWhite);
            part(0.4, 0.4, 0.02, 0, d / 2 + 0.01, h + 0.24, mSteel, cyl(0.2, 0.02, 24).rotateX(Math.PI / 2));
            /* adu-v1417: billed on the dryer's own row (FKI00012) */
            var Ddry = cat.dryer;
            if (Ddry && Ddry.code) { _add('aframe-fitout', Ddry.code, 1); tally[Ddry.code] = (tally[Ddry.code] || 0) + 1; stackedBilled++; }
            else noRow['dryer (stacked on the washer)'] = (noRow['dryer (stacked on the washer)'] || 0) + 1;
          }
        } else if (k === 'dryer') {
          /* the dryer: the washer's box, a plain round door, the lint filter
             in the top front */
          part(w, h, d, 0, 0, 0, mWhite);
          part(0.4, 0.4, 0.02, 0, d / 2 + 0.01, 0.24, mSteel, cyl(0.2, 0.02, 24).rotateX(Math.PI / 2));
          part(0.3, 0.02, 0.06, 0, d / 2 - 0.05, h, mDark);
        } else {
          part(w, h, d, 0, 0, 0, mFab);
        }
        if (D.code) { _add('aframe-fitout', D.code, 1); tally[D.code] = (tally[D.code] || 0) + 1; }
        /* what fixes it: four screws for every piece that stands on a wall, a
           tube of silicone for every wet piece (bath, shower, basin, wc, sink) */
        /* adu-v1417: an appliance (fridge, washer, dryer) stands free on its
           feet -- nothing screws it to the wall and nothing seals it */
        if (D.code && D.wall && !D.appliance) _add('aframe-fitout', 'FAS60080', 4);
        if (D.code && !D.appliance && (D.grp === 'bath' || D.grp === 'wet' || D.grp === 'kitchen' || /shower|bath|basin|wc|sink|toilet/i.test(String(D.def || '')))) _add('aframe-fitout', 'FEC00040', 1);
        /* adu-v1416: what has no catalogue row is counted and named once,
           below -- the line here hung off the silicone test and named every
           dry piece that IS billed (a bed, a sofa, a table) as not billed */
        if (!D.code) noRow[k] = (noRow[k] || 0) + 1;
        if (D.extra) { var eq; for (eq = 0; eq < D.extra.length; eq++) { _add('aframe-fitout', D.extra[eq], 1); } }
        /* UNDER THE SLOPE (aframe-v138): the piece's top corners against the
           lining; one that pokes into the roof is drawn and billed as placed,
           and named here -- the plan's head-height lines (1500, 2000) show where */
        var pk = _fitPoke(f, w, d, h);
        if (pk > 0.005) pokes.push(k + ' floor ' + ((f.st | 0) + 1) + ' ' + Math.round(pk * 1000));
        n++;
      }
      } finally { STATE.planStorey = psKeep; }
      var codes = [], kk;
      for (kk in tally) codes.push(kk + ' x' + tally[kk]);
      ctx.log('FIT  ' + n + ' piece(s): ' + codes.join(', ') + ' -- modelled in parts on the floor finish, billed with their companion rows | by floor ' + onSt.join(' / ') +
              (nOff ? (' | ' + nOff + ' on a floor the A no longer has: not built') : '') + (nStair ? (' | ' + nStair + ' stair piece(s) from the plan left to the stairs layer') : ''));
      /* aframe-v145 (the barndo's barndo-v28 / v29, Marek's line: the range, the dishwasher with its kit and the hood -- nothing smaller) */
      (function () {
        var FXa = ((STATE.product || {}).fixtures || []), na = { kit: 0, wc: 0, basin: 0, tub: 0 }, ia;
        for (ia = 0; ia < FXa.length; ia++) {
          var kda = String((FXa[ia] && FXa[ia].kind) || '');
          if (/^kitchen(24|30|36|L|U)$/.test(kda)) na.kit++; else if (kda === 'wc') na.wc++; else if (/^basin/.test(kda)) na.basin++; else if (/^bath/.test(kda)) na.tub++;
        }
        ctx.log('FIT  appliances (aframe-v145, the barndo\'s rule): ' + na.kit + ' kitchen run(s) -> FKI00013 range, FKI00014 dishwasher + FKI00015 its kit, FKI00016 hood with each run (the fixture table); nothing smaller billed (Marek\'s line): no bathroom accessories, mirrors or curtain rods (' +
                na.wc + ' toilet(s), ' + na.basin + ' basin(s), ' + na.tub + ' tub(s))');
      })();
      if (nudged.length) { try { if (API.savePref) API.savePref(); } catch (eSv) {} }
      ctx.log('FIT  under the slope: ' + (nudged.length ? (nudged.length + ' piece(s) moved out from the slope\'s foot into the room until clear of the lining (aframe-v169, mm): ' + nudged.join(', ') + '; ') : '') +
              (pokes.length ? (pokes.length + ' piece(s) still reach into the roof (mm past the lining -- the move does not help them: too tall for the space under the slope, under the floor above, or against a gable): ' + pokes.join(', ')) : 'every piece clear of the lining'));
      var nr = [], kr;
      for (kr in noRow) if (noRow.hasOwnProperty(kr)) nr.push(kr + ' x' + noRow[kr]);
      if (nr.length) ctx.log('FIT  NOT BILLED, no catalogue row yet: ' + nr.join(', ') + ' -- drawn, and nothing billed into another row in their place');
      if (sizedUS || nCompact || stackedBilled) ctx.log('FIT  appliances (adu-v1417): ' + sizedUS + ' at the US stock size (27 in washer and dryer, 36 in fridge)' +
                                                       (nCompact ? (', ' + nCompact + ' compact 24 in where the full size does not fit') : '') +
                                                       (stackedBilled ? (', ' + stackedBilled + ' stacked dryer(s) billed as FKI00012') : '') +
                                                       ' -- standing free: no screws, no silicone');
    }
    _regLayer({
      id: 'aframe-fitout', version: VERSION, role: 'fitout', claims: ['fitout'],
      build3d: _buildFitout, boq: function () { return _rows('aframe-fitout'); }
    });

    /* =========================================================================
       THE ELECTRICS FROM THE SHARED MEP ASSET (aframe-v139, P5 of the parity
       with the ADU). The asset (assets/configurator-mep.js, window.MepLib,
       the same rules for the whole house line) builds them; this product
       hands it what it knows, under the names the ADU uses -- COPIED from the
       T house (thouse-v306 / v313, the other storeyed product on the core):
       the ground floor's board beside the entrance door, a socket radial and
       a light and switch a room; every upper storey fed from that board up
       the exterior wall (riserFrom), its lamps under the slope (ceilAt), a
       room with no door switched beside its socket nearest the stair opening
       (switchNear).
       ADAPTED to the A:
         THE OUTLINE OF EACH STOREY is the plan's (__PROD._planPoly: the floor
           at its own width, the side wings on the ground floor, the dormer
           slots on floor 2), the exterior faces the build-up in from it
           (AF_MEP.wt -- the gable and its lining; on a slope the lining at the
           socket line sits within a couple of cm of it);
         ITS WALLS AND OPENINGS are the plan's too (__PROD._planOps), their
           sills over that storey's floor -- the gable runs through every
           storey;
         THE ROOMS of a storey as the plan last showed them (kept while it
           shows another), cut to that storey's outline; an upper storey whose
           plan was never opened is one room, the loft;
         THE CEILING: under the floor above, or under the slope (the lamp
           hangs where the lining is over it); a top storey's cable runs at
           AF_MEP.runUp over its floor.
       Magenta for an admin until checked (ELEC_REVIEW). No MepLib at build
       time (an old cached page): nothing billed, the log says so, one rebuild
       when it arrives. Status: status/mep.md.
       ========================================================================= */
    var AF_MEP = { wt: GABLE.d + 0.030 + 0.0002 + 0.0125, runUp: 2.00, clearH: 1.65, ups: ['aframe-elec-up', 'aframe-elec-up2'] };
    var ELEC_REVIEW = true;
    var _mepRooms = {}, _mepAsked = false;
    function _mepPL() { try { return __CORE._P ? __CORE._P() : null; } catch (e) { return null; } }
    function _mepRowOf(PL, r, i) {
      var FL = global.FloorplanLib, T0 = [], idx = null;
      try { T0 = (FL && FL.draw && FL.draw.roomTable) ? (FL.draw.roomTable() || []) : []; } catch (eT) { T0 = []; }
      try { idx = PL.roomNameIdx ? (PL.roomNameIdx(r, i) | 0) : null; } catch (eI) { idx = null; }
      if (idx == null || !T0.length) return null;
      return T0[((idx % T0.length) + T0.length) % T0.length] || null;
    }
    /* a storey's plan: the outline, the edge tags, its box */
    function _mepPlan(k) {
      var P = null, W = null;
      try { P = __PROD._planPoly(k); } catch (eP) { P = null; }
      if (!P || P.length < 3) { try { P = poly(); } catch (eP2) { P = null; } }
      try {
        var B0 = poly(), B = _barRect(), cx = (B.x0 + B.x1) / 2, f = _planW(k) / (B.x1 - B.x0);
        W = _planWithWings(k, B0.map(function (p) { return [cx + (p[0] - cx) * f, p[1]]; }));
      } catch (eW) { W = null; }
      var bx = { x0: 1e9, x1: -1e9, z0: 1e9, z1: -1e9 }, q;
      for (q = 0; q < P.length; q++) { bx.x0 = Math.min(bx.x0, P[q][0]); bx.x1 = Math.max(bx.x1, P[q][0]); bx.z0 = Math.min(bx.z0, P[q][1]); bx.z1 = Math.max(bx.z1, P[q][1]); }
      return { P: P, tags: (W && W.P.length === P.length) ? W.tags : null, box: bx };
    }
    /* the rooms of storey k as the plan last showed them, cut to its outline */
    function _mepReadRooms(PL, k) {
      var RR = [], rr = [], i, j, BX = _mepPlan(k).box, wt = AF_MEP.wt;
      try { rr = PL.rooms() || []; } catch (eR) { rr = []; }
      for (i = 0; i < rr.length; i++) {
        var r = rr[i], RS = (r && r.rects) || [], cp = [], big = null, bA = -1;
        for (j = 0; j < RS.length; j++) {
          var q = { x0: Math.max(RS[j].x0, BX.x0), x1: Math.min(RS[j].x1, BX.x1), z0: Math.max(RS[j].z0, BX.z0), z1: Math.min(RS[j].z1, BX.z1) };
          if (q.x1 - q.x0 < 0.05 || q.z1 - q.z0 < 0.05) continue;
          var a = (q.x1 - q.x0) * (q.z1 - q.z0);
          cp.push(q);
          if (a > bA) { bA = a; big = q; }
        }
        if (!cp.length) continue;
        var nm = '', row = r.closet ? null : _mepRowOf(PL, r, i), fc = null;
        try { nm = PL.roomName ? (PL.roomName(r, i) || '') : ''; } catch (eN) { nm = ''; }
        try { fc = PL.roomFaces ? PL.roomFaces((big.x0 + big.x1) / 2, (big.z0 + big.z1) / 2) : null; } catch (eF) { fc = null; }
        var F = fc ? { x0: Math.max(fc.x0, BX.x0 + wt), x1: Math.min(fc.x1, BX.x1 - wt), z0: Math.max(fc.z0, BX.z0 + wt), z1: Math.min(fc.z1, BX.z1 - wt) } : null;
        RR.push({ rects: cp, closet: !!r.closet, name: nm, def: row ? String(row.def || '') : '', key: row ? String(row.i18n || '') : '', faces: F });
      }
      return RR;
    }
    /* storey k's rooms: read while the plan shows it, kept while it shows
       another; an upper storey never shown is one room, the loft */
    function _mepRoomsOf(k) {
      var PL = _mepPL(), how = '';
      if ((STATE.planStorey | 0) === k && PL && PL.rooms) _mepRooms[k] = _mepReadRooms(PL, k);
      if (_mepRooms[k] && _mepRooms[k].length) return { rooms: _mepRooms[k], how: 'the rooms of the plan of storey ' + (k + 1) + ((STATE.planStorey | 0) === k ? '' : ' (as last seen)') };
      var BX = _mepPlan(k).box, wt = AF_MEP.wt;
      if (!(BX.x1 - BX.x0 > 1.0)) return { rooms: [], how: 'no floor' };
      var F = { x0: BX.x0 + wt, x1: BX.x1 - wt, z0: BX.z0 + wt, z1: BX.z1 - wt };
      return { rooms: [{ rects: [{ x0: BX.x0, x1: BX.x1, z0: BX.z0, z1: BX.z1 }], closet: false, name: 'LOFT', def: 'LOFT', key: '', faces: F }],
               how: 'one room, the loft -- the plan of storey ' + (k + 1) + ' not opened yet' };
    }
    /* storey k's walls and openings, from the plan: each outline edge a
       segment, its openings with their sills over this storey's floor */
    function _mepSegs(k, electrical) {
      var PLN = _mepPlan(k), P = PLN.P, tags = PLN.tags, fl = floors(), F = fl[k] || fl[0], GS = _gableSegs(), out = [], i, q;
      var y0g = {}; for (q = 0; q < GS.length; q++) y0g[GS[q].id] = GS[q].y0;
      for (i = 0; i < P.length; i++) {
        var a = P[i], b = P[(i + 1) % P.length], len = Math.hypot(b[0] - a[0], b[1] - a[1]);
        if (!(len > 0.05)) continue;
        var id = 'S0-W' + i, tg = tags ? tags[i] : id, ops = [];
        try { ops = __PROD._planOps(k, id) || []; } catch (eO) { ops = []; }
        if (electrical) {
          var gsg = GS.filter(function (g) { return g.id === tg; })[0];
          var full = gsg && (gsg.openings || []).filter(function (o) { return o.rake || o.fullW || o.halfW; })[0];
          if (full) {
            var RUe = _rakeUnit(gsg, full), ux = (b[0] - a[0]) / len;
            ops = ops.filter(function (o) { return !/^FIX[HF]/.test(o.code || ''); });
            RUe.polys.forEach(function (poly) {
              var part = _polyBand(poly, F.y - 0.1, k + 1 < fl.length ? fl[k + 1].y : RUe.apex + 0.1).poly;
              if (part.length < 3) return;
              var xs = part.map(function (v) { return v[0]; }), ys = part.map(function (v) { return v[1]; });
              var x0 = Math.min.apply(null, xs), x1 = Math.max.apply(null, xs), y0 = Math.min.apply(null, ys), y1 = Math.max.apply(null, ys);
              ops.push({ at: ((x0 + x1) / 2 - a[0]) * ux, w: x1 - x0, h: y1 - y0,
                sill: y0 - gsg.y0, kind: 'window', code: RUe.code });
            });
          }
        }
        var base = (tg && tg.charAt(0) === 'S' && y0g[tg] != null) ? y0g[tg] : ((tg && tg.charAt(0) === 'D') ? F.y : fl[0].y);
        out.push({ id: id, tag: tg, storey: k, x0: a[0], z0: a[1], x1: b[0], z1: b[1], len: len, y0: F.y,
                   openings: ops.map(function (o) { return { at: o.at, w: o.w, h: o.h, sill: Math.max(0, base + (o.sill || 0) - F.y), kind: o.kind, code: o.code, hand: (o.hand === 'R') ? 'right' : 'left', leaves: o.leaves }; }) });
      }
      return out;
    }
    /* the inside of the roof over a point of storey k: the ceiling under the
       floor above, the slope's lining, or in a side wing its ceiling */
    function _mepCeilAt(k, x, z) {
      var fl = floors(), S = _sect(), B = _barRect(), cx = (B.x0 + B.x1) / 2, linT = LINE.vb + LINE.batt + LINE.board.t, y = 1e9, q;
      if (k + 1 < fl.length) y = fl[k + 1].y - FLOOR.joist.d - FLOOR.deck.t - LINE.batt - LINE.board.t;
      var ySl = S.top + S.tan * (S.half - (S.rafD + linT) / S.sin - Math.abs(x - cx));
      if (k === 0) {
        var sides = _wingSides();
        for (q = 0; q < sides.length; q++) {
          var WR = _wingRect(sides[q]);
          if (z > WR.z0 && z < WR.z1 && (x - cx) * sides[q] > 0) { var Hw = _wingH(sides[q]); ySl = Math.max(Math.min(ySl, 1e9), Hw.wallTop - LINE.batt - LINE.board.t); }
        }
      }
      return Math.min(y, ySl);
    }
    function _mepState(k) {
      var ps = STATE.parts || [], out = [], ids = {}, i;
      for (i = 0; i < ps.length; i++) {
        var p = ps[i];
        if (!p) continue;
        if (((typeof p.st === 'number') ? p.st : 0) !== k) continue;
        if (p.cutOn && p.cutOn.indexOf(k) >= 0) continue;
        out.push(p); ids[p.id] = 1;
      }
      var ds = STATE.doors || [], dd = [];
      for (i = 0; i < ds.length; i++) if (ds[i] && ids[ds[i].pid]) dd.push(ds[i]);
      return { parts: out, doors: dd, product: STATE.product, planStorey: k, openings: STATE.openings, footprint: STATE.footprint, origin: STATE.origin, isMetric: STATE.isMetric };
    }
    function _mepSharedEdge(rects, self, ax0, ax1, az0, az1, horiz) {
      var q, T = 0.02;
      for (q = 0; q < rects.length; q++) {
        if (q === self) continue;
        var O = rects[q];
        if (typeof O.x0 !== 'number') continue;
        if (horiz) {
          if (Math.abs(O.z1 - az0) > T && Math.abs(O.z0 - az0) > T) continue;
          if (Math.min(O.x1, ax1) - Math.max(O.x0, ax0) > T) return true;
        } else {
          if (Math.abs(O.x1 - ax0) > T && Math.abs(O.x0 - ax0) > T) continue;
          if (Math.min(O.z1, az1) - Math.max(O.z0, az0) > T) return true;
        }
      }
      return false;
    }
    function _mepOnRoomLineOf(ps, ax0, ax1, az0, az1, horiz) {
      var q, T = 0.08;
      for (q = 0; q < ps.length; q++) {
        var P = ps[q];
        if (!P || !P.sep || ((P.dir || P.o) === 'h') !== !!horiz) continue;
        var c = (typeof P.at === 'number') ? P.at : P.c, sp = API.partSpan ? API.partSpan(P) : null;
        if (!sp || Math.abs(c - (horiz ? az0 : ax0)) > T) continue;
        var e0 = horiz ? ax0 : az0, e1 = horiz ? ax1 : az1, ov = Math.min(sp[1], e1) - Math.max(sp[0], e0);
        if (ov > 0.5 * (e1 - e0)) return true;
      }
      return false;
    }
    function _mepRoomLabel(r, i) {
      if (r && r.closet) {
        var a = 0, j, RS = r.rects || [];
        for (j = 0; j < RS.length; j++) a += (RS[j].x1 - RS[j].x0) * (RS[j].z1 - RS[j].z0);
        return 'closet ' + (Math.round(a * 10) / 10) + ' m2';
      }
      return (r && (r.def || r.name)) || ('room ' + ((i | 0) + 1));
    }
    /* the env the asset reads, for storey k */
    function _mepEnvA(layerId, k) {
      var S0 = _mepState(k), UR = _mepRoomsOf(k), fl = floors(), F = fl[k] || fl[0], PLN = _mepPlan(k), A = Object.create(API), PLc = _mepPL();
      A.poly = function () { return PLN.P.map(function (p) { return [p[0], p[1]]; }); };
      A.segments = function () { return _mepSegs(k); };
      A.storeys = function () { return [{ i: 0, y0: F.y, y1: F.y + 2.5, h: 2.5 }]; };
      A.wallTop = function () {
        var yC = (k + 1 < fl.length) ? (fl[k + 1].y - FLOOR.joist.d - FLOOR.deck.t - LINE.batt - LINE.board.t) : (F.y + FIT.lift + AF_MEP.runUp);
        return yC + 0.02;
      };
      A.STATE = S0;
      return { layerId: layerId, API: A, STATE: S0, FINISH: { dry: { h: FIT.lift } }, PART: { d: PARTA.d }, MAGENTA: MAGENTA,
               _P: function () {
                 return {
                   rooms: function () { return UR.rooms; },
                   roomName: function (r) { return (r && (r.def || r.name)) || ''; },
                   roomFaces: function (x, z) {
                     var i, j;
                     for (i = 0; i < UR.rooms.length; i++) for (j = 0; j < UR.rooms[i].rects.length; j++) {
                       var q = UR.rooms[i].rects[j];
                       if (x > q.x0 && x < q.x1 && z > q.z0 && z < q.z1) return UR.rooms[i].faces;
                     }
                     return null;
                   },
                   fixtures: PLc ? PLc.fixtures : null
                 };
               },
               _add: API.billAdd, _billReset: function (l) { _bill[l] = {}; }, _asmCode: __CORE._asmCode,
               _buildRect: function () { return { x0: PLN.box.x0, x1: PLN.box.x1, z0: PLN.box.z0, z1: PLN.box.z1 }; },
               wallThickness: function () { return AF_MEP.wt; },
               isNew: function () { return ELEC_REVIEW && _isAdmin(); },
               _onRoomLine: function (ax0, ax1, az0, az1, horiz) { return _mepOnRoomLineOf(S0.parts, ax0, ax1, az0, az1, horiz); },
               _roomLabel: _mepRoomLabel, _sharedEdge: _mepSharedEdge,
               _slantRaw: function () { return []; }, _spaceFree: function () { return true; }, _wedgeRoomAt: function () { return -1; },
               /* the lamp under the roof: raised to the slope where it is higher (a top storey), let
                  down to it where the slope comes lower than the ceiling (a lamp near the side) */
               ceilAt: function (x, z) { return _mepCeilAt(k, x, z); },
               ceilLowAt: function (x, z) { return _mepCeilAt(k, x, z); },
               _roomsHow: UR.how + ' | ' + (function () { var SG = _mepSegs(k), n = 0, q; for (q = 0; q < SG.length; q++) n += SG[q].openings.length; return SG.length + ' wall(s) from the plan, ' + n + ' opening(s): ' + SG.map(function (sg) { return sg.openings.map(function (o) { return o.kind + ' ' + Math.round(o.w * 1000) + 'x' + Math.round(o.h * 1000) + ' sill ' + Math.round(o.sill * 1000); }).join(', '); }).filter(function (t) { return t; }).join('; '); })() };
    }
    /* the rows the electrics bill, into the core's map when it lacks them (the T house's list) */
    var MEP_ELEC_ROWS = { EEE00001: ['m', 'Cable 3x2.5'], EES00001: ['pcs', 'Socket'], EEC00002: ['pcs', 'Ceiling light'], EEL00001: ['pcs', 'Light switch'],
                          EED00001: ['pcs', 'Consumer unit'], EEC00003: ['pcs', 'Circuit breaker 16 A'], EER00001: ['pcs', 'RCD 30 mA'],
                          EEJ00001: ['pcs', 'Junction box'], EES00003: ['pcs', 'Quick connector'], EEG00001: ['pcs', 'Grounding set'] };
    function _mepMint(rows) {
      var k;
      for (k in rows) if (rows.hasOwnProperty(k) && !__CORE.CATALOG[k]) __CORE.CATALOG[k] = { code: k, unit: rows[k][0], label: rows[k][1] };
    }
    function _mepWaitFor(L, ctx, what) {
      _bill[L] = {};
      ctx.log(what + ' SKIPPED -- configurator-mep.js is not loaded (yet): nothing billed; the model rebuilds when it arrives');
      if (!_mepAsked) {
        _mepAsked = true;
        try { (global.__mepWait = global.__mepWait || []).push(function () { try { API.rebuild(); } catch (eR) {} }); } catch (eW) {}
      }
    }
    /* aframe-v173: the shared installer uses upright plan faces. Fit its
       bodies and drawn runs to this product's actual lining. This is geometry,
       not a circuit design or an electrical-code approval. Undrawn circuit
       allowances and slack remain in the bill; only the drawn length changes.
       The section fit includes side wings and the recessed outdoor terraces. */
    function _mepFitElectrical(ctx, k, L) {
      var T = ctx.THREE, S = _sect(), B = _barRect(), cx = (B.x0 + B.x1) / 2;
      var fl = floors(), BX = _mepPlan(k).box, wt = AF_MEP.wt;
      var lining = S.rafD + (INSUL === 'between' ? LINE.vb + LINE.batt + LINE.board.t : 0);
      var ridge = S.top + S.tan * (S.half - lining / S.sin);
      var flat = k + 1 < fl.length ? fl[k + 1].y - FLOOR.joist.d - FLOOR.deck.t - LINE.batt - LINE.board.t : Infinity;
      var nodes = [], anchors = [], changed = 0, delta = {}, oldLen = {}, newLen = {};
      /* v175: a wing makes the interior non-convex; the recessed terrace
         cuts another notch out of the upper floor. Fitting just the cable's
         two ends can still draw a chord outdoors. Split at every change of
         section and use the intersection at a boundary, so both adjoining
         runs stay inside. Exposed rafters use their underside, not gypsum. */
      var wings = [], slots = [], zCuts = [], yCuts = [], gap = 0.012;
      _wingSides().forEach(function (sd) {
        var W = _wingRect(sd), H = _wingH(sd), D = _dormer(sd);
        var w = { sd: sd, x: sd < 0 ? W.x0 + wt : W.x1 - wt,
          z0: W.z0 + wt, z1: W.z1 - wt, y: H.wallTop - LINE.batt - LINE.board.t };
        wings.push(w); zCuts.push(w.z0 + gap, w.z1 - gap); yCuts.push(w.y - gap);
        if (D) {
          var s = { sd: sd, x: cx + sd * (D.dD - DORM.wallT - LINE.batt - LINE.board.t),
            z0: D.bays[0][0] - DORM.triT - LINE.batt - LINE.board.t,
            z1: D.bays[D.bays.length - 1][1] + DORM.triT + LINE.batt + LINE.board.t, y: D.deckTop };
          slots.push(s); zCuts.push(s.z0 - gap, s.z1 + gap); yCuts.push(s.y - gap);
        }
      });
      function hw(y) { return Math.max(0, (ridge - y) / S.tan); }
      function bounds(y, z, pad) {
        var h = Math.max(0, hw(y) - pad / S.sin), lo = cx - h, hi = cx + h;
        wings.forEach(function (w) {
          if (y >= w.y - pad - 1e-7 || z <= w.z0 + pad + 1e-7 || z >= w.z1 - pad - 1e-7) return;
          if (w.sd < 0) lo = Math.min(lo, w.x + pad); else hi = Math.max(hi, w.x - pad);
        });
        slots.forEach(function (s) {
          if (y < s.y - pad - 1e-7 || z < s.z0 - pad - 1e-7 || z > s.z1 + pad + 1e-7) return;
          if (s.sd < 0) lo = Math.max(lo, s.x + pad); else hi = Math.min(hi, s.x - pad);
        });
        return [lo, hi];
      }
      function shellPoint(p) {
        var q = p.clone();
        q.y = Math.min(q.y, ridge - gap);
        var b = bounds(q.y, q.z, gap);
        q.x = Math.max(b[0], Math.min(b[1], q.x));
        return q;
      }
      function sectionRoute(a, b) {
        var ts = [0, 1];
        function cut(values, axis) {
          if (Math.abs(b[axis] - a[axis]) < 1e-9) return;
          values.forEach(function (v) { var t = (v - a[axis]) / (b[axis] - a[axis]); if (t > 1e-8 && t < 1 - 1e-8) ts.push(t); });
        }
        cut(zCuts, 'z'); cut(yCuts, 'y');
        ts.sort(function (u, v) { return u - v; });
        return ts.filter(function (t, i) { return !i || t - ts[i - 1] > 1e-8; }).map(function (t) {
          return shellPoint(a.clone().lerp(b, t));
        });
      }
      function insideRun(a, b) {
        if (shellPoint(a).distanceTo(a) > 1e-6 || shellPoint(b).distanceTo(b) > 1e-6) return false;
        var pts = sectionRoute(a, b), i;
        for (i = 0; i < pts.length; i++) {
          var t = b.distanceTo(a) > 1e-9 ? pts[i].clone().sub(a).dot(b.clone().sub(a)) / a.distanceToSquared(b) : 0;
          if (pts[i].distanceTo(a.clone().lerp(b, t)) > 1e-6) return false;
        }
        return true;
      }
      /* v176: a glazed gable is not a mounting wall. Put its perimeter
         wiring on the adjacent roof lining, set back from the glazing/frame.
         Across the house it follows both rakes through the ridge, never a
         chord through the glass or the room. The mapping is shared by every
         endpoint and device, so branches remain connected. */
      var glazed = _gableSegs().filter(function (sg) {
        return (sg.openings || []).some(function (o) { return o.rake || o.fullW || o.halfW; });
      }).map(function (sg) { return { sg: sg, z: sg.z0, inward: sg.z0 < (B.z0 + B.z1) / 2 ? 1 : -1 }; });
      function glassFace(p) {
        for (var i = 0; i < glazed.length; i++) {
          var f = glazed[i], depth = (p.z - f.z) * f.inward;
          if (depth >= -0.01 && depth <= wt + 0.07) return f;
        }
        return null;
      }
      function gablePoint(p) {
        var f = glassFace(p);
        if (!f) return p.clone();
        var q = p.clone(), sd = p.x < cx - 1e-6 ? -1 : 1;
        q.x = cx + sd * Math.max(0, hw(q.y) - gap / S.sin);
        q.z = f.z + f.inward * (wt + 0.16);
        return shellPoint(q);
      }
      function gableRoute(a, b) {
        var same = glazed.some(function (f) {
          return Math.abs(a.z - (f.z + f.inward * (wt + 0.16))) < 1e-6 && Math.abs(b.z - a.z) < 1e-6;
        });
        if (same && (a.x - cx) * (b.x - cx) < -1e-8) {
          return [a, new T.Vector3(cx, ridge - gap / S.cos, a.z), b];
        }
        return [a, b];
      }
      function clearMount(sg, u, y, radius) {
        if (_isWingSeg(sg) && (y - radius < sg.y0 || y + radius > sg.y1)) return false;
        if (u < radius + 0.10 || u > sg.len - radius - 0.10) return false;
        var x = sg.x0 + (sg.x1 - sg.x0) * u / sg.len;
        if (_isGable(sg) && !_isWingSeg(sg) && y + radius > ridge - Math.abs(x - cx) * S.tan) return false;
        return !(sg.openings || []).some(function (o) {
          if (o.rake || o.fullW || o.halfW) {
            return _rakeUnit(sg, o).xRuns(y - radius, y + radius).some(function (r) { return x + radius > r[0] && x - radius < r[1]; });
          }
          return Math.abs(u - o.at) < o.w / 2 + radius + 0.10 && y + radius > sg.y0 + (o.sill || 0) && y - radius < sg.y0 + (o.sill || 0) + o.h;
        });
      }
      function exteriorMount(m) {
        var p = m.position, f = glazed.filter(function (g) { return Math.abs(p.z - g.z) < wt + 0.08; })[0];
        if (!f) return;
        var D = m.geometry.parameters, radius = Math.max(D.width, D.height) / 2, candidates = _gableSegs();
        _wingSides().forEach(function (sd) { candidates = candidates.concat(_wingSegs(sd)); });
        var best = null, distance = Infinity;
        candidates.forEach(function (sg) {
          if (!_isGable(sg) && !_isWingSeg(sg)) return;
          var ux = (sg.x1 - sg.x0) / sg.len, uz = (sg.z1 - sg.z0) / sg.len;
          for (var u = radius + 0.10; u < sg.len - radius - 0.10; u += 0.10) {
            if (!clearMount(sg, u, p.y, radius)) continue;
            var x = sg.x0 + ux * u, z = sg.z0 + uz * u;
            var distance2 = Math.hypot(x - p.x, z - p.z);
            if (distance2 < distance) { distance = distance2; best = { x: x, z: z, nx: uz, nz: -ux }; }
          }
        });
        if (best) {
          p.x = best.x + best.nx * (_facT() + D.depth / 2);
          p.z = best.z + best.nz * (_facT() + D.depth / 2);
          m.rotation.set(0, Math.atan2(best.nx, best.nz), 0);
          m.userData.aframeMount = 'solid-exterior-wall';
          ctx.log('ELEC glazed gable: ' + code(m) + ' moved to the nearest solid exterior wall');
        }
      }
      var RW = _roofWinPlan(S, _rafSize(), B, _rafGrid(), S.top + S.half * S.tan);
      function slopeS(p) { return (Math.abs(p.x - cx) + lining * S.sin) / S.cos; }
      function clearWindow(p, radius) {
        var q = p.clone(), sd = q.x < cx ? -1 : 1, s = slopeS(q);
        RW.wins.forEach(function (w) {
          if (w.side !== sd || s + radius < w.sT || s - radius > w.sB || Math.abs(q.z - w.z) > w.clr / 2 + radius + 0.02) return;
          var za = w.z - w.clr / 2 - radius - 0.03, zb = w.z + w.clr / 2 + radius + 0.03;
          q.z = Math.abs(q.z - za) < Math.abs(q.z - zb) ? za : zb;
        });
        return q;
      }
      function roofNear(p) { return Math.abs(p.y - (ridge - Math.abs(p.x - cx) * S.tan)) < 0.05; }
      function crosses(a, b, w) {
        if ((a.x - cx) * w.side < 0 || (b.x - cx) * w.side < 0) return false;
        /* Measure clearance normal to the roof, also at steep pitches. */
        var av = [slopeS(a), a.z, (ridge - Math.abs(a.x - cx) * S.tan - a.y) * S.cos], bv = [slopeS(b), b.z, (ridge - Math.abs(b.x - cx) * S.tan - b.y) * S.cos];
        var lo = [w.sT - 0.012, w.z - w.clr / 2 - 0.012, -0.05], hi = [w.sB + 0.012, w.z + w.clr / 2 + 0.012, 0.05], t0 = 0, t1 = 1, i;
        for (i = 0; i < 3; i++) {
          var d = bv[i] - av[i];
          if (Math.abs(d) < 1e-9) { if (av[i] < lo[i] || av[i] > hi[i]) return false; }
          else { var u = (lo[i] - av[i]) / d, v = (hi[i] - av[i]) / d; t0 = Math.max(t0, Math.min(u, v)); t1 = Math.min(t1, Math.max(u, v)); }
        }
        return t0 < t1 - 1e-8;
      }
      function routed(a, b) {
        var pts = [a, b];
        RW.wins.forEach(function (w) {
          var out = [pts[0]], i;
          for (i = 1; i < pts.length; i++) {
            var p = pts[i - 1], q = pts[i];
            if (crosses(p, q, w)) {
              var candidates = [], best = null, bestLength = Infinity;
              [w.z - w.clr / 2 - 0.03, w.z + w.clr / 2 + 0.03].forEach(function (z) {
                if (z > BX.z0 + wt && z < BX.z1 - wt) candidates.push([p, new T.Vector3(p.x, p.y, z), new T.Vector3(q.x, q.y, z), q]);
              });
              [w.sT - 0.03, w.sB + 0.03].forEach(function (s) {
                var x = s * S.cos - lining * S.sin;
                if (x < 0.012) return;
                var y = ridge - x * S.tan - gap / S.cos - 0.001;
                if (y < fl[Math.max(0, k - 1)].y + 0.05) return;
                x = cx + w.side * x;
                candidates.push([p, new T.Vector3(x, y, p.z), new T.Vector3(x, y, q.z), q]);
              });
              candidates.forEach(function (cand) {
                var length = 0, good = true, j;
                for (j = 1; j < cand.length; j++) {
                  length += cand[j].distanceTo(cand[j - 1]);
                  if (!insideRun(cand[j - 1], cand[j]) || RW.wins.some(function (win) { return crosses(cand[j - 1], cand[j], win); })) good = false;
                }
                if (good && length < bestLength) { best = cand; bestLength = length; }
              });
              if (best) out.push(best[1], best[2]);
              else ctx.log('ELEC A-frame fit CHECK: no clear cable detour round roof window ' + w.idx);
            }
            out.push(q);
          }
          pts = out;
        });
        return pts;
      }
      function code(m) { var a = m.userData.asm; return typeof a === 'string' ? a : a && a.code; }
      ctx.group.traverse(function (m) { if (m.isMesh && /^elec-/.test(m.name)) nodes.push(m); });
      nodes.forEach(function (m) {
        var p = m.position, D = m.geometry.parameters, old = p.clone(), normal, sd;
        if (code(m) === 'EES00005' || code(m) === 'EEW00003') { exteriorMount(m); return; }
        if ((m.name === 'elec-socket' || m.name === 'elec-switch') && D.depth != null && !m.userData.onPart && glassFace(p)) {
          sd = p.x < cx - 1e-6 ? -1 : 1;
          p.copy(gablePoint(p));
          p.x = cx + sd * (hw(p.y) - D.depth / (2 * S.sin));
          m.rotation.order = 'YXZ'; m.rotation.y = Math.atan2(-sd, 0);
          m.rotation.x = Math.PI / 2 - Math.atan(S.tan);
          p.copy(clearWindow(p, Math.max(D.width, D.height) / 2 + 0.02));
          m.userData.aframeMount = 'slope'; changed++;
        }
        if ((m.name === 'elec-light' || m.name === 'elec-alarm') && D.radiusTop != null) {
          var r = Math.max(D.radiusTop, D.radiusBottom), t = D.height, x = p.x, z = p.z, y;
          var wingLamp = null;
          wings.forEach(function (w) {
            if (p.y < w.y + 0.1 && (x - cx) * w.sd > hw(w.y) - r &&
                z > w.z0 + r && z < w.z1 - r) wingLamp = w;
          });
          sd = x < cx ? -1 : 1;
          /* Keep a flat-ceiling disc wholly under that ceiling, including its
             rim. At the ridge, move a slope-mounted disc just far enough to
             lie on one roof plane; do not cut its other half into the roof. */
          if (wingLamp) {
            y = Math.min(flat, wingLamp.y); normal = new T.Vector3(0, 1, 0);
            if (wingLamp.sd < 0) x = Math.max(x, wingLamp.x + r + 0.001);
            else x = Math.min(x, wingLamp.x - r - 0.001);
          } else if (isFinite(flat) && hw(flat) >= r + 0.001 && ridge - Math.abs(x - cx) * S.tan >= flat) {
            x = cx + sd * Math.min(Math.abs(x - cx), hw(flat) - r - 0.001);
            y = flat; normal = new T.Vector3(0, 1, 0);
          } else {
            var minX = r * S.cos + t * S.sin + 0.001;
            if (isFinite(flat)) minX = Math.max(minX, (ridge - flat + r * S.sin + 0.001) / S.tan);
            x = cx + sd * Math.max(Math.abs(x - cx), minX);
            y = ridge - Math.abs(x - cx) * S.tan;
            normal = new T.Vector3(sd * S.sin, S.cos, 0);
          }
          slots.forEach(function (s) {
            if (y < s.y || (x - s.x) * s.sd < -r || z + r < s.z0 || z - r > s.z1) return;
            var za = s.z0 - r - 0.03, zb = s.z1 + r + 0.03;
            z = Math.abs(z - za) < Math.abs(z - zb) ? za : zb;
          });
          var anchor = new T.Vector3(x, y, z);
          if (normal.y < 0.99 || ridge - Math.abs(x - cx) * S.tan - y < r * S.tan + 0.05) anchor = clearWindow(anchor, r);
          m.quaternion.setFromUnitVectors(new T.Vector3(0, 1, 0), normal);
          p.copy(anchor).addScaledVector(normal, -t / 2);
          anchors.push({ old: old, top: old.y + t / 2, next: anchor.clone().addScaledVector(normal, wingLamp ? -0.014 : -0.012) });
          m.userData.aframeMount = normal.y === 1 ? 'ceiling' : 'slope'; changed++;
        } else if ((m.name === 'elec-socket' || m.name === 'elec-switch') && D.depth != null && !m.userData.onPart) {
          normal = new T.Vector3(0, 0, 1).applyQuaternion(m.quaternion);
          /* Only the shared installer's upright outer side faces. Its
             partition devices and the already-sloped stair switches stay. */
          sd = p.x < cx ? -1 : 1;
          var side = cx + sd * (_planW(k) / 2 - wt);
          if (Math.abs(normal.x) > 0.99 && Math.abs(normal.y) < 0.001 && Math.abs(p.x - side) < D.depth + 0.02) {
            p.x = cx + sd * (hw(p.y) - D.depth / (2 * S.sin));
            m.rotation.order = 'YXZ'; m.rotation.y = Math.atan2(-sd, 0);
            m.rotation.x = Math.PI / 2 - Math.atan(S.tan);
            m.userData.aframeMount = 'slope'; changed++;
          }
        }
      });
      function fitPoint(p) {
        var q = p.clone(), i;
        for (i = 0; i < anchors.length; i++) {
          var a = anchors[i];
          if (Math.abs(p.x - a.old.x) < 0.001 && Math.abs(p.z - a.old.z) < 0.001 && Math.abs(p.y - a.top) <= 0.051) return a.next.clone();
        }
        /* A single deterministic mapping keeps common cable endpoints joined.
           The main roof envelope is convex: a segment between fitted endpoints
           stays within it. Leave exterior through-wall tails outside the gables. */
        if (q.z < BX.z0 || q.z > BX.z1) return q;
        q = shellPoint(gablePoint(q));
        return roofNear(q) ? clearWindow(q, 0.012) : q;
      }
      nodes.forEach(function (m) {
        if (m.name !== 'elec-cable') return;
        var previousGeometry = m.geometry, D = previousGeometry.parameters, c = code(m), half = D.height / 2;
        var a = new T.Vector3(0, -half, 0).applyQuaternion(m.quaternion).add(m.position);
        var b = new T.Vector3(0, half, 0).applyQuaternion(m.quaternion).add(m.position);
        a = fitPoint(a); b = fitPoint(b);
        var via = gableRoute(a, b), sections = [via[0]], vi;
        for (vi = 1; vi < via.length; vi++) sections = sections.concat(sectionRoute(via[vi - 1], via[vi]).slice(1));
        var pts = [sections[0]], len = 0, i;
        for (i = 1; i < sections.length; i++) pts = pts.concat(routed(sections[i - 1], sections[i]).slice(1));
        oldLen[c] = (oldLen[c] || 0) + D.height;
        for (i = 1; i < pts.length; i++) {
          var v = pts[i].clone().sub(pts[i - 1]), segment = v.length();
          var mesh = i === 1 ? m : m.clone();
          mesh.geometry = new T.CylinderGeometry(D.radiusTop, D.radiusBottom, Math.max(segment, 1e-9), D.radialSegments);
          mesh.position.copy(pts[i - 1]).add(pts[i]).multiplyScalar(0.5);
          if (segment > 1e-9) mesh.quaternion.setFromUnitVectors(new T.Vector3(0, 1, 0), v.multiplyScalar(1 / segment));
          mesh.visible = segment > 1e-9;
          if (i > 1) ctx.group.add(mesh);
          len += segment;
        }
        previousGeometry.dispose();
        newLen[c] = (newLen[c] || 0) + len;
        delta[c] = (delta[c] || 0) + len - D.height;
      });
      Object.keys(delta).forEach(function (c) {
        if (_bill[L] && typeof _bill[L][c] === 'number') _bill[L][c] = Math.max(0, _bill[L][c] + delta[c]);
        ctx.log('ELEC A-frame fit ' + L + ' ' + c + ': drawn ' + oldLen[c].toFixed(3) + ' -> ' + newLen[c].toFixed(3) + ' m; bill delta ' + delta[c].toFixed(3) + ' m (existing allowances unchanged)');
      });
      ctx.log('ELEC A-frame fit ' + L + ': ' + changed + ' bodies on the lining; mounting/circuit safety still requires professional review');
    }
    /* THE GROUND FLOOR -- aframe-elec */
    /* THE US CODE ON EVERY STOREY (aframe-v145, the barndo's barndo-v25 on
       mep-v25 env.nec): the NEC / IRC kit on top of the line's rules --
       receptacles on the interior walls (6 ft), the kitchen's small-appliance
       and dedicated circuits, a receptacle by every basin, the laundry's
       circuits, smoke alarms a bedroom / outside the sleeping areas / a
       storey, the breakers by what they feed, the surge protector, the main
       breaker and the meter; the outdoor devices through the gable. No
       attached garage, no fuel appliance (smoke alarms, no CO). */
    /* v178: reserve a standing/access volume on a solid gable/wing wall before
       the shared installer calculates any feeds. The roof's physical inner
       face, not the schematic plan width, determines usable headroom.
       30 in wide, 36 in deep from the cabinet face, 6 ft 6 in high are the
       geometric minima used here; this is not electrical-code certification.
       Keep valid existing positions. Never invent a wall on full glazing. */
    function _mepBoardPlacement(Q) {
      var S = _sect(), B = _barRect(), cx = (B.x0 + B.x1) / 2, fl = floors();
      var lining = S.rafD + (INSUL === 'between' ? LINE.vb + LINE.batt + LINE.board.t : 0);
      var ridge = S.top + S.tan * (S.half - lining / S.sin);
      var flat = fl.length > 1 ? fl[1].y - FLOOR.joist.d - FLOOR.deck.t - LINE.batt - LINE.board.t : Infinity;
      var width = Math.max(0.762, Q.width), depth = 0.9144, head = 1.9812, pad = 0.02;
      var gs = _gableSegs(), PL = _mepPL(), rooms = _mepRoomsOf(0).rooms;
      var wingWalls = [];
      _wingSides().forEach(function (sd) {
        var segs = _wingSegs(sd);
        segs.forEach(function (sg) {
          if (sg.wall === 'outer') wingWalls.push({ sg: sg, segs: segs, rect: _wingRect(sd), height: _wingH(sd) });
        });
      });
      var fixtures = (STATE.product && STATE.product.fixtures) || [];
      function overlaps(a, b) { return a.x1 > b.x0 + 1e-6 && a.x0 < b.x1 - 1e-6 && a.z1 > b.z0 + 1e-6 && a.z0 < b.z1 - 1e-6; }
      function candidate(side, u) {
        var s = Q.sides[side];
        if (!s || u < width / 2 + pad || u > s.len - width / 2 - pad) return null;
        var x = s.a[0] + s.u[0] * u, z = s.a[1] + s.u[1] * u;
        var outerX = x - s.n[0] * AF_MEP.wt;
        var wing = Math.abs(s.n[0]) > 0.999 ? wingWalls.filter(function (w) {
          return Math.abs(w.sg.x0 - outerX) < 0.005 && z >= w.rect.z0 && z <= w.rect.z1;
        })[0] : null;
        var sg = wing ? wing.sg : Math.abs(s.n[1]) > 0.999 ? gs.filter(function (g) {
          return !_isWingSeg(g) && Math.abs(g.z0 - (z - s.n[1] * AF_MEP.wt)) < 0.005;
        })[0] : null;
        if (!sg || (sg.openings || []).some(function (o) { return o.rake || o.fullW || o.halfW; })) return null;
        var xf = x + s.n[0] * Q.depth, xb = xf + s.n[0] * depth;
        var zf = z + s.n[1] * Q.depth, zb = zf + s.n[1] * depth;
        var work = { x0: Math.min(xf, xb) - Math.abs(s.u[0]) * width / 2,
          x1: Math.max(xf, xb) + Math.abs(s.u[0]) * width / 2,
          z0: Math.min(zf, zb) - Math.abs(s.u[1]) * width / 2,
          z1: Math.max(zf, zb) + Math.abs(s.u[1]) * width / 2 };
        var top = Q.centreY + Q.height / 2, bottom = Q.centreY - Q.height / 2;
        if (wing) {
          // The whole volume stays in the wing, away from the non-convex
          // main-roof junction. Its flat lining is the mounting envelope.
          var W = wing.rect, ceiling = wing.height.wallTop - LINE.batt - LINE.board.t;
          if (work.x0 < W.x0 + AF_MEP.wt || work.x1 > W.x1 - AF_MEP.wt || work.z0 < W.z0 + AF_MEP.wt || work.z1 > W.z1 - AF_MEP.wt) return null;
          if (Q.floorY + head + pad > ceiling || top + pad > ceiling || bottom < Q.floorY) return null;
        } else {
          if (work.x0 < B.x0 + AF_MEP.wt || work.x1 > B.x1 - AF_MEP.wt || work.z0 < B.z0 + AF_MEP.wt || work.z1 > B.z1 - AF_MEP.wt) return null;
          var roof = ridge - Math.max(Math.abs(work.x0 - cx), Math.abs(work.x1 - cx)) * S.tan;
          if (Math.min(roof, flat) < Q.floorY + head + pad || bottom < Q.floorY || top + pad > Math.min(flat, ridge - (Math.abs(x - cx) + Q.width / 2) * S.tan)) return null;
        }
        var along = ((x - sg.x0) * (sg.x1 - sg.x0) + (z - sg.z0) * (sg.z1 - sg.z0)) / sg.len;
        var blocked = (sg.openings || []).some(function (o) {
          var oy = sg.y0 + (o.sill || 0);
          if ((o.kind === 'door' || o.kind === 'french') && Math.abs(along - o.at) < o.w / 2 + width / 2) return true;
          return Math.abs(along - o.at) < o.w / 2 + Q.width / 2 + pad && top + pad > oy && bottom - pad < oy + o.h;
        });
        if (blocked) return null;
        var occupied = { x0: Math.min(work.x0, x) - Math.abs(s.n[0]) * pad,
          x1: Math.max(work.x1, x) + Math.abs(s.n[0]) * pad,
          z0: Math.min(work.z0, z) - Math.abs(s.n[1]) * pad,
          z1: Math.max(work.z1, z) + Math.abs(s.n[1]) * pad };
        // Reserve a conservative inward swing rectangle on the wing's end
        // walls too: a cabinet around the corner must not obstruct a door.
        if (wing && wing.segs.some(function (g) {
          return (g.openings || []).some(function (o) {
            if (o.kind !== 'door' && o.kind !== 'french') return false;
            var ux = (g.x1 - g.x0) / g.len, uz = (g.z1 - g.z0) / g.len;
            var ax = g.x0 + ux * (o.at - o.w / 2) - g.nx * AF_MEP.wt;
            var az = g.z0 + uz * (o.at - o.w / 2) - g.nz * AF_MEP.wt;
            var bx = ax + ux * o.w - g.nx * o.w, bz = az + uz * o.w - g.nz * o.w;
            return overlaps(occupied, { x0: Math.min(ax, bx) - pad, x1: Math.max(ax, bx) + pad,
              z0: Math.min(az, bz) - pad, z1: Math.max(az, bz) + pad });
          });
        })) return null;
        if ((STATE.parts || []).some(function (p) {
          if (!p || p.sep || (p.st | 0) !== 0 || (p.cutOn && p.cutOn.indexOf(0) >= 0)) return false;
          var span = API.partSpan ? API.partSpan(p) : [Math.min(p.a, p.b), Math.max(p.a, p.b)];
          if (!span) return false;
          var at = p.at != null ? p.at : p.c, d = PARTA.d / 2;
          var r = (p.dir || p.o) === 'v' ? { x0: at - d, x1: at + d, z0: span[0], z1: span[1] } : { x0: span[0], x1: span[1], z0: at - d, z1: at + d };
          return overlaps(occupied, r);
        })) return null;
        if (rooms.some(function (r) { return (r.closet || /bath|toilet|wc|closet/i.test([r.key, r.def, r.name].join(' '))) && (r.rects || []).some(function (rect) { return overlaps(occupied, rect); }); })) return null;
        if (fixtures.some(function (f) {
          if (!f || (f.st | 0) !== 0 || !PL || !PL.fixtures || !PL.fixtures.rect) return false;
          var rect = PL.fixtures.rect(f); return rect && overlaps(occupied, rect);
        })) return null;
        return { clear: true, side: side, u: u, work: work, floorY: Q.floorY, headroom: head,
          width: width, depth: depth, surface: sg.id, x: x, z: z };
      }
      var old = candidate(Q.proposed.side, Q.proposed.u);
      if (old) return old;
      var best = null, score = Infinity;
      Q.sides.forEach(function (s, side) {
        var values = [s.len / 2], n = Math.ceil(s.len / 0.05), j;
        for (j = 0; j <= n; j++) values.push(s.len * j / n);
        values.forEach(function (u) {
          var c = candidate(side, u); if (!c) return;
          var d = Math.hypot(c.x - Q.proposed.x, c.z - Q.proposed.z);
          if (d < score - 1e-8) { score = d; best = c; }
        });
      });
      return best || { clear: false, reason: 'No solid gable or wing outer-wall position with clear cabinet and working space; layout review required' };
    }
    var _panelPlacement = null;
    function _panelNotice() {
      var doc = global.document, el = doc && doc.getElementById('af-panel-notice');
      if (!_panelPlacement || _panelPlacement.clear !== false) { if (el) el.remove(); return; }
      var stage = (API._stage || __CORE._stage)(), cv = stage && stage.renderer && stage.renderer.domElement;
      var host = cv && cv.parentElement;
      if (!host) return;
      if (!el || el.parentElement !== host) {
        if (el) el.remove();
        el = doc.createElement('div'); el.id = 'af-panel-notice';
        el.setAttribute('role', 'status'); el.setAttribute('aria-live', 'polite');
        el.setAttribute('style', 'position:absolute;left:12px;top:12px;max-width:420px;width:calc(100% - 100px);box-sizing:border-box;padding:10px 12px;border-radius:10px;background:#fff3d6;color:#543900;border:1px solid #d8ad53;font:13px/1.4 sans-serif;z-index:25;pointer-events:none;');
        host.appendChild(el);
      }
      var cs = /^cs(?:-|$)/i.test(doc.documentElement.lang || (global.Shopify && global.Shopify.locale) || '');
      var message = cs ? 'Pro rozvad\u011b\u010d chyb\u00ed voln\u00e1 st\u011bna s prostorem pro obsluhu. Upravte rozm\u011bry domu nebo uvoln\u011bte st\u011bnu. Elektroinstalace zat\u00edm nen\u00ed do\u0159e\u0161en\u00e1.' : 'No clear wall with working space for the electrical panel. Adjust the house dimensions or free up a wall. The electrical layout is not yet resolved.';
      if (el.textContent !== message) el.textContent = message;
    }
    function _mepNec(E, k) {
      E.nec = true; E.pieceTags = true; E.attachedGarage = false; E.CATALOG = __CORE.CATALOG;
      E.API.segments = function () { return _mepSegs(k, true); };
      if (k === 0) E.boardPlacement = function (Q) { _panelPlacement = _mepBoardPlacement(Q); return _panelPlacement; };
      if (k > 0) E.storey = k;
      E.wallThrough = function () { return AF_MEP.wt + _facT(); };
      return E;
    }
    function _buildElecA(ctx) {
      var M = global.MepLib, L = 'aframe-elec';
      _panelPlacement = null;
      if (!M || typeof M.elec !== 'function') { _mepWaitFor(L, ctx, 'ELEC'); return; }
      _mepMint(MEP_ELEC_ROWS);
      var E = _mepNec(_mepEnvA(L, 0), 0);
      ctx.log('MEP  electrics for ' + L + ' built by configurator-mep.js ' + (M.VERSION || '?') + ' (aframe-v139, the US code aframe-v145) -- the ground floor, ' + E._P().rooms().length + ' room(s): ' + E._roomsHow);
      var result = M.elec(E, ctx);
      _mepFitElectrical(ctx, 0, L);
      _panelNotice();
      return result;
    }
    /* AN UPPER STOREY -- aframe-elec-up (floor 2), aframe-elec-up2 (floor 3):
       fed from the ground floor's board, as the T house's storey 2 */
    function _buildElecUpA(ctx, k) {
      var M = global.MepLib, L = AF_MEP.ups[k - 1];
      if (!M || typeof M.elec !== 'function') { _mepWaitFor(L, ctx, 'ELEC'); return; }
      _bill[L] = {};
      if (floors().length <= k) { ctx.log('ELEC storey ' + (k + 1) + ' none -- the A has ' + floors().length + ' floor(s)'); return; }
      _mepMint(MEP_ELEC_ROWS);
      var E = _mepEnvA(L, k);
      if (!E._P().rooms().length) { ctx.log('ELEC storey ' + (k + 1) + ' none -- no room up there'); return; }
      E.riserFrom = 'aframe-elec';
      E.floorY = function () { return floors()[k].y + FIT.lift; };
      /* A ROOM WITH NO DOOR TAKES ITS SWITCH AT THE HEAD OF THE STAIR (aframe-v165, the garage apartment's 9a:
         "a room with no door (an open plan) takes its switch nearest the head of the stair") -- it went by the
         opening's middle, so on floor 3 it stood halfway along the opening, behind the guard */
      E.switchNear = function () {
        var Hd = null; try { Hd = _stairEnds(k); } catch (eH) { Hd = null; }
        return Hd ? { x: Hd.head.x, z: Hd.head.z, what: 'the head of the stair' } : null;
      };
      _mepNec(E, k);
      ctx.log('MEP  electrics of storey ' + (k + 1) + ' for ' + L + ' built by configurator-mep.js ' + (M.VERSION || '?') + ' (aframe-v139, the US code aframe-v145) -- ' + E._P().rooms().length + ' room(s): ' + E._roomsHow);
      var rE = M.elec(E, ctx);
      try { _stairLight(ctx, k, L, E); } catch (eSL) { ctx.log('ELEC stair light flight ' + k + ' THREW ' + ((eSL && eSL.message) || eSL)); }
      _mepFitElectrical(ctx, k, L);
      return rE;
    }
    /* THE FLIGHT'S TWO ENDS ON PLAN: the foot (300 in front of the first riser) and the head (half the 900 landing past
       the opening's edge the flight arrives at), both on the flight's middle line */
    function _stairEnds(k) {
      var fl = floors(), H = _hole(k);
      if (!H || k < 1 || k >= fl.length) return null;
      var up = _stairDir(k, H), alongX = (up === '+x' || up === '-x'), sgn = (up.charAt(0) === '-') ? -1 : 1;
      var Lf = alongX ? (H.x1 - H.x0) : (H.z1 - H.z0), FF = _fitFlight(fl[k].y - fl[k - 1].y, Lf);
      var e1 = alongX ? (sgn > 0 ? H.x1 : H.x0) : (sgn > 0 ? H.z1 : H.z0), foot = e1 - sgn * (FF.n - 1) * FF.G, mid = alongX ? (H.z0 + H.z1) / 2 : (H.x0 + H.x1) / 2;
      var P = function (a) { return alongX ? { x: a, z: mid } : { x: mid, z: a }; };
      return { H: H, up: up, alongX: alongX, sgn: sgn, FF: FF, head: P(e1 + sgn * STAIR.landing / 2), foot: P(foot - sgn * 0.30), edge: P(e1), n: FF.n };
    }
    /* THE STAIR'S LIGHT (aframe-v165; COPIED from the garage apartment's 9a,
       garageapt-v15: "the stair's own light (IRC R303.7): a light over the
       flight on two 3-way switches, at the foot and at the head ... 14/3
       between them, its feed 14/2 from the lighting circuit; boxes and
       connectors" -- 1 light, 2 x 3-way, 3 x EEJ00001, 6 x EES00003). R303.7:
       a light over the treads and landings, at the top landing or over the
       flight; R303.7.1: with six risers or more a wall switch at each floor
       level. ADAPTED to the A: the flight stands free in the room (no stair
       wall), so the light is a ceiling light EEC00002 over the head landing
       (under the floor above or the slope; moved clear of the opening of the
       next flight up), and each switch goes on the outer face nearest that
       end -- a gable's lining or a slope's -- at the line's switch height
       (1100 over the finish, the asset's), slid off a door or a window in a
       gable. The 14/3 EEE00006 from the foot's switch up its face into the
       floor's joist space, across to the head's face and up to its switch;
       the 14/2 EEE00001 from there to the light, and the feed 14/2 down to
       the foot's switch from the lighting circuit at the ceiling over it.
       The 3-way pair has no catalogue row: TBD.sw3way (MISSING). Drawn and
       billed on the electrics layer of the floor the flight climbs to. */
    var STL = { lamp: 'EEC00002', sw3: 'TBD.sw3way', cab3: 'EEE00006', cab2: 'EEE00001', box: 'EEJ00001', conn: 'EES00003', swH: 1.10, slack: 0.60 };
    function _stairLight(ctx, k, L, E) {
      var T = ctx.THREE, g = ctx.group, fl = floors(), SE = _stairEnds(k);
      if (!SE) { ctx.log('ELEC stair light flight ' + k + ': no opening -- none'); return; }
      var B = _barRect(), cx = (B.x0 + B.x1) / 2, S = _sect(), R = _rafSize(), yT0 = S.top + S.half * S.tan, oF = -(R.d + LINE.batt + LINE.vb + LINE.board.t);
      var hw = function (y) { return (yT0 + oF * S.cos - y) / S.tan + oF * S.sin; };
      var mag = !!(E && E.isNew && E.isNew());
      var mLamp = new T.MeshStandardMaterial({ color: mag ? MAGENTA : 0xF7F7F5, roughness: 0.4 }), mSw = new T.MeshStandardMaterial({ color: mag ? MAGENTA : 0xF7F7F5, roughness: 0.5 });
      var mCab = new T.MeshStandardMaterial({ color: mag ? MAGENTA : 0x1A1C1D, roughness: 0.6, metalness: 0.1 });
      /* the outer face of storey st nearest (x, z), at height y */
      var face = function (st, x, z, y) {
        var h = hw(y), BX = _mepPlan(st).box, zg0 = BX.z0 + AF_MEP.wt, zg1 = BX.z1 - AF_MEP.wt, C = [], ws = [];
        if (!(h > 0.15)) return null;
        try { ws = (st === 0) ? _wingSides() : []; } catch (eW) { ws = []; }
        var xin = function (v) { return Math.max(cx - h + 0.10, Math.min(cx + h - 0.10, v)); }, zin = function (v) { return Math.max(zg0 + 0.10, Math.min(zg1 - 0.10, v)); };
        C.push({ x: xin(x), z: zg0, nx: 0, nz: 1, sd: 0, d: Math.abs(z - zg0), what: 'the gable z0' });
        C.push({ x: xin(x), z: zg1, nx: 0, nz: -1, sd: 0, d: Math.abs(zg1 - z), what: 'the gable z1' });
        [-1, 1].forEach(function (sd) {
          if (ws.indexOf(sd) >= 0) { var WR = _wingRect(sd); if (z > WR.z0 - 0.20 && z < WR.z1 + 0.20) return; }
          C.push({ x: cx + sd * h, z: zin(z), nx: -sd, nz: 0, sd: sd, d: Math.abs(cx + sd * h - x), what: 'the slope x' + (sd < 0 ? '0' : '1') });
        });
        C.sort(function (a, b) { return a.d - b.d; });
        var F = C[0], said = '';
        /* in a gable: off a door or a window there */
        if (!F.sd) {
          var SG = _mepSegs(st), yR = y - fl[st].y, q, j;
          for (q = 0; q < SG.length; q++) {
            var sg = SG[q]; if (Math.abs(sg.z0 - (F.nz > 0 ? BX.z0 : BX.z1)) > 0.05 || Math.abs(sg.z1 - sg.z0) > 0.05) continue;
            var ux = (sg.x1 >= sg.x0) ? 1 : -1;
            for (j = 0; j < sg.openings.length; j++) {
              var o = sg.openings[j], xa = sg.x0 + ux * (o.at - o.w / 2), xb = sg.x0 + ux * (o.at + o.w / 2), lo = Math.min(xa, xb), hi = Math.max(xa, xb);
              if (yR < o.sill - 0.10 || yR > o.sill + o.h + 0.10 || F.x < lo - 0.15 || F.x > hi + 0.15) continue;
              var nx2 = (Math.abs(F.x - (lo - 0.20)) <= Math.abs(F.x - (hi + 0.20))) ? lo - 0.20 : hi + 0.20;
              F.x = xin(nx2); said = ' (slid off a ' + (o.kind || 'unit') + ' ' + Math.round(o.w * 1000) + ' there)';
            }
          }
        }
        F.said = said;
        return F;
      };
      /* a point on face F at height y (a slope's face leans in as it rises) */
      var on = function (F, y, off) { off = off || 0; return F.sd ? [cx + F.sd * hw(y) - F.sd * off, y, F.z] : [F.x, y, F.z + F.nz * off]; };
      var tube = function (a, b) {
        var dx = b[0] - a[0], dy = b[1] - a[1], dz = b[2] - a[2], Ln = Math.hypot(dx, dy, dz);
        if (!(Ln > 0.005)) return 0;
        var m = new T.Mesh(new T.CylinderGeometry(0.006, 0.006, Ln, 8), mCab);
        m.quaternion.setFromUnitVectors(new T.Vector3(0, 1, 0), new T.Vector3(dx / Ln, dy / Ln, dz / Ln));
        m.position.set((a[0] + b[0]) / 2, (a[1] + b[1]) / 2, (a[2] + b[2]) / 2); m.name = 'elec-cable'; m.userData.viz = 'elec'; g.add(m);
        return Ln;
      };
      var run = function (pts) { var t = 0, q; for (q = 0; q + 1 < pts.length; q++) t += tube(pts[q], pts[q + 1]); return t; };
      var plate = function (F, y) {
        var p = on(F, y, F.sd ? 0.006 / S.sin : 0.006), m = new T.Mesh(new T.BoxGeometry(0.08, 0.12, 0.012), mSw);
        m.position.set(p[0], p[1], p[2]); m.rotation.order = 'YXZ'; m.rotation.y = Math.atan2(F.nx, F.nz);
        if (F.sd) m.rotation.x = Math.PI / 2 - Math.atan(S.tan);   /* lying on the slope, its face down into the room */
        m.name = 'elec-switch'; m.userData.viz = 'elec'; g.add(m);
      };
      var y0 = fl[k - 1].y + FIT.lift + STL.swH, y1 = fl[k].y + FIT.lift + STL.swH;
      var F0 = face(k - 1, SE.foot.x, SE.foot.z, y0), F1 = face(k, SE.head.x, SE.head.z, y1);
      if (!F0 || !F1) { ctx.log('ELEC stair light flight ' + k + ': no outer face for a switch at the ' + (!F0 ? 'foot' : 'head') + ' -- none'); return; }
      /* the light over the head landing, under the ceiling there -- clear of the next flight's opening */
      var LP = { x: SE.head.x, z: SE.head.z }, Hn = null, moved = '';
      try { Hn = (k + 1 < fl.length) ? _hole(k + 1) : null; } catch (eHn) { Hn = null; }
      if (Hn && LP.x > Hn.x0 - 0.15 && LP.x < Hn.x1 + 0.15 && LP.z > Hn.z0 - 0.15 && LP.z < Hn.z1 + 0.15) {
        var cand = [{ x: Hn.x0 - 0.30, z: LP.z }, { x: Hn.x1 + 0.30, z: LP.z }, { x: LP.x, z: Hn.z0 - 0.30 }, { x: LP.x, z: Hn.z1 + 0.30 }];
        cand.sort(function (a, b) { return Math.hypot(a.x - LP.x, a.z - LP.z) - Math.hypot(b.x - LP.x, b.z - LP.z); });
        LP = cand[0]; moved = ' (moved clear of the opening of flight ' + (k + 1) + ')';
      }
      var yC = _mepCeilAt(k, LP.x, LP.z);
      _am(ctx, 'stair_light', 'Stair light', STL.lamp, 'top');
      var lamp = new T.Mesh(new T.CylinderGeometry(0.14, 0.14, 0.04, 20), mLamp);
      lamp.position.set(LP.x, yC - 0.02, LP.z); lamp.name = 'elec-light'; lamp.userData.viz = 'elec'; g.add(lamp);
      _am(ctx, 'stair_light_switch', '3-way switch', STL.sw3, 'side');
      plate(F0, y0); plate(F1, y1);
      /* the 14/3: up the foot's face into the joist space of the floor between, across (round the opening), up the head's face */
      _am(ctx, 'stair_light_cable', 'Cable 14/3', STL.cab3, 'side');
      var yJ = fl[k].y - FLOOR.deck.t - FLOOR.joist.d / 2, A2 = on(F0, yJ), B2 = on(F1, yJ), H = SE.H;
      var cross = function (a, b) {   /* does the leg a -> b (along one axis) pass over the opening? */
        var xa = Math.min(a[0], b[0]), xb = Math.max(a[0], b[0]), za = Math.min(a[2], b[2]), zb = Math.max(a[2], b[2]);
        return xb > H.x0 + 0.01 && xa < H.x1 - 0.01 && zb > H.z0 + 0.01 && za < H.z1 - 0.01;
      };
      var cA = [B2[0], yJ, A2[2]], cB = [A2[0], yJ, B2[2]], corner = (!cross(A2, cA) && !cross(cA, B2)) ? cA : cB;
      var c3 = run([on(F0, y0), A2, corner, B2, on(F1, y1)]) + STL.slack;
      /* the 14/2 from the head's switch up its face to the ceiling and across to the light */
      _am(ctx, 'stair_light_feed', 'Cable', STL.cab2, 'side');
      var hC = hw(yC - 0.01), P3 = F1.sd ? [cx + F1.sd * Math.max(0, hC), yC - 0.01, F1.z] : [F1.x, yC - 0.01, F1.z];
      var c2a = run([on(F1, y1), P3, [P3[0], yC - 0.01, LP.z], [LP.x, yC - 0.01, LP.z]]);
      /* the feed: from the lighting circuit at the ceiling over the foot's switch down to it (not drawn, as the garage apartment's) */
      var yCf = _mepCeilAt(k - 1, F0.x, F0.z), c2b = Math.max(0, yCf - y0) + STL.slack, c2 = c2a + c2b + STL.slack;
      var r2 = function (v) { return Math.round(v * 100) / 100; };
      API.billAdd(L, STL.lamp, 1); API.billAdd(L, STL.sw3, 2); API.billAdd(L, STL.cab3, r2(c3)); API.billAdd(L, STL.cab2, r2(c2)); API.billAdd(L, STL.box, 3); API.billAdd(L, STL.conn, 6);
      var mm = function (v) { return Math.round(v * 1000); };
      ctx.log('ELEC stair light flight ' + k + ' (aframe-v165, IRC R303.7 / R303.7.1, ' + SE.n + ' risers): ' + STL.lamp + ' over the head landing at ' + LP.x.toFixed(2) + ',' + LP.z.toFixed(2) + moved + ', ' + mm(yC - fl[k].y) + ' over floor ' + (k + 1) +
              '; 2 x ' + STL.sw3 + ' NO CODE YET at ' + mm(STL.swH) + ': the foot on ' + F0.what + ' at ' + F0.x.toFixed(2) + ',' + F0.z.toFixed(2) + F0.said + ' (floor ' + k + '), the head on ' + F1.what + ' at ' + F1.x.toFixed(2) + ',' + F1.z.toFixed(2) + F1.said + ' (floor ' + (k + 1) + ')' +
              '; ' + r2(c3) + ' m ' + STL.cab3 + ' 14/3 between them through the joist space, ' + r2(c2) + ' m ' + STL.cab2 + ' (' + r2(c2a) + ' to the light + ' + r2(c2b) + ' feed from the lighting at the ceiling over the foot + slack), 3 x ' + STL.box + ', 6 x ' + STL.conn);
    }
    _regLayer({
      id: 'aframe-elec', version: VERSION, role: 'tzb', claims: ['elec'],
      build3d: _buildElecA, boq: function () { return _rows('aframe-elec'); }
    });
    _regLayer({
      id: 'aframe-elec-up', version: VERSION, role: 'tzb', claims: ['elec'],
      build3d: function (ctx) { return _buildElecUpA(ctx, 1); }, boq: function () { return _rows('aframe-elec-up'); }
    });
    _regLayer({
      id: 'aframe-elec-up2', version: VERSION, role: 'tzb', claims: ['elec'],
      build3d: function (ctx) { return _buildElecUpA(ctx, 2); }, boq: function () { return _rows('aframe-elec-up2'); }
    });

    /* =========================================================================
       THE HEATING AND THE VENTILATION FROM THE SHARED MEP ASSET (aframe-v140,
       P5; Marek 2026-10-12: srovnavat s barndominium). COPIED from the
       barndominium (barndo-v21..v27, _mepHeatEnv / _buildHeat): the
       multi-split by calculation -- a head in the living room and every
       bedroom, the bedrooms of floor 2 on the same outdoor unit (roomsUp /
       storeyY), a towel rail in a bathroom, the unit's feed from the board of
       aframe-elec -- and then on the same layer the ventilation (MepLib.vent):
       bathroom fans, the hood's duct, the dryer's vent, whole-house exhaust,
       an HRV in a cold climate (hrvCold, the frost depth STATE.climateZone).
       ADAPTED to the A:
         A HEAD HANGS ON A GABLE. The A's only upright exterior walls are its
           gables (and a wing's walls): a slope gets a run the full length of
           it marked as no place for a head or the outdoor unit (an opening to
           the asset), so both go onto a gable;
         FLOOR 2's HEADS at its own head height: the asset hangs a head of
           floor 2 under the wall top, and a ground floor's under a lower
           ceiling (ceilLowAt) -- so the wall top here is floor 2's head height
           and the ground floor's ceiling (under floor 2's joists, or the
           slope) is its lower ceiling, the barndo's loft read the other way;
         its walls carry floor 2's openings too, their sills over the ground;
         an upper storey never opened on the plan is a bedroom (the A's
           sleeping loft); floor 3 has no head yet (the asset heats two);
         the outdoor unit on a bracket on the gable, as the ADU (a timber
           wall carries it; the barndo's pad is for its steel wall);
         the roof the ducts go through: the rafters' top plane plus the skin.
       Magenta for an admin until checked (HEAT_REVIEW).
       ========================================================================= */
    var HEAT_REVIEW = true, AF_HEAT = { headH: 2.20 };
    function _mepSegsHeat() {
      var fl = floors(), out = [], k, q;
      for (k = 0; k < Math.min(2, fl.length); k++) {
        var dy = fl[k].y - fl[0].y, SG = _mepSegs(k);
        for (q = 0; q < SG.length; q++) {
          var sg = SG[q], ops = sg.openings.map(function (o) { var o2 = {}, kk; for (kk in o) if (o.hasOwnProperty(kk)) o2[kk] = o[kk]; o2.sill = (o.sill || 0) + dy; return o2; });
          var slope = (sg.tag === 'S0-W1' || sg.tag === 'S0-W3');
          if (slope) ops.push({ at: sg.len / 2, w: sg.len + 0.20, h: 50, sill: 0.40, kind: 'slope', hand: 'left' });   /* over the socket line: the feed does not hop it */
          out.push({ id: sg.id + (k ? ('-st' + k) : ''), tag: sg.tag, storey: k, x0: sg.x0, z0: sg.z0, x1: sg.x1, z1: sg.z1, len: sg.len, y0: fl[0].y, openings: ops });
        }
      }
      return out;
    }
    /* the roof's top over a point: the rafters' top plane and the skin on it */
    function _mepRoofTopAt(x, z) {
      var S = _sect(), B = _barRect(), cx = (B.x0 + B.x1) / 2, yTop0 = S.top + S.half * S.tan;
      var skinT = 0.10 + _pirT();
      return yTop0 - Math.abs(x - cx) * S.tan + skinT / Math.max(0.2, S.cos);
    }
    function _mepHeatEnvA(layerId) {
      var E = _mepEnvA(layerId, 0), fl = floors(), A = E.API, up = fl.length > 1;
      A.segments = _mepSegsHeat;
      A.wallTop = function () { return (up ? fl[1].y : fl[0].y) + FIT.lift + AF_HEAT.headH + 0.02; };
      E.elecId = 'aframe-elec';
      E.CATALOG = __CORE.CATALOG;
      E._roomKey = function (r) { return (r && r.key) || ''; };
      E._terraceRect = function () { return null; };
      E.isNew = function () { return HEAT_REVIEW && _isAdmin(); };
      E.ceilLowAt = function (x, z) { return _mepCeilAt(0, x, z); };
      E.storeyY = function (st) { return ((st | 0) === 1 && up) ? fl[1].y + FIT.lift : null; };
      E.roomsUp = function () {
        if (!up) return [];
        var U = _mepRoomsOf(1);
        if (/^one room/.test(U.how)) return U.rooms.map(function (r) { return { rects: r.rects, closet: false, name: 'BEDROOM', def: 'BEDROOM', key: 'rooms.bedroom', faces: r.faces }; });
        /* A LIVED-IN ROOM OF FLOOR 2 A HEAD AS A BEDROOM (aframe-v167): the asset reads env.headRoom on the ground
           floor only (mep-v45) and gives floor 2 its bedrooms (and a living room only with env.upLiving) -- so an
           office, a living room, a den up here is handed over keyed as a bedroom, its own name kept for the log */
        return U.rooms.map(function (r) {
          var k9 = String(r.key || ''), n9 = String(r.def || r.name || '');
          if (r.closet || k9 === 'rooms.bedroom' || /bed/i.test(n9) || !_afHeadRoom(k9, n9)) return r;
          var o = {}, q; for (q in r) if (r.hasOwnProperty(q)) o[q] = r[q];
          o.key = 'rooms.bedroom'; o.afLived = true;
          return o;
        });
      };
      /* EVERY LIVED-IN ROOM A HEAD (aframe-v167; COPIED from the garage apartment, garageapt-v22 _gaHeadRoom on
         mep-v45 env.headRoom, IRC R303.10 "heat in every habitable room"): an office, a dining room, a kitchen
         walled off, a den, a gym on the ground floor gets its head as a bedroom does -- the asset gave only the
         living room and the bedrooms one; the halls, the wet and service rooms none (the garage apartment's list,
         'loft' taken off it: the A's loft is lived in) */
      E.headRoom = _afHeadRoom;
      E.frostDepth = function () { return Number(STATE.climateZone) || 0; };
      E.hrvCold = true;
      return E;
    }
    function _afHeadRoom(key, nm) { return !NOHEAD.test(String(key || '') + ' ' + String(nm || '')); }
    function _buildHeatA(ctx) {
      var M = global.MepLib, L = 'aframe-heat';
      if (!M || typeof M.heat !== 'function') { _mepWaitFor(L, ctx, 'HEAT'); return; }
      var E = _mepHeatEnvA(L), fl = floors();
      ctx.log('MEP  heating for ' + L + ' built by configurator-mep.js ' + (M.VERSION || '?') + ' (aframe-v140) -- the ground floor ' + E._P().rooms().length + ' room(s)' +
              (fl.length > 1 ? (', floor 2 ' + E.roomsUp().length + ' room(s) on the same unit') : '') + (fl.length > 2 ? '; floor 3 NOT HEATED yet (the asset heats two storeys)' : '') +
              ' | heads on a gable: the slopes held clear');
      var rH = M.heat(E, ctx);
      (function () {
        var lived = [], none = [];
        try { E._P().rooms().forEach(function (r, i) { var k9 = String((r && r.key) || ''), n9 = String((r && (r.def || r.name)) || ''); if (!r || r.closet) return; if (/living|bed/i.test(k9 + ' ' + n9)) return; (_afHeadRoom(k9, n9) ? lived : none).push(n9 || ('room ' + (i + 1))); }); } catch (eG) {}
        try { E.roomsUp().forEach(function (r) { if (r && r.afLived) lived.push('storey 2 ' + String(r.def || r.name || 'room')); }); } catch (eU) {}
        ctx.log('HEAT lived-in rooms (aframe-v167, env.headRoom, IRC R303.10): ' + (lived.length ? (lived.join(', ') + ' -- a head each, as a bedroom') : 'none beyond the living room and the bedrooms') +
                (none.length ? ('; no head (a hall, wet or service room): ' + none.join(', ')) : '') + (fl.length > 2 ? '; floor 3 still unheated (the MEP request)' : ''));
      })();
      if (typeof M.vent === 'function') {
        var EV = _mepHeatEnvA(L);
        EV._roofPlaneYAt = _mepRoofTopAt;
        EV.wallThrough = function () { return AF_MEP.wt + _facT(); };
        M.vent(EV, ctx);
      } else ctx.log('VENT SKIPPED -- configurator-mep.js ' + (M.VERSION || '?') + ' has no MepLib.vent (needs mep-v26)');
      return rH;
    }
    _regLayer({
      id: 'aframe-heat', version: VERSION, role: 'tzb', claims: ['heat'],
      build3d: _buildHeatA, boq: function () { return _rows('aframe-heat'); }
    });

    /* =========================================================================
       THE WATER FROM THE SHARED MEP ASSET (aframe-v141, P5). COPIED from the
       barndominium (barndo-v21 / v22 / v26, _mepWaterEnv / _buildWater): cold
       and hot by calculation to every wet piece of the fitout (sink, basin,
       WC, washing machine, bath, shower), the electric storage heater in the
       laundry / the closet nearest the bathroom / the bathroom, fed from the
       board of aframe-elec, the entry on the nearest exterior wall, two
       frost-free sillcocks (hoseBibs); a piece upstairs fed by a riser from
       the ground floor's trunk (storeyY, every storey of the A).
       ADAPTED to the A:
         UNDER THE SLAB on strips (underSlab): the runs in trenches on the
           subgrade under the A's own build-up -- slab 150, EPS 150, gravel
           150 -- no joint under it; on point footings (a timber floor over a
           crawl space) the asset's runs as in the ADU;
         THE ENTRY, THE SILLCOCKS AND THE HEATER OFF THE SLOPES: the asset puts
           the entry on the exterior wall nearest the wet points and a sillcock
           beside it and on the opposite wall, and the heater (1550 high) in a
           corner of its room -- on a slope that is through the roof. So the
           water reads the gables as the only exterior walls (the slope sides
           handed over a footprint's length out), and a room's faces across the
           A as the lining stands 1650 over its floor (AF_MEP.clearH);
         the wall the entry goes through is the gable's: frame, lining,
           sheathing, membrane, battens and boards (wallThrough).
       Magenta for an admin until checked (WATER_REVIEW).
       ========================================================================= */
    var WATER_REVIEW = true, AF_SLAB = { t: 0.15, eps: 0.15, gravel: 0.15 };
    function _mepUnderSlab() {
      if (STATE.foundation !== 'strips') return null;
      var yT = floors()[0].y, yB = yT - AF_SLAB.t;
      return { yTop: yT, yBot: yB, ySub: yB - AF_SLAB.eps - AF_SLAB.gravel, yGrade: 0,
               dig: 'grd.excavation', bed: 'grd.gravelSlab', trapBox: 'SMH00504' };
    }
    /* a room's faces across the A where the lining stands h over floor k
       (a room in a side wing keeps its own: the wing has its ceiling) */
    function _mepFacesClear(F, h, k) {
      if (!F) return F;
      var S = _sect(), B = _barRect(), cx = (B.x0 + B.x1) / 2, linT = LINE.vb + LINE.batt + LINE.board.t, fl = floors(), Fk = fl[k | 0] || fl[0], q;
      var mx = (F.x0 + F.x1) / 2, mz = (F.z0 + F.z1) / 2;
      if ((k | 0) === 0) { var sd = _wingSides(); for (q = 0; q < sd.length; q++) { var WR = _wingRect(sd[q]); if (mz > WR.z0 && mz < WR.z1 && (mx - cx) * sd[q] > 0 && Math.abs(mx - cx) > S.half - 0.3) return F; } }
      var xc = S.half - (S.rafD + linT) / S.sin - (Fk.y + FIT.lift + h - S.top) / S.tan;
      if (!(xc > 0.3)) xc = 0.3;
      return { x0: Math.max(F.x0, cx - xc), x1: Math.min(F.x1, cx + xc), z0: F.z0, z1: F.z1 };
    }
    function _mepWaterEnvA(layerId) {
      var E = _mepEnvA(layerId, 0), fl = floors(), BX = _mepPlan(0).box, Lf = (STATE.footprint && STATE.footprint.l) || 9;
      E.API.poly = function () { return [[BX.x0 - Lf, BX.z0], [BX.x1 + Lf, BX.z0], [BX.x1 + Lf, BX.z1], [BX.x0 - Lf, BX.z1]]; };
      E._buildRect = function () { return { x0: BX.x0 - Lf, x1: BX.x1 + Lf, z0: BX.z0, z1: BX.z1 }; };
      var P0 = E._P;
      E._P = function () {
        var p = P0(), rf = p.roomFaces;
        p.roomFaces = function (x, z) { return _mepFacesClear(rf(x, z), AF_MEP.clearH, 0); };
        return p;
      };
      E.elecId = 'aframe-elec';
      E.CATALOG = __CORE.CATALOG;
      E._roomKey = function (r) { return (r && r.key) || ''; };
      E.isNew = function () { return WATER_REVIEW && _isAdmin(); };
      E.storeyY = function (st) { st = st | 0; return (st > 0 && st < fl.length) ? fl[st].y + FIT.lift : null; };
      E.underSlab = _mepUnderSlab;
      E.hoseBibs = true;
      E.wallThrough = function () { return AF_MEP.wt + _facT(); };
      return E;
    }
    function _buildWaterA(ctx) {
      var M = global.MepLib, L = 'aframe-water';
      if (!M || typeof M.water !== 'function') { _mepWaitFor(L, ctx, 'WATER'); return; }
      var E = _mepWaterEnvA(L), FX = ((STATE.product || {}).fixtures || []), byS = {}, q;
      for (q = 0; q < FX.length; q++) if (FX[q]) byS[FX[q].st | 0] = (byS[FX[q].st | 0] || 0) + 1;
      ctx.log('MEP  water for ' + L + ' built by configurator-mep.js ' + (M.VERSION || '?') + ' (aframe-v141) -- fitout pieces by floor ' +
              Object.keys(byS).map(function (k) { return (+k + 1) + ': ' + byS[k]; }).join(', ') + (STATE.foundation === 'strips' ? ' | runs under the slab (subgrade at ' + Math.round(_mepUnderSlab().ySub * 1000) + ')' : ' | a timber floor on ' + STATE.foundation + ': no slab to go under'));
      var k0 = ctx.group ? ctx.group.children.length : 0, rW = M.water(E, ctx);
      _mepSlabFirst(ctx, k0, 'water_under_slab', 'Water under the slab');
      return rW;
    }
    /* WHAT GOES IN UNDER THE SLAB COMES IN THE WALK WITH THE BASE (aframe-v141):
       the asset names those bodies '*-slab-*'; they take an item of their own
       (the same code, the key below), which the walk puts before the slab */
    function _mepSlabFirst(ctx, k0, key, name) {
      if (!ctx || !ctx.group) return 0;
      var ch = ctx.group.children, i, n = 0, keep = ctx.item;
      for (i = k0; i < ch.length; i++) {
        var o = ch[i], hit = false;
        o.traverse(function (m) { if (m.name && /-slab-/.test(m.name)) hit = true; });
        if (!hit) continue;
        var t = o.userData && o.userData.asm, code = t ? (typeof t === 'string' ? t : (t.code || '')) : '';
        _am(ctx, key, name, code, 'top');
        o.userData.asm = ctx.item; n++;
      }
      ctx.item = keep;
      return n;
    }
    _regLayer({
      id: 'aframe-water', version: VERSION, role: 'tzb', claims: ['water'],
      build3d: _buildWaterA, boq: function () { return _rows('aframe-water'); }
    });

    /* =========================================================================
       THE WASTE FROM THE SHARED MEP ASSET (aframe-v142, P5). COPIED from the
       barndominium (its waste hook on the water's env): every wet piece of the
       fitout by calculation -- its trap (P-trap, shower drain, outlet box,
       toilet flange), its branch 50 / 110 to the building drain 110 met room
       by room, a cleanout where the drain leaves and 1 m of sewer pipe outside
       (the sewer beyond is site work); a wet room off the drain on a collector
       50 with an air admittance valve; a piece upstairs down a drop
       (storeyY, every storey of the A); the vent stack 75 at the drain's far
       end to 300 over the roof with its flashing.
       ADAPTED to the A (on the water's env, _mepWaterEnvA):
         UNDER THE SLAB on strips (underSlab): the drain at 1/8 in./ft and the
           branches at 1/4 in./ft in trenches to the subgrade under the slab,
           the EPS and the gravel, stub-ups through the slab, a tub box
           SMH00504 at a floor drain, out under the gable to the cleanout on a
           riser to grade; on point footings the pipes hang under the timber
           floor (the ADU);
         THE DRAIN LEAVES THROUGH A GABLE: the slope sides handed over a
           footprint's length out, as for the water;
         THE VENT STACK IN A GABLE (stackOuter): the gables are the A's only
           walls that run up to the roof -- a partition below has the loft
           floor over it, a slope is no wall. It rises in the gable of its room
           (none: in the gable nearest, the drain carried on to it) to 300 over
           the roof plane over it (_mepRoofTopAt: the rafters' top and the
           skin). A stack crossing an opening of that gable is logged (***).
       Magenta for an admin until checked (WASTE_REVIEW).
       ========================================================================= */
    var WASTE_REVIEW = true, AF_WASTE = { clear: 0.15, door: 0.50, edge: 1.00 }, _wasteExit = null;
    function _mepWasteEnvA(L, SL) {
      var E = _mepWaterEnvA(L);
      E.isNew = function () { return WASTE_REVIEW && _isAdmin(); };
      E._roofPlaneYAt = _mepRoofTopAt;
      E.stackOuter = true;
      E.exitClear = _mepExitClear;
      /* THE STACK SLID ALONG ITS GABLE: the asset stands it at its pieces'
         middle clamped into its room's face 150 in; that face handed over
         narrowed so the clamp lands on the clear spot */
      if (SL && SL.x != null && SL.F) {
        var P1 = E._P, F0 = SL.F, X = SL.x, right = SL.x > SL.from;
        E._P = function () {
          var p = P1(), rf = p.roomFaces;
          p.roomFaces = function (x, z) {
            var f = rf(x, z);
            if (!f || Math.abs(f.x0 - F0.x0) > 1e-6 || Math.abs(f.x1 - F0.x1) > 1e-6 || Math.abs(f.z0 - F0.z0) > 1e-6 || Math.abs(f.z1 - F0.z1) > 1e-6) return f;
            return right ? { x0: X - 0.15, x1: f.x1, z0: f.z0, z1: f.z1 } : { x0: f.x0, x1: X + 0.15, z0: f.z0, z1: f.z1 };
          };
          return p;
        };
      }
      return E;
    }
    function _buildWasteA(ctx) {
      var M = global.MepLib, L = 'aframe-waste';
      if (!M || typeof M.waste !== 'function') { _mepWaitFor(L, ctx, 'WASTE'); return; }
      var US = _mepUnderSlab(), SL = null, R0 = null;
      ctx.log('MEP  waste for ' + L + ' built by configurator-mep.js ' + (M.VERSION || '?') + ' (aframe-v142) -- ' +
              (US ? ('the runs under the slab (subgrade at ' + Math.round(US.ySub * 1000) + ')') : ('a timber floor on ' + STATE.foundation + ': the pipes hang under it')) +
              ' | the drain out through a gable, the vent stack in a gable (stackOuter)');
      /* A DRY RUN to see where the asset stands the stack: no log, no walk
         marks, a group of its own thrown away; the bill is reset by the run
         that counts */
      if (ctx.THREE && ctx.group && ctx.THREE.Group) {
        var Q = Object.create(ctx), G0 = new ctx.THREE.Group();
        Q.group = G0; Q.marks = null; Q.log = function () {};
        try { M.waste(_mepWasteEnvA(L, null), Q); R0 = _mepStackAt(G0, 0); } catch (eQ) { R0 = null; }
        _mepDispose(G0);
        if (R0 && R0.hits.length) SL = _mepStackSlide(R0, _mepWasteEnvA(L, null));
      }
      _wasteExit = null;
      var k0 = ctx.group ? ctx.group.children.length : 0, rS = M.waste(_mepWasteEnvA(L, SL), ctx);
      var R1 = ctx.group ? _mepStackAt(ctx.group, k0) : null;
      if (R1) {
        ctx.log('WASTE stack (aframe-v142): at ' + R1.x.toFixed(2) + ',' + R1.z.toFixed(2) + ' in wall ' + (R1.sg ? R1.sg.tag : '?') + ', ' + Math.round(R1.yA * 1000) + ' to ' + Math.round(R1.yB * 1000) +
                ((SL && SL.x != null) ? (' -- slid ' + Math.round(Math.abs(SL.x - SL.from) * 1000) + ' along the gable off ' + R0.hits.map(function (h) { return h.txt; }).join(', ') + ' (the asset stood it at ' + SL.from.toFixed(2) + ')') : '') +
                (R1.hits.length ? (' -- *** it crosses ' + R1.hits.map(function (h) { return h.txt; }).join(', ') + ' in that wall' + ((SL && SL.why) ? (': ' + SL.why) : '') + ' -- move the bathroom or the opening') : ' -- clear of the openings of that wall (' + Math.round(AF_WASTE.clear * 1000) + ' off their edges)'));
      }
      if (_wasteExit) {
        var BXe = _mepPlan(0).box, eG = (_wasteExit.z < (BXe.z0 + BXe.z1) / 2) ? 0 : 1;
        ctx.log('WASTE exit (aframe-v142): under the gable ' + (eG ? 'z1' : 'z0') + ' at x ' + _wasteExit.x.toFixed(2) + (_wasteExit.why ? (' -- ' + _wasteExit.why) : ' -- clear of its doors') +
                (_porch(eG) ? (' -- *** a porch on that gable (reach ' + Math.round(_rakeOf(eG) * 1000) + '): the cleanout 1000 out comes up in its deck, a cap in the deck') : ''));
      }
      _mepSlabFirst(ctx, k0, 'waste_under_slab', 'Waste under the slab');
      return rS;
    }
    function _mepDispose(g) {
      try {
        g.traverse(function (m) {
          if (m.geometry && m.geometry.dispose) m.geometry.dispose();
          var mt = m.material, i; mt = mt ? (Array.isArray(mt) ? mt : [mt]) : [];
          for (i = 0; i < mt.length; i++) if (mt[i] && mt[i].dispose) mt[i].dispose();
        });
      } catch (eD) {}
    }
    /* WHERE THE STACK STANDS and what of its wall it crosses: the openings of
       that wall line on every floor over the stack's height, AF_WASTE.clear
       off their edges (the pipe and the opening's studs) */
    function _mepStackAt(group, k0) {
      var ch = group.children, sk = null, i;
      for (i = k0 || 0; i < ch.length && !sk; i++) ch[i].traverse(function (m) { if (!sk && m.name === 'waste-vent-stack') sk = m; });
      if (!sk) return null;
      var p = sk.position, h = (sk.geometry && sk.geometry.parameters && sk.geometry.parameters.height) || 0;
      var R = { x: p.x, z: p.z, yA: p.y - h / 2, yB: p.y + h / 2, sg: null, hits: [] };
      R.hits = _mepStackHits(R, R.x, R.z);
      return R;
    }
    function _mepStackHits(R, x, z) {
      var fl = floors(), out = [], k, q, j;
      for (k = 0; k < fl.length; k++) {
        var SG = _mepSegs(k);
        for (q = 0; q < SG.length; q++) {
          var sg = SG[q], ux = (sg.x1 - sg.x0) / sg.len, uz = (sg.z1 - sg.z0) / sg.len;
          var t = (x - sg.x0) * ux + (z - sg.z0) * uz, dn = Math.abs((x - sg.x0) * uz - (z - sg.z0) * ux);
          if (dn > AF_MEP.wt + 0.10 || t < -0.05 || t > sg.len + 0.05) continue;
          if (!R.sg) R.sg = sg;
          for (j = 0; j < sg.openings.length; j++) {
            var o = sg.openings[j], yo0 = fl[k].y + o.sill, yo1 = yo0 + o.h;
            if (Math.abs(t - o.at) < o.w / 2 + AF_WASTE.clear && R.yB > yo0 && R.yA < yo1)
              out.push({ k: k, txt: o.kind + ' ' + Math.round(o.w * 1000) + 'x' + Math.round(o.h * 1000) + ' on floor ' + (k + 1) });
          }
        }
      }
      return out;
    }
    /* the nearest clear spot along the gable, inside the stack's room: the
       edges of every opening of that wall line, AF_WASTE.clear off */
    function _mepStackSlide(R, E) {
      var sg = R.sg, out = { from: R.x, x: null, F: null, why: '' };
      if (!sg) { out.why = 'no wall at the stack'; return out; }
      if (Math.abs(sg.z1 - sg.z0) > 0.01) { out.why = 'its wall is not a gable'; return out; }
      var BX = _mepPlan(0).box, dir = (R.z < (BX.z0 + BX.z1) / 2) ? 1 : -1, F = null;
      try { F = E._P().roomFaces(R.x, R.z + dir * 0.25); } catch (eF) { F = null; }
      if (!F) { out.why = 'no room at the stack'; return out; }
      var lo = F.x0 + 0.15, hi = F.x1 - 0.15, C = [], fl = floors(), k, q, j;
      for (k = 0; k < fl.length; k++) {
        var SG = _mepSegs(k);
        for (q = 0; q < SG.length; q++) {
          var s2 = SG[q];
          if (Math.abs(s2.z1 - s2.z0) > 0.01 || Math.abs(s2.z0 - sg.z0) > 0.05) continue;
          var u2 = (s2.x1 - s2.x0) / s2.len;
          for (j = 0; j < s2.openings.length; j++) {
            var o = s2.openings[j], xc = s2.x0 + u2 * o.at, hw = o.w / 2 + AF_WASTE.clear + 0.01;
            C.push(xc - hw, xc + hw);
          }
        }
      }
      C = C.filter(function (x) { return x >= lo - 1e-6 && x <= hi + 1e-6; }).sort(function (a, b) { return Math.abs(a - R.x) - Math.abs(b - R.x); });
      for (j = 0; j < C.length; j++) {
        if (!_mepStackHits({ yA: R.yA, yB: R.yB, sg: sg }, C[j], R.z).length) { out.x = C[j]; out.F = F; return out; }
      }
      out.why = 'no clear spot in the gable of its room between ' + lo.toFixed(2) + ' and ' + hi.toFixed(2);
      return out;
    }
    /* THE DRAIN LEAVES CLEAR OF A DOOR (env.exitClear): the cleanout rises
       1000 out from the gable, so not in front of a ground-floor door -- the
       exit slid along the gable to AF_WASTE.door past its edge, kept
       AF_WASTE.edge in from the gable's ends (the strips under the slopes) */
    function _mepExitClear(x, z, k) {
      var SG = _mepSegs(0), BX = _mepPlan(0).box, lo = BX.x0 + AF_WASTE.edge, hi = BX.x1 - AF_WASTE.edge, D = [], q, j;
      for (q = 0; q < SG.length; q++) {
        var sg = SG[q];
        if (Math.abs(sg.z1 - sg.z0) > 0.01 || Math.abs(sg.z0 - z) > AF_MEP.wt + 0.30) continue;
        var u = (sg.x1 - sg.x0) / sg.len;
        for (j = 0; j < sg.openings.length; j++) {
          var o = sg.openings[j];
          if (o.sill < 0.30) D.push({ c: sg.x0 + u * o.at, hw: o.w / 2 + AF_WASTE.door, txt: o.kind + ' ' + Math.round(o.w * 1000) });
        }
      }
      function hit(xx) { var i; for (i = 0; i < D.length; i++) if (Math.abs(xx - D[i].c) < D[i].hw - 1e-6) return D[i]; return null; }
      var x0 = Math.max(lo, Math.min(hi, x)), H0 = hit(x0), C = [], i;
      _wasteExit = { x: x0, z: z, k: k, why: '' };
      if (!H0 && Math.abs(x0 - x) < 1e-6) return null;
      if (H0) {
        for (i = 0; i < D.length; i++) C.push(D[i].c - D[i].hw, D[i].c + D[i].hw);
        C = C.filter(function (xx) { return xx >= lo && xx <= hi && !hit(xx); }).sort(function (a, b) { return Math.abs(a - x) - Math.abs(b - x); });
        if (!C.length) { _wasteExit.why = '*** no spot clear of its doors on that gable'; return null; }
        x0 = C[0];
      }
      _wasteExit.x = x0;
      _wasteExit.why = H0 ? ('slid ' + Math.round(Math.abs(x0 - x) * 1000) + ' off the ' + H0.txt + ' (the cleanout not in front of it)') : ('kept ' + Math.round(AF_WASTE.edge * 1000) + ' in from the gable\'s end');
      return { x: x0, z: z, why: _wasteExit.why };
    }
    _regLayer({
      id: 'aframe-waste', version: VERSION, role: 'tzb', claims: ['waste'],
      build3d: _buildWasteA, boq: function () { return _rows('aframe-waste'); }
    });

    /* -------------------------------------------------------------------------
       THE BARRIER'S PENETRATIONS (aframe-v155, plan J part 2b), after every
       service is built. What goes through the vapour barrier is sealed to it
       with the membrane tape INS01005, what goes on out through the breather
       membrane and the cladding is taped there too and bedded in the PU
       sealant FEC00038 outside:
         an electric box in the barrier -- a socket, switch, lamp or smoke
           alarm on a slope, a gable, the wing's walls or ceiling or the
           dormer (one on a partition, or on a ceiling under an upper floor, is
           warm on both sides and left out); the board in an outer wall
           -- a collar of tape round its flange, 0.6 m (the board 1.8 m)
         through a wall: each split head's line set, each sillcock, each
           outdoor socket / lamp / isolator's cable -- 0.4 m in, 0.4 m out;
           each wall hood and fresh-air / exhaust terminal's duct -- 1.0 m
           in, 1.0 m out; all of them sealed outside, a cartridge per six
         through the roof: each roof cap's duct 1.0 m, each plumbing vent
           0.4 m, in the barrier (outside the roof's own flashing, billed by
           the services)
       The devices are found among the electric layers' bodies by their code
       and place; the rest are counted from the services' own rows.
       ------------------------------------------------------------------------- */
    var AIRSEAL = { tape: 'INS01005', seal: 'FEC00038', box: 0.6, board: 1.8, pipe: 0.4, duct: 1.0, perTube: 6 };
    /* EVERY LIVED-IN ROOM'S LIGHT AND AIR AND EVERY BEDROOM'S WAY OUT
       (aframe-v166; COPIED from the garage apartment's 14b, garageapt-v23:
       "IRC R303.1: glass 8 % of the floor ... R310: an emergency escape
       opening -- net clear 5.7 sq ft, 5.0 on the grade floor, 20 in. wide
       and 24 in. high clear at least, its sill 44 in. over the floor at most
       -- or a door straight out ... A log check only: the glass is the
       window's size less a frame (x 0.80), the clear opening a casement's
       (the size less 100 x 120); a room with too little glass passes by
       R303.1's exceptions where the house has whole-house ventilation and
       the room its light -- not a bedroom, whose escape opening R310 asks
       anyway"). ADAPTED to the A: every storey; a storey's windows are its
       gables' units as the plan has them and its roof windows (R310 lets a
       roof window be the escape opening, its sill the bottom of the clear
       opening -- the unit has to open as an escape window, not pivot on
       its middle: CHECK with the maker); fixed glazing (FIX...) gives light,
       never a way out; an upper storey never opened on the plan is the
       sleeping loft, a bedroom (the heating's rule, aframe-v140); the
       lived-in rooms by the garage apartment's list (GA_NOHEAD, mep-v45's)
       less 'loft'. */
    var LIGHT = { glass: 0.08, frame: 0.80, clrW: 0.10, clrH: 0.12, egUp: 5.7 * 0.09290304, egGr: 5.0 * 0.09290304, egW: 20 * 0.0254, egH: 24 * 0.0254, egSill: 44 * 0.0254 };
    var NOHEAD = /garage|hall|corridor|entry|mud|laundry|utility|storage|pantry|wardrobe|closet|wc|bath|shower|cellar|porch|terrace|balcony|garden|pool|sauna|cooling|changing|attic/i;
    function _roomLight(ctx) {
      var G = LIGHT, fl = floors(), said = [], warn = [], k;
      var S = _sect(), B = _barRect(), cx = (B.x0 + B.x1) / 2, R5 = _rafSize(), yT0 = S.top + S.half * S.tan, oF = -(R5.d + LINE.batt + LINE.vb + LINE.board.t);
      var hw = function (y) { return (yT0 + oF * S.cos - y) / S.tan + oF * S.sin; };
      var RW = null; try { RW = _roofWinPlan(S, R5, B, _rafGrid(), yT0); } catch (eRW) { RW = null; }
      var mm = function (v) { return Math.round(v * 1000); }, sq = function (a) { return (a / 0.09290304).toFixed(1); };
      /* R303.1 exception 1 holds only with whole-house ventilation: its control VMM00004 in the heating's bill (the VENT line;
         none without a bathroom fan to run it) -- without it the room asks its 4 % openable, so a window */
      var whv = !!((_bill['aframe-heat'] || {})['VMM00004']);
      for (k = 0; k < fl.length; k++) {
        var UR = _mepRoomsOf(k), loft = (k > 0 && /^one room/.test(UR.how)), RO = [];
        UR.rooms.forEach(function (r) {
          if (r.closet) return;
          var a = 0; r.rects.forEach(function (q9) { a += (q9.x1 - q9.x0) * (q9.z1 - q9.z0); });
          RO.push({ key: loft ? 'rooms.bedroom' : String(r.key || ''), name: loft ? 'LOFT (sleeping)' : String(r.def || r.name || ''), rects: r.rects, area: a, win: [], door: 0 });
        });
        var inRoom = function (px, pz) {
          var hit = null;
          RO.forEach(function (R) { if (!hit) R.rects.forEach(function (r) { if (!hit && px >= r.x0 - 0.02 && px <= r.x1 + 0.02 && pz >= r.z0 - 0.02 && pz <= r.z1 + 0.02) hit = R; }); });
          return hit;
        };
        /* the gables' units of this storey (the plan's), their sills over this floor */
        _mepSegs(k).forEach(function (s0) {
          var ux = (s0.x1 - s0.x0) / s0.len, uz = (s0.z1 - s0.z0) / s0.len, d = AF_MEP.wt + 0.30;
          s0.openings.forEach(function (o) {
            var bx = s0.x0 + ux * o.at, bz = s0.z0 + uz * o.at, hit = inRoom(bx - uz * d, bz + ux * d) || inRoom(bx + uz * d, bz - ux * d);
            if (!hit) return;
            var fixed = /^FIX/.test(String(o.code || ''));
            if ((o.sill || 0) <= 0.05 && (o.kind === 'door' || o.kind === 'french')) { hit.door++; return; }
            hit.win.push({ w: o.w, h: o.h, sill: o.sill || 0, fixed: fixed, what: (fixed ? 'fixed glazing ' : (o.kind || 'window') + ' ') + mm(o.w) + ' x ' + mm(o.h) + ' in a gable' });
          });
        });
        /* its roof windows: the sill on the lining, the point 300 into the room from there */
        ((RW && RW.wins) || []).forEach(function (W) {
          if ((W.st | 0) !== k) return;
          var px = cx + W.side * (Math.max(0.40, hw(W.ySill)) - 0.30), hit = inRoom(px, W.z);
          if (!hit) return;
          hit.win.push({ w: W.sz.w, h: W.sz.h, sill: W.ySill - fl[k].y, fixed: false, roof: true, what: 'roof window ' + (W.sz.code || '') });
        });
        RO.forEach(function (R) {
          if (NOHEAD.test(R.key + ' ' + R.name)) return;   /* the lived-in rooms */
          var gl = 0, bestE = null;
          R.win.forEach(function (o) {
            gl += o.w * o.h * G.frame;
            if (o.fixed) return;
            var cw = o.w - G.clrW, ch = o.h - G.clrH, ca = Math.max(0, cw) * Math.max(0, ch);
            if (cw >= G.egW && ch >= G.egH && o.sill <= G.egSill && (!bestE || ca > bestE.a)) bestE = { a: ca, o: o };
          });
          var pc = R.area > 0 ? gl / R.area : 0, nm = (k ? 'storey ' + (k + 1) + ' ' : '') + String(R.name || 'room').toUpperCase();
          var isBed = /bed|guest|nursery/i.test(R.key + ' ' + R.name);
          var line = nm + ' ' + R.area.toFixed(1) + ' m2: glass ' + gl.toFixed(2) + ' m2 = ' + Math.round(pc * 100) + ' %' +
                     (pc >= G.glass ? '' : (isBed ? ' (8 % asked)' : (whv ? ' (8 % asked -- met by R303.1 exceptions 1 + 2: whole-house ventilation and the room\'s light)' : ' (8 % asked -- NOT met: no whole-house ventilation)')));
          if (pc < G.glass && !isBed && !whv) warn.push(nm + ' has ' + Math.round(pc * 100) + ' % glass and the house no whole-house ventilation (no bathroom fan on the plan, the VENT line) -- R303.1 asks 8 % glass, 4 % of it openable: a window in a gable, or a bathroom on the plan');
          if (isBed) {
            var need = k ? G.egUp : G.egGr;
            if (R.door && !k) line += '; egress: a door straight out (R310.1)';
            else if (bestE && bestE.a >= need) line += '; egress: the ' + bestE.o.what + ' ' + mm(bestE.o.w) + ' x ' + mm(bestE.o.h) + ' sill ' + mm(bestE.o.sill) + ', clear ~' + sq(bestE.a) + ' sq ft (' + sq(need) + ' asked) -- as a casement' + (bestE.o.roof ? ' (CHECK: an escape roof window, top-hung -- a centre-pivot sash is no way out)' : '');
            else { line += '; egress: NONE big enough'; warn.push(nm + ' has no emergency escape opening (IRC R310: ' + sq(need) + ' sq ft clear, 20 x 24 in., sill 44 in.) -- a roof window 780 x 1180 or bigger on that storey, or a bigger window in a gable'); }
          }
          said.push(line);
        });
      }
      if (!said.length) { ctx.log('rooms    light and air / egress (aframe-v166): no lived-in room'); return; }
      ctx.log('rooms    light and air (IRC R303.1) and egress (R310), from the windows as placed (aframe-v166, the garage apartment\'s 14b): ' + said.join('; ') + (warn.length ? (' -- CHECK: ' + warn.join('; ')) : ' -- all held'));
    }
    function _buildAirseal(ctx) {
      var L0 = 'aframe-airseal';
      _bill[L0] = {};
      /* THE LEAVES THE WALK-THROUGH OPENS (aframe-v161), counted as the layers drew them */
      var nAr = _arTally.swing + _arTally.slide;
      ctx.log('ar       ' + nAr + ' leaf / sash(es) open in the AR walk-through (arLeaf, aframe-v161; the ADU\'s adu-v1431 copied): ' + _arTally.swing + ' swing, ' + _arTally.slide + ' slide -- ' +
              (nAr ? Object.keys(_arTally.where).map(function (k) { return _arTally.where[k] + ' ' + k; }).join(', ') : 'none -- the doors stay merged in the AR model') + '; the outer doors swing into the room, the HS doors run their inner sash, the windows stay shut');
      try { _roomLight(ctx); } catch (eRL) { ctx.log('rooms    light / egress THREW ' + ((eRL && eRL.message) || eRL)); }
      var st = null; try { st = (API._stage || __CORE._stage)(); } catch (eSt) { st = null; }
      if (!st || !st.group) { ctx.log('airseal  no stage to look at -- nothing counted'); return; }
      try { st.group.updateMatrixWorld(true); } catch (eUm) {}
      var T = ctx.THREE, fl = floors(), parts = STATE.parts || [];
      var DIN = { EES00001: 'socket', EEL00001: 'switch', 'TBD.sw3way': 'switch', EEC00002: 'lamp', EES00004: 'smoke alarm', EED00002: 'board', EED00001: 'board' };   /* the stair light's 3-way pair too (aframe-v165) */
      var DOUT = { EES00005: 'outdoor socket', EEW00003: 'outdoor lamp', EEI00001: 'outdoor isolator' };
      var layOf = function (o) { var p = o; while (p) { if (p.userData && p.userData.layer) return String(p.userData.layer); p = p.parent; } return ''; };
      var storeyOf = function (y) { var k, s9 = 0; for (k = 0; k < fl.length; k++) if (y >= fl[k].y - 0.05) s9 = k; return s9; };
      var onPart = function (c) {
        var k = storeyOf(c.y), i;
        for (i = 0; i < parts.length; i++) {
          var p = parts[i]; if (!p) continue;
          if (((typeof p.st === 'number') ? (p.st | 0) : 0) !== k) continue;
          var vert = ((p.dir || p.o) === 'v'), at = (typeof p.at === 'number') ? p.at : p.c, spn = null;
          try { spn = API.partSpan ? API.partSpan(p) : null; } catch (eS) { spn = null; }
          var lo = (spn && typeof spn[0] === 'number') ? spn[0] : ((typeof p.a === 'number' && typeof p.b === 'number') ? Math.min(p.a, p.b) : -1e9);
          var hi = (spn && typeof spn[1] === 'number') ? spn[1] : ((typeof p.a === 'number' && typeof p.b === 'number') ? Math.max(p.a, p.b) : 1e9);
          var nrm = vert ? c.x : c.z, alg = vert ? c.z : c.x;
          if (Math.abs(nrm - at) < PARTA.d / 2 + 0.10 && alg > lo - 0.05 && alg < hi + 0.05) return true;
        }
        return false;
      };
      var underFloor = function (c) {
        var k; for (k = 1; k < fl.length; k++) { var yC = fl[k].y - FLOOR.deck.t - FLOOR.joist.d - LINE.batt - LINE.board.t; if (Math.abs(c.y - yC) < 0.20) return true; }
        return false;
      };
      var seen = {}, env = {}, inn = 0, out = {}, nEnv = 0, nBoard = 0, nOut = 0;
      st.group.traverse(function (o) {
        if (!o.isMesh || !o.geometry) return;
        var lay = layOf(o); if (!/^aframe-(elec|heat)/.test(lay)) return;
        var m = o.userData && o.userData.asm, cd = m ? String((typeof m === 'string') ? m : (m.code || '')) : '';
        if (!DIN[cd] && !DOUT[cd]) return;
        /* Additional switch gangs share the first switch's box and collar. */
        if (/^esw[0-9]+g[0-9]+$/.test(o.userData.qtyPiece || '')) return;
        var bb = null; try { o.geometry.computeBoundingBox(); bb = o.geometry.boundingBox.clone().applyMatrix4(o.matrixWorld); } catch (eBb) { bb = null; }
        if (!bb) return;
        var c = new T.Vector3(); bb.getCenter(c);
        var key = cd + '@' + Math.round(c.x * 20) + ',' + Math.round(c.y * 20) + ',' + Math.round(c.z * 20);
        if (seen[key]) return; seen[key] = 1;
        if (DOUT[cd]) { out[DOUT[cd]] = (out[DOUT[cd]] || 0) + 1; nOut++; return; }
        if (onPart(c) || underFloor(c)) { inn++; return; }
        env[DIN[cd]] = (env[DIN[cd]] || 0) + 1;
        if (DIN[cd] === 'board') nBoard++; else nEnv++;
      });
      /* the services through the envelope, from their own rows */
      var rowsN = function (codes) { var n = 0, k2, c2; for (k2 in _bill) { if (!_bill.hasOwnProperty(k2) || k2 === L0 || k2.indexOf('aframe-') !== 0) continue; for (c2 = 0; c2 < codes.length; c2++) n += +((_bill[k2] || {})[codes[c2]] || 0); } return Math.round(n); };
      var nLine = rowsN(['VMI00001']), nBib = rowsN(['SMB00122']), nHood = rowsN(['VMG01001', 'VMG01601', 'VME01602']), nCap = rowsN(['VMG01002', 'VMG01602']), nVent = rowsN(['SMV00751']);
      var tapeIn = nEnv * AIRSEAL.box + nBoard * AIRSEAL.board + (nLine + nBib + nOut) * AIRSEAL.pipe + nHood * AIRSEAL.duct + nCap * AIRSEAL.duct + nVent * AIRSEAL.pipe;
      var tapeOut = (nLine + nBib + nOut) * AIRSEAL.pipe + nHood * AIRSEAL.duct;
      var nExt = nLine + nBib + nOut + nHood, nTube = nExt ? Math.ceil(nExt / AIRSEAL.perTube) : 0;
      if (tapeIn + tapeOut > 0.01) API.billAdd(L0, AIRSEAL.tape, Math.round((tapeIn + tapeOut) * 1.05 * 100) / 100);
      if (nTube) API.billAdd(L0, AIRSEAL.seal, nTube);
      var lst = function (o) { return Object.keys(o).map(function (k) { return o[k] + ' ' + k; }).join(', ') || 'none'; };
      ctx.log('airseal  the barrier\'s penetrations (aframe-v155): ' + (nEnv + nBoard) + ' electric box(es) in it (' + lst(env) + '), ' + inn + ' on a partition or a ceiling under a floor left out (warm both sides); through a wall: ' + nLine + ' line set(s), ' + nBib + ' sillcock(s), ' + nHood + ' duct(s) to a wall hood / terminal, ' + nOut + ' outdoor device(s) (' + lst(out) + '); through the roof: ' + nCap + ' duct(s) to a roof cap, ' + nVent + ' plumbing vent(s)');
      try { _insulAudit(ctx); } catch (eIa) { ctx.log('insul    ERROR ' + ((eIa && eIa.message) || eIa)); }
      ctx.log('airseal  BILL ' + AIRSEAL.tape + ' ' + ((tapeIn + tapeOut) * 1.05).toFixed(2) + ' m (collars: ' + tapeIn.toFixed(2) + ' in the barrier + ' + tapeOut.toFixed(2) + ' in the breather membrane, +5%)' + (nTube ? (', ' + nTube + ' x ' + AIRSEAL.seal + ' (' + nExt + ' penetration(s) sealed outside, a cartridge per ' + AIRSEAL.perTube + ')') : ', no outside penetration -- no sealant'));
    }
    /* -------------------------------------------------------------------------
       THE INSULATION AGAINST THE CLIMATE (aframe-v156, plan K step 1: the
       audit). The core's climate choice is the frost depth (Roof & Base:
       subtropical 0, warm temperate 0.6, temperate 0.8, cool temperate 1.0,
       cold / boreal 1.2, arctic 1.5 m); read here as the IECC climate zone
       it stands for (2, 3, 4, 5, 6, 7-8). The 2021 IECC Table R402.1.3 (IRC
       N1102.1.3) minimum R-values for that zone: the ceiling (the A's slopes
       and the wing's roof are ceilings without an attic -- R402.2.2 lets
       R-30 stand only over 500 ft2 or 20 % of the ceiling, not a whole A),
       the wood frame wall (cavity + continuous: 13 / 0+10 in 2; 20, 13+5 or
       0+15 in 3; 20+5, 13+10 or 0+15 from 4), the floor over open air (13,
       19, 19, 30, 30, 38) and the slab edge (none; R-10 2 ft in 3; R-10 4 ft
       from 4). Each build-up's insulation by its stock thickness at R-4.0 an
       inch for the mineral wool, 6.0 for the PIR (aged), 4.0 the EPS, 5.0 the
       XPS; written as it stands, SHORT where it is under the figure. The
       slopes between the rafters follow the zone since aframe-v157 (the
       hybrid, _pirAbove); the walls, the PIR above the rafters, the wing's
       roof and the dormer not yet (step 2b / 2c) */
    var IECC_Z = [
      { f: 0.0, cz: '2', wallU: 0.084, ceil: 49, ceilU: 0.026, wall: [[13, 0], [0, 10]], floor: 13, slab: 0, slabFt: 0 },
      { f: 0.6, cz: '3', wallU: 0.060, ceil: 49, ceilU: 0.026, wall: [[20, 0], [13, 5], [0, 15]], floor: 19, slab: 10, slabFt: 2 },
      { f: 0.8, cz: '4', wallU: 0.045, ceil: 60, ceilU: 0.024, wall: [[20, 5], [13, 10], [0, 15]], floor: 19, slab: 10, slabFt: 4 },
      { f: 1.0, cz: '5', wallU: 0.045, ceil: 60, ceilU: 0.024, wall: [[20, 5], [13, 10], [0, 15]], floor: 30, slab: 10, slabFt: 4 },
      { f: 1.2, cz: '6', wallU: 0.045, ceil: 60, ceilU: 0.024, wall: [[20, 5], [13, 10], [0, 15]], floor: 30, slab: 10, slabFt: 4 },
      { f: 1.5, cz: '7-8', wallU: 0.045, ceil: 60, ceilU: 0.024, wall: [[20, 5], [13, 10], [0, 15]], floor: 38, slab: 10, slabFt: 4 }
    ];
    var R_IN = { wool: 4.0, pir: 6.0, eps: 4.0, xps: 5.0 };
    /* the opaque areas the builds measured (aframe-v160), for the total UA check: reset by the facade, which every build runs before the wing */
    var _envA = { gab: 0, wingW: 0, dormW: 0, dormT: 0 };
    /* an assembly's U by parallel paths (aframe-v160): the cavity path and the framing path, the framing fraction f;
       the layers outside the cavity (films, boards, a continuous board) in both */
    function _uPar(rCav, rWood, rRest, f) { return f / (rWood + rRest) + (1 - f) / (rCav + rRest); }
    function _inR(m, perIn) { return m / 0.0254 * perIn; }
    function _iecc() { var f = +STATE.climateZone || 0, Z = IECC_Z[0], i; for (i = 0; i < IECC_Z.length; i++) if (f >= IECC_Z[i].f - 0.01) Z = IECC_Z[i]; return Z; }
    function _rOf(tM, perIn) { return Math.round(tM / 0.0254 * perIn * 10) / 10; }
    function _insulAudit(ctx) {
      var Z = _iecc(), R = _rafSize(), rows = [], nShort = 0, S0a = _sect();
      var say = function (what, r, need, note) { var ok = r >= need - 0.5; if (!ok) nShort++; rows.push(what + ' R-' + r + (need > 0 ? (' vs R-' + need + (ok ? ' OK' : (' SHORT by ' + Math.round((need - r) * 10) / 10))) : ' (no figure)') + (note ? (' ' + note) : '')); };
      var wallSay = function (what, cav, ci) {
        var ok = Z.wall.some(function (w) { return cav >= w[0] - 0.5 && ci >= w[1] - 0.5; });
        if (!ok) nShort++;
        rows.push(what + ' R-' + cav + (ci ? ('+' + ci + 'ci') : '') + ' vs ' + Z.wall.map(function (w) { return w[1] ? (w[0] + '+' + w[1] + 'ci') : String(w[0]); }).join(' or ') + (ok ? ' OK' : (ci ? ' SHORT' : ' SHORT (no continuous layer outside the studs)')));
      };
      if (INSUL === 'above') {
        /* above the rafters (aframe-v158): one continuous layer, measured by the U-factor alternative */
        var PAa = _pirAbove(), okU = PAa.u <= Z.ceilU + 1e-5;
        if (!okU) nShort++;
        rows.push('slopes (PIR above the rafters ' + _pirTxt(PAa) + ' R-' + PAa.r + ', continuous) U-' + PAa.u.toFixed(4) + ' vs U-' + Z.ceilU + ' (R402.1.2, the R-' + Z.ceil + ' of the table would take ' + Math.round(Z.ceil / R_IN.pir * 25.4) + ' of PIR) ' + (okU ? 'OK' : 'SHORT'));
      }
      else {
        /* the hybrid (aframe-v157): the wool's R and the PIR's together, the PIR's alone against R806.5 */
        var HYa = _pirAbove();
        say('slopes (hybrid: wool ' + Math.round(HYa.wool.t * 1000) + ' filling the rafters ' + Math.round(R.d * 1000) + ' R-' + HYa.rW + ' + PIR on the deck ' + _pirTxt(HYa) + ' R-' + HYa.r + ')', Math.round((HYa.rW + HYa.r) * 10) / 10, Z.ceil,
            '(the PIR R-' + HYa.r + ' vs R-' + HYa.cond + ' IRC R806.5 condensation ' + (HYa.r >= HYa.cond - 0.5 ? 'OK' : 'SHORT') + ')');
      }
      var WGa = woolFill(GABLE.d), ciA9 = _ciT();
      wallSay('gables (wool ' + Math.round(WGa.t * 1000) + ' in the 160 studs' + (ciA9 > 0 ? (' + EPS ' + Math.round(ciA9 * 1000) + ' outside, aframe-v158') : '') + ')', _rOf(WGa.t, R_IN.wool), ciA9 > 0 ? _rOf(ciA9, R_IN.eps) : 0);
      if (STATE.foundation === 'strips') {
        var rX = _rOf(PERIM.t, R_IN.xps);
        say('slab edge (XPS ' + Math.round(PERIM.t * 1000) + ' from the slab top down to the footing, ' + (_deckY() + Math.max(0.80, STATE.climateZone || 0) - 0.25).toFixed(2) + ' m; EPS 150 under the whole slab R-' + _rOf(0.150, R_IN.eps) + ')', rX, Z.slab, Z.slabFt ? ('(' + Z.slabFt + ' ft down or to the footing top, R402.2.10)') : '');
      } else { var WFf = woolFill(0.240); say('floor on footings (wool ' + Math.round(WFf.t * 1000) + ' between the joists)', _rOf(WFf.t, R_IN.wool), Z.floor, ''); }
      var sides = _wingSides();
      if (sides.length) {
        wallSay('wing walls (wool ' + Math.round(WGa.t * 1000) + (ciA9 > 0 ? (' + EPS ' + Math.round(ciA9 * 1000) + ' outside, aframe-v159') : '') + ')', _rOf(WGa.t, R_IN.wool), ciA9 > 0 ? _rOf(ciA9, R_IN.eps) : 0);
        /* THE WING'S ROOF AND IECC R402.2.2 (aframe-v159): a ceiling without an attic whose build-up has no room for more
           -- the joists 240 under the walked deck, the walls already about 2150 clear under the ceiling and the IRC R305
           minimum 2134 (7 ft): PIR on its deck would take the room under it -- may stop at R-30 over no more than 500 ft2
           (46.45 m2) or 20 % of the insulated ceiling area, whichever is less. The wing's ceiling against the slopes' */
        var WRa = woolFill(0.20), rWr = _rOf(WRa.t, R_IN.wool), aWr = 0, RGa9 = _rafGrid(), aSl = 2 * (RGa9.z1 - RGa9.z0) * (S0a.half / S0a.cos);
        sides.forEach(function (sw) { var WRw = _wingRect(sw), Hw = _wingH(sw); aWr += Math.max(0, Hw.span) * (WRw.z1 - WRw.z0); aSl -= (WRw.z1 - WRw.z0) * Math.max(0, S0a.half - Hw.dMeet) / S0a.cos; });
        var lim22 = Math.min(46.45, 0.20 * (aSl + aWr)), ok22 = rWr >= 30 - 0.5 && aWr <= lim22 + 0.01;
        if (!ok22) nShort++;
        rows.push('wing roof (wool ' + Math.round(WRa.t * 1000) + ' between the joists, 40 vented over it) R-' + rWr + ' vs R-' + Z.ceil + ': R402.2.2 lets a ceiling without an attic stop at R-30 on ' + aWr.toFixed(1) + ' m2 of ' + lim22.toFixed(1) + ' allowed (500 ft2 or 20 % of ' + (aSl + aWr).toFixed(0) + ' m2, the lesser) ' + (ok22 ? 'OK' : ('SHORT -- ' + (aWr - lim22).toFixed(1) + ' m2 over the allowance (both wings)')));
        if (sides.some(function (sw) { return !!_dormer(sw); })) { var WDa = woolFill(DORM.wallT), WDt = woolFill(DORM.triT), ciDa = _dormCi();
          wallSay('dormer door wall (wool ' + Math.round(WDa.t * 1000) + ' in the 100 frame' + (ciDa > 0 ? (' + EPS ' + Math.round(ciDa * 1000) + ' outside') : '') + ', aframe-v160)', _rOf(WDa.t, R_IN.wool), ciDa > 0 ? _rOf(ciDa, R_IN.eps) : 0);
          wallSay('dormer triangles (wool ' + Math.round(WDt.t * 1000) + ' in the 160 frame, aframe-v160)', _rOf(WDt.t, R_IN.wool), 0); }
      }
      /* THE TOTAL UA ALTERNATIVE (aframe-v160, 2021 IECC R402.1.5 / IRC N1102.1.5): what the prescriptive table
         leaves short on a small area -- the dormer's triangles from zone 4, the walked roofs of two wings -- the
         whole envelope may carry, when the sum of U x area over it is no more than the table's U-factors (R402.1.2:
         ceiling 0.026 / 0.024, wood frame wall 0.084 / 0.060 / 0.045) over the same areas. Each assembly's U by
         parallel paths (the cavity and the framing, framing 10 % of a roof, 20 % of a wall, 25 % of the door wall),
         air films 0.61 / 0.68, gypsum R-0.45, OSB and wood R-1.25 an inch; the opaque areas as built (the slopes
         less the wing's cut, the gables' boards, the wing's walls, its ceiling, the dormers' walls). The windows,
         doors and the slab are taken at the table's own values, so they fall out of the comparison */
      var RGu = _rafGrid(), aSlU = 2 * (RGu.z1 - RGu.z0) * (S0a.half / S0a.cos), aWrU = 0, sidesU = _wingSides();
      sidesU.forEach(function (sw) { var WRw = _wingRect(sw), Hw = _wingH(sw); aWrU += Math.max(0, Hw.span) * (WRw.z1 - WRw.z0); aSlU -= (WRw.z1 - WRw.z0) * Math.max(0, S0a.half - Hw.dMeet) / S0a.cos; });
      var rGy = 0.45, rOs = _inR(0.018, 1.25), fV = 0.68, fH = 0.61, uSl;
      if (INSUL === 'above') uSl = _pirAbove().u;
      else { var HYu = _pirAbove(); uSl = _uPar(HYu.rW, _inR(R.d, 1.25), fH + rGy + rOs + HYu.r + fH, 0.10); }
      var uGa = _uPar(_rOf(woolFill(GABLE.d).t, R_IN.wool), _inR(GABLE.d, 1.25), fV + rGy + rOs + _rOf(_ciT(), R_IN.eps) + fV, 0.20);
      var uWr = _uPar(_rOf(woolFill(0.20).t, R_IN.wool), _inR(0.20, 1.25), fH + rGy + fH, 0.10);
      var uDw = _uPar(_rOf(woolFill(DORM.wallT).t, R_IN.wool), _inR(DORM.wallT, 1.25), fV + rGy + rOs + _rOf(_dormCi(), R_IN.eps) + fV, 0.25);
      var uDt = _uPar(_rOf(woolFill(DORM.triT).t, R_IN.wool), _inR(DORM.triT, 1.25), fV + rGy + rOs + fV, 0.20);
      var partsU = [['slopes', aSlU, uSl, Z.ceilU], ['gables', _envA.gab, uGa, Z.wallU]];
      if (sidesU.length) {
        partsU.push(['wing walls', _envA.wingW, uGa, Z.wallU], ['wing roof', aWrU, uWr, Z.ceilU]);
        if (_envA.dormW + _envA.dormT > 0) partsU.push(['dormer door wall', _envA.dormW, uDw, Z.wallU], ['dormer triangles', _envA.dormT, uDt, Z.wallU]);
      }
      var uaP = 0, uaR = 0; partsU.forEach(function (p9) { uaP += p9[1] * p9[2] * 10.764; uaR += p9[1] * p9[3] * 10.764; });
      var okUA = uaP <= uaR + 1e-6;
      ctx.log('insul    climate: frost ' + (+STATE.climateZone || 0).toFixed(1) + ' m -> IECC zone ' + Z.cz + ' (2021 IECC R402.1.3 / IRC N1102.1.3: ceiling R-' + Z.ceil + ', wood frame wall ' + Z.wall.map(function (w) { return w[1] ? (w[0] + '+' + w[1]) : String(w[0]); }).join(' / ') + ', floor R-' + Z.floor + ', slab ' + (Z.slab ? ('R-' + Z.slab + ' ' + Z.slabFt + ' ft') : 'none') + ') (aframe-v156; the slopes follow it since aframe-v157, the gables and the PIR above the rafters since aframe-v158, the wing since aframe-v159, the dormer since aframe-v160)');
      ctx.log('insul    ' + rows.join(' | '));
      ctx.log('insul    total UA (2021 IECC R402.1.5, aframe-v160) over the opaque envelope: ' + partsU.map(function (p9) { return p9[0] + ' ' + p9[1].toFixed(1) + ' m2 U-' + p9[2].toFixed(3) + ' (table U-' + p9[3] + ')'; }).join(', ') +
              ' | the A ' + uaP.toFixed(1) + ' vs the table ' + uaR.toFixed(1) + ' Btu/h.F ' + (okUA ? ('OK, ' + Math.round((1 - uaP / uaR) * 100) + ' % under') : ('OVER by ' + Math.round((uaP / uaR - 1) * 100) + ' %')));
      ctx.log('insul    ' + (nShort ? (nShort + ' build-up(s) SHORT of the prescriptive table -- ' + (okUA ? 'the whole envelope meets the zone by the total UA alternative (R402.1.5)' : 'and the total UA is OVER too: the zone is NOT met') + ' (aframe-v160)') : 'every build-up meets the zone'));
    }
    _regLayer({
      id: 'aframe-airseal', version: VERSION, role: 'finishes', claims: ['airseal'],
      build3d: _buildAirseal, boq: function () { return _rows('aframe-airseal'); }
    });

    function _barRect() {
      var hw = STATE.footprint.w / 2, hl = STATE.footprint.l / 2, ox = STATE.origin.x, oz = STATE.origin.z;
      return { x0: ox - hw, x1: ox + hw, z0: oz - hl, z1: oz + hl };
    }

    /* -------------------------------------------------------------------------
       THE COLOURS
       ------------------------------------------------------------------------- */
    API.colorSlots([
      { key: 'roof',    grp: 'exterior', labelKey: 'roof',          def: 'Roof',
        pal: ['anthracite', 'graphite', 'terracotta', 'moss', 'copper', 'patina'] },
      { key: 'gable',   grp: 'exterior', labelKey: 'facade_toggle', def: 'Facade finish',
        pal: ['larch', 'spruce', 'anthracite', 'white', 'graphite'] },
      { key: 'joinery', grp: 'exterior', labelKey: 'windows_doors', def: 'Windows & doors',
        pal: ['anthracite', 'lightGrey', 'white', 'oak', 'walnut'] },
      { key: 'metal',   grp: 'exterior', labelKey: 'pdf_pool_cat_accessories', def: 'Accessories',
        pal: ['anthracite', 'graphite', 'zinc', 'white', 'copper', 'patina'] },
      { key: 'floor',   grp: 'interior', labelKey: 'floor_label',   def: 'Floor',
        pal: ['vinylOak', 'vinylGrey', 'walnut', 'stone'] },
      { key: 'ceiling', grp: 'interior', labelKey: 'walls',         def: 'Walls',
        pal: ['white', 'spruce', 'sand', 'greige'] },
      /* the wet rooms' tiles (aframe-v143), the ADU's two slots: room + part */
      { key: 'bathTiles', grp: 'interior', labelKey: 'rooms.bathroom', def: 'Bathroom', label2Key: 'pool_surface_tiles', def2: 'Tiles',
        pal: ['ivory', 'white', 'lightGreen', 'lightBlue', 'pink', 'stone', 'graphite'] },
      { key: 'bathFloor', grp: 'interior', labelKey: 'rooms.bathroom', def: 'Bathroom', label2Key: 'floor_label', def2: 'Floor',
        pal: ['ivory', 'white', 'lightGreen', 'lightBlue', 'pink', 'greige', 'graphite'] }
    ]);

    /* -------------------------------------------------------------------------
       THE STEPS. The line's list; STRUCTURE carries the insulation switch.
       ------------------------------------------------------------------------- */
    function GROUPS(key) {
      if (key === 'place') return API.placeGroups({ trees: true });
      if (key === 'layout') {
        var nF = floors().length;
        if ((STATE.planStorey | 0) >= nF) STATE.planStorey = 0;
        /* THE STAIR KIND, beside the storeys (aframe-v5): switching it puts
           the openings back where the new flight wants them, since an opening
           dragged for one kind is the wrong length for the other */
        var setKind = function (kd) {
          var P = STATE.product = STATE.product || {};
          if (_stairKind() === kd) return;
          P.aframeStair = kd; P.aframeHoles = {};
          try { if (API.savePref) API.savePref(); } catch (eSv) {}
          API.rebuild();
          _log('stairs   kind -> ' + kd + ' (openings placed again by the flight)');
        };
        var stairRow = (nF > 1) ? [{ label: _t('stairs', 'Stairs'), items: [
          { label: _t('stair_straight', 'Straight'), svg: ICO.floor,
            on: function () { return _stairKind() === 'straight'; }, tap: function () { setKind('straight'); } },
          { label: _t('rooms.loft', 'Loft'), svg: ICO.floor,
            on: function () { return _stairKind() === 'loft'; }, tap: function () { setKind('loft'); } },
          { label: _t('rotate', 'Rotate'), svg: ICO_ROTATE,
            on: function () { return false; },
            tap: function () { var kR = Math.max(1, Math.min(nF - 1, STATE.planStorey | 0)); _rotateStair(kR); } }
        ] }] : [];
        return API.layoutGroups({ storeys: nF > 1 ? nF : 0, after: stairRow });
      }
      if (key === 'structure') return [
        /* THE SIDE WING SWITCH (aframe-v97), with two floors or more */
      ].concat(_wingOk() ? [{ label: _t('side_wing', 'Side wing'), items: [
          /* ONE TILE THAT CYCLES (aframe-v105, Marek: kridla prepinat cyklovanim,
             jedno tlacitko, ne 4): off -> left -> right -> both -> off; its
             caption says what is on */
          { label: _wingModeLabel(), svg: ICO.wall || ICO.roof, on: function () { return _wingBag().mode !== 'off'; },
            tap: function () { var M = ['off', 'left', 'right', 'both'], i = M.indexOf(_wingBag().mode); _wingSet(M[(i + 1) % M.length]); } }
        ] }] : []).concat([
        { label: _t('envelope_toggle', 'Insulation type'), items: [
          { label: _t('roof_ins_above', 'Above rafters'), svg: ICO.roof || ICO.gable,
            on: function () { return INSUL === 'above'; },
            tap: function () { INSUL = 'above'; (STATE.product = STATE.product || {}).aframeInsul = INSUL; try { API.savePref(); } catch (eS) {} API.rebuild(); _log('insulation -> above the rafters (rafters seen inside)'); } },
          { label: _t('roof_ins_between', 'Between rafters'), svg: ICO.wall,
            on: function () { return INSUL === 'between'; },
            tap: function () { INSUL = 'between'; (STATE.product = STATE.product || {}).aframeInsul = INSUL; try { API.savePref(); } catch (eS) {} API.rebuild(); _log('insulation -> between the rafters'); } }
        ] }
      ]);
      if (key === 'roof') return API.roofGroups({ hip: false, mono: false, parapet: false,
                                                  eave: 0.30, pitch: 60, foundations: footingKinds() });
      /* THE CORE'S DOORS & WINDOWS, as in the ADU (aframe-v24, P1): a kind
         opens the catalogue, a tap places it -- windows, doors and french
         doors in a gable, a roof window on a slope -- Edit moves it, the bin
         takes it away */
      if (key === 'openings') {
        _rwTrimOffer();
        var og = API.openingsGroups({ kinds: AF_KINDS }) || [];
        /* ONE GABLE GLAZING (aframe-v64, Marek: jen jedno full wall window s
           prepinacem i pro half): the half wall tile goes, the full wall unit
           takes every variant through the cycler icon on the gable in Edit;
           the Glazing tile of v63 is gone with it */
        try {
          var U9 = (typeof _UI === 'function') ? _UI() : _UI, C9w = U9 && U9.OPENING_CATALOG, G9 = C9w && C9w.window;
          if (G9 && G9.items) {
            var keep9 = G9.items.filter(function (it) { return !(it && it.code === 'FIXH0001'); });
            if (keep9.length !== G9.items.length) { G9.items = keep9; if (!_glzTileSaid) { _glzTileSaid = 1; _log('glass    the half wall unit is taken out of the picker -- one full wall window, its variants on the cycler icon'); } }
          }
        } catch (eH9) { _log('glass    could not take the half wall unit out of the picker: ' + ((eH9 && eH9.message) || eH9)); }
        return og;
      }
      if (key === 'colors') return [];
      if (key === 'exterior') return API.exteriorGroups({ facade: false, slats: false });
      return [];
    }
    /* THE 1140 WIDE ROOF WINDOW IS NOT OFFERED ON THE A (aframe-v25): the
       core's picker lists the whole roof group, so a pick of it is turned
       down here and the snapshot says why */
    function KIT() {
      _rwTrimOffer();
      return API.kitDefault({ groups: GROUPS, kinds: AF_KINDS, onPick: function (spec) {
        if (spec && spec.kind === 'roof' && !_rwOffered(spec.code)) {
          _opNote = 'roof window ' + spec.code + ' is not offered on the A -- a bay that wide would need a header; pick 550 or 780';
          _log('opening: ' + spec.code + ' is not offered on the A-frame');
          try { API.rebuild(); } catch (eR) {}
          return;
        }
        API.armOpening(spec);
        try { var w = API.wizard && API.wizard(); if (w && w.refresh) w.refresh(); } catch (eW) {}
        _log('armed ' + spec.kind + ' -- tap ' + (spec.kind === 'roof' ? 'a roof slope' : 'a gable') + ' to place it');
      } });
    }
    _opOn = true;   /* everything the opening hooks read is defined from here on */

    /* -------------------------------------------------------------------------
       WHAT THE PAGE CALLS, AND WHAT THE PAGE READS.

       The core builds everything, but it does not START itself: the liquid calls
       HouseLib.boot() and reads HouseLib.VERSION and HouseLib.snapshot(). Without
       these four the lib loads, builds nothing, and the debug pill says NOT
       LOADED even though the object is there -- which is exactly what a first
       product misses, because every other product in the line inherited them
       from the fork it came out of (Marek: nic se nenacetlo).
       ------------------------------------------------------------------------- */
    API.VERSION = VERSION;
    API.PRODUCT = __CORE.PRODUCT;
    /* THE STEPS ARE THE LINE'S (core-v319): Place, Floorplan, Roof & Base,
       Doors & Windows, Color, Exterior, and Video once there is a video. The
       same steps as every other product, from the same list, so the T house is
       the same configurator to use as the ADU and the sauna. */
    function wizSteps() { return API.wizardSteps({ structure: true }); }

    API.boot = function () {
      var B = BOOTDATA();
      var ok = API._coreBoot({
        t: _t,
        prefKey: 'leva:' + __CORE.PRODUCT + ':' + (B.productId || '0'),
        /* the size is dragged on the plan step, where the building is seen from
           above and the dimension can be read */
        /* AND ON ROOF & BASE THE ROOF ITSELF (aframe-v62, Marek: nevidim
           moznost vytazeni strechy v roof and base, jak to mame jinde): the
           core's roof rectangle, each gable edge dragged out on its own */
        handlesActive: function () { return API.editing('layout') || API.editing('roof'); },
        blueprint: !!B.blueprint
      });
      if (!ok || B.blueprint) return ok;
      API.railBind();
      API.wizardMount(wizSteps());
      return ok;
    };
    API.snapshot = function () { return API._coreSnapshot(); };
    API.shareDims = function () {
      return { L: STATE.footprint.l, W: STATE.footprint.w,
               H: API.apexY(), unit: STATE.isMetric ? 'm' : 'ft' };
    };

    /* -------------------------------------------------------------------------
       AND WHAT THIS PRODUCT HANDS BACK TO THE CORE. Five names: everything else
       the core either has or does without, and a product that hands back less is
       a product that has less to go wrong.
       ------------------------------------------------------------------------- */
    __PROD.VERSION = VERSION;
    __PROD.KIT = KIT;
    __PROD._rebarStage = true;   /* the eye's first press shows the reinforcement alone (core-v474) */
    __PROD.RAFTER = { t: 0.060, d: 0.200 };     /* the rafter, for the core's overhang maths */
    __PROD._pitchLim = { min: 50, max: 70 };    /* an A-frame's own range (core-v335) */
    __PROD._planStep = function () { return STATE.isMetric ? 0.050 : 0.0508; };   /* 50 mm / 2 in (core-v335) */
    /* WHAT SITS OUTSIDE THE WALL, ANSWERED BY THE PRODUCT. The core's own sum
       is the timber line's -- sheathing, membrane, battens, boards -- and a
       masonry wall has none of them: it has render straight on the block. The
       core asks this before it does its own arithmetic, so answering it is what
       keeps a masonry product out of the timber one's maths. */
    __PROD._productCladThk = function () { return 0.020; };

    try {
      if (global.Configurator && global.Configurator.log) {
        global.Configurator.log.log('[' + __CORE.LOG_TAG + '] loaded ' + VERSION + ' on ' + __CORE.CORE_VERSION);
      }
    } catch (e) {}
  }

  /* ---------------------------------------------------------------------------
     AND IF THE CORE IS NOT THERE, SAY WHICH FILE IS MISSING. Without it this
     file builds nothing and the page comes up blank with nothing in the log,
     because the log is inside the thing that never got built.
     --------------------------------------------------------------------------- */
  if (!global.ConfiguratorCore || typeof global.ConfiguratorCore.create !== 'function') {
    var m = '[aframe] ConfiguratorCore is MISSING -- configurator-ui.js is not loaded, ' +
            'or the one that loaded is older than core-v308. Upload configurator-ui.js and hard-refresh.';
    try { global.__levaLogs = global.__levaLogs || []; global.__levaLogs.push(m); } catch (e1) {}
    try { if (global.console) (global.console.error || global.console.log)(m); } catch (e2) {}
    try {
      var dd = global.document.createElement('div');
      dd.setAttribute('style', 'position:fixed;left:0;right:0;top:0;z-index:2147483647;' +
        'background:#B3261E;color:#fff;font:12px/1.45 ui-monospace,Menlo,monospace;padding:10px 12px;white-space:pre-wrap');
      dd.textContent = m;
      var hh = global.document.body || global.document.documentElement;
      if (hh) hh.appendChild(dd);
    } catch (e3) {}
  } else {
    /* AND IF THE BUILD ITSELF FAILS, SAY SO ON THE PAGE. Marek has no console:
       a lib that dies while it is being created leaves HouseLib undefined and
       the pill saying NOT LOADED, with nothing that says why (from thouse-v17). */
    try {
      global.AFrameLib = global.HouseLib = global.ConfiguratorCore.create(build);
    } catch (eB) {
      var mb = '[aframe] the lib threw while being created on ' + (global.ConfiguratorCore.VERSION || '?') + ': ' +
               (eB && eB.message ? eB.message : String(eB));
      try { global.__levaLogs = global.__levaLogs || []; global.__levaLogs.push(mb); } catch (e4) {}
      try { if (global.console) (global.console.error || global.console.log)(mb, eB); } catch (e5) {}
      try {
        var db = global.document.createElement('div');
        db.setAttribute('style', 'position:fixed;left:0;right:0;top:0;z-index:2147483647;' +
          'background:#B3261E;color:#fff;font:12px/1.45 ui-monospace,Menlo,monospace;padding:10px 12px;white-space:pre-wrap');
        db.textContent = mb;
        var hb = global.document.body || global.document.documentElement;
        if (hb) hb.appendChild(db);
      } catch (e6) {}
    }
  }

})(window);
